import * as y from "react";
import ee, { useMemo as Mt, useRef as lt, useDebugValue as Kh, createElement as tw, useContext as Bt, useState as wt, useEffect as ut, createContext as $a, Component as nw, isValidElement as rw, useLayoutEffect as z0, forwardRef as Na, Children as ow, useImperativeHandle as iw, useCallback as Xi } from "react";
import { useConfig as jn, QuotaMgtService as aw, CWElementsI18NProvider as q0, useTranslation as Fa, i18nInstance as sr, CWElementsConfig as _o, CWElementsSharedService as dl, loadPackageTranslations as sw, request as Gc } from "@cw-elements/config";
import { openMfe as Ms, useMfe as ci, DYNAMIC_SLOT_CHANGE_PROPS as Yh, MFE_OPENED as Zh } from "@cw-elements/mfe-dynamic-slot";
import * as W0 from "react-dom";
import Qh, { createPortal as lw } from "react-dom";
const Bn = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
function G0() {
  throw new Error("setTimeout has not been defined");
}
function K0() {
  throw new Error("clearTimeout has not been defined");
}
var eo = G0, to = K0;
typeof Bn.setTimeout == "function" && (eo = setTimeout);
typeof Bn.clearTimeout == "function" && (to = clearTimeout);
function Y0(e) {
  if (eo === setTimeout)
    return setTimeout(e, 0);
  if ((eo === G0 || !eo) && setTimeout)
    return eo = setTimeout, setTimeout(e, 0);
  try {
    return eo(e, 0);
  } catch {
    try {
      return eo.call(null, e, 0);
    } catch {
      return eo.call(this, e, 0);
    }
  }
}
function cw(e) {
  if (to === clearTimeout)
    return clearTimeout(e);
  if ((to === K0 || !to) && clearTimeout)
    return to = clearTimeout, clearTimeout(e);
  try {
    return to(e);
  } catch {
    try {
      return to.call(null, e);
    } catch {
      return to.call(this, e);
    }
  }
}
var Dr = [], mi = !1, Oo, Ds = -1;
function uw() {
  !mi || !Oo || (mi = !1, Oo.length ? Dr = Oo.concat(Dr) : Ds = -1, Dr.length && Z0());
}
function Z0() {
  if (!mi) {
    var e = Y0(uw);
    mi = !0;
    for (var t = Dr.length; t; ) {
      for (Oo = Dr, Dr = []; ++Ds < t; )
        Oo && Oo[Ds].run();
      Ds = -1, t = Dr.length;
    }
    Oo = null, mi = !1, cw(e);
  }
}
function dw(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  Dr.push(new Q0(e, t)), Dr.length === 1 && !mi && Y0(Z0);
}
function Q0(e, t) {
  this.fun = e, this.array = t;
}
Q0.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var fw = "browser", hw = "browser", pw = !0, vw = {}, gw = [], mw = "", yw = {}, bw = {}, Cw = {};
function zo() {
}
var ww = zo, Ew = zo, _w = zo, xw = zo, Sw = zo, Tw = zo, Ow = zo;
function Pw(e) {
  throw new Error("process.binding is not supported");
}
function Rw() {
  return "/";
}
function Aw(e) {
  throw new Error("process.chdir is not supported");
}
function Iw() {
  return 0;
}
var ui = Bn.performance || {}, kw = ui.now || ui.mozNow || ui.msNow || ui.oNow || ui.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function $w(e) {
  var t = kw.call(ui) * 1e-3, n = Math.floor(t), r = Math.floor(t % 1 * 1e9);
  return e && (n = n - e[0], r = r - e[1], r < 0 && (n--, r += 1e9)), [n, r];
}
var Nw = /* @__PURE__ */ new Date();
function Fw() {
  var e = /* @__PURE__ */ new Date(), t = e - Nw;
  return t / 1e3;
}
var z = {
  nextTick: dw,
  title: fw,
  browser: pw,
  env: vw,
  argv: gw,
  version: mw,
  versions: yw,
  on: ww,
  addListener: Ew,
  once: _w,
  off: xw,
  removeListener: Sw,
  removeAllListeners: Tw,
  emit: Ow,
  binding: Pw,
  cwd: Rw,
  chdir: Aw,
  umask: Iw,
  hrtime: $w,
  platform: hw,
  release: bw,
  config: Cw,
  uptime: Fw
}, as = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Uf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var od = { exports: {} }, Ji = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xh;
function Lw() {
  if (Xh)
    return Ji;
  Xh = 1;
  var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: f, ref: h, props: d, _owner: o.current };
  }
  return Ji.Fragment = n, Ji.jsx = a, Ji.jsxs = a, Ji;
}
var ea = {}, Jh;
function Mw() {
  return Jh || (Jh = 1, z.env.NODE_ENV !== "production" && function() {
    var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function v(R) {
      if (R === null || typeof R != "object")
        return null;
      var re = p && R[p] || R[g];
      return typeof re == "function" ? re : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(R) {
      {
        for (var re = arguments.length, pe = new Array(re > 1 ? re - 1 : 0), Ie = 1; Ie < re; Ie++)
          pe[Ie - 1] = arguments[Ie];
        w("error", R, pe);
      }
    }
    function w(R, re, pe) {
      {
        var Ie = b.ReactDebugCurrentFrame, He = Ie.getStackAddendum();
        He !== "" && (re += "%s", pe = pe.concat([He]));
        var Ze = pe.map(function(je) {
          return String(je);
        });
        Ze.unshift("Warning: " + re), Function.prototype.apply.call(console[R], console, Ze);
      }
    }
    var E = !1, C = !1, x = !1, _ = !1, T = !1, O;
    O = Symbol.for("react.module.reference");
    function I(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === r || R === i || T || R === o || R === c || R === u || _ || R === h || E || C || x || typeof R == "object" && R !== null && (R.$$typeof === f || R.$$typeof === d || R.$$typeof === a || R.$$typeof === s || R.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === O || R.getModuleId !== void 0));
    }
    function L(R, re, pe) {
      var Ie = R.displayName;
      if (Ie)
        return Ie;
      var He = re.displayName || re.name || "";
      return He !== "" ? pe + "(" + He + ")" : pe;
    }
    function B(R) {
      return R.displayName || "Context";
    }
    function j(R) {
      if (R == null)
        return null;
      if (typeof R.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof R == "function")
        return R.displayName || R.name || null;
      if (typeof R == "string")
        return R;
      switch (R) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case s:
            var re = R;
            return B(re) + ".Consumer";
          case a:
            var pe = R;
            return B(pe._context) + ".Provider";
          case l:
            return L(R, R.render, "ForwardRef");
          case d:
            var Ie = R.displayName || null;
            return Ie !== null ? Ie : j(R.type) || "Memo";
          case f: {
            var He = R, Ze = He._payload, je = He._init;
            try {
              return j(je(Ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, q = 0, N, $, F, H, k, W, G;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function Y() {
      {
        if (q === 0) {
          N = console.log, $ = console.info, F = console.warn, H = console.error, k = console.group, W = console.groupCollapsed, G = console.groupEnd;
          var R = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: R,
            log: R,
            warn: R,
            error: R,
            group: R,
            groupCollapsed: R,
            groupEnd: R
          });
        }
        q++;
      }
    }
    function fe() {
      {
        if (q--, q === 0) {
          var R = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, R, {
              value: N
            }),
            info: M({}, R, {
              value: $
            }),
            warn: M({}, R, {
              value: F
            }),
            error: M({}, R, {
              value: H
            }),
            group: M({}, R, {
              value: k
            }),
            groupCollapsed: M({}, R, {
              value: W
            }),
            groupEnd: M({}, R, {
              value: G
            })
          });
        }
        q < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ge = b.ReactCurrentDispatcher, ie;
    function he(R, re, pe) {
      {
        if (ie === void 0)
          try {
            throw Error();
          } catch (He) {
            var Ie = He.stack.trim().match(/\n( *(at )?)/);
            ie = Ie && Ie[1] || "";
          }
        return `
` + ie + R;
      }
    }
    var ue = !1, ce;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      ce = new Se();
    }
    function te(R, re) {
      if (!R || ue)
        return "";
      {
        var pe = ce.get(R);
        if (pe !== void 0)
          return pe;
      }
      var Ie;
      ue = !0;
      var He = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ze;
      Ze = ge.current, ge.current = null, Y();
      try {
        if (re) {
          var je = function() {
            throw Error();
          };
          if (Object.defineProperty(je.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(je, []);
            } catch (Qt) {
              Ie = Qt;
            }
            Reflect.construct(R, [], je);
          } else {
            try {
              je.call();
            } catch (Qt) {
              Ie = Qt;
            }
            R.call(je.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qt) {
            Ie = Qt;
          }
          R();
        }
      } catch (Qt) {
        if (Qt && Ie && typeof Qt.stack == "string") {
          for (var Be = Qt.stack.split(`
`), Ot = Ie.stack.split(`
`), Xe = Be.length - 1, Qe = Ot.length - 1; Xe >= 1 && Qe >= 0 && Be[Xe] !== Ot[Qe]; )
            Qe--;
          for (; Xe >= 1 && Qe >= 0; Xe--, Qe--)
            if (Be[Xe] !== Ot[Qe]) {
              if (Xe !== 1 || Qe !== 1)
                do
                  if (Xe--, Qe--, Qe < 0 || Be[Xe] !== Ot[Qe]) {
                    var hn = `
` + Be[Xe].replace(" at new ", " at ");
                    return R.displayName && hn.includes("<anonymous>") && (hn = hn.replace("<anonymous>", R.displayName)), typeof R == "function" && ce.set(R, hn), hn;
                  }
                while (Xe >= 1 && Qe >= 0);
              break;
            }
        }
      } finally {
        ue = !1, ge.current = Ze, fe(), Error.prepareStackTrace = He;
      }
      var wr = R ? R.displayName || R.name : "", xn = wr ? he(wr) : "";
      return typeof R == "function" && ce.set(R, xn), xn;
    }
    function ke(R, re, pe) {
      return te(R, !1);
    }
    function se(R) {
      var re = R.prototype;
      return !!(re && re.isReactComponent);
    }
    function D(R, re, pe) {
      if (R == null)
        return "";
      if (typeof R == "function")
        return te(R, se(R));
      if (typeof R == "string")
        return he(R);
      switch (R) {
        case c:
          return he("Suspense");
        case u:
          return he("SuspenseList");
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case l:
            return ke(R.render);
          case d:
            return D(R.type, re, pe);
          case f: {
            var Ie = R, He = Ie._payload, Ze = Ie._init;
            try {
              return D(Ze(He), re, pe);
            } catch {
            }
          }
        }
      return "";
    }
    var X = Object.prototype.hasOwnProperty, Q = {}, _e = b.ReactDebugCurrentFrame;
    function Ce(R) {
      if (R) {
        var re = R._owner, pe = D(R.type, R._source, re ? re.type : null);
        _e.setExtraStackFrame(pe);
      } else
        _e.setExtraStackFrame(null);
    }
    function Ne(R, re, pe, Ie, He) {
      {
        var Ze = Function.call.bind(X);
        for (var je in R)
          if (Ze(R, je)) {
            var Be = void 0;
            try {
              if (typeof R[je] != "function") {
                var Ot = Error((Ie || "React class") + ": " + pe + " type `" + je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[je] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ot.name = "Invariant Violation", Ot;
              }
              Be = R[je](re, je, Ie, pe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Xe) {
              Be = Xe;
            }
            Be && !(Be instanceof Error) && (Ce(He), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ie || "React class", pe, je, typeof Be), Ce(null)), Be instanceof Error && !(Be.message in Q) && (Q[Be.message] = !0, Ce(He), m("Failed %s type: %s", pe, Be.message), Ce(null));
          }
      }
    }
    var ae = Array.isArray;
    function xe(R) {
      return ae(R);
    }
    function Re(R) {
      {
        var re = typeof Symbol == "function" && Symbol.toStringTag, pe = re && R[Symbol.toStringTag] || R.constructor.name || "Object";
        return pe;
      }
    }
    function mt(R) {
      try {
        return et(R), !1;
      } catch {
        return !0;
      }
    }
    function et(R) {
      return "" + R;
    }
    function tt(R) {
      if (mt(R))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Re(R)), et(R);
    }
    var _t = b.ReactCurrentOwner, $t = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, en, Ee, Fe;
    Fe = {};
    function S(R) {
      if (X.call(R, "ref")) {
        var re = Object.getOwnPropertyDescriptor(R, "ref").get;
        if (re && re.isReactWarning)
          return !1;
      }
      return R.ref !== void 0;
    }
    function A(R) {
      if (X.call(R, "key")) {
        var re = Object.getOwnPropertyDescriptor(R, "key").get;
        if (re && re.isReactWarning)
          return !1;
      }
      return R.key !== void 0;
    }
    function K(R, re) {
      if (typeof R.ref == "string" && _t.current && re && _t.current.stateNode !== re) {
        var pe = j(_t.current.type);
        Fe[pe] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(_t.current.type), R.ref), Fe[pe] = !0);
      }
    }
    function J(R, re) {
      {
        var pe = function() {
          en || (en = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", re));
        };
        pe.isReactWarning = !0, Object.defineProperty(R, "key", {
          get: pe,
          configurable: !0
        });
      }
    }
    function le(R, re) {
      {
        var pe = function() {
          Ee || (Ee = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", re));
        };
        pe.isReactWarning = !0, Object.defineProperty(R, "ref", {
          get: pe,
          configurable: !0
        });
      }
    }
    var be = function(R, re, pe, Ie, He, Ze, je) {
      var Be = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: R,
        key: re,
        ref: pe,
        props: je,
        // Record the component responsible for creating this element.
        _owner: Ze
      };
      return Be._store = {}, Object.defineProperty(Be._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Be, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ie
      }), Object.defineProperty(Be, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: He
      }), Object.freeze && (Object.freeze(Be.props), Object.freeze(Be)), Be;
    };
    function Oe(R, re, pe, Ie, He) {
      {
        var Ze, je = {}, Be = null, Ot = null;
        pe !== void 0 && (tt(pe), Be = "" + pe), A(re) && (tt(re.key), Be = "" + re.key), S(re) && (Ot = re.ref, K(re, He));
        for (Ze in re)
          X.call(re, Ze) && !$t.hasOwnProperty(Ze) && (je[Ze] = re[Ze]);
        if (R && R.defaultProps) {
          var Xe = R.defaultProps;
          for (Ze in Xe)
            je[Ze] === void 0 && (je[Ze] = Xe[Ze]);
        }
        if (Be || Ot) {
          var Qe = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
          Be && J(je, Qe), Ot && le(je, Qe);
        }
        return be(R, Be, Ot, He, Ie, _t.current, je);
      }
    }
    var We = b.ReactCurrentOwner, Ke = b.ReactDebugCurrentFrame;
    function nt(R) {
      if (R) {
        var re = R._owner, pe = D(R.type, R._source, re ? re.type : null);
        Ke.setExtraStackFrame(pe);
      } else
        Ke.setExtraStackFrame(null);
    }
    var at;
    at = !1;
    function st(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function ct() {
      {
        if (We.current) {
          var R = j(We.current.type);
          if (R)
            return `

Check the render method of \`` + R + "`.";
        }
        return "";
      }
    }
    function Vt(R) {
      return "";
    }
    var xt = {};
    function _n(R) {
      {
        var re = ct();
        if (!re) {
          var pe = typeof R == "string" ? R : R.displayName || R.name;
          pe && (re = `

Check the top-level render call using <` + pe + ">.");
        }
        return re;
      }
    }
    function ot(R, re) {
      {
        if (!R._store || R._store.validated || R.key != null)
          return;
        R._store.validated = !0;
        var pe = _n(re);
        if (xt[pe])
          return;
        xt[pe] = !0;
        var Ie = "";
        R && R._owner && R._owner !== We.current && (Ie = " It was passed a child from " + j(R._owner.type) + "."), nt(R), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', pe, Ie), nt(null);
      }
    }
    function rt(R, re) {
      {
        if (typeof R != "object")
          return;
        if (xe(R))
          for (var pe = 0; pe < R.length; pe++) {
            var Ie = R[pe];
            st(Ie) && ot(Ie, re);
          }
        else if (st(R))
          R._store && (R._store.validated = !0);
        else if (R) {
          var He = v(R);
          if (typeof He == "function" && He !== R.entries)
            for (var Ze = He.call(R), je; !(je = Ze.next()).done; )
              st(je.value) && ot(je.value, re);
        }
      }
    }
    function Ut(R) {
      {
        var re = R.type;
        if (re == null || typeof re == "string")
          return;
        var pe;
        if (typeof re == "function")
          pe = re.propTypes;
        else if (typeof re == "object" && (re.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        re.$$typeof === d))
          pe = re.propTypes;
        else
          return;
        if (pe) {
          var Ie = j(re);
          Ne(pe, R.props, "prop", Ie, R);
        } else if (re.PropTypes !== void 0 && !at) {
          at = !0;
          var He = j(re);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", He || "Unknown");
        }
        typeof re.getDefaultProps == "function" && !re.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ir(R) {
      {
        for (var re = Object.keys(R.props), pe = 0; pe < re.length; pe++) {
          var Ie = re[pe];
          if (Ie !== "children" && Ie !== "key") {
            nt(R), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ie), nt(null);
            break;
          }
        }
        R.ref !== null && (nt(R), m("Invalid attribute `ref` supplied to `React.Fragment`."), nt(null));
      }
    }
    var St = {};
    function tn(R, re, pe, Ie, He, Ze) {
      {
        var je = I(R);
        if (!je) {
          var Be = "";
          (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (Be += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ot = Vt();
          Ot ? Be += Ot : Be += ct();
          var Xe;
          R === null ? Xe = "null" : xe(R) ? Xe = "array" : R !== void 0 && R.$$typeof === t ? (Xe = "<" + (j(R.type) || "Unknown") + " />", Be = " Did you accidentally export a JSX literal instead of a component?") : Xe = typeof R, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xe, Be);
        }
        var Qe = Oe(R, re, pe, He, Ze);
        if (Qe == null)
          return Qe;
        if (je) {
          var hn = re.children;
          if (hn !== void 0)
            if (Ie)
              if (xe(hn)) {
                for (var wr = 0; wr < hn.length; wr++)
                  rt(hn[wr], R);
                Object.freeze && Object.freeze(hn);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              rt(hn, R);
        }
        if (X.call(re, "key")) {
          var xn = j(R), Qt = Object.keys(re).filter(function(Ko) {
            return Ko !== "key";
          }), wo = Qt.length > 0 ? "{key: someKey, " + Qt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!St[xn + wo]) {
            var Go = Qt.length > 0 ? "{" + Qt.join(": ..., ") + ": ...}" : "{}";
            m(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, wo, xn, Go, xn), St[xn + wo] = !0;
          }
        }
        return R === r ? ir(Qe) : Ut(Qe), Qe;
      }
    }
    function Yr(R, re, pe) {
      return tn(R, re, pe, !0);
    }
    function yt(R, re, pe) {
      return tn(R, re, pe, !1);
    }
    var bt = yt, fn = Yr;
    ea.Fragment = r, ea.jsx = bt, ea.jsxs = fn;
  }()), ea;
}
z.env.NODE_ENV === "production" ? od.exports = Lw() : od.exports = Mw();
var P = od.exports;
const Dw = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 19 18", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M15.5 8.25H6.3725L10.565 4.0575L9.5 3L3.5 9L9.5 15L10.5575 13.9425L6.3725 9.75H15.5V8.25Z", fill: "#696F88" })), jw = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.41 15.7069L12 11.1269L16.59 15.7069L18 14.2969L12 8.29688L6 14.2969L7.41 15.7069Z" })), HM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z", fill: "#696F88" }));
function ep({
  fill: e = "#696F88"
}) {
  return /* @__PURE__ */ P.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "19", height: "18", viewBox: "0 0 19 18", fill: "none", children: /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 3.75V14.25H14.75V9H16.25V14.25C16.25 15.075 15.575 15.75 14.75 15.75H4.25C3.4175 15.75 2.75 15.075 2.75 14.25V3.75C2.75 2.925 3.4175 2.25 4.25 2.25H9.5V3.75H4.25ZM11 3.75V2.25H16.25V7.5H14.75V4.8075L7.3775 12.18L6.32 11.1225L13.6925 3.75H11Z", fill: e }) });
}
function X0({
  dark: e,
  className: t
}) {
  return /* @__PURE__ */ P.jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: t, children: /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.33333 1.33333V10.6667H10.6667V6H12V10.6667C12 11.4 11.4 12 10.6667 12H1.33333C0.593333 12 0 11.4 0 10.6667V1.33333C0 0.6 0.593333 0 1.33333 0H6V1.33333H1.33333ZM7.33333 1.33333V0H12V4.66667H10.6667V2.27333L4.11333 8.82667L3.17333 7.88667L9.72667 1.33333H7.33333Z", fill: e ? "#A3A9B9" : "#696F88" }) });
}
function zM({
  dark: e
}) {
  return /* @__PURE__ */ P.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "61", height: "32", viewBox: "0 0 61 32", fill: "none", children: [
    /* @__PURE__ */ P.jsxs("g", { filter: "url(#filter0_d_923_17213)", children: [
      /* @__PURE__ */ P.jsx("rect", { x: "1", width: "32", height: "32", rx: "16", fill: "white" }),
      /* @__PURE__ */ P.jsx("rect", { x: "1.5", y: "0.5", width: "31", height: "31", rx: "15.5", stroke: "#DFE2E7" }),
      /* @__PURE__ */ P.jsx("path", { d: "M24.7573 8.53125C23.9919 8.62738 21.7512 8.92318 19.5327 9.42604C16.523 10.1101 13.7647 11.186 11.879 12.9312C10.6588 14.059 9.85644 15.2976 9.45711 17.0909C9.0356 18.9951 9.27963 21.1027 9.93039 23.4395C10.6736 23.2731 11.3613 23.2324 12.1008 23.1807C13.162 23.1067 14.4857 23.0106 15.8907 22.7702C17.9946 22.4079 19.4551 21.6721 20.7751 19.8899C21.9287 18.337 22.2948 16.1591 22.6238 14.6062C23.0675 12.5319 23.5112 11.138 23.9216 10.1877C24.1768 9.61091 24.3543 9.1857 24.7573 8.53125ZM19.8174 19.7198C18.9596 20.7699 17.9576 21.4613 16.1976 21.8274C18.7045 20.5887 19.3922 18.1669 19.7731 16.8099C19.9949 16.0112 20.202 14.939 20.4312 13.9259C20.7344 12.5615 21.2077 10.8865 21.7512 9.86234C22.1912 9.7847 23.086 9.64049 23.2191 9.61831C22.8568 10.4133 22.2911 11.8109 21.681 14.8946C21.167 17.4644 20.6087 18.7511 19.8174 19.7198ZM14.2675 12.2398C12.2635 13.9887 11.7163 15.6378 11.4427 17.1242C11.1395 18.7918 11.4168 20.6553 11.7532 22.2045C11.3206 22.3044 10.7919 22.4005 10.5774 22.4449C10.1301 20.7884 9.94518 18.9212 10.3001 17.3128C10.8658 14.7615 12.4521 13.3491 14.2675 12.2398ZM12.3042 17.1944C12.6517 15.3568 13.6722 13.3047 16.4269 11.504C14.3452 13.6449 13.8275 14.9797 13.5022 16.5955C13.2433 17.8822 13.3616 19.6311 13.7092 21.258C13.3616 21.5353 12.9327 21.7386 12.5889 21.9013C12.2043 20.256 12.0749 18.3998 12.3042 17.1944ZM14.4561 20.622C14.2416 19.4055 14.1233 17.9968 14.3193 16.9171C14.7223 14.6469 16.0608 12.739 18.0722 11.1306C17.7062 12.0845 17.4363 13.2566 17.2884 13.937C16.963 15.4529 16.7042 16.8506 16.2568 17.9672C15.7391 19.2576 15.2067 19.9306 14.4561 20.622ZM13.5206 22.1897C15.1327 21.4909 16.2864 20.1598 16.9667 18.5144C17.5213 17.1686 17.7616 15.8929 18.0833 14.3511C18.2238 13.6818 18.6527 11.8368 19.163 10.6129C19.5106 10.4613 20.1724 10.2432 20.6974 10.1027C20.165 11.2674 19.7546 12.8906 19.4662 14.2365C18.9781 16.503 18.6269 18.2963 17.562 19.705C16.5304 21.062 15.0736 21.7978 13.5206 22.1897Z", fill: "#73DC78" })
    ] }),
    /* @__PURE__ */ P.jsxs("g", { filter: "url(#filter1_d_923_17213)", children: [
      /* @__PURE__ */ P.jsx("rect", { x: "29", width: "32", height: "32", rx: "16", fill: "white" }),
      /* @__PURE__ */ P.jsx("rect", { x: "29.5", y: "0.5", width: "31", height: "31", rx: "15.5", stroke: "#DFE2E7" }),
      /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.2494 5.01488C44.7103 4.993 45.1699 4.99984 45.6308 5.00667C46.7742 5.07779 47.9093 5.3144 48.9775 5.73427C50.2166 6.21295 51.3681 6.92004 52.3556 7.81176C52.5293 7.97724 52.7153 8.13316 52.8794 8.30959C53.3143 8.76912 53.7274 9.25191 54.0816 9.77709C55.3385 11.5988 56.0291 13.8103 55.9991 16.026C56.0141 18.1294 55.3699 20.2247 54.2211 21.9835C53.5373 23.0188 52.6852 23.9475 51.6977 24.7011C50.7541 25.4287 49.6886 25.9962 48.5631 26.3847C46.2709 27.1683 43.7161 27.1724 41.4266 26.3764C39.1439 25.5996 37.1444 24.0391 35.8178 22.03C35.0245 20.8333 34.4665 19.4807 34.1985 18.0692C33.7759 15.8769 34.0289 13.5518 34.9507 11.514C35.5771 10.104 36.5112 8.8334 37.66 7.80492C38.8978 6.69027 40.394 5.8601 41.9983 5.40877C42.7327 5.20088 43.489 5.07232 44.2494 5.01488ZM44.1838 6.08029C42.6192 6.20748 41.086 6.71352 39.7553 7.54643C38.4287 8.37113 37.299 9.51176 36.4907 10.848C35.5538 12.3975 35.0259 14.2097 35.071 16.026C35.0437 17.3184 35.3282 18.6081 35.8178 19.8007C36.3047 20.9523 37.0022 22.0177 37.8802 22.908C39.5843 24.6751 41.9695 25.7719 44.4218 25.8991C44.9798 25.9019 45.5405 25.9279 46.0958 25.8567C47.2241 25.7377 48.3292 25.4136 49.3508 24.9185C51.5446 23.8531 53.3266 21.9575 54.2307 19.6899C54.8954 18.061 55.106 16.2516 54.8434 14.5133C54.5575 12.5781 53.6754 10.7386 52.3556 9.29841C50.8785 7.67225 48.8489 6.55214 46.6825 6.1897C45.8592 6.03926 45.0167 6.02285 44.1838 6.08029Z", fill: "#019DB0" }),
      /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.2287 11.0605C46 10.9579 46.8028 11.0413 47.5263 11.3367C48.5261 11.7374 49.3207 12.5772 49.7324 13.5646C49.9485 14.0693 50.0716 14.6109 50.1112 15.158C50.1112 15.4794 50.1345 15.8035 50.0743 16.1208C49.9129 17.2341 49.3111 18.2886 48.4016 18.956C47.8026 19.4032 47.0723 19.6658 46.3296 19.7273C45.8332 19.752 45.3271 19.7492 44.8443 19.6166C44.274 19.4757 43.7379 19.1858 43.3276 18.7618C43.2018 18.6305 43.0965 18.4814 42.9843 18.3392C42.9747 19.7725 42.9843 21.2072 42.9802 22.6405C42.5494 22.65 42.1172 22.4722 41.8163 22.1645C41.5031 21.8609 41.3199 21.4219 41.339 20.9856C41.3404 17.6731 41.3376 14.3606 41.3404 11.0495C41.7849 11.0468 42.228 11.2382 42.5111 11.5829C42.6301 11.7265 42.7149 11.8934 42.7778 12.0684C42.827 12.2107 42.8325 12.3625 42.8585 12.5102C43.0513 12.2599 43.2537 12.0151 43.5013 11.8181C43.9909 11.4078 44.5995 11.1535 45.2287 11.0605ZM45.4543 12.4596C44.8211 12.517 44.2166 12.8152 43.783 13.2788C43.2237 13.856 42.9241 14.6697 42.9529 15.4698C42.9652 16.1509 43.2127 16.8306 43.6586 17.349C44.0634 17.8277 44.6378 18.1573 45.2546 18.2694C45.7087 18.3392 46.1847 18.3255 46.6223 18.175C47.2159 17.9781 47.7452 17.5787 48.0816 17.0495C48.4003 16.5653 48.5521 15.9827 48.5576 15.4069C48.5493 14.4276 48.0515 13.4539 47.2323 12.9095C46.718 12.5553 46.0739 12.4008 45.4543 12.4596Z", fill: "#363F44" })
    ] }),
    /* @__PURE__ */ P.jsxs("defs", { children: [
      /* @__PURE__ */ P.jsxs("filter", { id: "filter0_d_923_17213", x: "0", y: "0", width: "33", height: "32", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
        /* @__PURE__ */ P.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        /* @__PURE__ */ P.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
        /* @__PURE__ */ P.jsx("feOffset", { dx: "-1" }),
        /* @__PURE__ */ P.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
        /* @__PURE__ */ P.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" }),
        /* @__PURE__ */ P.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_923_17213" }),
        /* @__PURE__ */ P.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_923_17213", result: "shape" })
      ] }),
      /* @__PURE__ */ P.jsxs("filter", { id: "filter1_d_923_17213", x: "28", y: "0", width: "33", height: "32", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
        /* @__PURE__ */ P.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        /* @__PURE__ */ P.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
        /* @__PURE__ */ P.jsx("feOffset", { dx: "-1" }),
        /* @__PURE__ */ P.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
        /* @__PURE__ */ P.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" }),
        /* @__PURE__ */ P.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_923_17213" }),
        /* @__PURE__ */ P.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_923_17213", result: "shape" })
      ] })
    ] })
  ] });
}
function qM({
  dark: e
}) {
  return /* @__PURE__ */ P.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "32", viewBox: "0 0 33 32", fill: "none", children: [
    /* @__PURE__ */ P.jsxs("g", { filter: "url(#filter0_d_1019_13674)", children: [
      /* @__PURE__ */ P.jsx("rect", { x: "1", width: "32", height: "32", rx: "16", fill: "white" }),
      /* @__PURE__ */ P.jsx("rect", { x: "1.5", y: "0.5", width: "31", height: "31", rx: "15.5", stroke: "#DFE2E7" }),
      /* @__PURE__ */ P.jsx("path", { d: "M17.0003 11.993L22.0203 20.6663H11.9803L17.0003 11.993ZM17.0003 9.33301L9.66699 21.9997H24.3337L17.0003 9.33301ZM17.667 18.6663H16.3337V19.9997H17.667V18.6663ZM17.667 14.6663H16.3337V17.333H17.667V14.6663Z", fill: "#E99921" })
    ] }),
    /* @__PURE__ */ P.jsx("defs", { children: /* @__PURE__ */ P.jsxs("filter", { id: "filter0_d_1019_13674", x: "0", y: "0", width: "33", height: "32", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB", children: [
      /* @__PURE__ */ P.jsx("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ P.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ P.jsx("feOffset", { dx: "-1" }),
      /* @__PURE__ */ P.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ P.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" }),
      /* @__PURE__ */ P.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1019_13674" }),
      /* @__PURE__ */ P.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_1019_13674", result: "shape" })
    ] }) })
  ] });
}
function Bw() {
  return /* @__PURE__ */ P.jsxs("svg", { width: "474", height: "145", viewBox: "0 0 474 145", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ P.jsx("path", { d: "M261.344 32.5352L231.995 37.2194L202.647 32.5352L173.299 37.2194V119.363L202.647 114.68L231.995 119.363L261.344 114.68L290.692 119.363V37.2194L261.344 32.5352Z", fill: "#DFE2E7" }),
    /* @__PURE__ */ P.jsx("path", { d: "M178 54.5V32.5L200.5 29L206.5 28L236.5 32.5L263 28.5L265.5 28L295 33V114.5L266 110L256 111.5L236.5 114.5L221.5 112.5L207 110L200.5 111L178 114.5V54.5Z", fill: "#F3F4F6", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M226.5 96L221.5 112L236.5 114.5L256 111.5L248.5 86L226.5 96Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M186.5 91L200.5 111L178 114.5V55L194.5 62.5L186.5 91Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M200.5 29L178 32.5V54.5L188 59.5L203 34.5L200.5 29Z", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M225 53.5L207.5 68L226.5 96L236.5 93.5L248.5 86V62.5L236.5 68L225 53.5Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M207.5 68L194.5 62.5L188 59.5L203 34.5L200.5 29L206.5 28L225 53.5L207.5 68Z", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M284 77.5L278 57L265.5 58.5L248.5 62.5V86L253 101.5L266 94H278L284 77.5Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M278 94L284 77.5H295V114.5L266 110L256 111.5L253 101.5L266 94H278Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M194.5 62.5L207.5 68L226.5 96L221.5 112.5L207 110L200.5 111L186.5 91L194.5 62.5Z", fill: "#DFFBE8", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M248.5 62.5L236.5 68L224.5 53.5L206.5 28L236.5 32.5L263 28.5L254.5 61L248.5 62.5Z", stroke: "#00004B", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ P.jsx("path", { d: "M254.5 61L263 28.5L265.5 28L295 33V77.5H284L278 57L265.5 58.5L254.5 61Z", fill: "#F3F4F6", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M178 54.5V32.5L200.5 29L206.5 28L236.5 32.5L263 28.5L265.5 28L295 33V114.5L266 110L256 111.5L236.5 114.5L221.5 112.5L207 110L200.5 111L178 114.5V54.5Z", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("line", { opacity: "0.2", x1: "206.75", y1: "29", x2: "206.75", y2: "110", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("line", { opacity: "0.2", x1: "265.75", y1: "28", x2: "265.75", y2: "110", stroke: "#00004B", strokeWidth: "1.5" }),
    /* @__PURE__ */ P.jsx("path", { d: "M149 55H325", stroke: "#31B4F2", strokeWidth: "4", strokeLinecap: "round", strokeDasharray: "0.1 6" })
  ] });
}
function Vw({
  dark: e
}) {
  return /* @__PURE__ */ P.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ P.jsx("path", { d: "M9.38626 3.79599C9.38626 5.15679 7.97829 6.25994 7.97829 6.25994C7.97829 6.25994 6.57031 5.15679 6.57031 3.79599C6.57031 2.43518 7.97829 1.33203 7.97829 1.33203C7.97829 1.33203 9.38626 2.43518 9.38626 3.79599Z", stroke: e ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ P.jsx("path", { d: "M11.1073 7.60455C10.1451 8.56679 8.36943 8.35124 8.36943 8.35124C8.36943 8.35124 8.15388 6.57561 9.11612 5.61337C10.0784 4.65114 11.854 4.86668 11.854 4.86668C11.854 4.86668 12.0695 6.64232 11.1073 7.60455Z", stroke: e ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ P.jsx("path", { d: "M11.1073 11.1163C10.1451 12.0785 8.36943 11.863 8.36943 11.863C8.36943 11.863 8.15388 10.0873 9.11612 9.12509C10.0784 8.16286 11.854 8.3784 11.854 8.3784C11.854 8.3784 12.0695 10.154 11.1073 11.1163Z", stroke: e ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ P.jsx("path", { d: "M4.8927 7.60455C5.85494 8.56679 7.63057 8.35124 7.63057 8.35124C7.63057 8.35124 7.84612 6.57561 6.88388 5.61337C5.92165 4.65114 4.14601 4.86668 4.14601 4.86668C4.14601 4.86668 3.93047 6.64232 4.8927 7.60455Z", stroke: e ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ P.jsx("path", { d: "M4.8927 11.1163C5.85494 12.0785 7.63057 11.863 7.63057 11.863C7.63057 11.863 7.84612 10.0873 6.88388 9.12509C5.92165 8.16286 4.14601 8.3784 4.14601 8.3784C4.14601 8.3784 3.93047 10.154 4.8927 11.1163Z", stroke: e ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinejoin: "round" }),
    /* @__PURE__ */ P.jsx("path", { d: "M7.97852 6.96094L7.97852 14.7048", stroke: e ? "#A3A9B9" : "#0071CD", strokeWidth: "1.5", strokeLinecap: "round" })
  ] });
}
function WM({
  dark: e
}) {
  return /* @__PURE__ */ P.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6665 5.33224V9.37224C15.0798 9.79224 15.3332 10.3656 15.3332 10.9989C15.3332 12.2856 14.2865 13.3322 12.9998 13.3322C11.7132 13.3322 10.6665 12.2856 10.6665 10.9989C10.6665 10.9139 10.6778 10.8289 10.689 10.7439C10.6928 10.7156 10.6965 10.6872 10.6998 10.6589H7.25984C7.21984 10.8456 7.1665 11.0322 7.09984 11.2056L6.49984 10.9389L6.35984 11.2456L6.95317 11.5122C6.6065 12.1989 6.03984 12.7456 5.33317 13.0522L5.09984 12.4322L4.7865 12.5522L5.01317 13.1589C4.69317 13.2589 4.35317 13.3322 3.99984 13.3322C3.57317 13.3322 3.15984 13.2456 2.79317 13.0989L3.05984 12.4989L2.75317 12.3589L2.4865 12.9522C1.79984 12.6056 1.25317 12.0389 0.946504 11.3322L1.5665 11.0989L1.4465 10.7856L0.839837 11.0122C0.739837 10.6922 0.666504 10.3522 0.666504 9.99891C0.666504 9.57224 0.753171 9.15891 0.899837 8.79224L1.49984 9.05891L1.63984 8.75224L1.0465 8.48557C1.39317 7.79891 1.95984 7.25224 2.6665 6.94557L2.89984 7.56557L3.21317 7.44557L2.9865 6.83891C3.3065 6.73891 3.6465 6.66557 3.99984 6.66557C4.4265 6.66557 4.83984 6.75224 5.2065 6.89891L4.93984 7.49891L5.2465 7.63891L5.51317 7.04557C5.67317 7.13224 5.8265 7.22557 5.97317 7.33224H7.33317C8.0665 7.33224 8.6665 6.73224 8.6665 5.99891V4.47224L7.95984 3.76557L7.01984 4.70557L6.5465 4.23224L8.89984 1.87891L9.37317 2.35224L8.43317 3.29224L9.13984 3.99891H13.3332C14.0665 3.99891 14.6665 4.59891 14.6665 5.33224ZM1.99984 9.99891C1.99984 11.1056 2.89317 11.9989 3.99984 11.9989C5.1065 11.9989 5.99984 11.1056 5.99984 9.99891C5.99984 8.89224 5.1065 7.99891 3.99984 7.99891C2.89317 7.99891 1.99984 8.89224 1.99984 9.99891ZM7.15984 8.98557C7.19317 9.09891 7.21984 9.21224 7.2465 9.33224H11.3732C11.7932 8.91891 12.3665 8.66557 12.9998 8.66557C13.0879 8.66557 13.1759 8.67764 13.2608 8.68927C13.2852 8.69262 13.3093 8.69593 13.3332 8.69891V5.33224H9.99984V5.99891C9.99984 7.47224 8.8065 8.66557 7.33317 8.66557H7.05317L6.43317 8.89891L6.55317 9.21224L7.15984 8.98557ZM11.9998 10.9989C11.9998 11.5522 12.4465 11.9989 12.9998 11.9989C13.5532 11.9989 13.9998 11.5522 13.9998 10.9989C13.9998 10.4456 13.5532 9.99891 12.9998 9.99891C12.4465 9.99891 11.9998 10.4456 11.9998 10.9989ZM5.99984 5.9987H2.6665C2.29984 5.9987 1.99984 5.6987 1.99984 5.33203C1.99984 4.96536 2.29984 4.66536 2.6665 4.66536H4.6665C5.39984 4.66536 5.99984 5.26536 5.99984 5.9987Z", fill: e ? "#A3A9B9" : "#0071CD" }) });
}
function Uw({
  dark: e
}) {
  return /* @__PURE__ */ P.jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.33333 2H4.66667V3.33333L11.3333 3.33333V2H12.6667V3.33333L14 3.33333V4.66667H12.6667V11.3333H14V12.6667H12.6667V14H11.3333V12.6667L4.66667 12.6667V14H3.33333V12.6667H2V11.3333H3.33333V4.66667H2V3.33333L3.33333 3.33333V2ZM4.66667 11.3333V4.66667L11.3333 4.66667V11.3333L4.66667 11.3333Z", fill: e ? "#A3A9B9" : "#0071CD" }) });
}
const Hw = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M5.02633 13.666C4.6018 13.666 4.23624 13.5221 3.92963 13.2344C3.62303 12.9467 3.46973 12.5905 3.46973 12.166V4.26979C3.46973 3.9113 3.58058 3.59054 3.80227 3.30753C4.02397 3.02451 4.31407 2.84526 4.67256 2.76979L10.2622 1.66602V10.7226L4.89897 11.7981C4.81407 11.817 4.74331 11.8618 4.68671 11.9325C4.6301 12.0033 4.6018 12.0811 4.6018 12.166C4.6018 12.2698 4.64425 12.3571 4.72916 12.4278C4.81407 12.4986 4.91312 12.5339 5.02633 12.5339H11.3943V3.47734H12.5263V13.666H5.02633ZM6.29992 10.3688L9.1301 9.81696V3.05281L6.29992 3.60469V10.3688ZM5.16784 10.5953V3.83111L4.95558 3.87356C4.8518 3.89243 4.7669 3.93724 4.70086 4.008C4.63482 4.07875 4.6018 4.16602 4.6018 4.26979V10.7368C4.64897 10.7179 4.6985 10.7014 4.75039 10.6872C4.80227 10.6731 4.8518 10.6613 4.89897 10.6519L5.16784 10.5953Z", fill: "currentColor" })), zw = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.35059 8.00052C3.35059 10.3472 5.09059 12.2872 7.35059 12.6139V14.6339C3.98392 14.3005 1.35059 11.4605 1.35059 8.00052C1.35059 4.54052 3.98392 1.70052 7.35059 1.36719V3.38719C5.09059 3.71385 3.35059 5.65385 3.35059 8.00052ZM8.68392 3.38719C10.7239 3.68052 12.3373 5.29385 12.6306 7.33385H14.6506C14.3373 4.18719 11.8306 1.68052 8.68392 1.36719V3.38719ZM12.6306 8.66667C12.3373 10.7067 10.7239 12.32 8.68392 12.6133V14.6333C11.8306 14.32 14.3373 11.8133 14.6506 8.66667H12.6306Z", fill: "currentColor" })), qw = (e) => /* @__PURE__ */ y.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M13.3332 6.0013V4.0013H11.9998V6.0013H9.99984V7.33464H11.9998V9.33463H13.3332V7.33464H15.3332V6.0013H13.3332ZM5.99984 8.0013C7.47317 8.0013 8.6665 6.80797 8.6665 5.33464C8.6665 3.8613 7.47317 2.66797 5.99984 2.66797C4.5265 2.66797 3.33317 3.8613 3.33317 5.33464C3.33317 6.80797 4.5265 8.0013 5.99984 8.0013ZM5.99984 4.0013C6.73317 4.0013 7.33317 4.6013 7.33317 5.33464C7.33317 6.06797 6.73317 6.66797 5.99984 6.66797C5.2665 6.66797 4.6665 6.06797 4.6665 5.33464C4.6665 4.6013 5.2665 4.0013 5.99984 4.0013ZM10.2598 9.70797C9.13984 9.13464 7.6865 8.66797 5.99984 8.66797C4.31317 8.66797 2.85984 9.13464 1.73984 9.70797C1.07317 10.048 0.666504 10.7346 0.666504 11.4813V13.3346H11.3332V11.4813C11.3332 10.7346 10.9265 10.048 10.2598 9.70797ZM9.99984 12.0013H1.99984V11.4813C1.99984 11.228 2.13317 11.0013 2.3465 10.8946C3.13984 10.488 4.41984 10.0013 5.99984 10.0013C7.57984 10.0013 8.85984 10.488 9.65317 10.8946C9.8665 11.0013 9.99984 11.228 9.99984 11.4813V12.0013Z", fill: "currentColor" }));
function Ww({
  dark: e
}) {
  return /* @__PURE__ */ P.jsxs("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00021 7.9987H9.00021L9.91828 10.4298C10.0829 10.8659 9.76072 11.332 9.2946 11.332H6.70651C6.24046 11.332 5.91823 10.866 6.08277 10.43L7.00021 7.9987ZM7.66688 9.33203L7.33354 9.9987H8.66688L8.33354 9.33203H7.66688Z", fill: e ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33354 15.332L7.33354 12.6654H8.66688V15.332H7.33354Z", fill: e ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5549 14.0326L9.44552 12.3685L10.5549 11.6289L11.6643 13.293L10.5549 14.0326Z", fill: e ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.33612 13.293L5.44552 11.6289L6.55492 12.3685L5.44552 14.0326L4.33612 13.293Z", fill: e ? "#A3A9B9" : "#0071CD" }),
    /* @__PURE__ */ P.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.45976 2.38678C3.14391 1.94561 3.45925 1.33203 4.00183 1.33203H11.9984C12.541 1.33203 12.8563 1.94559 12.5405 2.38677L9.00021 7.33203H7.00021L3.45976 2.38678ZM5.29556 2.66536L7.67651 5.9987H8.32368L10.7046 2.66536H5.29556Z", fill: e ? "#A3A9B9" : "#0071CD" })
  ] });
}
const Gw = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 8C8.895 8 8 8.895 8 10C8 11.105 8.895 12 10 12C11.105 12 12 11.105 12 10C12 8.895 11.105 8 10 8ZM10.6667 10C10.6667 10.3682 10.3682 10.6667 10 10.6667C9.63181 10.6667 9.33333 10.3682 9.33333 10C9.33333 9.63181 9.63181 9.33333 10 9.33333C10.3682 9.33333 10.6667 9.63181 10.6667 10ZM9.33333 6.66667C10.8061 6.66667 12 5.47276 12 4C12 2.52724 10.8061 1.33333 9.33333 1.33333L4.66667 1.33333V2.66667L9.33333 2.66667C10.0697 2.66667 10.6667 3.26361 10.6667 4C10.6667 4.73639 10.0697 5.33333 9.33333 5.33333L2.66667 5.33333C1.19391 5.33333 5.96046e-08 6.52724 0 8C0 9.47276 1.19391 10.6667 2.66667 10.6667L7.33333 10.6667V9.33333L2.66667 9.33333C1.93029 9.33333 1.33333 8.73639 1.33333 8C1.33333 7.26361 1.93029 6.66667 2.66667 6.66667L9.33333 6.66667ZM4 0H4.17233e-07L2.38419e-07 4L4 4L4 0ZM2.66667 1.33333H1.33333L1.33333 2.66667H2.66667L2.66667 1.33333Z", fill: "#0071CD" })), GM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 1.5H4.5C3.675 1.5 3 2.175 3 3V15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5ZM12 9H6V10.5H12V9ZM12 12H6V13.5H12V12ZM4.5 15H13.5V6.75H9.75V3H4.5V15Z", fill: "#696F88" })), KM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z", fill: "#CF3537" })), Kw = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M7.33317 0.333984H1.99984C1.2665 0.333984 0.673171 0.933984 0.673171 1.66732L0.666504 12.334C0.666504 13.0673 1.25984 13.6673 1.99317 13.6673H9.99984C10.7332 13.6673 11.3332 13.0673 11.3332 12.334V4.33398L7.33317 0.333984ZM9.99984 12.334H1.99984V1.66732H6.6665V5.00065H9.99984V12.334ZM3.33317 9.00732L4.27317 9.94732L5.33317 8.89398V11.6673H6.6665V8.89398L7.7265 9.95399L8.6665 9.00732L6.0065 6.33398L3.33317 9.00732Z", fill: "currentColor" })), YM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.1265 4.35052L1.33984 2.56385L2.27984 1.61719L14.0998 13.4439L13.1598 14.3839L10.8798 12.1039C9.9865 12.4572 9.01317 12.6505 7.99984 12.6505C4.6665 12.6505 1.81984 10.5772 0.666504 7.65052C1.17984 6.33719 2.03984 5.20385 3.1265 4.35052ZM8.00007 3.98438C10.5267 3.98438 12.7801 5.40438 13.8801 7.65104C13.4867 8.46437 12.9334 9.16437 12.2734 9.73104L13.2134 10.671C14.1401 9.85104 14.8734 8.82437 15.3334 7.65104C14.1801 4.72438 11.3334 2.65104 8.00007 2.65104C7.15341 2.65104 6.34007 2.78438 5.57341 3.03104L6.67341 4.13104C7.10674 4.04437 7.54674 3.98438 8.00007 3.98438ZM7.2863 4.74437L8.6663 6.12437C9.0463 6.29104 9.35296 6.59771 9.51963 6.97771L10.8996 8.35771C10.953 8.13104 10.993 7.89104 10.993 7.64437C10.9996 5.99104 9.65296 4.65104 7.99963 4.65104C7.75296 4.65104 7.51963 4.68437 7.2863 4.74437ZM6.33984 7.5651L8.07984 9.3051C8.05317 9.31177 8.0265 9.31844 7.99984 9.31844C7.07984 9.31844 6.33317 8.57177 6.33317 7.65177C6.33317 7.6351 6.33484 7.62177 6.3365 7.60844C6.33817 7.5951 6.33984 7.58177 6.33984 7.5651ZM5.23963 6.46354L4.07296 5.29688C3.2663 5.91021 2.5863 6.69688 2.11963 7.65021C3.21963 9.89687 5.47296 11.3169 7.99963 11.3169C8.63296 11.3169 9.2463 11.2235 9.83296 11.0635L9.17963 10.4102C8.81963 10.5635 8.41963 10.6502 7.99963 10.6502C6.3463 10.6502 4.99963 9.30354 4.99963 7.65021C4.99963 7.23021 5.0863 6.83021 5.23963 6.46354Z", fill: "currentColor" })), ZM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18.3333C14.6 18.3333 18.3334 14.5999 18.3334 9.99992C18.3334 5.39992 14.6 1.66658 10 1.66658C5.40004 1.66658 1.66671 5.39992 1.66671 9.99992C1.66671 14.5999 5.40004 18.3333 10 18.3333ZM10.8334 14.1666V12.4999H9.16671V14.1666H10.8334ZM10.8334 10.8333L10.8334 5.83325H9.16671V10.8333H10.8334ZM16.6667 9.99992C16.6667 6.32492 13.675 3.33325 10 3.33325C6.32504 3.33325 3.33337 6.32492 3.33337 9.99992C3.33337 13.6749 6.32504 16.6666 10 16.6666C13.675 16.6666 16.6667 13.6749 16.6667 9.99992Z", fill: "#696F88" })), Yw = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0002 10.334H11.6668C12.7714 10.334 13.6668 9.43855 13.6668 8.33398C13.6668 7.22941 12.7714 6.33398 11.6668 6.33398H11.0002V4.33398C11.0002 3.5976 10.4032 3.00065 9.66683 3.00065H7.66683V2.33398C7.66683 1.22941 6.7714 0.333984 5.66683 0.333984C4.56226 0.333984 3.66683 1.22941 3.66683 2.33398V3.00065H1.66683C0.93045 3.00065 0.333496 3.5976 0.333496 4.33398V7.66732H2.3335C2.70169 7.66732 3.00016 7.96579 3.00016 8.33398C3.00016 8.70218 2.70169 9.00065 2.3335 9.00065H0.333496V12.334C0.333496 13.0704 0.93045 13.6673 1.66683 13.6673H5.00016V11.6673C5.00016 11.2991 5.29864 11.0007 5.66683 11.0007C6.03502 11.0007 6.3335 11.2991 6.3335 11.6673V13.6673H9.66683C10.4032 13.6673 11.0002 13.0704 11.0002 12.334V10.334ZM7.66683 12.334H9.66683V9.00065H11.6668C12.035 9.00065 12.3335 8.70218 12.3335 8.33398C12.3335 7.96579 12.035 7.66732 11.6668 7.66732H9.66683V4.33398H6.3335V2.33398C6.3335 1.96579 6.03502 1.66732 5.66683 1.66732C5.29864 1.66732 5.00016 1.96579 5.00016 2.33398V4.33398H1.66683V6.33398H2.3335C3.43807 6.33398 4.3335 7.22941 4.3335 8.33398C4.3335 9.43855 3.43807 10.334 2.3335 10.334H1.66683V12.334H3.66683V11.6673C3.66683 10.5627 4.56226 9.66732 5.66683 9.66732C6.7714 9.66732 7.66683 10.5627 7.66683 11.6673V12.334Z", fill: "currentColor" })), QM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 14.25H16.5V11.25H18V6.75H9.99C9.1275 4.935 7.29 3.75 5.25 3.75C2.355 3.75 0 6.105 0 9C0 11.895 2.355 14.25 5.25 14.25C7.29 14.25 9.135 13.065 9.99 11.25H12V14.25ZM15 12.75H13.5V9.75H8.955L8.7825 10.2525C8.2575 11.745 6.8325 12.75 5.25 12.75C3.18 12.75 1.5 11.07 1.5 9C1.5 6.93 3.18 5.25 5.25 5.25C6.8325 5.25 8.2575 6.255 8.7825 7.7475L8.955 8.25H16.5V9.75H15V12.75ZM5.25 11.25C4.0125 11.25 3 10.2375 3 9C3 7.7625 4.0125 6.75 5.25 6.75C6.4875 6.75 7.5 7.7625 7.5 9C7.5 10.2375 6.4875 11.25 5.25 11.25ZM4.5 9C4.5 8.5875 4.8375 8.25 5.25 8.25C5.6625 8.25 6 8.5875 6 9C6 9.4125 5.6625 9.75 5.25 9.75C4.8375 9.75 4.5 9.4125 4.5 9Z", fill: "#696F88" })), Zw = () => /* @__PURE__ */ P.jsx("svg", { viewBox: "0 0 1024 1024", focusable: "false", "data-icon": "loading", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ P.jsx("path", { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" }) }), tp = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z", fill: "currentColor" })), XM = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 6.75H11.25V2.25H12.75V3.75H15.75V5.25H12.75V6.75ZM2.25 5.25V3.75H9.75V5.25H2.25ZM2.25 14.25V12.75H6.75V14.25H2.25ZM9.75 15.75V14.25H15.75V12.75H9.75V11.25H8.25V15.75H9.75ZM5.25 8.25V6.75H6.75V11.25H5.25V9.75H2.25V8.25H5.25ZM15.75 9.75V8.25H8.25V9.75H15.75Z", fill: "#696F88" })), JM = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.75 9C2.0475 5.7075 5.25 3.375 9 3.375C12.75 3.375 15.9525 5.7075 17.25 9C15.9525 12.2925 12.75 14.625 9 14.625C5.25 14.625 2.0475 12.2925 0.75 9ZM15.6148 9C14.3773 6.4725 11.8423 4.875 8.99977 4.875C6.15727 4.875 3.62227 6.4725 2.38477 9C3.62227 11.5275 6.15727 13.125 8.99977 13.125C11.8423 13.125 14.3773 11.5275 15.6148 9ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM5.625 9C5.625 7.14 7.14 5.625 9 5.625C10.86 5.625 12.375 7.14 12.375 9C12.375 10.86 10.86 12.375 9 12.375C7.14 12.375 5.625 10.86 5.625 9Z", fill: "currentColor" })), eD = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.378 6.75 9 4.372 6.623 6.75 5.558 5.692 9 2.25l3.435 3.442-1.057 1.058Zm-4.755 4.5L9 13.627l2.378-2.377 1.065 1.057L9 15.75l-3.435-3.443 1.058-1.057Z", fill: "#696F88" })), tD = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.51 5L21.5 9L17.51 13V10H10.5V8H17.51V5ZM3.5 15L7.49 11V14H14.5V16H7.49V19L3.5 15Z", fill: "#696F88" })), nD = (e) => /* @__PURE__ */ y.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.875 2.25H7.125L6.375 3H3.75V4.5H14.25V3H11.625L10.875 2.25ZM12 6.75V14.25H6V6.75H12ZM4.5 5.25H13.5V14.25C13.5 15.075 12.825 15.75 12 15.75H6C5.175 15.75 4.5 15.075 4.5 14.25V5.25Z", fill: "#CF3537" }));
var wn = function() {
  return wn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, wn.apply(this, arguments);
};
function Si(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Qw(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Xw = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Jw = /* @__PURE__ */ Qw(
  function(e) {
    return Xw.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Pt = "-ms-", pa = "-moz-", vt = "-webkit-", J0 = "comm", Bl = "rule", Hf = "decl", e5 = "@import", em = "@keyframes", t5 = "@layer", tm = Math.abs, zf = String.fromCharCode, id = Object.assign;
function n5(e, t) {
  return an(e, 0) ^ 45 ? (((t << 2 ^ an(e, 0)) << 2 ^ an(e, 1)) << 2 ^ an(e, 2)) << 2 ^ an(e, 3) : 0;
}
function nm(e) {
  return e.trim();
}
function Lr(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ge(e, t, n) {
  return e.replace(t, n);
}
function js(e, t, n) {
  return e.indexOf(t, n);
}
function an(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ti(e, t, n) {
  return e.slice(t, n);
}
function Tr(e) {
  return e.length;
}
function rm(e) {
  return e.length;
}
function da(e, t) {
  return t.push(e), e;
}
function r5(e, t) {
  return e.map(t).join("");
}
function np(e, t) {
  return e.filter(function(n) {
    return !Lr(n, t);
  });
}
var Vl = 1, Oi = 1, om = 0, er = 0, Wt = 0, Bi = "";
function Ul(e, t, n, r, o, i, a, s) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: Vl, column: Oi, length: a, return: "", siblings: s };
}
function no(e, t) {
  return id(Ul("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function Jo(e) {
  for (; e.root; )
    e = no(e.root, { children: [e] });
  da(e, e.siblings);
}
function o5() {
  return Wt;
}
function i5() {
  return Wt = er > 0 ? an(Bi, --er) : 0, Oi--, Wt === 10 && (Oi = 1, Vl--), Wt;
}
function fr() {
  return Wt = er < om ? an(Bi, er++) : 0, Oi++, Wt === 10 && (Oi = 1, Vl++), Wt;
}
function No() {
  return an(Bi, er);
}
function Bs() {
  return er;
}
function Hl(e, t) {
  return Ti(Bi, e, t);
}
function ad(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function a5(e) {
  return Vl = Oi = 1, om = Tr(Bi = e), er = 0, [];
}
function s5(e) {
  return Bi = "", e;
}
function Kc(e) {
  return nm(Hl(er - 1, sd(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function l5(e) {
  for (; (Wt = No()) && Wt < 33; )
    fr();
  return ad(e) > 2 || ad(Wt) > 3 ? "" : " ";
}
function c5(e, t) {
  for (; --t && fr() && !(Wt < 48 || Wt > 102 || Wt > 57 && Wt < 65 || Wt > 70 && Wt < 97); )
    ;
  return Hl(e, Bs() + (t < 6 && No() == 32 && fr() == 32));
}
function sd(e) {
  for (; fr(); )
    switch (Wt) {
      case e:
        return er;
      case 34:
      case 39:
        e !== 34 && e !== 39 && sd(Wt);
        break;
      case 40:
        e === 41 && sd(e);
        break;
      case 92:
        fr();
        break;
    }
  return er;
}
function u5(e, t) {
  for (; fr() && e + Wt !== 57; )
    if (e + Wt === 84 && No() === 47)
      break;
  return "/*" + Hl(t, er - 1) + "*" + zf(e === 47 ? e : fr());
}
function d5(e) {
  for (; !ad(No()); )
    fr();
  return Hl(e, er);
}
function f5(e) {
  return s5(Vs("", null, null, null, [""], e = a5(e), 0, [0], e));
}
function Vs(e, t, n, r, o, i, a, s, l) {
  for (var c = 0, u = 0, d = a, f = 0, h = 0, p = 0, g = 1, v = 1, b = 1, m = 0, w = "", E = o, C = i, x = r, _ = w; v; )
    switch (p = m, m = fr()) {
      case 40:
        if (p != 108 && an(_, d - 1) == 58) {
          js(_ += Ge(Kc(m), "&", "&\f"), "&\f", tm(c ? s[c - 1] : 0)) != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Kc(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += l5(p);
        break;
      case 92:
        _ += c5(Bs() - 1, 7);
        continue;
      case 47:
        switch (No()) {
          case 42:
          case 47:
            da(h5(u5(fr(), Bs()), t, n, l), l);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * g:
        s[c++] = Tr(_) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            v = 0;
          case 59 + u:
            b == -1 && (_ = Ge(_, /\f/g, "")), h > 0 && Tr(_) - d && da(h > 32 ? op(_ + ";", r, n, d - 1, l) : op(Ge(_, " ", "") + ";", r, n, d - 2, l), l);
            break;
          case 59:
            _ += ";";
          default:
            if (da(x = rp(_, t, n, c, u, o, s, w, E = [], C = [], d, i), i), m === 123)
              if (u === 0)
                Vs(_, t, x, x, E, i, d, s, C);
              else
                switch (f === 99 && an(_, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Vs(e, x, x, r && da(rp(e, x, x, 0, 0, o, s, w, o, E = [], d, C), C), o, C, d, s, r ? E : C);
                    break;
                  default:
                    Vs(_, x, x, x, [""], C, 0, s, C);
                }
        }
        c = u = h = 0, g = b = 1, w = _ = "", d = a;
        break;
      case 58:
        d = 1 + Tr(_), h = p;
      default:
        if (g < 1) {
          if (m == 123)
            --g;
          else if (m == 125 && g++ == 0 && i5() == 125)
            continue;
        }
        switch (_ += zf(m), m * g) {
          case 38:
            b = u > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[c++] = (Tr(_) - 1) * b, b = 1;
            break;
          case 64:
            No() === 45 && (_ += Kc(fr())), f = No(), u = d = Tr(w = _ += d5(Bs())), m++;
            break;
          case 45:
            p === 45 && Tr(_) == 2 && (g = 0);
        }
    }
  return i;
}
function rp(e, t, n, r, o, i, a, s, l, c, u, d) {
  for (var f = o - 1, h = o === 0 ? i : [""], p = rm(h), g = 0, v = 0, b = 0; g < r; ++g)
    for (var m = 0, w = Ti(e, f + 1, f = tm(v = a[g])), E = e; m < p; ++m)
      (E = nm(v > 0 ? h[m] + " " + w : Ge(w, /&\f/g, h[m]))) && (l[b++] = E);
  return Ul(e, t, n, o === 0 ? Bl : s, l, c, u, d);
}
function h5(e, t, n, r) {
  return Ul(e, t, n, J0, zf(o5()), Ti(e, 2, -2), 0, r);
}
function op(e, t, n, r, o) {
  return Ul(e, t, n, Hf, Ti(e, 0, r), Ti(e, r + 1, -1), r, o);
}
function im(e, t, n) {
  switch (n5(e, t)) {
    case 5103:
      return vt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return vt + e + e;
    case 4789:
      return pa + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return vt + e + pa + e + Pt + e + e;
    case 5936:
      switch (an(e, t + 11)) {
        case 114:
          return vt + e + Pt + Ge(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return vt + e + Pt + Ge(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return vt + e + Pt + Ge(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return vt + e + Pt + e + e;
    case 6165:
      return vt + e + Pt + "flex-" + e + e;
    case 5187:
      return vt + e + Ge(e, /(\w+).+(:[^]+)/, vt + "box-$1$2" + Pt + "flex-$1$2") + e;
    case 5443:
      return vt + e + Pt + "flex-item-" + Ge(e, /flex-|-self/g, "") + (Lr(e, /flex-|baseline/) ? "" : Pt + "grid-row-" + Ge(e, /flex-|-self/g, "")) + e;
    case 4675:
      return vt + e + Pt + "flex-line-pack" + Ge(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return vt + e + Pt + Ge(e, "shrink", "negative") + e;
    case 5292:
      return vt + e + Pt + Ge(e, "basis", "preferred-size") + e;
    case 6060:
      return vt + "box-" + Ge(e, "-grow", "") + vt + e + Pt + Ge(e, "grow", "positive") + e;
    case 4554:
      return vt + Ge(e, /([^-])(transform)/g, "$1" + vt + "$2") + e;
    case 6187:
      return Ge(Ge(Ge(e, /(zoom-|grab)/, vt + "$1"), /(image-set)/, vt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ge(e, /(image-set\([^]*)/, vt + "$1$`$1");
    case 4968:
      return Ge(Ge(e, /(.+:)(flex-)?(.*)/, vt + "box-pack:$3" + Pt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + vt + e + e;
    case 4200:
      if (!Lr(e, /flex-|baseline/))
        return Pt + "grid-column-align" + Ti(e, t) + e;
      break;
    case 2592:
    case 3360:
      return Pt + Ge(e, "template-", "") + e;
    case 4384:
    case 3616:
      return n && n.some(function(r, o) {
        return t = o, Lr(r.props, /grid-\w+-end/);
      }) ? ~js(e + (n = n[t].value), "span", 0) ? e : Pt + Ge(e, "-start", "") + e + Pt + "grid-row-span:" + (~js(n, "span", 0) ? Lr(n, /\d+/) : +Lr(n, /\d+/) - +Lr(e, /\d+/)) + ";" : Pt + Ge(e, "-start", "") + e;
    case 4896:
    case 4128:
      return n && n.some(function(r) {
        return Lr(r.props, /grid-\w+-start/);
      }) ? e : Pt + Ge(Ge(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ge(e, /(.+)-inline(.+)/, vt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Tr(e) - 1 - t > 6)
        switch (an(e, t + 1)) {
          case 109:
            if (an(e, t + 4) !== 45)
              break;
          case 102:
            return Ge(e, /(.+:)(.+)-([^]+)/, "$1" + vt + "$2-$3$1" + pa + (an(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~js(e, "stretch", 0) ? im(Ge(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return Ge(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, o, i, a, s, l, c) {
        return Pt + o + ":" + i + c + (a ? Pt + o + "-span:" + (s ? l : +l - +i) + c : "") + e;
      });
    case 4949:
      if (an(e, t + 6) === 121)
        return Ge(e, ":", ":" + vt) + e;
      break;
    case 6444:
      switch (an(e, an(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return Ge(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + vt + (an(e, 14) === 45 ? "inline-" : "") + "box$3$1" + vt + "$2$3$1" + Pt + "$2box$3") + e;
        case 100:
          return Ge(e, ":", ":" + Pt) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return Ge(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function fl(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function p5(e, t, n, r) {
  switch (e.type) {
    case t5:
      if (e.children.length)
        break;
    case e5:
    case Hf:
      return e.return = e.return || e.value;
    case J0:
      return "";
    case em:
      return e.return = e.value + "{" + fl(e.children, r) + "}";
    case Bl:
      if (!Tr(e.value = e.props.join(",")))
        return "";
  }
  return Tr(n = fl(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function v5(e) {
  var t = rm(e);
  return function(n, r, o, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, r, o, i) || "";
    return a;
  };
}
function g5(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function m5(e, t, n, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Hf:
        e.return = im(e.value, e.length, n);
        return;
      case em:
        return fl([no(e, { value: Ge(e.value, "@", "@" + vt) })], r);
      case Bl:
        if (e.length)
          return r5(n = e.props, function(o) {
            switch (Lr(o, r = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Jo(no(e, { props: [Ge(o, /:(read-\w+)/, ":" + pa + "$1")] })), Jo(no(e, { props: [o] })), id(e, { props: np(n, r) });
                break;
              case "::placeholder":
                Jo(no(e, { props: [Ge(o, /:(plac\w+)/, ":" + vt + "input-$1")] })), Jo(no(e, { props: [Ge(o, /:(plac\w+)/, ":" + pa + "$1")] })), Jo(no(e, { props: [Ge(o, /:(plac\w+)/, Pt + "input-$1")] })), Jo(no(e, { props: [o] })), id(e, { props: np(n, r) });
                break;
            }
            return "";
          });
    }
}
var y5 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Do = typeof z < "u" && z.env !== void 0 && (z.env.REACT_APP_SC_ATTR || z.env.SC_ATTR) || "data-styled", am = "active", sm = "data-styled-version", zl = "6.1.12", qf = `/*!sc*/
`, hl = typeof window < "u" && "HTMLElement" in window, b5 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof z < "u" && z.env !== void 0 && z.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && z.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? z.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && z.env.REACT_APP_SC_DISABLE_SPEEDY : typeof z < "u" && z.env !== void 0 && z.env.SC_DISABLE_SPEEDY !== void 0 && z.env.SC_DISABLE_SPEEDY !== "" ? z.env.SC_DISABLE_SPEEDY !== "false" && z.env.SC_DISABLE_SPEEDY : z.env.NODE_ENV !== "production"), ip = /invalid hook call/i, ss = /* @__PURE__ */ new Set(), C5 = function(e, t) {
  if (z.env.NODE_ENV !== "production") {
    var n = t ? ' with the id of "'.concat(t, '"') : "", r = "The component ".concat(e).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, o = console.error;
    try {
      var i = !0;
      console.error = function(a) {
        for (var s = [], l = 1; l < arguments.length; l++)
          s[l - 1] = arguments[l];
        ip.test(a) ? (i = !1, ss.delete(r)) : o.apply(void 0, Si([a], s, !1));
      }, lt(), i && !ss.has(r) && (console.warn(r), ss.add(r));
    } catch (a) {
      ip.test(a.message) && ss.delete(r);
    } finally {
      console.error = o;
    }
  }
}, ql = Object.freeze([]), Pi = Object.freeze({});
function w5(e, t, n) {
  return n === void 0 && (n = Pi), e.theme !== n.theme && e.theme || t || n.theme;
}
var ld = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), E5 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, _5 = /(^-|-$)/g;
function ap(e) {
  return e.replace(E5, "-").replace(_5, "");
}
var x5 = /(a)(d)/gi, ls = 52, sp = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function cd(e) {
  var t, n = "";
  for (t = Math.abs(e); t > ls; t = t / ls | 0)
    n = sp(t % ls) + n;
  return (sp(t % ls) + n).replace(x5, "$1-$2");
}
var Yc, lm = 5381, xo = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, cm = function(e) {
  return xo(lm, e);
};
function S5(e) {
  return cd(cm(e) >>> 0);
}
function um(e) {
  return z.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Zc(e) {
  return typeof e == "string" && (z.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var dm = typeof Symbol == "function" && Symbol.for, fm = dm ? Symbol.for("react.memo") : 60115, T5 = dm ? Symbol.for("react.forward_ref") : 60112, O5 = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, P5 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, hm = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, R5 = ((Yc = {})[T5] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, Yc[fm] = hm, Yc);
function lp(e) {
  return ("type" in (t = e) && t.type.$$typeof) === fm ? hm : "$$typeof" in e ? R5[e.$$typeof] : O5;
  var t;
}
var A5 = Object.defineProperty, I5 = Object.getOwnPropertyNames, cp = Object.getOwnPropertySymbols, k5 = Object.getOwnPropertyDescriptor, $5 = Object.getPrototypeOf, up = Object.prototype;
function pm(e, t, n) {
  if (typeof t != "string") {
    if (up) {
      var r = $5(t);
      r && r !== up && pm(e, r, n);
    }
    var o = I5(t);
    cp && (o = o.concat(cp(t)));
    for (var i = lp(e), a = lp(t), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!(l in P5 || n && n[l] || a && l in a || i && l in i)) {
        var c = k5(t, l);
        try {
          A5(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
function jo(e) {
  return typeof e == "function";
}
function Wf(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function Po(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function dp(e, t) {
  if (e.length === 0)
    return "";
  for (var n = e[0], r = 1; r < e.length; r++)
    n += e[r];
  return n;
}
function Ri(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function ud(e, t, n) {
  if (n === void 0 && (n = !1), !n && !Ri(e) && !Array.isArray(e))
    return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      e[r] = ud(e[r], t[r]);
  else if (Ri(t))
    for (var r in t)
      e[r] = ud(e[r], t[r]);
  return e;
}
function Gf(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
var N5 = z.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function F5() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = e[0], r = [], o = 1, i = e.length; o < i; o += 1)
    r.push(e[o]);
  return r.forEach(function(a) {
    n = n.replace(/%[a-z]/, a);
  }), n;
}
function Vr(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return z.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : "")) : new Error(F5.apply(void 0, Si([N5[e]], t, !1)).trim());
}
var L5 = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var n = 0, r = 0; r < t; r++)
      n += this.groupSizes[r];
    return n;
  }, e.prototype.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var r = this.groupSizes, o = r.length, i = o; t >= i; )
        if ((i <<= 1) < 0)
          throw Vr(16, "".concat(t));
      this.groupSizes = new Uint32Array(i), this.groupSizes.set(r), this.length = i;
      for (var a = o; a < i; a++)
        this.groupSizes[a] = 0;
    }
    for (var s = this.indexOfGroup(t + 1), l = (a = 0, n.length); a < l; a++)
      this.tag.insertRule(s, n[a]) && (this.groupSizes[t]++, s++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], r = this.indexOfGroup(t), o = r + n;
      this.groupSizes[t] = 0;
      for (var i = r; i < o; i++)
        this.tag.deleteRule(r);
    }
  }, e.prototype.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return n;
    for (var r = this.groupSizes[t], o = this.indexOfGroup(t), i = o + r, a = o; a < i; a++)
      n += "".concat(this.tag.getRule(a)).concat(qf);
    return n;
  }, e;
}(), M5 = 1 << 30, Us = /* @__PURE__ */ new Map(), pl = /* @__PURE__ */ new Map(), Hs = 1, cs = function(e) {
  if (Us.has(e))
    return Us.get(e);
  for (; pl.has(Hs); )
    Hs++;
  var t = Hs++;
  if (z.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > M5))
    throw Vr(16, "".concat(t));
  return Us.set(e, t), pl.set(t, e), t;
}, D5 = function(e, t) {
  Hs = t + 1, Us.set(e, t), pl.set(t, e);
}, j5 = "style[".concat(Do, "][").concat(sm, '="').concat(zl, '"]'), B5 = new RegExp("^".concat(Do, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), V5 = function(e, t, n) {
  for (var r, o = n.split(","), i = 0, a = o.length; i < a; i++)
    (r = o[i]) && e.registerName(t, r);
}, U5 = function(e, t) {
  for (var n, r = ((n = t.textContent) !== null && n !== void 0 ? n : "").split(qf), o = [], i = 0, a = r.length; i < a; i++) {
    var s = r[i].trim();
    if (s) {
      var l = s.match(B5);
      if (l) {
        var c = 0 | parseInt(l[1], 10), u = l[2];
        c !== 0 && (D5(u, c), V5(e, u, l[3]), e.getTag().insertRules(c, o)), o.length = 0;
      } else
        o.push(s);
    }
  }
}, fp = function(e) {
  for (var t = document.querySelectorAll(j5), n = 0, r = t.length; n < r; n++) {
    var o = t[n];
    o && o.getAttribute(Do) !== am && (U5(e, o), o.parentNode && o.parentNode.removeChild(o));
  }
};
function H5() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var vm = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), o = function(s) {
    var l = Array.from(s.querySelectorAll("style[".concat(Do, "]")));
    return l[l.length - 1];
  }(n), i = o !== void 0 ? o.nextSibling : null;
  r.setAttribute(Do, am), r.setAttribute(sm, zl);
  var a = H5();
  return a && r.setAttribute("nonce", a), n.insertBefore(r, i), r;
}, z5 = function() {
  function e(t) {
    this.element = vm(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet)
        return n.sheet;
      for (var r = document.styleSheets, o = 0, i = r.length; o < i; o++) {
        var a = r[o];
        if (a.ownerNode === n)
          return a;
      }
      throw Vr(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n && n.cssText ? n.cssText : "";
  }, e;
}(), q5 = function() {
  function e(t) {
    this.element = vm(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var r = document.createTextNode(n);
      return this.element.insertBefore(r, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), W5 = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), hp = hl, G5 = { isServer: !hl, useCSSOMInjection: !b5 }, gm = function() {
  function e(t, n, r) {
    t === void 0 && (t = Pi), n === void 0 && (n = {});
    var o = this;
    this.options = wn(wn({}, G5), t), this.gs = n, this.names = new Map(r), this.server = !!t.isServer, !this.server && hl && hp && (hp = !1, fp(this)), Gf(this, function() {
      return function(i) {
        for (var a = i.getTag(), s = a.length, l = "", c = function(d) {
          var f = function(b) {
            return pl.get(b);
          }(d);
          if (f === void 0)
            return "continue";
          var h = i.names.get(f), p = a.getGroup(d);
          if (h === void 0 || !h.size || p.length === 0)
            return "continue";
          var g = "".concat(Do, ".g").concat(d, '[id="').concat(f, '"]'), v = "";
          h !== void 0 && h.forEach(function(b) {
            b.length > 0 && (v += "".concat(b, ","));
          }), l += "".concat(p).concat(g, '{content:"').concat(v, '"}').concat(qf);
        }, u = 0; u < s; u++)
          c(u);
        return l;
      }(o);
    });
  }
  return e.registerId = function(t) {
    return cs(t);
  }, e.prototype.rehydrate = function() {
    !this.server && hl && fp(this);
  }, e.prototype.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(wn(wn({}, this.options), t), this.gs, n && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(n) {
      var r = n.useCSSOMInjection, o = n.target;
      return n.isServer ? new W5(o) : r ? new z5(o) : new q5(o);
    }(this.options), new L5(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, e.prototype.registerName = function(t, n) {
    if (cs(t), this.names.has(t))
      this.names.get(t).add(n);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(n), this.names.set(t, r);
    }
  }, e.prototype.insertRules = function(t, n, r) {
    this.registerName(t, n), this.getTag().insertRules(cs(t), r);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(cs(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), K5 = /&/g, Y5 = /^\s*\/\/.*$/gm;
function mm(e, t) {
  return e.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(t, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(t, " ")), n.props = n.props.map(function(r) {
      return "".concat(t, " ").concat(r);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = mm(n.children, t)), n;
  });
}
function Z5(e) {
  var t, n, r, o = Pi, i = o.options, a = i === void 0 ? Pi : i, s = o.plugins, l = s === void 0 ? ql : s, c = function(f, h, p) {
    return p.startsWith(n) && p.endsWith(n) && p.replaceAll(n, "").length > 0 ? ".".concat(t) : f;
  }, u = l.slice();
  u.push(function(f) {
    f.type === Bl && f.value.includes("&") && (f.props[0] = f.props[0].replace(K5, n).replace(r, c));
  }), a.prefix && u.push(m5), u.push(p5);
  var d = function(f, h, p, g) {
    h === void 0 && (h = ""), p === void 0 && (p = ""), g === void 0 && (g = "&"), t = g, n = h, r = new RegExp("\\".concat(n, "\\b"), "g");
    var v = f.replace(Y5, ""), b = f5(p || h ? "".concat(p, " ").concat(h, " { ").concat(v, " }") : v);
    a.namespace && (b = mm(b, a.namespace));
    var m = [];
    return fl(b, v5(u.concat(g5(function(w) {
      return m.push(w);
    })))), m;
  };
  return d.hash = l.length ? l.reduce(function(f, h) {
    return h.name || Vr(15), xo(f, h.name);
  }, lm).toString() : "", d;
}
var Q5 = new gm(), dd = Z5(), ym = ee.createContext({ shouldForwardProp: void 0, styleSheet: Q5, stylis: dd });
ym.Consumer;
ee.createContext(void 0);
function pp() {
  return Bt(ym);
}
var vp = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(o, i) {
      i === void 0 && (i = dd);
      var a = r.name + i.hash;
      o.hasNameForId(r.id, a) || o.insertRules(r.id, a, i(r.rules, a, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = n, Gf(this, function() {
      throw Vr(12, String(r.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = dd), this.name + t.hash;
  }, e;
}(), X5 = function(e) {
  return e >= "A" && e <= "Z";
};
function gp(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var r = e[n];
    if (n === 1 && r === "-" && e[0] === "-")
      return e;
    X5(r) ? t += "-" + r.toLowerCase() : t += r;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var bm = function(e) {
  return e == null || e === !1 || e === "";
}, Cm = function(e) {
  var t, n, r = [];
  for (var o in e) {
    var i = e[o];
    e.hasOwnProperty(o) && !bm(i) && (Array.isArray(i) && i.isCss || jo(i) ? r.push("".concat(gp(o), ":"), i, ";") : Ri(i) ? r.push.apply(r, Si(Si(["".concat(o, " {")], Cm(i), !1), ["}"], !1)) : r.push("".concat(gp(o), ": ").concat((t = o, (n = i) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || t in y5 || t.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return r;
};
function Fo(e, t, n, r) {
  if (bm(e))
    return [];
  if (Wf(e))
    return [".".concat(e.styledComponentId)];
  if (jo(e)) {
    if (!jo(i = e) || i.prototype && i.prototype.isReactComponent || !t)
      return [e];
    var o = e(t);
    return z.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || o instanceof vp || Ri(o) || o === null || console.error("".concat(um(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Fo(o, t, n, r);
  }
  var i;
  return e instanceof vp ? n ? (e.inject(n, r), [e.getName(r)]) : [e] : Ri(e) ? Cm(e) : Array.isArray(e) ? Array.prototype.concat.apply(ql, e.map(function(a) {
    return Fo(a, t, n, r);
  })) : [e.toString()];
}
function J5(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (jo(n) && !Wf(n))
      return !1;
  }
  return !0;
}
var eE = cm(zl), tE = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = z.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && J5(t), this.componentId = n, this.baseHash = xo(eE, n), this.baseStyle = r, gm.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, n, r) : "";
    if (this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId))
        o = Po(o, this.staticRulesId);
      else {
        var i = dp(Fo(this.rules, t, n, r)), a = cd(xo(this.baseHash, i) >>> 0);
        if (!n.hasNameForId(this.componentId, a)) {
          var s = r(i, ".".concat(a), void 0, this.componentId);
          n.insertRules(this.componentId, a, s);
        }
        o = Po(o, a), this.staticRulesId = a;
      }
    else {
      for (var l = xo(this.baseHash, r.hash), c = "", u = 0; u < this.rules.length; u++) {
        var d = this.rules[u];
        if (typeof d == "string")
          c += d, z.env.NODE_ENV !== "production" && (l = xo(l, d));
        else if (d) {
          var f = dp(Fo(d, t, n, r));
          l = xo(l, f + u), c += f;
        }
      }
      if (c) {
        var h = cd(l >>> 0);
        n.hasNameForId(this.componentId, h) || n.insertRules(this.componentId, h, r(c, ".".concat(h), void 0, this.componentId)), o = Po(o, h);
      }
    }
    return o;
  }, e;
}(), vl = ee.createContext(void 0);
vl.Consumer;
function nE(e) {
  var t = ee.useContext(vl), n = Mt(function() {
    return function(r, o) {
      if (!r)
        throw Vr(14);
      if (jo(r)) {
        var i = r(o);
        if (z.env.NODE_ENV !== "production" && (i === null || Array.isArray(i) || typeof i != "object"))
          throw Vr(7);
        return i;
      }
      if (Array.isArray(r) || typeof r != "object")
        throw Vr(8);
      return o ? wn(wn({}, o), r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? ee.createElement(vl.Provider, { value: n }, e.children) : null;
}
var Qc = {}, mp = /* @__PURE__ */ new Set();
function rE(e, t, n) {
  var r = Wf(e), o = e, i = !Zc(e), a = t.attrs, s = a === void 0 ? ql : a, l = t.componentId, c = l === void 0 ? function(E, C) {
    var x = typeof E != "string" ? "sc" : ap(E);
    Qc[x] = (Qc[x] || 0) + 1;
    var _ = "".concat(x, "-").concat(S5(zl + x + Qc[x]));
    return C ? "".concat(C, "-").concat(_) : _;
  }(t.displayName, t.parentComponentId) : l, u = t.displayName, d = u === void 0 ? function(E) {
    return Zc(E) ? "styled.".concat(E) : "Styled(".concat(um(E), ")");
  }(e) : u, f = t.displayName && t.componentId ? "".concat(ap(t.displayName), "-").concat(t.componentId) : t.componentId || c, h = r && o.attrs ? o.attrs.concat(s).filter(Boolean) : s, p = t.shouldForwardProp;
  if (r && o.shouldForwardProp) {
    var g = o.shouldForwardProp;
    if (t.shouldForwardProp) {
      var v = t.shouldForwardProp;
      p = function(E, C) {
        return g(E, C) && v(E, C);
      };
    } else
      p = g;
  }
  var b = new tE(n, f, r ? o.componentStyle : void 0);
  function m(E, C) {
    return function(x, _, T) {
      var O = x.attrs, I = x.componentStyle, L = x.defaultProps, B = x.foldedComponentIds, j = x.styledComponentId, M = x.target, q = ee.useContext(vl), N = pp(), $ = x.shouldForwardProp || N.shouldForwardProp;
      z.env.NODE_ENV !== "production" && Kh(j);
      var F = w5(_, q, L) || Pi, H = function(fe, ge, ie) {
        for (var he, ue = wn(wn({}, ge), { className: void 0, theme: ie }), ce = 0; ce < fe.length; ce += 1) {
          var Se = jo(he = fe[ce]) ? he(ue) : he;
          for (var te in Se)
            ue[te] = te === "className" ? Po(ue[te], Se[te]) : te === "style" ? wn(wn({}, ue[te]), Se[te]) : Se[te];
        }
        return ge.className && (ue.className = Po(ue.className, ge.className)), ue;
      }(O, _, F), k = H.as || M, W = {};
      for (var G in H)
        H[G] === void 0 || G[0] === "$" || G === "as" || G === "theme" && H.theme === F || (G === "forwardedAs" ? W.as = H.forwardedAs : $ && !$(G, k) || (W[G] = H[G], $ || z.env.NODE_ENV !== "development" || Jw(G) || mp.has(G) || !ld.has(k) || (mp.add(G), console.warn('styled-components: it looks like an unknown prop "'.concat(G, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var ne = function(fe, ge) {
        var ie = pp(), he = fe.generateAndInjectStyles(ge, ie.styleSheet, ie.stylis);
        return z.env.NODE_ENV !== "production" && Kh(he), he;
      }(I, H);
      z.env.NODE_ENV !== "production" && x.warnTooManyClasses && x.warnTooManyClasses(ne);
      var Y = Po(B, j);
      return ne && (Y += " " + ne), H.className && (Y += " " + H.className), W[Zc(k) && !ld.has(k) ? "class" : "className"] = Y, W.ref = T, tw(k, W);
    }(w, E, C);
  }
  m.displayName = d;
  var w = ee.forwardRef(m);
  return w.attrs = h, w.componentStyle = b, w.displayName = d, w.shouldForwardProp = p, w.foldedComponentIds = r ? Po(o.foldedComponentIds, o.styledComponentId) : "", w.styledComponentId = f, w.target = r ? o.target : e, Object.defineProperty(w, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(E) {
    this._foldedDefaultProps = r ? function(C) {
      for (var x = [], _ = 1; _ < arguments.length; _++)
        x[_ - 1] = arguments[_];
      for (var T = 0, O = x; T < O.length; T++)
        ud(C, O[T], !0);
      return C;
    }({}, o.defaultProps, E) : E;
  } }), z.env.NODE_ENV !== "production" && (C5(d, f), w.warnTooManyClasses = /* @__PURE__ */ function(E, C) {
    var x = {}, _ = !1;
    return function(T) {
      if (!_ && (x[T] = !0, Object.keys(x).length >= 200)) {
        var O = C ? ' with the id of "'.concat(C, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(E).concat(O, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), _ = !0, x = {};
      }
    };
  }(d, f)), Gf(w, function() {
    return ".".concat(w.styledComponentId);
  }), i && pm(w, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), w;
}
function yp(e, t) {
  for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}
var bp = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function Rt(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (jo(e) || Ri(e))
    return bp(Fo(yp(ql, Si([e], t, !0))));
  var r = e;
  return t.length === 0 && r.length === 1 && typeof r[0] == "string" ? Fo(r) : bp(Fo(yp(r, t)));
}
function fd(e, t, n) {
  if (n === void 0 && (n = Pi), !t)
    throw Vr(1, t);
  var r = function(o) {
    for (var i = [], a = 1; a < arguments.length; a++)
      i[a - 1] = arguments[a];
    return e(t, n, Rt.apply(void 0, Si([o], i, !1)));
  };
  return r.attrs = function(o) {
    return fd(e, t, wn(wn({}, n), { attrs: Array.prototype.concat(n.attrs, o).filter(Boolean) }));
  }, r.withConfig = function(o) {
    return fd(e, t, wn(wn({}, n), o));
  }, r;
}
var wm = function(e) {
  return fd(rE, e);
}, Ue = wm;
ld.forEach(function(e) {
  Ue[e] = wm(e);
});
z.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var us = "__sc-".concat(Do, "__");
z.env.NODE_ENV !== "production" && z.env.NODE_ENV !== "test" && typeof window < "u" && (window[us] || (window[us] = 0), window[us] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[us] += 1);
const ln = {
  10: "#EAF6FF",
  20: "#C6E6FF",
  30: "#82CFFF",
  40: "#31B4F2",
  50: "#0092E4",
  60: "#0071CD",
  70: "#005693",
  80: "#003B69",
  90: "#002747",
  100: "#00172D"
}, so = {
  10: "#DFFBE8",
  20: "#C3EAD1",
  30: "#90D6AA",
  40: "#5EBB7F",
  50: "#19A04B",
  60: "#14803C",
  70: "#0C612C",
  80: "#06431C",
  90: "#032D10",
  100: "#011B07"
}, Pr = {
  10: "#FFF1F1",
  20: "#FFD9D9",
  30: "#FFB3B3",
  40: "#F98989",
  50: "#EB4B4B",
  60: "#CF3537",
  70: "#9C2628",
  80: "#70191A",
  90: "#4C0E0F",
  100: "#300606"
}, Em = {
  10: "#FFF1ED",
  20: "#FFDACE",
  30: "#FFB59D",
  40: "#FF785A",
  50: "#EE5B3A",
  60: "#C1462B",
  70: "#92331E",
  80: "#682213",
  90: "#48150A",
  100: "#2D0A04"
}, _m = {
  10: "#FFF3DD",
  20: "#FFE4AE",
  30: "#F0C355",
  40: "#E99921",
  50: "#C17E19",
  60: "#9A6412",
  70: "#744A0B",
  80: "#523305",
  90: "#372102",
  100: "#221201"
}, xm = {
  10: "#E0F9F7",
  20: "#A9EFE8",
  30: "#5FD2C8",
  40: "#46BBB0",
  50: "#2B9C92",
  60: "#217C74",
  70: "#165C56",
  80: "#0D413C",
  90: "#062B27",
  100: "#021917"
}, Sm = {
  10: "#F6F2FE",
  20: "#E7DDFC",
  30: "#D2BDF9",
  40: "#BA99F6",
  50: "#BA99F6",
  60: "#8354D6",
  70: "#643AAA",
  80: "#462779",
  90: "#2E1954",
  100: "#1C0D35"
}, Tm = {
  10: "#FFF1F3",
  20: "#FFD8DF",
  30: "#FFB2C1",
  40: "#FF7D96",
  50: "#E85D78",
  60: "#BB485D",
  70: "#8D3545",
  80: "#65232F",
  90: "#45161E",
  100: "#2B0A10"
}, ve = {
  0: "#FFFFFF",
  10: "#F3F4F6",
  20: "#DFE2E7",
  30: "#C2C7D0",
  40: "#A3A9B9",
  50: "#868CA2",
  60: "#696F88",
  70: "#4D5165",
  80: "#363948",
  90: "#232630",
  100: "#14151C"
}, oE = {
  Elevation1: "0px 2px 8px 0px rgba(0, 0, 0, 0.15)",
  Elevation2: "0px 4px 12px 0px rgba(0, 0, 0, 0.15)",
  ElevationLeft1: "-2px 0px 8px 0px rgba(0, 0, 0, 0.15)",
  ElevationLeft2: "2px 0px 8px 0px rgba(0, 0, 0, 0.15)",
  ElevationRight1: "-4px 0px 12px 0px rgba(0, 0, 0, 0.15)",
  ElevationRight2: "4px 0px 12px 0px rgba(0, 0, 0, 0.15)",
  ElevationTop1: "0px -4px 8px 0px rgba(0, 0, 0, 0.15)",
  ElevationTop2: "0px -4px 12px 0px rgba(0, 0, 0, 0.25)"
}, ur = {
  Big: 16,
  Medium: 12,
  Default: 8,
  Small: 4,
  XSmall: 2
}, on = {
  Title1: 56,
  Title2: 46,
  Title3: 36,
  Title4: 30,
  Title5: 24,
  Title6: 20,
  Body1: 16,
  Body2: 14,
  Subtitle1: 16,
  Subtitle2: 14,
  Button1: 14,
  Button2: 14,
  Caption: 12
}, Jn = {
  BorderRadius: {
    Big: `${ur.Big}px`,
    Medium: `${ur.Medium}px`,
    Default: `${ur.Default}px`,
    Small: `${ur.Small}px`
  },
  FontSize: {
    Title1: `${on.Title1}px`,
    Title2: `${on.Title2}px`,
    Title3: `${on.Title3}px`,
    Title4: `${on.Title4}px`,
    Title5: `${on.Title5}px`,
    Title6: `${on.Title6}px`,
    Body1: `${on.Body1}px`,
    Body2: `${on.Body2}px`,
    Subtitle1: `${on.Subtitle1}px`,
    Subtitle2: `${on.Subtitle2}px`,
    Button1: `${on.Button1}px`,
    Button2: `${on.Button2}px`,
    Caption: `${on.Caption}px`
  },
  FontWeight: {
    Regular: 400,
    Bold: 600
  }
};
({
  ...ln,
  ...so,
  ...Pr,
  ...Em,
  ..._m,
  ...xm,
  ...Sm,
  ...Tm,
  ...ve
});
const iE = {
  borderRadius: ur.Default,
  colorTextBase: ve[100],
  colorBgContainerDisabled: ve[20],
  colorIcon: ve[60],
  colorTextPlaceholder: ve[50],
  colorTextDisabled: ve[50],
  colorBorder: ve[30]
}, aE = {
  Table: {
    borderColor: ve[20],
    headerBg: ve[10],
    headerSortActiveBg: ve[20],
    colorBgContainer: ve[0]
  },
  Select: {
    fontSizeLG: on.Body2,
    borderRadiusLG: 4,
    colorBgContainer: ve[10]
  },
  Input: {
    colorBgContainer: ve[10],
    inputFontSizeLG: on.Body2,
    borderRadiusLG: ur.Small,
    borderRadius: ur.Small,
    paddingBlockLG: 8,
    lineHeightLG: 1.572
  },
  DatePicker: {
    colorBgContainer: ve[10],
    fontSizeLG: on.Body2,
    borderRadius: ur.Small,
    lineHeightLG: 1.715
  },
  Form: {
    verticalLabelPadding: "0 0 3px 0",
    itemMarginBottom: 14
  },
  InputNumber: {
    colorBgContainer: ve[10],
    inputFontSizeLG: on.Body2,
    borderRadiusLG: ur.Small,
    paddingBlockLG: 8,
    lineHeightLG: 1.572
  },
  Tag: {
    fontSize: on.Caption,
    defaultColor: ve[70],
    defaultBg: ve[10],
    colorIcon: ve[60],
    colorBorder: ve[30],
    lineHeight: 1.67
  },
  Button: {
    algorithm: !0,
    borderRadius: ur.Small,
    borderRadiusLG: ur.Small,
    colorPrimary: so[60],
    colorLink: ve[100],
    primaryShadow: `0 2px 0 ${ve[10]}`
  },
  Drawer: {
    zIndexPopup: 1005,
    lineType: "none"
  }
}, sE = {
  components: aE,
  token: iE
}, rD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blue: ln,
  Green: so,
  Neutral: ve,
  Orange: Em,
  Pink: Tm,
  Purple: Sm,
  Red: Pr,
  Shadows: oE,
  SyngentaTheme: Jn,
  Teal: xm,
  Yellow: _m,
  antDTheme: sE
}, Symbol.toStringTag, { value: "Module" })), lE = {
  default: "6px 12px",
  small: "2px 8px",
  large: "10px 16px",
  icon: "2px"
}, Vi = Rt`
  background-color: ${ve[10]};
  border: solid 1px ${ve[20]};
  color: ${ve[30]};
  cursor: not-allowed;
`, cE = Rt`
  background-color: ${ve[0]};
  border: solid 1px ${ve[30]};

  &:hover {
    background-color: ${ve[10]};
  }

  &:focus {
    background-color: ${ve[20]};
    box-shadow: 0px 0px 0px 3px rgba(0, 146, 228, 0.25);
  }

  &:active {
    background-color: ${ve[30]};
  }

  &:disabled {
    ${Vi}
  }
`, uE = Rt`
  background-color: ${so[60]};
  color: ${ve[0]};
  border: solid 1px ${so[60]};

  &:hover {
    background-color: ${so[50]};
  }

  &:focus {
    background-color: ${so[60]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }

  &:active {
    background-color: ${so[70]};
  }

  &:disabled {
    ${Vi}
  }
`, dE = Rt`
  background-color: ${Pr[60]};
  color: ${ve[0]};
  border: solid 1px ${Pr[60]};

  &:hover {
    background-color: ${Pr[50]};
  }

  &:focus {
    background-color: ${Pr[60]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }

  &:active {
    background-color: ${Pr[70]};
  }

  &:disabled {
    ${Vi}
  }
`, fE = Rt`
  background-color: ${ve[0]};
  border: 0;
  padding: 3px;
  line-height: 0;

  &:hover {
    background-color: ${ve[10]};
  }

  &:focus {
    background-color: ${ve[20]};
  }

  &:active {
    background-color: ${ve[30]};
  }
  &:disabled {
    color: ${ve[30]};
    background-color: ${ve[0]};
    cursor: not-allowed;
  }
`, hE = Rt`
  background-color: ${ve[0]};
  border: 0;

  &:hover {
    background-color: ${ve[10]};
  }

  &:focus {
    background-color: ${ve[20]};
  }

  &:active {
    background-color: ${ve[30]};
  }

  &:disabled {
    ${Vi}
  }
`, pE = Rt`
  white-space: nowrap;
  background-color: transparent !important;
  color: ${ln[60]};
  border: 0;
  padding: 0;
  height: fit-content;
  line-height: inherit;

  &:hover,
  &:focus {
    color: ${ln[50]};
  }

  &:active {
    color: ${ln[70]};
  }

  &:disabled {
    ${Vi}
    border: 0;
  }
`, vE = Rt`
  background-color: ${ln[60]};
  color: ${ve[0]};
  border: 0;

  &:hover,
  &:focus {
    background-color: ${ln[50]};
  }

  &:active {
    background-color: ${ln[70]};
  }

  &:disabled {
    ${Vi}
    color: ${ve[40]};
  }
`, gE = Rt`
  background-color: transparent;
  color: ${Pr[60]};

  &:hover {
    background-color: ${Pr[20]};
  }

  &:focus {
    background-color: ${Pr[30]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }
`, mE = Rt`
  background-color: transparent;
  color: ${ve[0]};
  border: 1px solid ${ve[0]};
  cursor: pointer;

  path {
    fill: ${ve[0]};
  }

  &:hover {
    background-color: ${ve[70]};
  }

  &:focus {
    background-color: ${ve[20]};
    box-shadow: 0px 0px 0px 3px rgba(25, 160, 75, 0.25);
  }
`, yE = {
  danger: gE
}, bE = {
  normal: cE,
  primary: uE,
  danger: dE,
  icon: fE,
  text: hE,
  link: pE,
  action: vE,
  ghost: mE
}, CE = Rt`
  pointer-events: none;

  .is-loading {
    display: block;
    color: inherit;
    width: 18px;
    height: 18px;
    z-index: 3;
    animation: spin 1s infinite linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`, wE = Ue.button`
  position: relative;
  padding: ${({
  $size: e
}) => lE[e ?? "default"]};
  width: ${({
  $full: e,
  $width: t
}) => e ? "100%" : t ?? ""};
  border-radius: ${Jn.BorderRadius.Small};
  font-size: ${Jn.FontSize.Button2};
  text-align: center;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 4px;

  ${({
  $type: e
}) => bE[e ?? "normal"]}
  ${({
  $outline: e,
  $type: t
}) => e && t ? yE[t] : {}}
  ${({
  $isLoading: e
}) => e ? CE : null};

  &:focus {
    outline: none;
  }
`, EE = () => /* @__PURE__ */ P.jsx("span", { className: "is-loading", children: /* @__PURE__ */ P.jsx(Zw, {}) }), oD = ({
  children: e,
  space: t,
  type: n,
  size: r,
  full: o,
  isLoading: i,
  outline: a,
  htmlType: s,
  disabled: l,
  width: c,
  ...u
}) => /* @__PURE__ */ P.jsx(wE, { $space: t, $type: n, $size: r, $full: o, $isLoading: i, $outline: a, $width: c, type: s, disabled: !!l, ...u, children: i ? /* @__PURE__ */ P.jsx(EE, {}) : e });
var _E = /* @__PURE__ */ ((e) => (e.LARGE = "large", e.SMALL = "small", e))(_E || {}), xE = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.ICON = "icon", e.DANGER = "danger", e.TEXT = "text", e.LINK = "link", e.ACTION = "action", e.GHOST = "ghost", e))(xE || {}), SE = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.BIG = "big", e))(SE || {});
const TE = Ue.div`
  border: solid 1px ${ln[30]};
  border-radius: ${Jn.BorderRadius.Default};
  padding: 12px 20px 0;
  display: flex;
  flex-direction: column;
  gap: ${({
  $isOpen: e
}) => e ? "18px" : "12px"};

  & ~ & {
    margin-top: 8px;
  }
`, OE = Ue.div`
  position: relative;
  cursor: pointer;

  .icon {
    position: absolute;
    top: calc(50% - 9px);
    right: 0;
    color: ${ve[60]};
    transform: rotate(180deg);
    transition: transform 0.4s ease-in-out;
    cursor: pointer;

    ${({
  $isOpen: e
}) => e && Rt`
        transform: rotate(0deg);
      `};
  }
`, PE = Ue.div`
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition:
    grid-template-rows 0.4s ease-in-out,
    opacity 0.4s ease-in-out;

  ${({
  $isOpen: e
}) => e && Rt`
      grid-template-rows: 1fr;
      opacity: 1;
    `}
`, RE = Ue.div`
  overflow: hidden;
`, AE = Ue.div`
  h3 {
    margin: 0;
    font-weight: ${Jn.FontWeight.Bold};
    font-size: ${Jn.FontSize.Body1};
  }

  p {
    margin: 0;
    color: ${ve[60]};
    font-size: ${Jn.FontSize.Body2};
  }
`, iD = ({
  headerTitle: e,
  headerDescription: t,
  children: n,
  defaultOpen: r
}) => {
  const [o, i] = wt(r ?? !1);
  return /* @__PURE__ */ P.jsxs(TE, { children: [
    /* @__PURE__ */ P.jsxs(OE, { onClick: () => i(!o), $isOpen: o, children: [
      /* @__PURE__ */ P.jsxs(AE, { children: [
        e && /* @__PURE__ */ P.jsx("h3", { children: e }),
        t && /* @__PURE__ */ P.jsx("p", { children: t })
      ] }),
      /* @__PURE__ */ P.jsx(jw, { className: "icon" })
    ] }),
    /* @__PURE__ */ P.jsx(PE, { $isOpen: o, children: /* @__PURE__ */ P.jsx(RE, { children: n }) })
  ] });
}, aD = ["KILOGRAMS", "LITERS", "UNITS", "BOXS", "SACK", "GALLONS", "GRAMS", "TONNES", "MILLILITER", "METERS", "OUNCES", "POUNDS", "PINTS", "DOSE", "UNKNOWN", "QUARTS"];
var Om = /* @__PURE__ */ ((e) => (e.OPEN_DRAWER = "CW-ONBOARDING-OPEN-INPUTS-DRAWER", e))(Om || {}), zs = /* @__PURE__ */ ((e) => (e.OPEN_MODAL = "CW-ONBOARDING-OPEN-MODAL", e.MODAL_INFORMATION = "CW-ONBOARDING-MODAL-INFORMATION", e))(zs || {}), hd = /* @__PURE__ */ ((e) => (e.PROPERTY_CREATED = "PROPERTY_CREATED", e.FIELD_CREATED = "FIELD_CREATED", e.CROP_ASSIGNED = "CROP_ASSIGNED", e))(hd || {}), gl = /* @__PURE__ */ ((e) => (e.CLOSE_MENU = "CW-CLOSE-SETTINGS-MENU", e))(gl || {}), pd = function(e, t) {
  return pd = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, pd(e, t);
};
function zn(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  pd(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Ae = function() {
  return Ae = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ae.apply(this, arguments);
};
function vd(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function we(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : o(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function ye(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, o && (i = c[0] & 2 ? o.return : c[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, c[1])).done)
          return i;
        switch (o = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, o = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = c;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(c);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (u) {
        c = [6, u], o = 0;
      } finally {
        r = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Yt(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function gt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function sn(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function yi(e) {
  return this instanceof yi ? (this.v = e, this) : new yi(e);
}
function IE(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), o, i = [];
  return o = {}, s("next"), s("throw"), s("return", a), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function a(h) {
    return function(p) {
      return Promise.resolve(p).then(h, d);
    };
  }
  function s(h, p) {
    r[h] && (o[h] = function(g) {
      return new Promise(function(v, b) {
        i.push([h, g, v, b]) > 1 || l(h, g);
      });
    }, p && (o[h] = p(o[h])));
  }
  function l(h, p) {
    try {
      c(r[h](p));
    } catch (g) {
      f(i[0][3], g);
    }
  }
  function c(h) {
    h.value instanceof yi ? Promise.resolve(h.value.v).then(u, d) : f(i[0][2], h);
  }
  function u(h) {
    l("next", h);
  }
  function d(h) {
    l("throw", h);
  }
  function f(h, p) {
    h(p), i.shift(), i.length && l(i[0][0], i[0][1]);
  }
}
function kE(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof Yt == "function" ? Yt(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = e[i] && function(a) {
      return new Promise(function(s, l) {
        a = e[i](a), o(s, l, a.done, a.value);
      });
    };
  }
  function o(i, a, s, l) {
    Promise.resolve(l).then(function(c) {
      i({ value: c, done: s });
    }, a);
  }
}
var $E = "Event tracked successfully", NE = "Unexpected error occurred", FE = "Event rejected due to exceeded retry count", LE = "Event skipped due to optOut config", ME = "Event rejected due to missing API key", DE = "Invalid API key", jE = "Client not initialized", rn;
(function(e) {
  e.SET = "$set", e.SET_ONCE = "$setOnce", e.ADD = "$add", e.APPEND = "$append", e.PREPEND = "$prepend", e.REMOVE = "$remove", e.PREINSERT = "$preInsert", e.POSTINSERT = "$postInsert", e.UNSET = "$unset", e.CLEAR_ALL = "$clearAll";
})(rn || (rn = {}));
var So;
(function(e) {
  e.REVENUE_PRODUCT_ID = "$productId", e.REVENUE_QUANTITY = "$quantity", e.REVENUE_PRICE = "$price", e.REVENUE_TYPE = "$revenueType", e.REVENUE = "$revenue";
})(So || (So = {}));
var Ai;
(function(e) {
  e.IDENTIFY = "$identify", e.GROUP_IDENTIFY = "$groupidentify", e.REVENUE = "revenue_amount";
})(Ai || (Ai = {}));
var Ln;
(function(e) {
  e[e.None = 0] = "None", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Verbose = 3] = "Verbose", e[e.Debug = 4] = "Debug";
})(Ln || (Ln = {}));
var ml;
(function(e) {
  e.US = "US", e.EU = "EU";
})(ml || (ml = {}));
var Lt;
(function(e) {
  e.Unknown = "unknown", e.Skipped = "skipped", e.Success = "success", e.RateLimit = "rate_limit", e.PayloadTooLarge = "payload_too_large", e.Invalid = "invalid", e.Failed = "failed", e.Timeout = "Timeout", e.SystemError = "SystemError";
})(Lt || (Lt = {}));
var BE = null, VE = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "video",
  "audio",
  '[contenteditable="true" i]',
  "[data-amp-default-track]",
  ".amp-default-track"
], UE = "data-amp-track-", HE = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"], bi = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Lt.Unknown), { event: e, code: t, message: n };
}, Ui = function(e) {
  return e ? (
    // a random number from 0 to 15
    (e ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    e / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      Ui
    )
  );
}, zE = (
  /** @class */
  function() {
    function e(t) {
      this.client = t, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return e.prototype.register = function(t, n) {
      var r, o;
      return we(this, void 0, void 0, function() {
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              return this.plugins.some(function(a) {
                return a.name === t.name;
              }) ? (n.loggerProvider.warn("Plugin with name ".concat(t.name, " already exists, skipping registration")), [
                2
                /*return*/
              ]) : (t.name === void 0 && (t.name = Ui(), n.loggerProvider.warn(`Plugin name is undefined. 
      Generating a random UUID for plugin name: `.concat(t.name, `. 
      Set a name for the plugin to prevent it from being added multiple times.`))), t.type = (r = t.type) !== null && r !== void 0 ? r : "enrichment", [4, (o = t.setup) === null || o === void 0 ? void 0 : o.call(t, n, this.client)]);
            case 1:
              return i.sent(), this.plugins.push(t), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.deregister = function(t) {
      var n;
      return we(this, void 0, void 0, function() {
        var r, o;
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.plugins.findIndex(function(a) {
                return a.name === t;
              }), o = this.plugins[r], this.plugins.splice(r, 1), [4, (n = o.teardown) === null || n === void 0 ? void 0 : n.call(o)];
            case 1:
              return i.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.reset = function(t) {
      this.applying = !1;
      var n = this.plugins;
      n.map(function(r) {
        var o;
        return (o = r.teardown) === null || o === void 0 ? void 0 : o.call(r);
      }), this.plugins = [], this.client = t;
    }, e.prototype.push = function(t) {
      var n = this;
      return new Promise(function(r) {
        n.queue.push([t, r]), n.scheduleApply(0);
      });
    }, e.prototype.scheduleApply = function(t) {
      var n = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        n.apply(n.queue.shift()).then(function() {
          n.applying = !1, n.queue.length > 0 && n.scheduleApply(0);
        });
      }, t));
    }, e.prototype.apply = function(t) {
      return we(this, void 0, void 0, function() {
        var n, r, o, i, a, s, l, h, p, c, u, d, f, h, p, g, v, b, m, w, E, C;
        return ye(this, function(x) {
          switch (x.label) {
            case 0:
              if (!t)
                return [
                  2
                  /*return*/
                ];
              n = gt(t, 1), r = n[0], o = gt(t, 2), i = o[1], a = this.plugins.filter(function(_) {
                return _.type === "before";
              }), x.label = 1;
            case 1:
              x.trys.push([1, 6, 7, 8]), s = Yt(a), l = s.next(), x.label = 2;
            case 2:
              return l.done ? [3, 5] : (h = l.value, h.execute ? [4, h.execute(Ae({}, r))] : [3, 4]);
            case 3:
              if (p = x.sent(), p === null)
                return i({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = p, x.label = 4;
            case 4:
              return l = s.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return c = x.sent(), m = { error: c }, [3, 8];
            case 7:
              try {
                l && !l.done && (w = s.return) && w.call(s);
              } finally {
                if (m)
                  throw m.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              u = this.plugins.filter(function(_) {
                return _.type === "enrichment" || _.type === void 0;
              }), x.label = 9;
            case 9:
              x.trys.push([9, 14, 15, 16]), d = Yt(u), f = d.next(), x.label = 10;
            case 10:
              return f.done ? [3, 13] : (h = f.value, h.execute ? [4, h.execute(Ae({}, r))] : [3, 12]);
            case 11:
              if (p = x.sent(), p === null)
                return i({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = p, x.label = 12;
            case 12:
              return f = d.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return g = x.sent(), E = { error: g }, [3, 16];
            case 15:
              try {
                f && !f.done && (C = d.return) && C.call(d);
              } finally {
                if (E)
                  throw E.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return v = this.plugins.filter(function(_) {
                return _.type === "destination";
              }), b = v.map(function(_) {
                var T = Ae({}, r);
                return _.execute(T).catch(function(O) {
                  return bi(T, 0, String(O));
                });
              }), Promise.all(b).then(function(_) {
                var T = gt(_, 1), O = T[0], I = O || bi(r, 100, "Event not tracked, no destination plugins on the instance");
                i(I);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.flush = function() {
      return we(this, void 0, void 0, function() {
        var t, n, r, o = this;
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              return t = this.queue, this.queue = [], [4, Promise.all(t.map(function(a) {
                return o.apply(a);
              }))];
            case 1:
              return i.sent(), n = this.plugins.filter(function(a) {
                return a.type === "destination";
              }), r = n.map(function(a) {
                return a.flush && a.flush();
              }), [4, Promise.all(r)];
            case 2:
              return i.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), Cp = "-", Wl = "AMP", qE = "".concat(Wl, "_unsent"), Pm = "https://api2.amplitude.com/2/httpapi", WE = "https://api.eu.amplitude.com/2/httpapi", GE = "https://api2.amplitude.com/batch", KE = "https://api.eu.amplitude.com/batch", YE = 1e3, gd = function(e) {
  if (Object.keys(e).length > YE)
    return !1;
  for (var t in e) {
    var n = e[t];
    if (!Rm(t, n))
      return !1;
  }
  return !0;
}, Rm = function(e, t) {
  var n, r;
  if (typeof e != "string")
    return !1;
  if (Array.isArray(t)) {
    var o = !0;
    try {
      for (var i = Yt(t), a = i.next(); !a.done; a = i.next()) {
        var s = a.value;
        if (Array.isArray(s))
          return !1;
        if (typeof s == "object")
          o = o && gd(s);
        else if (!["number", "string"].includes(typeof s))
          return !1;
        if (!o)
          return !1;
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
  } else {
    if (t == null)
      return !1;
    if (typeof t == "object")
      return gd(t);
    if (!["number", "string", "boolean"].includes(typeof t))
      return !1;
  }
  return !0;
}, Ca = (
  /** @class */
  function() {
    function e() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return e.prototype.getUserProperties = function() {
      return Ae({}, this._properties);
    }, e.prototype.set = function(t, n) {
      return this._safeSet(rn.SET, t, n), this;
    }, e.prototype.setOnce = function(t, n) {
      return this._safeSet(rn.SET_ONCE, t, n), this;
    }, e.prototype.append = function(t, n) {
      return this._safeSet(rn.APPEND, t, n), this;
    }, e.prototype.prepend = function(t, n) {
      return this._safeSet(rn.PREPEND, t, n), this;
    }, e.prototype.postInsert = function(t, n) {
      return this._safeSet(rn.POSTINSERT, t, n), this;
    }, e.prototype.preInsert = function(t, n) {
      return this._safeSet(rn.PREINSERT, t, n), this;
    }, e.prototype.remove = function(t, n) {
      return this._safeSet(rn.REMOVE, t, n), this;
    }, e.prototype.add = function(t, n) {
      return this._safeSet(rn.ADD, t, n), this;
    }, e.prototype.unset = function(t) {
      return this._safeSet(rn.UNSET, t, Cp), this;
    }, e.prototype.clearAll = function() {
      return this._properties = {}, this._properties[rn.CLEAR_ALL] = Cp, this;
    }, e.prototype._safeSet = function(t, n, r) {
      if (this._validate(t, n, r)) {
        var o = this._properties[t];
        return o === void 0 && (o = {}, this._properties[t] = o), o[n] = r, this._propertySet.add(n), !0;
      }
      return !1;
    }, e.prototype._validate = function(t, n, r) {
      return this._properties[rn.CLEAR_ALL] !== void 0 || this._propertySet.has(n) ? !1 : t === rn.ADD ? typeof r == "number" : t !== rn.UNSET && t !== rn.REMOVE ? Rm(n, r) : !0;
    }, e;
  }()
), ZE = function(e, t, n) {
  var r = typeof e == "string" ? { event_type: e } : e;
  return Ae(Ae(Ae({}, r), n), t && { event_properties: t });
}, Am = function(e, t) {
  var n = Ae(Ae({}, t), { event_type: Ai.IDENTIFY, user_properties: e.getUserProperties() });
  return n;
}, QE = function(e, t, n, r) {
  var o, i = Ae(Ae({}, r), { event_type: Ai.GROUP_IDENTIFY, group_properties: n.getUserProperties(), groups: (o = {}, o[e] = t, o) });
  return i;
}, XE = function(e, t, n) {
  var r, o = new Ca();
  o.set(e, t);
  var i = Ae(Ae({}, n), { event_type: Ai.IDENTIFY, user_properties: o.getUserProperties(), groups: (r = {}, r[e] = t, r) });
  return i;
}, JE = function(e, t) {
  return Ae(Ae({}, t), { event_type: Ai.REVENUE, event_properties: e.getEventProperties() });
}, Pn = function(e) {
  return {
    promise: e || Promise.resolve()
  };
}, e_ = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = "$default"), this.initializing = !1, this.isReady = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new zE(this), this.name = t;
    }
    return e.prototype._init = function(t) {
      return we(this, void 0, void 0, function() {
        return ye(this, function(n) {
          switch (n.label) {
            case 0:
              return this.config = t, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return n.sent(), this.isReady = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.runQueuedFunctions = function(t) {
      return we(this, void 0, void 0, function() {
        var n, r, o, i, a, s, l, c;
        return ye(this, function(u) {
          switch (u.label) {
            case 0:
              n = this[t], this[t] = [], u.label = 1;
            case 1:
              u.trys.push([1, 8, 9, 10]), r = Yt(n), o = r.next(), u.label = 2;
            case 2:
              return o.done ? [3, 7] : (i = o.value, a = i(), a && "promise" in a ? [4, a.promise] : [3, 4]);
            case 3:
              return u.sent(), [3, 6];
            case 4:
              return [4, a];
            case 5:
              u.sent(), u.label = 6;
            case 6:
              return o = r.next(), [3, 2];
            case 7:
              return [3, 10];
            case 8:
              return s = u.sent(), l = { error: s }, [3, 10];
            case 9:
              try {
                o && !o.done && (c = r.return) && c.call(r);
              } finally {
                if (l)
                  throw l.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 10:
              return this[t].length ? [4, this.runQueuedFunctions(t)] : [3, 12];
            case 11:
              u.sent(), u.label = 12;
            case 12:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.track = function(t, n, r) {
      var o = ZE(t, n, r);
      return Pn(this.dispatch(o));
    }, e.prototype.identify = function(t, n) {
      var r = Am(t, n);
      return Pn(this.dispatch(r));
    }, e.prototype.groupIdentify = function(t, n, r, o) {
      var i = QE(t, n, r, o);
      return Pn(this.dispatch(i));
    }, e.prototype.setGroup = function(t, n, r) {
      var o = XE(t, n, r);
      return Pn(this.dispatch(o));
    }, e.prototype.revenue = function(t, n) {
      var r = JE(t, n);
      return Pn(this.dispatch(r));
    }, e.prototype.add = function(t) {
      return this.isReady ? this._addPlugin(t) : (this.q.push(this._addPlugin.bind(this, t)), Pn());
    }, e.prototype._addPlugin = function(t) {
      return Pn(this.timeline.register(t, this.config));
    }, e.prototype.remove = function(t) {
      return this.isReady ? this._removePlugin(t) : (this.q.push(this._removePlugin.bind(this, t)), Pn());
    }, e.prototype._removePlugin = function(t) {
      return Pn(this.timeline.deregister(t));
    }, e.prototype.dispatchWithCallback = function(t, n) {
      if (!this.isReady)
        return n(bi(t, 0, jE));
      this.process(t).then(n);
    }, e.prototype.dispatch = function(t) {
      return we(this, void 0, void 0, function() {
        var n = this;
        return ye(this, function(r) {
          return this.isReady ? [2, this.process(t)] : [2, new Promise(function(o) {
            n.dispatchQ.push(n.dispatchWithCallback.bind(n, t, o));
          })];
        });
      });
    }, e.prototype.process = function(t) {
      return we(this, void 0, void 0, function() {
        var o, n, r, o;
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), this.config.optOut ? [2, bi(t, 0, LE)] : [4, this.timeline.push(t)];
            case 1:
              return o = i.sent(), o.code === 200 ? this.config.loggerProvider.log(o.message) : o.code === 100 ? this.config.loggerProvider.warn(o.message) : this.config.loggerProvider.error(o.message), [2, o];
            case 2:
              return n = i.sent(), r = String(n), this.config.loggerProvider.error(r), o = bi(t, 0, r), [2, o];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.setOptOut = function(t) {
      if (!this.isReady) {
        this.q.push(this._setOptOut.bind(this, !!t));
        return;
      }
      this._setOptOut(t);
    }, e.prototype._setOptOut = function(t) {
      this.config.optOut = !!t;
    }, e.prototype.flush = function() {
      return Pn(this.timeline.flush());
    }, e;
  }()
), t_ = (
  /** @class */
  function() {
    function e() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return e.prototype.setProductId = function(t) {
      return this.productId = t, this;
    }, e.prototype.setQuantity = function(t) {
      return t > 0 && (this.quantity = t), this;
    }, e.prototype.setPrice = function(t) {
      return this.price = t, this;
    }, e.prototype.setRevenueType = function(t) {
      return this.revenueType = t, this;
    }, e.prototype.setRevenue = function(t) {
      return this.revenue = t, this;
    }, e.prototype.setEventProperties = function(t) {
      return gd(t) && (this.properties = t), this;
    }, e.prototype.getEventProperties = function() {
      var t = this.properties ? Ae({}, this.properties) : {};
      return t[So.REVENUE_PRODUCT_ID] = this.productId, t[So.REVENUE_QUANTITY] = this.quantity, t[So.REVENUE_PRICE] = this.price, t[So.REVENUE_TYPE] = this.revenueType, t[So.REVENUE] = this.revenue, t;
    }, e;
  }()
), n_ = function(e, t) {
  var n = Math.max(t, 1);
  return e.reduce(function(r, o, i) {
    var a = Math.floor(i / n);
    return r[a] || (r[a] = []), r[a].push(o), r;
  }, []);
}, ds = "Amplitude Logger ", Im = (
  /** @class */
  function() {
    function e() {
      this.logLevel = Ln.None;
    }
    return e.prototype.disable = function() {
      this.logLevel = Ln.None;
    }, e.prototype.enable = function(t) {
      t === void 0 && (t = Ln.Warn), this.logLevel = t;
    }, e.prototype.log = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Ln.Verbose || console.log("".concat(ds, "[Log]: ").concat(t.join(" ")));
    }, e.prototype.warn = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Ln.Warn || console.warn("".concat(ds, "[Warn]: ").concat(t.join(" ")));
    }, e.prototype.error = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Ln.Error || console.error("".concat(ds, "[Error]: ").concat(t.join(" ")));
    }, e.prototype.debug = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Ln.Debug || console.log("".concat(ds, "[Debug]: ").concat(t.join(" ")));
    }, e;
  }()
), qs = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: Ln.Warn,
    loggerProvider: new Im(),
    offline: !1,
    optOut: !1,
    serverUrl: Pm,
    serverZone: "US",
    useBatch: !1
  };
}, r_ = (
  /** @class */
  function() {
    function e(t) {
      var n, r, o, i;
      this._optOut = !1;
      var a = qs();
      this.apiKey = t.apiKey, this.flushIntervalMillis = (n = t.flushIntervalMillis) !== null && n !== void 0 ? n : a.flushIntervalMillis, this.flushMaxRetries = t.flushMaxRetries || a.flushMaxRetries, this.flushQueueSize = t.flushQueueSize || a.flushQueueSize, this.instanceName = t.instanceName || a.instanceName, this.loggerProvider = t.loggerProvider || a.loggerProvider, this.logLevel = (r = t.logLevel) !== null && r !== void 0 ? r : a.logLevel, this.minIdLength = t.minIdLength, this.plan = t.plan, this.ingestionMetadata = t.ingestionMetadata, this.offline = t.offline !== void 0 ? t.offline : a.offline, this.optOut = (o = t.optOut) !== null && o !== void 0 ? o : a.optOut, this.serverUrl = t.serverUrl, this.serverZone = t.serverZone || a.serverZone, this.storageProvider = t.storageProvider, this.transportProvider = t.transportProvider, this.useBatch = (i = t.useBatch) !== null && i !== void 0 ? i : a.useBatch, this.loggerProvider.enable(this.logLevel);
      var s = km(t.serverUrl, t.serverZone, t.useBatch);
      this.serverZone = s.serverZone, this.serverUrl = s.serverUrl;
    }
    return Object.defineProperty(e.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(t) {
        this._optOut = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), o_ = function(e, t) {
  return e === "EU" ? t ? KE : WE : t ? GE : Pm;
}, km = function(e, t, n) {
  if (e === void 0 && (e = ""), t === void 0 && (t = qs().serverZone), n === void 0 && (n = qs().useBatch), e)
    return { serverUrl: e, serverZone: void 0 };
  var r = ["US", "EU"].includes(t) ? t : qs().serverZone;
  return {
    serverZone: r,
    serverUrl: o_(r, n)
  };
}, $m = (
  /** @class */
  function() {
    function e() {
      this.sdk = {
        metrics: {
          histogram: {}
        }
      };
    }
    return e.prototype.recordHistogram = function(t, n) {
      this.sdk.metrics.histogram[t] = n;
    }, e;
  }()
);
function i_(e) {
  return e instanceof Error ? e.message : String(e);
}
function fs(e) {
  var t = "";
  try {
    "body" in e && (t = JSON.stringify(e.body, null, 2));
  } catch {
  }
  return t;
}
var a_ = (
  /** @class */
  function() {
    function e() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduled = null, this.queue = [];
    }
    return e.prototype.setup = function(t) {
      var n;
      return we(this, void 0, void 0, function() {
        var r, o = this;
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              return this.config = t, this.storageKey = "".concat(qE, "_").concat(this.config.apiKey.substring(0, 10)), [4, (n = this.config.storageProvider) === null || n === void 0 ? void 0 : n.get(this.storageKey)];
            case 1:
              return r = i.sent(), r && r.length > 0 && Promise.all(r.map(function(a) {
                return o.execute(a);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, e.prototype.execute = function(t) {
      var n = this;
      return t.insert_id || (t.insert_id = Ui()), new Promise(function(r) {
        var o = {
          event: t,
          attempts: 0,
          callback: function(i) {
            return r(i);
          },
          timeout: 0
        };
        n.addToQueue(o);
      });
    }, e.prototype.getTryableList = function(t) {
      var n = this;
      return t.filter(function(r) {
        return r.attempts < n.config.flushMaxRetries ? (r.attempts += 1, !0) : (n.fulfillRequest([r], 500, FE), !1);
      });
    }, e.prototype.scheduleTryable = function(t, n) {
      var r = this;
      n === void 0 && (n = !1), t.forEach(function(o) {
        if (n && (r.queue = r.queue.concat(o)), o.timeout === 0) {
          r.schedule(r.config.flushIntervalMillis);
          return;
        }
        setTimeout(function() {
          o.timeout = 0, r.schedule(0);
        }, o.timeout);
      });
    }, e.prototype.addToQueue = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      var r = this.getTryableList(t);
      this.scheduleTryable(r, !0), this.saveEvents();
    }, e.prototype.schedule = function(t) {
      var n = this;
      this.scheduled || this.config.offline || (this.scheduled = setTimeout(function() {
        n.flush(!0).then(function() {
          n.queue.length > 0 && n.schedule(t);
        });
      }, t));
    }, e.prototype.flush = function(t) {
      return t === void 0 && (t = !1), we(this, void 0, void 0, function() {
        var n, r, o, i = this;
        return ye(this, function(a) {
          switch (a.label) {
            case 0:
              return this.config.offline ? (this.config.loggerProvider.debug("Skipping flush while offline."), [
                2
                /*return*/
              ]) : (n = [], r = [], this.queue.forEach(function(s) {
                return s.timeout === 0 ? n.push(s) : r.push(s);
              }), this.scheduled && (clearTimeout(this.scheduled), this.scheduled = null), o = n_(n, this.config.flushQueueSize), [4, Promise.all(o.map(function(s) {
                return i.send(s, t);
              }))]);
            case 1:
              return a.sent(), this.scheduleTryable(r), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.send = function(t, n) {
      return n === void 0 && (n = !0), we(this, void 0, void 0, function() {
        var r, o, i, a, s;
        return ye(this, function(l) {
          switch (l.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(t, 400, ME)];
              r = {
                api_key: this.config.apiKey,
                events: t.map(function(c) {
                  var u = c.event;
                  u.extra;
                  var d = vd(u, ["extra"]);
                  return d;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                request_metadata: this.config.requestMetadata
              }, this.config.requestMetadata = new $m(), l.label = 1;
            case 1:
              return l.trys.push([1, 3, , 4]), o = km(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(o, r)];
            case 2:
              return i = l.sent(), i === null ? (this.fulfillRequest(t, 0, NE), [
                2
                /*return*/
              ]) : n ? (this.handleResponse(i, t), [3, 4]) : ("body" in i ? this.fulfillRequest(t, i.statusCode, "".concat(i.status, ": ").concat(fs(i))) : this.fulfillRequest(t, i.statusCode, i.status), [
                2
                /*return*/
              ]);
            case 3:
              return a = l.sent(), s = i_(a), this.config.loggerProvider.error(s), this.handleResponse({ status: Lt.Failed, statusCode: 0 }, t), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.handleResponse = function(t, n) {
      var r = t.status;
      switch (r) {
        case Lt.Success: {
          this.handleSuccessResponse(t, n);
          break;
        }
        case Lt.Invalid: {
          this.handleInvalidResponse(t, n);
          break;
        }
        case Lt.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(t, n);
          break;
        }
        case Lt.RateLimit: {
          this.handleRateLimitResponse(t, n);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(r, "' provided for ").concat(n.length, ' events"}')), this.handleOtherResponse(n);
          break;
        }
      }
    }, e.prototype.handleSuccessResponse = function(t, n) {
      this.fulfillRequest(n, t.statusCode, $E);
    }, e.prototype.handleInvalidResponse = function(t, n) {
      var r = this;
      if (t.body.missingField || t.body.error.startsWith(DE)) {
        this.fulfillRequest(n, t.statusCode, t.body.error);
        return;
      }
      var o = sn(sn(sn(sn([], gt(Object.values(t.body.eventsWithInvalidFields)), !1), gt(Object.values(t.body.eventsWithMissingFields)), !1), gt(Object.values(t.body.eventsWithInvalidIdLengths)), !1), gt(t.body.silencedEvents), !1).flat(), i = new Set(o), a = n.filter(function(l, c) {
        if (i.has(c)) {
          r.fulfillRequest([l], t.statusCode, t.body.error);
          return;
        }
        return !0;
      });
      a.length > 0 && this.config.loggerProvider.warn(fs(t));
      var s = this.getTryableList(a);
      this.scheduleTryable(s);
    }, e.prototype.handlePayloadTooLargeResponse = function(t, n) {
      if (n.length === 1) {
        this.fulfillRequest(n, t.statusCode, t.body.error);
        return;
      }
      this.config.loggerProvider.warn(fs(t)), this.config.flushQueueSize /= 2;
      var r = this.getTryableList(n);
      this.scheduleTryable(r);
    }, e.prototype.handleRateLimitResponse = function(t, n) {
      var r = this, o = Object.keys(t.body.exceededDailyQuotaUsers), i = Object.keys(t.body.exceededDailyQuotaDevices), a = t.body.throttledEvents, s = new Set(o), l = new Set(i), c = new Set(a), u = n.filter(function(f, h) {
        if (f.event.user_id && s.has(f.event.user_id) || f.event.device_id && l.has(f.event.device_id)) {
          r.fulfillRequest([f], t.statusCode, t.body.error);
          return;
        }
        return c.has(h) && (f.timeout = r.throttleTimeout), !0;
      });
      u.length > 0 && this.config.loggerProvider.warn(fs(t));
      var d = this.getTryableList(u);
      this.scheduleTryable(d);
    }, e.prototype.handleOtherResponse = function(t) {
      var n = this, r = t.map(function(i) {
        return i.timeout = i.attempts * n.retryTimeout, i;
      }), o = this.getTryableList(r);
      this.scheduleTryable(o);
    }, e.prototype.fulfillRequest = function(t, n, r) {
      this.removeEvents(t), t.forEach(function(o) {
        return o.callback(bi(o.event, n, r));
      });
    }, e.prototype.saveEvents = function() {
      if (this.config.storageProvider) {
        var t = this.queue.map(function(n) {
          return n.event;
        });
        this.config.storageProvider.set(this.storageKey, t);
      }
    }, e.prototype.removeEvents = function(t) {
      this.queue = this.queue.filter(function(n) {
        return !t.some(function(r) {
          return r.event.insert_id === n.event.insert_id;
        });
      }), this.saveEvents();
    }, e;
  }()
), s_ = function(e) {
  var t = new Error().stack || "";
  return t.split(`
`).slice(2 + e).map(function(n) {
    return n.trim();
  });
}, Ht = function(e) {
  return function() {
    var t = Ae({}, e.config), n = t.loggerProvider, r = t.logLevel;
    return {
      logger: n,
      logLevel: r
    };
  };
}, l_ = function(e, t) {
  var n, r;
  t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
  try {
    for (var o = Yt(t.split(".")), i = o.next(); !i.done; i = o.next()) {
      var a = i.value;
      if (a in e)
        e = e[a];
      else
        return;
    }
  } catch (s) {
    n = { error: s };
  } finally {
    try {
      i && !i.done && (r = o.return) && r.call(o);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return e;
}, zt = function(e, t) {
  return function() {
    var n, r, o = {};
    try {
      for (var i = Yt(t), a = i.next(); !a.done; a = i.next()) {
        var s = a.value;
        o[s] = l_(e, s);
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return o;
  };
}, qt = function(e, t, n, r, o) {
  return o === void 0 && (o = null), function() {
    for (var i = [], a = 0; a < arguments.length; a++)
      i[a] = arguments[a];
    var s = n(), l = s.logger, c = s.logLevel;
    if (c && c < Ln.Debug || !c || !l)
      return e.apply(o, i);
    var u = {
      type: "invoke public method",
      name: t,
      args: i,
      stacktrace: s_(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    r && u.states && (u.states.before = r());
    var d = e.apply(o, i);
    return d && d.promise ? d.promise.then(function() {
      r && u.states && (u.states.after = r()), u.time && (u.time.end = (/* @__PURE__ */ new Date()).toISOString()), l.debug(JSON.stringify(u, null, 2));
    }) : (r && u.states && (u.states.after = r()), u.time && (u.time.end = (/* @__PURE__ */ new Date()).toISOString()), l.debug(JSON.stringify(u, null, 2))), d;
  };
}, Kf = (
  /** @class */
  function() {
    function e() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return e.prototype.isEnabled = function() {
      return we(this, void 0, void 0, function() {
        return ye(this, function(t) {
          return [2, !0];
        });
      });
    }, e.prototype.get = function(t) {
      return we(this, void 0, void 0, function() {
        return ye(this, function(n) {
          return [2, this.memoryStorage.get(t)];
        });
      });
    }, e.prototype.getRaw = function(t) {
      return we(this, void 0, void 0, function() {
        var n;
        return ye(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.get(t)];
            case 1:
              return n = r.sent(), [2, n ? JSON.stringify(n) : void 0];
          }
        });
      });
    }, e.prototype.set = function(t, n) {
      return we(this, void 0, void 0, function() {
        return ye(this, function(r) {
          return this.memoryStorage.set(t, n), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      return we(this, void 0, void 0, function() {
        return ye(this, function(n) {
          return this.memoryStorage.delete(t), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.reset = function() {
      return we(this, void 0, void 0, function() {
        return ye(this, function(t) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), Gl = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.send = function(t, n) {
      return Promise.resolve(null);
    }, e.prototype.buildResponse = function(t) {
      var n, r, o, i, a, s, l, c, u, d, f, h, p, g, v, b, m, w, E, C, x, _;
      if (typeof t != "object")
        return null;
      var T = t.code || 0, O = this.buildStatus(T);
      switch (O) {
        case Lt.Success:
          return {
            status: O,
            statusCode: T,
            body: {
              eventsIngested: (n = t.events_ingested) !== null && n !== void 0 ? n : 0,
              payloadSizeBytes: (r = t.payload_size_bytes) !== null && r !== void 0 ? r : 0,
              serverUploadTime: (o = t.server_upload_time) !== null && o !== void 0 ? o : 0
            }
          };
        case Lt.Invalid:
          return {
            status: O,
            statusCode: T,
            body: {
              error: (i = t.error) !== null && i !== void 0 ? i : "",
              missingField: (a = t.missing_field) !== null && a !== void 0 ? a : "",
              eventsWithInvalidFields: (s = t.events_with_invalid_fields) !== null && s !== void 0 ? s : {},
              eventsWithMissingFields: (l = t.events_with_missing_fields) !== null && l !== void 0 ? l : {},
              eventsWithInvalidIdLengths: (c = t.events_with_invalid_id_lengths) !== null && c !== void 0 ? c : {},
              epsThreshold: (u = t.eps_threshold) !== null && u !== void 0 ? u : 0,
              exceededDailyQuotaDevices: (d = t.exceeded_daily_quota_devices) !== null && d !== void 0 ? d : {},
              silencedDevices: (f = t.silenced_devices) !== null && f !== void 0 ? f : [],
              silencedEvents: (h = t.silenced_events) !== null && h !== void 0 ? h : [],
              throttledDevices: (p = t.throttled_devices) !== null && p !== void 0 ? p : {},
              throttledEvents: (g = t.throttled_events) !== null && g !== void 0 ? g : []
            }
          };
        case Lt.PayloadTooLarge:
          return {
            status: O,
            statusCode: T,
            body: {
              error: (v = t.error) !== null && v !== void 0 ? v : ""
            }
          };
        case Lt.RateLimit:
          return {
            status: O,
            statusCode: T,
            body: {
              error: (b = t.error) !== null && b !== void 0 ? b : "",
              epsThreshold: (m = t.eps_threshold) !== null && m !== void 0 ? m : 0,
              throttledDevices: (w = t.throttled_devices) !== null && w !== void 0 ? w : {},
              throttledUsers: (E = t.throttled_users) !== null && E !== void 0 ? E : {},
              exceededDailyQuotaDevices: (C = t.exceeded_daily_quota_devices) !== null && C !== void 0 ? C : {},
              exceededDailyQuotaUsers: (x = t.exceeded_daily_quota_users) !== null && x !== void 0 ? x : {},
              throttledEvents: (_ = t.throttled_events) !== null && _ !== void 0 ? _ : []
            }
          };
        case Lt.Timeout:
        default:
          return {
            status: O,
            statusCode: T
          };
      }
    }, e.prototype.buildStatus = function(t) {
      return t >= 200 && t < 300 ? Lt.Success : t === 429 ? Lt.RateLimit : t === 413 ? Lt.PayloadTooLarge : t === 408 ? Lt.Timeout : t >= 400 && t < 500 ? Lt.Invalid : t >= 500 ? Lt.Failed : Lt.Unknown;
    }, e;
  }()
), hr = function() {
  var e = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[e] < "u")
    return globalThis[e];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof Bn < "u")
    return Bn;
}, yl = function() {
  var e, t = hr();
  if (!(!((e = t == null ? void 0 : t.location) === null || e === void 0) && e.search))
    return {};
  var n = t.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(o, i) {
    var a = i.split("=", 2), s = wp(a[0]), l = wp(a[1]);
    return l && (o[s] = l), o;
  }, {});
  return r;
}, wp = function(e) {
  e === void 0 && (e = "");
  try {
    return decodeURIComponent(e);
  } catch {
    return "";
  }
}, c_ = "utm_campaign", u_ = "utm_content", d_ = "utm_id", f_ = "utm_medium", h_ = "utm_source", p_ = "utm_term", Ep = "dclid", _p = "fbclid", xp = "gbraid", Sp = "gclid", Tp = "ko_click_id", Op = "li_fat_id", Pp = "msclkid", Rp = "rtd_cid", Ap = "ttclid", Ip = "twclid", kp = "wbraid", Kl = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, Nm = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.parse = function() {
      return we(this, void 0, void 0, function() {
        return ye(this, function(t) {
          return [2, Ae(Ae(Ae(Ae({}, Kl), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, e.prototype.getUtmParam = function() {
      var t = yl(), n = t[c_], r = t[u_], o = t[d_], i = t[f_], a = t[h_], s = t[p_];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: o,
        utm_medium: i,
        utm_source: a,
        utm_term: s
      };
    }, e.prototype.getReferrer = function() {
      var t, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (t = r.referrer) === null || t === void 0 ? void 0 : t.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, e.prototype.getClickIds = function() {
      var t, n = yl();
      return t = {}, t[Ep] = n[Ep], t[_p] = n[_p], t[xp] = n[xp], t[Sp] = n[Sp], t[Tp] = n[Tp], t[Op] = n[Op], t[Pp] = n[Pp], t[Rp] = n[Rp], t[Ap] = n[Ap], t[Ip] = n[Ip], t[kp] = n[kp], t;
    }, e;
  }()
), Fm = function(e, t, n) {
  return t === void 0 && (t = ""), n === void 0 && (n = 10), [Wl, t, e.substring(0, n)].filter(Boolean).join("_");
}, v_ = function(e) {
  return "".concat(Wl.toLowerCase(), "_").concat(e.substring(0, 6));
}, $p = function(e) {
  var t = e.split(".");
  return t.length <= 2 ? e : t.slice(t.length - 2, t.length).join(".");
}, g_ = function(e) {
  return Object.values(e).every(function(t) {
    return !t;
  });
}, m_ = function(e, t, n, r) {
  r === void 0 && (r = !0), e.referrer;
  var o = e.referring_domain, i = vd(e, ["referrer", "referring_domain"]), a = t || {};
  a.referrer;
  var s = a.referring_domain, l = vd(a, ["referrer", "referring_domain"]);
  if (y_(n.excludeReferrers, e.referring_domain) || !r && g_(e) && t)
    return !1;
  var c = JSON.stringify(i) !== JSON.stringify(l), u = $p(o || "") !== $p(s || "");
  return !t || c || u;
}, y_ = function(e, t) {
  return e === void 0 && (e = []), t === void 0 && (t = ""), e.some(function(n) {
    return n instanceof RegExp ? n.test(t) : n === t;
  });
}, b_ = function(e, t) {
  var n = Ae(Ae({}, Kl), e), r = Object.entries(n).reduce(function(o, i) {
    var a, s = gt(i, 2), l = s[0], c = s[1];
    return o.setOnce("initial_".concat(l), (a = c ?? t.initialEmptyValue) !== null && a !== void 0 ? a : "EMPTY"), c ? o.set(l, c) : o.unset(l);
  }, new Ca());
  return Am(r);
}, C_ = function(e) {
  var t = e;
  return t ? (t.startsWith(".") && (t = t.substring(1)), [new RegExp("".concat(t.replace(".", "\\."), "$"))]) : [];
}, w_ = function(e, t, n) {
  return n === void 0 && (n = 10), [Wl, t, e.substring(0, n)].filter(Boolean).join("_");
}, Lm = function(e, t) {
  t === void 0 && (t = Date.now());
  var n = Date.now(), r = n - t;
  return r > e;
}, E_ = (
  /** @class */
  function() {
    function e(t, n) {
      var r;
      this.shouldTrackNewCampaign = !1, this.options = Ae({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: C_((r = n.cookieOptions) === null || r === void 0 ? void 0 : r.domain) }, t), this.storage = n.cookieStorage, this.storageKey = w_(n.apiKey, "MKTG"), this.currentCampaign = Kl, this.sessionTimeout = n.sessionTimeout, this.lastEventTime = n.lastEventTime, n.loggerProvider.log("Installing web attribution tracking.");
    }
    return e.prototype.init = function() {
      return we(this, void 0, void 0, function() {
        var t, n;
        return ye(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.fetchCampaign()];
            case 1:
              return n = gt.apply(void 0, [r.sent(), 2]), this.currentCampaign = n[0], this.previousCampaign = n[1], t = this.lastEventTime ? Lm(this.sessionTimeout, this.lastEventTime) : !0, m_(this.currentCampaign, this.previousCampaign, this.options, t) ? (this.shouldTrackNewCampaign = !0, [4, this.storage.set(this.storageKey, this.currentCampaign)]) : [3, 3];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.fetchCampaign = function() {
      return we(this, void 0, void 0, function() {
        return ye(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all([new Nm().parse(), this.storage.get(this.storageKey)])];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.generateCampaignEvent = function(t) {
      this.shouldTrackNewCampaign = !1;
      var n = b_(this.currentCampaign, this.options);
      return t && (n.event_id = t), n;
    }, e.prototype.shouldSetSessionIdOnNewCampaign = function() {
      return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    }, e;
  }()
), md = (
  /** @class */
  function() {
    function e(t) {
      this.options = Ae({}, t);
    }
    return e.prototype.isEnabled = function() {
      return we(this, void 0, void 0, function() {
        var t, n, r;
        return ye(this, function(o) {
          switch (o.label) {
            case 0:
              if (!hr())
                return [2, !1];
              e.testValue = String(Date.now()), t = new e(this.options), n = "AMP_TEST", o.label = 1;
            case 1:
              return o.trys.push([1, 4, 5, 7]), [4, t.set(n, e.testValue)];
            case 2:
              return o.sent(), [4, t.get(n)];
            case 3:
              return r = o.sent(), [2, r === e.testValue];
            case 4:
              return o.sent(), [2, !1];
            case 5:
              return [4, t.remove(n)];
            case 6:
              return o.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(t) {
      var n;
      return we(this, void 0, void 0, function() {
        var r, o;
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.getRaw(t)];
            case 1:
              if (r = i.sent(), !r)
                return [2, void 0];
              try {
                return o = (n = __(r)) !== null && n !== void 0 ? n : x_(r), o === void 0 ? (console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(t, ", value: ").concat(r)), [2, void 0]) : [2, JSON.parse(o)];
              } catch {
                return console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(t, ", value: ").concat(r)), [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRaw = function(t) {
      var n, r;
      return we(this, void 0, void 0, function() {
        var o, i, a;
        return ye(this, function(s) {
          return o = hr(), i = (r = (n = o == null ? void 0 : o.document) === null || n === void 0 ? void 0 : n.cookie.split("; ")) !== null && r !== void 0 ? r : [], a = i.find(function(l) {
            return l.indexOf(t + "=") === 0;
          }), a ? [2, a.substring(t.length + 1)] : [2, void 0];
        });
      });
    }, e.prototype.set = function(t, n) {
      var r;
      return we(this, void 0, void 0, function() {
        var o, i, a, s, l, c, u;
        return ye(this, function(d) {
          try {
            o = (r = this.options.expirationDays) !== null && r !== void 0 ? r : 0, i = n !== null ? o : -1, a = void 0, i && (s = /* @__PURE__ */ new Date(), s.setTime(s.getTime() + i * 24 * 60 * 60 * 1e3), a = s), l = "".concat(t, "=").concat(btoa(encodeURIComponent(JSON.stringify(n)))), a && (l += "; expires=".concat(a.toUTCString())), l += "; path=/", this.options.domain && (l += "; domain=".concat(this.options.domain)), this.options.secure && (l += "; Secure"), this.options.sameSite && (l += "; SameSite=".concat(this.options.sameSite)), c = hr(), c && (c.document.cookie = l);
          } catch (f) {
            u = f instanceof Error ? f.message : String(f), console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(t, ". Error: ").concat(u));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      return we(this, void 0, void 0, function() {
        return ye(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.set(t, null)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.reset = function() {
      return we(this, void 0, void 0, function() {
        return ye(this, function(t) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), __ = function(e) {
  try {
    return decodeURIComponent(atob(e));
  } catch {
    return;
  }
}, x_ = function(e) {
  try {
    return decodeURIComponent(atob(decodeURIComponent(e)));
  } catch {
    return;
  }
}, S_ = (
  /** @class */
  function(e) {
    zn(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.send = function(n, r) {
      return we(this, void 0, void 0, function() {
        var o, i, a;
        return ye(this, function(s) {
          switch (s.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return o = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(r),
                method: "POST"
              }, [4, fetch(n, o)];
            case 1:
              return i = s.sent(), [4, i.text()];
            case 2:
              a = s.sent();
              try {
                return [2, this.buildResponse(JSON.parse(a))];
              } catch {
                return [2, this.buildResponse({ code: i.status })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Gl)
), T_ = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: O_(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, e;
  }()
), O_ = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, P_ = (
  /** @class */
  function() {
    function e() {
      this.queue = [];
    }
    return e.prototype.logEvent = function(t) {
      this.receiver ? this.receiver(t) : this.queue.length < 512 && this.queue.push(t);
    }, e.prototype.setEventReceiver = function(t) {
      this.receiver = t, this.queue.length > 0 && (this.queue.forEach(function(n) {
        t(n);
      }), this.queue = []);
    }, e;
  }()
), oo = function() {
  return oo = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, oo.apply(this, arguments);
}, Ws = function(e, t) {
  var n = ["string", "number", "boolean", "undefined"], r = typeof e, o = typeof t;
  if (r !== o)
    return !1;
  for (var i = 0, a = n; i < a.length; i++) {
    var s = a[i];
    if (s === r)
      return e === t;
  }
  if (e == null && t == null)
    return !0;
  if (e == null || t == null || e.length !== t.length)
    return !1;
  var l = Array.isArray(e), c = Array.isArray(t);
  if (l !== c)
    return !1;
  if (l && c) {
    for (var u = 0; u < e.length; u++)
      if (!Ws(e[u], t[u]))
        return !1;
  } else {
    var d = Object.keys(e).sort(), f = Object.keys(t).sort();
    if (!Ws(d, f))
      return !1;
    var h = !0;
    return Object.keys(e).forEach(function(p) {
      Ws(e[p], t[p]) || (h = !1);
    }), h;
  }
  return !0;
}, R_ = "$set", A_ = "$unset", I_ = "$clearAll";
Object.entries || (Object.entries = function(e) {
  for (var t = Object.keys(e), n = t.length, r = new Array(n); n--; )
    r[n] = [t[n], e[t[n]]];
  return r;
});
var k_ = (
  /** @class */
  function() {
    function e() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return e.prototype.editIdentity = function() {
      var t = this, n = oo({}, this.identity.userProperties), r = oo(oo({}, this.identity), { userProperties: n });
      return {
        setUserId: function(o) {
          return r.userId = o, this;
        },
        setDeviceId: function(o) {
          return r.deviceId = o, this;
        },
        setUserProperties: function(o) {
          return r.userProperties = o, this;
        },
        setOptOut: function(o) {
          return r.optOut = o, this;
        },
        updateUserProperties: function(o) {
          for (var i = r.userProperties || {}, a = 0, s = Object.entries(o); a < s.length; a++) {
            var l = s[a], c = l[0], u = l[1];
            switch (c) {
              case R_:
                for (var d = 0, f = Object.entries(u); d < f.length; d++) {
                  var h = f[d], p = h[0], g = h[1];
                  i[p] = g;
                }
                break;
              case A_:
                for (var v = 0, b = Object.keys(u); v < b.length; v++) {
                  var p = b[v];
                  delete i[p];
                }
                break;
              case I_:
                i = {};
                break;
            }
          }
          return r.userProperties = i, this;
        },
        commit: function() {
          return t.setIdentity(r), this;
        }
      };
    }, e.prototype.getIdentity = function() {
      return oo({}, this.identity);
    }, e.prototype.setIdentity = function(t) {
      var n = oo({}, this.identity);
      this.identity = oo({}, t), Ws(n, this.identity) || this.listeners.forEach(function(r) {
        r(t);
      });
    }, e.prototype.addIdentityListener = function(t) {
      this.listeners.add(t);
    }, e.prototype.removeIdentityListener = function(t) {
      this.listeners.delete(t);
    }, e;
  }()
), ta = typeof globalThis < "u" ? globalThis : typeof Bn < "u" ? Bn : self, $_ = (
  /** @class */
  function() {
    function e() {
      this.identityStore = new k_(), this.eventBridge = new P_(), this.applicationContextProvider = new T_();
    }
    return e.getInstance = function(t) {
      return ta.analyticsConnectorInstances || (ta.analyticsConnectorInstances = {}), ta.analyticsConnectorInstances[t] || (ta.analyticsConnectorInstances[t] = new e()), ta.analyticsConnectorInstances[t];
    }, e;
  }()
), wa = function(e) {
  return e === void 0 && (e = "$default_instance"), $_.getInstance(e);
}, N_ = function(e, t) {
  wa(t).identityStore.editIdentity().setUserId(e).commit();
}, F_ = function(e, t) {
  wa(t).identityStore.editIdentity().setDeviceId(e).commit();
}, L_ = (
  /** @class */
  function() {
    function e() {
      this.name = "identity", this.type = "before", this.identityStore = wa().identityStore;
    }
    return e.prototype.execute = function(t) {
      return we(this, void 0, void 0, function() {
        var n;
        return ye(this, function(r) {
          return n = t.user_properties, n && this.identityStore.editIdentity().updateUserProperties(n).commit(), [2, t];
        });
      });
    }, e.prototype.setup = function(t) {
      return we(this, void 0, void 0, function() {
        return ye(this, function(n) {
          return t.instanceName && (this.identityStore = wa(t.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), M_ = function() {
  var e, t, n, r;
  if (typeof navigator > "u")
    return "";
  var o = navigator.userLanguage;
  return (r = (n = (t = (e = navigator.languages) === null || e === void 0 ? void 0 : e[0]) !== null && t !== void 0 ? t : navigator.language) !== null && n !== void 0 ? n : o) !== null && r !== void 0 ? r : "";
}, La = function(e, t) {
  return typeof e == "boolean" ? e : (e == null ? void 0 : e[t]) !== !1;
}, Mm = function(e) {
  return La(e, "attribution");
}, D_ = function(e) {
  return La(e, "fileDownloads");
}, j_ = function(e) {
  return La(e, "formInteractions");
}, Dm = function(e) {
  return La(e, "pageViews");
}, Np = function(e) {
  return La(e, "sessions");
}, jm = function(e) {
  return typeof e == "boolean" ? e : typeof e == "object" && (e.elementInteractions === !0 || typeof e.elementInteractions == "object");
}, B_ = function(e) {
  if (jm(e.autocapture) && typeof e.autocapture == "object" && typeof e.autocapture.elementInteractions == "object")
    return e.autocapture.elementInteractions;
}, V_ = function(e) {
  var t = function() {
    return !1;
  }, n = void 0, r, o = e.pageCounter, i = Dm(e.defaultTracking);
  return i && (t = void 0, r = void 0, e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.pageViews && typeof e.defaultTracking.pageViews == "object" && ("trackOn" in e.defaultTracking.pageViews && (t = e.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in e.defaultTracking.pageViews && (n = e.defaultTracking.pageViews.trackHistoryChanges), "eventType" in e.defaultTracking.pageViews && e.defaultTracking.pageViews.eventType && (r = e.defaultTracking.pageViews.eventType))), {
    trackOn: t,
    trackHistoryChanges: n,
    eventType: r,
    pageCounter: o
  };
}, U_ = function(e) {
  return Mm(e.defaultTracking) && e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.attribution && typeof e.defaultTracking.attribution == "object" ? Ae({}, e.defaultTracking.attribution) : {};
}, Xc = function(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n], o = r.name, i = r.args, a = r.resolve, s = e && e[o];
    if (typeof s == "function") {
      var l = s.apply(e, i);
      typeof a == "function" && a(l == null ? void 0 : l.promise);
    }
  }
  return e;
}, Jc = function(e) {
  var t = e;
  return t && t._q !== void 0;
}, H_ = "2.11.7", z_ = "Web", q_ = "$remote", W_ = (
  /** @class */
  function() {
    function e() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "amplitude-ts/".concat(H_), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return e.prototype.setup = function(t) {
      return this.config = t, Promise.resolve(void 0);
    }, e.prototype.execute = function(t) {
      var n, r;
      return we(this, void 0, void 0, function() {
        var o, i, a, s;
        return ye(this, function(l) {
          return o = (/* @__PURE__ */ new Date()).getTime(), i = (n = this.config.lastEventId) !== null && n !== void 0 ? n : -1, a = (r = t.event_id) !== null && r !== void 0 ? r : i + 1, this.config.lastEventId = a, t.time || (this.config.lastEventTime = o), s = Ae(Ae(Ae(Ae(Ae(Ae(Ae(Ae({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: o }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: z_ }), this.config.trackingOptions.language && { language: M_() }), this.config.trackingOptions.ipAddress && { ip: q_ }), { insert_id: Ui(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), t), { event_id: a, library: this.library, user_agent: this.userAgent }), [2, s];
        });
      });
    }, e;
  }()
), Bm = (
  /** @class */
  function() {
    function e(t) {
      this.storage = t;
    }
    return e.prototype.isEnabled = function() {
      return we(this, void 0, void 0, function() {
        var t, n, r, o;
        return ye(this, function(i) {
          switch (i.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              t = String(Date.now()), n = new e(this.storage), r = "AMP_TEST", i.label = 1;
            case 1:
              return i.trys.push([1, 4, 5, 7]), [4, n.set(r, t)];
            case 2:
              return i.sent(), [4, n.get(r)];
            case 3:
              return o = i.sent(), [2, o === t];
            case 4:
              return i.sent(), [2, !1];
            case 5:
              return [4, n.remove(r)];
            case 6:
              return i.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(t) {
      return we(this, void 0, void 0, function() {
        var n;
        return ye(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.getRaw(t)];
            case 1:
              return n = r.sent(), n ? [2, JSON.parse(n)] : [2, void 0];
            case 2:
              return r.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRaw = function(t) {
      var n;
      return we(this, void 0, void 0, function() {
        return ye(this, function(r) {
          return [2, ((n = this.storage) === null || n === void 0 ? void 0 : n.getItem(t)) || void 0];
        });
      });
    }, e.prototype.set = function(t, n) {
      var r;
      return we(this, void 0, void 0, function() {
        return ye(this, function(o) {
          try {
            (r = this.storage) === null || r === void 0 || r.setItem(t, JSON.stringify(n));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      var n;
      return we(this, void 0, void 0, function() {
        return ye(this, function(r) {
          try {
            (n = this.storage) === null || n === void 0 || n.removeItem(t);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.reset = function() {
      var t;
      return we(this, void 0, void 0, function() {
        return ye(this, function(n) {
          try {
            (t = this.storage) === null || t === void 0 || t.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), hs = 1e3, Vm = (
  /** @class */
  function(e) {
    zn(t, e);
    function t(n) {
      var r = this, o;
      return r = e.call(this, (o = hr()) === null || o === void 0 ? void 0 : o.localStorage) || this, r.loggerProvider = n == null ? void 0 : n.loggerProvider, r;
    }
    return t.prototype.set = function(n, r) {
      var o;
      return we(this, void 0, void 0, function() {
        var i;
        return ye(this, function(a) {
          switch (a.label) {
            case 0:
              return Array.isArray(r) && r.length > hs ? (i = r.length - hs, [4, e.prototype.set.call(this, n, r.slice(0, hs))]) : [3, 2];
            case 1:
              return a.sent(), (o = this.loggerProvider) === null || o === void 0 || o.error("Failed to save ".concat(i, " events because the queue length exceeded ").concat(hs, ".")), [3, 4];
            case 2:
              return [4, e.prototype.set.call(this, n, r)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Bm)
), G_ = (
  /** @class */
  function(e) {
    zn(t, e);
    function t() {
      var n;
      return e.call(this, (n = hr()) === null || n === void 0 ? void 0 : n.sessionStorage) || this;
    }
    return t;
  }(Bm)
), K_ = (
  /** @class */
  function(e) {
    zn(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.state = {
        done: 4
      }, n;
    }
    return t.prototype.send = function(n, r) {
      return we(this, void 0, void 0, function() {
        var o = this;
        return ye(this, function(i) {
          return [2, new Promise(function(a, s) {
            typeof XMLHttpRequest > "u" && s(new Error("XHRTransport is not supported."));
            var l = new XMLHttpRequest();
            l.open("POST", n, !0), l.onreadystatechange = function() {
              if (l.readyState === o.state.done) {
                var c = l.responseText;
                try {
                  a(o.buildResponse(JSON.parse(c)));
                } catch {
                  a(o.buildResponse({ code: l.status }));
                }
              }
            }, l.setRequestHeader("Content-Type", "application/json"), l.setRequestHeader("Accept", "*/*"), l.send(JSON.stringify(r));
          })];
        });
      });
    }, t;
  }(Gl)
), Y_ = (
  /** @class */
  function(e) {
    zn(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.send = function(n, r) {
      return we(this, void 0, void 0, function() {
        var o = this;
        return ye(this, function(i) {
          return [2, new Promise(function(a, s) {
            var l = hr();
            if (!(l != null && l.navigator.sendBeacon))
              throw new Error("SendBeaconTransport is not supported");
            try {
              var c = JSON.stringify(r), u = l.navigator.sendBeacon(n, JSON.stringify(r));
              return a(u ? o.buildResponse({
                code: 200,
                events_ingested: r.events.length,
                payload_size_bytes: c.length,
                server_upload_time: Date.now()
              }) : o.buildResponse({ code: 500 }));
            } catch (d) {
              s(d);
            }
          })];
        });
      });
    }, t;
  }(Gl)
), Z_ = function(e, t, n) {
  return n === void 0 && (n = !0), we(void 0, void 0, void 0, function() {
    var r, o, i, a, s, l, c, u, d;
    return ye(this, function(f) {
      switch (f.label) {
        case 0:
          return r = v_(e), [4, t.getRaw(r)];
        case 1:
          return o = f.sent(), o ? n ? [4, t.remove(r)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          f.sent(), f.label = 3;
        case 3:
          return i = gt(o.split("."), 6), a = i[0], s = i[1], l = i[2], c = i[3], u = i[4], d = i[5], [2, {
            deviceId: a,
            userId: Q_(s),
            sessionId: eu(c),
            lastEventId: eu(d),
            lastEventTime: eu(u),
            optOut: !!l
          }];
      }
    });
  });
}, eu = function(e) {
  var t = parseInt(e, 32);
  if (!isNaN(t))
    return t;
}, Q_ = function(e) {
  if (!(!atob || !escape || !e))
    try {
      return decodeURIComponent(escape(atob(e)));
    } catch {
      return;
    }
}, gr = "[Amplitude]", Fp = "".concat(gr, " Form Started"), X_ = "".concat(gr, " Form Submitted"), J_ = "".concat(gr, " File Downloaded"), Lp = "session_start", Mp = "session_end", e6 = "".concat(gr, " File Extension"), t6 = "".concat(gr, " File Name"), n6 = "".concat(gr, " Link ID"), r6 = "".concat(gr, " Link Text"), o6 = "".concat(gr, " Link URL"), tu = "".concat(gr, " Form ID"), nu = "".concat(gr, " Form Name"), ru = "".concat(gr, " Form Destination"), bl = "cookie", i6 = "US", a6 = (
  /** @class */
  function(e) {
    zn(t, e);
    function t(n, r, o, i, a, s, l, c, u, d, f, h, p, g, v, b, m, w, E, C, x, _, T, O, I, L, B, j, M, q, N, $, F, H) {
      o === void 0 && (o = new Kf()), i === void 0 && (i = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), c === void 0 && (c = 1e3), u === void 0 && (u = 5), d === void 0 && (d = 30), f === void 0 && (f = bl), b === void 0 && (b = new Im()), m === void 0 && (m = Ln.Warn), E === void 0 && (E = !1), C === void 0 && (C = !1), T === void 0 && (T = ""), O === void 0 && (O = i6), L === void 0 && (L = 30 * 60 * 1e3), B === void 0 && (B = new Vm({ loggerProvider: b })), j === void 0 && (j = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), M === void 0 && (M = "fetch"), q === void 0 && (q = !1), N === void 0 && (N = !1);
      var k = e.call(this, { apiKey: n, storageProvider: B, transportProvider: Um(M) }) || this;
      return k.apiKey = n, k.appVersion = r, k.cookieOptions = i, k.defaultTracking = a, k.autocapture = s, k.flushIntervalMillis = c, k.flushMaxRetries = u, k.flushQueueSize = d, k.identityStorage = f, k.ingestionMetadata = h, k.instanceName = p, k.loggerProvider = b, k.logLevel = m, k.minIdLength = w, k.offline = E, k.partnerId = x, k.plan = _, k.serverUrl = T, k.serverZone = O, k.sessionTimeout = L, k.storageProvider = B, k.trackingOptions = j, k.transport = M, k.useBatch = q, k.fetchRemoteConfig = N, k._optOut = !1, k._cookieStorage = o, k.deviceId = l, k.lastEventId = g, k.lastEventTime = v, k.optOut = C, k.sessionId = I, k.pageCounter = F, k.userId = $, k.debugLogsEnabled = H, k.loggerProvider.enable(H ? Ln.Debug : k.logLevel), k;
    }
    return Object.defineProperty(t.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(n) {
        this._cookieStorage !== n && (this._cookieStorage = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(n) {
        this._deviceId !== n && (this._deviceId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(n) {
        this._userId !== n && (this._userId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(n) {
        this._sessionId !== n && (this._sessionId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(n) {
        this._optOut !== n && (this._optOut = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(n) {
        this._lastEventTime !== n && (this._lastEventTime = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(n) {
        this._lastEventId !== n && (this._lastEventId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(n) {
        this._pageCounter !== n && (this._pageCounter = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "debugLogsEnabled", {
      set: function(n) {
        this._debugLogsEnabled !== n && (this._debugLogsEnabled = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateStorage = function() {
      var n = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter,
        debugLogsEnabled: this._debugLogsEnabled
      };
      this.cookieStorage.set(Fm(this.apiKey), n);
    }, t;
  }(r_)
), s6 = function(e, t, n) {
  return t === void 0 && (t = {}), we(void 0, void 0, void 0, function() {
    var r, o, i, a, s, l, c, u, d, f, h, p, g, v, b, m, w, E, C, x, _, T, O, I, L, B, j, M, q, N, $, F, H, k, W, G, ne, Y, fe, ge, ie, he, ue;
    return ye(this, function(ce) {
      switch (ce.label) {
        case 0:
          return r = t.identityStorage || bl, C = {}, r === bl ? [3, 1] : (i = "", [3, 5]);
        case 1:
          return (_ = (x = t.cookieOptions) === null || x === void 0 ? void 0 : x.domain) !== null && _ !== void 0 ? (a = _, [3, 4]) : [3, 2];
        case 2:
          return [4, c6()];
        case 3:
          a = ce.sent(), ce.label = 4;
        case 4:
          i = a, ce.label = 5;
        case 5:
          return o = Ae.apply(void 0, [(C.domain = i, C.expiration = 365, C.sameSite = "Lax", C.secure = !1, C.upgrade = !0, C), t.cookieOptions]), s = l6(t.identityStorage, o), [4, Z_(e, s, (O = (T = t.cookieOptions) === null || T === void 0 ? void 0 : T.upgrade) !== null && O !== void 0 ? O : !0)];
        case 6:
          return l = ce.sent(), [4, s.get(Fm(e))];
        case 7:
          return c = ce.sent(), u = yl(), d = (M = (j = (B = (L = (I = t.deviceId) !== null && I !== void 0 ? I : u.ampDeviceId) !== null && L !== void 0 ? L : u.deviceId) !== null && B !== void 0 ? B : c == null ? void 0 : c.deviceId) !== null && j !== void 0 ? j : l.deviceId) !== null && M !== void 0 ? M : Ui(), f = (q = c == null ? void 0 : c.lastEventId) !== null && q !== void 0 ? q : l.lastEventId, h = (N = c == null ? void 0 : c.lastEventTime) !== null && N !== void 0 ? N : l.lastEventTime, p = (F = ($ = t.optOut) !== null && $ !== void 0 ? $ : c == null ? void 0 : c.optOut) !== null && F !== void 0 ? F : l.optOut, g = (H = c == null ? void 0 : c.sessionId) !== null && H !== void 0 ? H : l.sessionId, v = (W = (k = t.userId) !== null && k !== void 0 ? k : c == null ? void 0 : c.userId) !== null && W !== void 0 ? W : l.userId, n.previousSessionDeviceId = (G = c == null ? void 0 : c.deviceId) !== null && G !== void 0 ? G : l.deviceId, n.previousSessionUserId = (ne = c == null ? void 0 : c.userId) !== null && ne !== void 0 ? ne : l.userId, b = {
            ipAddress: (fe = (Y = t.trackingOptions) === null || Y === void 0 ? void 0 : Y.ipAddress) !== null && fe !== void 0 ? fe : !0,
            language: (ie = (ge = t.trackingOptions) === null || ge === void 0 ? void 0 : ge.language) !== null && ie !== void 0 ? ie : !0,
            platform: (ue = (he = t.trackingOptions) === null || he === void 0 ? void 0 : he.platform) !== null && ue !== void 0 ? ue : !0
          }, m = c == null ? void 0 : c.pageCounter, w = c == null ? void 0 : c.debugLogsEnabled, t.autocapture !== void 0 && (t.defaultTracking = t.autocapture), E = new a6(e, t.appVersion, s, o, t.defaultTracking, t.autocapture, d, t.flushIntervalMillis, t.flushMaxRetries, t.flushQueueSize, r, t.ingestionMetadata, t.instanceName, f, h, t.loggerProvider, t.logLevel, t.minIdLength, t.offline, p, t.partnerId, t.plan, t.serverUrl, t.serverZone, g, t.sessionTimeout, t.storageProvider, b, t.transport, t.useBatch, t.fetchRemoteConfig, v, m, w), [4, E.storageProvider.isEnabled()];
        case 8:
          return ce.sent() || (E.loggerProvider.warn("Storage provider ".concat(E.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage.")), E.storageProvider = new Kf()), [2, E];
      }
    });
  });
}, l6 = function(e, t) {
  switch (e === void 0 && (e = bl), t === void 0 && (t = {}), e) {
    case "localStorage":
      return new Vm();
    case "sessionStorage":
      return new G_();
    case "none":
      return new Kf();
    case "cookie":
    default:
      return new md(Ae(Ae({}, t), { expirationDays: t.expiration }));
  }
}, Um = function(e) {
  return e === "xhr" ? new K_() : e === "beacon" ? new Y_() : new S_();
}, c6 = function(e) {
  return we(void 0, void 0, void 0, function() {
    var t, n, r, o, i, i, a, s, l, c;
    return ye(this, function(u) {
      switch (u.label) {
        case 0:
          return [4, new md().isEnabled()];
        case 1:
          if (!u.sent() || typeof location > "u" || !location.hostname)
            return [2, ""];
          for (t = location.hostname, n = t.split("."), r = [], o = "AMP_TLDTEST", i = n.length - 2; i >= 0; --i)
            r.push(n.slice(i).join("."));
          i = 0, u.label = 2;
        case 2:
          return i < r.length ? (a = r[i], s = { domain: "." + a }, l = new md(s), [4, l.set(o, 1)]) : [3, 7];
        case 3:
          return u.sent(), [4, l.get(o)];
        case 4:
          return c = u.sent(), c ? [4, l.remove(o)] : [3, 6];
        case 5:
          return u.sent(), [2, "." + a];
        case 6:
          return i++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, u6 = function(e) {
  var t = {};
  for (var n in e) {
    var r = e[n];
    r && (t[n] = r);
  }
  return t;
}, d6 = "[Amplitude] Page Viewed", f6 = function(e) {
  e === void 0 && (e = {});
  var t, n = hr(), r = void 0, o, i, a = e.trackOn, s = e.trackHistoryChanges, l = e.eventType, c = l === void 0 ? d6 : l, u = function(b) {
    var m = b;
    try {
      m = decodeURI(b);
    } catch (w) {
      r == null || r.error("Malformed URI sequence: ", w);
    }
    return m;
  }, d = function() {
    return we(void 0, void 0, void 0, function() {
      var b, m, w;
      return ye(this, function(E) {
        switch (E.label) {
          case 0:
            return b = u(typeof location < "u" && location.href || ""), w = {
              event_type: c
            }, m = [{}], [4, h6()];
          case 1:
            return [2, (w.event_properties = Ae.apply(void 0, [Ae.apply(void 0, m.concat([E.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": b, "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && u(location.pathname) || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": b.split("?")[0] }]), w)];
        }
      });
    });
  }, f = function() {
    return typeof a > "u" || typeof a == "function" && a();
  }, h = typeof location < "u" ? location.href : null, p = function() {
    return we(void 0, void 0, void 0, function() {
      var b, m, w, E;
      return ye(this, function(C) {
        switch (C.label) {
          case 0:
            return b = location.href, m = v6(s, b, h || "") && f(), h = b, m ? (r == null || r.log("Tracking page view event"), t != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return E = (w = t).track, [4, d()];
          case 2:
            E.apply(w, [C.sent()]), C.label = 3;
          case 3:
            C.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, g = function() {
    p();
  }, v = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(b, m) {
      return we(void 0, void 0, void 0, function() {
        var w, E;
        return ye(this, function(C) {
          switch (C.label) {
            case 0:
              return t = m, i = b, r = b.loggerProvider, r.log("Installing @amplitude/plugin-page-view-tracking-browser"), n && (n.addEventListener("popstate", g), o = n.history.pushState, n.history.pushState = new Proxy(n.history.pushState, {
                apply: function(x, _, T) {
                  var O = gt(T, 3), I = O[0], L = O[1], B = O[2];
                  x.apply(_, [I, L, B]), p();
                }
              })), f() ? (r.log("Tracking page view event"), E = (w = t).track, [4, d()]) : [3, 2];
            case 1:
              E.apply(w, [C.sent()]), C.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(b) {
      return we(void 0, void 0, void 0, function() {
        var m;
        return ye(this, function(w) {
          switch (w.label) {
            case 0:
              return a === "attribution" && p6(b) ? (r == null || r.log("Enriching campaign event to page view event with campaign parameters"), [4, d()]) : [3, 2];
            case 1:
              m = w.sent(), b.event_type = m.event_type, b.event_properties = Ae(Ae({}, b.event_properties), m.event_properties), w.label = 2;
            case 2:
              return i && b.event_type === c && (i.pageCounter = i.pageCounter ? i.pageCounter + 1 : 1, b.event_properties = Ae(Ae({}, b.event_properties), { "[Amplitude] Page Counter": i.pageCounter })), [2, b];
          }
        });
      });
    },
    teardown: function() {
      return we(void 0, void 0, void 0, function() {
        return ye(this, function(b) {
          return n && (n.removeEventListener("popstate", g), o && (n.history.pushState = o)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return v;
}, h6 = function() {
  return we(void 0, void 0, void 0, function() {
    var e;
    return ye(this, function(t) {
      switch (t.label) {
        case 0:
          return e = u6, [4, new Nm().parse()];
        case 1:
          return [2, e.apply(void 0, [t.sent()])];
      }
    });
  });
}, p6 = function(e) {
  if (e.event_type === "$identify" && e.user_properties) {
    var t = e.user_properties, n = t[rn.SET] || {}, r = t[rn.UNSET] || {}, o = sn(sn([], gt(Object.keys(n)), !1), gt(Object.keys(r)), !1);
    return Object.keys(Kl).every(function(i) {
      return o.includes(i);
    });
  }
  return !1;
}, v6 = function(e, t, n) {
  switch (e) {
    case "pathOnly": {
      if (n == "")
        return !0;
      var r = new URL(t), o = new URL(n), i = r.origin + r.pathname, a = o.origin + o.pathname;
      return i !== a;
    }
    default:
      return t !== n;
  }
}, g6 = function() {
  var e, t = [], n = function(c, u, d) {
    c.addEventListener(u, d), t.push({
      element: c,
      type: u,
      handler: d
    });
  }, r = function() {
    t.forEach(function(c) {
      var u = c.element, d = c.type, f = c.handler;
      u == null || u.removeEventListener(d, f);
    }), t = [];
  }, o = "@amplitude/plugin-form-interaction-tracking-browser", i = "enrichment", a = function(c, u) {
    return we(void 0, void 0, void 0, function() {
      var d;
      return ye(this, function(f) {
        return (d = hr()) === null || d === void 0 || d.addEventListener("load", function() {
          if (!u) {
            c.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var h = function(g) {
              var v = !1;
              n(g, "change", function() {
                var b;
                v || u.track(Fp, (b = {}, b[tu] = ei(g.id), b[nu] = ei(g.name), b[ru] = g.action, b)), v = !0;
              }), n(g, "submit", function() {
                var b, m;
                v || u.track(Fp, (b = {}, b[tu] = ei(g.id), b[nu] = ei(g.name), b[ru] = g.action, b)), u.track(X_, (m = {}, m[tu] = ei(g.id), m[nu] = ei(g.name), m[ru] = g.action, m)), v = !1;
              });
            }, p = Array.from(document.getElementsByTagName("form"));
            p.forEach(h), typeof MutationObserver < "u" && (e = new MutationObserver(function(g) {
              g.forEach(function(v) {
                v.addedNodes.forEach(function(b) {
                  b.nodeName === "FORM" && h(b), "querySelectorAll" in b && typeof b.querySelectorAll == "function" && Array.from(b.querySelectorAll("form")).map(h);
                });
              });
            }), e.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }), [
          2
          /*return*/
        ];
      });
    });
  }, s = function(c) {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(u) {
        return [2, c];
      });
    });
  }, l = function() {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(c) {
        return e == null || e.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: o,
    type: i,
    setup: a,
    execute: s,
    teardown: l
  };
}, ei = function(e) {
  if (typeof e == "string")
    return e;
}, m6 = function() {
  var e, t = [], n = function(c, u, d) {
    c.addEventListener(u, d), t.push({
      element: c,
      type: u,
      handler: d
    });
  }, r = function() {
    t.forEach(function(c) {
      var u = c.element, d = c.type, f = c.handler;
      u == null || u.removeEventListener(d, f);
    }), t = [];
  }, o = "@amplitude/plugin-file-download-tracking-browser", i = "enrichment", a = function(c, u) {
    return we(void 0, void 0, void 0, function() {
      var d;
      return ye(this, function(f) {
        return (d = hr()) === null || d === void 0 || d.addEventListener("load", function() {
          if (!u) {
            c.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var h = function(v) {
              var b;
              try {
                b = new URL(v.href, window.location.href);
              } catch {
                return;
              }
              var m = p.exec(b.href), w = m == null ? void 0 : m[1];
              w && n(v, "click", function() {
                var E;
                w && u.track(J_, (E = {}, E[e6] = w, E[t6] = b.pathname, E[n6] = v.id, E[r6] = v.text, E[o6] = v.href, E));
              });
            }, p = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)$/, g = Array.from(document.getElementsByTagName("a"));
            g.forEach(h), typeof MutationObserver < "u" && (e = new MutationObserver(function(v) {
              v.forEach(function(b) {
                b.addedNodes.forEach(function(m) {
                  m.nodeName === "A" && h(m), "querySelectorAll" in m && typeof m.querySelectorAll == "function" && Array.from(m.querySelectorAll("a")).map(h);
                });
              });
            }), e.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }), [
          2
          /*return*/
        ];
      });
    });
  }, s = function(c) {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(u) {
        return [2, c];
      });
    });
  }, l = function() {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(c) {
        return e == null || e.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: o,
    type: i,
    setup: a,
    execute: s,
    teardown: l
  };
}, Dp = !1, y6 = function(e) {
  if (!(Dp || e.defaultTracking !== void 0)) {
    var t = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    e.loggerProvider.warn(t), Dp = !0;
  }
}, b6 = function() {
  var e = "@amplitude/plugin-network-checker-browser", t = "before", n = hr(), r = [], o = function(l, c) {
    n && (n.addEventListener(l, c), r.push({
      type: l,
      handler: c
    }));
  }, i = function() {
    r.forEach(function(l) {
      var c = l.type, u = l.handler;
      n && n.removeEventListener(c, u);
    }), r = [];
  }, a = function(l, c) {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(u) {
        return typeof navigator > "u" ? (l.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available."), l.offline = !1, [
          2
          /*return*/
        ]) : (l.offline = !navigator.onLine, o("online", function() {
          l.loggerProvider.debug("Network connectivity changed to online."), l.offline = !1, setTimeout(function() {
            c.flush();
          }, l.flushIntervalMillis);
        }), o("offline", function() {
          l.loggerProvider.debug("Network connectivity changed to offline."), l.offline = !0;
        }), [
          2
          /*return*/
        ]);
      });
    });
  }, s = function() {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(l) {
        return i(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: e,
    type: t,
    setup: a,
    teardown: s
  };
}, C6 = "Network error occurred, remote config fetch failed", w6 = "Remote config successfully fetched", E6 = "Remote config fetch rejected due to exceeded retry count", jp = "Remote config fetch rejected due to timeout after 5 seconds", _6 = "Unexpected error occurred", x6 = "https://sr-client-cfg.amplitude.com/config", S6 = "https://sr-client-cfg.stag2.amplitude.com/config", T6 = "https://sr-client-cfg.eu.amplitude.com/config", O6 = (
  /** @class */
  function() {
    function e(t) {
      var n = t.localConfig, r = t.configKeys, o = this;
      this.retryTimeout = 1e3, this.attempts = 0, this.sessionTargetingMatch = !1, this.metrics = {}, this.getRemoteConfig = function(i, a, s) {
        return we(o, void 0, void 0, function() {
          var l, c, u;
          return ye(this, function(d) {
            switch (d.label) {
              case 0:
                return l = Date.now(), [4, this.fetchWithTimeout(s)];
              case 1:
                return c = d.sent(), c && (u = c.configs && c.configs[i], u) ? (this.metrics.fetchTimeAPISuccess = Date.now() - l, [2, u[a]]) : (this.metrics.fetchTimeAPIFail = Date.now() - l, [2, void 0]);
            }
          });
        });
      }, this.fetchWithTimeout = function(i) {
        return we(o, void 0, void 0, function() {
          var a, s, l;
          return ye(this, function(c) {
            switch (c.label) {
              case 0:
                return a = new AbortController(), s = setTimeout(function() {
                  return a.abort();
                }, 5e3), [4, this.fetchRemoteConfig(a.signal, i)];
              case 1:
                return l = c.sent(), clearTimeout(s), [2, l];
            }
          });
        });
      }, this.fetchRemoteConfig = function(i, a) {
        return we(o, void 0, void 0, function() {
          var s, l, c, u, d, f, h, p, g, v, b, m;
          return ye(this, function(w) {
            switch (w.label) {
              case 0:
                if (a === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries)
                  return [2, this.completeRequest({ err: E6 })];
                if (i.aborted)
                  return [2, this.completeRequest({ err: jp })];
                a !== this.lastFetchedSessionId && (this.lastFetchedSessionId = a, this.attempts = 0), w.label = 1;
              case 1:
                w.trys.push([1, 3, , 4]), s = new URLSearchParams({
                  api_key: this.localConfig.apiKey
                });
                try {
                  for (l = Yt(this.configKeys), c = l.next(); !c.done; c = l.next())
                    u = c.value, s.append("config_keys", u);
                } catch (E) {
                  b = { error: E };
                } finally {
                  try {
                    c && !c.done && (m = l.return) && m.call(l);
                  } finally {
                    if (b)
                      throw b.error;
                  }
                }
                return a && s.set("session_id", String(a)), d = {
                  headers: {
                    Accept: "*/*"
                  },
                  method: "GET"
                }, f = "".concat(this.getServerUrl(), "?").concat(s.toString()), this.attempts += 1, [4, fetch(f, Ae(Ae({}, d), { signal: i }))];
              case 2:
                if (h = w.sent(), h === null)
                  return [2, this.completeRequest({ err: _6 })];
                switch (p = new Gl().buildStatus(h.status), p) {
                  case Lt.Success:
                    return this.attempts = 0, [2, this.parseAndStoreConfig(h)];
                  case Lt.Failed:
                    return [2, this.retryFetch(i, a)];
                  default:
                    return [2, this.completeRequest({ err: C6 })];
                }
              case 3:
                return g = w.sent(), v = g, i.aborted ? [2, this.completeRequest({ err: jp })] : [2, this.completeRequest({ err: v.message })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, this.retryFetch = function(i, a) {
        return we(o, void 0, void 0, function() {
          var s = this;
          return ye(this, function(l) {
            switch (l.label) {
              case 0:
                return [4, new Promise(function(c) {
                  return setTimeout(c, s.attempts * s.retryTimeout);
                })];
              case 1:
                return l.sent(), [2, this.fetchRemoteConfig(i, a)];
            }
          });
        });
      }, this.parseAndStoreConfig = function(i) {
        return we(o, void 0, void 0, function() {
          var a;
          return ye(this, function(s) {
            switch (s.label) {
              case 0:
                return [4, i.json()];
              case 1:
                return a = s.sent(), this.completeRequest({ success: w6 }), [2, a];
            }
          });
        });
      }, this.localConfig = n, this.configKeys = r;
    }
    return e.prototype.getServerUrl = function() {
      return this.localConfig.serverZone === ml.STAGING ? S6 : this.localConfig.serverZone === ml.EU ? T6 : x6;
    }, e.prototype.completeRequest = function(t) {
      var n = t.err, r = t.success;
      if (n)
        throw new Error(n);
      r && this.localConfig.loggerProvider.log(r);
    }, e;
  }()
), P6 = function(e) {
  var t = e.localConfig, n = e.configKeys;
  return we(void 0, void 0, void 0, function() {
    return ye(this, function(r) {
      return [2, new O6({ localConfig: t, configKeys: n })];
    });
  });
}, R6 = P6, A6 = (
  /** @class */
  function() {
    function e(t) {
      this.config = t, this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
    }
    return e.prototype.initialize = function() {
      return we(this, void 0, void 0, function() {
        var t;
        return ye(this, function(n) {
          switch (n.label) {
            case 0:
              return t = this, [4, R6({
                localConfig: this.config,
                configKeys: ["analyticsSDK"]
              })];
            case 1:
              return t.remoteConfigFetch = n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.generateJoinedConfig = function() {
      var t, n, r, o;
      return we(this, void 0, void 0, function() {
        var i, a, s;
        return ye(this, function(l) {
          switch (l.label) {
            case 0:
              return l.trys.push([0, 3, , 4]), a = this.remoteConfigFetch, a ? [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)] : [3, 2];
            case 1:
              a = l.sent(), l.label = 2;
            case 2:
              return i = a, this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(i, null, 2)), i && "autocapture" in i && (typeof i.autocapture == "boolean" && (this.config.autocapture = i.autocapture), typeof i.autocapture == "object" && (this.config.autocapture === void 0 && (this.config.autocapture = i.autocapture), typeof this.config.autocapture == "boolean" && (this.config.autocapture = Ae({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, i.autocapture)), typeof this.config.autocapture == "object" && (this.config.autocapture = Ae(Ae({}, this.config.autocapture), i.autocapture))), this.config.defaultTracking = this.config.autocapture), this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2)), (t = (o = this.config).requestMetadata) !== null && t !== void 0 || (o.requestMetadata = new $m()), !((n = this.remoteConfigFetch) === null || n === void 0) && n.metrics.fetchTimeAPISuccess && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess), !((r = this.remoteConfigFetch) === null || r === void 0) && r.metrics.fetchTimeAPIFail && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail), [3, 4];
            case 3:
              return s = l.sent(), this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", s), [3, 4];
            case 4:
              return [2, this.config];
          }
        });
      });
    }, e;
  }()
), I6 = function(e) {
  return we(void 0, void 0, void 0, function() {
    var t;
    return ye(this, function(n) {
      switch (n.label) {
        case 0:
          return t = new A6(e), [4, t.initialize()];
        case 1:
          return n.sent(), [2, t];
      }
    });
  });
}, k6 = "@amplitude/plugin-autocapture-browser", yd = "[Amplitude] Element Clicked", $6 = "[Amplitude] Element Changed", N6 = "[Amplitude] Element ID", F6 = "[Amplitude] Element Class", Hm = "[Amplitude] Element Tag", zm = "[Amplitude] Element Text", L6 = "[Amplitude] Element Hierarchy", M6 = "[Amplitude] Element Href", D6 = "[Amplitude] Element Position Left", j6 = "[Amplitude] Element Position Top", B6 = "[Amplitude] Element Aria Label", V6 = "[Amplitude] Element Attributes", qm = "[Amplitude] Element Selector", U6 = "[Amplitude] Element Parent Label", Wm = "[Amplitude] Page URL", H6 = "[Amplitude] Page Title", z6 = "[Amplitude] Viewport Height", q6 = "[Amplitude] Viewport Width", Gs = "https://app.amplitude.com", W6 = "https://app.eu.amplitude.com", G6 = "https://apps.stag2.amplitude.com", K6 = {
  US: Gs,
  EU: W6,
  STAGING: G6
}, Y6 = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz", bd = "amp-visual-tagging-selector-highlight";
function Tt(e) {
  return typeof e == "function";
}
function Gm(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var ou = Gm(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, o) {
      return o + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function Cd(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Yl = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, o, i;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var s = Yt(a), l = s.next(); !l.done; l = s.next()) {
              var c = l.value;
              c.remove(this);
            }
          } catch (g) {
            t = { error: g };
          } finally {
            try {
              l && !l.done && (n = s.return) && n.call(s);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          a.remove(this);
      var u = this.initialTeardown;
      if (Tt(u))
        try {
          u();
        } catch (g) {
          i = g instanceof ou ? g.errors : [g];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var f = Yt(d), h = f.next(); !h.done; h = f.next()) {
            var p = h.value;
            try {
              Bp(p);
            } catch (g) {
              i = i ?? [], g instanceof ou ? i = sn(sn([], gt(i)), gt(g.errors)) : i.push(g);
            }
          }
        } catch (g) {
          r = { error: g };
        } finally {
          try {
            h && !h.done && (o = f.return) && o.call(f);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (i)
        throw new ou(i);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        Bp(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && Cd(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && Cd(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}();
Yl.EMPTY;
function Km(e) {
  return e instanceof Yl || e && "closed" in e && Tt(e.remove) && Tt(e.add) && Tt(e.unsubscribe);
}
function Bp(e) {
  Tt(e) ? e() : e.unsubscribe();
}
var Ym = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, Zm = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, sn([e, t], gt(n)));
  },
  clearTimeout: function(e) {
    var t = Zm.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function Qm(e) {
  Zm.setTimeout(function() {
    throw e;
  });
}
function wd() {
}
function Z6(e) {
  e();
}
var Yf = function(e) {
  zn(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, Km(n) && n.add(r)) : r.destination = e4, r;
  }
  return t.create = function(n, r, o) {
    return new Ed(n, r, o);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Yl), Q6 = Function.prototype.bind;
function iu(e, t) {
  return Q6.call(e, t);
}
var X6 = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        ps(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        ps(r);
      }
    else
      ps(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        ps(n);
      }
  }, e;
}(), Ed = function(e) {
  zn(t, e);
  function t(n, r, o) {
    var i = e.call(this) || this, a;
    if (Tt(n) || !n)
      a = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: o ?? void 0
      };
    else {
      var s;
      i && Ym.useDeprecatedNextContext ? (s = Object.create(n), s.unsubscribe = function() {
        return i.unsubscribe();
      }, a = {
        next: n.next && iu(n.next, s),
        error: n.error && iu(n.error, s),
        complete: n.complete && iu(n.complete, s)
      }) : a = n;
    }
    return i.destination = new X6(a), i;
  }
  return t;
}(Yf);
function ps(e) {
  Qm(e);
}
function J6(e) {
  throw e;
}
var e4 = {
  closed: !0,
  next: wd,
  error: J6,
  complete: wd
}, Zf = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Xm(e) {
  return e;
}
function t4(e) {
  return e.length === 0 ? Xm : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, o) {
      return o(r);
    }, n);
  };
}
var qn = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var o = this, i = r4(t) ? t : new Ed(t, n, r);
    return Z6(function() {
      var a = o, s = a.operator, l = a.source;
      i.add(s ? s.call(i, l) : l ? o._subscribe(i) : o._trySubscribe(i));
    }), i;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Vp(n), new n(function(o, i) {
      var a = new Ed({
        next: function(s) {
          try {
            t(s);
          } catch (l) {
            i(l), a.unsubscribe();
          }
        },
        error: i,
        complete: o
      });
      r.subscribe(a);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[Zf] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return t4(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Vp(t), new t(function(r, o) {
      var i;
      n.subscribe(function(a) {
        return i = a;
      }, function(a) {
        return o(a);
      }, function() {
        return r(i);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Vp(e) {
  var t;
  return (t = e ?? Ym.Promise) !== null && t !== void 0 ? t : Promise;
}
function n4(e) {
  return e && Tt(e.next) && Tt(e.error) && Tt(e.complete);
}
function r4(e) {
  return e && e instanceof Yf || n4(e) && Km(e);
}
function o4(e) {
  return Tt(e == null ? void 0 : e.lift);
}
function mr(e) {
  return function(t) {
    if (o4(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Un(e, t, n, r, o) {
  return new i4(e, t, n, r, o);
}
var i4 = function(e) {
  zn(t, e);
  function t(n, r, o, i, a, s) {
    var l = e.call(this, n) || this;
    return l.onFinalize = a, l.shouldUnsubscribe = s, l._next = r ? function(c) {
      try {
        r(c);
      } catch (u) {
        n.error(u);
      }
    } : e.prototype._next, l._error = i ? function(c) {
      try {
        i(c);
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, l._complete = o ? function() {
      try {
        o();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, l;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(Yf), a4 = {
  now: function() {
    return Date.now();
  },
  delegate: void 0
}, s4 = function(e) {
  zn(t, e);
  function t(n, r) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, r) {
    return this;
  }, t;
}(Yl), _d = {
  setInterval: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, sn([e, t], gt(n)));
  },
  clearInterval: function(e) {
    var t = _d.delegate;
    return ((t == null ? void 0 : t.clearInterval) || clearInterval)(e);
  },
  delegate: void 0
}, l4 = function(e) {
  zn(t, e);
  function t(n, r) {
    var o = e.call(this, n, r) || this;
    return o.scheduler = n, o.work = r, o.pending = !1, o;
  }
  return t.prototype.schedule = function(n, r) {
    var o;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var i = this.id, a = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(a, i, r)), this.pending = !0, this.delay = r, this.id = (o = this.id) !== null && o !== void 0 ? o : this.requestAsyncId(a, this.id, r), this;
  }, t.prototype.requestAsyncId = function(n, r, o) {
    return o === void 0 && (o = 0), _d.setInterval(n.flush.bind(n, this), o);
  }, t.prototype.recycleAsyncId = function(n, r, o) {
    if (o === void 0 && (o = 0), o != null && this.delay === o && this.pending === !1)
      return r;
    r != null && _d.clearInterval(r);
  }, t.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var o = this._execute(n, r);
    if (o)
      return o;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, r) {
    var o = !1, i;
    try {
      this.work(n);
    } catch (a) {
      o = !0, i = a || new Error("Scheduled action threw falsy error");
    }
    if (o)
      return this.unsubscribe(), i;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, o = n.scheduler, i = o.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Cd(i, this), r != null && (this.id = this.recycleAsyncId(o, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(s4), Up = function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(r, n);
  }, e.now = a4.now, e;
}(), c4 = function(e) {
  zn(t, e);
  function t(n, r) {
    r === void 0 && (r = Up.now);
    var o = e.call(this, n, r) || this;
    return o.actions = [], o._active = !1, o;
  }
  return t.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var o;
    this._active = !0;
    do
      if (o = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, o) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw o;
    }
  }, t;
}(Up), Zl = new c4(l4), u4 = Zl, Qf = new qn(function(e) {
  return e.complete();
});
function Jm(e) {
  return e && Tt(e.schedule);
}
function e1(e) {
  return e[e.length - 1];
}
function d4(e) {
  return Jm(e1(e)) ? e.pop() : void 0;
}
function f4(e, t) {
  return typeof e1(e) == "number" ? e.pop() : t;
}
var Xf = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function t1(e) {
  return Tt(e == null ? void 0 : e.then);
}
function n1(e) {
  return Tt(e[Zf]);
}
function r1(e) {
  return Symbol.asyncIterator && Tt(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function o1(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function h4() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var i1 = h4();
function a1(e) {
  return Tt(e == null ? void 0 : e[i1]);
}
function s1(e) {
  return IE(this, arguments, function() {
    var n, r, o, i;
    return ye(this, function(a) {
      switch (a.label) {
        case 0:
          n = e.getReader(), a.label = 1;
        case 1:
          a.trys.push([1, , 9, 10]), a.label = 2;
        case 2:
          return [4, yi(n.read())];
        case 3:
          return r = a.sent(), o = r.value, i = r.done, i ? [4, yi(void 0)] : [3, 5];
        case 4:
          return [2, a.sent()];
        case 5:
          return [4, yi(o)];
        case 6:
          return [4, a.sent()];
        case 7:
          return a.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function l1(e) {
  return Tt(e == null ? void 0 : e.getReader);
}
function yr(e) {
  if (e instanceof qn)
    return e;
  if (e != null) {
    if (n1(e))
      return p4(e);
    if (Xf(e))
      return v4(e);
    if (t1(e))
      return g4(e);
    if (r1(e))
      return c1(e);
    if (a1(e))
      return m4(e);
    if (l1(e))
      return y4(e);
  }
  throw o1(e);
}
function p4(e) {
  return new qn(function(t) {
    var n = e[Zf]();
    if (Tt(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function v4(e) {
  return new qn(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function g4(e) {
  return new qn(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, Qm);
  });
}
function m4(e) {
  return new qn(function(t) {
    var n, r;
    try {
      for (var o = Yt(e), i = o.next(); !i.done; i = o.next()) {
        var a = i.value;
        if (t.next(a), t.closed)
          return;
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        i && !i.done && (r = o.return) && r.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function c1(e) {
  return new qn(function(t) {
    b4(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function y4(e) {
  return c1(s1(e));
}
function b4(e, t) {
  var n, r, o, i;
  return we(this, void 0, void 0, function() {
    var a, s;
    return ye(this, function(l) {
      switch (l.label) {
        case 0:
          l.trys.push([0, 5, 6, 11]), n = kE(e), l.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = l.sent(), !!r.done)
            return [3, 4];
          if (a = r.value, t.next(a), t.closed)
            return [2];
          l.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return s = l.sent(), o = { error: s }, [3, 11];
        case 6:
          return l.trys.push([6, , 9, 10]), r && !r.done && (i = n.return) ? [4, i.call(n)] : [3, 8];
        case 7:
          l.sent(), l.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (o)
            throw o.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function ho(e, t, n, r, o) {
  r === void 0 && (r = 0), o === void 0 && (o = !1);
  var i = t.schedule(function() {
    n(), o ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(i), !o)
    return i;
}
function u1(e, t) {
  return t === void 0 && (t = 0), mr(function(n, r) {
    n.subscribe(Un(r, function(o) {
      return ho(r, e, function() {
        return r.next(o);
      }, t);
    }, function() {
      return ho(r, e, function() {
        return r.complete();
      }, t);
    }, function(o) {
      return ho(r, e, function() {
        return r.error(o);
      }, t);
    }));
  });
}
function d1(e, t) {
  return t === void 0 && (t = 0), mr(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function C4(e, t) {
  return yr(e).pipe(d1(t), u1(t));
}
function w4(e, t) {
  return yr(e).pipe(d1(t), u1(t));
}
function E4(e, t) {
  return new qn(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function _4(e, t) {
  return new qn(function(n) {
    var r;
    return ho(n, t, function() {
      r = e[i1](), ho(n, t, function() {
        var o, i, a;
        try {
          o = r.next(), i = o.value, a = o.done;
        } catch (s) {
          n.error(s);
          return;
        }
        a ? n.complete() : n.next(i);
      }, 0, !0);
    }), function() {
      return Tt(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function f1(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new qn(function(n) {
    ho(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      ho(n, t, function() {
        r.next().then(function(o) {
          o.done ? n.complete() : n.next(o.value);
        });
      }, 0, !0);
    });
  });
}
function x4(e, t) {
  return f1(s1(e), t);
}
function S4(e, t) {
  if (e != null) {
    if (n1(e))
      return C4(e, t);
    if (Xf(e))
      return E4(e, t);
    if (t1(e))
      return w4(e, t);
    if (r1(e))
      return f1(e, t);
    if (a1(e))
      return _4(e, t);
    if (l1(e))
      return x4(e, t);
  }
  throw o1(e);
}
function T4(e, t) {
  return t ? S4(e, t) : yr(e);
}
function h1(e) {
  return e instanceof Date && !isNaN(e);
}
var O4 = Gm(function(e) {
  return function(n) {
    n === void 0 && (n = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function P4(e, t) {
  var n = h1(e) ? { first: e } : typeof e == "number" ? { each: e } : e, r = n.first, o = n.each, i = n.with, a = i === void 0 ? R4 : i, s = n.scheduler, l = s === void 0 ? Zl : s, c = n.meta, u = c === void 0 ? null : c;
  if (r == null && o == null)
    throw new TypeError("No timeout provided.");
  return mr(function(d, f) {
    var h, p, g = null, v = 0, b = function(m) {
      p = ho(f, l, function() {
        try {
          h.unsubscribe(), yr(a({
            meta: u,
            lastValue: g,
            seen: v
          })).subscribe(f);
        } catch (w) {
          f.error(w);
        }
      }, m);
    };
    h = d.subscribe(Un(f, function(m) {
      p == null || p.unsubscribe(), v++, f.next(g = m), o > 0 && b(o);
    }, void 0, void 0, function() {
      p != null && p.closed || p == null || p.unsubscribe(), g = null;
    })), !v && b(r != null ? typeof r == "number" ? r : +r - l.now() : o);
  });
}
function R4(e) {
  throw new O4(e);
}
function Ar(e, t) {
  return mr(function(n, r) {
    var o = 0;
    n.subscribe(Un(r, function(i) {
      r.next(e.call(t, i, o++));
    }));
  });
}
var A4 = Array.isArray;
function I4(e, t) {
  return A4(t) ? e.apply(void 0, sn([], gt(t))) : e(t);
}
function k4(e) {
  return Ar(function(t) {
    return I4(e, t);
  });
}
function $4(e, t, n, r, o, i, a, s) {
  var l = [], c = 0, u = 0, d = !1, f = function() {
    d && !l.length && !c && t.complete();
  }, h = function(g) {
    return c < r ? p(g) : l.push(g);
  }, p = function(g) {
    c++;
    var v = !1;
    yr(n(g, u++)).subscribe(Un(t, function(b) {
      t.next(b);
    }, function() {
      v = !0;
    }, void 0, function() {
      if (v)
        try {
          c--;
          for (var b = function() {
            var m = l.shift();
            a || p(m);
          }; l.length && c < r; )
            b();
          f();
        } catch (m) {
          t.error(m);
        }
    }));
  };
  return e.subscribe(Un(t, h, function() {
    d = !0, f();
  })), function() {
  };
}
function Ql(e, t, n) {
  return n === void 0 && (n = 1 / 0), Tt(t) ? Ql(function(r, o) {
    return Ar(function(i, a) {
      return t(r, i, o, a);
    })(yr(e(r, o)));
  }, n) : (typeof t == "number" && (n = t), mr(function(r, o) {
    return $4(r, o, e, n);
  }));
}
function N4(e) {
  return e === void 0 && (e = 1 / 0), Ql(Xm, e);
}
var F4 = ["addListener", "removeListener"], L4 = ["addEventListener", "removeEventListener"], M4 = ["on", "off"];
function va(e, t, n, r) {
  if (Tt(n) && (r = n, n = void 0), r)
    return va(e, t, n).pipe(k4(r));
  var o = gt(B4(e) ? L4.map(function(s) {
    return function(l) {
      return e[s](t, l, n);
    };
  }) : D4(e) ? F4.map(Hp(e, t)) : j4(e) ? M4.map(Hp(e, t)) : [], 2), i = o[0], a = o[1];
  if (!i && Xf(e))
    return Ql(function(s) {
      return va(s, t, n);
    })(yr(e));
  if (!i)
    throw new TypeError("Invalid event target");
  return new qn(function(s) {
    var l = function() {
      for (var c = [], u = 0; u < arguments.length; u++)
        c[u] = arguments[u];
      return s.next(1 < c.length ? c : c[0]);
    };
    return i(l), function() {
      return a(l);
    };
  });
}
function Hp(e, t) {
  return function(n) {
    return function(r) {
      return e[n](t, r);
    };
  };
}
function D4(e) {
  return Tt(e.addListener) && Tt(e.removeListener);
}
function j4(e) {
  return Tt(e.on) && Tt(e.off);
}
function B4(e) {
  return Tt(e.addEventListener) && Tt(e.removeEventListener);
}
function V4(e, t, n) {
  n === void 0 && (n = u4);
  var r = -1;
  return t != null && (Jm(t) ? n = t : r = t), new qn(function(o) {
    var i = h1(e) ? +e - n.now() : e;
    i < 0 && (i = 0);
    var a = 0;
    return n.schedule(function() {
      o.closed || (o.next(a++), 0 <= r ? this.schedule(void 0, r) : o.complete());
    }, i);
  });
}
function p1() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = d4(e), r = f4(e, 1 / 0), o = e;
  return o.length ? o.length === 1 ? yr(o[0]) : N4(r)(T4(o, n)) : Qf;
}
function po(e, t) {
  return mr(function(n, r) {
    var o = 0;
    n.subscribe(Un(r, function(i) {
      return e.call(t, i, o++) && r.next(i);
    }));
  });
}
function U4(e) {
  return mr(function(t, n) {
    var r = [];
    return t.subscribe(Un(n, function(o) {
      return r.push(o);
    }, function() {
      n.next(r), n.complete();
    })), yr(e).subscribe(Un(n, function() {
      var o = r;
      r = [], n.next(o);
    }, wd)), function() {
      r = null;
    };
  });
}
function H4(e, t) {
  return t === void 0 && (t = Zl), mr(function(n, r) {
    var o = null, i = null, a = null, s = function() {
      if (o) {
        o.unsubscribe(), o = null;
        var c = i;
        i = null, r.next(c);
      }
    };
    function l() {
      var c = a + e, u = t.now();
      if (u < c) {
        o = this.schedule(void 0, c - u), r.add(o);
        return;
      }
      s();
    }
    n.subscribe(Un(r, function(c) {
      i = c, a = t.now(), o || (o = t.schedule(l, e), r.add(o));
    }, function() {
      s(), r.complete();
    }, void 0, function() {
      i = o = null;
    }));
  });
}
function v1(e) {
  return e <= 0 ? function() {
    return Qf;
  } : mr(function(t, n) {
    var r = 0;
    t.subscribe(Un(n, function(o) {
      ++r <= e && (n.next(o), e <= r && n.complete());
    }));
  });
}
function z4(e) {
  return Ar(function() {
    return e;
  });
}
function q4(e, t) {
  return Ql(function(n, r) {
    return yr(e(n, r)).pipe(v1(1), z4(n));
  });
}
function W4(e, t) {
  t === void 0 && (t = Zl);
  var n = V4(e, t);
  return q4(function() {
    return n;
  });
}
function G4() {
  return mr(function(e, t) {
    var n, r = !1;
    e.subscribe(Un(t, function(o) {
      var i = n;
      n = o, r && t.next([i, o]), r = !0;
    }));
  });
}
function K4(e, t) {
  return mr(function(n, r) {
    var o = null, i = 0, a = !1, s = function() {
      return a && !o && r.complete();
    };
    n.subscribe(Un(r, function(l) {
      o == null || o.unsubscribe();
      var c = 0, u = i++;
      yr(e(l, u)).subscribe(o = Un(r, function(d) {
        return r.next(t ? t(l, d, u, c++) : d);
      }, function() {
        o = null, s();
      }));
    }, function() {
      a = !0, s();
    }));
  });
}
var kr, Jf;
function Y4(e, t) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    throw new Error("Can't generate CSS selector for non-element node type.");
  if (e.tagName.toLowerCase() === "html")
    return "html";
  var n = {
    root: document.body,
    idName: function(i) {
      return !0;
    },
    className: function(i) {
      return !0;
    },
    tagName: function(i) {
      return !0;
    },
    attr: function(i, a) {
      return !1;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1e3,
    maxNumberOfTries: 1e4
  };
  kr = Ae(Ae({}, n), t), Jf = Z4(kr.root, n);
  var r = vs(e, "all", function() {
    return vs(e, "two", function() {
      return vs(e, "one", function() {
        return vs(e, "none");
      });
    });
  });
  if (r) {
    var o = y1(b1(r, e));
    return o.length > 0 && (r = o[0]), Xl(r);
  } else
    throw new Error("Selector was not found.");
}
function Z4(e, t) {
  return e.nodeType === Node.DOCUMENT_NODE ? e : e === t.root ? e.ownerDocument : e;
}
function vs(e, t, n) {
  for (var r = null, o = [], i = e, a = 0, s = function() {
    var c, u, d = ms(Q4(i)) || ms.apply(void 0, sn([], gt(X4(i)), !1)) || ms.apply(void 0, sn([], gt(J4(i)), !1)) || ms(ex(i)) || [Wp()], f = tx(i);
    if (t == "all")
      f && (d = d.concat(d.filter(au).map(function(b) {
        return gs(b, f);
      })));
    else if (t == "two")
      d = d.slice(0, 1), f && (d = d.concat(d.filter(au).map(function(b) {
        return gs(b, f);
      })));
    else if (t == "one") {
      var h = gt(d = d.slice(0, 1), 1), p = h[0];
      f && au(p) && (d = [gs(p, f)]);
    } else
      t == "none" && (d = [Wp()], f && (d = [gs(d[0], f)]));
    try {
      for (var g = (c = void 0, Yt(d)), v = g.next(); !v.done; v = g.next()) {
        var p = v.value;
        p.level = a;
      }
    } catch (b) {
      c = { error: b };
    } finally {
      try {
        v && !v.done && (u = g.return) && u.call(g);
      } finally {
        if (c)
          throw c.error;
      }
    }
    if (o.push(d), o.length >= kr.seedMinLength && (r = zp(o, n), r))
      return "break";
    i = i.parentElement, a++;
  }; i; ) {
    var l = s();
    if (l === "break")
      break;
  }
  return r || (r = zp(o, n)), !r && n ? n() : r;
}
function zp(e, t) {
  var n, r, o = e.reduce(function(c, u) {
    return c * u.length;
  }, 1);
  if (o > kr.threshold)
    return t ? t() : null;
  var i = y1(m1(e));
  try {
    for (var a = Yt(i), s = a.next(); !s.done; s = a.next()) {
      var l = s.value;
      if (g1(l))
        return l;
    }
  } catch (c) {
    n = { error: c };
  } finally {
    try {
      s && !s.done && (r = a.return) && r.call(a);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return null;
}
function Xl(e) {
  for (var t = e[0], n = t.name, r = 1; r < e.length; r++) {
    var o = e[r].level || 0;
    t.level === o - 1 ? n = "".concat(e[r].name, " > ").concat(n) : n = "".concat(e[r].name, " ").concat(n), t = e[r];
  }
  return n;
}
function qp(e) {
  return e.map(function(t) {
    return t.penalty;
  }).reduce(function(t, n) {
    return t + n;
  }, 0);
}
function g1(e) {
  var t = Xl(e);
  switch (Jf.querySelectorAll(t).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(t));
    case 1:
      return !0;
    default:
      return !1;
  }
}
function Q4(e) {
  var t = e.getAttribute("id");
  return t && kr.idName(t) ? {
    name: "#" + CSS.escape(t),
    penalty: 0
  } : null;
}
function X4(e) {
  var t = Array.from(e.attributes).filter(function(n) {
    return kr.attr(n.name, n.value);
  });
  return t.map(function(n) {
    return {
      name: "[".concat(CSS.escape(n.name), '="').concat(CSS.escape(n.value), '"]'),
      penalty: 0.5
    };
  });
}
function J4(e) {
  var t = Array.from(e.classList).filter(kr.className);
  return t.map(function(n) {
    return {
      name: "." + CSS.escape(n),
      penalty: 1
    };
  });
}
function ex(e) {
  var t = e.tagName.toLowerCase();
  return kr.tagName(t) ? {
    name: t,
    penalty: 2
  } : null;
}
function Wp() {
  return {
    name: "*",
    penalty: 3
  };
}
function tx(e) {
  var t = e.parentNode;
  if (!t)
    return null;
  var n = t.firstChild;
  if (!n)
    return null;
  for (var r = 0; n && (n.nodeType === Node.ELEMENT_NODE && r++, n !== e); )
    n = n.nextSibling;
  return r;
}
function gs(e, t) {
  return {
    name: e.name + ":nth-child(".concat(t, ")"),
    penalty: e.penalty + 1
  };
}
function au(e) {
  return e.name !== "html" && !e.name.startsWith("#");
}
function ms() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = e.filter(nx);
  return n.length > 0 ? n : null;
}
function nx(e) {
  return e != null;
}
function m1(e, t) {
  var n, r, o, i, a, s;
  return t === void 0 && (t = []), ye(this, function(l) {
    switch (l.label) {
      case 0:
        if (!(e.length > 0))
          return [3, 9];
        l.label = 1;
      case 1:
        l.trys.push([1, 6, 7, 8]), n = Yt(e[0]), r = n.next(), l.label = 2;
      case 2:
        return r.done ? [3, 5] : (o = r.value, [5, Yt(m1(e.slice(1, e.length), t.concat(o)))]);
      case 3:
        l.sent(), l.label = 4;
      case 4:
        return r = n.next(), [3, 2];
      case 5:
        return [3, 8];
      case 6:
        return i = l.sent(), a = { error: i }, [3, 8];
      case 7:
        try {
          r && !r.done && (s = n.return) && s.call(n);
        } finally {
          if (a)
            throw a.error;
        }
        return [
          7
          /*endfinally*/
        ];
      case 8:
        return [3, 11];
      case 9:
        return [4, t];
      case 10:
        l.sent(), l.label = 11;
      case 11:
        return [
          2
          /*return*/
        ];
    }
  });
}
function y1(e) {
  return sn([], gt(e), !1).sort(function(t, n) {
    return qp(t) - qp(n);
  });
}
function b1(e, t, n) {
  var r, o, i;
  return n === void 0 && (n = {
    counter: 0,
    visited: /* @__PURE__ */ new Map()
  }), ye(this, function(a) {
    switch (a.label) {
      case 0:
        if (!(e.length > 2 && e.length > kr.optimizedMinLength))
          return [3, 5];
        r = 1, a.label = 1;
      case 1:
        return r < e.length - 1 ? n.counter > kr.maxNumberOfTries ? [
          2
          /*return*/
        ] : (n.counter += 1, o = sn([], gt(e), !1), o.splice(r, 1), i = Xl(o), n.visited.has(i) ? [
          2
          /*return*/
        ] : g1(o) && rx(o, t) ? [4, o] : [3, 4]) : [3, 5];
      case 2:
        return a.sent(), n.visited.set(i, !0), [5, Yt(b1(o, t, n))];
      case 3:
        a.sent(), a.label = 4;
      case 4:
        return r++, [3, 1];
      case 5:
        return [
          2
          /*return*/
        ];
    }
  });
}
function rx(e, t) {
  return Jf.querySelector(Xl(e)) === t;
}
var ox = ["input", "select", "textarea"], su = function(e, t) {
  return function(n, r) {
    var o, i, a, s = e.pageUrlAllowlist, l = e.shouldTrackEventResolver, c = (i = (o = r == null ? void 0 : r.tagName) === null || o === void 0 ? void 0 : o.toLowerCase) === null || i === void 0 ? void 0 : i.call(o);
    if (!c)
      return !1;
    if (l)
      return l(n, r);
    if (!ax(window.location.href, s))
      return !1;
    var u = String(r == null ? void 0 : r.getAttribute("type")) || "";
    if (typeof u == "string")
      switch (u.toLowerCase()) {
        case "hidden":
          return !1;
        case "password":
          return !1;
      }
    if (t) {
      var d = t.some(function(h) {
        var p;
        return !!(!((p = r == null ? void 0 : r.matches) === null || p === void 0) && p.call(r, h));
      });
      if (!d)
        return !1;
    }
    switch (c) {
      case "input":
      case "select":
      case "textarea":
        return n === "change" || n === "click";
      default: {
        var f = (a = window == null ? void 0 : window.getComputedStyle) === null || a === void 0 ? void 0 : a.call(window, r);
        return f && f.getPropertyValue("cursor") === "pointer" && n === "click" ? !0 : n === "click";
      }
    }
  };
}, C1 = function(e) {
  if (e == null)
    return !1;
  if (typeof e == "string") {
    var t = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (t.test((e || "").replace(/[- ]/g, "")))
      return !1;
    var n = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (n.test(e))
      return !1;
  }
  return !0;
}, ix = function(e) {
  return !!e && e.nodeType === 3;
}, w1 = function(e) {
  var t, n, r, o = (n = (t = e == null ? void 0 : e.tagName) === null || t === void 0 ? void 0 : t.toLowerCase) === null || n === void 0 ? void 0 : n.call(t), i = e instanceof HTMLElement ? ((r = e.getAttribute("contenteditable")) === null || r === void 0 ? void 0 : r.toLowerCase()) === "true" : !1;
  return !ox.includes(o) && !i;
}, eh = function(e) {
  var t = "";
  return w1(e) && e.childNodes && e.childNodes.length && e.childNodes.forEach(function(n) {
    var r = "";
    ix(n) ? n.textContent && (r = n.textContent) : r = eh(n), t += r.split(/(\s+)/).filter(C1).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
  }), t;
}, E1 = function(e, t) {
  var n, r, o = "";
  try {
    return o = Y4(e, {
      className: function(u) {
        return u !== bd;
      },
      maxNumberOfTries: 1e3
    }), o;
  } catch (u) {
    if (t) {
      var i = u;
      t.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(i.toString()));
    }
  }
  var a = (r = (n = e == null ? void 0 : e.tagName) === null || n === void 0 ? void 0 : n.toLowerCase) === null || r === void 0 ? void 0 : r.call(n);
  a && (o = a);
  var s = e.getAttribute("id"), l = e.getAttribute("class");
  if (s)
    o = "#".concat(s);
  else if (l) {
    var c = l.split(" ").filter(function(u) {
      return u !== bd;
    }).join(".");
    c && (o = "".concat(o, ".").concat(c));
  }
  return o;
}, ax = function(e, t) {
  return !t || !t.length ? !0 : t.some(function(n) {
    return typeof n == "string" ? e === n : e.match(n);
  });
}, sx = function(e, t) {
  return e.getAttributeNames().reduce(function(n, r) {
    if (r.startsWith(t)) {
      var o = r.replace(t, ""), i = e.getAttribute(r);
      o && (n[o] = i || "");
    }
    return n;
  }, {});
}, lx = function(e) {
  return e == null || typeof e == "object" && Object.keys(e).length === 0 || typeof e == "string" && e.trim().length === 0;
}, _1 = function(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    return lx(r) || (t[n] = r), t;
  }, {});
}, x1 = function(e) {
  var t = e.parentElement;
  if (!t)
    return "";
  var n;
  try {
    n = t.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
  } catch {
    n = null;
  }
  if (n) {
    var r = n.textContent || "";
    return C1(r) ? r : "";
  }
  return x1(t);
}, th = function(e, t) {
  return e ? t.some(function(n) {
    var r;
    return (r = e == null ? void 0 : e.matches) === null || r === void 0 ? void 0 : r.call(e, n);
  }) ? e : th(e == null ? void 0 : e.parentElement, t) : null;
}, cx = function(e, t) {
  var n, r, o;
  if (!e)
    return {};
  var i = (o = (r = e == null ? void 0 : e.tagName) === null || r === void 0 ? void 0 : r.toLowerCase) === null || o === void 0 ? void 0 : o.call(r), a = E1(e, t), s = (n = {}, n[Hm] = i, n[zm] = eh(e), n[qm] = a, n[Wm] = window.location.href.split("?")[0], n);
  return _1(s);
}, ux = function(e) {
  return new Promise(function(t, n) {
    var r;
    try {
      var o = document.createElement("script");
      o.type = "text/javascript", o.async = !0, o.src = e, o.addEventListener("load", function() {
        t({ status: !0 });
      }, { once: !0 }), o.addEventListener("error", function() {
        n({
          status: !1,
          message: "Failed to load the script ".concat(e)
        });
      }), (r = document.head) === null || r === void 0 || r.appendChild(o);
    } catch (i) {
      n(i);
    }
  });
};
function dx() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var nh = function(e) {
  return !(e.event.target === null || !e.closestTrackedAncestor);
}, fx = (
  /** @class */
  function() {
    function e(t) {
      var n = t === void 0 ? {} : t, r = n.origin, o = r === void 0 ? Gs : r, i = this;
      this.endpoint = Gs, this.requestCallbacks = {}, this.onSelect = function(a) {
        i.notify({ action: "element-selected", data: a });
      }, this.onTrack = function(a, s) {
        a === "selector-mode-changed" ? i.notify({ action: "track-selector-mode-changed", data: s }) : a === "selector-moved" && i.notify({ action: "track-selector-moved", data: s });
      }, this.endpoint = o;
    }
    return e.prototype.notify = function(t) {
      var n, r, o, i;
      (r = (n = this.logger) === null || n === void 0 ? void 0 : n.debug) === null || r === void 0 || r.call(n, "Message sent: ", JSON.stringify(t)), (i = (o = window.opener) === null || o === void 0 ? void 0 : o.postMessage) === null || i === void 0 || i.call(o, t, this.endpoint);
    }, e.prototype.sendRequest = function(t, n, r) {
      var o = this;
      r === void 0 && (r = { timeout: 15e3 });
      var i = dx(), a = {
        id: i,
        action: t,
        args: n
      }, s = new Promise(function(l, c) {
        o.requestCallbacks[i] = { resolve: l, reject: c }, o.notify(a), (r == null ? void 0 : r.timeout) > 0 && setTimeout(function() {
          c(new Error("".concat(t, " timed out (id: ").concat(i, ")"))), delete o.requestCallbacks[i];
        }, r.timeout);
      });
      return s;
    }, e.prototype.handleResponse = function(t) {
      var n;
      if (!this.requestCallbacks[t.id]) {
        (n = this.logger) === null || n === void 0 || n.warn("No callback found for request id: ".concat(t.id));
        return;
      }
      this.requestCallbacks[t.id].resolve(t.responseData), delete this.requestCallbacks[t.id];
    }, e.prototype.setup = function(t) {
      var n = this, r = t === void 0 ? {} : t, o = r.logger, i = r.endpoint, a = r.isElementSelectable, s = r.cssSelectorAllowlist, l = r.actionClickAllowlist;
      this.logger = o, i && this.endpoint === Gs && (this.endpoint = i);
      var c = null;
      window.addEventListener("message", function(u) {
        var d, f, h, p, g;
        if ((f = (d = n.logger) === null || d === void 0 ? void 0 : d.debug) === null || f === void 0 || f.call(d, "Message received: ", JSON.stringify(u)), n.endpoint === u.origin) {
          var v = u == null ? void 0 : u.data, b = v == null ? void 0 : v.action;
          if (b)
            if ("id" in v)
              (p = (h = n.logger) === null || h === void 0 ? void 0 : h.debug) === null || p === void 0 || p.call(h, "Received Response to previous request: ", JSON.stringify(u)), n.handleResponse(v);
            else if (b === "ping")
              n.notify({ action: "pong" });
            else if (b === "initialize-visual-tagging-selector") {
              var m = v == null ? void 0 : v.data;
              ux(Y6).then(function() {
                var w;
                c = (w = window == null ? void 0 : window.amplitudeVisualTaggingSelector) === null || w === void 0 ? void 0 : w.call(window, {
                  getEventTagProps: cx,
                  isElementSelectable: function(E) {
                    return a ? a((m == null ? void 0 : m.actionType) || "click", E) : !0;
                  },
                  onTrack: n.onTrack,
                  onSelect: n.onSelect,
                  visualHighlightClass: bd,
                  messenger: n,
                  cssSelectorAllowlist: s,
                  actionClickAllowlist: l
                }), n.notify({ action: "selector-loaded" });
              }).catch(function() {
                var w;
                (w = n.logger) === null || w === void 0 || w.warn("Failed to initialize visual tagging selector");
              });
            } else
              b === "close-visual-tagging-selector" && ((g = c == null ? void 0 : c.close) === null || g === void 0 || g.call(c));
        }
      }), this.notify({ action: "page-loaded" });
    }, e;
  }()
), hx = [
  // Already captured elsewhere in the hierarchy object
  "id",
  "class",
  // non-useful and potentially large attribute
  "style",
  // sensitive as prefilled form data may populate this attribute
  "value",
  // DOM events
  "onclick",
  "onchange",
  "oninput",
  "onblur",
  "onsubmit",
  "onfocus",
  "onkeydown",
  "onkeyup",
  "onkeypress",
  // React specific
  "data-reactid",
  "data-react-checksum",
  "data-reactroot"
], px = ["type"], vx = ["svg", "path", "g"], gx = ["password", "hidden"], mx = 128, yx = 1024;
function bx(e) {
  var t, n, r, o, i, a;
  if (e === null)
    return null;
  var s = String(e.tagName).toLowerCase(), l = {
    tag: s
  }, c = Array.from((o = (r = e.parentElement) === null || r === void 0 ? void 0 : r.children) !== null && o !== void 0 ? o : []);
  c.length && (l.index = c.indexOf(e), l.indexOfType = c.filter(function(E) {
    return E.tagName === e.tagName;
  }).indexOf(e));
  var u = (a = (i = e.previousElementSibling) === null || i === void 0 ? void 0 : i.tagName) === null || a === void 0 ? void 0 : a.toLowerCase();
  u && (l.prevSib = String(u));
  var d = e.getAttribute("id");
  d && (l.id = String(d));
  var f = Array.from(e.classList);
  f.length && (l.classes = f);
  var h = {}, p = Array.from(e.attributes), g = p.filter(function(E) {
    return !hx.includes(E.name);
  }), v = !w1(e);
  if (!gx.includes(String(e.getAttribute("type"))) && !vx.includes(s))
    try {
      for (var b = Yt(g), m = b.next(); !m.done; m = b.next()) {
        var w = m.value;
        v && !px.includes(w.name) || (h[w.name] = String(w.value).substring(0, mx));
      }
    } catch (E) {
      t = { error: E };
    } finally {
      try {
        m && !m.done && (n = b.return) && n.call(b);
      } finally {
        if (t)
          throw t.error;
      }
    }
  return Object.keys(h).length && (l.attrs = h), l;
}
function Cx(e) {
  var t = [];
  if (!e)
    return t;
  t.push(e);
  for (var n = e.parentElement; n && n.tagName !== "HTML"; )
    t.push(n), n = n.parentElement;
  return t;
}
var wx = function(e) {
  var t = [];
  if (!e)
    return [];
  var n = Cx(e);
  return t = Ex(n.map(function(r) {
    return bx(r);
  }), yx), t;
};
function Ex(e, t) {
  for (var n = 0, r = 0; r < e.length; r++) {
    var o = e[r];
    if (o === null)
      n += 4;
    else {
      var i = Ks(o);
      n += i ? Array.from(i).length : 4;
    }
    if (n > t)
      return e.slice(0, r);
  }
  return e;
}
function Ks(e, t) {
  t === void 0 && (t = !1);
  try {
    if (e == null)
      return t ? "None" : null;
    if (typeof e == "string")
      return t ? (e = e.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r"), e.includes('"') ? "'".concat(e, "'") : e.includes("'") ? '"'.concat(e.replace(/'/g, "\\'"), '"') : "'".concat(e, "'")) : e;
    if (typeof e == "boolean")
      return e ? "True" : "False";
    if (Array.isArray(e)) {
      var n = e.map(function(i) {
        return Ks(i, !0);
      });
      return "[".concat(n.join(", "), "]");
    } else if (typeof e == "object") {
      var r = Object.entries(e).filter(function(i) {
        var a = gt(i, 1), s = a[0];
        return s != null;
      }).map(function(i) {
        var a = gt(i, 2), s = a[0], l = a[1];
        return "".concat(String(Ks(s, !0)), ": ").concat(String(Ks(l, !0)));
      }), o = "{".concat(r.join(", "), "}");
      return o.includes("\\'") && (o = o.replace(/'/g, "'").replace(/'/g, "\\'")), o;
    }
    return e.toString();
  } catch {
    return null;
  }
}
var _x = 5;
function xx(e) {
  var t = e.amplitude, n = e.allObservables, r = e.options, o = e.shouldTrackEvent, i = n.clickObservable, a = i.pipe(G4(), po(function(u) {
    var d = gt(u, 2), f = d[0], h = d[1], p = f.event.target !== h.event.target, g = Math.abs(h.event.screenX - f.event.screenX) <= 20 && Math.abs(h.event.screenY - f.event.screenY) <= 20;
    return p && !g;
  })), s = i.pipe(H4(r.debounceTime), Ar(function() {
    return "timeout";
  })), l = p1(a, s), c = i.pipe(W4(0), po(nh), po(function(u) {
    return o("click", u.closestTrackedAncestor);
  }), U4(l));
  return c.subscribe(function(u) {
    var d, f, h = (u.length >= _x, yd);
    try {
      for (var p = Yt(u), g = p.next(); !g.done; g = p.next()) {
        var v = g.value;
        t == null || t.track(h, v.targetElementProperties, {
          time: v.timestamp
        });
      }
    } catch (b) {
      d = { error: b };
    } finally {
      try {
        g && !g.done && (f = p.return) && f.call(p);
      } finally {
        if (d)
          throw d.error;
      }
    }
  });
}
function Sx(e) {
  var t = e.amplitude, n = e.allObservables, r = e.getEventProperties, o = e.shouldTrackEvent, i = n.changeObservable, a = i.pipe(po(nh), po(function(s) {
    return o("change", s.closestTrackedAncestor);
  }));
  return a.subscribe(function(s) {
    t == null || t.track($6, r("change", s.closestTrackedAncestor));
  });
}
function Tx(e) {
  var t = e.amplitude, n = e.allObservables, r = e.options, o = e.getEventProperties, i = e.shouldTrackEvent, a = e.shouldTrackActionClick, s = n.clickObservable, l = n.mutationObservable, c = n.navigateObservable, u = s.pipe(po(function(p) {
    return !i("click", p.closestTrackedAncestor);
  }), Ar(function(p) {
    var g = th(p.event.target, r.actionClickAllowlist);
    return p.closestTrackedAncestor = g, p.closestTrackedAncestor !== null && (p.targetElementProperties = o(p.type, p.closestTrackedAncestor)), p;
  }), po(nh), po(function(p) {
    return a("click", p.closestTrackedAncestor);
  })), d = [l];
  c && d.push(c);
  var f = p1.apply(void 0, sn([], gt(d), !1)), h = u.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    K4(function(p) {
      return f.pipe(
        v1(1),
        P4({ first: 500, with: function() {
          return Qf;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        Ar(function() {
          return p;
        })
      );
    })
  );
  return h.subscribe(function(p) {
    t == null || t.track(yd, o("click", p.closestTrackedAncestor), {
      time: p.timestamp
    });
  });
}
var fi;
(function(e) {
  e.ClickObservable = "clickObservable", e.ChangeObservable = "changeObservable", e.NavigateObservable = "navigateObservable", e.MutationObservable = "mutationObservable";
})(fi || (fi = {}));
function Ox(e) {
  return e.type === "click" || e.type === "change";
}
var Px = function(e) {
  var t, n, r;
  e === void 0 && (e = {});
  var o = e.dataAttributePrefix, i = o === void 0 ? UE : o, a = e.visualTaggingOptions, s = a === void 0 ? {
    enabled: !0,
    messenger: new fx()
  } : a;
  e.cssSelectorAllowlist = (t = e.cssSelectorAllowlist) !== null && t !== void 0 ? t : VE, e.actionClickAllowlist = (n = e.actionClickAllowlist) !== null && n !== void 0 ? n : HE, e.debounceTime = (r = e.debounceTime) !== null && r !== void 0 ? r : 0;
  var l = k6, c = "enrichment", u = [], d = void 0, f = function() {
    var m, w = va(document, "click", { capture: !0 }).pipe(Ar(function(_) {
      return p(_, "click");
    })), E = va(document, "change", { capture: !0 }).pipe(Ar(function(_) {
      return p(_, "change");
    })), C;
    window.navigation && (C = va(window.navigation, "navigate").pipe(Ar(function(_) {
      return p(_, "navigate");
    })));
    var x = new qn(function(_) {
      var T = new MutationObserver(function(O) {
        _.next(O);
      });
      return T.observe(document.body, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
      }), function() {
        return T.disconnect();
      };
    }).pipe(Ar(function(_) {
      return p(_, "mutation");
    }));
    return m = {}, m[fi.ClickObservable] = w, m[fi.ChangeObservable] = E, // [ObservablesEnum.ErrorObservable]: errorObservable,
    m[fi.NavigateObservable] = C, m[fi.MutationObservable] = x, m;
  }, h = function(m, w) {
    var E, C, x, _ = (x = (C = w == null ? void 0 : w.tagName) === null || C === void 0 ? void 0 : C.toLowerCase) === null || x === void 0 ? void 0 : x.call(C), T = typeof w.getBoundingClientRect == "function" ? w.getBoundingClientRect() : { left: null, top: null }, O = w.getAttribute("aria-label"), I = sx(w, i), L = x1(w), B = E1(w, d), j = (E = {}, E[N6] = w.getAttribute("id") || "", E[F6] = w.getAttribute("class"), E[L6] = wx(w), E[Hm] = _, E[zm] = eh(w), E[D6] = T.left == null ? null : Math.round(T.left), E[j6] = T.top == null ? null : Math.round(T.top), E[B6] = O, E[V6] = I, E[qm] = B, E[U6] = L, E[Wm] = window.location.href.split("?")[0], E[H6] = typeof document < "u" && document.title || "", E[z6] = window.innerHeight, E[q6] = window.innerWidth, E);
    return _ === "a" && m === "click" && w instanceof HTMLAnchorElement && (j[M6] = w.href), _1(j);
  }, p = function(m, w) {
    var E = {
      event: m,
      timestamp: Date.now(),
      type: w
    };
    if (Ox(E) && E.event.target !== null) {
      var C = th(E.event.target, e.cssSelectorAllowlist);
      return C && (E.closestTrackedAncestor = C, E.targetElementProperties = h(E.type, C)), E;
    }
    return E;
  }, g = function(m, w) {
    return we(void 0, void 0, void 0, function() {
      var E, C, x, _, T, O, I, L, B, j;
      return ye(this, function(M) {
        return d = m.loggerProvider, typeof document > "u" ? [
          2
          /*return*/
        ] : (E = su(e, e.cssSelectorAllowlist), C = su(e, e.actionClickAllowlist), x = f(), _ = xx({
          allObservables: x,
          options: e,
          amplitude: w,
          shouldTrackEvent: E
        }), u.push(_), T = Sx({
          allObservables: x,
          getEventProperties: h,
          amplitude: w,
          shouldTrackEvent: E
        }), u.push(T), O = Tx({
          allObservables: x,
          options: e,
          getEventProperties: h,
          amplitude: w,
          shouldTrackEvent: E,
          shouldTrackActionClick: C
        }), u.push(O), (B = m == null ? void 0 : m.loggerProvider) === null || B === void 0 || B.log("".concat(l, " has been successfully added.")), window.opener && s.enabled && (I = e.cssSelectorAllowlist, L = e.actionClickAllowlist, (j = s.messenger) === null || j === void 0 || j.setup(Ae(Ae({ logger: m == null ? void 0 : m.loggerProvider }, (m == null ? void 0 : m.serverZone) && { endpoint: K6[m.serverZone] }), { isElementSelectable: su(e, sn(sn([], gt(I), !1), gt(L), !1)), cssSelectorAllowlist: I, actionClickAllowlist: L }))), [
          2
          /*return*/
        ]);
      });
    });
  }, v = function(m) {
    return we(void 0, void 0, void 0, function() {
      return ye(this, function(w) {
        return [2, m];
      });
    });
  }, b = function() {
    return we(void 0, void 0, void 0, function() {
      var m, w, E, C, x;
      return ye(this, function(_) {
        try {
          for (m = Yt(u), w = m.next(); !w.done; w = m.next())
            E = w.value, E.unsubscribe();
        } catch (T) {
          C = { error: T };
        } finally {
          try {
            w && !w.done && (x = m.return) && x.call(m);
          } finally {
            if (C)
              throw C.error;
          }
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: l,
    type: c,
    setup: g,
    execute: v,
    teardown: b
  };
}, Rx = (
  /** @class */
  function(e) {
    zn(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.init = function(n, r, o) {
      n === void 0 && (n = "");
      var i, a;
      return arguments.length > 2 ? (i = r, a = o) : typeof r == "string" ? (i = r, a = void 0) : (i = r == null ? void 0 : r.userId, a = r), Pn(this._init(Ae(Ae({}, a), { userId: i, apiKey: n })));
    }, t.prototype._init = function(n) {
      var r, o, i;
      return we(this, void 0, void 0, function() {
        var a, s, l, c, u, d, f = this;
        return ye(this, function(h) {
          switch (h.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, s6(n.apiKey, n, this)]);
            case 1:
              return a = h.sent(), n.fetchRemoteConfig ? [4, I6(a)] : [3, 4];
            case 2:
              return s = h.sent(), [4, s.generateJoinedConfig()];
            case 3:
              a = h.sent(), h.label = 4;
            case 4:
              return [4, e.prototype._init.call(this, a)];
            case 5:
              return h.sent(), this.logBrowserOptions(a), Mm(this.config.defaultTracking) ? (l = U_(this.config), this.webAttribution = new E_(l, this.config), [4, this.webAttribution.init()]) : [3, 7];
            case 6:
              h.sent(), h.label = 7;
            case 7:
              return c = yl(), u = Number.isNaN(Number(c.ampSessionId)) ? void 0 : Number(c.ampSessionId), this.setSessionId((i = (o = (r = n.sessionId) !== null && r !== void 0 ? r : u) !== null && o !== void 0 ? o : this.config.sessionId) !== null && i !== void 0 ? i : Date.now()), d = wa(n.instanceName), d.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), this.config.offline === BE ? [3, 9] : [4, this.add(b6()).promise];
            case 8:
              h.sent(), h.label = 9;
            case 9:
              return [4, this.add(new a_()).promise];
            case 10:
              return h.sent(), [4, this.add(new W_()).promise];
            case 11:
              return h.sent(), [4, this.add(new L_()).promise];
            case 12:
              return h.sent(), y6(this.config), D_(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding file download tracking plugin"), [4, this.add(m6()).promise]) : [3, 14];
            case 13:
              h.sent(), h.label = 14;
            case 14:
              return j_(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding form interaction plugin"), [4, this.add(g6()).promise]) : [3, 16];
            case 15:
              h.sent(), h.label = 16;
            case 16:
              return Dm(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding page view tracking plugin"), [4, this.add(f6(V_(this.config))).promise]) : [3, 18];
            case 17:
              h.sent(), h.label = 18;
            case 18:
              return jm(this.config.autocapture) ? (this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)"), [4, this.add(Px(B_(this.config))).promise]) : [3, 20];
            case 19:
              h.sent(), h.label = 20;
            case 20:
              return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 21:
              return h.sent(), d.eventBridge.setEventReceiver(function(p) {
                f.track(p.eventType, p.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getUserId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.userId;
    }, t.prototype.setUserId = function(n) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setUserId: ", n), (n !== this.config.userId || n === void 0) && (this.config.userId = n, N_(n, this.config.instanceName));
    }, t.prototype.getDeviceId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.deviceId;
    }, t.prototype.setDeviceId = function(n) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setDeviceId: ", n), this.config.deviceId = n, F_(n, this.config.instanceName);
    }, t.prototype.reset = function() {
      this.setDeviceId(Ui()), this.setUserId(void 0);
    }, t.prototype.getSessionId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.sessionId;
    }, t.prototype.setSessionId = function(n) {
      var r, o = [];
      if (!this.config)
        return this.q.push(this.setSessionId.bind(this, n)), Pn(Promise.resolve());
      if (n === this.config.sessionId)
        return Pn(Promise.resolve());
      this.config.loggerProvider.debug("function setSessionId: ", n);
      var i = this.getSessionId(), a = this.config.lastEventTime, s = (r = this.config.lastEventId) !== null && r !== void 0 ? r : -1;
      this.config.sessionId = n, this.config.lastEventTime = void 0, this.config.pageCounter = 0, Np(this.config.defaultTracking) && (i && a && o.push(this.track(Mp, void 0, {
        device_id: this.previousSessionDeviceId,
        event_id: ++s,
        session_id: i,
        time: a + 1,
        user_id: this.previousSessionUserId
      }).promise), this.config.lastEventTime = this.config.sessionId);
      var l = this.trackCampaignEventIfNeeded(++s, o);
      return Np(this.config.defaultTracking) && o.push(this.track(Lp, void 0, {
        event_id: l ? ++s : s,
        session_id: this.config.sessionId,
        time: this.config.lastEventTime
      }).promise), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId, Pn(Promise.all(o));
    }, t.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, t.prototype.setTransport = function(n) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, n));
        return;
      }
      this.config.transportProvider = Um(n);
    }, t.prototype.identify = function(n, r) {
      if (Jc(n)) {
        var o = n._q;
        n._q = [], n = Xc(new Ca(), o);
      }
      return r != null && r.user_id && this.setUserId(r.user_id), r != null && r.device_id && this.setDeviceId(r.device_id), e.prototype.identify.call(this, n, r);
    }, t.prototype.groupIdentify = function(n, r, o, i) {
      if (Jc(o)) {
        var a = o._q;
        o._q = [], o = Xc(new Ca(), a);
      }
      return e.prototype.groupIdentify.call(this, n, r, o, i);
    }, t.prototype.revenue = function(n, r) {
      if (Jc(n)) {
        var o = n._q;
        n._q = [], n = Xc(new t_(), o);
      }
      return e.prototype.revenue.call(this, n, r);
    }, t.prototype.trackCampaignEventIfNeeded = function(n, r) {
      if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign)
        return !1;
      var o = this.webAttribution.generateCampaignEvent(n);
      return r ? r.push(this.track(o).promise) : this.track(o), this.config.loggerProvider.log("Tracking attribution."), !0;
    }, t.prototype.process = function(n) {
      return we(this, void 0, void 0, function() {
        var r, o, i;
        return ye(this, function(a) {
          return r = Date.now(), o = Lm(this.config.sessionTimeout, this.config.lastEventTime), i = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign(), n.event_type !== Lp && n.event_type !== Mp && (!n.session_id || n.session_id === this.getSessionId()) && (o || i ? (this.setSessionId(r), i && this.config.loggerProvider.log("Created a new session for new campaign.")) : o || this.trackCampaignEventIfNeeded()), [2, e.prototype.process.call(this, n)];
        });
      });
    }, t.prototype.logBrowserOptions = function(n) {
      try {
        var r = Ae(Ae({}, n), { apiKey: n.apiKey.substring(0, 10) + "********" });
        this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(r));
      } catch (o) {
        this.config.loggerProvider.error("Error logging browser config", o);
      }
    }, t;
  }(e_)
), Ax = function() {
  var e = new Rx();
  return {
    init: qt(e.init.bind(e), "init", Ht(e), zt(e, ["config"])),
    add: qt(e.add.bind(e), "add", Ht(e), zt(e, ["config.apiKey", "timeline.plugins"])),
    remove: qt(e.remove.bind(e), "remove", Ht(e), zt(e, ["config.apiKey", "timeline.plugins"])),
    track: qt(e.track.bind(e), "track", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    logEvent: qt(e.logEvent.bind(e), "logEvent", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    identify: qt(e.identify.bind(e), "identify", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: qt(e.groupIdentify.bind(e), "groupIdentify", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    setGroup: qt(e.setGroup.bind(e), "setGroup", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    revenue: qt(e.revenue.bind(e), "revenue", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    flush: qt(e.flush.bind(e), "flush", Ht(e), zt(e, ["config.apiKey", "timeline.queue.length"])),
    getUserId: qt(e.getUserId.bind(e), "getUserId", Ht(e), zt(e, ["config", "config.userId"])),
    setUserId: qt(e.setUserId.bind(e), "setUserId", Ht(e), zt(e, ["config", "config.userId"])),
    getDeviceId: qt(e.getDeviceId.bind(e), "getDeviceId", Ht(e), zt(e, ["config", "config.deviceId"])),
    setDeviceId: qt(e.setDeviceId.bind(e), "setDeviceId", Ht(e), zt(e, ["config", "config.deviceId"])),
    reset: qt(e.reset.bind(e), "reset", Ht(e), zt(e, ["config", "config.userId", "config.deviceId"])),
    getSessionId: qt(e.getSessionId.bind(e), "getSessionId", Ht(e), zt(e, ["config"])),
    setSessionId: qt(e.setSessionId.bind(e), "setSessionId", Ht(e), zt(e, ["config"])),
    extendSession: qt(e.extendSession.bind(e), "extendSession", Ht(e), zt(e, ["config"])),
    setOptOut: qt(e.setOptOut.bind(e), "setOptOut", Ht(e), zt(e, ["config"])),
    setTransport: qt(e.setTransport.bind(e), "setTransport", Ht(e), zt(e, ["config"]))
  };
};
const Ma = Ax();
var Ix = Ma.add, kx = Ma.identify, $x = Ma.init, Nx = Ma.setUserId, Fx = Ma.track, Lx = function() {
  function e() {
  }
  return e.prototype.getApplicationContext = function() {
    return { versionName: this.versionName, language: Mx(), platform: "Web", os: void 0, deviceModel: void 0 };
  }, e;
}(), Mx = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, Dx = function() {
  function e() {
    this.queue = [];
  }
  return e.prototype.logEvent = function(t) {
    this.receiver ? this.receiver(t) : this.queue.length < 512 && this.queue.push(t);
  }, e.prototype.setEventReceiver = function(t) {
    this.receiver = t, this.queue.length > 0 && (this.queue.forEach(function(n) {
      t(n);
    }), this.queue = []);
  }, e;
}(), io = function() {
  return io = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, io.apply(this, arguments);
};
function Ys(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return { next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Gp(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
var Zs = function(e, t) {
  var n, r, o = ["string", "number", "boolean", "undefined"], i = typeof e, a = typeof t;
  if (i !== a)
    return !1;
  try {
    for (var s = Ys(o), l = s.next(); !l.done; l = s.next()) {
      var c = l.value;
      if (c === i)
        return e === t;
    }
  } catch (v) {
    n = { error: v };
  } finally {
    try {
      l && !l.done && (r = s.return) && r.call(s);
    } finally {
      if (n)
        throw n.error;
    }
  }
  if (e == null && t == null)
    return !0;
  if (e == null || t == null || e.length !== t.length)
    return !1;
  var u = Array.isArray(e), d = Array.isArray(t);
  if (u !== d)
    return !1;
  if (u && d) {
    for (var f = 0; f < e.length; f++)
      if (!Zs(e[f], t[f]))
        return !1;
  } else {
    var h = Object.keys(e).sort(), p = Object.keys(t).sort();
    if (!Zs(h, p))
      return !1;
    var g = !0;
    return Object.keys(e).forEach(function(v) {
      Zs(e[v], t[v]) || (g = !1);
    }), g;
  }
  return !0;
}, jx = "$set", Bx = "$unset", Vx = "$clearAll";
Object.entries || (Object.entries = function(e) {
  for (var t = Object.keys(e), n = t.length, r = new Array(n); n--; )
    r[n] = [t[n], e[t[n]]];
  return r;
});
var Ux = function() {
  function e() {
    this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
  }
  return e.prototype.editIdentity = function() {
    var t = this, n = io({}, this.identity.userProperties), r = io(io({}, this.identity), { userProperties: n });
    return { setUserId: function(o) {
      return r.userId = o, this;
    }, setDeviceId: function(o) {
      return r.deviceId = o, this;
    }, setUserProperties: function(o) {
      return r.userProperties = o, this;
    }, setOptOut: function(o) {
      return r.optOut = o, this;
    }, updateUserProperties: function(o) {
      var i, a, s, l, c, u, d = r.userProperties || {};
      try {
        for (var f = Ys(Object.entries(o)), h = f.next(); !h.done; h = f.next()) {
          var p = Gp(h.value, 2), g = p[0], v = p[1];
          switch (g) {
            case jx:
              try {
                for (var b = (s = void 0, Ys(Object.entries(v))), m = b.next(); !m.done; m = b.next()) {
                  var w = Gp(m.value, 2), E = w[0], C = w[1];
                  d[E] = C;
                }
              } catch (T) {
                s = { error: T };
              } finally {
                try {
                  m && !m.done && (l = b.return) && l.call(b);
                } finally {
                  if (s)
                    throw s.error;
                }
              }
              break;
            case Bx:
              try {
                for (var x = (c = void 0, Ys(Object.keys(v))), _ = x.next(); !_.done; _ = x.next()) {
                  var E = _.value;
                  delete d[E];
                }
              } catch (T) {
                c = { error: T };
              } finally {
                try {
                  _ && !_.done && (u = x.return) && u.call(x);
                } finally {
                  if (c)
                    throw c.error;
                }
              }
              break;
            case Vx:
              d = {};
              break;
          }
        }
      } catch (T) {
        i = { error: T };
      } finally {
        try {
          h && !h.done && (a = f.return) && a.call(f);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return r.userProperties = d, this;
    }, commit: function() {
      return t.setIdentity(r), this;
    } };
  }, e.prototype.getIdentity = function() {
    return io({}, this.identity);
  }, e.prototype.setIdentity = function(t) {
    var n = io({}, this.identity);
    this.identity = io({}, t), Zs(n, this.identity) || this.listeners.forEach(function(r) {
      r(t);
    });
  }, e.prototype.addIdentityListener = function(t) {
    this.listeners.add(t);
  }, e.prototype.removeIdentityListener = function(t) {
    this.listeners.delete(t);
  }, e;
}(), na = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : self, Hx = function() {
  function e() {
    this.identityStore = new Ux(), this.eventBridge = new Dx(), this.applicationContextProvider = new Lx();
  }
  return e.getInstance = function(t) {
    return na.analyticsConnectorInstances || (na.analyticsConnectorInstances = {}), na.analyticsConnectorInstances[t] || (na.analyticsConnectorInstances[t] = new e()), na.analyticsConnectorInstances[t];
  }, e;
}(), zx = ["boot"], qx = "$default_instance";
function Wx(e) {
  var t, n, r, o, i, a, s;
  let l = window.engagement, c = { _q: (t = l == null ? void 0 : l._q) != null ? t : [], _configuration: { apiKey: (r = (n = l == null ? void 0 : l._configuration) == null ? void 0 : n.apiKey) != null ? r : "", serverUrl: (o = l == null ? void 0 : l._configuration) == null ? void 0 : o.serverUrl, serverZone: (a = (i = l == null ? void 0 : l._configuration) == null ? void 0 : i.serverZone) != null ? a : "US", options: { ...(s = l == null ? void 0 : l._configuration) == null ? void 0 : s.options } }, _sentry: void 0, init(d, f) {
    var h, p, g;
    if (c._configuration.apiKey) {
      console.log("Engagement SDK has already been initialized. Ignoring additional init call.");
      return;
    }
    c._configuration = { ...c._configuration, ...f, apiKey: d, options: { ...c._configuration.options, ...f == null ? void 0 : f.options } }, (p = (h = c._configuration) == null ? void 0 : h.options) != null && p.logger && c._configuration.options.logger.enable((g = c._configuration.options.logLevel) != null ? g : 2), e();
  }, plugin(d) {
    let f = c.init;
    return { name: "@amplitude/engagement-browser", type: "enrichment", async setup(h, p) {
      var g;
      let v = (g = h.instanceName) != null ? g : qx, b = Hx.getInstance(v).identityStore;
      f(h.apiKey, { options: { logLevel: h.logLevel }, ...d, serverZone: h.serverZone }), await window.engagement.boot({ user: () => {
        let m = b.getIdentity();
        return { user_id: p.getUserId(), device_id: p.getDeviceId(), user_properties: m.userProperties, getSessionId: p.getSessionId };
      }, integrations: [{ track: (m) => {
        p.track(m);
      } }] }), b.addIdentityListener((m) => {
        window.engagement._setUserProperties(m.userProperties);
      });
    }, async execute(h) {
      return window.engagement.forwardEvent(h), h;
    } };
  } }, u = c;
  return new Proxy(c, { get: function(d, f) {
    if (f in u)
      return u[f];
    if (f !== "then")
      return f === "gs" ? new Proxy({}, { get: function(h, p) {
        return function() {
          let g = Array.from(arguments), v = `${f}.${p}`;
          g.unshift(v), c._q.push(g);
        };
      } }) : zx.includes(f) ? function() {
        let h = Array.prototype.slice.call(arguments);
        return new Promise((p, g) => {
          h.unshift(f, p, g), c._q.push(h);
        });
      } : function() {
        let h = Array.prototype.slice.call(arguments);
        h.unshift(f), c._q.push(h);
      };
  } });
}
var S1 = () => {
  function e(t) {
    for (let n of t) {
      let r = document.createElement("script");
      r.src = n, r.id = "engagement-sdk-bundle";
      let o = document.querySelector("[nonce]");
      o && r.setAttribute("nonce", o.nonce || o.getAttribute("nonce")), document.getElementsByTagName("head")[0].appendChild(r);
    }
  }
  return Wx(() => e(["https://cdn.amplitude.com/engagement-browser/prod/index.min.js.gz"]));
};
window.engagement = S1();
var T1 = S1();
window.engagement = T1;
var { init: sD, plugin: Gx } = T1;
const Kx = (e) => typeof e.__arguments__ < "u", Yx = async (e, t = {}) => {
  const n = {};
  for (const r of e) {
    const o = await r();
    Object.assign(n, o);
  }
  return {
    ...n,
    ...t
  };
}, O1 = (e) => e.flatMap((t) => Kx(t) ? O1(t.__arguments__) : t), Zx = ({
  clientId: e,
  autocapture: t = !1,
  engagement: n = !1
}) => {
  e && $x(e, {
    autocapture: t
  }), n && Ix(Gx());
}, Qx = (e) => {
  e && Nx(e);
}, Xx = (e) => {
  const t = new Ca();
  for (const [n, r] of Object.entries(e))
    t.set(n, r);
  kx(t);
}, Jx = (...e) => lt((n, r) => {
  Yx(e, r).then((o) => {
    Fx(n, o);
  });
}).current, eS = (...e) => {
  const t = (...n) => {
    const r = O1(e);
    return Jx(...r, ...n);
  };
  return t.__arguments__ = e, t;
}, P1 = (e) => eS(async () => {
  const t = jn();
  async function n() {
    var r;
    try {
      return (r = await t.getAppDetails()) == null ? void 0 : r.name;
    } catch {
      return t.getHostAppId();
    }
  }
  return {
    app: await n(),
    component: e
  };
});
function tS() {
  const e = jn();
  ut(() => {
    Zx({
      clientId: e.getAnalyticsKey(),
      engagement: !0
    }), e.addCallbackAfterSetToken(() => {
      e.getCurrentUser().then((t) => {
        t != null && t.id && Qx(t.id), t != null && t.job_title && Xx({
          "job title": t.job_title
        });
      });
    });
  }, [e]);
}
function vo(e) {
  function t(n, r) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = n, this.code = r;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
const nS = vo("LaunchDarklyUnexpectedResponseError"), rS = vo("LaunchDarklyInvalidEnvironmentIdError"), oS = vo("LaunchDarklyInvalidUserError"), iS = vo("LaunchDarklyInvalidEventKeyError"), aS = vo("LaunchDarklyInvalidArgumentError"), sS = vo("LaunchDarklyFlagFetchError");
for (var Dt = { LDUnexpectedResponseError: nS, LDInvalidEnvironmentIdError: rS, LDInvalidUserError: oS, LDInvalidEventKeyError: iS, LDInvalidArgumentError: aS, LDInvalidDataError: vo("LaunchDarklyInvalidDataError"), LDFlagFetchError: sS, LDTimeoutError: vo("LaunchDarklyTimeoutError"), isHttpErrorRecoverable: function(e) {
  return !(e >= 400 && e < 500) || e === 400 || e === 408 || e === 429;
} }, lS = function(e) {
  var t = Yp(e), n = t[0], r = t[1];
  return 3 * (n + r) / 4 - r;
}, cS = function(e) {
  var t, n, r = Yp(e), o = r[0], i = r[1], a = new dS(function(c, u, d) {
    return 3 * (u + d) / 4 - d;
  }(0, o, i)), s = 0, l = i > 0 ? o - 4 : o;
  for (n = 0; n < l; n += 4)
    t = Zn[e.charCodeAt(n)] << 18 | Zn[e.charCodeAt(n + 1)] << 12 | Zn[e.charCodeAt(n + 2)] << 6 | Zn[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
  return i === 2 && (t = Zn[e.charCodeAt(n)] << 2 | Zn[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t), i === 1 && (t = Zn[e.charCodeAt(n)] << 10 | Zn[e.charCodeAt(n + 1)] << 4 | Zn[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t), a;
}, uS = function(e) {
  for (var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i)
    o.push(fS(e, a, a + i > s ? s : a + i));
  return r === 1 ? (t = e[n - 1], o.push(Or[t >> 2] + Or[t << 4 & 63] + "==")) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], o.push(Or[t >> 10] + Or[t >> 4 & 63] + Or[t << 2 & 63] + "=")), o.join("");
}, Or = [], Zn = [], dS = typeof Uint8Array < "u" ? Uint8Array : Array, Kp = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ti = 0; ti < 64; ++ti)
  Or[ti] = Kp[ti], Zn[Kp.charCodeAt(ti)] = ti;
function Yp(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  return n === -1 && (n = t), [n, n === t ? 0 : 4 - n % 4];
}
function fS(e, t, n) {
  for (var r, o, i = [], a = t; a < n; a += 3)
    r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(Or[(o = r) >> 18 & 63] + Or[o >> 12 & 63] + Or[o >> 6 & 63] + Or[63 & o]);
  return i.join("");
}
Zn[45] = 62, Zn[95] = 63;
var hS = { byteLength: lS, toByteArray: cS, fromByteArray: uS }, Zp = Array.isArray, Qp = Object.keys, pS = Object.prototype.hasOwnProperty, vS = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    var r, o, i, a = Zp(t), s = Zp(n);
    if (a && s) {
      if ((o = t.length) != n.length)
        return !1;
      for (r = o; r-- != 0; )
        if (!e(t[r], n[r]))
          return !1;
      return !0;
    }
    if (a != s)
      return !1;
    var l = t instanceof Date, c = n instanceof Date;
    if (l != c)
      return !1;
    if (l && c)
      return t.getTime() == n.getTime();
    var u = t instanceof RegExp, d = n instanceof RegExp;
    if (u != d)
      return !1;
    if (u && d)
      return t.toString() == n.toString();
    var f = Qp(t);
    if ((o = f.length) !== Qp(n).length)
      return !1;
    for (r = o; r-- != 0; )
      if (!pS.call(n, f[r]))
        return !1;
    for (r = o; r-- != 0; )
      if (!e(t[i = f[r]], n[i]))
        return !1;
    return !0;
  }
  return t != t && n != n;
};
const gS = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function Xp(e) {
  const t = unescape(encodeURIComponent(e));
  return hS.fromByteArray(function(n) {
    const r = [];
    for (let o = 0; o < n.length; o++)
      r.push(n.charCodeAt(o));
    return r;
  }(t));
}
function lu(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var cu, Ve = { appendUrlPath: function(e, t) {
  return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
}, base64URLEncode: function(e) {
  return Xp(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, btoa: Xp, clone: function(e) {
  return JSON.parse(JSON.stringify(e));
}, deepEquals: function(e, t) {
  return vS(e, t);
}, extend: function(...e) {
  return e.reduce((t, n) => ({ ...t, ...n }), {});
}, getLDUserAgentString: function(e) {
  const t = e.version || "?";
  return e.userAgent + "/" + t;
}, objectHasOwnProperty: lu, onNextTick: function(e) {
  setTimeout(e, 0);
}, sanitizeContext: function(e) {
  if (!e)
    return e;
  let t;
  return e.kind !== null && e.kind !== void 0 || gS.forEach((n) => {
    const r = e[n];
    r !== void 0 && typeof r != "string" && (t = t || { ...e }, t[n] = String(r));
  }), t || e;
}, transformValuesToVersionedValues: function(e) {
  const t = {};
  for (const n in e)
    lu(e, n) && (t[n] = { value: e[n], version: 0 });
  return t;
}, transformVersionedValuesToValues: function(e) {
  const t = {};
  for (const n in e)
    lu(e, n) && (t[n] = e[n].value);
  return t;
}, wrapPromiseCallback: function(e, t) {
  const n = e.then((r) => (t && setTimeout(() => {
    t(null, r);
  }, 0), r), (r) => {
    if (!t)
      return Promise.reject(r);
    setTimeout(() => {
      t(r, null);
    }, 0);
  });
  return t ? void 0 : n;
} }, mS = new Uint8Array(16);
function Jp() {
  if (!cu && !(cu = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return cu(mS);
}
var yS = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Cl(e) {
  return typeof e == "string" && yS.test(e);
}
for (var ev, uu, pn = [], du = 0; du < 256; ++du)
  pn.push((du + 256).toString(16).substr(1));
function Qs(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (pn[e[t + 0]] + pn[e[t + 1]] + pn[e[t + 2]] + pn[e[t + 3]] + "-" + pn[e[t + 4]] + pn[e[t + 5]] + "-" + pn[e[t + 6]] + pn[e[t + 7]] + "-" + pn[e[t + 8]] + pn[e[t + 9]] + "-" + pn[e[t + 10]] + pn[e[t + 11]] + pn[e[t + 12]] + pn[e[t + 13]] + pn[e[t + 14]] + pn[e[t + 15]]).toLowerCase();
  if (!Cl(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
var fu = 0, hu = 0;
function R1(e) {
  if (!Cl(e))
    throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function A1(e, t, n) {
  function r(o, i, a, s) {
    if (typeof o == "string" && (o = function(u) {
      u = unescape(encodeURIComponent(u));
      for (var d = [], f = 0; f < u.length; ++f)
        d.push(u.charCodeAt(f));
      return d;
    }(o)), typeof i == "string" && (i = R1(i)), i.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var l = new Uint8Array(16 + o.length);
    if (l.set(i), l.set(o, i.length), (l = n(l))[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, a) {
      s = s || 0;
      for (var c = 0; c < 16; ++c)
        a[s + c] = l[c];
      return a;
    }
    return Qs(l);
  }
  try {
    r.name = e;
  } catch {
  }
  return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function tv(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function lo(e, t) {
  var n = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function Jl(e, t, n, r, o, i) {
  return lo((a = lo(lo(t, e), lo(r, i))) << (s = o) | a >>> 32 - s, n);
  var a, s;
}
function gn(e, t, n, r, o, i, a) {
  return Jl(t & n | ~t & r, e, t, o, i, a);
}
function mn(e, t, n, r, o, i, a) {
  return Jl(t & r | n & ~r, e, t, o, i, a);
}
function yn(e, t, n, r, o, i, a) {
  return Jl(t ^ n ^ r, e, t, o, i, a);
}
function bn(e, t, n, r, o, i, a) {
  return Jl(n ^ (t | ~r), e, t, o, i, a);
}
var bS = A1("v3", 48, function(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n)
      e[n] = t.charCodeAt(n);
  }
  return function(r) {
    for (var o = [], i = 32 * r.length, a = "0123456789abcdef", s = 0; s < i; s += 8) {
      var l = r[s >> 5] >>> s % 32 & 255, c = parseInt(a.charAt(l >>> 4 & 15) + a.charAt(15 & l), 16);
      o.push(c);
    }
    return o;
  }(function(r, o) {
    r[o >> 5] |= 128 << o % 32, r[tv(o) - 1] = o;
    for (var i = 1732584193, a = -271733879, s = -1732584194, l = 271733878, c = 0; c < r.length; c += 16) {
      var u = i, d = a, f = s, h = l;
      i = gn(i, a, s, l, r[c], 7, -680876936), l = gn(l, i, a, s, r[c + 1], 12, -389564586), s = gn(s, l, i, a, r[c + 2], 17, 606105819), a = gn(a, s, l, i, r[c + 3], 22, -1044525330), i = gn(i, a, s, l, r[c + 4], 7, -176418897), l = gn(l, i, a, s, r[c + 5], 12, 1200080426), s = gn(s, l, i, a, r[c + 6], 17, -1473231341), a = gn(a, s, l, i, r[c + 7], 22, -45705983), i = gn(i, a, s, l, r[c + 8], 7, 1770035416), l = gn(l, i, a, s, r[c + 9], 12, -1958414417), s = gn(s, l, i, a, r[c + 10], 17, -42063), a = gn(a, s, l, i, r[c + 11], 22, -1990404162), i = gn(i, a, s, l, r[c + 12], 7, 1804603682), l = gn(l, i, a, s, r[c + 13], 12, -40341101), s = gn(s, l, i, a, r[c + 14], 17, -1502002290), i = mn(i, a = gn(a, s, l, i, r[c + 15], 22, 1236535329), s, l, r[c + 1], 5, -165796510), l = mn(l, i, a, s, r[c + 6], 9, -1069501632), s = mn(s, l, i, a, r[c + 11], 14, 643717713), a = mn(a, s, l, i, r[c], 20, -373897302), i = mn(i, a, s, l, r[c + 5], 5, -701558691), l = mn(l, i, a, s, r[c + 10], 9, 38016083), s = mn(s, l, i, a, r[c + 15], 14, -660478335), a = mn(a, s, l, i, r[c + 4], 20, -405537848), i = mn(i, a, s, l, r[c + 9], 5, 568446438), l = mn(l, i, a, s, r[c + 14], 9, -1019803690), s = mn(s, l, i, a, r[c + 3], 14, -187363961), a = mn(a, s, l, i, r[c + 8], 20, 1163531501), i = mn(i, a, s, l, r[c + 13], 5, -1444681467), l = mn(l, i, a, s, r[c + 2], 9, -51403784), s = mn(s, l, i, a, r[c + 7], 14, 1735328473), i = yn(i, a = mn(a, s, l, i, r[c + 12], 20, -1926607734), s, l, r[c + 5], 4, -378558), l = yn(l, i, a, s, r[c + 8], 11, -2022574463), s = yn(s, l, i, a, r[c + 11], 16, 1839030562), a = yn(a, s, l, i, r[c + 14], 23, -35309556), i = yn(i, a, s, l, r[c + 1], 4, -1530992060), l = yn(l, i, a, s, r[c + 4], 11, 1272893353), s = yn(s, l, i, a, r[c + 7], 16, -155497632), a = yn(a, s, l, i, r[c + 10], 23, -1094730640), i = yn(i, a, s, l, r[c + 13], 4, 681279174), l = yn(l, i, a, s, r[c], 11, -358537222), s = yn(s, l, i, a, r[c + 3], 16, -722521979), a = yn(a, s, l, i, r[c + 6], 23, 76029189), i = yn(i, a, s, l, r[c + 9], 4, -640364487), l = yn(l, i, a, s, r[c + 12], 11, -421815835), s = yn(s, l, i, a, r[c + 15], 16, 530742520), i = bn(i, a = yn(a, s, l, i, r[c + 2], 23, -995338651), s, l, r[c], 6, -198630844), l = bn(l, i, a, s, r[c + 7], 10, 1126891415), s = bn(s, l, i, a, r[c + 14], 15, -1416354905), a = bn(a, s, l, i, r[c + 5], 21, -57434055), i = bn(i, a, s, l, r[c + 12], 6, 1700485571), l = bn(l, i, a, s, r[c + 3], 10, -1894986606), s = bn(s, l, i, a, r[c + 10], 15, -1051523), a = bn(a, s, l, i, r[c + 1], 21, -2054922799), i = bn(i, a, s, l, r[c + 8], 6, 1873313359), l = bn(l, i, a, s, r[c + 15], 10, -30611744), s = bn(s, l, i, a, r[c + 6], 15, -1560198380), a = bn(a, s, l, i, r[c + 13], 21, 1309151649), i = bn(i, a, s, l, r[c + 4], 6, -145523070), l = bn(l, i, a, s, r[c + 11], 10, -1120210379), s = bn(s, l, i, a, r[c + 2], 15, 718787259), a = bn(a, s, l, i, r[c + 9], 21, -343485551), i = lo(i, u), a = lo(a, d), s = lo(s, f), l = lo(l, h);
    }
    return [i, a, s, l];
  }(function(r) {
    if (r.length === 0)
      return [];
    for (var o = 8 * r.length, i = new Uint32Array(tv(o)), a = 0; a < o; a += 8)
      i[a >> 5] |= (255 & r[a / 8]) << a % 32;
    return i;
  }(e), 8 * e.length));
}), CS = bS;
function wS(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
    case 3:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
  }
}
function pu(e, t) {
  return e << t | e >>> 32 - t;
}
var ES = A1("v5", 80, function(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var r = unescape(encodeURIComponent(e));
    e = [];
    for (var o = 0; o < r.length; ++o)
      e.push(r.charCodeAt(o));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), l = 0; l < a; ++l) {
    for (var c = new Uint32Array(16), u = 0; u < 16; ++u)
      c[u] = e[64 * l + 4 * u] << 24 | e[64 * l + 4 * u + 1] << 16 | e[64 * l + 4 * u + 2] << 8 | e[64 * l + 4 * u + 3];
    s[l] = c;
  }
  s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
  for (var d = 0; d < a; ++d) {
    for (var f = new Uint32Array(80), h = 0; h < 16; ++h)
      f[h] = s[d][h];
    for (var p = 16; p < 80; ++p)
      f[p] = pu(f[p - 3] ^ f[p - 8] ^ f[p - 14] ^ f[p - 16], 1);
    for (var g = n[0], v = n[1], b = n[2], m = n[3], w = n[4], E = 0; E < 80; ++E) {
      var C = Math.floor(E / 20), x = pu(g, 5) + wS(C, v, b, m) + w + t[C] + f[E] >>> 0;
      w = m, m = b, b = pu(v, 30) >>> 0, v = g, g = x;
    }
    n[0] = n[0] + g >>> 0, n[1] = n[1] + v >>> 0, n[2] = n[2] + b >>> 0, n[3] = n[3] + m >>> 0, n[4] = n[4] + w >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, 255 & n[0], n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, 255 & n[1], n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, 255 & n[2], n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, 255 & n[3], n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, 255 & n[4]];
}), _S = ES, rh = Object.freeze({ __proto__: null, v1: function(e, t, n) {
  var r = t && n || 0, o = t || new Array(16), i = (e = e || {}).node || ev, a = e.clockseq !== void 0 ? e.clockseq : uu;
  if (i == null || a == null) {
    var s = e.random || (e.rng || Jp)();
    i == null && (i = ev = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), a == null && (a = uu = 16383 & (s[6] << 8 | s[7]));
  }
  var l = e.msecs !== void 0 ? e.msecs : Date.now(), c = e.nsecs !== void 0 ? e.nsecs : hu + 1, u = l - fu + (c - hu) / 1e4;
  if (u < 0 && e.clockseq === void 0 && (a = a + 1 & 16383), (u < 0 || l > fu) && e.nsecs === void 0 && (c = 0), c >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  fu = l, hu = c, uu = a;
  var d = (1e4 * (268435455 & (l += 122192928e5)) + c) % 4294967296;
  o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
  var f = l / 4294967296 * 1e4 & 268435455;
  o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
  for (var h = 0; h < 6; ++h)
    o[r + h] = i[h];
  return t || Qs(o);
}, v3: CS, v4: function(e, t, n) {
  var r = (e = e || {}).random || (e.rng || Jp)();
  if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return Qs(r);
}, v5: _S, NIL: "00000000-0000-0000-0000-000000000000", version: function(e) {
  if (!Cl(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}, validate: Cl, stringify: Qs, parse: R1 });
const ra = ["debug", "info", "warn", "error", "none"];
var oh = { commonBasicLogger: function(e, t) {
  if (e && e.destination && typeof e.destination != "function")
    throw new Error("destination for basicLogger was set to a non-function");
  function n(c) {
    return function(u) {
      console && console[c] && console[c].call(console, u);
    };
  }
  const r = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [n("log"), n("info"), n("warn"), n("error")], o = !(!e || !e.destination), i = e && e.prefix !== void 0 && e.prefix !== null ? e.prefix : "[LaunchDarkly] ";
  let a = 1;
  if (e && e.level)
    for (let c = 0; c < ra.length; c++)
      ra[c] === e.level && (a = c);
  function s(c, u, d) {
    if (d.length < 1)
      return;
    let f;
    const h = o ? u + ": " + i : i;
    if (d.length !== 1 && t) {
      const p = [...d];
      p[0] = h + p[0], f = t(...p);
    } else
      f = h + d[0];
    try {
      r[c](f);
    } catch (p) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + u + " method threw an exception: " + p);
    }
  }
  const l = {};
  for (let c = 0; c < ra.length; c++) {
    const u = ra[c];
    if (u !== "none")
      if (c < a)
        l[u] = () => {
        };
      else {
        const d = c;
        l[u] = function() {
          s(d, u, arguments);
        };
      }
  }
  return l;
}, validateLogger: function(e) {
  ra.forEach((t) => {
    if (t !== "none" && (!e[t] || typeof e[t] != "function"))
      throw new Error("Provided logger instance must support logger." + t + "(...) method");
  });
} };
function ys(e) {
  return e && e.message ? e.message : typeof e == "string" || e instanceof String ? e : JSON.stringify(e);
}
const ni = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var De = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + ni;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(e) {
  return 'enqueueing "' + e + '" event';
}, debugPostingDiagnosticEvent: function(e) {
  return "sending diagnostic event (" + e.kind + ")";
}, debugPostingEvents: function(e) {
  return "sending " + e + " events";
}, debugStreamDelete: function(e) {
  return 'received streaming deletion for flag "' + e + '"';
}, debugStreamDeleteIgnored: function(e) {
  return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
}, debugStreamPatch: function(e) {
  return 'received streaming update for flag "' + e + '"';
}, debugStreamPatchIgnored: function(e) {
  return 'received streaming update for flag "' + e + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(e) {
  return "polling for feature flags at " + e;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(e, t) {
  return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + ni;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + ni;
}, errorFetchingFlags: function(e) {
  return "Error fetching flag settings: " + ys(e);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(e, t, n) {
  return "Received error " + e + (e === 401 ? " (invalid SDK key)" : "") + " for " + t + " - " + (Dt.isHttpErrorRecoverable(e) ? n : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + ni;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (e, t) => `an inspector: "${t}" of type: "${e}" generated an exception`, invalidContentType: function(e) {
  return 'Expected application/json content type but got "' + e + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (e, t) => `an inspector: "${t}" of an invalid type (${e}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidMetricValue: (e) => `The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`, invalidContext: function() {
  return "Invalid context specified." + ni;
}, invalidTagValue: (e) => `Config option "${e}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(e) {
  return "local storage is unavailable: " + ys(e);
}, networkError: (e) => "network error" + (e ? " (" + e + ")" : ""), optionBelowMinimum: (e, t, n) => 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(e) {
  return "Opening stream connection to " + e;
}, streamError: function(e, t) {
  return "Error on stream connection: " + ys(e) + ", will continue retrying after " + t + " milliseconds.";
}, tagValueTooLong: (e) => `Value of "${e}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(e) {
  return 'Custom event "' + e + '" does not exist';
}, unknownOption: (e) => 'Ignoring unknown config option "' + e + '"', contextNotSpecified: function() {
  return "No context specified." + ni;
}, unrecoverableStreamError: (e) => `Error on stream connection ${ys(e)}, giving up permanently`, wrongOptionType: (e, t, n) => 'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value", wrongOptionTypeBoolean: (e, t) => 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean" };
const { validateLogger: xS } = oh, nv = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(e, t, n) {
  const r = {};
  return t.id && (r.id = rv(`${e}.id`, t.id, n)), t.version && (r.version = rv(`${e}.version`, t.version, n)), r;
} }, inspectors: { default: [] } }, SS = /^(\w|\.|-)+$/;
function vu(e) {
  return e && e.replace(/\/+$/, "");
}
function rv(e, t, n) {
  if (typeof t == "string" && t.match(SS)) {
    if (!(t.length > 64))
      return t;
    n.warn(De.tagValueTooLong(e));
  } else
    n.warn(De.invalidTagValue(e));
}
var ih = { baseOptionDefs: nv, validate: function(e, t, n, r) {
  const o = Ve.extend({ logger: { default: r } }, nv, n), i = {};
  function a(l) {
    Ve.onNextTick(() => {
      t && t.maybeReportError(new Dt.LDInvalidArgumentError(l));
    });
  }
  let s = Ve.extend({}, e || {});
  return function(l) {
    const c = l;
    Object.keys(i).forEach((u) => {
      if (c[u] !== void 0) {
        const d = i[u];
        r && r.warn(De.deprecated(u, d)), d && (c[d] === void 0 && (c[d] = c[u]), delete c[u]);
      }
    });
  }(s), s = function(l) {
    const c = Ve.extend({}, l);
    return Object.keys(o).forEach((u) => {
      c[u] !== void 0 && c[u] !== null || (c[u] = o[u] && o[u].default);
    }), c;
  }(s), s = function(l) {
    const c = Ve.extend({}, l), u = (d) => {
      if (d === null)
        return "any";
      if (d === void 0)
        return;
      if (Array.isArray(d))
        return "array";
      const f = typeof d;
      return f === "boolean" || f === "string" || f === "number" || f === "function" ? f : "object";
    };
    return Object.keys(l).forEach((d) => {
      const f = l[d];
      if (f != null) {
        const h = o[d];
        if (h === void 0)
          a(De.unknownOption(d));
        else {
          const p = h.type || u(h.default), g = h.validator;
          if (g) {
            const v = g(d, l[d], r);
            v !== void 0 ? c[d] = v : delete c[d];
          } else if (p !== "any") {
            const v = p.split("|"), b = u(f);
            v.indexOf(b) < 0 ? p === "boolean" ? (c[d] = !!f, a(De.wrongOptionTypeBoolean(d, b))) : (a(De.wrongOptionType(d, p, b)), c[d] = h.default) : b === "number" && h.minimum !== void 0 && f < h.minimum && (a(De.optionBelowMinimum(d, f, h.minimum)), c[d] = h.minimum);
          }
        }
      }
    }), c.baseUrl = vu(c.baseUrl), c.streamUrl = vu(c.streamUrl), c.eventsUrl = vu(c.eventsUrl), c;
  }(s), xS(s.logger), s;
}, getTags: function(e) {
  const t = {};
  return e && (e.application && e.application.id !== void 0 && e.application.id !== null && (t["application-id"] = [e.application.id]), e.application && e.application.version !== void 0 && e.application.id !== null && (t["application-version"] = [e.application.version])), t;
} };
const { getLDUserAgentString: TS } = Ve;
var ah = { getLDHeaders: function(e, t) {
  if (t && !t.sendLDHeaders)
    return {};
  const n = {};
  n[e.userAgentHeaderName || "User-Agent"] = TS(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
  const r = ih.getTags(t), o = Object.keys(r);
  return o.length && (n["x-launchdarkly-tags"] = o.sort().map((i) => Array.isArray(r[i]) ? r[i].sort().map((a) => `${i}/${a}`) : [`${i}/${r[i]}`]).reduce((i, a) => i.concat(a), []).join(" ")), n;
}, transformHeaders: function(e, t) {
  return t && t.requestHeaderTransform ? t.requestHeaderTransform({ ...e }) : e;
} };
const { v1: OS } = rh, { getLDHeaders: PS, transformHeaders: RS } = ah;
var I1 = function(e, t, n) {
  const r = Ve.extend({ "Content-Type": "application/json" }, PS(e, n)), o = {};
  return o.sendEvents = (i, a, s) => {
    if (!e.httpRequest)
      return Promise.resolve();
    const l = JSON.stringify(i), c = s ? null : OS();
    return function u(d) {
      const f = s ? r : Ve.extend({}, r, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": c });
      return e.httpRequest("POST", a, RS(f, n), l).promise.then((h) => {
        if (h)
          return h.status >= 400 && Dt.isHttpErrorRecoverable(h.status) && d ? u(!1) : function(p) {
            const g = { status: p.status }, v = p.header("date");
            if (v) {
              const b = Date.parse(v);
              b && (g.serverTime = b);
            }
            return g;
          }(h);
      }).catch(() => d ? u(!1) : Promise.reject());
    }(!0).catch(() => {
    });
  }, o;
};
const { commonBasicLogger: AS } = oh;
function ov(e) {
  return typeof e == "string" && e !== "kind" && e.match(/^(\w|\.|-)+$/);
}
function iv(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var ec = { checkContext: function(e, t) {
  if (e) {
    if (t && (e.kind === void 0 || e.kind === null))
      return e.key !== void 0 && e.key !== null;
    const n = e.key, r = e.kind === void 0 ? "user" : e.kind, o = ov(r), i = r === "multi" || n != null && n !== "";
    if (r === "multi") {
      const a = Object.keys(e).filter((s) => s !== "kind");
      return i && a.every((s) => ov(s)) && a.every((s) => {
        const l = e[s].key;
        return l != null && l !== "";
      });
    }
    return i && o;
  }
  return !1;
}, getContextKeys: function(e, t = AS()) {
  if (!e)
    return;
  const n = {}, { kind: r, key: o } = e;
  switch (r) {
    case void 0:
      n.user = `${o}`;
      break;
    case "multi":
      Object.entries(e).filter(([i]) => i !== "kind").forEach(([i, a]) => {
        a && a.key && (n[i] = a.key);
      });
      break;
    case null:
      t.warn(`null is not a valid context kind: ${e}`);
      break;
    case "":
      t.warn(`'' is not a valid context kind: ${e}`);
      break;
    default:
      n[r] = `${o}`;
  }
  return n;
}, getContextKinds: function(e) {
  return e ? e.kind === null || e.kind === void 0 ? ["user"] : e.kind !== "multi" ? [e.kind] : Object.keys(e).filter((t) => t !== "kind") : [];
}, getCanonicalKey: function(e) {
  if (e) {
    if ((e.kind === void 0 || e.kind === null || e.kind === "user") && e.key)
      return e.key;
    if (e.kind !== "multi" && e.key)
      return `${e.kind}:${iv(e.key)}`;
    if (e.kind === "multi")
      return Object.keys(e).sort().filter((t) => t !== "kind").map((t) => `${t}:${iv(e[t].key)}`).join(":");
  }
} };
const { getContextKinds: IS } = ec;
var kS = function() {
  const e = {};
  let t = 0, n = 0, r = {}, o = {};
  return e.summarizeEvent = (i) => {
    if (i.kind === "feature") {
      const a = i.key + ":" + (i.variation !== null && i.variation !== void 0 ? i.variation : "") + ":" + (i.version !== null && i.version !== void 0 ? i.version : ""), s = r[a];
      let l = o[i.key];
      l || (l = /* @__PURE__ */ new Set(), o[i.key] = l), function(c) {
        return c.context ? IS(c.context) : c.contextKeys ? Object.keys(c.contextKeys) : [];
      }(i).forEach((c) => l.add(c)), s ? s.count = s.count + 1 : r[a] = { count: 1, key: i.key, version: i.version, variation: i.variation, value: i.value, default: i.default }, (t === 0 || i.creationDate < t) && (t = i.creationDate), i.creationDate > n && (n = i.creationDate);
    }
  }, e.getSummary = () => {
    const i = {};
    let a = !0;
    for (const s of Object.values(r)) {
      let l = i[s.key];
      l || (l = { default: s.default, counters: [], contextKinds: [...o[s.key]] }, i[s.key] = l);
      const c = { value: s.value, count: s.count };
      s.variation !== void 0 && s.variation !== null && (c.variation = s.variation), s.version !== void 0 && s.version !== null ? c.version = s.version : c.unknown = !0, l.counters.push(c), a = !1;
    }
    return a ? null : { startDate: t, endDate: n, features: i };
  }, e.clearSummary = () => {
    t = 0, n = 0, r = {}, o = {};
  }, e;
};
function k1(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function av(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map((t) => t.indexOf("~") >= 0 ? t.replace(/~1/g, "/").replace(/~0/g, "~") : t);
}
function sv(e) {
  return !e.startsWith("/");
}
function lv(e, t) {
  const n = sv(e), r = sv(t);
  if (n && r)
    return e === t;
  if (n) {
    const o = av(t);
    return o.length === 1 && e === o[0];
  }
  if (r) {
    const o = av(e);
    return o.length === 1 && t === o[0];
  }
  return e === t;
}
function cv(e) {
  return `/${k1(e)}`;
}
var gu = { cloneExcluding: function(e, t) {
  const n = [], r = {}, o = [];
  for (n.push(...Object.keys(e).map((i) => ({ key: i, ptr: cv(i), source: e, parent: r, visited: [e] }))); n.length; ) {
    const i = n.pop();
    if (t.some((a) => lv(a, i.ptr)))
      o.push(i.ptr);
    else {
      const a = i.source[i.key];
      if (a === null)
        i.parent[i.key] = a;
      else if (Array.isArray(a))
        i.parent[i.key] = [...a];
      else if (typeof a == "object") {
        if (i.visited.includes(a))
          continue;
        i.parent[i.key] = {}, n.push(...Object.keys(a).map((s) => {
          return { key: s, ptr: (l = i.ptr, c = k1(s), `${l}/${c}`), source: a, parent: i.parent[i.key], visited: [...i.visited, a] };
          var l, c;
        }));
      } else
        i.parent[i.key] = a;
    }
  }
  return { cloned: r, excluded: o.sort() };
}, compare: lv, literalToReference: cv }, $S = function(e) {
  const t = {}, n = e.allAttributesPrivate, r = e.privateAttributes || [], o = ["key", "kind", "_meta", "anonymous"], i = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], a = (s, l) => {
    if (typeof s != "object" || s === null || Array.isArray(s))
      return;
    const { cloned: c, excluded: u } = gu.cloneExcluding(s, ((d, f) => (n || f && d.anonymous ? Object.keys(d) : [...r, ...d._meta && d._meta.privateAttributes || []]).filter((h) => !o.some((p) => gu.compare(h, p))))(s, l));
    return c.key = String(c.key), u.length && (c._meta || (c._meta = {}), c._meta.redactedAttributes = u), c._meta && (delete c._meta.privateAttributes, Object.keys(c._meta).length === 0 && delete c._meta), c.anonymous !== void 0 && (c.anonymous = !!c.anonymous), c;
  };
  return t.filter = (s, l = !1) => s.kind === void 0 || s.kind === null ? a(((c) => {
    const u = { ...c.custom || {}, kind: "user", key: c.key };
    c.anonymous !== void 0 && (u.anonymous = !!c.anonymous);
    for (const d of i)
      delete u[d], c[d] !== void 0 && c[d] !== null && (u[d] = String(c[d]));
    return c.privateAttributeNames !== void 0 && c.privateAttributeNames !== null && (u._meta = u._meta || {}, u._meta.privateAttributes = c.privateAttributeNames.map((d) => d.startsWith("/") ? gu.literalToReference(d) : d)), u;
  })(s), l) : s.kind === "multi" ? ((c, u) => {
    const d = { kind: c.kind }, f = Object.keys(c);
    for (const h of f)
      if (h !== "kind") {
        const p = a(c[h], u);
        p && (d[h] = p);
      }
    return d;
  })(s, l) : a(s, l), t;
};
const { getContextKeys: NS } = ec;
var FS = function(e, t, n, r = null, o = null, i = null) {
  const a = {}, s = i || I1(e, n, t), l = Ve.appendUrlPath(t.eventsUrl, "/events/bulk/" + n), c = kS(), u = $S(t), d = t.samplingInterval, f = t.eventCapacity, h = t.flushInterval, p = t.logger;
  let g, v = [], b = 0, m = !1, w = !1;
  function E() {
    return d === 0 || Math.floor(Math.random() * d) === 0;
  }
  function C(_) {
    const T = Ve.extend({}, _);
    return _.kind === "identify" ? T.context = u.filter(_.context) : _.kind === "feature" ? T.context = u.filter(_.context, !0) : (T.contextKeys = NS(_.context, p), delete T.context), _.kind === "feature" && (delete T.trackEvents, delete T.debugEventsUntilDate), T;
  }
  function x(_) {
    v.length < f ? (v.push(_), w = !1) : (w || (w = !0, p.warn(De.eventCapacityExceeded())), r && r.incrementDroppedEvents());
  }
  return a.enqueue = function(_) {
    if (m)
      return;
    let T = !1, O = !1;
    var I;
    if (c.summarizeEvent(_), _.kind === "feature" ? E() && (T = !!_.trackEvents, O = !!(I = _).debugEventsUntilDate && I.debugEventsUntilDate > b && I.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : T = E(), T && x(C(_)), O) {
      const L = Ve.extend({}, _, { kind: "debug" });
      L.context = u.filter(L.context), delete L.trackEvents, delete L.debugEventsUntilDate, x(L);
    }
  }, a.flush = function() {
    if (m)
      return Promise.resolve();
    const _ = v, T = c.getSummary();
    return c.clearSummary(), T && (T.kind = "summary", _.push(T)), r && r.setEventsInLastBatch(_.length), _.length === 0 ? Promise.resolve() : (v = [], p.debug(De.debugPostingEvents(_.length)), s.sendEvents(_, l).then((O) => {
      O && (O.serverTime && (b = O.serverTime), Dt.isHttpErrorRecoverable(O.status) || (m = !0), O.status >= 400 && Ve.onNextTick(() => {
        o.maybeReportError(new Dt.LDUnexpectedResponseError(De.httpErrorMessage(O.status, "event posting", "some events were dropped")));
      }));
    }));
  }, a.start = function() {
    const _ = () => {
      a.flush(), g = setTimeout(_, h);
    };
    g = setTimeout(_, h);
  }, a.stop = function() {
    clearTimeout(g);
  }, a;
}, LS = function(e) {
  const t = {}, n = {};
  return t.on = function(r, o, i) {
    n[r] = n[r] || [], n[r] = n[r].concat({ handler: o, context: i });
  }, t.off = function(r, o, i) {
    if (n[r])
      for (let a = 0; a < n[r].length; a++)
        n[r][a].handler === o && n[r][a].context === i && (n[r] = n[r].slice(0, a).concat(n[r].slice(a + 1)));
  }, t.emit = function(r) {
    if (!n[r])
      return;
    const o = n[r].slice(0);
    for (let i = 0; i < o.length; i++)
      o[i].handler.apply(o[i].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function() {
    return Object.keys(n);
  }, t.getEventListenerCount = function(r) {
    return n[r] ? n[r].length : 0;
  }, t.maybeReportError = function(r) {
    r && (n.error ? this.emit("error", r) : (e || console).error(r.message));
  }, t;
};
const bs = "ready", mu = "initialized", yu = "failed";
var MS = function(e) {
  let t = !1, n = !1, r = null, o = null;
  const i = new Promise((a) => {
    const s = () => {
      e.off(bs, s), a();
    };
    e.on(bs, s);
  }).catch(() => {
  });
  return { getInitializationPromise: () => o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise((a, s) => {
    const l = () => {
      e.off(mu, l), a();
    }, c = (u) => {
      e.off(yu, c), s(u);
    };
    e.on(mu, l), e.on(yu, c);
  }), o)), getReadyPromise: () => i, signalSuccess: () => {
    t || n || (t = !0, e.emit(mu), e.emit(bs));
  }, signalFailure: (a) => {
    t || n || (n = !0, r = a, e.emit(yu, a), e.emit(bs)), e.maybeReportError(a);
  } };
}, DS = function(e, t, n, r) {
  const o = {};
  function i() {
    let a = "";
    const s = r.getContext();
    return s && (a = n || Ve.btoa(JSON.stringify(s))), "ld:" + t + ":" + a;
  }
  return o.loadFlags = () => e.get(i()).then((a) => {
    if (a == null)
      return null;
    try {
      let s = JSON.parse(a);
      if (s) {
        const l = s.$schema;
        l === void 0 || l < 1 ? s = Ve.transformValuesToVersionedValues(s) : delete s.$schema;
      }
      return s;
    } catch {
      return o.clearFlags().then(() => null);
    }
  }), o.saveFlags = (a) => {
    const s = Ve.extend({}, a, { $schema: 1 });
    return e.set(i(), JSON.stringify(s));
  }, o.clearFlags = () => e.clear(i()), o;
}, jS = function(e, t) {
  const n = {};
  let r = !1;
  const o = (i) => {
    r || (r = !0, t.warn(De.localStorageUnavailable(i)));
  };
  return n.isEnabled = () => !!e, n.get = (i) => new Promise((a) => {
    e ? e.get(i).then(a).catch((s) => {
      o(s), a(void 0);
    }) : a(void 0);
  }), n.set = (i, a) => new Promise((s) => {
    e ? e.set(i, a).then(() => s(!0)).catch((l) => {
      o(l), s(!1);
    }) : s(!1);
  }), n.clear = (i) => new Promise((a) => {
    e ? e.clear(i).then(() => a(!0)).catch((s) => {
      o(s), a(!1);
    }) : a(!1);
  }), n;
};
const { appendUrlPath: uv, base64URLEncode: BS, objectHasOwnProperty: VS } = Ve, { getLDHeaders: US, transformHeaders: HS } = ah, { isHttpErrorRecoverable: zS } = Dt;
var qS = function(e, t, n, r) {
  const o = t.streamUrl, i = t.logger, a = {}, s = uv(o, "/eval/" + n), l = t.useReport, c = t.evaluationReasons, u = t.streamReconnectDelay, d = US(e, t);
  let f, h = !1, p = null, g = null, v = null, b = null, m = null, w = 0;
  function E() {
    const I = (L = function() {
      const B = u * Math.pow(2, w);
      return B > 3e4 ? 3e4 : B;
    }(), L - Math.trunc(0.5 * Math.random() * L));
    var L;
    return w += 1, I;
  }
  function C(I) {
    if (I.status && typeof I.status == "number" && !zS(I.status))
      return T(), i.error(De.unrecoverableStreamError(I)), void (g && (clearTimeout(g), g = null));
    const L = E();
    h || (i.warn(De.streamError(I, L)), h = !0), O(!1), T(), x(L);
  }
  function x(I) {
    g || (I ? g = setTimeout(_, I) : _());
  }
  function _() {
    let I;
    g = null;
    let L = "";
    const B = { headers: d, readTimeoutMillis: 3e5 };
    if (e.eventSourceFactory) {
      b != null && (L = "h=" + b), l ? e.eventSourceAllowsReport ? (I = s, B.method = "REPORT", B.headers["Content-Type"] = "application/json", B.body = JSON.stringify(v)) : (I = uv(o, "/ping/" + n), L = "") : I = s + "/" + BS(JSON.stringify(v)), B.headers = HS(B.headers, t), c && (L = L + (L ? "&" : "") + "withReasons=true"), I = I + (L ? "?" : "") + L, T(), i.info(De.streamConnecting(I)), f = (/* @__PURE__ */ new Date()).getTime(), p = e.eventSourceFactory(I, B);
      for (const j in m)
        VS(m, j) && p.addEventListener(j, m[j]);
      p.onerror = C, p.onopen = () => {
        w = 0;
      };
    }
  }
  function T() {
    p && (i.info(De.streamClosing()), p.close(), p = null);
  }
  function O(I) {
    f && r && r.recordStreamInit(f, !I, (/* @__PURE__ */ new Date()).getTime() - f), f = null;
  }
  return a.connect = function(I, L, B) {
    v = I, b = L, m = {};
    for (const j in B || {})
      m[j] = function(M) {
        h = !1, O(!0), B[j] && B[j](M);
      };
    x();
  }, a.disconnect = function() {
    clearTimeout(g), g = null, T();
  }, a.isConnected = function() {
    return !!(p && e.eventSourceIsActive && e.eventSourceIsActive(p));
  }, a;
}, WS = function(e) {
  let t, n, r, o;
  const i = { addPromise: (a, s) => {
    t = a, n && n(), n = s, a.then((l) => {
      t === a && (r(l), e && e());
    }, (l) => {
      t === a && (o(l), e && e());
    });
  } };
  return i.resultPromise = new Promise((a, s) => {
    r = a, o = s;
  }), i;
};
const { transformHeaders: GS, getLDHeaders: KS } = ah, dv = "application/json";
var YS = function(e, t, n) {
  const r = t.baseUrl, o = t.useReport, i = t.evaluationReasons, a = t.logger, s = {}, l = {};
  function c(u, d) {
    if (!e.httpRequest)
      return new Promise((b, m) => {
        m(new Dt.LDFlagFetchError(De.httpUnavailable()));
      });
    const f = d ? "REPORT" : "GET", h = KS(e, t);
    d && (h["Content-Type"] = dv);
    let p = l[u];
    p || (p = WS(() => {
      delete l[u];
    }), l[u] = p);
    const g = e.httpRequest(f, u, GS(h, t), d), v = g.promise.then((b) => {
      if (b.status === 200) {
        if (b.header("content-type") && b.header("content-type").substring(0, 16) === dv)
          return JSON.parse(b.body);
        {
          const m = De.invalidContentType(b.header("content-type") || "");
          return Promise.reject(new Dt.LDFlagFetchError(m));
        }
      }
      return Promise.reject(function(m) {
        return m.status === 404 ? new Dt.LDInvalidEnvironmentIdError(De.environmentNotFound()) : new Dt.LDFlagFetchError(De.errorFetchingFlags(m.statusText || String(m.status)));
      }(b));
    }, (b) => Promise.reject(new Dt.LDFlagFetchError(De.networkError(b))));
    return p.addPromise(v, () => {
      g.cancel && g.cancel();
    }), p.resultPromise;
  }
  return s.fetchJSON = function(u) {
    return c(Ve.appendUrlPath(r, u), null);
  }, s.fetchFlagSettings = function(u, d) {
    let f, h, p, g = "";
    return o ? (h = [r, "/sdk/evalx/", n, "/context"].join(""), p = JSON.stringify(u)) : (f = Ve.base64URLEncode(JSON.stringify(u)), h = [r, "/sdk/evalx/", n, "/contexts/", f].join("")), d && (g = "h=" + d), i && (g = g + (g ? "&" : "") + "withReasons=true"), h = h + (g ? "?" : "") + g, a.debug(De.debugPolling(h)), c(h, p);
  }, s;
}, ZS = function(e, t) {
  const n = {};
  let r;
  return n.setContext = function(o) {
    r = Ve.sanitizeContext(o), r && t && t(Ve.clone(r));
  }, n.getContext = function() {
    return r ? Ve.clone(r) : null;
  }, n;
};
const { v1: QS } = rh, { getContextKinds: XS } = ec;
var JS = function(e) {
  function t(r) {
    return r == null || r === "user" ? "ld:$anonUserId" : `ld:$contextKey:${r}`;
  }
  function n(r, o) {
    return o.key !== null && o.key !== void 0 ? (o.key = o.key.toString(), Promise.resolve(o)) : o.anonymous ? function(i) {
      return e.get(t(i));
    }(r).then((i) => {
      if (i)
        return o.key = i, o;
      {
        const a = QS();
        return o.key = a, function(s, l) {
          return e.set(t(l), s);
        }(a, r).then(() => o);
      }
    }) : Promise.reject(new Dt.LDInvalidUserError(De.invalidContext()));
  }
  this.processContext = (r) => {
    if (!r)
      return Promise.reject(new Dt.LDInvalidUserError(De.contextNotSpecified()));
    const o = Ve.clone(r);
    if (r.kind === "multi") {
      const i = XS(o);
      return Promise.all(i.map((a) => n(a, o[a]))).then(() => o);
    }
    return n(r.kind, o);
  };
};
const { v1: e9 } = rh, { baseOptionDefs: bu } = ih, { appendUrlPath: t9 } = Ve;
var Cu = { DiagnosticId: function(e) {
  const t = { diagnosticId: e9() };
  return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
}, DiagnosticsAccumulator: function(e) {
  let t, n, r, o;
  function i(a) {
    t = a, n = 0, r = 0, o = [];
  }
  return i(e), { getProps: () => ({ dataSinceDate: t, droppedEvents: n, eventsInLastBatch: r, streamInits: o }), setProps: (a) => {
    t = a.dataSinceDate, n = a.droppedEvents || 0, r = a.eventsInLastBatch || 0, o = a.streamInits || [];
  }, incrementDroppedEvents: () => {
    n++;
  }, setEventsInLastBatch: (a) => {
    r = a;
  }, recordStreamInit: (a, s, l) => {
    const c = { timestamp: a, failed: s, durationMillis: l };
    o.push(c);
  }, reset: i };
}, DiagnosticsManager: function(e, t, n, r, o, i, a) {
  const s = !!e.diagnosticUseCombinedEvent, l = "ld:" + o + ":$diagnostics", c = t9(i.eventsUrl, "/events/diagnostic/" + o), u = i.diagnosticRecordingInterval, d = n;
  let f, h, p = !!i.streaming;
  const g = {};
  function v() {
    return { sdk: w(), configuration: E(), platform: e.diagnosticPlatformData };
  }
  function b(C) {
    i.logger && i.logger.debug(De.debugPostingDiagnosticEvent(C)), r.sendEvents(C, c, !0).then(() => {
    }).catch(() => {
    });
  }
  function m() {
    b(function() {
      const C = (/* @__PURE__ */ new Date()).getTime();
      let x = { kind: s ? "diagnostic-combined" : "diagnostic", id: a, creationDate: C, ...d.getProps() };
      return s && (x = { ...x, ...v() }), d.reset(C), x;
    }()), h = setTimeout(m, u), f = (/* @__PURE__ */ new Date()).getTime(), s && function() {
      if (t.isEnabled()) {
        const C = { ...d.getProps() };
        t.set(l, JSON.stringify(C));
      }
    }();
  }
  function w() {
    const C = { ...e.diagnosticSdkData };
    return i.wrapperName && (C.wrapperName = i.wrapperName), i.wrapperVersion && (C.wrapperVersion = i.wrapperVersion), C;
  }
  function E() {
    return { customBaseURI: i.baseUrl !== bu.baseUrl.default, customStreamURI: i.streamUrl !== bu.streamUrl.default, customEventsURI: i.eventsUrl !== bu.eventsUrl.default, eventsCapacity: i.eventCapacity, eventsFlushIntervalMillis: i.flushInterval, reconnectTimeMillis: i.streamReconnectDelay, streamingDisabled: !p, allAttributesPrivate: !!i.allAttributesPrivate, diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval, usingSecureMode: !!i.hash, bootstrapMode: !!i.bootstrap, fetchGoalsDisabled: !i.fetchGoals, sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation };
  }
  return g.start = () => {
    s ? function(C) {
      if (!t.isEnabled())
        return C(!1);
      t.get(l).then((x) => {
        if (x)
          try {
            const _ = JSON.parse(x);
            d.setProps(_), f = _.dataSinceDate;
          } catch {
          }
        C(!0);
      }).catch(() => {
        C(!1);
      });
    }((C) => {
      if (C) {
        const x = (f || 0) + u, _ = (/* @__PURE__ */ new Date()).getTime();
        _ >= x ? m() : h = setTimeout(m, x - _);
      } else
        Math.floor(4 * Math.random()) === 0 ? m() : h = setTimeout(m, u);
    }) : (b({ kind: "diagnostic-init", id: a, creationDate: d.getProps().dataSinceDate, ...v() }), h = setTimeout(m, u));
  }, g.stop = () => {
    h && clearTimeout(h);
  }, g.setStreaming = (C) => {
    p = C;
  }, g;
} }, n9 = function(e, t) {
  let n = !1;
  const r = { type: e.type, name: e.name, synchronous: e.synchronous, method: (...o) => {
    try {
      e.method(...o);
    } catch {
      n || (n = !0, t.warn(De.inspectorMethodError(r.type, r.name)));
    }
  } };
  return r;
};
const { onNextTick: Cs } = Ve, On = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(On);
var r9 = { InspectorTypes: On, InspectorManager: function(e, t) {
  const n = {}, r = { [On.flagUsed]: [], [On.flagDetailsChanged]: [], [On.flagDetailChanged]: [], [On.clientIdentityChanged]: [] }, o = { [On.flagUsed]: [], [On.flagDetailsChanged]: [], [On.flagDetailChanged]: [], [On.clientIdentityChanged]: [] }, i = e && e.map((a) => n9(a, t));
  return i && i.forEach((a) => {
    Object.prototype.hasOwnProperty.call(r, a.type) && !a.synchronous ? r[a.type].push(a) : Object.prototype.hasOwnProperty.call(o, a.type) && a.synchronous ? o[a.type].push(a) : t.warn(De.invalidInspector(a.type, a.name));
  }), n.hasListeners = (a) => r[a] && r[a].length || o[a] && o[a].length, n.onFlagUsed = (a, s, l) => {
    const c = On.flagUsed;
    o[c].length && o[c].forEach((u) => u.method(a, s, l)), r[c].length && Cs(() => {
      r[c].forEach((u) => u.method(a, s, l));
    });
  }, n.onFlags = (a) => {
    const s = On.flagDetailsChanged;
    o[s].length && o[s].forEach((l) => l.method(a)), r[s].length && Cs(() => {
      r[s].forEach((l) => l.method(a));
    });
  }, n.onFlagChanged = (a, s) => {
    const l = On.flagDetailChanged;
    o[l].length && o[l].forEach((c) => c.method(a, s)), r[l].length && Cs(() => {
      r[l].forEach((c) => c.method(a, s));
    });
  }, n.onIdentityChanged = (a) => {
    const s = On.clientIdentityChanged;
    o[s].length && o[s].forEach((l) => l.method(a)), r[s].length && Cs(() => {
      r[s].forEach((l) => l.method(a));
    });
  }, n;
} };
const { LDTimeoutError: o9 } = Dt;
var i9 = function(e, t) {
  return new Promise((n, r) => {
    setTimeout(() => {
      r(new o9(`${t} timed out after ${e} seconds.`));
    }, 1e3 * e);
  });
};
const { commonBasicLogger: fv } = oh, { checkContext: a9, getContextKeys: s9 } = ec, { InspectorTypes: ws, InspectorManager: l9 } = r9, Es = "change", hv = "internal-change";
var $1 = { initialize: function(e, t, n, r, o) {
  const i = function() {
    return n && n.logger ? n.logger : o && o.logger && o.logger.default || fv("warn");
  }(), a = LS(i), s = MS(a), l = ih.validate(n, a, o, i), c = l9(l.inspectors, i), u = l.sendEvents;
  let d = e, f = l.hash;
  const h = jS(r.localStorage, i), p = I1(r, d, l), g = l.sendEvents && !l.diagnosticOptOut, v = g ? Cu.DiagnosticId(d) : null, b = g ? Cu.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, m = g ? Cu.DiagnosticsManager(r, h, b, p, d, l, v) : null, w = qS(r, l, d, b), E = l.eventProcessor || FS(r, l, d, b, a, p), C = YS(r, l, d);
  let x, _, T, O = {}, I = l.streaming, L = !1, B = !1, j = !0;
  const M = l.stateProvider, q = ZS(null, function(D) {
    (function(X) {
      M || X && F({ kind: "identify", context: X, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(D), c.hasListeners(ws.clientIdentityChanged) && c.onIdentityChanged(q.getContext());
  }), N = new JS(h), $ = h.isEnabled() ? DS(h, d, f, q) : null;
  function F(D) {
    d && (M && M.enqueueEvent && M.enqueueEvent(D) || (D.context ? (j = !1, !u || B || r.isDoNotTrack() || (i.debug(De.debugEnqueueingEvent(D.kind)), E.enqueue(D))) : j && (i.warn(De.eventWithoutContext()), j = !1)));
  }
  function H(D, X) {
    c.hasListeners(ws.flagDetailChanged) && c.onFlagChanged(D.key, Y(X));
  }
  function k() {
    c.hasListeners(ws.flagDetailsChanged) && c.onFlags(Object.entries(O).map(([D, X]) => ({ key: D, detail: Y(X) })).reduce((D, X) => (D[X.key] = X.detail, D), {}));
  }
  function W(D, X, Q, _e) {
    const Ce = q.getContext(), Ne = /* @__PURE__ */ new Date(), ae = { kind: "feature", key: D, context: Ce, value: X ? X.value : null, variation: X ? X.variationIndex : null, default: Q, creationDate: Ne.getTime() }, xe = O[D];
    xe && (ae.version = xe.flagVersion ? xe.flagVersion : xe.version, ae.trackEvents = xe.trackEvents, ae.debugEventsUntilDate = xe.debugEventsUntilDate), (_e || xe && xe.trackReason) && X && (ae.reason = X.reason), F(ae);
  }
  function G(D) {
    return a9(D, !1) ? Promise.resolve(D) : Promise.reject(new Dt.LDInvalidUserError(De.invalidContext()));
  }
  function ne(D, X, Q, _e, Ce) {
    let Ne;
    if (O && Ve.objectHasOwnProperty(O, D) && O[D] && !O[D].deleted) {
      const ae = O[D];
      Ne = Y(ae), ae.value !== null && ae.value !== void 0 || (Ne.value = X);
    } else
      Ne = { value: X, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } };
    return Q && W(D, Ne, X, _e), Ce || function(ae, xe) {
      c.hasListeners(ws.flagUsed) && c.onFlagUsed(ae, xe, q.getContext());
    }(D, Ne), Ne;
  }
  function Y(D) {
    return { value: D.value, variationIndex: D.variation === void 0 ? null : D.variation, reason: D.reason || null };
  }
  function fe() {
    if (_ = !0, !q.getContext())
      return;
    const D = (X) => {
      try {
        return JSON.parse(X);
      } catch {
        return void a.maybeReportError(new Dt.LDInvalidDataError(De.invalidData()));
      }
    };
    w.connect(q.getContext(), f, { ping: function() {
      i.debug(De.debugStreamPing());
      const X = q.getContext();
      C.fetchFlagSettings(X, f).then((Q) => {
        Ve.deepEquals(X, q.getContext()) && ie(Q || {});
      }).catch((Q) => {
        a.maybeReportError(new Dt.LDFlagFetchError(De.errorFetchingFlags(Q)));
      });
    }, put: function(X) {
      const Q = D(X.data);
      Q && (i.debug(De.debugStreamPut()), ie(Q));
    }, patch: function(X) {
      const Q = D(X.data);
      if (!Q)
        return;
      const _e = O[Q.key];
      if (!_e || !_e.version || !Q.version || _e.version < Q.version) {
        i.debug(De.debugStreamPatch(Q.key));
        const Ce = {}, Ne = Ve.extend({}, Q);
        delete Ne.key, O[Q.key] = Ne;
        const ae = Y(Ne);
        Ce[Q.key] = _e ? { previous: _e.value, current: ae } : { current: ae }, H(Q, Ne), he(Ce);
      } else
        i.debug(De.debugStreamPatchIgnored(Q.key));
    }, delete: function(X) {
      const Q = D(X.data);
      if (Q)
        if (!O[Q.key] || O[Q.key].version < Q.version) {
          i.debug(De.debugStreamDelete(Q.key));
          const _e = {};
          O[Q.key] && !O[Q.key].deleted && (_e[Q.key] = { previous: O[Q.key].value }), O[Q.key] = { version: Q.version, deleted: !0 }, H(Q, O[Q.key]), he(_e);
        } else
          i.debug(De.debugStreamDeleteIgnored(Q.key));
    } });
  }
  function ge() {
    _ && (w.disconnect(), _ = !1);
  }
  function ie(D) {
    const X = {};
    if (!D)
      return Promise.resolve();
    for (const Q in O)
      Ve.objectHasOwnProperty(O, Q) && O[Q] && (D[Q] && !Ve.deepEquals(D[Q].value, O[Q].value) ? X[Q] = { previous: O[Q].value, current: Y(D[Q]) } : D[Q] && !D[Q].deleted || (X[Q] = { previous: O[Q].value }));
    for (const Q in D)
      Ve.objectHasOwnProperty(D, Q) && D[Q] && (!O[Q] || O[Q].deleted) && (X[Q] = { current: Y(D[Q]) });
    return O = { ...D }, k(), he(X).catch(() => {
    });
  }
  function he(D) {
    const X = Object.keys(D);
    if (X.length > 0) {
      const Q = {};
      X.forEach((_e) => {
        const Ce = D[_e].current, Ne = Ce ? Ce.value : void 0, ae = D[_e].previous;
        a.emit(Es + ":" + _e, Ne, ae), Q[_e] = Ce ? { current: Ne, previous: ae } : { previous: ae };
      }), a.emit(Es, Q), a.emit(hv, O), l.sendEventsOnlyForVariation || M || X.forEach((_e) => {
        W(_e, D[_e].current);
      });
    }
    return x && $ ? $.saveFlags(O) : Promise.resolve();
  }
  function ue() {
    const D = I || T && I === void 0;
    D && !_ ? fe() : !D && _ && ge(), m && m.setStreaming(D);
  }
  function ce(D) {
    return D === Es || D.substr(0, 7) === Es + ":";
  }
  if (typeof l.bootstrap == "string" && l.bootstrap.toUpperCase() === "LOCALSTORAGE" && ($ ? x = !0 : i.warn(De.localStorageUnavailable())), typeof l.bootstrap == "object" && (O = function(D) {
    const X = Object.keys(D), Q = "$flagsState", _e = "$valid", Ce = D[Q];
    !Ce && X.length && i.warn(De.bootstrapOldFormat()), D[_e] === !1 && i.warn(De.bootstrapInvalid());
    const Ne = {};
    return X.forEach((ae) => {
      if (ae !== Q && ae !== _e) {
        let xe = { value: D[ae] };
        Ce && Ce[ae] ? xe = Ve.extend(xe, Ce[ae]) : xe.version = 0, Ne[ae] = xe;
      }
    }), Ne;
  }(l.bootstrap)), M) {
    const D = M.getInitialState();
    D ? Se(D) : M.on("init", Se), M.on("update", function(X) {
      X.context && q.setContext(X.context), X.flags && ie(X.flags);
    });
  } else
    (function() {
      return e ? N.processContext(t).then(G).then((D) => (q.setContext(D), typeof l.bootstrap == "object" ? te() : x ? $.loadFlags().then((X) => X == null ? (O = {}, C.fetchFlagSettings(q.getContext(), f).then((Q) => ie(Q || {})).then(te).catch((Q) => {
        ke(new Dt.LDFlagFetchError(De.errorFetchingFlags(Q)));
      })) : (O = X, Ve.onNextTick(te), C.fetchFlagSettings(q.getContext(), f).then((Q) => ie(Q)).catch((Q) => a.maybeReportError(Q)))) : C.fetchFlagSettings(q.getContext(), f).then((X) => {
        O = X || {}, k(), te();
      }).catch((X) => {
        O = {}, ke(X);
      }))) : Promise.reject(new Dt.LDInvalidEnvironmentIdError(De.environmentNotSpecified()));
    })().catch(ke);
  function Se(D) {
    d = D.environment, q.setContext(D.context), O = { ...D.flags }, Ve.onNextTick(te);
  }
  function te() {
    i.info(De.clientInitialized()), L = !0, ue(), s.signalSuccess();
  }
  function ke(D) {
    s.signalFailure(D);
  }
  return { client: { waitForInitialization: function(D = void 0) {
    if (D != null) {
      if (typeof D == "number")
        return function(X) {
          X > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
          const Q = s.getInitializationPromise(), _e = i9(X, "waitForInitialization");
          return Promise.race([_e, Q]).catch((Ce) => {
            throw Ce instanceof Dt.LDTimeoutError && i.error(`waitForInitialization error: ${Ce}`), Ce;
          });
        }(D);
      i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
    }
    return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), s.getInitializationPromise();
  }, waitUntilReady: () => s.getReadyPromise(), identify: function(D, X, Q) {
    if (B)
      return Ve.wrapPromiseCallback(Promise.resolve({}), Q);
    if (M)
      return i.warn(De.identifyDisabled()), Ve.wrapPromiseCallback(Promise.resolve(Ve.transformVersionedValuesToValues(O)), Q);
    const _e = x && $ ? $.clearFlags() : Promise.resolve();
    return Ve.wrapPromiseCallback(_e.then(() => N.processContext(D)).then(G).then((Ce) => C.fetchFlagSettings(Ce, X).then((Ne) => {
      const ae = Ve.transformVersionedValuesToValues(Ne);
      return q.setContext(Ce), f = X, Ne ? ie(Ne).then(() => ae) : ae;
    })).then((Ce) => (_ && fe(), Ce)).catch((Ce) => (a.maybeReportError(Ce), Promise.reject(Ce))), Q);
  }, getContext: function() {
    return q.getContext();
  }, variation: function(D, X) {
    return ne(D, X, !0, !1, !1).value;
  }, variationDetail: function(D, X) {
    return ne(D, X, !0, !0, !1);
  }, track: function(D, X, Q) {
    if (typeof D != "string")
      return void a.maybeReportError(new Dt.LDInvalidEventKeyError(De.unknownCustomEventKey(D)));
    Q !== void 0 && typeof Q != "number" && i.warn(De.invalidMetricValue(typeof Q)), r.customEventFilter && !r.customEventFilter(D) && i.warn(De.unknownCustomEventKey(D));
    const _e = q.getContext(), Ce = { kind: "custom", key: D, context: _e, url: r.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    _e && _e.anonymous && (Ce.contextKind = _e.anonymous ? "anonymousUser" : "user"), X != null && (Ce.data = X), Q != null && (Ce.metricValue = Q), F(Ce);
  }, on: function(D, X, Q) {
    ce(D) ? (T = !0, L && ue(), a.on(D, X, Q)) : a.on(...arguments);
  }, off: function(D) {
    if (a.off(...arguments), ce(D)) {
      let X = !1;
      a.getEvents().forEach((Q) => {
        ce(Q) && a.getEventListenerCount(Q) > 0 && (X = !0);
      }), X || (T = !1, _ && I === void 0 && ge());
    }
  }, setStreaming: function(D) {
    const X = D === null ? void 0 : D;
    X !== I && (I = X, ue());
  }, flush: function(D) {
    return Ve.wrapPromiseCallback(u ? E.flush() : Promise.resolve(), D);
  }, allFlags: function() {
    const D = {};
    if (!O)
      return D;
    for (const X in O)
      Ve.objectHasOwnProperty(O, X) && !O[X].deleted && (D[X] = ne(X, null, !l.sendEventsOnlyForVariation, !1, !0).value);
    return D;
  }, close: function(D) {
    if (B)
      return Ve.wrapPromiseCallback(Promise.resolve(), D);
    const X = () => {
      B = !0, O = {};
    }, Q = Promise.resolve().then(() => {
      if (ge(), m && m.stop(), u)
        return E.stop(), E.flush();
    }).then(X).catch(X);
    return Ve.wrapPromiseCallback(Q, D);
  } }, options: l, emitter: a, ident: q, logger: i, requestor: C, start: function() {
    u && (m && m.start(), E.start());
  }, enqueueEvent: F, getFlagsInternal: function() {
    return O;
  }, getEnvironmentId: () => d, internalChangeEventName: hv };
}, commonBasicLogger: fv, errors: Dt, messages: De, utils: Ve, getContextKeys: s9 }, c9 = $1.initialize, u9 = $1.errors;
function d9(e, t, n) {
  return (t = function(r) {
    var o = function(i, a) {
      if (typeof i != "object" || !i)
        return i;
      var s = i[Symbol.toPrimitive];
      if (s !== void 0) {
        var l = s.call(i, a || "default");
        if (typeof l != "object")
          return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(i);
    }(r, "string");
    return typeof o == "symbol" ? o : o + "";
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function pv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pv(Object(n), !0).forEach(function(r) {
      d9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var gv = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function f9(e, t, n, r, o) {
  if (o && !function() {
    var c = window.navigator && window.navigator.userAgent;
    if (c) {
      var u = c.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (u)
        return parseInt(u[2], 10) < 73;
    }
    return !0;
  }())
    return gv;
  var i = new window.XMLHttpRequest();
  for (var a in i.open(e, t, !o), n || {})
    Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
  if (o) {
    try {
      i.send(r);
    } catch {
    }
    return gv;
  }
  var s, l = new Promise(function(c, u) {
    i.addEventListener("load", function() {
      s || c({ status: i.status, header: function(d) {
        return i.getResponseHeader(d);
      }, body: i.responseText });
    }), i.addEventListener("error", function() {
      s || u(new Error());
    }), i.send(r);
  });
  return { promise: l, cancel: function() {
    s = !0, i.abort();
  } };
}
var wu = (e) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function h9(e, t, n, r) {
  var o, i, a = ((e.kind === "substring" || e.kind === "regex") && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
  switch (e.kind) {
    case "exact":
      i = t, o = new RegExp("^" + wu(e.url) + "/?$");
      break;
    case "canonical":
      i = a, o = new RegExp("^" + wu(e.url) + "/?$");
      break;
    case "substring":
      i = a, o = new RegExp(".*" + wu(e.substring) + ".*$");
      break;
    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return o.test(i);
}
function mv(e, t) {
  for (var n = {}, r = null, o = [], i = 0; i < e.length; i++)
    for (var a = e[i], s = a.urls || [], l = 0; l < s.length; l++)
      if (h9(s[l], window.location.href, window.location.search, window.location.hash)) {
        a.kind === "pageview" ? t("pageview", a) : (o.push(a), t("click_pageview", a));
        break;
      }
  return o.length > 0 && (r = function(c) {
    for (var u = function(f, h) {
      for (var p = [], g = 0; g < h.length; g++)
        for (var v = f.target, b = h[g], m = b.selector, w = document.querySelectorAll(m); v && w.length > 0; ) {
          for (var E = 0; E < w.length; E++)
            v === w[E] && p.push(b);
          v = v.parentNode;
        }
      return p;
    }(c, o), d = 0; d < u.length; d++)
      t("click", u[d]);
  }, document.addEventListener("click", r)), n.dispose = function() {
    document.removeEventListener("click", r);
  }, n;
}
var p9 = 300;
function v9(e, t) {
  var n, r;
  function o() {
    r && r.dispose(), n && n.length && (r = mv(n, i));
  }
  function i(a, s) {
    var l = e.ident.getContext(), c = { kind: a, key: s.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: l };
    return a === "click" && (c.selector = s.selector), e.enqueueEvent(c);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(a) {
    a && a.length > 0 && (r = mv(n = a, i), function(s, l) {
      var c, u = window.location.href;
      function d() {
        (c = window.location.href) !== u && (u = c, l());
      }
      (function f(h, p) {
        h(), setTimeout(function() {
          f(h, p);
        }, p);
      })(d, s), window.history && window.history.pushState ? window.addEventListener("popstate", d) : window.addEventListener("hashchange", d);
    }(p9, o)), t();
  }).catch(function(a) {
    e.emitter.maybeReportError(new u9.LDUnexpectedResponseError((a && a.message, a.message))), t();
  }), {};
}
var _s = "goalsReady", g9 = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function m9(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = function(u) {
    var d, f = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var h = u && u.disableSyncEventPost;
      f.httpRequest = function(b, m, w, E) {
        var C = f.synchronousFlush & !h;
        return f.synchronousFlush = !1, f9(b, m, w, E, C);
      };
    }
    f.httpAllowsPost = function() {
      return d === void 0 && (d = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), d;
    }, f.httpFallbackPing = function(b) {
      new window.Image().src = b;
    };
    var p, g = u && u.eventUrlTransformer;
    f.getCurrentUrl = function() {
      return g ? g(window.location.href) : window.location.href;
    }, f.isDoNotTrack = function() {
      var b;
      return (b = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || b === !0 || b === "1" || b === "yes";
    };
    try {
      window.localStorage && (f.localStorage = { get: function(b) {
        return new Promise(function(m) {
          m(window.localStorage.getItem(b));
        });
      }, set: function(b, m) {
        return new Promise(function(w) {
          window.localStorage.setItem(b, m), w();
        });
      }, clear: function(b) {
        return new Promise(function(m) {
          window.localStorage.removeItem(b), m();
        });
      } });
    } catch {
      f.localStorage = null;
    }
    if (u && u.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (f.eventSourceAllowsReport = !0, p = window.EventSourcePolyfill) : (f.eventSourceAllowsReport = !1, p = window.EventSource), window.EventSource) {
      var v = 3e5;
      f.eventSourceFactory = function(b, m) {
        var w = vv(vv({}, { heartbeatTimeout: v, silentTimeout: v, skipDefaultHeaders: !0 }), m);
        return new p(b, w);
      }, f.eventSourceIsActive = function(b) {
        return b.readyState === window.EventSource.OPEN || b.readyState === window.EventSource.CONNECTING;
      };
    }
    return f.userAgent = "JSClient", f.version = "3.4.0", f.diagnosticSdkData = { name: "js-client-sdk", version: "3.4.0" }, f.diagnosticPlatformData = { name: "JS" }, f.diagnosticUseCombinedEvent = !0, f;
  }(n), o = c9(e, t, n, r, g9), i = o.client, a = o.options, s = o.emitter, l = new Promise(function(u) {
    var d = s.on(_s, function() {
      s.off(_s, d), u();
    });
  });
  i.waitUntilGoalsReady = function() {
    return l;
  }, a.fetchGoals ? v9(o, function() {
    return s.emit(_s);
  }) : s.emit(_s), document.readyState !== "complete" ? window.addEventListener("load", o.start) : o.start();
  var c = function() {
    r.synchronousFlush = !0, i.flush().catch(function() {
    }), r.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && c();
  }), window.addEventListener("pagehide", c), i;
}
var y9 = 1 / 0, b9 = "[object Symbol]", C9 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, w9 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, tc = "\\ud800-\\udfff", N1 = "\\u0300-\\u036f\\ufe20-\\ufe23", F1 = "\\u20d0-\\u20f0", L1 = "\\u2700-\\u27bf", M1 = "a-z\\xdf-\\xf6\\xf8-\\xff", E9 = "\\xac\\xb1\\xd7\\xf7", _9 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", x9 = "\\u2000-\\u206f", S9 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", D1 = "A-Z\\xc0-\\xd6\\xd8-\\xde", j1 = "\\ufe0e\\ufe0f", B1 = E9 + _9 + x9 + S9, sh = "['’]", T9 = "[" + tc + "]", yv = "[" + B1 + "]", wl = "[" + N1 + F1 + "]", V1 = "\\d+", O9 = "[" + L1 + "]", U1 = "[" + M1 + "]", H1 = "[^" + tc + B1 + V1 + L1 + M1 + D1 + "]", xd = "\\ud83c[\\udffb-\\udfff]", P9 = "(?:" + wl + "|" + xd + ")", z1 = "[^" + tc + "]", lh = "(?:\\ud83c[\\udde6-\\uddff]){2}", ch = "[\\ud800-\\udbff][\\udc00-\\udfff]", di = "[" + D1 + "]", q1 = "\\u200d", bv = "(?:" + U1 + "|" + H1 + ")", R9 = "(?:" + di + "|" + H1 + ")", Cv = "(?:" + sh + "(?:d|ll|m|re|s|t|ve))?", wv = "(?:" + sh + "(?:D|LL|M|RE|S|T|VE))?", W1 = P9 + "?", G1 = "[" + j1 + "]?", A9 = "(?:" + q1 + "(?:" + [z1, lh, ch].join("|") + ")" + G1 + W1 + ")*", K1 = G1 + W1 + A9, I9 = "(?:" + [O9, lh, ch].join("|") + ")" + K1, k9 = "(?:" + [z1 + wl + "?", wl, lh, ch, T9].join("|") + ")", $9 = RegExp(sh, "g"), N9 = RegExp(wl, "g"), F9 = RegExp(xd + "(?=" + xd + ")|" + k9 + K1, "g"), L9 = RegExp([
  di + "?" + U1 + "+" + Cv + "(?=" + [yv, di, "$"].join("|") + ")",
  R9 + "+" + wv + "(?=" + [yv, di + bv, "$"].join("|") + ")",
  di + "?" + bv + "+" + Cv,
  di + "+" + wv,
  V1,
  I9
].join("|"), "g"), M9 = RegExp("[" + q1 + tc + N1 + F1 + j1 + "]"), D9 = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, j9 = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "ss"
}, B9 = typeof as == "object" && as && as.Object === Object && as, V9 = typeof self == "object" && self && self.Object === Object && self, U9 = B9 || V9 || Function("return this")();
function H9(e, t, n, r) {
  for (var o = -1, i = e ? e.length : 0; ++o < i; )
    n = t(n, e[o], o, e);
  return n;
}
function z9(e) {
  return e.split("");
}
function q9(e) {
  return e.match(C9) || [];
}
function W9(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var G9 = W9(j9);
function Y1(e) {
  return M9.test(e);
}
function K9(e) {
  return D9.test(e);
}
function Y9(e) {
  return Y1(e) ? Z9(e) : z9(e);
}
function Z9(e) {
  return e.match(F9) || [];
}
function Q9(e) {
  return e.match(L9) || [];
}
var X9 = Object.prototype, J9 = X9.toString, Ev = U9.Symbol, _v = Ev ? Ev.prototype : void 0, xv = _v ? _v.toString : void 0;
function e8(e, t, n) {
  var r = -1, o = e.length;
  t < 0 && (t = -t > o ? 0 : o + t), n = n > o ? o : n, n < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var i = Array(o); ++r < o; )
    i[r] = e[r + t];
  return i;
}
function t8(e) {
  if (typeof e == "string")
    return e;
  if (a8(e))
    return xv ? xv.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -y9 ? "-0" : t;
}
function n8(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : e8(e, t, n);
}
function r8(e) {
  return function(t) {
    t = nc(t);
    var n = Y1(t) ? Y9(t) : void 0, r = n ? n[0] : t.charAt(0), o = n ? n8(n, 1).join("") : t.slice(1);
    return r[e]() + o;
  };
}
function o8(e) {
  return function(t) {
    return H9(d8(c8(t).replace($9, "")), e, "");
  };
}
function i8(e) {
  return !!e && typeof e == "object";
}
function a8(e) {
  return typeof e == "symbol" || i8(e) && J9.call(e) == b9;
}
function nc(e) {
  return e == null ? "" : t8(e);
}
var s8 = o8(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? l8(t) : t);
});
function l8(e) {
  return u8(nc(e).toLowerCase());
}
function c8(e) {
  return e = nc(e), e && e.replace(w9, G9).replace(N9, "");
}
var u8 = r8("toUpperCase");
function d8(e, t, n) {
  return e = nc(e), t = t, t === void 0 ? K9(e) ? Q9(e) : q9(e) : e.match(t) || [];
}
var f8 = s8;
const Z1 = /* @__PURE__ */ Uf(f8);
var Sd = { exports: {} }, dt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sv;
function h8() {
  if (Sv)
    return dt;
  Sv = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
  function w(C) {
    if (typeof C == "object" && C !== null) {
      var x = C.$$typeof;
      switch (x) {
        case t:
          switch (C = C.type, C) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case u:
                case p:
                case h:
                case a:
                  return C;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function E(C) {
    return w(C) === c;
  }
  return dt.AsyncMode = l, dt.ConcurrentMode = c, dt.ContextConsumer = s, dt.ContextProvider = a, dt.Element = t, dt.ForwardRef = u, dt.Fragment = r, dt.Lazy = p, dt.Memo = h, dt.Portal = n, dt.Profiler = i, dt.StrictMode = o, dt.Suspense = d, dt.isAsyncMode = function(C) {
    return E(C) || w(C) === l;
  }, dt.isConcurrentMode = E, dt.isContextConsumer = function(C) {
    return w(C) === s;
  }, dt.isContextProvider = function(C) {
    return w(C) === a;
  }, dt.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, dt.isForwardRef = function(C) {
    return w(C) === u;
  }, dt.isFragment = function(C) {
    return w(C) === r;
  }, dt.isLazy = function(C) {
    return w(C) === p;
  }, dt.isMemo = function(C) {
    return w(C) === h;
  }, dt.isPortal = function(C) {
    return w(C) === n;
  }, dt.isProfiler = function(C) {
    return w(C) === i;
  }, dt.isStrictMode = function(C) {
    return w(C) === o;
  }, dt.isSuspense = function(C) {
    return w(C) === d;
  }, dt.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === r || C === c || C === i || C === o || C === d || C === f || typeof C == "object" && C !== null && (C.$$typeof === p || C.$$typeof === h || C.$$typeof === a || C.$$typeof === s || C.$$typeof === u || C.$$typeof === v || C.$$typeof === b || C.$$typeof === m || C.$$typeof === g);
  }, dt.typeOf = w, dt;
}
var ft = {}, Tv;
function p8() {
  return Tv || (Tv = 1, z.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, m = e ? Symbol.for("react.scope") : 60119;
    function w(te) {
      return typeof te == "string" || typeof te == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      te === r || te === c || te === i || te === o || te === d || te === f || typeof te == "object" && te !== null && (te.$$typeof === p || te.$$typeof === h || te.$$typeof === a || te.$$typeof === s || te.$$typeof === u || te.$$typeof === v || te.$$typeof === b || te.$$typeof === m || te.$$typeof === g);
    }
    function E(te) {
      if (typeof te == "object" && te !== null) {
        var ke = te.$$typeof;
        switch (ke) {
          case t:
            var se = te.type;
            switch (se) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return se;
              default:
                var D = se && se.$$typeof;
                switch (D) {
                  case s:
                  case u:
                  case p:
                  case h:
                  case a:
                    return D;
                  default:
                    return ke;
                }
            }
          case n:
            return ke;
        }
      }
    }
    var C = l, x = c, _ = s, T = a, O = t, I = u, L = r, B = p, j = h, M = n, q = i, N = o, $ = d, F = !1;
    function H(te) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), k(te) || E(te) === l;
    }
    function k(te) {
      return E(te) === c;
    }
    function W(te) {
      return E(te) === s;
    }
    function G(te) {
      return E(te) === a;
    }
    function ne(te) {
      return typeof te == "object" && te !== null && te.$$typeof === t;
    }
    function Y(te) {
      return E(te) === u;
    }
    function fe(te) {
      return E(te) === r;
    }
    function ge(te) {
      return E(te) === p;
    }
    function ie(te) {
      return E(te) === h;
    }
    function he(te) {
      return E(te) === n;
    }
    function ue(te) {
      return E(te) === i;
    }
    function ce(te) {
      return E(te) === o;
    }
    function Se(te) {
      return E(te) === d;
    }
    ft.AsyncMode = C, ft.ConcurrentMode = x, ft.ContextConsumer = _, ft.ContextProvider = T, ft.Element = O, ft.ForwardRef = I, ft.Fragment = L, ft.Lazy = B, ft.Memo = j, ft.Portal = M, ft.Profiler = q, ft.StrictMode = N, ft.Suspense = $, ft.isAsyncMode = H, ft.isConcurrentMode = k, ft.isContextConsumer = W, ft.isContextProvider = G, ft.isElement = ne, ft.isForwardRef = Y, ft.isFragment = fe, ft.isLazy = ge, ft.isMemo = ie, ft.isPortal = he, ft.isProfiler = ue, ft.isStrictMode = ce, ft.isSuspense = Se, ft.isValidElementType = w, ft.typeOf = E;
  }()), ft;
}
z.env.NODE_ENV === "production" ? Sd.exports = h8() : Sd.exports = p8();
var v8 = Sd.exports, Q1 = v8, g8 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, m8 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, X1 = {};
X1[Q1.ForwardRef] = g8;
X1[Q1.Memo] = m8;
const J1 = { useCamelCaseFlagKeys: !0, sendEventsOnFlagRead: !0 }, uh = $a({ flags: {}, flagKeyMap: {}, ldClient: void 0 }), { Provider: y8, Consumer: lD } = uh, xs = (e) => {
  var t;
  return (t = e.context) != null ? t : e.user;
}, Td = (e) => {
  const t = {};
  for (const n in e)
    n.indexOf("$") !== 0 && (t[Z1(n)] = e[n]);
  return t;
}, b8 = (e, t) => {
  const n = {};
  for (const r in e)
    t && t[r] === void 0 || (n[r] = e[r].current);
  return n;
}, Eu = (e, t) => {
  const n = e.allFlags();
  return t ? Object.keys(t).reduce((r, o) => (r[o] = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : t[o], r), {}) : n;
};
function _u(e, t, n = J1, r) {
  const o = function(l, c) {
    return c === void 0 ? l : Object.keys(c).reduce((u, d) => (Od(l, d) && (u[d] = l[d]), u), {});
  }(t, r), { useCamelCaseFlagKeys: i = !0 } = n, [a, s = {}] = i ? function(l) {
    const c = {}, u = {};
    for (const d in l) {
      if (d.indexOf("$") === 0)
        continue;
      const f = Z1(d);
      c[f] = l[d], u[f] = d;
    }
    return [c, u];
  }(o) : [o];
  return { flags: n.sendEventsOnFlagRead ? C8(e, a, s, i) : a, flagKeyMap: s };
}
function Od(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function C8(e, t, n, r) {
  return new Proxy(t, { get(o, i, a) {
    const s = Reflect.get(o, i, a), l = r && Od(n, i) || Od(o, i);
    if (typeof i == "symbol" || !l)
      return s;
    if (s === void 0)
      return;
    const c = r ? n[i] : i;
    return e.variation(c, s);
  } });
}
Td.camelCaseKeys = Td;
const w8 = { wrapperName: "react-client-sdk", wrapperVersion: "3.4.0", sendEventsOnlyForVariation: !0 };
var E8 = Object.defineProperty, _8 = Object.defineProperties, x8 = Object.getOwnPropertyDescriptors, Ov = Object.getOwnPropertySymbols, S8 = Object.prototype.hasOwnProperty, T8 = Object.prototype.propertyIsEnumerable, Pv = (e, t, n) => t in e ? E8(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, kn = (e, t) => {
  for (var n in t || (t = {}))
    S8.call(t, n) && Pv(e, n, t[n]);
  if (Ov)
    for (var n of Ov(t))
      T8.call(t, n) && Pv(e, n, t[n]);
  return e;
}, oa = (e, t) => _8(e, x8(t)), xu = (e, t, n) => new Promise((r, o) => {
  var i = (l) => {
    try {
      s(n.next(l));
    } catch (c) {
      o(c);
    }
  }, a = (l) => {
    try {
      s(n.throw(l));
    } catch (c) {
      o(c);
    }
  }, s = (l) => l.done ? r(l.value) : Promise.resolve(l.value).then(i, a);
  s((n = n.apply(e, t)).next());
});
class O8 extends nw {
  constructor(t) {
    super(t), this.getReactOptions = () => kn(kn({}, J1), this.props.reactOptions), this.subscribeToChanges = (r) => {
      const { flags: o } = this.props;
      r.on("change", (i) => {
        const a = this.getReactOptions(), s = b8(i, o), l = kn(kn({}, this.state.unproxiedFlags), s);
        Object.keys(s).length > 0 && this.setState((c) => kn(oa(kn({}, c), { unproxiedFlags: l }), _u(r, l, a, o)));
      });
    }, this.onFailed = (r, o) => {
      this.setState((i) => oa(kn({}, i), { error: o }));
    }, this.onReady = (r, o, i) => {
      const a = Eu(r, i);
      this.setState((s) => kn(oa(kn({}, s), { unproxiedFlags: a }), _u(r, a, o, i)));
    }, this.prepareLDClient = () => xu(this, null, function* () {
      var r;
      const { clientSideID: o, flags: i, options: a } = this.props;
      let s = yield this.props.ldClient;
      const l = this.getReactOptions();
      let c, u = this.state.unproxiedFlags;
      if (s)
        u = Eu(s, i);
      else {
        const d = (r = xs(this.props)) != null ? r : { anonymous: !0, kind: "user" };
        s = m9(o, d, kn(kn({}, w8), a));
        try {
          yield s.waitForInitialization(this.props.timeout), u = Eu(s, i);
        } catch (f) {
          c = f, c != null && c.name.toLowerCase().includes("timeout") && (s.on("failed", this.onFailed), s.on("ready", () => {
            this.onReady(s, l, i);
          }));
        }
      }
      this.setState((d) => oa(kn(oa(kn({}, d), { unproxiedFlags: u }), _u(s, u, l, i)), { ldClient: s, error: c })), this.subscribeToChanges(s);
    });
    const { options: n } = t;
    if (this.state = { flags: {}, unproxiedFlags: {}, flagKeyMap: {} }, n) {
      const { bootstrap: r } = n;
      if (r && r !== "localStorage") {
        const { useCamelCaseFlagKeys: o } = this.getReactOptions();
        this.state = { flags: o ? Td(r) : r, unproxiedFlags: r, flagKeyMap: {} };
      }
    }
  }
  componentDidMount() {
    return xu(this, null, function* () {
      const { deferInitialization: t } = this.props;
      t && !xs(this.props) || (yield this.prepareLDClient());
    });
  }
  componentDidUpdate(t) {
    return xu(this, null, function* () {
      const { deferInitialization: n } = this.props, r = !xs(t) && xs(this.props);
      n && r && (yield this.prepareLDClient());
    });
  }
  render() {
    const { flags: t, flagKeyMap: n, ldClient: r, error: o } = this.state;
    return ee.createElement(y8, { value: { flags: t, flagKeyMap: n, ldClient: r, error: o } }, this.props.children);
  }
}
const dh = () => {
  const { flags: e } = Bt(uh);
  return e;
}, P8 = () => {
  const { ldClient: e } = Bt(uh);
  return e;
}, R8 = (e) => {
  const [t, n] = wt(!1), r = P8();
  return ut(() => {
    const o = async () => {
      e.getCurrentUser().then((i) => {
        i && r && (r.identify({
          kind: "user",
          key: i.id,
          email: i.email
        }), n(!0));
      }).catch(console.error);
    };
    e.addCallbackAfterSetToken(() => o());
  }, [e, r]), t;
};
class Da {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    const n = {
      listener: t
    };
    return this.listeners.add(n), this.onSubscribe(), () => {
      this.listeners.delete(n), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const Ea = typeof window > "u" || "Deno" in window;
function Xn() {
}
function A8(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Pd(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function ey(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function fa(e, t, n) {
  return rc(e) ? typeof t == "function" ? {
    ...n,
    queryKey: e,
    queryFn: t
  } : {
    ...t,
    queryKey: e
  } : e;
}
function ao(e, t, n) {
  return rc(e) ? [{
    ...t,
    queryKey: e
  }, n] : [e || {}, t];
}
function Rv(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: o,
    predicate: i,
    queryKey: a,
    stale: s
  } = e;
  if (rc(a)) {
    if (r) {
      if (t.queryHash !== fh(a, t.options))
        return !1;
    } else if (!hi(t.queryKey, a))
      return !1;
  }
  if (n !== "all") {
    const l = t.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || typeof o < "u" && o !== t.state.fetchStatus || i && !i(t));
}
function Av(e, t) {
  const {
    exact: n,
    fetching: r,
    predicate: o,
    mutationKey: i
  } = e;
  if (rc(i)) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ro(t.options.mutationKey) !== Ro(i))
        return !1;
    } else if (!hi(t.options.mutationKey, i))
      return !1;
  }
  return !(typeof r == "boolean" && t.state.status === "loading" !== r || o && !o(t));
}
function fh(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Ro)(e);
}
function Ro(e) {
  return JSON.stringify(e, (t, n) => Ad(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n);
}
function hi(e, t) {
  return ty(e, t);
}
function ty(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !ty(e[n], t[n])) : !1;
}
function ny(e, t) {
  if (e === t)
    return e;
  const n = Iv(e) && Iv(t);
  if (n || Ad(e) && Ad(t)) {
    const r = n ? e.length : Object.keys(e).length, o = n ? t : Object.keys(t), i = o.length, a = n ? [] : {};
    let s = 0;
    for (let l = 0; l < i; l++) {
      const c = n ? l : o[l];
      a[c] = ny(e[c], t[c]), a[c] === e[c] && s++;
    }
    return r === i && s === r ? e : a;
  }
  return t;
}
function Rd(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Iv(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Ad(e) {
  if (!kv(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!kv(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function kv(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function rc(e) {
  return Array.isArray(e);
}
function ry(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function $v(e) {
  ry(0).then(e);
}
function I8() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Id(e, t, n) {
  return n.isDataEqual != null && n.isDataEqual(e, t) ? e : typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? ny(e, t) : t;
}
class k8 extends Da {
  constructor() {
    super(), this.setup = (t) => {
      if (!Ea && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), window.addEventListener("focus", n, !1), () => {
          window.removeEventListener("visibilitychange", n), window.removeEventListener("focus", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var n;
    this.setup = t, (n = this.cleanup) == null || n.call(this), this.cleanup = t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(t) {
    this.focused !== t && (this.focused = t, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const El = new k8(), Nv = ["online", "offline"];
class $8 extends Da {
  constructor() {
    super(), this.setup = (t) => {
      if (!Ea && window.addEventListener) {
        const n = () => t();
        return Nv.forEach((r) => {
          window.addEventListener(r, n, !1);
        }), () => {
          Nv.forEach((r) => {
            window.removeEventListener(r, n);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var n;
    this.setup = t, (n = this.cleanup) == null || n.call(this), this.cleanup = t((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(t) {
    this.online !== t && (this.online = t, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const _l = new $8();
function N8(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function oc(e) {
  return (e ?? "online") === "online" ? _l.isOnline() : !0;
}
class oy {
  constructor(t) {
    this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}
function Xs(e) {
  return e instanceof oy;
}
function iy(e) {
  let t = !1, n = 0, r = !1, o, i, a;
  const s = new Promise((v, b) => {
    i = v, a = b;
  }), l = (v) => {
    r || (h(new oy(v)), e.abort == null || e.abort());
  }, c = () => {
    t = !0;
  }, u = () => {
    t = !1;
  }, d = () => !El.isFocused() || e.networkMode !== "always" && !_l.isOnline(), f = (v) => {
    r || (r = !0, e.onSuccess == null || e.onSuccess(v), o == null || o(), i(v));
  }, h = (v) => {
    r || (r = !0, e.onError == null || e.onError(v), o == null || o(), a(v));
  }, p = () => new Promise((v) => {
    o = (b) => {
      const m = r || !d();
      return m && v(b), m;
    }, e.onPause == null || e.onPause();
  }).then(() => {
    o = void 0, r || e.onContinue == null || e.onContinue();
  }), g = () => {
    if (r)
      return;
    let v;
    try {
      v = e.fn();
    } catch (b) {
      v = Promise.reject(b);
    }
    Promise.resolve(v).then(f).catch((b) => {
      var m, w;
      if (r)
        return;
      const E = (m = e.retry) != null ? m : 3, C = (w = e.retryDelay) != null ? w : N8, x = typeof C == "function" ? C(n, b) : C, _ = E === !0 || typeof E == "number" && n < E || typeof E == "function" && E(n, b);
      if (t || !_) {
        h(b);
        return;
      }
      n++, e.onFail == null || e.onFail(n, b), ry(x).then(() => {
        if (d())
          return p();
      }).then(() => {
        t ? h(b) : g();
      });
    });
  };
  return oc(e.networkMode) ? g() : p().then(g), {
    promise: s,
    cancel: l,
    continue: () => (o == null ? void 0 : o()) ? s : Promise.resolve(),
    cancelRetry: c,
    continueRetry: u
  };
}
const hh = console;
function F8() {
  let e = [], t = 0, n = (u) => {
    u();
  }, r = (u) => {
    u();
  };
  const o = (u) => {
    let d;
    t++;
    try {
      d = u();
    } finally {
      t--, t || s();
    }
    return d;
  }, i = (u) => {
    t ? e.push(u) : $v(() => {
      n(u);
    });
  }, a = (u) => (...d) => {
    i(() => {
      u(...d);
    });
  }, s = () => {
    const u = e;
    e = [], u.length && $v(() => {
      r(() => {
        u.forEach((d) => {
          n(d);
        });
      });
    });
  };
  return {
    batch: o,
    batchCalls: a,
    schedule: i,
    setNotifyFunction: (u) => {
      n = u;
    },
    setBatchNotifyFunction: (u) => {
      r = u;
    }
  };
}
const Gt = F8();
class ay {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Pd(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(t) {
    this.cacheTime = Math.max(this.cacheTime || 0, t ?? (Ea ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class L8 extends ay {
  constructor(t) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.cache = t.cache, this.logger = t.logger || hh, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.initialState = t.state || M8(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(t, n) {
    const r = Id(this.state.data, t, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    this.dispatch({
      type: "setState",
      state: t,
      setStateOptions: n
    });
  }
  cancel(t) {
    var n;
    const r = this.promise;
    return (n = this.retryer) == null || n.cancel(t), r ? r.then(Xn).catch(Xn) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !ey(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const n = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    n && n.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  onOnline() {
    var t;
    const n = this.observers.find((r) => r.shouldFetchOnReconnect());
    n && n.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: t
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(t, n) {
    var r, o;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && n != null && n.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var i;
        return (i = this.retryer) == null || i.continueRetry(), this.promise;
      }
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const h = this.observers.find((p) => p.options.queryFn);
      h && this.setOptions(h.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"));
    const a = I8(), s = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, l = (h) => {
      Object.defineProperty(h, "signal", {
        enumerable: !0,
        get: () => {
          if (a)
            return this.abortSignalConsumed = !0, a.signal;
        }
      });
    };
    l(s);
    const c = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(s)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), u = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: c
    };
    if (l(u), (r = this.options.behavior) == null || r.onFetch(u), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((o = u.fetchOptions) == null ? void 0 : o.meta)) {
      var d;
      this.dispatch({
        type: "fetch",
        meta: (d = u.fetchOptions) == null ? void 0 : d.meta
      });
    }
    const f = (h) => {
      if (Xs(h) && h.silent || this.dispatch({
        type: "error",
        error: h
      }), !Xs(h)) {
        var p, g, v, b;
        (p = (g = this.cache.config).onError) == null || p.call(g, h, this), (v = (b = this.cache.config).onSettled) == null || v.call(b, this.state.data, h, this), process.env.NODE_ENV !== "production" && this.logger.error(h);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = iy({
      fn: u.fetchFn,
      abort: a == null ? void 0 : a.abort.bind(a),
      onSuccess: (h) => {
        var p, g, v, b;
        if (typeof h > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), f(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(h), (p = (g = this.cache.config).onSuccess) == null || p.call(g, h, this), (v = (b = this.cache.config).onSettled) == null || v.call(b, h, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: f,
      onFail: (h, p) => {
        this.dispatch({
          type: "failed",
          failureCount: h,
          error: p
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: u.options.retry,
      retryDelay: u.options.retryDelay,
      networkMode: u.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(t) {
    const n = (r) => {
      var o, i;
      switch (t.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (o = t.meta) != null ? o : null,
            fetchStatus: oc(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...r,
            data: t.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (i = t.dataUpdatedAt) != null ? i : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const a = t.error;
          return Xs(a) && a.revert && this.revertState ? {
            ...this.revertState,
            fetchStatus: "idle"
          } : {
            ...r,
            error: a,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: a,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...t.state
          };
      }
    };
    this.state = n(this.state), Gt.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(t);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }
}
function M8(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = typeof t < "u", r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class D8 extends Da {
  constructor(t) {
    super(), this.config = t || {}, this.queries = [], this.queriesMap = {};
  }
  build(t, n, r) {
    var o;
    const i = n.queryKey, a = (o = n.queryHash) != null ? o : fh(i, n);
    let s = this.get(a);
    return s || (s = new L8({
      cache: this,
      logger: t.getLogger(),
      queryKey: i,
      queryHash: a,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(i)
    }), this.add(s)), s;
  }
  add(t) {
    this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = this.queriesMap[t.queryHash];
    n && (t.destroy(), this.queries = this.queries.filter((r) => r !== t), n === t && delete this.queriesMap[t.queryHash], this.notify({
      type: "removed",
      query: t
    }));
  }
  clear() {
    Gt.batch(() => {
      this.queries.forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.queriesMap[t];
  }
  getAll() {
    return this.queries;
  }
  find(t, n) {
    const [r] = ao(t, n);
    return typeof r.exact > "u" && (r.exact = !0), this.queries.find((o) => Rv(r, o));
  }
  findAll(t, n) {
    const [r] = ao(t, n);
    return Object.keys(r).length > 0 ? this.queries.filter((o) => Rv(r, o)) : this.queries;
  }
  notify(t) {
    Gt.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(t);
      });
    });
  }
  onFocus() {
    Gt.batch(() => {
      this.queries.forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    Gt.batch(() => {
      this.queries.forEach((t) => {
        t.onOnline();
      });
    });
  }
}
class j8 extends ay {
  constructor(t) {
    super(), this.defaultOptions = t.defaultOptions, this.mutationId = t.mutationId, this.mutationCache = t.mutationCache, this.logger = t.logger || hh, this.observers = [], this.state = t.state || B8(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(t) {
    this.dispatch({
      type: "setState",
      state: t
    });
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers = this.observers.filter((n) => n !== t), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var t, n;
    return (t = (n = this.retryer) == null ? void 0 : n.continue()) != null ? t : this.execute();
  }
  async execute() {
    const t = () => {
      var _;
      return this.retryer = iy({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (T, O) => {
          this.dispatch({
            type: "failed",
            failureCount: T,
            error: O
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (_ = this.options.retry) != null ? _ : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, n = this.state.status === "loading";
    try {
      var r, o, i, a, s, l, c, u;
      if (!n) {
        var d, f, h, p;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((d = (f = this.mutationCache.config).onMutate) == null ? void 0 : d.call(f, this.state.variables, this));
        const T = await ((h = (p = this.options).onMutate) == null ? void 0 : h.call(p, this.state.variables));
        T !== this.state.context && this.dispatch({
          type: "loading",
          context: T,
          variables: this.state.variables
        });
      }
      const _ = await t();
      return await ((r = (o = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(o, _, this.state.variables, this.state.context, this)), await ((i = (a = this.options).onSuccess) == null ? void 0 : i.call(a, _, this.state.variables, this.state.context)), await ((s = (l = this.mutationCache.config).onSettled) == null ? void 0 : s.call(l, _, null, this.state.variables, this.state.context, this)), await ((c = (u = this.options).onSettled) == null ? void 0 : c.call(u, _, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: _
      }), _;
    } catch (_) {
      try {
        var g, v, b, m, w, E, C, x;
        throw await ((g = (v = this.mutationCache.config).onError) == null ? void 0 : g.call(v, _, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(_), await ((b = (m = this.options).onError) == null ? void 0 : b.call(m, _, this.state.variables, this.state.context)), await ((w = (E = this.mutationCache.config).onSettled) == null ? void 0 : w.call(E, void 0, _, this.state.variables, this.state.context, this)), await ((C = (x = this.options).onSettled) == null ? void 0 : C.call(x, void 0, _, this.state.variables, this.state.context)), _;
      } finally {
        this.dispatch({
          type: "error",
          error: _
        });
      }
    }
  }
  dispatch(t) {
    const n = (r) => {
      switch (t.type) {
        case "failed":
          return {
            ...r,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "loading":
          return {
            ...r,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !oc(this.options.networkMode),
            status: "loading",
            variables: t.variables
          };
        case "success":
          return {
            ...r,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: t.error,
            failureCount: r.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...r,
            ...t.state
          };
      }
    };
    this.state = n(this.state), Gt.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(t);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
}
function B8() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class V8 extends Da {
  constructor(t) {
    super(), this.config = t || {}, this.mutations = [], this.mutationId = 0;
  }
  build(t, n, r) {
    const o = new j8({
      mutationCache: this,
      logger: t.getLogger(),
      mutationId: ++this.mutationId,
      options: t.defaultMutationOptions(n),
      state: r,
      defaultOptions: n.mutationKey ? t.getMutationDefaults(n.mutationKey) : void 0
    });
    return this.add(o), o;
  }
  add(t) {
    this.mutations.push(t), this.notify({
      type: "added",
      mutation: t
    });
  }
  remove(t) {
    this.mutations = this.mutations.filter((n) => n !== t), this.notify({
      type: "removed",
      mutation: t
    });
  }
  clear() {
    Gt.batch(() => {
      this.mutations.forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(t) {
    return typeof t.exact > "u" && (t.exact = !0), this.mutations.find((n) => Av(t, n));
  }
  findAll(t) {
    return this.mutations.filter((n) => Av(t, n));
  }
  notify(t) {
    Gt.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    var t;
    return this.resuming = ((t = this.resuming) != null ? t : Promise.resolve()).then(() => {
      const n = this.mutations.filter((r) => r.state.isPaused);
      return Gt.batch(() => n.reduce((r, o) => r.then(() => o.continue().catch(Xn)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function U8() {
  return {
    onFetch: (e) => {
      e.fetchFn = () => {
        var t, n, r, o, i, a;
        const s = (t = e.fetchOptions) == null || (n = t.meta) == null ? void 0 : n.refetchPage, l = (r = e.fetchOptions) == null || (o = r.meta) == null ? void 0 : o.fetchMore, c = l == null ? void 0 : l.pageParam, u = (l == null ? void 0 : l.direction) === "forward", d = (l == null ? void 0 : l.direction) === "backward", f = ((i = e.state.data) == null ? void 0 : i.pages) || [], h = ((a = e.state.data) == null ? void 0 : a.pageParams) || [];
        let p = h, g = !1;
        const v = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => {
              var _;
              if ((_ = e.signal) != null && _.aborted)
                g = !0;
              else {
                var T;
                (T = e.signal) == null || T.addEventListener("abort", () => {
                  g = !0;
                });
              }
              return e.signal;
            }
          });
        }, b = e.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + e.options.queryHash + "'")), m = (x, _, T, O) => (p = O ? [_, ...p] : [...p, _], O ? [T, ...x] : [...x, T]), w = (x, _, T, O) => {
          if (g)
            return Promise.reject("Cancelled");
          if (typeof T > "u" && !_ && x.length)
            return Promise.resolve(x);
          const I = {
            queryKey: e.queryKey,
            pageParam: T,
            meta: e.options.meta
          };
          v(I);
          const L = b(I);
          return Promise.resolve(L).then((j) => m(x, T, j, O));
        };
        let E;
        if (!f.length)
          E = w([]);
        else if (u) {
          const x = typeof c < "u", _ = x ? c : Fv(e.options, f);
          E = w(f, x, _);
        } else if (d) {
          const x = typeof c < "u", _ = x ? c : H8(e.options, f);
          E = w(f, x, _, !0);
        } else {
          p = [];
          const x = typeof e.options.getNextPageParam > "u";
          E = (s && f[0] ? s(f[0], 0, f) : !0) ? w([], x, h[0]) : Promise.resolve(m([], h[0], f[0]));
          for (let T = 1; T < f.length; T++)
            E = E.then((O) => {
              if (s && f[T] ? s(f[T], T, f) : !0) {
                const L = x ? h[T] : Fv(e.options, O);
                return w(O, x, L);
              }
              return Promise.resolve(m(O, h[T], f[T]));
            });
        }
        return E.then((x) => ({
          pages: x,
          pageParams: p
        }));
      };
    }
  };
}
function Fv(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function H8(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
class z8 {
  constructor(t = {}) {
    this.queryCache = t.queryCache || new D8(), this.mutationCache = t.mutationCache || new V8(), this.logger = t.logger || hh, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && t.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = El.subscribe(() => {
      El.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = _l.subscribe(() => {
      _l.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var t, n;
    this.mountCount--, this.mountCount === 0 && ((t = this.unsubscribeFocus) == null || t.call(this), this.unsubscribeFocus = void 0, (n = this.unsubscribeOnline) == null || n.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(t, n) {
    const [r] = ao(t, n);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(t) {
    return this.mutationCache.findAll({
      ...t,
      fetching: !0
    }).length;
  }
  getQueryData(t, n) {
    var r;
    return (r = this.queryCache.find(t, n)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t, n, r) {
    const o = fa(t, n, r), i = this.getQueryData(o.queryKey);
    return i ? Promise.resolve(i) : this.fetchQuery(o);
  }
  getQueriesData(t) {
    return this.getQueryCache().findAll(t).map(({
      queryKey: n,
      state: r
    }) => {
      const o = r.data;
      return [n, o];
    });
  }
  setQueryData(t, n, r) {
    const o = this.queryCache.find(t), i = o == null ? void 0 : o.state.data, a = A8(n, i);
    if (typeof a > "u")
      return;
    const s = fa(t), l = this.defaultQueryOptions(s);
    return this.queryCache.build(this, l).setData(a, {
      ...r,
      manual: !0
    });
  }
  setQueriesData(t, n, r) {
    return Gt.batch(() => this.getQueryCache().findAll(t).map(({
      queryKey: o
    }) => [o, this.setQueryData(o, n, r)]));
  }
  getQueryState(t, n) {
    var r;
    return (r = this.queryCache.find(t, n)) == null ? void 0 : r.state;
  }
  removeQueries(t, n) {
    const [r] = ao(t, n), o = this.queryCache;
    Gt.batch(() => {
      o.findAll(r).forEach((i) => {
        o.remove(i);
      });
    });
  }
  resetQueries(t, n, r) {
    const [o, i] = ao(t, n, r), a = this.queryCache, s = {
      type: "active",
      ...o
    };
    return Gt.batch(() => (a.findAll(o).forEach((l) => {
      l.reset();
    }), this.refetchQueries(s, i)));
  }
  cancelQueries(t, n, r) {
    const [o, i = {}] = ao(t, n, r);
    typeof i.revert > "u" && (i.revert = !0);
    const a = Gt.batch(() => this.queryCache.findAll(o).map((s) => s.cancel(i)));
    return Promise.all(a).then(Xn).catch(Xn);
  }
  invalidateQueries(t, n, r) {
    const [o, i] = ao(t, n, r);
    return Gt.batch(() => {
      var a, s;
      if (this.queryCache.findAll(o).forEach((c) => {
        c.invalidate();
      }), o.refetchType === "none")
        return Promise.resolve();
      const l = {
        ...o,
        type: (a = (s = o.refetchType) != null ? s : o.type) != null ? a : "active"
      };
      return this.refetchQueries(l, i);
    });
  }
  refetchQueries(t, n, r) {
    const [o, i] = ao(t, n, r), a = Gt.batch(() => this.queryCache.findAll(o).filter((l) => !l.isDisabled()).map((l) => {
      var c;
      return l.fetch(void 0, {
        ...i,
        cancelRefetch: (c = i == null ? void 0 : i.cancelRefetch) != null ? c : !0,
        meta: {
          refetchPage: o.refetchPage
        }
      });
    }));
    let s = Promise.all(a).then(Xn);
    return i != null && i.throwOnError || (s = s.catch(Xn)), s;
  }
  fetchQuery(t, n, r) {
    const o = fa(t, n, r), i = this.defaultQueryOptions(o);
    typeof i.retry > "u" && (i.retry = !1);
    const a = this.queryCache.build(this, i);
    return a.isStaleByTime(i.staleTime) ? a.fetch(i) : Promise.resolve(a.state.data);
  }
  prefetchQuery(t, n, r) {
    return this.fetchQuery(t, n, r).then(Xn).catch(Xn);
  }
  fetchInfiniteQuery(t, n, r) {
    const o = fa(t, n, r);
    return o.behavior = U8(), this.fetchQuery(o);
  }
  prefetchInfiniteQuery(t, n, r) {
    return this.fetchInfiniteQuery(t, n, r).then(Xn).catch(Xn);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(t) {
    this.defaultOptions = t;
  }
  setQueryDefaults(t, n) {
    const r = this.queryDefaults.find((o) => Ro(t) === Ro(o.queryKey));
    r ? r.defaultOptions = n : this.queryDefaults.push({
      queryKey: t,
      defaultOptions: n
    });
  }
  getQueryDefaults(t) {
    if (!t)
      return;
    const n = this.queryDefaults.find((r) => hi(t, r.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((o) => hi(t, o.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(t) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), n == null ? void 0 : n.defaultOptions;
  }
  setMutationDefaults(t, n) {
    const r = this.mutationDefaults.find((o) => Ro(t) === Ro(o.mutationKey));
    r ? r.defaultOptions = n : this.mutationDefaults.push({
      mutationKey: t,
      defaultOptions: n
    });
  }
  getMutationDefaults(t) {
    if (!t)
      return;
    const n = this.mutationDefaults.find((r) => hi(t, r.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((o) => hi(t, o.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(t) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), n == null ? void 0 : n.defaultOptions;
  }
  defaultQueryOptions(t) {
    if (t != null && t._defaulted)
      return t;
    const n = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(t == null ? void 0 : t.queryKey),
      ...t,
      _defaulted: !0
    };
    return !n.queryHash && n.queryKey && (n.queryHash = fh(n.queryKey, n)), typeof n.refetchOnReconnect > "u" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.useErrorBoundary > "u" && (n.useErrorBoundary = !!n.suspense), n;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(t == null ? void 0 : t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class q8 extends Da {
  constructor(t, n) {
    super(), this.client = t, this.options = n, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), Lv(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return kd(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return kd(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, o = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(t), process.env.NODE_ENV !== "production" && typeof (t == null ? void 0 : t.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), Rd(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const i = this.hasListeners();
    i && Mv(this.currentQuery, o, this.options, r) && this.executeFetch(), this.updateResult(n), i && (this.currentQuery !== o || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const a = this.computeRefetchInterval();
    i && (this.currentQuery !== o || this.options.enabled !== r.enabled || a !== this.currentRefetchInterval) && this.updateRefetchInterval(a);
  }
  getOptimisticResult(t) {
    const n = this.client.getQueryCache().build(this.client, t), r = this.createResult(n, t);
    return G8(this, r, t) && (this.currentResult = r, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), r;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(t) {
    const n = {};
    return Object.keys(t).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), t[r])
      });
    }), n;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: t,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        refetchPage: t
      }
    });
  }
  fetchOptimistic(t) {
    const n = this.client.defaultQueryOptions(t), r = this.client.getQueryCache().build(this.client, n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    var n;
    return this.executeFetch({
      ...t,
      cancelRefetch: (n = t.cancelRefetch) != null ? n : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(t) {
    this.updateQuery();
    let n = this.currentQuery.fetch(this.options, t);
    return t != null && t.throwOnError || (n = n.catch(Xn)), n;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), Ea || this.currentResult.isStale || !Pd(this.options.staleTime))
      return;
    const n = ey(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, n);
  }
  computeRefetchInterval() {
    var t;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (t = this.options.refetchInterval) != null ? t : !1;
  }
  updateRefetchInterval(t) {
    this.clearRefetchInterval(), this.currentRefetchInterval = t, !(Ea || this.options.enabled === !1 || !Pd(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || El.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(t, n) {
    const r = this.currentQuery, o = this.options, i = this.currentResult, a = this.currentResultState, s = this.currentResultOptions, l = t !== r, c = l ? t.state : this.currentQueryInitialState, u = l ? this.currentResult : this.previousQueryResult, {
      state: d
    } = t;
    let {
      dataUpdatedAt: f,
      error: h,
      errorUpdatedAt: p,
      fetchStatus: g,
      status: v
    } = d, b = !1, m = !1, w;
    if (n._optimisticResults) {
      const T = this.hasListeners(), O = !T && Lv(t, n), I = T && Mv(t, r, n, o);
      (O || I) && (g = oc(t.options.networkMode) ? "fetching" : "paused", f || (v = "loading")), n._optimisticResults === "isRestoring" && (g = "idle");
    }
    if (n.keepPreviousData && !d.dataUpdatedAt && u != null && u.isSuccess && v !== "error")
      w = u.data, f = u.dataUpdatedAt, v = u.status, b = !0;
    else if (n.select && typeof d.data < "u")
      if (i && d.data === (a == null ? void 0 : a.data) && n.select === this.selectFn)
        w = this.selectResult;
      else
        try {
          this.selectFn = n.select, w = n.select(d.data), w = Id(i == null ? void 0 : i.data, w, n), this.selectResult = w, this.selectError = null;
        } catch (T) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(T), this.selectError = T;
        }
    else
      w = d.data;
    if (typeof n.placeholderData < "u" && typeof w > "u" && v === "loading") {
      let T;
      if (i != null && i.isPlaceholderData && n.placeholderData === (s == null ? void 0 : s.placeholderData))
        T = i.data;
      else if (T = typeof n.placeholderData == "function" ? n.placeholderData() : n.placeholderData, n.select && typeof T < "u")
        try {
          T = n.select(T), this.selectError = null;
        } catch (O) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(O), this.selectError = O;
        }
      typeof T < "u" && (v = "success", w = Id(i == null ? void 0 : i.data, T, n), m = !0);
    }
    this.selectError && (h = this.selectError, w = this.selectResult, p = Date.now(), v = "error");
    const E = g === "fetching", C = v === "loading", x = v === "error";
    return {
      status: v,
      fetchStatus: g,
      isLoading: C,
      isSuccess: v === "success",
      isError: x,
      isInitialLoading: C && E,
      data: w,
      dataUpdatedAt: f,
      error: h,
      errorUpdatedAt: p,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > c.dataUpdateCount || d.errorUpdateCount > c.errorUpdateCount,
      isFetching: E,
      isRefetching: E && !C,
      isLoadingError: x && d.dataUpdatedAt === 0,
      isPaused: g === "paused",
      isPlaceholderData: m,
      isPreviousData: b,
      isRefetchError: x && d.dataUpdatedAt !== 0,
      isStale: ph(t, n),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(t) {
    const n = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, Rd(r, n))
      return;
    this.currentResult = r;
    const o = {
      cache: !0
    }, i = () => {
      if (!n)
        return !0;
      const {
        notifyOnChangeProps: a
      } = this.options, s = typeof a == "function" ? a() : a;
      if (s === "all" || !s && !this.trackedProps.size)
        return !0;
      const l = new Set(s ?? this.trackedProps);
      return this.options.useErrorBoundary && l.add("error"), Object.keys(this.currentResult).some((c) => {
        const u = c;
        return this.currentResult[u] !== n[u] && l.has(u);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && i() && (o.listeners = !0), this.notify({
      ...o,
      ...t
    });
  }
  updateQuery() {
    const t = this.client.getQueryCache().build(this.client, this.options);
    if (t === this.currentQuery)
      return;
    const n = this.currentQuery;
    this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate(t) {
    const n = {};
    t.type === "success" ? n.onSuccess = !t.manual : t.type === "error" && !Xs(t.error) && (n.onError = !0), this.updateResult(n), this.hasListeners() && this.updateTimers();
  }
  notify(t) {
    Gt.batch(() => {
      if (t.onSuccess) {
        var n, r, o, i;
        (n = (r = this.options).onSuccess) == null || n.call(r, this.currentResult.data), (o = (i = this.options).onSettled) == null || o.call(i, this.currentResult.data, null);
      } else if (t.onError) {
        var a, s, l, c;
        (a = (s = this.options).onError) == null || a.call(s, this.currentResult.error), (l = (c = this.options).onSettled) == null || l.call(c, void 0, this.currentResult.error);
      }
      t.listeners && this.listeners.forEach(({
        listener: u
      }) => {
        u(this.currentResult);
      }), t.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function W8(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function Lv(e, t) {
  return W8(e, t) || e.state.dataUpdatedAt > 0 && kd(e, t, t.refetchOnMount);
}
function kd(e, t, n) {
  if (t.enabled !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && ph(e, t);
  }
  return !1;
}
function Mv(e, t, n, r) {
  return n.enabled !== !1 && (e !== t || r.enabled === !1) && (!n.suspense || e.state.status !== "error") && ph(e, n);
}
function ph(e, t) {
  return e.isStaleByTime(t.staleTime);
}
function G8(e, t, n) {
  return n.keepPreviousData ? !1 : n.placeholderData !== void 0 ? t.isPlaceholderData : !Rd(e.getCurrentResult(), t);
}
var $d = { exports: {} }, Su = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dv;
function K8() {
  if (Dv)
    return Su;
  Dv = 1;
  var e = ee;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function s(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, v = p[1];
    return i(function() {
      g.value = h, g.getSnapshot = f, l(g) && v({ inst: g });
    }, [d, h, f]), o(function() {
      return l(g) && v({ inst: g }), d(function() {
        l(g) && v({ inst: g });
      });
    }, [d]), a(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return Su.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Su;
}
var Tu = {}, jv;
function Y8() {
  return jv || (jv = 1, z.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = ee, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var E = arguments.length, C = new Array(E > 1 ? E - 1 : 0), x = 1; x < E; x++)
          C[x - 1] = arguments[x];
        r("error", w, C);
      }
    }
    function r(w, E, C) {
      {
        var x = t.ReactDebugCurrentFrame, _ = x.getStackAddendum();
        _ !== "" && (E += "%s", C = C.concat([_]));
        var T = C.map(function(O) {
          return String(O);
        });
        T.unshift("Warning: " + E), Function.prototype.apply.call(console[w], console, T);
      }
    }
    function o(w, E) {
      return w === E && (w !== 0 || 1 / w === 1 / E) || w !== w && E !== E;
    }
    var i = typeof Object.is == "function" ? Object.is : o, a = e.useState, s = e.useEffect, l = e.useLayoutEffect, c = e.useDebugValue, u = !1, d = !1;
    function f(w, E, C) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var x = E();
      if (!d) {
        var _ = E();
        i(x, _) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var T = a({
        inst: {
          value: x,
          getSnapshot: E
        }
      }), O = T[0].inst, I = T[1];
      return l(function() {
        O.value = x, O.getSnapshot = E, h(O) && I({
          inst: O
        });
      }, [w, x, E]), s(function() {
        h(O) && I({
          inst: O
        });
        var L = function() {
          h(O) && I({
            inst: O
          });
        };
        return w(L);
      }, [w]), c(x), x;
    }
    function h(w) {
      var E = w.getSnapshot, C = w.value;
      try {
        var x = E();
        return !i(C, x);
      } catch {
        return !0;
      }
    }
    function p(w, E, C) {
      return E();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", v = !g, b = v ? p : f, m = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b;
    Tu.useSyncExternalStore = m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Tu;
}
z.env.NODE_ENV === "production" ? $d.exports = K8() : $d.exports = Y8();
var Z8 = $d.exports;
const Q8 = Z8.useSyncExternalStore, Bv = /* @__PURE__ */ y.createContext(void 0), sy = /* @__PURE__ */ y.createContext(!1);
function ly(e, t) {
  return e || (t && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = Bv), window.ReactQueryClientContext) : Bv);
}
const X8 = ({
  context: e
} = {}) => {
  const t = y.useContext(ly(e, y.useContext(sy)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, J8 = ({
  client: e,
  children: t,
  context: n,
  contextSharing: r = !1
}) => {
  y.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]), process.env.NODE_ENV !== "production" && r && e.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const o = ly(n, r);
  return /* @__PURE__ */ y.createElement(sy.Provider, {
    value: !n && r
  }, /* @__PURE__ */ y.createElement(o.Provider, {
    value: e
  }, t));
}, cy = /* @__PURE__ */ y.createContext(!1), e7 = () => y.useContext(cy);
cy.Provider;
function t7() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
const n7 = /* @__PURE__ */ y.createContext(t7()), r7 = () => y.useContext(n7);
function o7(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
const i7 = (e, t) => {
  (e.suspense || e.useErrorBoundary) && (t.isReset() || (e.retryOnMount = !1));
}, a7 = (e) => {
  y.useEffect(() => {
    e.clearReset();
  }, [e]);
}, s7 = ({
  result: e,
  errorResetBoundary: t,
  useErrorBoundary: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && o7(n, [e.error, r]), l7 = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, c7 = (e, t) => e.isLoading && e.isFetching && !t, u7 = (e, t, n) => (e == null ? void 0 : e.suspense) && c7(t, n), d7 = (e, t, n) => t.fetchOptimistic(e).then(({
  data: r
}) => {
  e.onSuccess == null || e.onSuccess(r), e.onSettled == null || e.onSettled(r, null);
}).catch((r) => {
  n.clearReset(), e.onError == null || e.onError(r), e.onSettled == null || e.onSettled(void 0, r);
});
function f7(e, t) {
  const n = X8({
    context: e.context
  }), r = e7(), o = r7(), i = n.defaultQueryOptions(e);
  i._optimisticResults = r ? "isRestoring" : "optimistic", i.onError && (i.onError = Gt.batchCalls(i.onError)), i.onSuccess && (i.onSuccess = Gt.batchCalls(i.onSuccess)), i.onSettled && (i.onSettled = Gt.batchCalls(i.onSettled)), l7(i), i7(i, o), a7(o);
  const [a] = y.useState(() => new t(n, i)), s = a.getOptimisticResult(i);
  if (Q8(y.useCallback((l) => {
    const c = r ? () => {
    } : a.subscribe(Gt.batchCalls(l));
    return a.updateResult(), c;
  }, [a, r]), () => a.getCurrentResult(), () => a.getCurrentResult()), y.useEffect(() => {
    a.setOptions(i, {
      listeners: !1
    });
  }, [i, a]), u7(i, s, r))
    throw d7(i, a, o);
  if (s7({
    result: s,
    errorResetBoundary: o,
    useErrorBoundary: i.useErrorBoundary,
    query: a.getCurrentQuery()
  }))
    throw s.error;
  return i.notifyOnChangeProps ? s : a.trackResult(s);
}
function h7(e, t, n) {
  const r = fa(e, t, n);
  return f7(r, q8);
}
const p7 = ({
  workspaceId: e,
  orgId: t
}) => {
  const n = jn(), r = Mt(() => `${n.getFarmSettingsURL()}/app/deep-actions/invite-members?workspace=${e}&invite_level=workspace&callback_uri=${window.location.href}`, [n, e]), o = Mt(() => `${n.getAccountsURL()}/app/workspaces/members?workspace=${e}&organization=${t}`, [n, t, e]), i = Mt(() => `${n.getAccountsURL()}/app/quota?workspace=${e}&organization=${t}`, [n, t, e]);
  return {
    inviteMembersDeepActionURL: r,
    membersAndContantURL: o,
    quotaMgtURL: i
  };
};
var vh = /* @__PURE__ */ $a({});
function it() {
  return it = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, it.apply(null, arguments);
}
function uy(e) {
  if (Array.isArray(e))
    return e;
}
function v7(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw o;
      }
    }
    return s;
  }
}
function Nd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function gh(e, t) {
  if (e) {
    if (typeof e == "string")
      return Nd(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Nd(e, t) : void 0;
  }
}
function dy() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function de(e, t) {
  return uy(e) || v7(e, t) || gh(e, t) || dy();
}
function Le(e) {
  "@babel/helpers - typeof";
  return Le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Le(e);
}
function g7(e, t) {
  if (Le(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Le(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fy(e) {
  var t = g7(e, "string");
  return Le(t) == "symbol" ? t : t + "";
}
function U(e, t, n) {
  return (t = fy(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function m7(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.includes(r))
        continue;
      n[r] = e[r];
    }
  return n;
}
function Hn(e, t) {
  if (e == null)
    return {};
  var n, r, o = m7(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var hy = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(hy);
var y7 = hy.exports;
const me = /* @__PURE__ */ Uf(y7), nn = Math.round;
function Ou(e, t) {
  const n = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], r = n.map((o) => parseFloat(o));
  for (let o = 0; o < 3; o += 1)
    r[o] = t(r[o] || 0, n[o] || "", o);
  return n[3] ? r[3] = n[3].includes("%") ? r[3] / 100 : r[3] : r[3] = 1, r;
}
const Vv = (e, t, n) => n === 0 ? e : e / 100;
function ia(e, t) {
  const n = t || 255;
  return e > n ? n : e < 0 ? 0 : e;
}
class Nt {
  constructor(t) {
    U(this, "isValid", !0), U(this, "r", 0), U(this, "g", 0), U(this, "b", 0), U(this, "a", 1), U(this, "_h", void 0), U(this, "_s", void 0), U(this, "_l", void 0), U(this, "_v", void 0), U(this, "_max", void 0), U(this, "_min", void 0), U(this, "_brightness", void 0);
    function n(r) {
      return r[0] in t && r[1] in t && r[2] in t;
    }
    if (t)
      if (typeof t == "string") {
        let o = function(i) {
          return r.startsWith(i);
        };
        const r = t.trim();
        /^#?[A-F\d]{3,8}$/i.test(r) ? this.fromHexString(r) : o("rgb") ? this.fromRgbString(r) : o("hsl") ? this.fromHslString(r) : (o("hsv") || o("hsb")) && this.fromHsvString(r);
      } else if (t instanceof Nt)
        this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
      else if (n("rgb"))
        this.r = ia(t.r), this.g = ia(t.g), this.b = ia(t.b), this.a = typeof t.a == "number" ? ia(t.a, 1) : 1;
      else if (n("hsl"))
        this.fromHsl(t);
      else if (n("hsv"))
        this.fromHsv(t);
      else
        throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const n = this.toHsv();
    return n.h = t, this._c(n);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(i) {
      const a = i / 255;
      return a <= 0.03928 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
    }
    const n = t(this.r), r = t(this.g), o = t(this.b);
    return 0.2126 * n + 0.7152 * r + 0.0722 * o;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = nn(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let o = this.getLightness() - t / 100;
    return o < 0 && (o = 0), this._c({
      h: n,
      s: r,
      l: o,
      a: this.a
    });
  }
  lighten(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let o = this.getLightness() + t / 100;
    return o > 1 && (o = 1), this._c({
      h: n,
      s: r,
      l: o,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, n = 50) {
    const r = this._c(t), o = n / 100, i = (s) => (r[s] - this[s]) * o + this[s], a = {
      r: nn(i("r")),
      g: nn(i("g")),
      b: nn(i("b")),
      a: nn(i("a") * 100) / 100
    };
    return this._c(a);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const n = this._c(t), r = this.a + n.a * (1 - this.a), o = (i) => nn((this[i] * this.a + n[i] * n.a * (1 - this.a)) / r);
    return this._c({
      r: o("r"),
      g: o("g"),
      b: o("b"),
      a: r
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const n = (this.r || 0).toString(16);
    t += n.length === 2 ? n : "0" + n;
    const r = (this.g || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const o = (this.b || 0).toString(16);
    if (t += o.length === 2 ? o : "0" + o, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const i = nn(this.a * 255).toString(16);
      t += i.length === 2 ? i : "0" + i;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), n = nn(this.getSaturation() * 100), r = nn(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${n}%,${r}%,${this.a})` : `hsl(${t},${n}%,${r}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, n, r) {
    const o = this.clone();
    return o[t] = ia(n, r), o;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const n = t.replace("#", "");
    function r(o, i) {
      return parseInt(n[o] + n[i || o], 16);
    }
    n.length < 6 ? (this.r = r(0), this.g = r(1), this.b = r(2), this.a = n[3] ? r(3) / 255 : 1) : (this.r = r(0, 1), this.g = r(2, 3), this.b = r(4, 5), this.a = n[6] ? r(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: n,
    l: r,
    a: o
  }) {
    if (this._h = t % 360, this._s = n, this._l = r, this.a = typeof o == "number" ? o : 1, n <= 0) {
      const f = nn(r * 255);
      this.r = f, this.g = f, this.b = f;
    }
    let i = 0, a = 0, s = 0;
    const l = t / 60, c = (1 - Math.abs(2 * r - 1)) * n, u = c * (1 - Math.abs(l % 2 - 1));
    l >= 0 && l < 1 ? (i = c, a = u) : l >= 1 && l < 2 ? (i = u, a = c) : l >= 2 && l < 3 ? (a = c, s = u) : l >= 3 && l < 4 ? (a = u, s = c) : l >= 4 && l < 5 ? (i = u, s = c) : l >= 5 && l < 6 && (i = c, s = u);
    const d = r - c / 2;
    this.r = nn((i + d) * 255), this.g = nn((a + d) * 255), this.b = nn((s + d) * 255);
  }
  fromHsv({
    h: t,
    s: n,
    v: r,
    a: o
  }) {
    this._h = t % 360, this._s = n, this._v = r, this.a = typeof o == "number" ? o : 1;
    const i = nn(r * 255);
    if (this.r = i, this.g = i, this.b = i, n <= 0)
      return;
    const a = t / 60, s = Math.floor(a), l = a - s, c = nn(r * (1 - n) * 255), u = nn(r * (1 - n * l) * 255), d = nn(r * (1 - n * (1 - l)) * 255);
    switch (s) {
      case 0:
        this.g = d, this.b = c;
        break;
      case 1:
        this.r = u, this.b = c;
        break;
      case 2:
        this.r = c, this.b = d;
        break;
      case 3:
        this.r = c, this.g = u;
        break;
      case 4:
        this.r = d, this.g = c;
        break;
      case 5:
      default:
        this.g = c, this.b = u;
        break;
    }
  }
  fromHsvString(t) {
    const n = Ou(t, Vv);
    this.fromHsv({
      h: n[0],
      s: n[1],
      v: n[2],
      a: n[3]
    });
  }
  fromHslString(t) {
    const n = Ou(t, Vv);
    this.fromHsl({
      h: n[0],
      s: n[1],
      l: n[2],
      a: n[3]
    });
  }
  fromRgbString(t) {
    const n = Ou(t, (r, o) => (
      // Convert percentage to number. e.g. 50% -> 128
      o.includes("%") ? nn(r / 100 * 255) : r
    ));
    this.r = n[0], this.g = n[1], this.b = n[2], this.a = n[3];
  }
}
var Ss = 2, Uv = 0.16, b7 = 0.05, C7 = 0.05, w7 = 0.15, py = 5, vy = 4, E7 = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function Hv(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - Ss * t : Math.round(e.h) + Ss * t : r = n ? Math.round(e.h) + Ss * t : Math.round(e.h) - Ss * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function zv(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - Uv * t : t === vy ? r = e.s + Uv : r = e.s + b7 * t, r > 1 && (r = 1), n && t === py && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Math.round(r * 100) / 100;
}
function qv(e, t, n) {
  var r;
  return n ? r = e.v + C7 * t : r = e.v - w7 * t, r = Math.max(0, Math.min(1, r)), Math.round(r * 100) / 100;
}
function _a(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = new Nt(e), o = r.toHsv(), i = py; i > 0; i -= 1) {
    var a = new Nt({
      h: Hv(o, i, !0),
      s: zv(o, i, !0),
      v: qv(o, i, !0)
    });
    n.push(a);
  }
  n.push(r);
  for (var s = 1; s <= vy; s += 1) {
    var l = new Nt({
      h: Hv(o, s),
      s: zv(o, s),
      v: qv(o, s)
    });
    n.push(l);
  }
  return t.theme === "dark" ? E7.map(function(c) {
    var u = c.index, d = c.amount;
    return new Nt(t.backgroundColor || "#141414").mix(n[u], d).toHexString();
  }) : n.map(function(c) {
    return c.toHexString();
  });
}
var Pu = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, Fd = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
Fd.primary = Fd[5];
var Ld = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
Ld.primary = Ld[5];
var Md = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
Md.primary = Md[5];
var Dd = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
Dd.primary = Dd[5];
var jd = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
jd.primary = jd[5];
var Bd = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
Bd.primary = Bd[5];
var Vd = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
Vd.primary = Vd[5];
var Ud = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
Ud.primary = Ud[5];
var xl = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
xl.primary = xl[5];
var Hd = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
Hd.primary = Hd[5];
var zd = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
zd.primary = zd[5];
var qd = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
qd.primary = qd[5];
var Wd = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
Wd.primary = Wd[5];
var Ru = {
  red: Fd,
  volcano: Ld,
  orange: Md,
  gold: Dd,
  yellow: jd,
  lime: Bd,
  green: Vd,
  cyan: Ud,
  blue: xl,
  geekblue: Hd,
  purple: zd,
  magenta: qd,
  grey: Wd
};
function Wv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function V(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wv(Object(n), !0).forEach(function(r) {
      U(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function En() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Gd(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var Gv = "data-rc-order", Kv = "data-rc-priority", _7 = "rc-util-key", Kd = /* @__PURE__ */ new Map();
function gy() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : _7;
}
function ic(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function x7(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function mh(e) {
  return Array.from((Kd.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function my(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!En())
    return null;
  var n = t.csp, r = t.prepend, o = t.priority, i = o === void 0 ? 0 : o, a = x7(r), s = a === "prependQueue", l = document.createElement("style");
  l.setAttribute(Gv, a), s && i && l.setAttribute(Kv, "".concat(i)), n != null && n.nonce && (l.nonce = n == null ? void 0 : n.nonce), l.innerHTML = e;
  var c = ic(t), u = c.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || mh(c)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(Gv)))
          return !1;
        var h = Number(f.getAttribute(Kv) || 0);
        return i >= h;
      });
      if (d.length)
        return c.insertBefore(l, d[d.length - 1].nextSibling), l;
    }
    c.insertBefore(l, u);
  } else
    c.appendChild(l);
  return l;
}
function yy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = ic(t);
  return (t.styles || mh(n)).find(function(r) {
    return r.getAttribute(gy(t)) === e;
  });
}
function xa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = yy(e, t);
  if (n) {
    var r = ic(t);
    r.removeChild(n);
  }
}
function S7(e, t) {
  var n = Kd.get(e);
  if (!n || !Gd(document, n)) {
    var r = my("", t), o = r.parentNode;
    Kd.set(e, o), e.removeChild(r);
  }
}
function Ur(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = ic(n), o = mh(r), i = V(V({}, n), {}, {
    styles: o
  });
  S7(r, i);
  var a = yy(t, i);
  if (a) {
    var s, l;
    if ((s = i.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((l = i.csp) === null || l === void 0 ? void 0 : l.nonce)) {
      var c;
      a.nonce = (c = i.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var u = my(e, i);
  return u.setAttribute(gy(i), t), u;
}
function by(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function T7(e) {
  return by(e) instanceof ShadowRoot;
}
function Sl(e) {
  return T7(e) ? by(e) : null;
}
var Yd = {}, yh = [], O7 = function(t) {
  yh.push(t);
};
function go(e, t) {
  if (z.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = yh.reduce(function(r, o) {
      return o(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function P7(e, t) {
  if (z.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = yh.reduce(function(r, o) {
      return o(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function Cy() {
  Yd = {};
}
function wy(e, t, n) {
  !t && !Yd[n] && (e(!1, n), Yd[n] = !0);
}
function Et(e, t) {
  wy(go, e, t);
}
function R7(e, t) {
  wy(P7, e, t);
}
Et.preMessage = O7;
Et.resetWarned = Cy;
Et.noteOnce = R7;
function A7(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function I7(e, t) {
  Et(e, "[@ant-design/icons] ".concat(t));
}
function Yv(e) {
  return Le(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Le(e.icon) === "object" || typeof e.icon == "function");
}
function Zv() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[A7(n)] = r;
    }
    return t;
  }, {});
}
function Zd(e, t, n) {
  return n ? /* @__PURE__ */ ee.createElement(e.tag, V(V({
    key: t
  }, Zv(e.attrs)), n), (e.children || []).map(function(r, o) {
    return Zd(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  })) : /* @__PURE__ */ ee.createElement(e.tag, V({
    key: t
  }, Zv(e.attrs)), (e.children || []).map(function(r, o) {
    return Zd(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  }));
}
function Ey(e) {
  return _a(e)[0];
}
function _y(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var k7 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, $7 = function(t) {
  var n = Bt(vh), r = n.csp, o = n.prefixCls, i = n.layer, a = k7;
  o && (a = a.replace(/anticon/g, o)), i && (a = "@layer ".concat(i, ` {
`).concat(a, `
}`)), ut(function() {
    var s = t.current, l = Sl(s);
    Ur(a, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: l
    });
  }, []);
}, N7 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], ga = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function F7(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  ga.primaryColor = t, ga.secondaryColor = n || Ey(t), ga.calculated = !!n;
}
function L7() {
  return V({}, ga);
}
var Hi = function(t) {
  var n = t.icon, r = t.className, o = t.onClick, i = t.style, a = t.primaryColor, s = t.secondaryColor, l = Hn(t, N7), c = y.useRef(), u = ga;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: s || Ey(a)
  }), $7(c), I7(Yv(n), "icon should be icon definiton, but got ".concat(n)), !Yv(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = V(V({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), Zd(d.icon, "svg-".concat(d.name), V(V({
    className: r,
    onClick: o,
    style: i,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: c
  }));
};
Hi.displayName = "IconReact";
Hi.getTwoToneColors = L7;
Hi.setTwoToneColors = F7;
function xy(e) {
  var t = _y(e), n = de(t, 2), r = n[0], o = n[1];
  return Hi.setTwoToneColors({
    primaryColor: r,
    secondaryColor: o
  });
}
function M7() {
  var e = Hi.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var D7 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
xy(xl.primary);
var qr = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, o = e.spin, i = e.rotate, a = e.tabIndex, s = e.onClick, l = e.twoToneColor, c = Hn(e, D7), u = y.useContext(vh), d = u.prefixCls, f = d === void 0 ? "anticon" : d, h = u.rootClassName, p = me(h, f, U(U({}, "".concat(f, "-").concat(r.name), !!r.name), "".concat(f, "-spin"), !!o || r.name === "loading"), n), g = a;
  g === void 0 && s && (g = -1);
  var v = i ? {
    msTransform: "rotate(".concat(i, "deg)"),
    transform: "rotate(".concat(i, "deg)")
  } : void 0, b = _y(l), m = de(b, 2), w = m[0], E = m[1];
  return /* @__PURE__ */ y.createElement("span", it({
    role: "img",
    "aria-label": r.name
  }, c, {
    ref: t,
    tabIndex: g,
    onClick: s,
    className: p
  }), /* @__PURE__ */ y.createElement(Hi, {
    icon: r,
    primaryColor: w,
    secondaryColor: E,
    style: v
  }));
});
qr.displayName = "AntdIcon";
qr.getTwoToneColor = M7;
qr.setTwoToneColor = xy;
var j7 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" }, B7 = function(t, n) {
  return /* @__PURE__ */ y.createElement(qr, it({}, t, {
    ref: n,
    icon: j7
  }));
}, Sy = /* @__PURE__ */ y.forwardRef(B7);
z.env.NODE_ENV !== "production" && (Sy.displayName = "CheckCircleFilled");
var V7 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" }, U7 = function(t, n) {
  return /* @__PURE__ */ y.createElement(qr, it({}, t, {
    ref: n,
    icon: V7
  }));
}, Ty = /* @__PURE__ */ y.forwardRef(U7);
z.env.NODE_ENV !== "production" && (Ty.displayName = "CloseCircleFilled");
var H7 = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" }, z7 = function(t, n) {
  return /* @__PURE__ */ y.createElement(qr, it({}, t, {
    ref: n,
    icon: H7
  }));
}, Bo = /* @__PURE__ */ y.forwardRef(z7);
z.env.NODE_ENV !== "production" && (Bo.displayName = "CloseOutlined");
var q7 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" }, W7 = function(t, n) {
  return /* @__PURE__ */ y.createElement(qr, it({}, t, {
    ref: n,
    icon: q7
  }));
}, Oy = /* @__PURE__ */ y.forwardRef(W7);
z.env.NODE_ENV !== "production" && (Oy.displayName = "ExclamationCircleFilled");
var G7 = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" }, K7 = function(t, n) {
  return /* @__PURE__ */ y.createElement(qr, it({}, t, {
    ref: n,
    icon: G7
  }));
}, Py = /* @__PURE__ */ y.forwardRef(K7);
z.env.NODE_ENV !== "production" && (Py.displayName = "InfoCircleFilled");
var Y7 = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" }, Z7 = function(t, n) {
  return /* @__PURE__ */ y.createElement(qr, it({}, t, {
    ref: n,
    icon: Y7
  }));
}, Ry = /* @__PURE__ */ y.forwardRef(Z7);
z.env.NODE_ENV !== "production" && (Ry.displayName = "LoadingOutlined");
var Qd = { exports: {} }, ht = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qv;
function Q7() {
  if (Qv)
    return ht;
  Qv = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function g(v) {
    if (typeof v == "object" && v !== null) {
      var b = v.$$typeof;
      switch (b) {
        case e:
          switch (v = v.type, v) {
            case n:
            case o:
            case r:
            case c:
            case u:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case a:
                case l:
                case f:
                case d:
                case i:
                  return v;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return ht.ContextConsumer = a, ht.ContextProvider = i, ht.Element = e, ht.ForwardRef = l, ht.Fragment = n, ht.Lazy = f, ht.Memo = d, ht.Portal = t, ht.Profiler = o, ht.StrictMode = r, ht.Suspense = c, ht.SuspenseList = u, ht.isAsyncMode = function() {
    return !1;
  }, ht.isConcurrentMode = function() {
    return !1;
  }, ht.isContextConsumer = function(v) {
    return g(v) === a;
  }, ht.isContextProvider = function(v) {
    return g(v) === i;
  }, ht.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, ht.isForwardRef = function(v) {
    return g(v) === l;
  }, ht.isFragment = function(v) {
    return g(v) === n;
  }, ht.isLazy = function(v) {
    return g(v) === f;
  }, ht.isMemo = function(v) {
    return g(v) === d;
  }, ht.isPortal = function(v) {
    return g(v) === t;
  }, ht.isProfiler = function(v) {
    return g(v) === o;
  }, ht.isStrictMode = function(v) {
    return g(v) === r;
  }, ht.isSuspense = function(v) {
    return g(v) === c;
  }, ht.isSuspenseList = function(v) {
    return g(v) === u;
  }, ht.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === o || v === r || v === c || v === u || v === h || typeof v == "object" && v !== null && (v.$$typeof === f || v.$$typeof === d || v.$$typeof === i || v.$$typeof === a || v.$$typeof === l || v.$$typeof === p || v.getModuleId !== void 0);
  }, ht.typeOf = g, ht;
}
var pt = {}, Xv;
function X7() {
  return Xv || (Xv = 1, z.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, g = !1, v = !1, b = !1, m = !1, w;
    w = Symbol.for("react.module.reference");
    function E(se) {
      return !!(typeof se == "string" || typeof se == "function" || se === n || se === o || m || se === r || se === c || se === u || b || se === h || p || g || v || typeof se == "object" && se !== null && (se.$$typeof === f || se.$$typeof === d || se.$$typeof === i || se.$$typeof === a || se.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      se.$$typeof === w || se.getModuleId !== void 0));
    }
    function C(se) {
      if (typeof se == "object" && se !== null) {
        var D = se.$$typeof;
        switch (D) {
          case e:
            var X = se.type;
            switch (X) {
              case n:
              case o:
              case r:
              case c:
              case u:
                return X;
              default:
                var Q = X && X.$$typeof;
                switch (Q) {
                  case s:
                  case a:
                  case l:
                  case f:
                  case d:
                  case i:
                    return Q;
                  default:
                    return D;
                }
            }
          case t:
            return D;
        }
      }
    }
    var x = a, _ = i, T = e, O = l, I = n, L = f, B = d, j = t, M = o, q = r, N = c, $ = u, F = !1, H = !1;
    function k(se) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(se) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(se) {
      return C(se) === a;
    }
    function ne(se) {
      return C(se) === i;
    }
    function Y(se) {
      return typeof se == "object" && se !== null && se.$$typeof === e;
    }
    function fe(se) {
      return C(se) === l;
    }
    function ge(se) {
      return C(se) === n;
    }
    function ie(se) {
      return C(se) === f;
    }
    function he(se) {
      return C(se) === d;
    }
    function ue(se) {
      return C(se) === t;
    }
    function ce(se) {
      return C(se) === o;
    }
    function Se(se) {
      return C(se) === r;
    }
    function te(se) {
      return C(se) === c;
    }
    function ke(se) {
      return C(se) === u;
    }
    pt.ContextConsumer = x, pt.ContextProvider = _, pt.Element = T, pt.ForwardRef = O, pt.Fragment = I, pt.Lazy = L, pt.Memo = B, pt.Portal = j, pt.Profiler = M, pt.StrictMode = q, pt.Suspense = N, pt.SuspenseList = $, pt.isAsyncMode = k, pt.isConcurrentMode = W, pt.isContextConsumer = G, pt.isContextProvider = ne, pt.isElement = Y, pt.isForwardRef = fe, pt.isFragment = ge, pt.isLazy = ie, pt.isMemo = he, pt.isPortal = ue, pt.isProfiler = ce, pt.isStrictMode = Se, pt.isSuspense = te, pt.isSuspenseList = ke, pt.isValidElementType = E, pt.typeOf = C;
  }()), pt;
}
z.env.NODE_ENV === "production" ? Qd.exports = Q7() : Qd.exports = X7();
var Au = Qd.exports;
function bh(e, t, n) {
  var r = y.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var J7 = Symbol.for("react.element"), eT = Symbol.for("react.transitional.element"), tT = Symbol.for("react.fragment");
function Ay(e) {
  return (
    // Base object type
    e && Le(e) === "object" && // React Element type
    (e.$$typeof === J7 || e.$$typeof === eT) && // React Fragment type
    e.type === tT
  );
}
var Ch = function(t, n) {
  typeof t == "function" ? t(n) : Le(t) === "object" && t && "current" in t && (t.current = n);
}, ac = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var o = n.filter(Boolean);
  return o.length <= 1 ? o[0] : function(i) {
    n.forEach(function(a) {
      Ch(a, i);
    });
  };
}, zi = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return bh(function() {
    return ac.apply(void 0, n);
  }, n, function(o, i) {
    return o.length !== i.length || o.every(function(a, s) {
      return a !== i[s];
    });
  });
}, ja = function(t) {
  var n, r;
  if (!t)
    return !1;
  if (Iy(t) && t.props.propertyIsEnumerable("ref"))
    return !0;
  var o = Au.isMemo(t) ? t.type.type : t.type;
  return !(typeof o == "function" && !((n = o.prototype) !== null && n !== void 0 && n.render) && o.$$typeof !== Au.ForwardRef || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render) && t.$$typeof !== Au.ForwardRef);
};
function Iy(e) {
  return /* @__PURE__ */ rw(e) && !Ay(e);
}
var sc = function(t) {
  if (t && Iy(t)) {
    var n = t;
    return n.props.propertyIsEnumerable("ref") ? n.props.ref : n.ref;
  }
  return null;
};
function Tl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return ee.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(Tl(r)) : Ay(r) && r.props ? n = n.concat(Tl(r.props.children, t)) : n.push(r));
  }), n;
}
function Sa(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function nT(e) {
  return e && Le(e) === "object" && Sa(e.nativeElement) ? e.nativeElement : Sa(e) ? e : null;
}
function Js(e) {
  var t = nT(e);
  if (t)
    return t;
  if (e instanceof ee.Component) {
    var n;
    return (n = Qh.findDOMNode) === null || n === void 0 ? void 0 : n.call(Qh, e);
  }
  return null;
}
var Xd = /* @__PURE__ */ y.createContext(null);
function rT(e) {
  var t = e.children, n = e.onBatchResize, r = y.useRef(0), o = y.useRef([]), i = y.useContext(Xd), a = y.useCallback(function(s, l, c) {
    r.current += 1;
    var u = r.current;
    o.current.push({
      size: s,
      element: l,
      data: c
    }), Promise.resolve().then(function() {
      u === r.current && (n == null || n(o.current), o.current = []);
    }), i == null || i(s, l, c);
  }, [n, i]);
  return /* @__PURE__ */ y.createElement(Xd.Provider, {
    value: a
  }, t);
}
var ky = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(o, i) {
      return o[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, t.prototype.set = function(n, r) {
        var o = e(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, o = e(r, n);
        ~o && r.splice(o, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, i = this.__entries__; o < i.length; o++) {
          var a = i[o];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), Jd = typeof window < "u" && typeof document < "u" && window.document === document, Ol = function() {
  return typeof Bn < "u" && Bn.Math === Math ? Bn : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), oT = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Ol) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), iT = 2;
function aT(e, t) {
  var n = !1, r = !1, o = 0;
  function i() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    oT(i);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - o < iT)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    o = l;
  }
  return s;
}
var sT = 20, lT = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], cT = typeof MutationObserver < "u", uT = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = aT(this.refresh.bind(this), sT);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Jd || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), cT ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Jd || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, o = lT.some(function(i) {
        return !!~r.indexOf(i);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), $y = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Ii = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Ol;
}, Ny = lc(0, 0, 0, 0);
function Pl(e) {
  return parseFloat(e) || 0;
}
function Jv(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, o) {
    var i = e["border-" + o + "-width"];
    return r + Pl(i);
  }, 0);
}
function dT(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = e["padding-" + i];
    n[i] = Pl(a);
  }
  return n;
}
function fT(e) {
  var t = e.getBBox();
  return lc(0, 0, t.width, t.height);
}
function hT(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return Ny;
  var r = Ii(e).getComputedStyle(e), o = dT(r), i = o.left + o.right, a = o.top + o.bottom, s = Pl(r.width), l = Pl(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= Jv(r, "left", "right") + i), Math.round(l + a) !== n && (l -= Jv(r, "top", "bottom") + a)), !vT(e)) {
    var c = Math.round(s + i) - t, u = Math.round(l + a) - n;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return lc(o.left, o.top, s, l);
}
var pT = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Ii(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Ii(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function vT(e) {
  return e === Ii(e).document.documentElement;
}
function gT(e) {
  return Jd ? pT(e) ? fT(e) : hT(e) : Ny;
}
function mT(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(i.prototype);
  return $y(a, {
    x: t,
    y: n,
    width: r,
    height: o,
    top: n,
    right: t + r,
    bottom: o + n,
    left: t
  }), a;
}
function lc(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var yT = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = lc(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = gT(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), bT = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = mT(n);
      $y(this, { target: t, contentRect: r });
    }
    return e;
  }()
), CT = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new ky(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Ii(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new yT(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Ii(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new bT(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Fy = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new ky(), Ly = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = uT.getInstance(), r = new CT(t, n, this);
      Fy.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  Ly.prototype[e] = function() {
    var t;
    return (t = Fy.get(this))[e].apply(t, arguments);
  };
});
var wT = function() {
  return typeof Ol.ResizeObserver < "u" ? Ol.ResizeObserver : Ly;
}(), jr = /* @__PURE__ */ new Map();
function My(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = jr.get(r)) === null || n === void 0 || n.forEach(function(o) {
      return o(r);
    });
  });
}
var Dy = new wT(My);
z.env.NODE_ENV;
z.env.NODE_ENV;
function ET(e, t) {
  jr.has(e) || (jr.set(e, /* @__PURE__ */ new Set()), Dy.observe(e)), jr.get(e).add(t);
}
function _T(e, t) {
  jr.has(e) && (jr.get(e).delete(t), jr.get(e).size || (Dy.unobserve(e), jr.delete(e)));
}
function cn(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function eg(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fy(r.key), r);
  }
}
function un(e, t, n) {
  return t && eg(e.prototype, t), n && eg(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ta(e, t) {
  return Ta = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Ta(e, t);
}
function bo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ta(e, t);
}
function Oa(e) {
  return Oa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Oa(e);
}
function wh() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (wh = function() {
    return !!e;
  })();
}
function Ye(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xT(e, t) {
  if (t && (Le(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ye(e);
}
function Co(e) {
  var t = wh();
  return function() {
    var n, r = Oa(e);
    if (t) {
      var o = Oa(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return xT(this, n);
  };
}
var ST = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n() {
    return cn(this, n), t.apply(this, arguments);
  }
  return un(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(y.Component);
function TT(e, t) {
  var n = e.children, r = e.disabled, o = y.useRef(null), i = y.useRef(null), a = y.useContext(Xd), s = typeof n == "function", l = s ? n(o) : n, c = y.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !s && /* @__PURE__ */ y.isValidElement(l) && ja(l), d = u ? sc(l) : null, f = zi(d, o), h = function() {
    var b;
    return Js(o.current) || // Support `nativeElement` format
    (o.current && Le(o.current) === "object" ? Js((b = o.current) === null || b === void 0 ? void 0 : b.nativeElement) : null) || Js(i.current);
  };
  y.useImperativeHandle(t, function() {
    return h();
  });
  var p = y.useRef(e);
  p.current = e;
  var g = y.useCallback(function(v) {
    var b = p.current, m = b.onResize, w = b.data, E = v.getBoundingClientRect(), C = E.width, x = E.height, _ = v.offsetWidth, T = v.offsetHeight, O = Math.floor(C), I = Math.floor(x);
    if (c.current.width !== O || c.current.height !== I || c.current.offsetWidth !== _ || c.current.offsetHeight !== T) {
      var L = {
        width: O,
        height: I,
        offsetWidth: _,
        offsetHeight: T
      };
      c.current = L;
      var B = _ === Math.round(C) ? C : _, j = T === Math.round(x) ? x : T, M = V(V({}, L), {}, {
        offsetWidth: B,
        offsetHeight: j
      });
      a == null || a(M, v, w), m && Promise.resolve().then(function() {
        m(M, v);
      });
    }
  }, []);
  return y.useEffect(function() {
    var v = h();
    return v && !r && ET(v, g), function() {
      return _T(v, g);
    };
  }, [o.current, r]), /* @__PURE__ */ y.createElement(ST, {
    ref: i
  }, u ? /* @__PURE__ */ y.cloneElement(l, {
    ref: f
  }) : l);
}
var jy = /* @__PURE__ */ y.forwardRef(TT);
z.env.NODE_ENV !== "production" && (jy.displayName = "SingleObserver");
var OT = "rc-observer-key";
function PT(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : Tl(n);
  return z.env.NODE_ENV !== "production" && (r.length > 1 ? go(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && go(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(o, i) {
    var a = (o == null ? void 0 : o.key) || "".concat(OT, "-").concat(i);
    return /* @__PURE__ */ y.createElement(jy, it({}, e, {
      key: a,
      ref: i === 0 ? t : void 0
    }), o);
  });
}
var cc = /* @__PURE__ */ y.forwardRef(PT);
z.env.NODE_ENV !== "production" && (cc.displayName = "ResizeObserver");
cc.Collection = rT;
function uc(e, t) {
  var n = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function RT(e) {
  if (Array.isArray(e))
    return Nd(e);
}
function By(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function AT() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pe(e) {
  return RT(e) || By(e) || gh(e) || AT();
}
var Vy = function(t) {
  return +setTimeout(t, 16);
}, Uy = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (Vy = function(t) {
  return window.requestAnimationFrame(t);
}, Uy = function(t) {
  return window.cancelAnimationFrame(t);
});
var tg = 0, dc = /* @__PURE__ */ new Map();
function Hy(e) {
  dc.delete(e);
}
var mo = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  tg += 1;
  var r = tg;
  function o(i) {
    if (i === 0)
      Hy(r), t();
    else {
      var a = Vy(function() {
        o(i - 1);
      });
      dc.set(r, a);
    }
  }
  return o(n), r;
};
mo.cancel = function(e) {
  var t = dc.get(e);
  return Hy(e), Uy(t);
};
z.env.NODE_ENV !== "production" && (mo.ids = function() {
  return dc;
});
function Pa(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function ef(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function o(i, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = r.has(i);
    if (Et(!l, "Warning: There may be circular references"), l)
      return !1;
    if (i === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(i);
    var c = s + 1;
    if (Array.isArray(i)) {
      if (!Array.isArray(a) || i.length !== a.length)
        return !1;
      for (var u = 0; u < i.length; u++)
        if (!o(i[u], a[u], c))
          return !1;
      return !0;
    }
    if (i && a && Le(i) === "object" && Le(a) === "object") {
      var d = Object.keys(i);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return o(i[f], a[f], c);
      });
    }
    return !1;
  }
  return o(e, t);
}
var IT = "%";
function tf(e) {
  return e.join(IT);
}
var kT = /* @__PURE__ */ function() {
  function e(t) {
    cn(this, e), U(this, "instanceId", void 0), U(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return un(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(tf(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(tf(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var o = this.cache.get(n), i = r(o);
      i === null ? this.cache.delete(n) : this.cache.set(n, i);
    }
  }]), e;
}(), ki = "data-token-hash", pr = "data-css-hash", $T = "data-cache-path", co = "__cssinjs_instance__";
function NT() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(pr, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(o) {
      o[co] = o[co] || e, o[co] === e && document.head.insertBefore(o, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(pr, "]"))).forEach(function(o) {
      var i = o.getAttribute(pr);
      if (r[i]) {
        if (o[co] === e) {
          var a;
          (a = o.parentNode) === null || a === void 0 || a.removeChild(o);
        }
      } else
        r[i] = !0;
    });
  }
  return new kT(e);
}
var fc = /* @__PURE__ */ y.createContext({
  hashPriority: "low",
  cache: NT(),
  defaultCache: !0
});
function FT(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var Eh = /* @__PURE__ */ function() {
  function e() {
    cn(this, e), U(this, "cache", void 0), U(this, "keys", void 0), U(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return un(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, o, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return n.forEach(function(s) {
        if (!a)
          a = void 0;
        else {
          var l;
          a = (l = a) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(s);
        }
      }), (r = a) !== null && r !== void 0 && r.value && i && (a.value[1] = this.cacheCallTimes++), (o = a) === null || o === void 0 ? void 0 : o.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var o = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var i = this.keys.reduce(function(c, u) {
            var d = de(c, 2), f = d[1];
            return o.internalGet(u)[1] < f ? [u, o.internalGet(u)[1]] : c;
          }, [this.keys[0], this.cacheCallTimes]), a = de(i, 1), s = a[0];
          this.delete(s);
        }
        this.keys.push(n);
      }
      var l = this.cache;
      n.forEach(function(c, u) {
        if (u === n.length - 1)
          l.set(c, {
            value: [r, o.cacheCallTimes++]
          });
        else {
          var d = l.get(c);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : l.set(c, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(c).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var o = n.get(r[0]);
      if (r.length === 1) {
        var i;
        return o.map ? n.set(r[0], {
          map: o.map
        }) : n.delete(r[0]), (i = o.value) === null || i === void 0 ? void 0 : i[0];
      }
      var a = this.deleteByPath(o.map, r.slice(1));
      return (!o.map || o.map.size === 0) && !o.value && n.delete(r[0]), a;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !FT(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
U(Eh, "MAX_CACHE_SIZE", 20);
U(Eh, "MAX_CACHE_OFFSET", 5);
var ng = 0, zy = /* @__PURE__ */ function() {
  function e(t) {
    cn(this, e), U(this, "derivatives", void 0), U(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = ng, t.length === 0 && go(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), ng += 1;
  }
  return un(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, o) {
        return o(n, r);
      }, void 0);
    }
  }]), e;
}(), Iu = new Eh();
function nf(e) {
  var t = Array.isArray(e) ? e : [e];
  return Iu.has(t) || Iu.set(t, new zy(t)), Iu.get(t);
}
var LT = /* @__PURE__ */ new WeakMap(), ku = {};
function MT(e, t) {
  for (var n = LT, r = 0; r < t.length; r += 1) {
    var o = t[r];
    n.has(o) || n.set(o, /* @__PURE__ */ new WeakMap()), n = n.get(o);
  }
  return n.has(ku) || n.set(ku, e()), n.get(ku);
}
var rg = /* @__PURE__ */ new WeakMap();
function ma(e) {
  var t = rg.get(e) || "";
  return t || (Object.keys(e).forEach(function(n) {
    var r = e[n];
    t += n, r instanceof zy ? t += r.id : r && Le(r) === "object" ? t += ma(r) : t += r;
  }), t = Pa(t), rg.set(e, t)), t;
}
function og(e, t) {
  return Pa("".concat(t, "_").concat(ma(e)));
}
var rf = En();
function ze(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function Rl(e, t, n) {
  var r, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var a = V(V({}, o), {}, (r = {}, U(r, ki, t), U(r, pr, n), r)), s = Object.keys(a).map(function(l) {
    var c = a[l];
    return c ? "".concat(l, '="').concat(c, '"') : null;
  }).filter(function(l) {
    return l;
  }).join(" ");
  return "<style ".concat(s, ">").concat(e, "</style>");
}
var el = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, DT = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(o) {
    var i = de(o, 2), a = i[0], s = i[1];
    return "".concat(a, ":").concat(s, ";");
  }).join(""), "}") : "";
}, qy = function(t, n, r) {
  var o = {}, i = {};
  return Object.entries(t).forEach(function(a) {
    var s, l, c = de(a, 2), u = c[0], d = c[1];
    if (r != null && (s = r.preserve) !== null && s !== void 0 && s[u])
      i[u] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(r != null && (l = r.ignore) !== null && l !== void 0 && l[u])) {
      var f, h = el(u, r == null ? void 0 : r.prefix);
      o[h] = typeof d == "number" && !(r != null && (f = r.unitless) !== null && f !== void 0 && f[u]) ? "".concat(d, "px") : String(d), i[u] = "var(".concat(h, ")");
    }
  }), [i, DT(o, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, ig = z.env.NODE_ENV !== "test" && En() ? y.useLayoutEffect : y.useEffect, vn = function(t, n) {
  var r = y.useRef(!0);
  ig(function() {
    return t(r.current);
  }, n), ig(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, ag = function(t, n) {
  vn(function(r) {
    if (!r)
      return t();
  }, n);
}, jT = V({}, y), sg = jT.useInsertionEffect, BT = function(t, n, r) {
  y.useMemo(t, r), vn(function() {
    return n(!0);
  }, r);
}, VT = sg ? function(e, t, n) {
  return sg(function() {
    return e(), t();
  }, n);
} : BT, UT = V({}, y), HT = UT.useInsertionEffect, zT = function(t) {
  var n = [], r = !1;
  function o(i) {
    if (r) {
      z.env.NODE_ENV !== "production" && go(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    n.push(i);
  }
  return y.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(i) {
        return i();
      });
    };
  }, t), o;
}, qT = function() {
  return function(t) {
    t();
  };
}, WT = typeof HT < "u" ? zT : qT;
function GT() {
  return !1;
}
var of = !1;
function KT() {
  return of;
}
const YT = z.env.NODE_ENV === "production" ? GT : KT;
if (z.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var Ts = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : null;
  if (Ts && typeof Ts.webpackHotUpdate == "function") {
    var ZT = Ts.webpackHotUpdate;
    Ts.webpackHotUpdate = function() {
      return of = !0, setTimeout(function() {
        of = !1;
      }, 0), ZT.apply(void 0, arguments);
    };
  }
}
function _h(e, t, n, r, o) {
  var i = y.useContext(fc), a = i.cache, s = [e].concat(Pe(t)), l = tf(s), c = WT([l]), u = YT(), d = function(g) {
    a.opUpdate(l, function(v) {
      var b = v || [void 0, void 0], m = de(b, 2), w = m[0], E = w === void 0 ? 0 : w, C = m[1], x = C;
      z.env.NODE_ENV !== "production" && C && u && (r == null || r(x, u), x = null);
      var _ = x || n(), T = [E, _];
      return g ? g(T) : T;
    });
  };
  y.useMemo(
    function() {
      d();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var f = a.opGet(l);
  z.env.NODE_ENV !== "production" && !f && (d(), f = a.opGet(l));
  var h = f[1];
  return VT(function() {
    o == null || o(h);
  }, function(p) {
    return d(function(g) {
      var v = de(g, 2), b = v[0], m = v[1];
      return p && b === 0 && (o == null || o(h)), [b + 1, m];
    }), function() {
      a.opUpdate(l, function(g) {
        var v = g || [], b = de(v, 2), m = b[0], w = m === void 0 ? 0 : m, E = b[1], C = w - 1;
        return C === 0 ? (c(function() {
          (p || !a.opGet(l)) && (r == null || r(E, !1));
        }), null) : [w - 1, E];
      });
    };
  }, [l]), h;
}
var QT = {}, XT = z.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", To = /* @__PURE__ */ new Map();
function JT(e) {
  To.set(e, (To.get(e) || 0) + 1);
}
function eO(e, t) {
  if (typeof document < "u") {
    var n = document.querySelectorAll("style[".concat(ki, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[co] === t) {
        var o;
        (o = r.parentNode) === null || o === void 0 || o.removeChild(r);
      }
    });
  }
}
var tO = 0;
function nO(e, t) {
  To.set(e, (To.get(e) || 0) - 1);
  var n = Array.from(To.keys()), r = n.filter(function(o) {
    var i = To.get(o) || 0;
    return i <= 0;
  });
  n.length - r.length > tO && r.forEach(function(o) {
    eO(o, t), To.delete(o);
  });
}
var rO = function(t, n, r, o) {
  var i = r.getDerivativeToken(t), a = V(V({}, i), n);
  return o && (a = o(a)), a;
}, Wy = "token";
function oO(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Bt(fc), o = r.cache.instanceId, i = r.container, a = n.salt, s = a === void 0 ? "" : a, l = n.override, c = l === void 0 ? QT : l, u = n.formatToken, d = n.getComputedToken, f = n.cssVar, h = MT(function() {
    return Object.assign.apply(Object, [{}].concat(Pe(t)));
  }, t), p = ma(h), g = ma(c), v = f ? ma(f) : "", b = _h(Wy, [s, e.id, p, g, v], function() {
    var m, w = d ? d(h, c, e) : rO(h, c, e, u), E = V({}, w), C = "";
    if (f) {
      var x = qy(w, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), _ = de(x, 2);
      w = _[0], C = _[1];
    }
    var T = og(w, s);
    w._tokenKey = T, E._tokenKey = og(E, s);
    var O = (m = f == null ? void 0 : f.key) !== null && m !== void 0 ? m : T;
    w._themeKey = O, JT(O);
    var I = "".concat(XT, "-").concat(Pa(T));
    return w._hashId = I, [w, I, E, C, (f == null ? void 0 : f.key) || ""];
  }, function(m) {
    nO(m[0]._themeKey, o);
  }, function(m) {
    var w = de(m, 4), E = w[0], C = w[3];
    if (f && C) {
      var x = Ur(C, Pa("css-variables-".concat(E._themeKey)), {
        mark: pr,
        prepend: "queue",
        attachTo: i,
        priority: -999
      });
      x[co] = o, x.setAttribute(ki, E._themeKey);
    }
  });
  return b;
}
var iO = function(t, n, r) {
  var o = de(t, 5), i = o[2], a = o[3], s = o[4], l = r || {}, c = l.plain;
  if (!a)
    return null;
  var u = i._tokenKey, d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, h = Rl(a, s, u, f, c);
  return [d, u, h];
}, aO = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Gy = "comm", Ky = "rule", Yy = "decl", sO = "@import", lO = "@keyframes", cO = "@layer", Zy = Math.abs, xh = String.fromCharCode;
function Qy(e) {
  return e.trim();
}
function tl(e, t, n) {
  return e.replace(t, n);
}
function uO(e, t, n) {
  return e.indexOf(t, n);
}
function Ci(e, t) {
  return e.charCodeAt(t) | 0;
}
function $i(e, t, n) {
  return e.slice(t, n);
}
function Sr(e) {
  return e.length;
}
function dO(e) {
  return e.length;
}
function Os(e, t) {
  return t.push(e), e;
}
var hc = 1, Ni = 1, Xy = 0, tr = 0, Kt = 0, qi = "";
function Sh(e, t, n, r, o, i, a, s) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: hc, column: Ni, length: a, return: "", siblings: s };
}
function fO() {
  return Kt;
}
function hO() {
  return Kt = tr > 0 ? Ci(qi, --tr) : 0, Ni--, Kt === 10 && (Ni = 1, hc--), Kt;
}
function vr() {
  return Kt = tr < Xy ? Ci(qi, tr++) : 0, Ni++, Kt === 10 && (Ni = 1, hc++), Kt;
}
function uo() {
  return Ci(qi, tr);
}
function nl() {
  return tr;
}
function pc(e, t) {
  return $i(qi, e, t);
}
function Ra(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function pO(e) {
  return hc = Ni = 1, Xy = Sr(qi = e), tr = 0, [];
}
function vO(e) {
  return qi = "", e;
}
function $u(e) {
  return Qy(pc(tr - 1, af(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function gO(e) {
  for (; (Kt = uo()) && Kt < 33; )
    vr();
  return Ra(e) > 2 || Ra(Kt) > 3 ? "" : " ";
}
function mO(e, t) {
  for (; --t && vr() && !(Kt < 48 || Kt > 102 || Kt > 57 && Kt < 65 || Kt > 70 && Kt < 97); )
    ;
  return pc(e, nl() + (t < 6 && uo() == 32 && vr() == 32));
}
function af(e) {
  for (; vr(); )
    switch (Kt) {
      case e:
        return tr;
      case 34:
      case 39:
        e !== 34 && e !== 39 && af(Kt);
        break;
      case 40:
        e === 41 && af(e);
        break;
      case 92:
        vr();
        break;
    }
  return tr;
}
function yO(e, t) {
  for (; vr() && e + Kt !== 57; )
    if (e + Kt === 84 && uo() === 47)
      break;
  return "/*" + pc(t, tr - 1) + "*" + xh(e === 47 ? e : vr());
}
function bO(e) {
  for (; !Ra(uo()); )
    vr();
  return pc(e, tr);
}
function CO(e) {
  return vO(rl("", null, null, null, [""], e = pO(e), 0, [0], e));
}
function rl(e, t, n, r, o, i, a, s, l) {
  for (var c = 0, u = 0, d = a, f = 0, h = 0, p = 0, g = 1, v = 1, b = 1, m = 0, w = "", E = o, C = i, x = r, _ = w; v; )
    switch (p = m, m = vr()) {
      case 40:
        if (p != 108 && Ci(_, d - 1) == 58) {
          uO(_ += tl($u(m), "&", "&\f"), "&\f", Zy(c ? s[c - 1] : 0)) != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += $u(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += gO(p);
        break;
      case 92:
        _ += mO(nl() - 1, 7);
        continue;
      case 47:
        switch (uo()) {
          case 42:
          case 47:
            Os(wO(yO(vr(), nl()), t, n, l), l), (Ra(p || 1) == 5 || Ra(uo() || 1) == 5) && Sr(_) && $i(_, -1, void 0) !== " " && (_ += " ");
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * g:
        s[c++] = Sr(_) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            v = 0;
          case 59 + u:
            b == -1 && (_ = tl(_, /\f/g, "")), h > 0 && (Sr(_) - d || g === 0 && p === 47) && Os(h > 32 ? cg(_ + ";", r, n, d - 1, l) : cg(tl(_, " ", "") + ";", r, n, d - 2, l), l);
            break;
          case 59:
            _ += ";";
          default:
            if (Os(x = lg(_, t, n, c, u, o, s, w, E = [], C = [], d, i), i), m === 123)
              if (u === 0)
                rl(_, t, x, x, E, i, d, s, C);
              else {
                switch (f) {
                  case 99:
                    if (Ci(_, 3) === 110)
                      break;
                  case 108:
                    if (Ci(_, 2) === 97)
                      break;
                  default:
                    u = 0;
                  case 100:
                  case 109:
                  case 115:
                }
                u ? rl(e, x, x, r && Os(lg(e, x, x, 0, 0, o, s, w, o, E = [], d, C), C), o, C, d, s, r ? E : C) : rl(_, x, x, x, [""], C, 0, s, C);
              }
        }
        c = u = h = 0, g = b = 1, w = _ = "", d = a;
        break;
      case 58:
        d = 1 + Sr(_), h = p;
      default:
        if (g < 1) {
          if (m == 123)
            --g;
          else if (m == 125 && g++ == 0 && hO() == 125)
            continue;
        }
        switch (_ += xh(m), m * g) {
          case 38:
            b = u > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[c++] = (Sr(_) - 1) * b, b = 1;
            break;
          case 64:
            uo() === 45 && (_ += $u(vr())), f = uo(), u = d = Sr(w = _ += bO(nl())), m++;
            break;
          case 45:
            p === 45 && Sr(_) == 2 && (g = 0);
        }
    }
  return i;
}
function lg(e, t, n, r, o, i, a, s, l, c, u, d) {
  for (var f = o - 1, h = o === 0 ? i : [""], p = dO(h), g = 0, v = 0, b = 0; g < r; ++g)
    for (var m = 0, w = $i(e, f + 1, f = Zy(v = a[g])), E = e; m < p; ++m)
      (E = Qy(v > 0 ? h[m] + " " + w : tl(w, /&\f/g, h[m]))) && (l[b++] = E);
  return Sh(e, t, n, o === 0 ? Ky : s, l, c, u, d);
}
function wO(e, t, n, r) {
  return Sh(e, t, n, Gy, xh(fO()), $i(e, 2, -2), 0, r);
}
function cg(e, t, n, r, o) {
  return Sh(e, t, n, Yy, $i(e, 0, r), $i(e, r + 1, -1), r, o);
}
function sf(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function EO(e, t, n, r) {
  switch (e.type) {
    case cO:
      if (e.children.length)
        break;
    case sO:
    case Yy:
      return e.return = e.return || e.value;
    case Gy:
      return "";
    case lO:
      return e.return = e.value + "{" + sf(e.children, r) + "}";
    case Ky:
      if (!Sr(e.value = e.props.join(",")))
        return "";
  }
  return Sr(n = sf(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function Jy(e, t) {
  var n = t.path, r = t.parentSelectors;
  Et(!1, "[Ant Design CSS-in-JS] ".concat(n ? "Error in ".concat(n, ": ") : "").concat(e).concat(r.length ? " Selector: ".concat(r.join(" | ")) : ""));
}
var _O = function(t, n, r) {
  if (t === "content") {
    var o = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, i = ["normal", "none", "initial", "inherit", "unset"];
    (typeof n != "string" || i.indexOf(n) === -1 && !o.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")) && Jy("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(n, "\"'`."), r);
  }
}, xO = function(t, n, r) {
  t === "animation" && r.hashId && n !== "none" && Jy("You seem to be using hashed animation '".concat(n, "', in which case 'animationName' with Keyframe as value is recommended."), r);
}, ug = "data-ant-cssinjs-cache-path", eb = "_FILE_STYLE__", Lo, tb = !0;
function SO() {
  if (!Lo && (Lo = {}, En())) {
    var e = document.createElement("div");
    e.className = ug, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(o) {
      var i = o.split(":"), a = de(i, 2), s = a[0], l = a[1];
      Lo[s] = l;
    });
    var n = document.querySelector("style[".concat(ug, "]"));
    if (n) {
      var r;
      tb = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function TO(e) {
  return SO(), !!Lo[e];
}
function OO(e) {
  var t = Lo[e], n = null;
  if (t && En())
    if (tb)
      n = eb;
    else {
      var r = document.querySelector("style[".concat(pr, '="').concat(Lo[e], '"]'));
      r ? n = r.innerHTML : delete Lo[e];
    }
  return [n, t];
}
var nb = "_skip_check_", rb = "_multi_value_";
function ol(e) {
  var t = sf(CO(e), EO);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function PO(e) {
  return Le(e) === "object" && e && (nb in e || rb in e);
}
function dg(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), o = n === "low" ? ":where(".concat(r, ")") : r, i = e.split(",").map(function(a) {
    var s, l = a.trim().split(/\s+/), c = l[0] || "", u = ((s = c.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return c = "".concat(u).concat(o).concat(c.slice(u.length)), [c].concat(Pe(l.slice(1))).join(" ");
  });
  return i.join(",");
}
var RO = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, o = r.root, i = r.injectHash, a = r.parentSelectors, s = n.hashId, l = n.layer, c = n.path, u = n.hashPriority, d = n.transformers, f = d === void 0 ? [] : d, h = n.linters, p = h === void 0 ? [] : h, g = "", v = {};
  function b(E) {
    var C = E.getName(s);
    if (!v[C]) {
      var x = e(E.style, n, {
        root: !1,
        parentSelectors: a
      }), _ = de(x, 1), T = _[0];
      v[C] = "@keyframes ".concat(E.getName(s)).concat(T);
    }
  }
  function m(E) {
    var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return E.forEach(function(x) {
      Array.isArray(x) ? m(x, C) : x && C.push(x);
    }), C;
  }
  var w = m(Array.isArray(t) ? t : [t]);
  return w.forEach(function(E) {
    var C = typeof E == "string" && !o ? {} : E;
    if (typeof C == "string")
      g += "".concat(C, `
`);
    else if (C._keyframe)
      b(C);
    else {
      var x = f.reduce(function(_, T) {
        var O;
        return (T == null || (O = T.visit) === null || O === void 0 ? void 0 : O.call(T, _)) || _;
      }, C);
      Object.keys(x).forEach(function(_) {
        var T = x[_];
        if (Le(T) === "object" && T && (_ !== "animationName" || !T._keyframe) && !PO(T)) {
          var O = !1, I = _.trim(), L = !1;
          (o || i) && s ? I.startsWith("@") ? O = !0 : I === "&" ? I = dg("", s, u) : I = dg(_, s, u) : o && !s && (I === "&" || I === "") && (I = "", L = !0);
          var B = e(T, n, {
            root: L,
            injectHash: O,
            parentSelectors: [].concat(Pe(a), [I])
          }), j = de(B, 2), M = j[0], q = j[1];
          v = V(V({}, v), q), g += "".concat(I).concat(M);
        } else {
          let F = function(H, k) {
            z.env.NODE_ENV !== "production" && (Le(T) !== "object" || !(T != null && T[nb])) && [_O, xO].concat(Pe(p)).forEach(function(ne) {
              return ne(H, k, {
                path: c,
                hashId: s,
                parentSelectors: a
              });
            });
            var W = H.replace(/[A-Z]/g, function(ne) {
              return "-".concat(ne.toLowerCase());
            }), G = k;
            !aO[H] && typeof G == "number" && G !== 0 && (G = "".concat(G, "px")), H === "animationName" && k !== null && k !== void 0 && k._keyframe && (b(k), G = k.getName(s)), g += "".concat(W, ":").concat(G, ";");
          };
          var N, $ = (N = T == null ? void 0 : T.value) !== null && N !== void 0 ? N : T;
          Le(T) === "object" && T !== null && T !== void 0 && T[rb] && Array.isArray($) ? $.forEach(function(H) {
            F(_, H);
          }) : F(_, $);
        }
      });
    }
  }), o ? l && (g && (g = "@layer ".concat(l.name, " {").concat(g, "}")), l.dependencies && (v["@layer ".concat(l.name)] = l.dependencies.map(function(E) {
    return "@layer ".concat(E, ", ").concat(l.name, ";");
  }).join(`
`))) : g = "{".concat(g, "}"), [g, v];
};
function ob(e, t) {
  return Pa("".concat(e.join("%")).concat(t));
}
function AO() {
  return null;
}
var ib = "style";
function lf(e, t) {
  var n = e.token, r = e.path, o = e.hashId, i = e.layer, a = e.nonce, s = e.clientOnly, l = e.order, c = l === void 0 ? 0 : l, u = y.useContext(fc), d = u.autoClear, f = u.mock, h = u.defaultCache, p = u.hashPriority, g = u.container, v = u.ssrInline, b = u.transformers, m = u.linters, w = u.cache, E = u.layer, C = n._tokenKey, x = [C];
  E && x.push("layer"), x.push.apply(x, Pe(r));
  var _ = rf;
  z.env.NODE_ENV !== "production" && f !== void 0 && (_ = f === "client");
  var T = _h(
    ib,
    x,
    // Create cache if needed
    function() {
      var j = x.join("|");
      if (TO(j)) {
        var M = OO(j), q = de(M, 2), N = q[0], $ = q[1];
        if (N)
          return [N, C, $, {}, s, c];
      }
      var F = t(), H = RO(F, {
        hashId: o,
        hashPriority: p,
        layer: E ? i : void 0,
        path: r.join("-"),
        transformers: b,
        linters: m
      }), k = de(H, 2), W = k[0], G = k[1], ne = ol(W), Y = ob(x, ne);
      return [ne, C, Y, G, s, c];
    },
    // Remove cache if no need
    function(j, M) {
      var q = de(j, 3), N = q[2];
      (M || d) && rf && xa(N, {
        mark: pr
      });
    },
    // Effect: Inject style here
    function(j) {
      var M = de(j, 4), q = M[0];
      M[1];
      var N = M[2], $ = M[3];
      if (_ && q !== eb) {
        var F = {
          mark: pr,
          prepend: E ? !1 : "queue",
          attachTo: g,
          priority: c
        }, H = typeof a == "function" ? a() : a;
        H && (F.csp = {
          nonce: H
        });
        var k = [], W = [];
        Object.keys($).forEach(function(ne) {
          ne.startsWith("@layer") ? k.push(ne) : W.push(ne);
        }), k.forEach(function(ne) {
          Ur(ol($[ne]), "_layer-".concat(ne), V(V({}, F), {}, {
            prepend: !0
          }));
        });
        var G = Ur(q, N, F);
        G[co] = w.instanceId, G.setAttribute(ki, C), z.env.NODE_ENV !== "production" && G.setAttribute($T, x.join("|")), W.forEach(function(ne) {
          Ur(ol($[ne]), "_effect-".concat(ne), F);
        });
      }
    }
  ), O = de(T, 3), I = O[0], L = O[1], B = O[2];
  return function(j) {
    var M;
    if (!v || _ || !h)
      M = /* @__PURE__ */ y.createElement(AO, null);
    else {
      var q;
      M = /* @__PURE__ */ y.createElement("style", it({}, (q = {}, U(q, ki, L), U(q, pr, B), q), {
        dangerouslySetInnerHTML: {
          __html: I
        }
      }));
    }
    return /* @__PURE__ */ y.createElement(y.Fragment, null, M, j);
  };
}
var IO = function(t, n, r) {
  var o = de(t, 6), i = o[0], a = o[1], s = o[2], l = o[3], c = o[4], u = o[5], d = r || {}, f = d.plain;
  if (c)
    return null;
  var h = i, p = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return h = Rl(i, a, s, p, f), l && Object.keys(l).forEach(function(g) {
    if (!n[g]) {
      n[g] = !0;
      var v = ol(l[g]), b = Rl(v, a, "_effect-".concat(g), p, f);
      g.startsWith("@layer") ? h = b + h : h += b;
    }
  }), [u, s, h];
}, ab = "cssVar", kO = function(t, n) {
  var r = t.key, o = t.prefix, i = t.unitless, a = t.ignore, s = t.token, l = t.scope, c = l === void 0 ? "" : l, u = Bt(fc), d = u.cache.instanceId, f = u.container, h = s._tokenKey, p = [].concat(Pe(t.path), [r, c, h]), g = _h(ab, p, function() {
    var v = n(), b = qy(v, r, {
      prefix: o,
      unitless: i,
      ignore: a,
      scope: c
    }), m = de(b, 2), w = m[0], E = m[1], C = ob(p, E);
    return [w, E, C, r];
  }, function(v) {
    var b = de(v, 3), m = b[2];
    rf && xa(m, {
      mark: pr
    });
  }, function(v) {
    var b = de(v, 3), m = b[1], w = b[2];
    if (m) {
      var E = Ur(m, w, {
        mark: pr,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      E[co] = d, E.setAttribute(ki, r);
    }
  });
  return g;
}, $O = function(t, n, r) {
  var o = de(t, 4), i = o[1], a = o[2], s = o[3], l = r || {}, c = l.plain;
  if (!i)
    return null;
  var u = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, f = Rl(i, s, a, d, c);
  return [u, a, f];
}, aa;
aa = {}, U(aa, ib, IO), U(aa, Wy, iO), U(aa, ab, $O);
var Tn = /* @__PURE__ */ function() {
  function e(t, n) {
    cn(this, e), U(this, "name", void 0), U(this, "style", void 0), U(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return un(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function ri(e) {
  return e.notSplit = !0, e;
}
ri(["borderTop", "borderBottom"]), ri(["borderTop"]), ri(["borderBottom"]), ri(["borderLeft", "borderRight"]), ri(["borderLeft"]), ri(["borderRight"]);
function NO(e) {
  return uy(e) || By(e) || gh(e) || dy();
}
function Ir(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function sb(e, t, n, r) {
  if (!t.length)
    return n;
  var o = NO(t), i = o[0], a = o.slice(1), s;
  return !e && typeof i == "number" ? s = [] : Array.isArray(e) ? s = Pe(e) : s = V({}, e), r && n === void 0 && a.length === 1 ? delete s[i][a[0]] : s[i] = sb(s[i], a, n, r), s;
}
function lr(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !Ir(e, t.slice(0, -1)) ? e : sb(e, t, n, r);
}
function FO(e) {
  return Le(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function fg(e) {
  return Array.isArray(e) ? [] : {};
}
var LO = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function pi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = fg(t[0]);
  return t.forEach(function(o) {
    function i(a, s) {
      var l = new Set(s), c = Ir(o, a), u = Array.isArray(c);
      if (u || FO(c)) {
        if (!l.has(c)) {
          l.add(c);
          var d = Ir(r, a);
          u ? r = lr(r, a, []) : (!d || Le(d) !== "object") && (r = lr(r, a, fg(c))), LO(c).forEach(function(f) {
            i([].concat(Pe(a), [f]), l);
          });
        }
      } else
        r = lr(r, a, c);
    }
    i([]);
  }), r;
}
function lb() {
}
let Fr = null;
function MO() {
  Fr = null, Cy();
}
let Wr = lb;
z.env.NODE_ENV !== "production" && (Wr = (e, t, n) => {
  Et(e, `[antd: ${t}] ${n}`), z.env.NODE_ENV === "test" && MO();
});
const cb = /* @__PURE__ */ y.createContext({}), nr = z.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = y.useContext(cb), n = (r, o, i) => {
    if (!r)
      if (t === !1 && o === "deprecated") {
        const a = Fr;
        Fr || (Fr = {}), Fr[e] = Fr[e] || [], Fr[e].includes(i || "") || Fr[e].push(i || ""), a || console.warn("[antd] There exists deprecated usage in your code:", Fr);
      } else
        z.env.NODE_ENV !== "production" && Wr(r, e, i);
  };
  return n.deprecated = (r, o, i, a) => {
    n(r, "deprecated", `\`${o}\` is deprecated. Please use \`${i}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = lb, e;
}, DO = /* @__PURE__ */ $a(void 0);
var jO = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, BO = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, VO = V(V({}, BO), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const ub = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, hg = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, VO),
  timePickerLocale: Object.assign({}, ub)
}, $n = "${label} is not a valid ${type}", Vo = {
  locale: "en",
  Pagination: jO,
  DatePicker: hg,
  TimePicker: ub,
  Calendar: hg,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: $n,
        method: $n,
        array: $n,
        object: $n,
        number: $n,
        date: $n,
        boolean: $n,
        integer: $n,
        float: $n,
        regexp: $n,
        email: $n,
        url: $n,
        hex: $n
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
let il = Object.assign({}, Vo.Modal), al = [];
const pg = () => al.reduce((e, t) => Object.assign(Object.assign({}, e), t), Vo.Modal);
function UO(e) {
  if (e) {
    const t = Object.assign({}, e);
    return al.push(t), il = pg(), () => {
      al = al.filter((n) => n !== t), il = pg();
    };
  }
  il = Object.assign({}, Vo.Modal);
}
function db() {
  return il;
}
const Th = /* @__PURE__ */ $a(void 0), Oh = (e, t) => {
  const n = y.useContext(Th), r = y.useMemo(() => {
    var i;
    const a = t || Vo[e], s = (i = n == null ? void 0 : n[e]) !== null && i !== void 0 ? i : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), o = y.useMemo(() => {
    const i = n == null ? void 0 : n.locale;
    return n != null && n.exist && !i ? Vo.locale : i;
  }, [n]);
  return [r, o];
}, fb = "internalMark", hb = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  if (z.env.NODE_ENV !== "production") {
    const i = nr("LocaleProvider");
    z.env.NODE_ENV !== "production" && i(r === fb, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  y.useEffect(() => UO(t == null ? void 0 : t.Modal), [t]);
  const o = y.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ y.createElement(Th.Provider, {
    value: o
  }, n);
};
z.env.NODE_ENV !== "production" && (hb.displayName = "LocaleProvider");
const pb = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, Aa = Object.assign(Object.assign({}, pb), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
function HO(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: o,
    colorWarning: i,
    colorError: a,
    colorInfo: s,
    colorPrimary: l,
    colorBgBase: c,
    colorTextBase: u
  } = e, d = n(l), f = n(o), h = n(i), p = n(a), g = n(s), v = r(c, u), b = e.colorLink || e.colorInfo, m = n(b), w = new Nt(p[1]).mix(new Nt(p[3]), 50).toHexString();
  return Object.assign(Object.assign({}, v), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: p[1],
    colorErrorBgHover: p[2],
    colorErrorBgFilledHover: w,
    colorErrorBgActive: p[3],
    colorErrorBorder: p[3],
    colorErrorBorderHover: p[4],
    colorErrorHover: p[5],
    colorError: p[6],
    colorErrorActive: p[7],
    colorErrorTextHover: p[8],
    colorErrorText: p[9],
    colorErrorTextActive: p[10],
    colorWarningBg: h[1],
    colorWarningBgHover: h[2],
    colorWarningBorder: h[3],
    colorWarningBorderHover: h[4],
    colorWarningHover: h[4],
    colorWarning: h[6],
    colorWarningActive: h[7],
    colorWarningTextHover: h[8],
    colorWarningText: h[9],
    colorWarningTextActive: h[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: m[4],
    colorLink: m[6],
    colorLinkActive: m[7],
    colorBgMask: new Nt("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const zO = (e) => {
  let t = e, n = e, r = e, o = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: o
  };
};
function qO(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, zO(r));
}
const WO = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function sl(e) {
  return (e + 8) / e;
}
function GO(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const o = r - 1, i = e * Math.pow(Math.E, o / 5), a = r > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: sl(n)
  }));
}
const KO = (e) => {
  const t = GO(e), n = t.map((u) => u.size), r = t.map((u) => u.lineHeight), o = n[1], i = n[0], a = n[2], s = r[1], l = r[0], c = r[2];
  return {
    fontSizeSM: i,
    fontSize: o,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: c,
    lineHeightSM: l,
    fontHeight: Math.round(s * o),
    fontHeightLG: Math.round(c * a),
    fontHeightSM: Math.round(l * i),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
};
function YO(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const Gn = (e, t) => new Nt(e).setA(t).toRgbString(), sa = (e, t) => new Nt(e).darken(t).toHexString(), ZO = (e) => {
  const t = _a(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, QO = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: Gn(r, 0.88),
    colorTextSecondary: Gn(r, 0.65),
    colorTextTertiary: Gn(r, 0.45),
    colorTextQuaternary: Gn(r, 0.25),
    colorFill: Gn(r, 0.15),
    colorFillSecondary: Gn(r, 0.06),
    colorFillTertiary: Gn(r, 0.04),
    colorFillQuaternary: Gn(r, 0.02),
    colorBgSolid: Gn(r, 1),
    colorBgSolidHover: Gn(r, 0.75),
    colorBgSolidActive: Gn(r, 0.95),
    colorBgLayout: sa(n, 4),
    colorBgContainer: sa(n, 0),
    colorBgElevated: sa(n, 0),
    colorBgSpotlight: Gn(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: sa(n, 15),
    colorBorderSecondary: sa(n, 6)
  };
};
function XO(e) {
  Pu.pink = Pu.magenta, Ru.pink = Ru.magenta;
  const t = Object.keys(pb).map((n) => {
    const r = e[n] === Pu[n] ? Ru[n] : _a(e[n]);
    return new Array(10).fill(1).reduce((o, i, a) => (o[`${n}-${a + 1}`] = r[a], o[`${n}${a + 1}`] = r[a], o), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), HO(e, {
    generateColorPalettes: ZO,
    generateNeutralColorPalettes: QO
  })), KO(e.fontSize)), YO(e)), WO(e)), qO(e));
}
const vb = nf(XO), cf = {
  token: Aa,
  override: {
    override: Aa
  },
  hashed: !0
}, gb = /* @__PURE__ */ ee.createContext(cf), Al = "ant", vc = "anticon", JO = (e, t) => t || (e ? `${Al}-${e}` : Al), kt = /* @__PURE__ */ y.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: JO,
  iconPrefixCls: vc
}), eP = `-ant-${Date.now()}-${Math.random()}`;
function tP(e, t) {
  const n = {}, r = (a, s) => {
    let l = a.clone();
    return l = (s == null ? void 0 : s(l)) || l, l.toRgbString();
  }, o = (a, s) => {
    const l = new Nt(a), c = _a(l.toRgbString());
    n[`${s}-color`] = r(l), n[`${s}-color-disabled`] = c[1], n[`${s}-color-hover`] = c[4], n[`${s}-color-active`] = c[6], n[`${s}-color-outline`] = l.clone().setA(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = c[0], n[`${s}-color-deprecated-border`] = c[2];
  };
  if (t.primaryColor) {
    o(t.primaryColor, "primary");
    const a = new Nt(t.primaryColor), s = _a(a.toRgbString());
    s.forEach((c, u) => {
      n[`primary-${u + 1}`] = c;
    }), n["primary-color-deprecated-l-35"] = r(a, (c) => c.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (c) => c.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (c) => c.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (c) => c.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (c) => c.setA(c.a * 0.12));
    const l = new Nt(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(l, (c) => c.setA(c.a * 0.3)), n["primary-color-active-deprecated-d-02"] = r(l, (c) => c.darken(2));
  }
  return t.successColor && o(t.successColor, "success"), t.warningColor && o(t.warningColor, "warning"), t.errorColor && o(t.errorColor, "error"), t.infoColor && o(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function nP(e, t) {
  const n = tP(e, t);
  En() ? Ur(n, `${eP}-dynamic-theme`) : z.env.NODE_ENV !== "production" && Wr(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const Il = /* @__PURE__ */ y.createContext(!1), mb = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = y.useContext(Il);
  return /* @__PURE__ */ y.createElement(Il.Provider, {
    value: n ?? r
  }, t);
}, Fi = /* @__PURE__ */ y.createContext(void 0), rP = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = y.useContext(Fi);
  return /* @__PURE__ */ y.createElement(Fi.Provider, {
    value: n || r
  }, t);
};
function oP() {
  const e = Bt(Il), t = Bt(Fi);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
var yb = /* @__PURE__ */ un(function e() {
  cn(this, e);
}), bb = "CALC_UNIT", iP = new RegExp(bb, "g");
function Nu(e) {
  return typeof e == "number" ? "".concat(e).concat(bb) : e;
}
var aP = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n(r, o) {
    var i;
    cn(this, n), i = t.call(this), U(Ye(i), "result", ""), U(Ye(i), "unitlessCssVar", void 0), U(Ye(i), "lowPriority", void 0);
    var a = Le(r);
    return i.unitlessCssVar = o, r instanceof n ? i.result = "(".concat(r.result, ")") : a === "number" ? i.result = Nu(r) : a === "string" && (i.result = r), i;
  }
  return un(n, [{
    key: "add",
    value: function(o) {
      return o instanceof n ? this.result = "".concat(this.result, " + ").concat(o.getResult()) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " + ").concat(Nu(o))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(o) {
      return o instanceof n ? this.result = "".concat(this.result, " - ").concat(o.getResult()) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " - ").concat(Nu(o))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(o) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), o instanceof n ? this.result = "".concat(this.result, " * ").concat(o.getResult(!0)) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " * ").concat(o)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(o) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), o instanceof n ? this.result = "".concat(this.result, " / ").concat(o.getResult(!0)) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " / ").concat(o)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(o) {
      return this.lowPriority || o ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(o) {
      var i = this, a = o || {}, s = a.unit, l = !0;
      return typeof s == "boolean" ? l = s : Array.from(this.unitlessCssVar).some(function(c) {
        return i.result.includes(c);
      }) && (l = !1), this.result = this.result.replace(iP, l ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), n;
}(yb), sP = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n(r) {
    var o;
    return cn(this, n), o = t.call(this), U(Ye(o), "result", 0), r instanceof n ? o.result = r.result : typeof r == "number" && (o.result = r), o;
  }
  return un(n, [{
    key: "add",
    value: function(o) {
      return o instanceof n ? this.result += o.result : typeof o == "number" && (this.result += o), this;
    }
  }, {
    key: "sub",
    value: function(o) {
      return o instanceof n ? this.result -= o.result : typeof o == "number" && (this.result -= o), this;
    }
  }, {
    key: "mul",
    value: function(o) {
      return o instanceof n ? this.result *= o.result : typeof o == "number" && (this.result *= o), this;
    }
  }, {
    key: "div",
    value: function(o) {
      return o instanceof n ? this.result /= o.result : typeof o == "number" && (this.result /= o), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), n;
}(yb), lP = function(t, n) {
  var r = t === "css" ? aP : sP;
  return function(o) {
    return new r(o, n);
  };
}, vg = function(t, n) {
  return "".concat([n, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function Cn(e) {
  var t = y.useRef();
  t.current = e;
  var n = y.useCallback(function() {
    for (var r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(i));
  }, []);
  return n;
}
function Li(e) {
  var t = y.useRef(!1), n = y.useState(e), r = de(n, 2), o = r[0], i = r[1];
  y.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || i(s);
  }
  return [o, a];
}
function Fu(e) {
  return e !== void 0;
}
function Cb(e, t) {
  var n = t || {}, r = n.defaultValue, o = n.value, i = n.onChange, a = n.postState, s = Li(function() {
    return Fu(o) ? o : Fu(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = de(s, 2), c = l[0], u = l[1], d = o !== void 0 ? o : c, f = a ? a(d) : d, h = Cn(i), p = Li([d]), g = de(p, 2), v = g[0], b = g[1];
  ag(function() {
    var w = v[0];
    c !== w && h(c, w);
  }, [v]), ag(function() {
    Fu(o) || u(o);
  }, [o]);
  var m = Cn(function(w, E) {
    u(w, E), b([d], E);
  });
  return [f, m];
}
function gg(e, t, n, r) {
  var o = V({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    var i = r.deprecatedTokens;
    i.forEach(function(s) {
      var l = de(s, 2), c = l[0], u = l[1];
      if (z.env.NODE_ENV !== "production" && Et(!(o != null && o[c]), "Component Token `".concat(String(c), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(u), "` instead.")), o != null && o[c] || o != null && o[u]) {
        var d;
        (d = o[u]) !== null && d !== void 0 || (o[u] = o == null ? void 0 : o[c]);
      }
    });
  }
  var a = V(V({}, n), o);
  return Object.keys(a).forEach(function(s) {
    a[s] === t[s] && delete a[s];
  }), a;
}
var wb = z.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", uf = !0;
function rr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!wb)
    return Object.assign.apply(Object, [{}].concat(t));
  uf = !1;
  var r = {};
  return t.forEach(function(o) {
    if (Le(o) === "object") {
      var i = Object.keys(o);
      i.forEach(function(a) {
        Object.defineProperty(r, a, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return o[a];
          }
        });
      });
    }
  }), uf = !0, r;
}
var mg = {};
function cP() {
}
var uP = function(t) {
  var n, r = t, o = cP;
  return wb && typeof Proxy < "u" && (n = /* @__PURE__ */ new Set(), r = new Proxy(t, {
    get: function(a, s) {
      if (uf) {
        var l;
        (l = n) === null || l === void 0 || l.add(s);
      }
      return a[s];
    }
  }), o = function(a, s) {
    var l;
    mg[a] = {
      global: Array.from(n),
      component: V(V({}, (l = mg[a]) === null || l === void 0 ? void 0 : l.component), s)
    };
  }), {
    token: r,
    keys: n,
    flush: o
  };
};
function yg(e, t, n) {
  if (typeof n == "function") {
    var r;
    return n(rr(t, (r = t[e]) !== null && r !== void 0 ? r : {}));
  }
  return n ?? {};
}
function dP(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return "max(".concat(r.map(function(i) {
        return ze(i);
      }).join(","), ")");
    },
    min: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return "min(".concat(r.map(function(i) {
        return ze(i);
      }).join(","), ")");
    }
  };
}
var fP = 1e3 * 60 * 10, hP = /* @__PURE__ */ function() {
  function e() {
    cn(this, e), U(this, "map", /* @__PURE__ */ new Map()), U(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), U(this, "nextID", 0), U(this, "lastAccessBeat", /* @__PURE__ */ new Map()), U(this, "accessBeat", 0);
  }
  return un(e, [{
    key: "set",
    value: function(n, r) {
      this.clear();
      var o = this.getCompositeKey(n);
      this.map.set(o, r), this.lastAccessBeat.set(o, Date.now());
    }
  }, {
    key: "get",
    value: function(n) {
      var r = this.getCompositeKey(n), o = this.map.get(r);
      return this.lastAccessBeat.set(r, Date.now()), this.accessBeat += 1, o;
    }
  }, {
    key: "getCompositeKey",
    value: function(n) {
      var r = this, o = n.map(function(i) {
        return i && Le(i) === "object" ? "obj_".concat(r.getObjectID(i)) : "".concat(Le(i), "_").concat(i);
      });
      return o.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(n) {
      if (this.objectIDMap.has(n))
        return this.objectIDMap.get(n);
      var r = this.nextID;
      return this.objectIDMap.set(n, r), this.nextID += 1, r;
    }
  }, {
    key: "clear",
    value: function() {
      var n = this;
      if (this.accessBeat > 1e4) {
        var r = Date.now();
        this.lastAccessBeat.forEach(function(o, i) {
          r - o > fP && (n.map.delete(i), n.lastAccessBeat.delete(i));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
}(), bg = new hP();
function pP(e, t) {
  return ee.useMemo(function() {
    var n = bg.get(t);
    if (n)
      return n;
    var r = e();
    return bg.set(t, r), r;
  }, t);
}
var vP = function() {
  return {};
};
function gP(e) {
  var t = e.useCSP, n = t === void 0 ? vP : t, r = e.useToken, o = e.usePrefix, i = e.getResetStyles, a = e.getCommonStyle, s = e.getCompUnitless;
  function l(f, h, p, g) {
    var v = Array.isArray(f) ? f[0] : f;
    function b(T) {
      return "".concat(String(v)).concat(T.slice(0, 1).toUpperCase()).concat(T.slice(1));
    }
    var m = (g == null ? void 0 : g.unitless) || {}, w = typeof s == "function" ? s(f) : {}, E = V(V({}, w), {}, U({}, b("zIndexPopup"), !0));
    Object.keys(m).forEach(function(T) {
      E[b(T)] = m[T];
    });
    var C = V(V({}, g), {}, {
      unitless: E,
      prefixToken: b
    }), x = u(f, h, p, C), _ = c(v, p, C);
    return function(T) {
      var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : T, I = x(T, O), L = de(I, 2), B = L[1], j = _(O), M = de(j, 2), q = M[0], N = M[1];
      return [q, B, N];
    };
  }
  function c(f, h, p) {
    var g = p.unitless, v = p.injectStyle, b = v === void 0 ? !0 : v, m = p.prefixToken, w = p.ignore, E = function(_) {
      var T = _.rootCls, O = _.cssVar, I = O === void 0 ? {} : O, L = r(), B = L.realToken;
      return kO({
        path: [f],
        prefix: I.prefix,
        key: I.key,
        unitless: g,
        ignore: w,
        token: B,
        scope: T
      }, function() {
        var j = yg(f, B, h), M = gg(f, B, j, {
          deprecatedTokens: p == null ? void 0 : p.deprecatedTokens
        });
        return Object.keys(j).forEach(function(q) {
          M[m(q)] = M[q], delete M[q];
        }), M;
      }), null;
    }, C = function(_) {
      var T = r(), O = T.cssVar;
      return [function(I) {
        return b && O ? /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(E, {
          rootCls: _,
          cssVar: O,
          component: f
        }), I) : I;
      }, O == null ? void 0 : O.key];
    };
    return C;
  }
  function u(f, h, p) {
    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, v = Array.isArray(f) ? f : [f, f], b = de(v, 1), m = b[0], w = v.join("-"), E = e.layer || {
      name: "antd"
    };
    return function(C) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : C, _ = r(), T = _.theme, O = _.realToken, I = _.hashId, L = _.token, B = _.cssVar, j = o(), M = j.rootPrefixCls, q = j.iconPrefixCls, N = n(), $ = B ? "css" : "js", F = pP(function() {
        var Y = /* @__PURE__ */ new Set();
        return B && Object.keys(g.unitless || {}).forEach(function(fe) {
          Y.add(el(fe, B.prefix)), Y.add(el(fe, vg(m, B.prefix)));
        }), lP($, Y);
      }, [$, m, B == null ? void 0 : B.prefix]), H = dP($), k = H.max, W = H.min, G = {
        theme: T,
        token: L,
        hashId: I,
        nonce: function() {
          return N.nonce;
        },
        clientOnly: g.clientOnly,
        layer: E,
        // antd is always at top of styles
        order: g.order || -999
      };
      typeof i == "function" && lf(V(V({}, G), {}, {
        clientOnly: !1,
        path: ["Shared", M]
      }), function() {
        return i(L, {
          prefix: {
            rootPrefixCls: M,
            iconPrefixCls: q
          },
          csp: N
        });
      });
      var ne = lf(V(V({}, G), {}, {
        path: [w, C, q]
      }), function() {
        if (g.injectStyle === !1)
          return [];
        var Y = uP(L), fe = Y.token, ge = Y.flush, ie = yg(m, O, p), he = ".".concat(C), ue = gg(m, O, ie, {
          deprecatedTokens: g.deprecatedTokens
        });
        B && ie && Le(ie) === "object" && Object.keys(ie).forEach(function(ke) {
          ie[ke] = "var(".concat(el(ke, vg(m, B.prefix)), ")");
        });
        var ce = rr(fe, {
          componentCls: he,
          prefixCls: C,
          iconCls: ".".concat(q),
          antCls: ".".concat(M),
          calc: F,
          // @ts-ignore
          max: k,
          // @ts-ignore
          min: W
        }, B ? ie : ue), Se = h(ce, {
          hashId: I,
          prefixCls: C,
          rootPrefixCls: M,
          iconPrefixCls: q
        });
        ge(m, ue);
        var te = typeof a == "function" ? a(ce, C, x, g.resetFont) : null;
        return [g.resetStyle === !1 ? null : te, Se];
      });
      return [ne, I];
    };
  }
  function d(f, h, p) {
    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, v = u(f, h, p, V({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, g)), b = function(w) {
      var E = w.prefixCls, C = w.rootCls, x = C === void 0 ? E : C;
      return v(E, x), null;
    };
    return z.env.NODE_ENV !== "production" && (b.displayName = "SubStyle_".concat(String(Array.isArray(f) ? f.join(".") : f))), b;
  }
  return {
    genStyleHooks: l,
    genSubStyleComponent: d,
    genComponentStyleHook: u
  };
}
const Mi = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], mP = "5.23.2";
function Lu(e) {
  return e >= 0 && e <= 255;
}
function Ps(e, t) {
  const {
    r: n,
    g: r,
    b: o,
    a: i
  } = new Nt(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: a,
    g: s,
    b: l
  } = new Nt(t).toRgb();
  for (let c = 0.01; c <= 1; c += 0.01) {
    const u = Math.round((n - a * (1 - c)) / c), d = Math.round((r - s * (1 - c)) / c), f = Math.round((o - l * (1 - c)) / c);
    if (Lu(u) && Lu(d) && Lu(f))
      return new Nt({
        r: u,
        g: d,
        b: f,
        a: Math.round(c * 100) / 100
      }).toRgbString();
  }
  return new Nt({
    r: n,
    g: r,
    b: o,
    a: 1
  }).toRgbString();
}
var yP = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Eb(e) {
  const {
    override: t
  } = e, n = yP(e, ["override"]), r = Object.assign({}, t);
  Object.keys(Aa).forEach((f) => {
    delete r[f];
  });
  const o = Object.assign(Object.assign({}, n), r), i = 480, a = 576, s = 768, l = 992, c = 1200, u = 1600;
  if (o.motion === !1) {
    const f = "0s";
    o.motionDurationFast = f, o.motionDurationMid = f, o.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: Ps(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: Ps(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: Ps(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 3,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: Ps(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: c - 1,
    screenXL: c,
    screenXLMin: c,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Nt("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Nt("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Nt("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var Cg = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const _b = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, bP = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, CP = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, xb = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: o
  } = t, i = Cg(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: o
  });
  return a = Eb(a), i && Object.entries(i).forEach((s) => {
    let [l, c] = s;
    const {
      theme: u
    } = c, d = Cg(c, ["theme"]);
    let f = d;
    u && (f = xb(Object.assign(Object.assign({}, a), d), {
      override: d
    }, u)), a[l] = f;
  }), a;
};
function Gr() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: o
  } = ee.useContext(gb), i = `${mP}-${t || ""}`, a = n || vb, [s, l, c] = oO(a, [Aa, e], {
    salt: i,
    override: r,
    getComputedToken: xb,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Eb,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: _b,
      ignore: bP,
      preserve: CP
    }
  });
  return [a, c, t ? l : "", s, o];
}
const Sb = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, Tb = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), wP = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), EP = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), _P = (e, t, n, r) => {
  const o = `[class^="${t}"], [class*=" ${t}"]`, i = n ? `.${n}` : o, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return r !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [i]: Object.assign(Object.assign(Object.assign({}, s), a), {
      [o]: a
    })
  };
}, xP = (e, t) => ({
  outline: `${ze(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: t ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), Ph = (e, t) => ({
  "&:focus-visible": Object.assign({}, xP(e, t))
}), Ob = (e) => ({
  [`.${e}`]: Object.assign(Object.assign({}, Tb()), {
    [`.${e} .${e}-icon`]: {
      display: "block"
    }
  })
}), {
  genStyleHooks: qo,
  genComponentStyleHook: SP,
  genSubStyleComponent: Pb
} = gP({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = Bt(kt);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, n, r, o] = Gr();
    return {
      theme: e,
      realToken: t,
      hashId: n,
      token: r,
      cssVar: o
    };
  },
  useCSP: () => {
    const {
      csp: e
    } = Bt(kt);
    return e ?? {};
  },
  getResetStyles: (e, t) => {
    var n;
    return [{
      "&": EP(e)
    }, Ob((n = t == null ? void 0 : t.prefix.iconPrefixCls) !== null && n !== void 0 ? n : vc)];
  },
  getCommonStyle: _P,
  getCompUnitless: () => _b
});
function TP(e, t) {
  return Mi.reduce((n, r) => {
    const o = e[`${r}1`], i = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: o,
      lightBorderColor: i,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
const OP = (e, t) => {
  const [n, r] = Gr();
  return lf({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [Ob(e)]);
}, PP = Object.assign({}, y), {
  useId: wg
} = PP, RP = () => "", AP = typeof wg > "u" ? RP : wg;
function IP(e, t, n) {
  var r, o;
  const i = nr("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, cf), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : cf.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, l = AP();
  if (z.env.NODE_ENV !== "production") {
    const c = a.cssVar || s.cssVar, u = !!(typeof a.cssVar == "object" && (!((o = a.cssVar) === null || o === void 0) && o.key) || l);
    z.env.NODE_ENV !== "production" && i(!c || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return bh(() => {
    var c, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((p) => {
      d[p] = Object.assign(Object.assign({}, d[p]), e.components[p]);
    });
    const f = `css-var-${l.replace(/:/g, "")}`, h = ((c = a.cssVar) !== null && c !== void 0 ? c : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((u = a.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: d,
      cssVar: h
    });
  }, [a, s], (c, u) => c.some((d, f) => {
    const h = u[f];
    return !ef(d, h, !0);
  }));
}
var kP = ["children"], Rb = /* @__PURE__ */ y.createContext({});
function $P(e) {
  var t = e.children, n = Hn(e, kP);
  return /* @__PURE__ */ y.createElement(Rb.Provider, {
    value: n
  }, t);
}
var NP = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n() {
    return cn(this, n), t.apply(this, arguments);
  }
  return un(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(y.Component);
function FP(e) {
  var t = y.useReducer(function(s) {
    return s + 1;
  }, 0), n = de(t, 2), r = n[1], o = y.useRef(e), i = Cn(function() {
    return o.current;
  }), a = Cn(function(s) {
    o.current = typeof s == "function" ? s(o.current) : s, r();
  });
  return [i, a];
}
var ro = "none", Rs = "appear", As = "enter", Is = "leave", Eg = "none", cr = "prepare", vi = "start", gi = "active", Rh = "end", Ab = "prepared";
function _g(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function LP(e, t) {
  var n = {
    animationend: _g("Animation", "AnimationEnd"),
    transitionend: _g("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var MP = LP(En(), typeof window < "u" ? window : {}), Ib = {};
if (En()) {
  var DP = document.createElement("div");
  Ib = DP.style;
}
var ks = {};
function kb(e) {
  if (ks[e])
    return ks[e];
  var t = MP[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, o = 0; o < r; o += 1) {
      var i = n[o];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in Ib)
        return ks[e] = t[i], ks[e];
    }
  return "";
}
var $b = kb("animationend"), Nb = kb("transitionend"), Fb = !!($b && Nb), xg = $b || "animationend", Sg = Nb || "transitionend";
function Tg(e, t) {
  if (!e)
    return null;
  if (Le(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const jP = function(e) {
  var t = lt();
  function n(o) {
    o && (o.removeEventListener(Sg, e), o.removeEventListener(xg, e));
  }
  function r(o) {
    t.current && t.current !== o && n(t.current), o && o !== t.current && (o.addEventListener(Sg, e), o.addEventListener(xg, e), t.current = o);
  }
  return y.useEffect(function() {
    return function() {
      n(t.current);
    };
  }, []), [r, n];
};
var Lb = En() ? z0 : ut;
const BP = function() {
  var e = y.useRef(null);
  function t() {
    mo.cancel(e.current);
  }
  function n(r) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = mo(function() {
      o <= 1 ? r({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : n(r, o - 1);
    });
    e.current = i;
  }
  return y.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var VP = [cr, vi, gi, Rh], UP = [cr, Ab], Mb = !1, HP = !0;
function Db(e) {
  return e === gi || e === Rh;
}
const zP = function(e, t, n) {
  var r = Li(Eg), o = de(r, 2), i = o[0], a = o[1], s = BP(), l = de(s, 2), c = l[0], u = l[1];
  function d() {
    a(cr, !0);
  }
  var f = t ? UP : VP;
  return Lb(function() {
    if (i !== Eg && i !== Rh) {
      var h = f.indexOf(i), p = f[h + 1], g = n(i);
      g === Mb ? a(p, !0) : p && c(function(v) {
        function b() {
          v.isCanceled() || a(p, !0);
        }
        g === !0 ? b() : Promise.resolve(g).then(b);
      });
    }
  }, [e, i]), y.useEffect(function() {
    return function() {
      u();
    };
  }, []), [d, i];
};
function qP(e, t, n, r) {
  var o = r.motionEnter, i = o === void 0 ? !0 : o, a = r.motionAppear, s = a === void 0 ? !0 : a, l = r.motionLeave, c = l === void 0 ? !0 : l, u = r.motionDeadline, d = r.motionLeaveImmediately, f = r.onAppearPrepare, h = r.onEnterPrepare, p = r.onLeavePrepare, g = r.onAppearStart, v = r.onEnterStart, b = r.onLeaveStart, m = r.onAppearActive, w = r.onEnterActive, E = r.onLeaveActive, C = r.onAppearEnd, x = r.onEnterEnd, _ = r.onLeaveEnd, T = r.onVisibleChanged, O = Li(), I = de(O, 2), L = I[0], B = I[1], j = FP(ro), M = de(j, 2), q = M[0], N = M[1], $ = Li(null), F = de($, 2), H = F[0], k = F[1], W = q(), G = lt(!1), ne = lt(null);
  function Y() {
    return n();
  }
  var fe = lt(!1);
  function ge() {
    N(ro), k(null, !0);
  }
  var ie = Cn(function(ae) {
    var xe = q();
    if (xe !== ro) {
      var Re = Y();
      if (!(ae && !ae.deadline && ae.target !== Re)) {
        var mt = fe.current, et;
        xe === Rs && mt ? et = C == null ? void 0 : C(Re, ae) : xe === As && mt ? et = x == null ? void 0 : x(Re, ae) : xe === Is && mt && (et = _ == null ? void 0 : _(Re, ae)), mt && et !== !1 && ge();
      }
    }
  }), he = jP(ie), ue = de(he, 1), ce = ue[0], Se = function(xe) {
    switch (xe) {
      case Rs:
        return U(U(U({}, cr, f), vi, g), gi, m);
      case As:
        return U(U(U({}, cr, h), vi, v), gi, w);
      case Is:
        return U(U(U({}, cr, p), vi, b), gi, E);
      default:
        return {};
    }
  }, te = y.useMemo(function() {
    return Se(W);
  }, [W]), ke = zP(W, !e, function(ae) {
    if (ae === cr) {
      var xe = te[cr];
      return xe ? xe(Y()) : Mb;
    }
    if (X in te) {
      var Re;
      k(((Re = te[X]) === null || Re === void 0 ? void 0 : Re.call(te, Y(), null)) || null);
    }
    return X === gi && W !== ro && (ce(Y()), u > 0 && (clearTimeout(ne.current), ne.current = setTimeout(function() {
      ie({
        deadline: !0
      });
    }, u))), X === Ab && ge(), HP;
  }), se = de(ke, 2), D = se[0], X = se[1], Q = Db(X);
  fe.current = Q;
  var _e = lt(null);
  Lb(function() {
    if (!(G.current && _e.current === t)) {
      B(t);
      var ae = G.current;
      G.current = !0;
      var xe;
      !ae && t && s && (xe = Rs), ae && t && i && (xe = As), (ae && !t && c || !ae && d && !t && c) && (xe = Is);
      var Re = Se(xe);
      xe && (e || Re[cr]) ? (N(xe), D()) : N(ro), _e.current = t;
    }
  }, [t]), ut(function() {
    // Cancel appear
    (W === Rs && !s || // Cancel enter
    W === As && !i || // Cancel leave
    W === Is && !c) && N(ro);
  }, [s, i, c]), ut(function() {
    return function() {
      G.current = !1, clearTimeout(ne.current);
    };
  }, []);
  var Ce = y.useRef(!1);
  ut(function() {
    L && (Ce.current = !0), L !== void 0 && W === ro && ((Ce.current || L) && (T == null || T(L)), Ce.current = !0);
  }, [L, W]);
  var Ne = H;
  return te[cr] && X === vi && (Ne = V({
    transition: "none"
  }, Ne)), [W, X, Ne, L ?? t];
}
function WP(e) {
  var t = e;
  Le(e) === "object" && (t = e.transitionSupport);
  function n(o, i) {
    return !!(o.motionName && t && i !== !1);
  }
  var r = /* @__PURE__ */ y.forwardRef(function(o, i) {
    var a = o.visible, s = a === void 0 ? !0 : a, l = o.removeOnLeave, c = l === void 0 ? !0 : l, u = o.forceRender, d = o.children, f = o.motionName, h = o.leavedClassName, p = o.eventProps, g = y.useContext(Rb), v = g.motion, b = n(o, v), m = lt(), w = lt();
    function E() {
      try {
        return m.current instanceof HTMLElement ? m.current : Js(w.current);
      } catch {
        return null;
      }
    }
    var C = qP(b, s, E, o), x = de(C, 4), _ = x[0], T = x[1], O = x[2], I = x[3], L = y.useRef(I);
    I && (L.current = !0);
    var B = y.useCallback(function(F) {
      m.current = F, Ch(i, F);
    }, [i]), j, M = V(V({}, p), {}, {
      visible: s
    });
    if (!d)
      j = null;
    else if (_ === ro)
      I ? j = d(V({}, M), B) : !c && L.current && h ? j = d(V(V({}, M), {}, {
        className: h
      }), B) : u || !c && !h ? j = d(V(V({}, M), {}, {
        style: {
          display: "none"
        }
      }), B) : j = null;
    else {
      var q;
      T === cr ? q = "prepare" : Db(T) ? q = "active" : T === vi && (q = "start");
      var N = Tg(f, "".concat(_, "-").concat(q));
      j = d(V(V({}, M), {}, {
        className: me(Tg(f, _), U(U({}, N, N && q), f, typeof f == "string")),
        style: O
      }), B);
    }
    if (/* @__PURE__ */ y.isValidElement(j) && ja(j)) {
      var $ = sc(j);
      $ || (j = /* @__PURE__ */ y.cloneElement(j, {
        ref: B
      }));
    }
    return /* @__PURE__ */ y.createElement(NP, {
      ref: w
    }, j);
  });
  return r.displayName = "CSSMotion", r;
}
const Hr = WP(Fb);
var df = "add", ff = "keep", hf = "remove", Mu = "removed";
function GP(e) {
  var t;
  return e && Le(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, V(V({}, t), {}, {
    key: String(t.key)
  });
}
function pf() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(GP);
}
function KP() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, o = t.length, i = pf(e), a = pf(t);
  i.forEach(function(c) {
    for (var u = !1, d = r; d < o; d += 1) {
      var f = a[d];
      if (f.key === c.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(h) {
          return V(V({}, h), {}, {
            status: df
          });
        })), r = d), n.push(V(V({}, f), {}, {
          status: ff
        })), r += 1, u = !0;
        break;
      }
    }
    u || n.push(V(V({}, c), {}, {
      status: hf
    }));
  }), r < o && (n = n.concat(a.slice(r).map(function(c) {
    return V(V({}, c), {}, {
      status: df
    });
  })));
  var s = {};
  n.forEach(function(c) {
    var u = c.key;
    s[u] = (s[u] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    n = n.filter(function(u) {
      var d = u.key, f = u.status;
      return d !== c || f !== hf;
    }), n.forEach(function(u) {
      u.key === c && (u.status = ff);
    });
  }), n;
}
var YP = ["component", "children", "onVisibleChanged", "onAllRemoved"], ZP = ["status"], QP = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function XP(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Hr, n = /* @__PURE__ */ function(r) {
    bo(i, r);
    var o = Co(i);
    function i() {
      var a;
      cn(this, i);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return a = o.call.apply(o, [this].concat(l)), U(Ye(a), "state", {
        keyEntities: []
      }), U(Ye(a), "removeKey", function(u) {
        a.setState(function(d) {
          var f = d.keyEntities.map(function(h) {
            return h.key !== u ? h : V(V({}, h), {}, {
              status: Mu
            });
          });
          return {
            keyEntities: f
          };
        }, function() {
          var d = a.state.keyEntities, f = d.filter(function(h) {
            var p = h.status;
            return p !== Mu;
          }).length;
          f === 0 && a.props.onAllRemoved && a.props.onAllRemoved();
        });
      }), a;
    }
    return un(i, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, u = c.component, d = c.children, f = c.onVisibleChanged;
        c.onAllRemoved;
        var h = Hn(c, YP), p = u || y.Fragment, g = {};
        return QP.forEach(function(v) {
          g[v] = h[v], delete h[v];
        }), delete h.keys, /* @__PURE__ */ y.createElement(p, h, l.map(function(v, b) {
          var m = v.status, w = Hn(v, ZP), E = m === df || m === ff;
          return /* @__PURE__ */ y.createElement(t, it({}, g, {
            key: w.key,
            visible: E,
            eventProps: w,
            onVisibleChanged: function(x) {
              f == null || f(x, {
                key: w.key
              }), x || s.removeKey(w.key);
            }
          }), function(C, x) {
            return d(V(V({}, C), {}, {
              index: b
            }), x);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, u = l.keyEntities, d = pf(c), f = KP(u, d);
        return {
          keyEntities: f.filter(function(h) {
            var p = u.find(function(g) {
              var v = g.key;
              return h.key === v;
            });
            return !(p && p.status === Mu && h.status === hf);
          })
        };
      }
    }]), i;
  }(y.Component);
  return U(n, "defaultProps", {
    component: "div"
  }), n;
}
XP(Fb);
function JP(e) {
  const {
    children: t
  } = e, [, n] = Gr(), {
    motion: r
  } = n, o = y.useRef(!1);
  return o.current = o.current || r === !1, o.current ? /* @__PURE__ */ y.createElement($P, {
    motion: r
  }, t) : t;
}
const jb = /* @__PURE__ */ y.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return nr("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
z.env.NODE_ENV !== "production" && (jb.displayName = "PropWarning");
const eR = z.env.NODE_ENV !== "production" ? jb : () => null;
var tR = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let vf = !1;
const nR = z.env.NODE_ENV !== "production" ? (e) => {
  z.env.NODE_ENV !== "production" && Wr(!vf, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), rR = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let kl, Bb, Vb, Ub;
function ll() {
  return kl || Al;
}
function oR() {
  return Bb || vc;
}
function iR(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const aR = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: o
  } = e;
  t !== void 0 && (kl = t), n !== void 0 && (Bb = n), "holderRender" in e && (Ub = o), r && (iR(r) ? (z.env.NODE_ENV !== "production" && Wr(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), nP(ll(), r)) : Vb = r);
}, sR = () => ({
  getPrefixCls: (e, t) => t || (e ? `${ll()}-${e}` : ll()),
  getIconPrefixCls: oR,
  getRootPrefixCls: () => kl || ll(),
  getTheme: () => Vb,
  holderRender: Ub
}), lR = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    form: a,
    locale: s,
    componentSize: l,
    direction: c,
    space: u,
    splitter: d,
    virtual: f,
    dropdownMatchSelectWidth: h,
    popupMatchSelectWidth: p,
    popupOverflow: g,
    legacyLocale: v,
    parentContext: b,
    iconPrefixCls: m,
    theme: w,
    componentDisabled: E,
    segmented: C,
    statistic: x,
    spin: _,
    calendar: T,
    carousel: O,
    cascader: I,
    collapse: L,
    typography: B,
    checkbox: j,
    descriptions: M,
    divider: q,
    drawer: N,
    skeleton: $,
    steps: F,
    image: H,
    layout: k,
    list: W,
    mentions: G,
    modal: ne,
    progress: Y,
    result: fe,
    slider: ge,
    breadcrumb: ie,
    menu: he,
    pagination: ue,
    input: ce,
    textArea: Se,
    empty: te,
    badge: ke,
    radio: se,
    rate: D,
    switch: X,
    transfer: Q,
    avatar: _e,
    message: Ce,
    tag: Ne,
    table: ae,
    card: xe,
    tabs: Re,
    timeline: mt,
    timePicker: et,
    upload: tt,
    notification: _t,
    tree: $t,
    colorPicker: en,
    datePicker: Ee,
    rangePicker: Fe,
    flex: S,
    wave: A,
    dropdown: K,
    warning: J,
    tour: le,
    tooltip: be,
    popover: Oe,
    popconfirm: We,
    floatButtonGroup: Ke,
    variant: nt,
    inputNumber: at,
    treeSelect: st
  } = e, ct = y.useCallback((yt, bt) => {
    const {
      prefixCls: fn
    } = e;
    if (bt)
      return bt;
    const R = fn || b.getPrefixCls("");
    return yt ? `${R}-${yt}` : R;
  }, [b.getPrefixCls, e.prefixCls]), Vt = m || b.iconPrefixCls || vc, xt = n || b.csp;
  OP(Vt, xt);
  const _n = IP(w, b.theme, {
    prefixCls: ct("")
  });
  z.env.NODE_ENV !== "production" && (vf = vf || !!_n);
  const ot = {
    csp: xt,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    locale: s || v,
    direction: c,
    space: u,
    splitter: d,
    virtual: f,
    popupMatchSelectWidth: p ?? h,
    popupOverflow: g,
    getPrefixCls: ct,
    iconPrefixCls: Vt,
    theme: _n,
    segmented: C,
    statistic: x,
    spin: _,
    calendar: T,
    carousel: O,
    cascader: I,
    collapse: L,
    typography: B,
    checkbox: j,
    descriptions: M,
    divider: q,
    drawer: N,
    skeleton: $,
    steps: F,
    image: H,
    input: ce,
    textArea: Se,
    layout: k,
    list: W,
    mentions: G,
    modal: ne,
    progress: Y,
    result: fe,
    slider: ge,
    breadcrumb: ie,
    menu: he,
    pagination: ue,
    empty: te,
    badge: ke,
    radio: se,
    rate: D,
    switch: X,
    transfer: Q,
    avatar: _e,
    message: Ce,
    tag: Ne,
    table: ae,
    card: xe,
    tabs: Re,
    timeline: mt,
    timePicker: et,
    upload: tt,
    notification: _t,
    tree: $t,
    colorPicker: en,
    datePicker: Ee,
    rangePicker: Fe,
    flex: S,
    wave: A,
    dropdown: K,
    warning: J,
    tour: le,
    tooltip: be,
    popover: Oe,
    popconfirm: We,
    floatButtonGroup: Ke,
    variant: nt,
    inputNumber: at,
    treeSelect: st
  };
  z.env.NODE_ENV !== "production" && nr("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const rt = Object.assign({}, b);
  Object.keys(ot).forEach((yt) => {
    ot[yt] !== void 0 && (rt[yt] = ot[yt]);
  }), rR.forEach((yt) => {
    const bt = e[yt];
    bt && (rt[yt] = bt);
  }), typeof r < "u" && (rt.button = Object.assign({
    autoInsertSpace: r
  }, rt.button));
  const Ut = bh(() => rt, rt, (yt, bt) => {
    const fn = Object.keys(yt), R = Object.keys(bt);
    return fn.length !== R.length || fn.some((re) => yt[re] !== bt[re]);
  }), ir = y.useMemo(() => ({
    prefixCls: Vt,
    csp: xt
  }), [Vt, xt]);
  let St = /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(eR, {
    dropdownMatchSelectWidth: h
  }), t);
  const tn = y.useMemo(() => {
    var yt, bt, fn, R;
    return pi(((yt = Vo.Form) === null || yt === void 0 ? void 0 : yt.defaultValidateMessages) || {}, ((fn = (bt = Ut.locale) === null || bt === void 0 ? void 0 : bt.Form) === null || fn === void 0 ? void 0 : fn.defaultValidateMessages) || {}, ((R = Ut.form) === null || R === void 0 ? void 0 : R.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [Ut, a == null ? void 0 : a.validateMessages]);
  Object.keys(tn).length > 0 && (St = /* @__PURE__ */ y.createElement(DO.Provider, {
    value: tn
  }, St)), s && (St = /* @__PURE__ */ y.createElement(hb, {
    locale: s,
    _ANT_MARK__: fb
  }, St)), (Vt || xt) && (St = /* @__PURE__ */ y.createElement(vh.Provider, {
    value: ir
  }, St)), l && (St = /* @__PURE__ */ y.createElement(rP, {
    size: l
  }, St)), St = /* @__PURE__ */ y.createElement(JP, null, St);
  const Yr = y.useMemo(() => {
    const yt = _n || {}, {
      algorithm: bt,
      token: fn,
      components: R,
      cssVar: re
    } = yt, pe = tR(yt, ["algorithm", "token", "components", "cssVar"]), Ie = bt && (!Array.isArray(bt) || bt.length > 0) ? nf(bt) : vb, He = {};
    Object.entries(R || {}).forEach((je) => {
      let [Be, Ot] = je;
      const Xe = Object.assign({}, Ot);
      "algorithm" in Xe && (Xe.algorithm === !0 ? Xe.theme = Ie : (Array.isArray(Xe.algorithm) || typeof Xe.algorithm == "function") && (Xe.theme = nf(Xe.algorithm)), delete Xe.algorithm), He[Be] = Xe;
    });
    const Ze = Object.assign(Object.assign({}, Aa), fn);
    return Object.assign(Object.assign({}, pe), {
      theme: Ie,
      token: Ze,
      components: He,
      override: Object.assign({
        override: Ze
      }, He),
      cssVar: re
    });
  }, [_n]);
  return w && (St = /* @__PURE__ */ y.createElement(gb.Provider, {
    value: Yr
  }, St)), Ut.warning && (St = /* @__PURE__ */ y.createElement(cb.Provider, {
    value: Ut.warning
  }, St)), E !== void 0 && (St = /* @__PURE__ */ y.createElement(mb, {
    disabled: E
  }, St)), /* @__PURE__ */ y.createElement(kt.Provider, {
    value: Ut
  }, St);
}, br = (e) => {
  const t = y.useContext(kt), n = y.useContext(Th);
  return /* @__PURE__ */ y.createElement(lR, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
br.ConfigContext = kt;
br.SizeContext = Fi;
br.config = aR;
br.useConfig = oP;
Object.defineProperty(br, "SizeContext", {
  get: () => (z.env.NODE_ENV !== "production" && Wr(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Fi)
});
z.env.NODE_ENV !== "production" && (br.displayName = "ConfigProvider");
var cR = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, uR = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, dR = "".concat(cR, " ").concat(uR).split(/[\s\n]+/), fR = "aria-", hR = "data-";
function Og(e, t) {
  return e.indexOf(t) === 0;
}
function Di(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = V({}, t);
  var r = {};
  return Object.keys(e).forEach(function(o) {
    // Aria
    (n.aria && (o === "role" || Og(o, fR)) || // Data
    n.data && Og(o, hR) || // Attr
    n.attr && dR.includes(o)) && (r[o] = e[o]);
  }), r;
}
function Hb(e) {
  return e && /* @__PURE__ */ ee.isValidElement(e) && e.type === ee.Fragment;
}
const pR = (e, t, n) => /* @__PURE__ */ ee.isValidElement(e) ? /* @__PURE__ */ ee.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
function Ah(e, t) {
  return pR(e, e, t);
}
const zb = (e) => {
  const [, , , , t] = Gr();
  return t ? `${e}-css-var` : "";
};
var $e = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= $e.F1 && n <= $e.F12)
      return !1;
    switch (n) {
      case $e.ALT:
      case $e.CAPS_LOCK:
      case $e.CONTEXT_MENU:
      case $e.CTRL:
      case $e.DOWN:
      case $e.END:
      case $e.ESC:
      case $e.HOME:
      case $e.INSERT:
      case $e.LEFT:
      case $e.MAC_FF_META:
      case $e.META:
      case $e.NUMLOCK:
      case $e.NUM_CENTER:
      case $e.PAGE_DOWN:
      case $e.PAGE_UP:
      case $e.PAUSE:
      case $e.PRINT_SCREEN:
      case $e.RIGHT:
      case $e.SHIFT:
      case $e.UP:
      case $e.WIN_KEY:
      case $e.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= $e.ZERO && t <= $e.NINE || t >= $e.NUM_ZERO && t <= $e.NUM_MULTIPLY || t >= $e.A && t <= $e.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case $e.SPACE:
      case $e.QUESTION_MARK:
      case $e.NUM_PLUS:
      case $e.NUM_MINUS:
      case $e.NUM_PERIOD:
      case $e.NUM_DIVISION:
      case $e.SEMICOLON:
      case $e.DASH:
      case $e.EQUALS:
      case $e.COMMA:
      case $e.PERIOD:
      case $e.SLASH:
      case $e.APOSTROPHE:
      case $e.SINGLE_QUOTE:
      case $e.OPEN_SQUARE_BRACKET:
      case $e.BACKSLASH:
      case $e.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
};
const Ba = /* @__PURE__ */ ee.createContext(void 0);
z.env.NODE_ENV !== "production" && (Ba.displayName = "zIndexContext");
const Mr = 100, vR = 10, qb = Mr * vR, gR = qb + Mr, Wb = {
  Modal: Mr,
  Drawer: Mr,
  Popover: Mr,
  Popconfirm: Mr,
  Tooltip: Mr,
  Tour: Mr,
  FloatButton: Mr
}, mR = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function yR(e) {
  return e in Wb;
}
const Ih = (e, t) => {
  const [, n] = Gr(), r = ee.useContext(Ba), o = yR(e);
  let i;
  if (t !== void 0)
    i = [t, t];
  else {
    let a = r ?? 0;
    o ? a += // Use preset token zIndex by default but not stack when has parent container
    (r ? 0 : n.zIndexPopupBase) + // Container offset
    Wb[e] : a += mR[e], i = [r === void 0 ? t : a, a];
  }
  if (z.env.NODE_ENV !== "production") {
    const a = nr(e), s = n.zIndexPopupBase + gR, l = i[0] || 0;
    z.env.NODE_ENV !== "production" && a(t !== void 0 || l <= s, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return i;
};
function bR() {
  const [e, t] = y.useState([]), n = y.useCallback((r) => (t((o) => [].concat(Pe(o), [r])), () => {
    t((o) => o.filter((i) => i !== r));
  }), []);
  return [e, n];
}
function Sn() {
  Sn = function() {
    return t;
  };
  var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(N, $, F) {
    N[$] = F.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, a = i.iterator || "@@iterator", s = i.asyncIterator || "@@asyncIterator", l = i.toStringTag || "@@toStringTag";
  function c(N, $, F) {
    return Object.defineProperty(N, $, {
      value: F,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), N[$];
  }
  try {
    c({}, "");
  } catch {
    c = function(F, H, k) {
      return F[H] = k;
    };
  }
  function u(N, $, F, H) {
    var k = $ && $.prototype instanceof b ? $ : b, W = Object.create(k.prototype), G = new M(H || []);
    return o(W, "_invoke", {
      value: I(N, F, G)
    }), W;
  }
  function d(N, $, F) {
    try {
      return {
        type: "normal",
        arg: N.call($, F)
      };
    } catch (H) {
      return {
        type: "throw",
        arg: H
      };
    }
  }
  t.wrap = u;
  var f = "suspendedStart", h = "suspendedYield", p = "executing", g = "completed", v = {};
  function b() {
  }
  function m() {
  }
  function w() {
  }
  var E = {};
  c(E, a, function() {
    return this;
  });
  var C = Object.getPrototypeOf, x = C && C(C(q([])));
  x && x !== n && r.call(x, a) && (E = x);
  var _ = w.prototype = b.prototype = Object.create(E);
  function T(N) {
    ["next", "throw", "return"].forEach(function($) {
      c(N, $, function(F) {
        return this._invoke($, F);
      });
    });
  }
  function O(N, $) {
    function F(k, W, G, ne) {
      var Y = d(N[k], N, W);
      if (Y.type !== "throw") {
        var fe = Y.arg, ge = fe.value;
        return ge && Le(ge) == "object" && r.call(ge, "__await") ? $.resolve(ge.__await).then(function(ie) {
          F("next", ie, G, ne);
        }, function(ie) {
          F("throw", ie, G, ne);
        }) : $.resolve(ge).then(function(ie) {
          fe.value = ie, G(fe);
        }, function(ie) {
          return F("throw", ie, G, ne);
        });
      }
      ne(Y.arg);
    }
    var H;
    o(this, "_invoke", {
      value: function(W, G) {
        function ne() {
          return new $(function(Y, fe) {
            F(W, G, Y, fe);
          });
        }
        return H = H ? H.then(ne, ne) : ne();
      }
    });
  }
  function I(N, $, F) {
    var H = f;
    return function(k, W) {
      if (H === p)
        throw Error("Generator is already running");
      if (H === g) {
        if (k === "throw")
          throw W;
        return {
          value: e,
          done: !0
        };
      }
      for (F.method = k, F.arg = W; ; ) {
        var G = F.delegate;
        if (G) {
          var ne = L(G, F);
          if (ne) {
            if (ne === v)
              continue;
            return ne;
          }
        }
        if (F.method === "next")
          F.sent = F._sent = F.arg;
        else if (F.method === "throw") {
          if (H === f)
            throw H = g, F.arg;
          F.dispatchException(F.arg);
        } else
          F.method === "return" && F.abrupt("return", F.arg);
        H = p;
        var Y = d(N, $, F);
        if (Y.type === "normal") {
          if (H = F.done ? g : h, Y.arg === v)
            continue;
          return {
            value: Y.arg,
            done: F.done
          };
        }
        Y.type === "throw" && (H = g, F.method = "throw", F.arg = Y.arg);
      }
    };
  }
  function L(N, $) {
    var F = $.method, H = N.iterator[F];
    if (H === e)
      return $.delegate = null, F === "throw" && N.iterator.return && ($.method = "return", $.arg = e, L(N, $), $.method === "throw") || F !== "return" && ($.method = "throw", $.arg = new TypeError("The iterator does not provide a '" + F + "' method")), v;
    var k = d(H, N.iterator, $.arg);
    if (k.type === "throw")
      return $.method = "throw", $.arg = k.arg, $.delegate = null, v;
    var W = k.arg;
    return W ? W.done ? ($[N.resultName] = W.value, $.next = N.nextLoc, $.method !== "return" && ($.method = "next", $.arg = e), $.delegate = null, v) : W : ($.method = "throw", $.arg = new TypeError("iterator result is not an object"), $.delegate = null, v);
  }
  function B(N) {
    var $ = {
      tryLoc: N[0]
    };
    1 in N && ($.catchLoc = N[1]), 2 in N && ($.finallyLoc = N[2], $.afterLoc = N[3]), this.tryEntries.push($);
  }
  function j(N) {
    var $ = N.completion || {};
    $.type = "normal", delete $.arg, N.completion = $;
  }
  function M(N) {
    this.tryEntries = [{
      tryLoc: "root"
    }], N.forEach(B, this), this.reset(!0);
  }
  function q(N) {
    if (N || N === "") {
      var $ = N[a];
      if ($)
        return $.call(N);
      if (typeof N.next == "function")
        return N;
      if (!isNaN(N.length)) {
        var F = -1, H = function k() {
          for (; ++F < N.length; )
            if (r.call(N, F))
              return k.value = N[F], k.done = !1, k;
          return k.value = e, k.done = !0, k;
        };
        return H.next = H;
      }
    }
    throw new TypeError(Le(N) + " is not iterable");
  }
  return m.prototype = w, o(_, "constructor", {
    value: w,
    configurable: !0
  }), o(w, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = c(w, l, "GeneratorFunction"), t.isGeneratorFunction = function(N) {
    var $ = typeof N == "function" && N.constructor;
    return !!$ && ($ === m || ($.displayName || $.name) === "GeneratorFunction");
  }, t.mark = function(N) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(N, w) : (N.__proto__ = w, c(N, l, "GeneratorFunction")), N.prototype = Object.create(_), N;
  }, t.awrap = function(N) {
    return {
      __await: N
    };
  }, T(O.prototype), c(O.prototype, s, function() {
    return this;
  }), t.AsyncIterator = O, t.async = function(N, $, F, H, k) {
    k === void 0 && (k = Promise);
    var W = new O(u(N, $, F, H), k);
    return t.isGeneratorFunction($) ? W : W.next().then(function(G) {
      return G.done ? G.value : W.next();
    });
  }, T(_), c(_, l, "Generator"), c(_, a, function() {
    return this;
  }), c(_, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(N) {
    var $ = Object(N), F = [];
    for (var H in $)
      F.push(H);
    return F.reverse(), function k() {
      for (; F.length; ) {
        var W = F.pop();
        if (W in $)
          return k.value = W, k.done = !1, k;
      }
      return k.done = !0, k;
    };
  }, t.values = q, M.prototype = {
    constructor: M,
    reset: function($) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(j), !$)
        for (var F in this)
          F.charAt(0) === "t" && r.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = e);
    },
    stop: function() {
      this.done = !0;
      var $ = this.tryEntries[0].completion;
      if ($.type === "throw")
        throw $.arg;
      return this.rval;
    },
    dispatchException: function($) {
      if (this.done)
        throw $;
      var F = this;
      function H(fe, ge) {
        return G.type = "throw", G.arg = $, F.next = fe, ge && (F.method = "next", F.arg = e), !!ge;
      }
      for (var k = this.tryEntries.length - 1; k >= 0; --k) {
        var W = this.tryEntries[k], G = W.completion;
        if (W.tryLoc === "root")
          return H("end");
        if (W.tryLoc <= this.prev) {
          var ne = r.call(W, "catchLoc"), Y = r.call(W, "finallyLoc");
          if (ne && Y) {
            if (this.prev < W.catchLoc)
              return H(W.catchLoc, !0);
            if (this.prev < W.finallyLoc)
              return H(W.finallyLoc);
          } else if (ne) {
            if (this.prev < W.catchLoc)
              return H(W.catchLoc, !0);
          } else {
            if (!Y)
              throw Error("try statement without catch or finally");
            if (this.prev < W.finallyLoc)
              return H(W.finallyLoc);
          }
        }
      }
    },
    abrupt: function($, F) {
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var k = this.tryEntries[H];
        if (k.tryLoc <= this.prev && r.call(k, "finallyLoc") && this.prev < k.finallyLoc) {
          var W = k;
          break;
        }
      }
      W && ($ === "break" || $ === "continue") && W.tryLoc <= F && F <= W.finallyLoc && (W = null);
      var G = W ? W.completion : {};
      return G.type = $, G.arg = F, W ? (this.method = "next", this.next = W.finallyLoc, v) : this.complete(G);
    },
    complete: function($, F) {
      if ($.type === "throw")
        throw $.arg;
      return $.type === "break" || $.type === "continue" ? this.next = $.arg : $.type === "return" ? (this.rval = this.arg = $.arg, this.method = "return", this.next = "end") : $.type === "normal" && F && (this.next = F), v;
    },
    finish: function($) {
      for (var F = this.tryEntries.length - 1; F >= 0; --F) {
        var H = this.tryEntries[F];
        if (H.finallyLoc === $)
          return this.complete(H.completion, H.afterLoc), j(H), v;
      }
    },
    catch: function($) {
      for (var F = this.tryEntries.length - 1; F >= 0; --F) {
        var H = this.tryEntries[F];
        if (H.tryLoc === $) {
          var k = H.completion;
          if (k.type === "throw") {
            var W = k.arg;
            j(H);
          }
          return W;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function($, F, H) {
      return this.delegate = {
        iterator: q($),
        resultName: F,
        nextLoc: H
      }, this.method === "next" && (this.arg = e), v;
    }
  }, t;
}
function Pg(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a), l = s.value;
  } catch (c) {
    return void n(c);
  }
  s.done ? t(l) : Promise.resolve(l).then(r, o);
}
function Wo(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, o) {
      var i = e.apply(t, n);
      function a(l) {
        Pg(i, r, o, a, s, "next", l);
      }
      function s(l) {
        Pg(i, r, o, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
var Va = V({}, W0), CR = Va.version, Du = Va.render, wR = Va.unmountComponentAtNode, gc;
try {
  var ER = Number((CR || "").split(".")[0]);
  ER >= 18 && (gc = Va.createRoot);
} catch {
}
function Rg(e) {
  var t = Va.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && Le(t) === "object" && (t.usingClientEntryPoint = e);
}
var $l = "__rc_react_root__";
function _R(e, t) {
  Rg(!0);
  var n = t[$l] || gc(t);
  Rg(!1), n.render(e), t[$l] = n;
}
function xR(e, t) {
  Du == null || Du(e, t);
}
function SR(e, t) {
  if (gc) {
    _R(e, t);
    return;
  }
  xR(e, t);
}
function TR(e) {
  return gf.apply(this, arguments);
}
function gf() {
  return gf = Wo(/* @__PURE__ */ Sn().mark(function e(t) {
    return Sn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var o;
              (o = t[$l]) === null || o === void 0 || o.unmount(), delete t[$l];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), gf.apply(this, arguments);
}
function OR(e) {
  wR(e);
}
function PR(e) {
  return mf.apply(this, arguments);
}
function mf() {
  return mf = Wo(/* @__PURE__ */ Sn().mark(function e(t) {
    return Sn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (gc === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", TR(t));
          case 2:
            OR(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), mf.apply(this, arguments);
}
const RR = (e, t) => {
  if (z.env.NODE_ENV !== "production") {
    const n = parseInt(y.version.split(".")[0], 10), r = Object.keys(W0);
    z.env.NODE_ENV !== "production" && Wr(n < 19 || r.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.");
  }
  return SR(e, t), () => PR(t);
};
let AR = RR;
function Gb() {
  return AR;
}
const Uo = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, Kb = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), i = o.width, a = o.height;
      if (i || a)
        return !0;
    }
  }
  return !1;
}, IR = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, kR = SP("Wave", (e) => [IR(e)]), Yb = `${Al}-wave-target`;
function ju(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function $R(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return ju(t) ? t : ju(n) ? n : ju(r) ? r : null;
}
function Bu(e) {
  return Number.isNaN(e) ? 0 : e;
}
const NR = (e) => {
  const {
    className: t,
    target: n,
    component: r,
    registerUnmount: o
  } = e, i = y.useRef(null), a = y.useRef(null);
  y.useEffect(() => {
    a.current = o();
  }, []);
  const [s, l] = y.useState(null), [c, u] = y.useState([]), [d, f] = y.useState(0), [h, p] = y.useState(0), [g, v] = y.useState(0), [b, m] = y.useState(0), [w, E] = y.useState(!1), C = {
    left: d,
    top: h,
    width: g,
    height: b,
    borderRadius: c.map((T) => `${T}px`).join(" ")
  };
  s && (C["--wave-color"] = s);
  function x() {
    const T = getComputedStyle(n);
    l($R(n));
    const O = T.position === "static", {
      borderLeftWidth: I,
      borderTopWidth: L
    } = T;
    f(O ? n.offsetLeft : Bu(-parseFloat(I))), p(O ? n.offsetTop : Bu(-parseFloat(L))), v(n.offsetWidth), m(n.offsetHeight);
    const {
      borderTopLeftRadius: B,
      borderTopRightRadius: j,
      borderBottomLeftRadius: M,
      borderBottomRightRadius: q
    } = T;
    u([B, j, q, M].map((N) => Bu(parseFloat(N))));
  }
  if (y.useEffect(() => {
    if (n) {
      const T = mo(() => {
        x(), E(!0);
      });
      let O;
      return typeof ResizeObserver < "u" && (O = new ResizeObserver(x), O.observe(n)), () => {
        mo.cancel(T), O == null || O.disconnect();
      };
    }
  }, []), !w)
    return null;
  const _ = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(Yb));
  return /* @__PURE__ */ y.createElement(Hr, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (T, O) => {
      var I, L;
      if (O.deadline || O.propertyName === "opacity") {
        const B = (I = i.current) === null || I === void 0 ? void 0 : I.parentElement;
        (L = a.current) === null || L === void 0 || L.call(a).then(() => {
          B == null || B.remove();
        });
      }
      return !1;
    }
  }, (T, O) => {
    let {
      className: I
    } = T;
    return /* @__PURE__ */ y.createElement("div", {
      ref: ac(i, O),
      className: me(t, I, {
        "wave-quick": _
      }),
      style: C
    });
  });
}, FR = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", e == null || e.insertBefore(o, e == null ? void 0 : e.firstChild);
  const i = Gb();
  let a = null;
  function s() {
    return a;
  }
  a = i(/* @__PURE__ */ y.createElement(NR, Object.assign({}, t, {
    target: e,
    registerUnmount: s
  })), o);
}, LR = (e, t, n) => {
  const {
    wave: r
  } = y.useContext(kt), [, o, i] = Gr(), a = Cn((c) => {
    const u = e.current;
    if (r != null && r.disabled || !u)
      return;
    const d = u.querySelector(`.${Yb}`) || u, {
      showEffect: f
    } = r || {};
    (f || FR)(d, {
      className: t,
      token: o,
      component: n,
      event: c,
      hashId: i
    });
  }), s = y.useRef(null);
  return (c) => {
    mo.cancel(s.current), s.current = mo(() => {
      a(c);
    });
  };
}, Zb = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: o
  } = Bt(kt), i = lt(null), a = o("wave"), [, s] = kR(a), l = LR(i, me(a, s), r);
  if (ee.useEffect(() => {
    const u = i.current;
    if (!u || u.nodeType !== 1 || n)
      return;
    const d = (f) => {
      !Kb(f.target) || // No need wave
      !u.getAttribute || u.getAttribute("disabled") || u.disabled || u.className.includes("disabled") || u.className.includes("-leave") || l(f);
    };
    return u.addEventListener("click", d, !0), () => {
      u.removeEventListener("click", d, !0);
    };
  }, [n]), !/* @__PURE__ */ ee.isValidElement(t))
    return t ?? null;
  const c = ja(t) ? ac(sc(t), i) : i;
  return Ah(t, {
    ref: c
  });
};
z.env.NODE_ENV !== "production" && (Zb.displayName = "Wave");
const MR = (e) => {
  const t = ee.useContext(Fi);
  return ee.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, Qb = /* @__PURE__ */ y.createContext(null), DR = (e, t) => {
  const n = y.useContext(Qb), r = y.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: o,
      isFirstItem: i,
      isLastItem: a
    } = n, s = o === "vertical" ? "-vertical-" : "-";
    return me(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: i,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, jR = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ y.createElement(Qb.Provider, {
    value: null
  }, t);
};
var BR = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Xb = /* @__PURE__ */ y.createContext(void 0), VR = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = y.useContext(kt), {
    prefixCls: r,
    size: o,
    className: i
  } = e, a = BR(e, ["prefixCls", "size", "className"]), s = t("btn-group", r), [, , l] = Gr();
  let c = "";
  switch (o) {
    case "large":
      c = "lg";
      break;
    case "small":
      c = "sm";
      break;
  }
  if (z.env.NODE_ENV !== "production") {
    const d = nr("Button.Group");
    z.env.NODE_ENV !== "production" && d(!o || ["large", "small", "middle"].includes(o), "usage", "Invalid prop `size`.");
  }
  const u = me(s, {
    [`${s}-${c}`]: c,
    [`${s}-rtl`]: n === "rtl"
  }, i, l);
  return /* @__PURE__ */ y.createElement(Xb.Provider, {
    value: o
  }, /* @__PURE__ */ y.createElement("div", Object.assign({}, a, {
    className: u
  })));
}, Ag = /^[\u4E00-\u9FA5]{2}$/, yf = Ag.test.bind(Ag);
function Jb(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function Ig(e) {
  return typeof e == "string";
}
function $s(e) {
  return e === "text" || e === "link";
}
function UR(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && Ig(e.type) && yf(e.props.children) ? Ah(e, {
    children: e.props.children.split("").join(n)
  }) : Ig(e) ? yf(e) ? /* @__PURE__ */ ee.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ ee.createElement("span", null, e) : Hb(e) ? /* @__PURE__ */ ee.createElement("span", null, e) : e;
}
function HR(e, t) {
  let n = !1;
  const r = [];
  return ee.Children.forEach(e, (o) => {
    const i = typeof o, a = i === "string" || i === "number";
    if (n && a) {
      const s = r.length - 1, l = r[s];
      r[s] = `${l}${o}`;
    } else
      r.push(o);
    n = a;
  }), ee.Children.map(r, (o) => UR(o, t));
}
["default", "primary", "danger"].concat(Pe(Mi));
const bf = /* @__PURE__ */ Na((e, t) => {
  const {
    className: n,
    style: r,
    children: o,
    prefixCls: i
  } = e, a = me(`${i}-icon`, n);
  return /* @__PURE__ */ ee.createElement("span", {
    ref: t,
    className: a,
    style: r
  }, o);
}), kg = /* @__PURE__ */ Na((e, t) => {
  const {
    prefixCls: n,
    className: r,
    style: o,
    iconClassName: i
  } = e, a = me(`${n}-loading-icon`, r);
  return /* @__PURE__ */ ee.createElement(bf, {
    prefixCls: n,
    className: a,
    style: o,
    ref: t
  }, /* @__PURE__ */ ee.createElement(Ry, {
    className: i
  }));
}), Vu = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), Uu = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), zR = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: o,
    style: i,
    mount: a
  } = e, s = !!n;
  return r ? /* @__PURE__ */ ee.createElement(kg, {
    prefixCls: t,
    className: o,
    style: i
  }) : /* @__PURE__ */ ee.createElement(Hr, {
    visible: s,
    // Used for minus flex gap style only
    motionName: `${t}-loading-icon-motion`,
    motionAppear: !a,
    motionEnter: !a,
    motionLeave: !a,
    removeOnLeave: !0,
    onAppearStart: Vu,
    onAppearActive: Uu,
    onEnterStart: Vu,
    onEnterActive: Uu,
    onLeaveStart: Uu,
    onLeaveActive: Vu
  }, (l, c) => {
    let {
      className: u,
      style: d
    } = l;
    const f = Object.assign(Object.assign({}, i), d);
    return /* @__PURE__ */ ee.createElement(kg, {
      prefixCls: t,
      className: me(o, u),
      style: f,
      ref: c
    });
  });
}, $g = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), qR = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: o,
    colorErrorHover: i
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      $g(`${t}-primary`, o),
      $g(`${t}-danger`, i)
    ]
  };
};
var WR = ["b"], GR = ["v"], Hu = function(t) {
  return Math.round(Number(t || 0));
}, KR = function(t) {
  if (t instanceof Nt)
    return t;
  if (t && Le(t) === "object" && "h" in t && "b" in t) {
    var n = t, r = n.b, o = Hn(n, WR);
    return V(V({}, o), {}, {
      v: r
    });
  }
  return typeof t == "string" && /hsb/.test(t) ? t.replace(/hsb/, "hsv") : t;
}, zr = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n(r) {
    return cn(this, n), t.call(this, KR(r));
  }
  return un(n, [{
    key: "toHsbString",
    value: function() {
      var o = this.toHsb(), i = Hu(o.s * 100), a = Hu(o.b * 100), s = Hu(o.h), l = o.a, c = "hsb(".concat(s, ", ").concat(i, "%, ").concat(a, "%)"), u = "hsba(".concat(s, ", ").concat(i, "%, ").concat(a, "%, ").concat(l.toFixed(l === 0 ? 0 : 2), ")");
      return l === 1 ? c : u;
    }
  }, {
    key: "toHsb",
    value: function() {
      var o = this.toHsv(), i = o.v, a = Hn(o, GR);
      return V(V({}, a), {}, {
        b: i,
        a: this.a
      });
    }
  }]), n;
}(Nt), YR = "rc-color-picker", wi = function(t) {
  return t instanceof zr ? t : new zr(t);
}, ZR = wi("#1677ff"), e2 = function(t) {
  var n = t.offset, r = t.targetRef, o = t.containerRef, i = t.color, a = t.type, s = o.current.getBoundingClientRect(), l = s.width, c = s.height, u = r.current.getBoundingClientRect(), d = u.width, f = u.height, h = d / 2, p = f / 2, g = (n.x + h) / l, v = 1 - (n.y + p) / c, b = i.toHsb(), m = g, w = (n.x + h) / l * 360;
  if (a)
    switch (a) {
      case "hue":
        return wi(V(V({}, b), {}, {
          h: w <= 0 ? 0 : w
        }));
      case "alpha":
        return wi(V(V({}, b), {}, {
          a: m <= 0 ? 0 : m
        }));
    }
  return wi({
    h: b.h,
    s: g <= 0 ? 0 : g,
    b: v >= 1 ? 1 : v,
    a: b.a
  });
}, t2 = function(t, n) {
  var r = t.toHsb();
  switch (n) {
    case "hue":
      return {
        x: r.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: t.a * 100,
        y: 50
      };
    default:
      return {
        x: r.s * 100,
        y: (1 - r.b) * 100
      };
  }
}, QR = function(t) {
  var n = t.color, r = t.prefixCls, o = t.className, i = t.style, a = t.onClick, s = "".concat(r, "-color-block");
  return /* @__PURE__ */ ee.createElement("div", {
    className: me(s, o),
    style: i,
    onClick: a
  }, /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(s, "-inner"),
    style: {
      background: n
    }
  }));
};
function XR(e) {
  var t = "touches" in e ? e.touches[0] : e, n = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, r = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: t.pageX - n,
    pageY: t.pageY - r
  };
}
function n2(e) {
  var t = e.targetRef, n = e.containerRef, r = e.direction, o = e.onDragChange, i = e.onDragChangeComplete, a = e.calculate, s = e.color, l = e.disabledDrag, c = wt({
    x: 0,
    y: 0
  }), u = de(c, 2), d = u[0], f = u[1], h = lt(null), p = lt(null);
  ut(function() {
    f(a());
  }, [s]), ut(function() {
    return function() {
      document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), document.removeEventListener("touchmove", h.current), document.removeEventListener("touchend", p.current), h.current = null, p.current = null;
    };
  }, []);
  var g = function(E) {
    var C = XR(E), x = C.pageX, _ = C.pageY, T = n.current.getBoundingClientRect(), O = T.x, I = T.y, L = T.width, B = T.height, j = t.current.getBoundingClientRect(), M = j.width, q = j.height, N = M / 2, $ = q / 2, F = Math.max(0, Math.min(x - O, L)) - N, H = Math.max(0, Math.min(_ - I, B)) - $, k = {
      x: F,
      y: r === "x" ? d.y : H
    };
    if (M === 0 && q === 0 || M !== q)
      return !1;
    o == null || o(k);
  }, v = function(E) {
    E.preventDefault(), g(E);
  }, b = function(E) {
    E.preventDefault(), document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), document.removeEventListener("touchmove", h.current), document.removeEventListener("touchend", p.current), h.current = null, p.current = null, i == null || i();
  }, m = function(E) {
    document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), !l && (g(E), document.addEventListener("mousemove", v), document.addEventListener("mouseup", b), document.addEventListener("touchmove", v), document.addEventListener("touchend", b), h.current = v, p.current = b);
  };
  return [d, m];
}
var r2 = function(t) {
  var n = t.size, r = n === void 0 ? "default" : n, o = t.color, i = t.prefixCls;
  return /* @__PURE__ */ ee.createElement("div", {
    className: me("".concat(i, "-handler"), U({}, "".concat(i, "-handler-sm"), r === "small")),
    style: {
      backgroundColor: o
    }
  });
}, o2 = function(t) {
  var n = t.children, r = t.style, o = t.prefixCls;
  return /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(o, "-palette"),
    style: V({
      position: "relative"
    }, r)
  }, n);
}, i2 = /* @__PURE__ */ Na(function(e, t) {
  var n = e.children, r = e.x, o = e.y;
  return /* @__PURE__ */ ee.createElement("div", {
    ref: t,
    style: {
      position: "absolute",
      left: "".concat(r, "%"),
      top: "".concat(o, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, n);
}), JR = function(t) {
  var n = t.color, r = t.onChange, o = t.prefixCls, i = t.onChangeComplete, a = t.disabled, s = lt(), l = lt(), c = lt(n), u = Cn(function(g) {
    var v = e2({
      offset: g,
      targetRef: l,
      containerRef: s,
      color: n
    });
    c.current = v, r(v);
  }), d = n2({
    color: n,
    containerRef: s,
    targetRef: l,
    calculate: function() {
      return t2(n);
    },
    onDragChange: u,
    onDragChangeComplete: function() {
      return i == null ? void 0 : i(c.current);
    },
    disabledDrag: a
  }), f = de(d, 2), h = f[0], p = f[1];
  return /* @__PURE__ */ ee.createElement("div", {
    ref: s,
    className: "".concat(o, "-select"),
    onMouseDown: p,
    onTouchStart: p
  }, /* @__PURE__ */ ee.createElement(o2, {
    prefixCls: o
  }, /* @__PURE__ */ ee.createElement(i2, {
    x: h.x,
    y: h.y,
    ref: l
  }, /* @__PURE__ */ ee.createElement(r2, {
    color: n.toRgbString(),
    prefixCls: o
  })), /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(o, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(n.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, eA = function(t, n) {
  var r = Cb(t, {
    value: n
  }), o = de(r, 2), i = o[0], a = o[1], s = Mt(function() {
    return wi(i);
  }, [i]);
  return [s, a];
}, tA = function(t) {
  var n = t.colors, r = t.children, o = t.direction, i = o === void 0 ? "to right" : o, a = t.type, s = t.prefixCls, l = Mt(function() {
    return n.map(function(c, u) {
      var d = wi(c);
      return a === "alpha" && u === n.length - 1 && (d = new zr(d.setA(1))), d.toRgbString();
    }).join(",");
  }, [n, a]);
  return /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(s, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(i, ", ").concat(l, ")")
    }
  }, r);
}, nA = function(t) {
  var n = t.prefixCls, r = t.colors, o = t.disabled, i = t.onChange, a = t.onChangeComplete, s = t.color, l = t.type, c = lt(), u = lt(), d = lt(s), f = function(C) {
    return l === "hue" ? C.getHue() : C.a * 100;
  }, h = Cn(function(E) {
    var C = e2({
      offset: E,
      targetRef: u,
      containerRef: c,
      color: s,
      type: l
    });
    d.current = C, i(f(C));
  }), p = n2({
    color: s,
    targetRef: u,
    containerRef: c,
    calculate: function() {
      return t2(s, l);
    },
    onDragChange: h,
    onDragChangeComplete: function() {
      a(f(d.current));
    },
    direction: "x",
    disabledDrag: o
  }), g = de(p, 2), v = g[0], b = g[1], m = ee.useMemo(function() {
    if (l === "hue") {
      var E = s.toHsb();
      E.s = 1, E.b = 1, E.a = 1;
      var C = new zr(E);
      return C;
    }
    return s;
  }, [s, l]), w = ee.useMemo(function() {
    return r.map(function(E) {
      return "".concat(E.color, " ").concat(E.percent, "%");
    });
  }, [r]);
  return /* @__PURE__ */ ee.createElement("div", {
    ref: c,
    className: me("".concat(n, "-slider"), "".concat(n, "-slider-").concat(l)),
    onMouseDown: b,
    onTouchStart: b
  }, /* @__PURE__ */ ee.createElement(o2, {
    prefixCls: n
  }, /* @__PURE__ */ ee.createElement(i2, {
    x: v.x,
    y: v.y,
    ref: u
  }, /* @__PURE__ */ ee.createElement(r2, {
    size: "small",
    color: m.toHexString(),
    prefixCls: n
  })), /* @__PURE__ */ ee.createElement(tA, {
    colors: w,
    type: l,
    prefixCls: n
  })));
};
function rA(e) {
  return y.useMemo(function() {
    var t = e || {}, n = t.slider;
    return [n || nA];
  }, [e]);
}
var oA = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], iA = /* @__PURE__ */ Na(function(e, t) {
  var n = e.value, r = e.defaultValue, o = e.prefixCls, i = o === void 0 ? YR : o, a = e.onChange, s = e.onChangeComplete, l = e.className, c = e.style, u = e.panelRender, d = e.disabledAlpha, f = d === void 0 ? !1 : d, h = e.disabled, p = h === void 0 ? !1 : h, g = e.components, v = rA(g), b = de(v, 1), m = b[0], w = eA(r || ZR, n), E = de(w, 2), C = E[0], x = E[1], _ = Mt(function() {
    return C.setA(1).toRgbString();
  }, [C]), T = function(H, k) {
    n || x(H), a == null || a(H, k);
  }, O = function(H) {
    return new zr(C.setHue(H));
  }, I = function(H) {
    return new zr(C.setA(H / 100));
  }, L = function(H) {
    T(O(H), {
      type: "hue",
      value: H
    });
  }, B = function(H) {
    T(I(H), {
      type: "alpha",
      value: H
    });
  }, j = function(H) {
    s && s(O(H));
  }, M = function(H) {
    s && s(I(H));
  }, q = me("".concat(i, "-panel"), l, U({}, "".concat(i, "-panel-disabled"), p)), N = {
    prefixCls: i,
    disabled: p,
    color: C
  }, $ = /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(JR, it({
    onChange: T
  }, N, {
    onChangeComplete: s
  })), /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(i, "-slider-container")
  }, /* @__PURE__ */ ee.createElement("div", {
    className: me("".concat(i, "-slider-group"), U({}, "".concat(i, "-slider-group-disabled-alpha"), f))
  }, /* @__PURE__ */ ee.createElement(m, it({}, N, {
    type: "hue",
    colors: oA,
    min: 0,
    max: 359,
    value: C.getHue(),
    onChange: L,
    onChangeComplete: j
  })), !f && /* @__PURE__ */ ee.createElement(m, it({}, N, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: _
    }],
    min: 0,
    max: 100,
    value: C.a * 100,
    onChange: B,
    onChangeComplete: M
  }))), /* @__PURE__ */ ee.createElement(QR, {
    color: C.toRgbString(),
    prefixCls: i
  })));
  return /* @__PURE__ */ ee.createElement("div", {
    className: q,
    style: c,
    ref: t
  }, typeof u == "function" ? u($) : $);
});
z.env.NODE_ENV !== "production" && (iA.displayName = "ColorPicker");
const aA = (e, t) => (e == null ? void 0 : e.replace(/[^\w/]/g, "").slice(0, t ? 8 : 6)) || "", sA = (e, t) => e ? aA(e, t) : "";
let lA = /* @__PURE__ */ function() {
  function e(t) {
    cn(this, e);
    var n;
    if (this.cleared = !1, t instanceof e) {
      this.metaColor = t.metaColor.clone(), this.colors = (n = t.colors) === null || n === void 0 ? void 0 : n.map((o) => ({
        color: new e(o.color),
        percent: o.percent
      })), this.cleared = t.cleared;
      return;
    }
    const r = Array.isArray(t);
    r && t.length ? (this.colors = t.map((o) => {
      let {
        color: i,
        percent: a
      } = o;
      return {
        color: new e(i),
        percent: a
      };
    }), this.metaColor = new zr(this.colors[0].color.metaColor)) : this.metaColor = new zr(r ? "" : t), (!t || r && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return un(e, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return sA(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: n
      } = this;
      return n ? `linear-gradient(90deg, ${n.map((o) => `${o.color.toRgbString()} ${o.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(n) {
      return !n || this.isGradient() !== n.isGradient() ? !1 : this.isGradient() ? this.colors.length === n.colors.length && this.colors.every((r, o) => {
        const i = n.colors[o];
        return r.percent === i.percent && r.color.equals(i.color);
      }) : this.toHexString() === n.toHexString();
    }
  }]);
}();
const cA = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), uA = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), a2 = function(e, t, n, r) {
  const i = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${i}${e}-enter,
      ${i}${e}-appear
    `]: Object.assign(Object.assign({}, cA(r)), {
      animationPlayState: "paused"
    }),
    [`${i}${e}-leave`]: Object.assign(Object.assign({}, uA(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${i}${e}-enter${e}-enter-active,
      ${i}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${i}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, dA = new Tn("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
}), fA = new Tn("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
}), hA = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  const {
    antCls: n
  } = e, r = `${n}-fade`, o = t ? "&" : "";
  return [a2(r, dA, fA, e.motionDurationMid, t), {
    [`
        ${o}${r}-enter,
        ${o}${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${o}${r}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
}, pA = new Tn("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), vA = new Tn("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), Ng = new Tn("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), Fg = new Tn("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), gA = new Tn("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), mA = new Tn("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), yA = new Tn("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), bA = new Tn("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), CA = new Tn("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), wA = new Tn("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), EA = new Tn("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), _A = new Tn("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), xA = {
  zoom: {
    inKeyframes: pA,
    outKeyframes: vA
  },
  "zoom-big": {
    inKeyframes: Ng,
    outKeyframes: Fg
  },
  "zoom-big-fast": {
    inKeyframes: Ng,
    outKeyframes: Fg
  },
  "zoom-left": {
    inKeyframes: yA,
    outKeyframes: bA
  },
  "zoom-right": {
    inKeyframes: CA,
    outKeyframes: wA
  },
  "zoom-up": {
    inKeyframes: gA,
    outKeyframes: mA
  },
  "zoom-down": {
    inKeyframes: EA,
    outKeyframes: _A
  }
}, s2 = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: i
  } = xA[t];
  return [a2(r, o, i, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, SA = (e, t) => {
  const {
    r: n,
    g: r,
    b: o,
    a: i
  } = e.toRgb(), a = new zr(e.toRgbString()).onBackground(t).toHsv();
  return i <= 0.5 ? a.v > 0.5 : n * 0.299 + r * 0.587 + o * 0.114 > 192;
}, l2 = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n
  } = e;
  return rr(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: n
  });
}, c2 = (e) => {
  var t, n, r, o, i, a;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, l = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, c = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, u = (o = e.contentLineHeight) !== null && o !== void 0 ? o : sl(s), d = (i = e.contentLineHeightSM) !== null && i !== void 0 ? i : sl(l), f = (a = e.contentLineHeightLG) !== null && a !== void 0 ? a : sl(c), h = SA(new lA(e.colorBgSolid), "#fff") ? "#000" : "#fff";
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: e.colorText,
    textTextHoverColor: e.colorText,
    textTextActiveColor: e.colorText,
    textHoverBg: e.colorFillTertiary,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    solidTextColor: h,
    contentFontSize: s,
    contentFontSizeSM: l,
    contentFontSizeLG: c,
    contentLineHeight: u,
    contentLineHeightSM: d,
    contentLineHeightLG: f,
    paddingBlock: Math.max((e.controlHeight - s * u) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - l * d) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - c * f) / 2 - e.lineWidth, 0)
  };
}, TA = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r,
    opacityLoading: o,
    motionDurationSlow: i,
    motionEaseInOut: a,
    marginXS: s,
    calc: l
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${ze(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${t}-icon > svg`]: Tb(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Ph(e),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${t}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${t}-compact-item`]: {
          flex: "none"
        },
        [`&${t}-round`]: {
          width: "auto"
        }
      },
      // Loading
      [`&${t}-loading`]: {
        opacity: o,
        cursor: "default"
      },
      [`${t}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((c) => `${c} ${i} ${a}`).join(",")
      },
      // iconPosition
      [`&:not(${t}-icon-end)`]: {
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: l(s).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: l(s).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: l(s).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: l(s).mul(-1).equal()
          }
        }
      }
    }
  };
}, u2 = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), OA = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), PA = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), RA = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), kh = (e, t, n, r, o, i, a, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, u2(e, Object.assign({
    background: t
  }, a), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: o || void 0,
      borderColor: i || void 0
    }
  })
}), AA = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, RA(e))
}), IA = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), mc = (e, t, n, r) => {
  const i = r && ["link", "text"].includes(r) ? IA : AA;
  return Object.assign(Object.assign({}, i(e)), u2(e.componentCls, t, n));
}, yc = (e, t, n, r, o) => ({
  [`&${e.componentCls}-variant-solid`]: Object.assign({
    color: t,
    background: n
  }, mc(e, r, o))
}), bc = (e, t, n, r, o) => ({
  [`&${e.componentCls}-variant-outlined, &${e.componentCls}-variant-dashed`]: Object.assign({
    borderColor: t,
    background: n
  }, mc(e, r, o))
}), Cc = (e) => ({
  [`&${e.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), wc = (e, t, n, r) => ({
  [`&${e.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: t
  }, mc(e, n, r))
}), yo = (e, t, n, r, o) => ({
  [`&${e.componentCls}-variant-${n}`]: Object.assign({
    color: t,
    boxShadow: "none"
  }, mc(e, r, o, n))
}), kA = (e) => {
  const {
    componentCls: t
  } = e;
  return Mi.reduce((n, r) => {
    const o = e[`${r}6`], i = e[`${r}1`], a = e[`${r}5`], s = e[`${r}2`], l = e[`${r}3`], c = e[`${r}7`], u = `0 ${ze(e.controlOutlineWidth)} 0 ${e[`${r}1`]}`;
    return Object.assign(Object.assign({}, n), {
      [`&${t}-color-${r}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: o,
        boxShadow: u
      }, yc(e, e.colorTextLightSolid, o, {
        background: a
      }, {
        background: c
      })), bc(e, o, e.colorBgContainer, {
        color: a,
        borderColor: a,
        background: e.colorBgContainer
      }, {
        color: c,
        borderColor: c,
        background: e.colorBgContainer
      })), Cc(e)), wc(e, i, {
        background: s
      }, {
        background: l
      })), yo(e, o, "link", {
        color: a
      }, {
        color: c
      })), yo(e, o, "text", {
        color: a,
        background: i
      }, {
        color: c,
        background: l
      }))
    });
  }, {});
}, $A = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}, yc(e, e.solidTextColor, e.colorBgSolid, {
  color: e.solidTextColor,
  background: e.colorBgSolidHover
}, {
  color: e.solidTextColor,
  background: e.colorBgSolidActive
})), Cc(e)), wc(e, e.colorFillTertiary, {
  background: e.colorFillSecondary
}, {
  background: e.colorFill
})), yo(e, e.textTextColor, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), kh(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), NA = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorPrimary,
  boxShadow: e.primaryShadow
}, bc(e, e.colorPrimary, e.colorBgContainer, {
  color: e.colorPrimaryTextHover,
  borderColor: e.colorPrimaryHover,
  background: e.colorBgContainer
}, {
  color: e.colorPrimaryTextActive,
  borderColor: e.colorPrimaryActive,
  background: e.colorBgContainer
})), Cc(e)), wc(e, e.colorPrimaryBg, {
  background: e.colorPrimaryBgHover
}, {
  background: e.colorPrimaryBorder
})), yo(e, e.colorLink, "text", {
  color: e.colorPrimaryTextHover,
  background: e.colorPrimaryBg
}, {
  color: e.colorPrimaryTextActive,
  background: e.colorPrimaryBorder
})), kh(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), FA = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorError,
  boxShadow: e.dangerShadow
}, yc(e, e.dangerColor, e.colorError, {
  background: e.colorErrorHover
}, {
  background: e.colorErrorActive
})), bc(e, e.colorError, e.colorBgContainer, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorBorderHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), Cc(e)), wc(e, e.colorErrorBg, {
  background: e.colorErrorBgFilledHover
}, {
  background: e.colorErrorBgActive
})), yo(e, e.colorError, "text", {
  color: e.colorErrorHover,
  background: e.colorErrorBg
}, {
  color: e.colorErrorHover,
  background: e.colorErrorBgActive
})), yo(e, e.colorError, "link", {
  color: e.colorErrorHover
}, {
  color: e.colorErrorActive
})), kh(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), LA = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-color-default`]: $A(e),
    [`${t}-color-primary`]: NA(e),
    [`${t}-color-dangerous`]: FA(e)
  }, kA(e));
}, MA = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, bc(e, e.defaultBorderColor, e.defaultBg, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), yo(e, e.textTextColor, "text", {
  color: e.textTextHoverColor,
  background: e.textHoverBg
}, {
  color: e.textTextActiveColor,
  background: e.colorBgTextActive
})), yc(e, e.primaryColor, e.colorPrimary, {
  background: e.colorPrimaryHover,
  color: e.primaryColor
}, {
  background: e.colorPrimaryActive,
  color: e.primaryColor
})), yo(e, e.colorLink, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), $h = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: o,
    borderRadius: i,
    buttonPaddingHorizontal: a,
    iconCls: s,
    buttonPaddingVertical: l,
    buttonIconOnlyFontSize: c
  } = e;
  return [
    {
      [t]: {
        fontSize: o,
        height: r,
        padding: `${ze(l)} ${ze(a)}`,
        borderRadius: i,
        [`&${n}-icon-only`]: {
          width: r,
          [s]: {
            fontSize: c
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: OA(e)
    },
    {
      [`${n}${n}-round${t}`]: PA(e)
    }
  ];
}, DA = (e) => {
  const t = rr(e, {
    fontSize: e.contentFontSize
  });
  return $h(t, e.componentCls);
}, jA = (e) => {
  const t = rr(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return $h(t, `${e.componentCls}-sm`);
}, BA = (e) => {
  const t = rr(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return $h(t, `${e.componentCls}-lg`);
}, VA = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, UA = qo("Button", (e) => {
  const t = l2(e);
  return [
    // Shared
    TA(t),
    // Size
    DA(t),
    jA(t),
    BA(t),
    // Block
    VA(t),
    // Color
    LA(t),
    // https://github.com/ant-design/ant-design/issues/50969
    MA(t),
    // Button Group
    qR(t)
  ];
}, c2, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function HA(e, t, n) {
  const {
    focusElCls: r,
    focus: o,
    borderElCls: i
  } = n, a = i ? "> *" : "", s = ["hover", o ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function zA(e, t, n) {
  const {
    borderElCls: r
  } = n, o = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${o}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function qA(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, HA(e, r, t)), zA(n, r, t))
  };
}
function WA(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function GA(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function KA(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, WA(e, t)), GA(e.componentCls, t))
  };
}
const YA = (e) => {
  const {
    componentCls: t,
    colorPrimaryHover: n,
    lineWidth: r,
    calc: o
  } = e, i = o(r).mul(-1).equal(), a = (s) => {
    const l = `${t}-compact${s ? "-vertical" : ""}-item${t}-primary:not([disabled])`;
    return {
      [`${l} + ${l}::before`]: {
        position: "absolute",
        top: s ? i : 0,
        insetInlineStart: s ? 0 : i,
        backgroundColor: n,
        content: '""',
        width: s ? "100%" : r,
        height: s ? r : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, a()), a(!0));
}, ZA = Pb(["Button", "compact"], (e) => {
  const t = l2(e);
  return [
    // Space Compact
    qA(t),
    KA(t),
    YA(t)
  ];
}, c2);
var QA = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function XA(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const JA = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  link: ["primary", "link"],
  text: ["default", "text"]
}, eI = /* @__PURE__ */ ee.forwardRef((e, t) => {
  var n, r, o, i;
  const {
    loading: a = !1,
    prefixCls: s,
    color: l,
    variant: c,
    type: u,
    danger: d = !1,
    shape: f = "default",
    size: h,
    styles: p,
    disabled: g,
    className: v,
    rootClassName: b,
    children: m,
    icon: w,
    iconPosition: E = "start",
    ghost: C = !1,
    block: x = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: _ = "button",
    classNames: T,
    style: O = {},
    autoInsertSpace: I,
    autoFocus: L
  } = e, B = QA(e, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]), j = u || "default", [M, q] = Mt(() => {
    if (l && c)
      return [l, c];
    const A = JA[j] || [];
    return d ? ["danger", A[1]] : A;
  }, [u, l, c, d]), $ = M === "danger" ? "dangerous" : M, {
    getPrefixCls: F,
    direction: H,
    button: k
  } = Bt(kt), W = (n = I ?? (k == null ? void 0 : k.autoInsertSpace)) !== null && n !== void 0 ? n : !0, G = F("btn", s), [ne, Y, fe] = UA(G), ge = Bt(Il), ie = g ?? ge, he = Bt(Xb), ue = Mt(() => XA(a), [a]), [ce, Se] = wt(ue.loading), [te, ke] = wt(!1), se = lt(null), D = zi(t, se), X = ow.count(m) === 1 && !w && !$s(q), Q = lt(!0);
  ee.useEffect(() => (Q.current = !1, () => {
    Q.current = !0;
  }), []), ut(() => {
    let A = null;
    ue.delay > 0 ? A = setTimeout(() => {
      A = null, Se(!0);
    }, ue.delay) : Se(ue.loading);
    function K() {
      A && (clearTimeout(A), A = null);
    }
    return K;
  }, [ue]), ut(() => {
    if (!se.current || !W)
      return;
    const A = se.current.textContent || "";
    X && yf(A) ? te || ke(!0) : te && ke(!1);
  }), ut(() => {
    L && se.current && se.current.focus();
  }, []);
  const _e = ee.useCallback((A) => {
    var K;
    if (ce || ie) {
      A.preventDefault();
      return;
    }
    (K = e.onClick) === null || K === void 0 || K.call(e, A);
  }, [e.onClick, ce, ie]);
  if (z.env.NODE_ENV !== "production") {
    const A = nr("Button");
    z.env.NODE_ENV !== "production" && A(!(typeof w == "string" && w.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${w}\` at https://ant.design/components/icon`), z.env.NODE_ENV !== "production" && A(!(C && $s(q)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: Ce,
    compactItemClassnames: Ne
  } = DR(G, H), ae = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, xe = MR((A) => {
    var K, J;
    return (J = (K = h ?? Ce) !== null && K !== void 0 ? K : he) !== null && J !== void 0 ? J : A;
  }), Re = xe && (r = ae[xe]) !== null && r !== void 0 ? r : "", mt = ce ? "loading" : w, et = uc(B, ["navigate"]), tt = me(G, Y, fe, {
    [`${G}-${f}`]: f !== "default" && f,
    // line(253 - 254): Compatible with versions earlier than 5.21.0
    [`${G}-${j}`]: j,
    [`${G}-dangerous`]: d,
    [`${G}-color-${$}`]: $,
    [`${G}-variant-${q}`]: q,
    [`${G}-${Re}`]: Re,
    [`${G}-icon-only`]: !m && m !== 0 && !!mt,
    [`${G}-background-ghost`]: C && !$s(q),
    [`${G}-loading`]: ce,
    [`${G}-two-chinese-chars`]: te && W && !ce,
    [`${G}-block`]: x,
    [`${G}-rtl`]: H === "rtl",
    [`${G}-icon-end`]: E === "end"
  }, Ne, v, b, k == null ? void 0 : k.className), _t = Object.assign(Object.assign({}, k == null ? void 0 : k.style), O), $t = me(T == null ? void 0 : T.icon, (o = k == null ? void 0 : k.classNames) === null || o === void 0 ? void 0 : o.icon), en = Object.assign(Object.assign({}, (p == null ? void 0 : p.icon) || {}), ((i = k == null ? void 0 : k.styles) === null || i === void 0 ? void 0 : i.icon) || {}), Ee = w && !ce ? /* @__PURE__ */ ee.createElement(bf, {
    prefixCls: G,
    className: $t,
    style: en
  }, w) : typeof a == "object" && a.icon ? /* @__PURE__ */ ee.createElement(bf, {
    prefixCls: G,
    className: $t,
    style: en
  }, a.icon) : /* @__PURE__ */ ee.createElement(zR, {
    existIcon: !!w,
    prefixCls: G,
    loading: ce,
    mount: Q.current
  }), Fe = m || m === 0 ? HR(m, X && W) : null;
  if (et.href !== void 0)
    return ne(/* @__PURE__ */ ee.createElement("a", Object.assign({}, et, {
      className: me(tt, {
        [`${G}-disabled`]: ie
      }),
      href: ie ? void 0 : et.href,
      style: _t,
      onClick: _e,
      ref: D,
      tabIndex: ie ? -1 : 0
    }), Ee, Fe));
  let S = /* @__PURE__ */ ee.createElement("button", Object.assign({}, B, {
    type: _,
    className: tt,
    style: _t,
    onClick: _e,
    disabled: ie,
    ref: D
  }), Ee, Fe, Ne && /* @__PURE__ */ ee.createElement(ZA, {
    prefixCls: G
  }));
  return $s(q) || (S = /* @__PURE__ */ ee.createElement(Zb, {
    component: "Button",
    disabled: ce
  }, S)), ne(S);
}), dr = eI;
dr.Group = VR;
dr.__ANT_BUTTON = !0;
z.env.NODE_ENV !== "production" && (dr.displayName = "Button");
function zu(e) {
  return !!(e != null && e.then);
}
const d2 = (e) => {
  const {
    type: t,
    children: n,
    prefixCls: r,
    buttonProps: o,
    close: i,
    autoFocus: a,
    emitEvent: s,
    isSilent: l,
    quitOnNullishReturnValue: c,
    actionFn: u
  } = e, d = y.useRef(!1), f = y.useRef(null), [h, p] = Li(!1), g = function() {
    i == null || i.apply(void 0, arguments);
  };
  y.useEffect(() => {
    let m = null;
    return a && (m = setTimeout(() => {
      var w;
      (w = f.current) === null || w === void 0 || w.focus({
        preventScroll: !0
      });
    })), () => {
      m && clearTimeout(m);
    };
  }, []);
  const v = (m) => {
    zu(m) && (p(!0), m.then(function() {
      p(!1, !0), g.apply(void 0, arguments), d.current = !1;
    }, (w) => {
      if (p(!1, !0), d.current = !1, !(l != null && l()))
        return Promise.reject(w);
    }));
  }, b = (m) => {
    if (d.current)
      return;
    if (d.current = !0, !u) {
      g();
      return;
    }
    let w;
    if (s) {
      if (w = u(m), c && !zu(w)) {
        d.current = !1, g(m);
        return;
      }
    } else if (u.length)
      w = u(i), d.current = !1;
    else if (w = u(), !zu(w)) {
      g();
      return;
    }
    v(w);
  };
  return /* @__PURE__ */ y.createElement(dr, Object.assign({}, Jb(t), {
    onClick: b,
    loading: h,
    prefixCls: r
  }, o, {
    ref: f
  }), n);
}, Ua = /* @__PURE__ */ ee.createContext({}), {
  Provider: f2
} = Ua, Lg = () => {
  const {
    autoFocusButton: e,
    cancelButtonProps: t,
    cancelTextLocale: n,
    isSilent: r,
    mergedOkCancel: o,
    rootPrefixCls: i,
    close: a,
    onCancel: s,
    onConfirm: l
  } = Bt(Ua);
  return o ? /* @__PURE__ */ ee.createElement(d2, {
    isSilent: r,
    actionFn: s,
    close: function() {
      a == null || a.apply(void 0, arguments), l == null || l(!1);
    },
    autoFocus: e === "cancel",
    buttonProps: t,
    prefixCls: `${i}-btn`
  }, n) : null;
}, Mg = () => {
  const {
    autoFocusButton: e,
    close: t,
    isSilent: n,
    okButtonProps: r,
    rootPrefixCls: o,
    okTextLocale: i,
    okType: a,
    onConfirm: s,
    onOk: l
  } = Bt(Ua);
  return /* @__PURE__ */ ee.createElement(d2, {
    isSilent: n,
    type: a || "primary",
    actionFn: l,
    close: function() {
      t == null || t.apply(void 0, arguments), s == null || s(!0);
    },
    autoFocus: e === "ok",
    buttonProps: r,
    prefixCls: `${o}-btn`
  }, i);
};
var h2 = /* @__PURE__ */ y.createContext(null), Dg = [];
function tI(e, t) {
  var n = y.useState(function() {
    if (!En())
      return null;
    var p = document.createElement("div");
    return z.env.NODE_ENV !== "production" && t && p.setAttribute("data-debug", t), p;
  }), r = de(n, 1), o = r[0], i = y.useRef(!1), a = y.useContext(h2), s = y.useState(Dg), l = de(s, 2), c = l[0], u = l[1], d = a || (i.current ? void 0 : function(p) {
    u(function(g) {
      var v = [p].concat(Pe(g));
      return v;
    });
  });
  function f() {
    o.parentElement || document.body.appendChild(o), i.current = !0;
  }
  function h() {
    var p;
    (p = o.parentElement) === null || p === void 0 || p.removeChild(o), i.current = !1;
  }
  return vn(function() {
    return e ? a ? a(f) : f() : h(), h;
  }, [e]), vn(function() {
    c.length && (c.forEach(function(p) {
      return p();
    }), u(Dg));
  }, [c]), [o, d];
}
function nI(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = t;
  var r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var o, i;
  if (e) {
    var a = getComputedStyle(e);
    r.scrollbarColor = a.scrollbarColor, r.scrollbarWidth = a.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), l = parseInt(s.width, 10), c = parseInt(s.height, 10);
    try {
      var u = l ? "width: ".concat(s.width, ";") : "", d = c ? "height: ".concat(s.height, ";") : "";
      Ur(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(u, `
`).concat(d, `
}`), t);
    } catch (p) {
      console.error(p), o = l, i = c;
    }
  }
  document.body.appendChild(n);
  var f = e && o && !isNaN(o) ? o : n.offsetWidth - n.clientWidth, h = e && i && !isNaN(i) ? i : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), xa(t), {
    width: f,
    height: h
  };
}
function rI(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : nI(e);
}
function oI() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var iI = "rc-util-locker-".concat(Date.now()), jg = 0;
function aI(e) {
  var t = !!e, n = y.useState(function() {
    return jg += 1, "".concat(iI, "_").concat(jg);
  }), r = de(n, 1), o = r[0];
  vn(function() {
    if (t) {
      var i = rI(document.body).width, a = oI();
      Ur(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), o);
    } else
      xa(o);
    return function() {
      xa(o);
    };
  }, [t, o]);
}
var sI = !1;
function lI(e) {
  return sI;
}
var Bg = function(t) {
  return t === !1 ? !1 : !En() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, Ha = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, o = e.getContainer, i = e.debug, a = e.autoDestroy, s = a === void 0 ? !0 : a, l = e.children, c = y.useState(n), u = de(c, 2), d = u[0], f = u[1], h = d || n;
  z.env.NODE_ENV !== "production" && Et(En() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), y.useEffect(function() {
    (s || n) && f(n);
  }, [n, s]);
  var p = y.useState(function() {
    return Bg(o);
  }), g = de(p, 2), v = g[0], b = g[1];
  y.useEffect(function() {
    var B = Bg(o);
    b(B ?? null);
  });
  var m = tI(h && !v, i), w = de(m, 2), E = w[0], C = w[1], x = v ?? E;
  aI(r && n && En() && (x === E || x === document.body));
  var _ = null;
  if (l && ja(l) && t) {
    var T = l;
    _ = T.ref;
  }
  var O = zi(_, t);
  if (!h || !En() || v === void 0)
    return null;
  var I = x === !1 || lI(), L = l;
  return t && (L = /* @__PURE__ */ y.cloneElement(l, {
    ref: O
  })), /* @__PURE__ */ y.createElement(h2.Provider, {
    value: C
  }, I ? L : /* @__PURE__ */ lw(L, x));
});
z.env.NODE_ENV !== "production" && (Ha.displayName = "Portal");
var p2 = /* @__PURE__ */ y.createContext({});
function cI() {
  var e = V({}, y);
  return e.useId;
}
var Vg = 0, Ug = cI();
const v2 = Ug ? (
  // Use React `useId`
  function(t) {
    var n = Ug();
    return t || (z.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = y.useState("ssr-id"), r = de(n, 2), o = r[0], i = r[1];
    return y.useEffect(function() {
      var a = Vg;
      Vg += 1, i("rc_unique_".concat(a));
    }, []), t || (z.env.NODE_ENV === "test" ? "test-id" : o);
  }
);
function Hg(e, t, n) {
  var r = t;
  return !r && n && (r = "".concat(e, "-").concat(n)), r;
}
function zg(e, t) {
  var n = e["page".concat(t ? "Y" : "X", "Offset")], r = "scroll".concat(t ? "Top" : "Left");
  if (typeof n != "number") {
    var o = e.document;
    n = o.documentElement[r], typeof n != "number" && (n = o.body[r]);
  }
  return n;
}
function uI(e) {
  var t = e.getBoundingClientRect(), n = {
    left: t.left,
    top: t.top
  }, r = e.ownerDocument, o = r.defaultView || r.parentWindow;
  return n.left += zg(o), n.top += zg(o, !0), n;
}
const dI = /* @__PURE__ */ y.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  var n = t.shouldUpdate;
  return !n;
});
var fI = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
}, hI = {
  outline: "none"
}, Nh = /* @__PURE__ */ ee.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, o = e.style, i = e.title, a = e.ariaId, s = e.footer, l = e.closable, c = e.closeIcon, u = e.onClose, d = e.children, f = e.bodyStyle, h = e.bodyProps, p = e.modalRender, g = e.onMouseDown, v = e.onMouseUp, b = e.holderRef, m = e.visible, w = e.forceRender, E = e.width, C = e.height, x = e.classNames, _ = e.styles, T = ee.useContext(p2), O = T.panel, I = zi(b, O), L = lt(), B = lt();
  ee.useImperativeHandle(t, function() {
    return {
      focus: function() {
        var G;
        (G = L.current) === null || G === void 0 || G.focus({
          preventScroll: !0
        });
      },
      changeActive: function(G) {
        var ne = document, Y = ne.activeElement;
        G && Y === B.current ? L.current.focus({
          preventScroll: !0
        }) : !G && Y === L.current && B.current.focus({
          preventScroll: !0
        });
      }
    };
  });
  var j = {};
  E !== void 0 && (j.width = E), C !== void 0 && (j.height = C);
  var M = s ? /* @__PURE__ */ ee.createElement("div", {
    className: me("".concat(n, "-footer"), x == null ? void 0 : x.footer),
    style: V({}, _ == null ? void 0 : _.footer)
  }, s) : null, q = i ? /* @__PURE__ */ ee.createElement("div", {
    className: me("".concat(n, "-header"), x == null ? void 0 : x.header),
    style: V({}, _ == null ? void 0 : _.header)
  }, /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(n, "-title"),
    id: a
  }, i)) : null, N = Mt(function() {
    return Le(l) === "object" && l !== null ? l : l ? {
      closeIcon: c ?? /* @__PURE__ */ ee.createElement("span", {
        className: "".concat(n, "-close-x")
      })
    } : {};
  }, [l, c, n]), $ = Di(N, !0), F = Le(l) === "object" && l.disabled, H = l ? /* @__PURE__ */ ee.createElement("button", it({
    type: "button",
    onClick: u,
    "aria-label": "Close"
  }, $, {
    className: "".concat(n, "-close"),
    disabled: F
  }), N.closeIcon) : null, k = /* @__PURE__ */ ee.createElement("div", {
    className: me("".concat(n, "-content"), x == null ? void 0 : x.content),
    style: _ == null ? void 0 : _.content
  }, H, q, /* @__PURE__ */ ee.createElement("div", it({
    className: me("".concat(n, "-body"), x == null ? void 0 : x.body),
    style: V(V({}, f), _ == null ? void 0 : _.body)
  }, h), d), M);
  return /* @__PURE__ */ ee.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": i ? a : null,
    "aria-modal": "true",
    ref: I,
    style: V(V({}, o), j),
    className: me(n, r),
    onMouseDown: g,
    onMouseUp: v
  }, /* @__PURE__ */ ee.createElement("div", {
    ref: L,
    tabIndex: 0,
    style: hI
  }, /* @__PURE__ */ ee.createElement(dI, {
    shouldUpdate: m || w
  }, p ? p(k) : k)), /* @__PURE__ */ ee.createElement("div", {
    tabIndex: 0,
    ref: B,
    style: fI
  }));
});
z.env.NODE_ENV !== "production" && (Nh.displayName = "Panel");
var g2 = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.title, o = e.style, i = e.className, a = e.visible, s = e.forceRender, l = e.destroyOnClose, c = e.motionName, u = e.ariaId, d = e.onVisibleChanged, f = e.mousePosition, h = lt(), p = y.useState(), g = de(p, 2), v = g[0], b = g[1], m = {};
  v && (m.transformOrigin = v);
  function w() {
    var E = uI(h.current);
    b(f && (f.x || f.y) ? "".concat(f.x - E.left, "px ").concat(f.y - E.top, "px") : "");
  }
  return /* @__PURE__ */ y.createElement(Hr, {
    visible: a,
    onVisibleChanged: d,
    onAppearPrepare: w,
    onEnterPrepare: w,
    forceRender: s,
    motionName: c,
    removeOnLeave: l,
    ref: h
  }, function(E, C) {
    var x = E.className, _ = E.style;
    return /* @__PURE__ */ y.createElement(Nh, it({}, e, {
      ref: t,
      title: r,
      ariaId: u,
      prefixCls: n,
      holderRef: C,
      style: V(V(V({}, _), o), m),
      className: me(i, x)
    }));
  });
});
g2.displayName = "Content";
var pI = function(t) {
  var n = t.prefixCls, r = t.style, o = t.visible, i = t.maskProps, a = t.motionName, s = t.className;
  return /* @__PURE__ */ y.createElement(Hr, {
    key: "mask",
    visible: o,
    motionName: a,
    leavedClassName: "".concat(n, "-mask-hidden")
  }, function(l, c) {
    var u = l.className, d = l.style;
    return /* @__PURE__ */ y.createElement("div", it({
      ref: c,
      style: V(V({}, d), r),
      className: me("".concat(n, "-mask"), u, s)
    }, i));
  });
}, vI = function(t) {
  var n = t.prefixCls, r = n === void 0 ? "rc-dialog" : n, o = t.zIndex, i = t.visible, a = i === void 0 ? !1 : i, s = t.keyboard, l = s === void 0 ? !0 : s, c = t.focusTriggerAfterClose, u = c === void 0 ? !0 : c, d = t.wrapStyle, f = t.wrapClassName, h = t.wrapProps, p = t.onClose, g = t.afterOpenChange, v = t.afterClose, b = t.transitionName, m = t.animation, w = t.closable, E = w === void 0 ? !0 : w, C = t.mask, x = C === void 0 ? !0 : C, _ = t.maskTransitionName, T = t.maskAnimation, O = t.maskClosable, I = O === void 0 ? !0 : O, L = t.maskStyle, B = t.maskProps, j = t.rootClassName, M = t.classNames, q = t.styles;
  z.env.NODE_ENV !== "production" && (["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(D) {
    go(!(D in t), "".concat(D, " is deprecated, please use styles instead."));
  }), "wrapClassName" in t && go(!1, "wrapClassName is deprecated, please use classNames instead."));
  var N = lt(), $ = lt(), F = lt(), H = y.useState(a), k = de(H, 2), W = k[0], G = k[1], ne = v2();
  function Y() {
    Gd($.current, document.activeElement) || (N.current = document.activeElement);
  }
  function fe() {
    if (!Gd($.current, document.activeElement)) {
      var D;
      (D = F.current) === null || D === void 0 || D.focus();
    }
  }
  function ge(D) {
    if (D)
      fe();
    else {
      if (G(!1), x && N.current && u) {
        try {
          N.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        N.current = null;
      }
      W && (v == null || v());
    }
    g == null || g(D);
  }
  function ie(D) {
    p == null || p(D);
  }
  var he = lt(!1), ue = lt(), ce = function() {
    clearTimeout(ue.current), he.current = !0;
  }, Se = function() {
    ue.current = setTimeout(function() {
      he.current = !1;
    });
  }, te = null;
  I && (te = function(X) {
    he.current ? he.current = !1 : $.current === X.target && ie(X);
  });
  function ke(D) {
    if (l && D.keyCode === $e.ESC) {
      D.stopPropagation(), ie(D);
      return;
    }
    a && D.keyCode === $e.TAB && F.current.changeActive(!D.shiftKey);
  }
  ut(function() {
    a && (G(!0), Y());
  }, [a]), ut(function() {
    return function() {
      clearTimeout(ue.current);
    };
  }, []);
  var se = V(V(V({
    zIndex: o
  }, d), q == null ? void 0 : q.wrapper), {}, {
    display: W ? null : "none"
  });
  return /* @__PURE__ */ y.createElement("div", it({
    className: me("".concat(r, "-root"), j)
  }, Di(t, {
    data: !0
  })), /* @__PURE__ */ y.createElement(pI, {
    prefixCls: r,
    visible: x && a,
    motionName: Hg(r, _, T),
    style: V(V({
      zIndex: o
    }, L), q == null ? void 0 : q.mask),
    maskProps: B,
    className: M == null ? void 0 : M.mask
  }), /* @__PURE__ */ y.createElement("div", it({
    tabIndex: -1,
    onKeyDown: ke,
    className: me("".concat(r, "-wrap"), f, M == null ? void 0 : M.wrapper),
    ref: $,
    onClick: te,
    style: se
  }, h), /* @__PURE__ */ y.createElement(g2, it({}, t, {
    onMouseDown: ce,
    onMouseUp: Se,
    ref: F,
    closable: E,
    ariaId: ne,
    prefixCls: r,
    visible: a && W,
    onClose: ie,
    onVisibleChanged: ge,
    motionName: Hg(r, b, m)
  }))));
}, m2 = function(t) {
  var n = t.visible, r = t.getContainer, o = t.forceRender, i = t.destroyOnClose, a = i === void 0 ? !1 : i, s = t.afterClose, l = t.panelRef, c = y.useState(n), u = de(c, 2), d = u[0], f = u[1], h = y.useMemo(function() {
    return {
      panel: l
    };
  }, [l]);
  return y.useEffect(function() {
    n && f(!0);
  }, [n]), !o && a && !d ? null : /* @__PURE__ */ y.createElement(p2.Provider, {
    value: h
  }, /* @__PURE__ */ y.createElement(Ha, {
    open: n || o || d,
    autoDestroy: !1,
    getContainer: r,
    autoLock: n || d
  }, /* @__PURE__ */ y.createElement(vI, it({}, t, {
    destroyOnClose: a,
    afterClose: function() {
      s == null || s(), f(!1);
    }
  }))));
};
m2.displayName = "Dialog";
var Ao = "RC_FORM_INTERNAL_HOOKS", Ct = function() {
  Et(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, ji = /* @__PURE__ */ y.createContext({
  getFieldValue: Ct,
  getFieldsValue: Ct,
  getFieldError: Ct,
  getFieldWarning: Ct,
  getFieldsError: Ct,
  isFieldsTouched: Ct,
  isFieldTouched: Ct,
  isFieldValidating: Ct,
  isFieldsValidating: Ct,
  resetFields: Ct,
  setFields: Ct,
  setFieldValue: Ct,
  setFieldsValue: Ct,
  validateFields: Ct,
  submit: Ct,
  getInternalHooks: function() {
    return Ct(), {
      dispatch: Ct,
      initEntityValue: Ct,
      registerField: Ct,
      useSubscribe: Ct,
      setInitialValues: Ct,
      destroyForm: Ct,
      setCallbacks: Ct,
      registerWatch: Ct,
      getFields: Ct,
      setValidateMessages: Ct,
      setPreserve: Ct,
      getInitialValue: Ct
    };
  }
}), Nl = /* @__PURE__ */ y.createContext(null);
function Cf(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function gI(e) {
  return e && !!e._init;
}
function wf() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var Ef = wf();
function mI(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function yI(e, t, n) {
  if (wh())
    return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var o = new (e.bind.apply(e, r))();
  return n && Ta(o, n.prototype), o;
}
function _f(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _f = function(r) {
    if (r === null || !mI(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r))
        return t.get(r);
      t.set(r, o);
    }
    function o() {
      return yI(r, arguments, Oa(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Ta(o, r);
  }, _f(e);
}
var bI = /%[sdj%]/g, y2 = function() {
};
typeof z < "u" && z.env && z.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (y2 = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function xf(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function Mn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = 0, i = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var a = e.replace(bI, function(s) {
      if (s === "%%")
        return "%";
      if (o >= i)
        return s;
      switch (s) {
        case "%s":
          return String(n[o++]);
        case "%d":
          return Number(n[o++]);
        case "%j":
          try {
            return JSON.stringify(n[o++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function CI(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Jt(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || CI(t) && typeof e == "string" && !e);
}
function wI(e, t, n) {
  var r = [], o = 0, i = e.length;
  function a(s) {
    r.push.apply(r, Pe(s || [])), o++, o === i && n(r);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function qg(e, t, n) {
  var r = 0, o = e.length;
  function i(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < o ? t(e[s], i) : n([]);
  }
  i([]);
}
function EI(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, Pe(e[n] || []));
  }), t;
}
var Wg = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n(r, o) {
    var i;
    return cn(this, n), i = t.call(this, "Async Validation Error"), U(Ye(i), "errors", void 0), U(Ye(i), "fields", void 0), i.errors = r, i.fields = o, i;
  }
  return un(n);
}(/* @__PURE__ */ _f(Error));
function _I(e, t, n, r, o) {
  if (t.first) {
    var i = new Promise(function(f, h) {
      var p = function(b) {
        return r(b), b.length ? h(new Wg(b, xf(b))) : f(o);
      }, g = EI(e);
      qg(g, n, p);
    });
    return i.catch(function(f) {
      return f;
    }), i;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, c = 0, u = [], d = new Promise(function(f, h) {
    var p = function(v) {
      if (u.push.apply(u, v), c++, c === l)
        return r(u), u.length ? h(new Wg(u, xf(u))) : f(o);
    };
    s.length || (r(u), f(o)), s.forEach(function(g) {
      var v = e[g];
      a.indexOf(g) !== -1 ? qg(v, n, p) : wI(v, n, p);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function xI(e) {
  return !!(e && e.message !== void 0);
}
function SI(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function Gg(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = SI(t, e.fullFields) : r = t[n.field || e.fullField], xI(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function Kg(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        Le(r) === "object" && Le(e[n]) === "object" ? e[n] = V(V({}, e[n]), r) : e[n] = r;
      }
  }
  return e;
}
var oi = "enum", TI = function(t, n, r, o, i) {
  t[oi] = Array.isArray(t[oi]) ? t[oi] : [], t[oi].indexOf(n) === -1 && o.push(Mn(i.messages[oi], t.fullField, t[oi].join(", ")));
}, OI = function(t, n, r, o, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || o.push(Mn(i.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(n) || o.push(Mn(i.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, PI = function(t, n, r, o, i) {
  var a = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", c = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = n, d = null, f = typeof n == "number", h = typeof n == "string", p = Array.isArray(n);
  if (f ? d = "number" : h ? d = "string" : p && (d = "array"), !d)
    return !1;
  p && (u = n.length), h && (u = n.replace(c, "_").length), a ? u !== t.len && o.push(Mn(i.messages[d].len, t.fullField, t.len)) : s && !l && u < t.min ? o.push(Mn(i.messages[d].min, t.fullField, t.min)) : l && !s && u > t.max ? o.push(Mn(i.messages[d].max, t.fullField, t.max)) : s && l && (u < t.min || u > t.max) && o.push(Mn(i.messages[d].range, t.fullField, t.min, t.max));
}, b2 = function(t, n, r, o, i, a) {
  t.required && (!r.hasOwnProperty(t.field) || Jt(n, a || t.type)) && o.push(Mn(i.messages.required, t.fullField));
}, Ns;
const RI = function() {
  if (Ns)
    return Ns;
  var e = "[a-fA-F\\d:]", t = function(x) {
    return x && x.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", o = [
    "(?:".concat(r, ":){7}(?:").concat(r, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(r, ":){6}(?:").concat(n, "|:").concat(r, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(r, ":){5}(?::").concat(n, "|(?::").concat(r, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(r, ":){4}(?:(?::").concat(r, "){0,1}:").concat(n, "|(?::").concat(r, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(r, ":){3}(?:(?::").concat(r, "){0,2}:").concat(n, "|(?::").concat(r, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(r, ":){2}(?:(?::").concat(r, "){0,3}:").concat(n, "|(?::").concat(r, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(r, ":){1}(?:(?::").concat(r, "){0,4}:").concat(n, "|(?::").concat(r, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(r, "){0,5}:").concat(n, "|(?::").concat(r, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], i = "(?:%[0-9a-zA-Z]{1,})?", a = "(?:".concat(o.join("|"), ")").concat(i), s = new RegExp("(?:^".concat(n, "$)|(?:^").concat(a, "$)")), l = new RegExp("^".concat(n, "$")), c = new RegExp("^".concat(a, "$")), u = function(x) {
    return x && x.exact ? s : new RegExp("(?:".concat(t(x)).concat(n).concat(t(x), ")|(?:").concat(t(x)).concat(a).concat(t(x), ")"), "g");
  };
  u.v4 = function(C) {
    return C && C.exact ? l : new RegExp("".concat(t(C)).concat(n).concat(t(C)), "g");
  }, u.v6 = function(C) {
    return C && C.exact ? c : new RegExp("".concat(t(C)).concat(a).concat(t(C)), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", h = u.v4().source, p = u.v6().source, g = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", v = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", b = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", w = '(?:[/?#][^\\s"]*)?', E = "(?:".concat(d, "|www\\.)").concat(f, "(?:localhost|").concat(h, "|").concat(p, "|").concat(g).concat(v).concat(b, ")").concat(m).concat(w);
  return Ns = new RegExp("(?:^".concat(E, "$)"), "i"), Ns;
};
var Yg = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, ha = {
  integer: function(t) {
    return ha.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return ha.number(t) && !ha.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return Le(t) === "object" && !ha.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(Yg.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(RI());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(Yg.hex);
  }
}, AI = function(t, n, r, o, i) {
  if (t.required && n === void 0) {
    b2(t, n, r, o, i);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? ha[s](n) || o.push(Mn(i.messages.types[s], t.fullField, t.type)) : s && Le(n) !== t.type && o.push(Mn(i.messages.types[s], t.fullField, t.type));
}, II = function(t, n, r, o, i) {
  (/^\s+$/.test(n) || n === "") && o.push(Mn(i.messages.whitespace, t.fullField));
};
const Je = {
  required: b2,
  whitespace: II,
  type: AI,
  range: PI,
  enum: TI,
  pattern: OI
};
var kI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i);
  }
  r(a);
}, $I = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    Je.required(t, n, o, a, i, "array"), n != null && (Je.type(t, n, o, a, i), Je.range(t, n, o, a, i));
  }
  r(a);
}, NI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && Je.type(t, n, o, a, i);
  }
  r(a);
}, FI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n, "date") && !t.required)
      return r();
    if (Je.required(t, n, o, a, i), !Jt(n, "date")) {
      var l;
      n instanceof Date ? l = n : l = new Date(n), Je.type(t, l, o, a, i), l && Je.range(t, l.getTime(), o, a, i);
    }
  }
  r(a);
}, LI = "enum", MI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && Je[LI](t, n, o, a, i);
  }
  r(a);
}, DI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && (Je.type(t, n, o, a, i), Je.range(t, n, o, a, i));
  }
  r(a);
}, jI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && (Je.type(t, n, o, a, i), Je.range(t, n, o, a, i));
  }
  r(a);
}, BI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && Je.type(t, n, o, a, i);
  }
  r(a);
}, VI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && (Je.type(t, n, o, a, i), Je.range(t, n, o, a, i));
  }
  r(a);
}, UI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), n !== void 0 && Je.type(t, n, o, a, i);
  }
  r(a);
}, HI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n, "string") && !t.required)
      return r();
    Je.required(t, n, o, a, i), Jt(n, "string") || Je.pattern(t, n, o, a, i);
  }
  r(a);
}, zI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n) && !t.required)
      return r();
    Je.required(t, n, o, a, i), Jt(n) || Je.type(t, n, o, a, i);
  }
  r(a);
}, qI = function(t, n, r, o, i) {
  var a = [], s = Array.isArray(n) ? "array" : Le(n);
  Je.required(t, n, o, a, i, s), r(a);
}, WI = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Jt(n, "string") && !t.required)
      return r();
    Je.required(t, n, o, a, i, "string"), Jt(n, "string") || (Je.type(t, n, o, a, i), Je.range(t, n, o, a, i), Je.pattern(t, n, o, a, i), t.whitespace === !0 && Je.whitespace(t, n, o, a, i));
  }
  r(a);
}, qu = function(t, n, r, o, i) {
  var a = t.type, s = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Jt(n, a) && !t.required)
      return r();
    Je.required(t, n, o, s, i, a), Jt(n, a) || Je.type(t, n, o, s, i);
  }
  r(s);
};
const ya = {
  string: WI,
  method: BI,
  number: VI,
  boolean: NI,
  regexp: zI,
  integer: jI,
  float: DI,
  array: $I,
  object: UI,
  enum: MI,
  pattern: HI,
  date: FI,
  url: qu,
  hex: qu,
  email: qu,
  required: qI,
  any: kI
};
var za = /* @__PURE__ */ function() {
  function e(t) {
    cn(this, e), U(this, "rules", null), U(this, "_messages", Ef), this.define(t);
  }
  return un(e, [{
    key: "define",
    value: function(n) {
      var r = this;
      if (!n)
        throw new Error("Cannot configure a schema with no rules");
      if (Le(n) !== "object" || Array.isArray(n))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(n).forEach(function(o) {
        var i = n[o];
        r.rules[o] = Array.isArray(i) ? i : [i];
      });
    }
  }, {
    key: "messages",
    value: function(n) {
      return n && (this._messages = Kg(wf(), n)), this._messages;
    }
  }, {
    key: "validate",
    value: function(n) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, a = n, s = o, l = i;
      if (typeof s == "function" && (l = s, s = {}), !this.rules || Object.keys(this.rules).length === 0)
        return l && l(null, a), Promise.resolve(a);
      function c(p) {
        var g = [], v = {};
        function b(w) {
          if (Array.isArray(w)) {
            var E;
            g = (E = g).concat.apply(E, Pe(w));
          } else
            g.push(w);
        }
        for (var m = 0; m < p.length; m++)
          b(p[m]);
        g.length ? (v = xf(g), l(g, v)) : l(null, a);
      }
      if (s.messages) {
        var u = this.messages();
        u === Ef && (u = wf()), Kg(u, s.messages), s.messages = u;
      } else
        s.messages = this.messages();
      var d = {}, f = s.keys || Object.keys(this.rules);
      f.forEach(function(p) {
        var g = r.rules[p], v = a[p];
        g.forEach(function(b) {
          var m = b;
          typeof m.transform == "function" && (a === n && (a = V({}, a)), v = a[p] = m.transform(v), v != null && (m.type = m.type || (Array.isArray(v) ? "array" : Le(v)))), typeof m == "function" ? m = {
            validator: m
          } : m = V({}, m), m.validator = r.getValidationMethod(m), m.validator && (m.field = p, m.fullField = m.fullField || p, m.type = r.getType(m), d[p] = d[p] || [], d[p].push({
            rule: m,
            value: v,
            source: a,
            field: p
          }));
        });
      });
      var h = {};
      return _I(d, s, function(p, g) {
        var v = p.rule, b = (v.type === "object" || v.type === "array") && (Le(v.fields) === "object" || Le(v.defaultField) === "object");
        b = b && (v.required || !v.required && p.value), v.field = p.field;
        function m(_, T) {
          return V(V({}, T), {}, {
            fullField: "".concat(v.fullField, ".").concat(_),
            fullFields: v.fullFields ? [].concat(Pe(v.fullFields), [_]) : [_]
          });
        }
        function w() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], T = Array.isArray(_) ? _ : [_];
          !s.suppressWarning && T.length && e.warning("async-validator:", T), T.length && v.message !== void 0 && (T = [].concat(v.message));
          var O = T.map(Gg(v, a));
          if (s.first && O.length)
            return h[v.field] = 1, g(O);
          if (!b)
            g(O);
          else {
            if (v.required && !p.value)
              return v.message !== void 0 ? O = [].concat(v.message).map(Gg(v, a)) : s.error && (O = [s.error(v, Mn(s.messages.required, v.field))]), g(O);
            var I = {};
            v.defaultField && Object.keys(p.value).map(function(j) {
              I[j] = v.defaultField;
            }), I = V(V({}, I), p.rule.fields);
            var L = {};
            Object.keys(I).forEach(function(j) {
              var M = I[j], q = Array.isArray(M) ? M : [M];
              L[j] = q.map(m.bind(null, j));
            });
            var B = new e(L);
            B.messages(s.messages), p.rule.options && (p.rule.options.messages = s.messages, p.rule.options.error = s.error), B.validate(p.value, p.rule.options || s, function(j) {
              var M = [];
              O && O.length && M.push.apply(M, Pe(O)), j && j.length && M.push.apply(M, Pe(j)), g(M.length ? M : null);
            });
          }
        }
        var E;
        if (v.asyncValidator)
          E = v.asyncValidator(v, p.value, w, p.source, s);
        else if (v.validator) {
          try {
            E = v.validator(v, p.value, w, p.source, s);
          } catch (_) {
            var C, x;
            (C = (x = console).error) === null || C === void 0 || C.call(x, _), s.suppressValidatorError || setTimeout(function() {
              throw _;
            }, 0), w(_.message);
          }
          E === !0 ? w() : E === !1 ? w(typeof v.message == "function" ? v.message(v.fullField || v.field) : v.message || "".concat(v.fullField || v.field, " fails")) : E instanceof Array ? w(E) : E instanceof Error && w(E.message);
        }
        E && E.then && E.then(function() {
          return w();
        }, function(_) {
          return w(_);
        });
      }, function(p) {
        c(p);
      }, a);
    }
  }, {
    key: "getType",
    value: function(n) {
      if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !ya.hasOwnProperty(n.type))
        throw new Error(Mn("Unknown rule type %s", n.type));
      return n.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(n) {
      if (typeof n.validator == "function")
        return n.validator;
      var r = Object.keys(n), o = r.indexOf("message");
      return o !== -1 && r.splice(o, 1), r.length === 1 && r[0] === "required" ? ya.required : ya[this.getType(n)] || void 0;
    }
  }]), e;
}();
U(za, "register", function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  ya[t] = n;
});
U(za, "warning", y2);
U(za, "messages", Ef);
U(za, "validators", ya);
var Nn = "'${name}' is not a valid ${type}", C2 = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: Nn,
    method: Nn,
    array: Nn,
    object: Nn,
    number: Nn,
    date: Nn,
    boolean: Nn,
    integer: Nn,
    float: Nn,
    regexp: Nn,
    email: Nn,
    url: Nn,
    hex: Nn
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, Zg = za;
function GI(e, t) {
  return e.replace(/\\?\$\{\w+\}/g, function(n) {
    if (n.startsWith("\\"))
      return n.slice(1);
    var r = n.slice(2, -1);
    return t[r];
  });
}
var Qg = "CODE_LOGIC_ERROR";
function Sf(e, t, n, r, o) {
  return Tf.apply(this, arguments);
}
function Tf() {
  return Tf = Wo(/* @__PURE__ */ Sn().mark(function e(t, n, r, o, i) {
    var a, s, l, c, u, d, f, h, p;
    return Sn().wrap(function(v) {
      for (; ; )
        switch (v.prev = v.next) {
          case 0:
            return a = V({}, r), delete a.ruleIndex, Zg.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (b) {
                return console.error(b), Promise.reject(Qg);
              }
            }), l = null, a && a.type === "array" && a.defaultField && (l = a.defaultField, delete a.defaultField), c = new Zg(U({}, t, [a])), u = pi(C2, o.validateMessages), c.messages(u), d = [], v.prev = 10, v.next = 13, Promise.resolve(c.validate(U({}, t, n), V({}, o)));
          case 13:
            v.next = 18;
            break;
          case 15:
            v.prev = 15, v.t0 = v.catch(10), v.t0.errors && (d = v.t0.errors.map(function(b, m) {
              var w = b.message, E = w === Qg ? u.default : w;
              return /* @__PURE__ */ y.isValidElement(E) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ y.cloneElement(E, {
                  key: "error_".concat(m)
                })
              ) : E;
            }));
          case 18:
            if (!(!d.length && l)) {
              v.next = 23;
              break;
            }
            return v.next = 21, Promise.all(n.map(function(b, m) {
              return Sf("".concat(t, ".").concat(m), b, l, o, i);
            }));
          case 21:
            return f = v.sent, v.abrupt("return", f.reduce(function(b, m) {
              return [].concat(Pe(b), Pe(m));
            }, []));
          case 23:
            return h = V(V({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, i), p = d.map(function(b) {
              return typeof b == "string" ? GI(b, h) : b;
            }), v.abrupt("return", p);
          case 26:
          case "end":
            return v.stop();
        }
    }, e, null, [[10, 15]]);
  })), Tf.apply(this, arguments);
}
function KI(e, t, n, r, o, i) {
  var a = e.join("."), s = n.map(function(u, d) {
    var f = u.validator, h = V(V({}, u), {}, {
      ruleIndex: d
    });
    return f && (h.validator = function(p, g, v) {
      var b = !1, m = function() {
        for (var C = arguments.length, x = new Array(C), _ = 0; _ < C; _++)
          x[_] = arguments[_];
        Promise.resolve().then(function() {
          Et(!b, "Your validator function has already return a promise. `callback` will be ignored."), b || v.apply(void 0, x);
        });
      }, w = f(p, g, m);
      b = w && typeof w.then == "function" && typeof w.catch == "function", Et(b, "`callback` is deprecated. Please return a promise instead."), b && w.then(function() {
        v();
      }).catch(function(E) {
        v(E || " ");
      });
    }), h;
  }).sort(function(u, d) {
    var f = u.warningOnly, h = u.ruleIndex, p = d.warningOnly, g = d.ruleIndex;
    return !!f == !!p ? h - g : f ? 1 : -1;
  }), l;
  if (o === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var u = Wo(/* @__PURE__ */ Sn().mark(function d(f, h) {
        var p, g, v;
        return Sn().wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                p = 0;
              case 1:
                if (!(p < s.length)) {
                  m.next = 12;
                  break;
                }
                return g = s[p], m.next = 5, Sf(a, t, g, r, i);
              case 5:
                if (v = m.sent, !v.length) {
                  m.next = 9;
                  break;
                }
                return h([{
                  errors: v,
                  rule: g
                }]), m.abrupt("return");
              case 9:
                p += 1, m.next = 1;
                break;
              case 12:
                f([]);
              case 13:
              case "end":
                return m.stop();
            }
        }, d);
      }));
      return function(d, f) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var c = s.map(function(u) {
      return Sf(a, t, u, r, i).then(function(d) {
        return {
          errors: d,
          rule: u
        };
      });
    });
    l = (o ? ZI(c) : YI(c)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return l.catch(function(u) {
    return u;
  }), l;
}
function YI(e) {
  return Of.apply(this, arguments);
}
function Of() {
  return Of = Wo(/* @__PURE__ */ Sn().mark(function e(t) {
    return Sn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(o) {
              var i, a = (i = []).concat.apply(i, Pe(o));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), Of.apply(this, arguments);
}
function ZI(e) {
  return Pf.apply(this, arguments);
}
function Pf() {
  return Pf = Wo(/* @__PURE__ */ Sn().mark(function e(t) {
    var n;
    return Sn().wrap(function(o) {
      for (; ; )
        switch (o.prev = o.next) {
          case 0:
            return n = 0, o.abrupt("return", new Promise(function(i) {
              t.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && i([s]), n += 1, n === t.length && i([]);
                });
              });
            }));
          case 2:
          case "end":
            return o.stop();
        }
    }, e);
  })), Pf.apply(this, arguments);
}
function jt(e) {
  return Cf(e);
}
function Xg(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var o = Ir(e, r);
    n = lr(n, r, o);
  }), n;
}
function Ei(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return w2(t, r, n);
  });
}
function w2(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, o) {
    return e[o] === r;
  });
}
function QI(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || Le(e) !== "object" || Le(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), o = new Set([].concat(n, r));
  return Pe(o).every(function(i) {
    var a = e[i], s = t[i];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function XI(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && Le(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function Jg(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var o = e[t], i = t - n;
  return i > 0 ? [].concat(Pe(e.slice(0, n)), [o], Pe(e.slice(n, t)), Pe(e.slice(t + 1, r))) : i < 0 ? [].concat(Pe(e.slice(0, t)), Pe(e.slice(t + 1, n + 1)), [o], Pe(e.slice(n + 1, r))) : e;
}
var JI = ["name"], Kn = [];
function Wu(e, t, n, r, o, i) {
  return typeof e == "function" ? e(t, n, "source" in i ? {
    source: i.source
  } : {}) : r !== o;
}
var Fh = /* @__PURE__ */ function(e) {
  bo(n, e);
  var t = Co(n);
  function n(r) {
    var o;
    if (cn(this, n), o = t.call(this, r), U(Ye(o), "state", {
      resetCount: 0
    }), U(Ye(o), "cancelRegisterFunc", null), U(Ye(o), "mounted", !1), U(Ye(o), "touched", !1), U(Ye(o), "dirty", !1), U(Ye(o), "validatePromise", void 0), U(Ye(o), "prevValidating", void 0), U(Ye(o), "errors", Kn), U(Ye(o), "warnings", Kn), U(Ye(o), "cancelRegister", function() {
      var l = o.props, c = l.preserve, u = l.isListField, d = l.name;
      o.cancelRegisterFunc && o.cancelRegisterFunc(u, c, jt(d)), o.cancelRegisterFunc = null;
    }), U(Ye(o), "getNamePath", function() {
      var l = o.props, c = l.name, u = l.fieldContext, d = u.prefixName, f = d === void 0 ? [] : d;
      return c !== void 0 ? [].concat(Pe(f), Pe(c)) : [];
    }), U(Ye(o), "getRules", function() {
      var l = o.props, c = l.rules, u = c === void 0 ? [] : c, d = l.fieldContext;
      return u.map(function(f) {
        return typeof f == "function" ? f(d) : f;
      });
    }), U(Ye(o), "refresh", function() {
      o.mounted && o.setState(function(l) {
        var c = l.resetCount;
        return {
          resetCount: c + 1
        };
      });
    }), U(Ye(o), "metaCache", null), U(Ye(o), "triggerMetaEvent", function(l) {
      var c = o.props.onMetaChange;
      if (c) {
        var u = V(V({}, o.getMeta()), {}, {
          destroy: l
        });
        ef(o.metaCache, u) || c(u), o.metaCache = u;
      } else
        o.metaCache = null;
    }), U(Ye(o), "onStoreChange", function(l, c, u) {
      var d = o.props, f = d.shouldUpdate, h = d.dependencies, p = h === void 0 ? [] : h, g = d.onReset, v = u.store, b = o.getNamePath(), m = o.getValue(l), w = o.getValue(v), E = c && Ei(c, b);
      switch (u.type === "valueUpdate" && u.source === "external" && !ef(m, w) && (o.touched = !0, o.dirty = !0, o.validatePromise = null, o.errors = Kn, o.warnings = Kn, o.triggerMetaEvent()), u.type) {
        case "reset":
          if (!c || E) {
            o.touched = !1, o.dirty = !1, o.validatePromise = void 0, o.errors = Kn, o.warnings = Kn, o.triggerMetaEvent(), g == null || g(), o.refresh();
            return;
          }
          break;
        case "remove": {
          if (f && Wu(f, l, v, m, w, u)) {
            o.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var C = u.data;
          if (E) {
            "touched" in C && (o.touched = C.touched), "validating" in C && !("originRCField" in C) && (o.validatePromise = C.validating ? Promise.resolve([]) : null), "errors" in C && (o.errors = C.errors || Kn), "warnings" in C && (o.warnings = C.warnings || Kn), o.dirty = !0, o.triggerMetaEvent(), o.reRender();
            return;
          } else if ("value" in C && Ei(c, b, !0)) {
            o.reRender();
            return;
          }
          if (f && !b.length && Wu(f, l, v, m, w, u)) {
            o.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var x = p.map(jt);
          if (x.some(function(_) {
            return Ei(u.relatedFields, _);
          })) {
            o.reRender();
            return;
          }
          break;
        }
        default:
          if (E || (!p.length || b.length || f) && Wu(f, l, v, m, w, u)) {
            o.reRender();
            return;
          }
          break;
      }
      f === !0 && o.reRender();
    }), U(Ye(o), "validateRules", function(l) {
      var c = o.getNamePath(), u = o.getValue(), d = l || {}, f = d.triggerName, h = d.validateOnly, p = h === void 0 ? !1 : h, g = Promise.resolve().then(/* @__PURE__ */ Wo(/* @__PURE__ */ Sn().mark(function v() {
        var b, m, w, E, C, x, _;
        return Sn().wrap(function(O) {
          for (; ; )
            switch (O.prev = O.next) {
              case 0:
                if (o.mounted) {
                  O.next = 2;
                  break;
                }
                return O.abrupt("return", []);
              case 2:
                if (b = o.props, m = b.validateFirst, w = m === void 0 ? !1 : m, E = b.messageVariables, C = b.validateDebounce, x = o.getRules(), f && (x = x.filter(function(I) {
                  return I;
                }).filter(function(I) {
                  var L = I.validateTrigger;
                  if (!L)
                    return !0;
                  var B = Cf(L);
                  return B.includes(f);
                })), !(C && f)) {
                  O.next = 10;
                  break;
                }
                return O.next = 8, new Promise(function(I) {
                  setTimeout(I, C);
                });
              case 8:
                if (o.validatePromise === g) {
                  O.next = 10;
                  break;
                }
                return O.abrupt("return", []);
              case 10:
                return _ = KI(c, u, x, l, w, E), _.catch(function(I) {
                  return I;
                }).then(function() {
                  var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Kn;
                  if (o.validatePromise === g) {
                    var L;
                    o.validatePromise = null;
                    var B = [], j = [];
                    (L = I.forEach) === null || L === void 0 || L.call(I, function(M) {
                      var q = M.rule.warningOnly, N = M.errors, $ = N === void 0 ? Kn : N;
                      q ? j.push.apply(j, Pe($)) : B.push.apply(B, Pe($));
                    }), o.errors = B, o.warnings = j, o.triggerMetaEvent(), o.reRender();
                  }
                }), O.abrupt("return", _);
              case 13:
              case "end":
                return O.stop();
            }
        }, v);
      })));
      return p || (o.validatePromise = g, o.dirty = !0, o.errors = Kn, o.warnings = Kn, o.triggerMetaEvent(), o.reRender()), g;
    }), U(Ye(o), "isFieldValidating", function() {
      return !!o.validatePromise;
    }), U(Ye(o), "isFieldTouched", function() {
      return o.touched;
    }), U(Ye(o), "isFieldDirty", function() {
      if (o.dirty || o.props.initialValue !== void 0)
        return !0;
      var l = o.props.fieldContext, c = l.getInternalHooks(Ao), u = c.getInitialValue;
      return u(o.getNamePath()) !== void 0;
    }), U(Ye(o), "getErrors", function() {
      return o.errors;
    }), U(Ye(o), "getWarnings", function() {
      return o.warnings;
    }), U(Ye(o), "isListField", function() {
      return o.props.isListField;
    }), U(Ye(o), "isList", function() {
      return o.props.isList;
    }), U(Ye(o), "isPreserve", function() {
      return o.props.preserve;
    }), U(Ye(o), "getMeta", function() {
      o.prevValidating = o.isFieldValidating();
      var l = {
        touched: o.isFieldTouched(),
        validating: o.prevValidating,
        errors: o.errors,
        warnings: o.warnings,
        name: o.getNamePath(),
        validated: o.validatePromise === null
      };
      return l;
    }), U(Ye(o), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var c = o.getMeta();
        return V(V({}, o.getOnlyChild(l(o.getControlled(), c, o.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = Tl(l);
      return u.length !== 1 || !/* @__PURE__ */ y.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), U(Ye(o), "getValue", function(l) {
      var c = o.props.fieldContext.getFieldsValue, u = o.getNamePath();
      return Ir(l || c(!0), u);
    }), U(Ye(o), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o.props, u = c.name, d = c.trigger, f = c.validateTrigger, h = c.getValueFromEvent, p = c.normalize, g = c.valuePropName, v = c.getValueProps, b = c.fieldContext, m = f !== void 0 ? f : b.validateTrigger, w = o.getNamePath(), E = b.getInternalHooks, C = b.getFieldsValue, x = E(Ao), _ = x.dispatch, T = o.getValue(), O = v || function(M) {
        return U({}, g, M);
      }, I = l[d], L = u !== void 0 ? O(T) : {};
      z.env.NODE_ENV !== "production" && L && Object.keys(L).forEach(function(M) {
        Et(typeof L[M] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(M, ")"));
      });
      var B = V(V({}, l), L);
      B[d] = function() {
        o.touched = !0, o.dirty = !0, o.triggerMetaEvent();
        for (var M, q = arguments.length, N = new Array(q), $ = 0; $ < q; $++)
          N[$] = arguments[$];
        h ? M = h.apply(void 0, N) : M = XI.apply(void 0, [g].concat(N)), p && (M = p(M, T, C(!0))), M !== T && _({
          type: "updateValue",
          namePath: w,
          value: M
        }), I && I.apply(void 0, N);
      };
      var j = Cf(m || []);
      return j.forEach(function(M) {
        var q = B[M];
        B[M] = function() {
          q && q.apply(void 0, arguments);
          var N = o.props.rules;
          N && N.length && _({
            type: "validateField",
            namePath: w,
            triggerName: M
          });
        };
      }), B;
    }), r.fieldContext) {
      var i = r.fieldContext.getInternalHooks, a = i(Ao), s = a.initEntityValue;
      s(Ye(o));
    }
    return o;
  }
  return un(n, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, i = o.shouldUpdate, a = o.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, l = s(Ao), c = l.registerField;
        this.cancelRegisterFunc = c(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state.resetCount, i = this.props.children, a = this.getOnlyChild(i), s = a.child, l = a.isFunction, c;
      return l ? c = s : /* @__PURE__ */ y.isValidElement(s) ? c = /* @__PURE__ */ y.cloneElement(s, this.getControlled(s.props)) : (Et(!s, "`children` of Field is not validate ReactElement."), c = s), /* @__PURE__ */ y.createElement(y.Fragment, {
        key: o
      }, c);
    }
  }]), n;
}(y.Component);
U(Fh, "contextType", ji);
U(Fh, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function E2(e) {
  var t, n = e.name, r = Hn(e, JI), o = y.useContext(ji), i = y.useContext(Nl), a = n !== void 0 ? jt(n) : void 0, s = (t = r.isListField) !== null && t !== void 0 ? t : !!i, l = "keep";
  return s || (l = "_".concat((a || []).join("_"))), z.env.NODE_ENV !== "production" && r.preserve === !1 && s && a.length <= 1 && Et(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ y.createElement(Fh, it({
    key: l,
    name: a,
    isListField: s
  }, r, {
    fieldContext: o
  }));
}
function ek(e) {
  var t = e.name, n = e.initialValue, r = e.children, o = e.rules, i = e.validateTrigger, a = e.isListField, s = y.useContext(ji), l = y.useContext(Nl), c = y.useRef({
    keys: [],
    id: 0
  }), u = c.current, d = y.useMemo(function() {
    var g = jt(s.prefixName) || [];
    return [].concat(Pe(g), Pe(jt(t)));
  }, [s.prefixName, t]), f = y.useMemo(function() {
    return V(V({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), h = y.useMemo(function() {
    return {
      getKey: function(v) {
        var b = d.length, m = v[b];
        return [u.keys[m], v.slice(b + 1)];
      }
    };
  }, [d]);
  if (typeof r != "function")
    return Et(!1, "Form.List only accepts function as children."), null;
  var p = function(v, b, m) {
    var w = m.source;
    return w === "internal" ? !1 : v !== b;
  };
  return /* @__PURE__ */ y.createElement(Nl.Provider, {
    value: h
  }, /* @__PURE__ */ y.createElement(ji.Provider, {
    value: f
  }, /* @__PURE__ */ y.createElement(E2, {
    name: [],
    shouldUpdate: p,
    rules: o,
    validateTrigger: i,
    initialValue: n,
    isList: !0,
    isListField: a ?? !!l
  }, function(g, v) {
    var b = g.value, m = b === void 0 ? [] : b, w = g.onChange, E = s.getFieldValue, C = function() {
      var O = E(d || []);
      return O || [];
    }, x = {
      add: function(O, I) {
        var L = C();
        I >= 0 && I <= L.length ? (u.keys = [].concat(Pe(u.keys.slice(0, I)), [u.id], Pe(u.keys.slice(I))), w([].concat(Pe(L.slice(0, I)), [O], Pe(L.slice(I))))) : (z.env.NODE_ENV !== "production" && (I < 0 || I > L.length) && Et(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(Pe(u.keys), [u.id]), w([].concat(Pe(L), [O]))), u.id += 1;
      },
      remove: function(O) {
        var I = C(), L = new Set(Array.isArray(O) ? O : [O]);
        L.size <= 0 || (u.keys = u.keys.filter(function(B, j) {
          return !L.has(j);
        }), w(I.filter(function(B, j) {
          return !L.has(j);
        })));
      },
      move: function(O, I) {
        if (O !== I) {
          var L = C();
          O < 0 || O >= L.length || I < 0 || I >= L.length || (u.keys = Jg(u.keys, O, I), w(Jg(L, O, I)));
        }
      }
    }, _ = m || [];
    return Array.isArray(_) || (_ = [], z.env.NODE_ENV !== "production" && Et(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), r(_.map(function(T, O) {
      var I = u.keys[O];
      return I === void 0 && (u.keys[O] = u.id, I = u.keys[O], u.id += 1), {
        name: O,
        key: I,
        isListField: !0
      };
    }), x, v);
  })));
}
function tk(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(o, i) {
    e.forEach(function(a, s) {
      a.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        n -= 1, r[s] = l, !(n > 0) && (t && i(r), o(r));
      });
    });
  }) : Promise.resolve([]);
}
var _2 = "__@field_split__";
function Gu(e) {
  return e.map(function(t) {
    return "".concat(Le(t), ":").concat(t);
  }).join(_2);
}
var ii = /* @__PURE__ */ function() {
  function e() {
    cn(this, e), U(this, "kvs", /* @__PURE__ */ new Map());
  }
  return un(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(Gu(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(Gu(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var o = this.get(n), i = r(o);
      i ? this.set(n, i) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(Gu(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return Pe(this.kvs.entries()).map(function(r) {
        var o = de(r, 2), i = o[0], a = o[1], s = i.split(_2);
        return n({
          key: s.map(function(l) {
            var c = l.match(/^([^:]*):(.*)$/), u = de(c, 3), d = u[1], f = u[2];
            return d === "number" ? Number(f) : f;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var o = r.key, i = r.value;
        return n[o.join(".")] = i, null;
      }), n;
    }
  }]), e;
}(), nk = ["name"], rk = /* @__PURE__ */ un(function e(t) {
  var n = this;
  cn(this, e), U(this, "formHooked", !1), U(this, "forceRootUpdate", void 0), U(this, "subscribable", !0), U(this, "store", {}), U(this, "fieldEntities", []), U(this, "initialValues", {}), U(this, "callbacks", {}), U(this, "validateMessages", null), U(this, "preserve", null), U(this, "lastValidatePromise", null), U(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), U(this, "getInternalHooks", function(r) {
    return r === Ao ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (Et(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), U(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), U(this, "prevWithoutPreserves", null), U(this, "setInitialValues", function(r, o) {
    if (n.initialValues = r || {}, o) {
      var i, a = pi(r, n.store);
      (i = n.prevWithoutPreserves) === null || i === void 0 || i.map(function(s) {
        var l = s.key;
        a = lr(a, l, Ir(r, l));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), U(this, "destroyForm", function(r) {
    if (r)
      n.updateStore({});
    else {
      var o = new ii();
      n.getFieldEntities(!0).forEach(function(i) {
        n.isMergedPreserve(i.isPreserve()) || o.set(i.getNamePath(), !0);
      }), n.prevWithoutPreserves = o;
    }
  }), U(this, "getInitialValue", function(r) {
    var o = Ir(n.initialValues, r);
    return r.length ? pi(o) : o;
  }), U(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), U(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), U(this, "setPreserve", function(r) {
    n.preserve = r;
  }), U(this, "watchList", []), U(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(o) {
        return o !== r;
      });
    };
  }), U(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var o = n.getFieldsValue(), i = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(o, i, r);
      });
    }
  }), U(this, "timeoutId", null), U(this, "warningUnhooked", function() {
    z.env.NODE_ENV !== "production" && !n.timeoutId && typeof window < "u" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || Et(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), U(this, "updateStore", function(r) {
    n.store = r;
  }), U(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(o) {
      return o.getNamePath().length;
    }) : n.fieldEntities;
  }), U(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = new ii();
    return n.getFieldEntities(r).forEach(function(i) {
      var a = i.getNamePath();
      o.set(a, i);
    }), o;
  }), U(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var o = n.getFieldsMap(!0);
    return r.map(function(i) {
      var a = jt(i);
      return o.get(a) || {
        INVALIDATE_NAME_PATH: jt(i)
      };
    });
  }), U(this, "getFieldsValue", function(r, o) {
    n.warningUnhooked();
    var i, a, s;
    if (r === !0 || Array.isArray(r) ? (i = r, a = o) : r && Le(r) === "object" && (s = r.strict, a = r.filter), i === !0 && !a)
      return n.store;
    var l = n.getFieldEntitiesForNamePathList(Array.isArray(i) ? i : null), c = [];
    return l.forEach(function(u) {
      var d, f, h = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (s) {
        var p, g;
        if ((p = (g = u).isList) !== null && p !== void 0 && p.call(g))
          return;
      } else if (!i && (d = (f = u).isListField) !== null && d !== void 0 && d.call(f))
        return;
      if (!a)
        c.push(h);
      else {
        var v = "getMeta" in u ? u.getMeta() : null;
        a(v) && c.push(h);
      }
    }), Xg(n.store, c.map(jt));
  }), U(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var o = jt(r);
    return Ir(n.store, o);
  }), U(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntitiesForNamePathList(r);
    return o.map(function(i, a) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: jt(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), U(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var o = jt(r), i = n.getFieldsError([o])[0];
    return i.errors;
  }), U(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var o = jt(r), i = n.getFieldsError([o])[0];
    return i.warnings;
  }), U(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    var a = o[0], s = o[1], l, c = !1;
    o.length === 0 ? l = null : o.length === 1 ? Array.isArray(a) ? (l = a.map(jt), c = !1) : (l = null, c = a) : (l = a.map(jt), c = s);
    var u = n.getFieldEntities(!0), d = function(v) {
      return v.isFieldTouched();
    };
    if (!l)
      return c ? u.every(function(g) {
        return d(g) || g.isList();
      }) : u.some(d);
    var f = new ii();
    l.forEach(function(g) {
      f.set(g, []);
    }), u.forEach(function(g) {
      var v = g.getNamePath();
      l.forEach(function(b) {
        b.every(function(m, w) {
          return v[w] === m;
        }) && f.update(b, function(m) {
          return [].concat(Pe(m), [g]);
        });
      });
    });
    var h = function(v) {
      return v.some(d);
    }, p = f.map(function(g) {
      var v = g.value;
      return v;
    });
    return c ? p.every(h) : p.some(h);
  }), U(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), U(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntities();
    if (!r)
      return o.some(function(a) {
        return a.isFieldValidating();
      });
    var i = r.map(jt);
    return o.some(function(a) {
      var s = a.getNamePath();
      return Ei(i, s) && a.isFieldValidating();
    });
  }), U(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), U(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = new ii(), i = n.getFieldEntities(!0);
    i.forEach(function(l) {
      var c = l.props.initialValue, u = l.getNamePath();
      if (c !== void 0) {
        var d = o.get(u) || /* @__PURE__ */ new Set();
        d.add({
          entity: l,
          value: c
        }), o.set(u, d);
      }
    });
    var a = function(c) {
      c.forEach(function(u) {
        var d = u.props.initialValue;
        if (d !== void 0) {
          var f = u.getNamePath(), h = n.getInitialValue(f);
          if (h !== void 0)
            Et(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var p = o.get(f);
            if (p && p.size > 1)
              Et(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (p) {
              var g = n.getFieldValue(f), v = u.isListField();
              !v && (!r.skipExist || g === void 0) && n.updateStore(lr(n.store, f, Pe(p)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(l) {
      var c = o.get(l);
      if (c) {
        var u;
        (u = s).push.apply(u, Pe(Pe(c).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = i, a(s);
  }), U(this, "resetFields", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (!r) {
      n.updateStore(pi(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(o, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var i = r.map(jt);
    i.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(lr(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: i
    }), n.notifyObservers(o, i, {
      type: "reset"
    }), n.notifyWatch(i);
  }), U(this, "setFields", function(r) {
    n.warningUnhooked();
    var o = n.store, i = [];
    r.forEach(function(a) {
      var s = a.name, l = Hn(a, nk), c = jt(s);
      i.push(c), "value" in l && n.updateStore(lr(n.store, c, l.value)), n.notifyObservers(o, [c], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(i);
  }), U(this, "getFields", function() {
    var r = n.getFieldEntities(!0), o = r.map(function(i) {
      var a = i.getNamePath(), s = i.getMeta(), l = V(V({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return o;
  }), U(this, "initEntityValue", function(r) {
    var o = r.props.initialValue;
    if (o !== void 0) {
      var i = r.getNamePath(), a = Ir(n.store, i);
      a === void 0 && n.updateStore(lr(n.store, i, o));
    }
  }), U(this, "isMergedPreserve", function(r) {
    var o = r !== void 0 ? r : n.preserve;
    return o ?? !0;
  }), U(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var o = r.getNamePath();
    if (n.notifyWatch([o]), r.props.initialValue !== void 0) {
      var i = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(i, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(d) {
        return d !== r;
      }), !n.isMergedPreserve(s) && (!a || l.length > 1)) {
        var c = a ? void 0 : n.getInitialValue(o);
        if (o.length && n.getFieldValue(o) !== c && n.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !w2(d.getNamePath(), o)
          );
        })) {
          var u = n.store;
          n.updateStore(lr(u, o, c, !0)), n.notifyObservers(u, [o], {
            type: "remove"
          }), n.triggerDependenciesUpdate(u, o);
        }
      }
      n.notifyWatch([o]);
    };
  }), U(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var o = r.namePath, i = r.value;
        n.updateValue(o, i);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), U(this, "notifyObservers", function(r, o, i) {
    if (n.subscribable) {
      var a = V(V({}, i), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var l = s.onStoreChange;
        l(r, o, a);
      });
    } else
      n.forceRootUpdate();
  }), U(this, "triggerDependenciesUpdate", function(r, o) {
    var i = n.getDependencyChildrenFields(o);
    return i.length && n.validateFields(i), n.notifyObservers(r, i, {
      type: "dependenciesUpdate",
      relatedFields: [o].concat(Pe(i))
    }), i;
  }), U(this, "updateValue", function(r, o) {
    var i = jt(r), a = n.store;
    n.updateStore(lr(n.store, i, o)), n.notifyObservers(a, [i], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([i]);
    var s = n.triggerDependenciesUpdate(a, i), l = n.callbacks.onValuesChange;
    if (l) {
      var c = Xg(n.store, [i]);
      l(c, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([i].concat(Pe(s)));
  }), U(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (r) {
      var i = pi(n.store, r);
      n.updateStore(i);
    }
    n.notifyObservers(o, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), U(this, "setFieldValue", function(r, o) {
    n.setFields([{
      name: r,
      value: o,
      errors: [],
      warnings: []
    }]);
  }), U(this, "getDependencyChildrenFields", function(r) {
    var o = /* @__PURE__ */ new Set(), i = [], a = new ii();
    n.getFieldEntities().forEach(function(l) {
      var c = l.props.dependencies;
      (c || []).forEach(function(u) {
        var d = jt(u);
        a.update(d, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(l), f;
        });
      });
    });
    var s = function l(c) {
      var u = a.get(c) || /* @__PURE__ */ new Set();
      u.forEach(function(d) {
        if (!o.has(d)) {
          o.add(d);
          var f = d.getNamePath();
          d.isFieldDirty() && f.length && (i.push(f), l(f));
        }
      });
    };
    return s(r), i;
  }), U(this, "triggerOnFieldsChange", function(r, o) {
    var i = n.callbacks.onFieldsChange;
    if (i) {
      var a = n.getFields();
      if (o) {
        var s = new ii();
        o.forEach(function(c) {
          var u = c.name, d = c.errors;
          s.set(u, d);
        }), a.forEach(function(c) {
          c.errors = s.get(c.name) || c.errors;
        });
      }
      var l = a.filter(function(c) {
        var u = c.name;
        return Ei(r, u);
      });
      l.length && i(l, a);
    }
  }), U(this, "validateFields", function(r, o) {
    n.warningUnhooked();
    var i, a;
    Array.isArray(r) || typeof r == "string" || typeof o == "string" ? (i = r, a = o) : a = r;
    var s = !!i, l = s ? i.map(jt) : [], c = [], u = String(Date.now()), d = /* @__PURE__ */ new Set(), f = a || {}, h = f.recursive, p = f.dirty;
    n.getFieldEntities(!0).forEach(function(m) {
      if (s || l.push(m.getNamePath()), !(!m.props.rules || !m.props.rules.length) && !(p && !m.isFieldDirty())) {
        var w = m.getNamePath();
        if (d.add(w.join(u)), !s || Ei(l, w, h)) {
          var E = m.validateRules(V({
            validateMessages: V(V({}, C2), n.validateMessages)
          }, a));
          c.push(E.then(function() {
            return {
              name: w,
              errors: [],
              warnings: []
            };
          }).catch(function(C) {
            var x, _ = [], T = [];
            return (x = C.forEach) === null || x === void 0 || x.call(C, function(O) {
              var I = O.rule.warningOnly, L = O.errors;
              I ? T.push.apply(T, Pe(L)) : _.push.apply(_, Pe(L));
            }), _.length ? Promise.reject({
              name: w,
              errors: _,
              warnings: T
            }) : {
              name: w,
              errors: _,
              warnings: T
            };
          }));
        }
      }
    });
    var g = tk(c);
    n.lastValidatePromise = g, g.catch(function(m) {
      return m;
    }).then(function(m) {
      var w = m.map(function(E) {
        var C = E.name;
        return C;
      });
      n.notifyObservers(n.store, w, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(w, m);
    });
    var v = g.then(function() {
      return n.lastValidatePromise === g ? Promise.resolve(n.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(m) {
      var w = m.filter(function(E) {
        return E && E.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(l),
        errorFields: w,
        outOfDate: n.lastValidatePromise !== g
      });
    });
    v.catch(function(m) {
      return m;
    });
    var b = l.filter(function(m) {
      return d.has(m.join(u));
    });
    return n.triggerOnFieldsChange(b), v;
  }), U(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var o = n.callbacks.onFinish;
      if (o)
        try {
          o(r);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(r) {
      var o = n.callbacks.onFinishFailed;
      o && o(r);
    });
  }), this.forceRootUpdate = t;
});
function x2(e) {
  var t = y.useRef(), n = y.useState({}), r = de(n, 2), o = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var i = function() {
        o({});
      }, a = new rk(i);
      t.current = a.getForm();
    }
  return [t.current];
}
var Rf = /* @__PURE__ */ y.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), ok = function(t) {
  var n = t.validateMessages, r = t.onFormChange, o = t.onFormFinish, i = t.children, a = y.useContext(Rf), s = y.useRef({});
  return /* @__PURE__ */ y.createElement(Rf.Provider, {
    value: V(V({}, a), {}, {
      validateMessages: V(V({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(c, u) {
        r && r(c, {
          changedFields: u,
          forms: s.current
        }), a.triggerFormChange(c, u);
      },
      triggerFormFinish: function(c, u) {
        o && o(c, {
          values: u,
          forms: s.current
        }), a.triggerFormFinish(c, u);
      },
      registerForm: function(c, u) {
        c && (s.current = V(V({}, s.current), {}, U({}, c, u))), a.registerForm(c, u);
      },
      unregisterForm: function(c) {
        var u = V({}, s.current);
        delete u[c], s.current = u, a.unregisterForm(c);
      }
    })
  }, i);
}, ik = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], ak = function(t, n) {
  var r = t.name, o = t.initialValues, i = t.fields, a = t.form, s = t.preserve, l = t.children, c = t.component, u = c === void 0 ? "form" : c, d = t.validateMessages, f = t.validateTrigger, h = f === void 0 ? "onChange" : f, p = t.onValuesChange, g = t.onFieldsChange, v = t.onFinish, b = t.onFinishFailed, m = t.clearOnDestroy, w = Hn(t, ik), E = y.useRef(null), C = y.useContext(Rf), x = x2(a), _ = de(x, 1), T = _[0], O = T.getInternalHooks(Ao), I = O.useSubscribe, L = O.setInitialValues, B = O.setCallbacks, j = O.setValidateMessages, M = O.setPreserve, q = O.destroyForm;
  y.useImperativeHandle(n, function() {
    return V(V({}, T), {}, {
      nativeElement: E.current
    });
  }), y.useEffect(function() {
    return C.registerForm(r, T), function() {
      C.unregisterForm(r);
    };
  }, [C, T, r]), j(V(V({}, C.validateMessages), d)), B({
    onValuesChange: p,
    onFieldsChange: function(Y) {
      if (C.triggerFormChange(r, Y), g) {
        for (var fe = arguments.length, ge = new Array(fe > 1 ? fe - 1 : 0), ie = 1; ie < fe; ie++)
          ge[ie - 1] = arguments[ie];
        g.apply(void 0, [Y].concat(ge));
      }
    },
    onFinish: function(Y) {
      C.triggerFormFinish(r, Y), v && v(Y);
    },
    onFinishFailed: b
  }), M(s);
  var N = y.useRef(null);
  L(o, !N.current), N.current || (N.current = !0), y.useEffect(
    function() {
      return function() {
        return q(m);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var $, F = typeof l == "function";
  if (F) {
    var H = T.getFieldsValue(!0);
    $ = l(H, T);
  } else
    $ = l;
  I(!F);
  var k = y.useRef();
  y.useEffect(function() {
    QI(k.current || [], i || []) || T.setFields(i || []), k.current = i;
  }, [i, T]);
  var W = y.useMemo(function() {
    return V(V({}, T), {}, {
      validateTrigger: h
    });
  }, [T, h]), G = /* @__PURE__ */ y.createElement(Nl.Provider, {
    value: null
  }, /* @__PURE__ */ y.createElement(ji.Provider, {
    value: W
  }, $));
  return u === !1 ? G : /* @__PURE__ */ y.createElement(u, it({}, w, {
    ref: E,
    onSubmit: function(Y) {
      Y.preventDefault(), Y.stopPropagation(), T.submit();
    },
    onReset: function(Y) {
      var fe;
      Y.preventDefault(), T.resetFields(), (fe = w.onReset) === null || fe === void 0 || fe.call(w, Y);
    }
  }), G);
};
function e0(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var sk = z.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), n = lt(t);
  Et(n.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function lk() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], o = t[1], i = o === void 0 ? {} : o, a = gI(i) ? {
    form: i
  } : i, s = a.form, l = wt(), c = de(l, 2), u = c[0], d = c[1], f = Mt(function() {
    return e0(u);
  }, [u]), h = lt(f);
  h.current = f;
  var p = Bt(ji), g = s || p, v = g && g._init;
  z.env.NODE_ENV !== "production" && Et(t.length === 2 ? s ? v : !0 : v, "useWatch requires a form instance since it can not auto detect from context.");
  var b = jt(r), m = lt(b);
  return m.current = b, sk(b), ut(
    function() {
      if (v) {
        var w = g.getFieldsValue, E = g.getInternalHooks, C = E(Ao), x = C.registerWatch, _ = function(L, B) {
          var j = a.preserve ? B : L;
          return typeof r == "function" ? r(j) : Ir(j, m.current);
        }, T = x(function(I, L) {
          var B = _(I, L), j = e0(B);
          h.current !== j && (h.current = j, d(B));
        }), O = _(w(), w(!0));
        return u !== O && d(O), T;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), u;
}
var ck = /* @__PURE__ */ y.forwardRef(ak), qa = ck;
qa.FormProvider = ok;
qa.Field = E2;
qa.List = ek;
qa.useForm = x2;
qa.useWatch = lk;
const Af = /* @__PURE__ */ y.createContext({});
z.env.NODE_ENV !== "production" && (Af.displayName = "FormItemInputContext");
const uk = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const o = y.useContext(Af), i = y.useMemo(() => {
    const a = Object.assign({}, o);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, o]);
  return /* @__PURE__ */ y.createElement(Af.Provider, {
    value: i
  }, t);
}, Lh = (e) => {
  const {
    space: t,
    form: n,
    children: r
  } = e;
  if (r == null)
    return null;
  let o = r;
  return n && (o = /* @__PURE__ */ ee.createElement(uk, {
    override: !0,
    status: !0
  }, o)), t && (o = /* @__PURE__ */ ee.createElement(jR, null, o)), o;
};
function Fl(e) {
  if (e)
    return {
      closable: e.closable,
      closeIcon: e.closeIcon
    };
}
function t0(e) {
  const {
    closable: t,
    closeIcon: n
  } = e || {};
  return ee.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !t && (t === !1 || n === !1 || n === null)
    )
      return !1;
    if (t === void 0 && n === void 0)
      return null;
    let r = {
      closeIcon: typeof n != "boolean" && n !== null ? n : void 0
    };
    return t && typeof t == "object" && (r = Object.assign(Object.assign({}, r), t)), r;
  }, [t, n]);
}
function n0() {
  const e = {};
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach((o) => {
    o && Object.keys(o).forEach((i) => {
      o[i] !== void 0 && (e[i] = o[i]);
    });
  }), e;
}
const dk = {};
function S2(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : dk;
  const r = t0(e), o = t0(t), i = typeof r != "boolean" ? !!(r != null && r.disabled) : !1, a = ee.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ ee.createElement(Bo, null)
  }, n), [n]), s = ee.useMemo(() => r === !1 ? !1 : r ? n0(a, o, r) : o === !1 ? !1 : o ? n0(a, o) : a.closable ? a : !1, [r, o, a]);
  return ee.useMemo(() => {
    if (s === !1)
      return [!1, null, i];
    const {
      closeIconRender: l
    } = a, {
      closeIcon: c
    } = s;
    let u = c;
    if (u != null) {
      l && (u = l(c));
      const d = Di(s, !0);
      Object.keys(d).length && (u = /* @__PURE__ */ ee.isValidElement(u) ? /* @__PURE__ */ ee.cloneElement(u, d) : /* @__PURE__ */ ee.createElement("span", Object.assign({}, d), u));
    }
    return [!0, u, i];
  }, [s, a]);
}
const fk = () => En() && window.document.documentElement, Ec = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    size: o,
    shape: i
  } = e, a = me({
    [`${t}-lg`]: o === "large",
    [`${t}-sm`]: o === "small"
  }), s = me({
    [`${t}-circle`]: i === "circle",
    [`${t}-square`]: i === "square",
    [`${t}-round`]: i === "round"
  }), l = y.useMemo(() => typeof o == "number" ? {
    width: o,
    height: o,
    lineHeight: `${o}px`
  } : {}, [o]);
  return /* @__PURE__ */ y.createElement("span", {
    className: me(t, a, s, n),
    style: Object.assign(Object.assign({}, l), r)
  });
}, hk = new Tn("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), _c = (e) => ({
  height: e,
  lineHeight: ze(e)
}), _i = (e) => Object.assign({
  width: e
}, _c(e)), pk = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: hk,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), Ku = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, _c(e)), vk = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: n,
    controlHeight: r,
    controlHeightLG: o,
    controlHeightSM: i
  } = e;
  return {
    [t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: n
    }, _i(r)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, _i(o)),
    [`${t}${t}-sm`]: Object.assign({}, _i(i))
  };
}, gk = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: n,
    skeletonInputCls: r,
    controlHeightLG: o,
    controlHeightSM: i,
    gradientFromColor: a,
    calc: s
  } = e;
  return {
    [r]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: n
    }, Ku(t, s)),
    [`${r}-lg`]: Object.assign({}, Ku(o, s)),
    [`${r}-sm`]: Object.assign({}, Ku(i, s))
  };
}, r0 = (e) => Object.assign({
  width: e
}, _c(e)), mk = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: n,
    gradientFromColor: r,
    borderRadiusSM: o,
    calc: i
  } = e;
  return {
    [t]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: r,
      borderRadius: o
    }, r0(i(n).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, r0(n)), {
        maxWidth: i(n).mul(4).equal(),
        maxHeight: i(n).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, Yu = (e, t, n) => {
  const {
    skeletonButtonCls: r
  } = e;
  return {
    [`${n}${r}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${n}${r}-round`]: {
      borderRadius: t
    }
  };
}, Zu = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, _c(e)), yk = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: n,
    controlHeight: r,
    controlHeightLG: o,
    controlHeightSM: i,
    gradientFromColor: a,
    calc: s
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [n]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: t,
      width: s(r).mul(2).equal(),
      minWidth: s(r).mul(2).equal()
    }, Zu(r, s))
  }, Yu(e, r, n)), {
    [`${n}-lg`]: Object.assign({}, Zu(o, s))
  }), Yu(e, o, `${n}-lg`)), {
    [`${n}-sm`]: Object.assign({}, Zu(i, s))
  }), Yu(e, i, `${n}-sm`));
}, bk = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: n,
    skeletonTitleCls: r,
    skeletonParagraphCls: o,
    skeletonButtonCls: i,
    skeletonInputCls: a,
    skeletonImageCls: s,
    controlHeight: l,
    controlHeightLG: c,
    controlHeightSM: u,
    gradientFromColor: d,
    padding: f,
    marginSM: h,
    borderRadius: p,
    titleHeight: g,
    blockRadius: v,
    paragraphLiHeight: b,
    controlHeightXS: m,
    paragraphMarginTop: w
  } = e;
  return {
    [t]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: f,
        verticalAlign: "top",
        // Avatar
        [n]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: d
        }, _i(l)),
        [`${n}-circle`]: {
          borderRadius: "50%"
        },
        [`${n}-lg`]: Object.assign({}, _i(c)),
        [`${n}-sm`]: Object.assign({}, _i(u))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [r]: {
          width: "100%",
          height: g,
          background: d,
          borderRadius: v,
          [`+ ${o}`]: {
            marginBlockStart: u
          }
        },
        // paragraph
        [o]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: b,
            listStyle: "none",
            background: d,
            borderRadius: v,
            "+ li": {
              marginBlockStart: m
            }
          }
        },
        [`${o}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${r}, ${o} > li`]: {
          borderRadius: p
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [r]: {
        marginBlockStart: h,
        [`+ ${o}`]: {
          marginBlockStart: w
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, yk(e)), vk(e)), gk(e)), mk(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [i]: {
        width: "100%"
      },
      [a]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${r},
        ${o} > li,
        ${n},
        ${i},
        ${a},
        ${s}
      `]: Object.assign({}, pk(e))
    }
  };
}, Ck = (e) => {
  const {
    colorFillContent: t,
    colorFill: n
  } = e, r = t, o = n;
  return {
    color: r,
    colorGradientEnd: o,
    gradientFromColor: r,
    gradientToColor: o,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, Wi = qo("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: n
  } = e, r = rr(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: n(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [bk(r)];
}, Ck, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), wk = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: o,
    shape: i = "circle",
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = y.useContext(kt), l = s("skeleton", t), [c, u, d] = Wi(l), f = uc(e, ["prefixCls", "className"]), h = me(l, `${l}-element`, {
    [`${l}-active`]: o
  }, n, r, u, d);
  return c(/* @__PURE__ */ y.createElement("div", {
    className: h
  }, /* @__PURE__ */ y.createElement(Ec, Object.assign({
    prefixCls: `${l}-avatar`,
    shape: i,
    size: a
  }, f))));
}, Ek = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: o,
    block: i = !1,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = y.useContext(kt), l = s("skeleton", t), [c, u, d] = Wi(l), f = uc(e, ["prefixCls"]), h = me(l, `${l}-element`, {
    [`${l}-active`]: o,
    [`${l}-block`]: i
  }, n, r, u, d);
  return c(/* @__PURE__ */ y.createElement("div", {
    className: h
  }, /* @__PURE__ */ y.createElement(Ec, Object.assign({
    prefixCls: `${l}-button`,
    size: a
  }, f))));
}, _k = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", xk = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: o,
    active: i
  } = e, {
    getPrefixCls: a
  } = y.useContext(kt), s = a("skeleton", t), [l, c, u] = Wi(s), d = me(s, `${s}-element`, {
    [`${s}-active`]: i
  }, n, r, c, u);
  return l(/* @__PURE__ */ y.createElement("div", {
    className: d
  }, /* @__PURE__ */ y.createElement("div", {
    className: me(`${s}-image`, n),
    style: o
  }, /* @__PURE__ */ y.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${s}-image-svg`
  }, /* @__PURE__ */ y.createElement("title", null, "Image placeholder"), /* @__PURE__ */ y.createElement("path", {
    d: _k,
    className: `${s}-image-path`
  })))));
}, Sk = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: o,
    block: i,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = y.useContext(kt), l = s("skeleton", t), [c, u, d] = Wi(l), f = uc(e, ["prefixCls"]), h = me(l, `${l}-element`, {
    [`${l}-active`]: o,
    [`${l}-block`]: i
  }, n, r, u, d);
  return c(/* @__PURE__ */ y.createElement("div", {
    className: h
  }, /* @__PURE__ */ y.createElement(Ec, Object.assign({
    prefixCls: `${l}-input`,
    size: a
  }, f))));
}, Tk = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: o,
    active: i,
    children: a
  } = e, {
    getPrefixCls: s
  } = y.useContext(kt), l = s("skeleton", t), [c, u, d] = Wi(l), f = me(l, `${l}-element`, {
    [`${l}-active`]: i
  }, u, n, r, d);
  return c(/* @__PURE__ */ y.createElement("div", {
    className: f
  }, /* @__PURE__ */ y.createElement("div", {
    className: me(`${l}-image`, n),
    style: o
  }, a)));
}, Ok = (e, t) => {
  const {
    width: n,
    rows: r = 2
  } = t;
  if (Array.isArray(n))
    return n[e];
  if (r - 1 === e)
    return n;
}, Pk = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    rows: o
  } = e, i = Pe(new Array(o)).map((a, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ y.createElement("li", {
      key: s,
      style: {
        width: Ok(s, e)
      }
    })
  ));
  return /* @__PURE__ */ y.createElement("ul", {
    className: me(t, n),
    style: r
  }, i);
}, Rk = (e) => {
  let {
    prefixCls: t,
    className: n,
    width: r,
    style: o
  } = e;
  return (
    // biome-ignore lint/a11y/useHeadingContent: HOC here
    /* @__PURE__ */ y.createElement("h3", {
      className: me(t, n),
      style: Object.assign({
        width: r
      }, o)
    })
  );
};
function Qu(e) {
  return e && typeof e == "object" ? e : {};
}
function Ak(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function Ik(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function kk(e, t) {
  const n = {};
  return (!e || !t) && (n.width = "61%"), !e && t ? n.rows = 3 : n.rows = 2, n;
}
const Kr = (e) => {
  const {
    prefixCls: t,
    loading: n,
    className: r,
    rootClassName: o,
    style: i,
    children: a,
    avatar: s = !1,
    title: l = !0,
    paragraph: c = !0,
    active: u,
    round: d
  } = e, {
    getPrefixCls: f,
    direction: h,
    skeleton: p
  } = y.useContext(kt), g = f("skeleton", t), [v, b, m] = Wi(g);
  if (n || !("loading" in e)) {
    const w = !!s, E = !!l, C = !!c;
    let x;
    if (w) {
      const O = Object.assign(Object.assign({
        prefixCls: `${g}-avatar`
      }, Ak(E, C)), Qu(s));
      x = /* @__PURE__ */ y.createElement("div", {
        className: `${g}-header`
      }, /* @__PURE__ */ y.createElement(Ec, Object.assign({}, O)));
    }
    let _;
    if (E || C) {
      let O;
      if (E) {
        const L = Object.assign(Object.assign({
          prefixCls: `${g}-title`
        }, Ik(w, C)), Qu(l));
        O = /* @__PURE__ */ y.createElement(Rk, Object.assign({}, L));
      }
      let I;
      if (C) {
        const L = Object.assign(Object.assign({
          prefixCls: `${g}-paragraph`
        }, kk(w, E)), Qu(c));
        I = /* @__PURE__ */ y.createElement(Pk, Object.assign({}, L));
      }
      _ = /* @__PURE__ */ y.createElement("div", {
        className: `${g}-content`
      }, O, I);
    }
    const T = me(g, {
      [`${g}-with-avatar`]: w,
      [`${g}-active`]: u,
      [`${g}-rtl`]: h === "rtl",
      [`${g}-round`]: d
    }, p == null ? void 0 : p.className, r, o, b, m);
    return v(/* @__PURE__ */ y.createElement("div", {
      className: T,
      style: Object.assign(Object.assign({}, p == null ? void 0 : p.style), i)
    }, x, _));
  }
  return a ?? null;
};
Kr.Button = Ek;
Kr.Avatar = wk;
Kr.Input = Sk;
Kr.Image = xk;
Kr.Node = Tk;
z.env.NODE_ENV !== "production" && (Kr.displayName = "Skeleton");
function o0() {
}
const $k = /* @__PURE__ */ y.createContext({
  add: o0,
  remove: o0
});
function T2(e) {
  const t = y.useContext($k), n = y.useRef(null);
  return Cn((o) => {
    if (o) {
      const i = e ? o.querySelector(e) : o;
      t.add(i), n.current = i;
    } else
      t.remove(n.current);
  });
}
const i0 = () => {
  const {
    cancelButtonProps: e,
    cancelTextLocale: t,
    onCancel: n
  } = Bt(Ua);
  return /* @__PURE__ */ ee.createElement(dr, Object.assign({
    onClick: n
  }, e), t);
}, a0 = () => {
  const {
    confirmLoading: e,
    okButtonProps: t,
    okType: n,
    okTextLocale: r,
    onOk: o
  } = Bt(Ua);
  return /* @__PURE__ */ ee.createElement(dr, Object.assign({}, Jb(n), {
    loading: e,
    onClick: o
  }, t), r);
};
function O2(e, t) {
  return /* @__PURE__ */ ee.createElement("span", {
    className: `${e}-close-x`
  }, t || /* @__PURE__ */ ee.createElement(Bo, {
    className: `${e}-close-icon`
  }));
}
const P2 = (e) => {
  const {
    okText: t,
    okType: n = "primary",
    cancelText: r,
    confirmLoading: o,
    onOk: i,
    onCancel: a,
    okButtonProps: s,
    cancelButtonProps: l,
    footer: c
  } = e, [u] = Oh("Modal", db()), d = t || (u == null ? void 0 : u.okText), f = r || (u == null ? void 0 : u.cancelText), h = {
    confirmLoading: o,
    okButtonProps: s,
    cancelButtonProps: l,
    okTextLocale: d,
    cancelTextLocale: f,
    okType: n,
    onOk: i,
    onCancel: a
  }, p = ee.useMemo(() => h, Pe(Object.values(h)));
  let g;
  return typeof c == "function" || typeof c > "u" ? (g = /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(i0, null), /* @__PURE__ */ ee.createElement(a0, null)), typeof c == "function" && (g = c(g, {
    OkBtn: a0,
    CancelBtn: i0
  })), g = /* @__PURE__ */ ee.createElement(f2, {
    value: p
  }, g)) : g = c, /* @__PURE__ */ ee.createElement(mb, {
    disabled: !1
  }, g);
}, Nk = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      display: "flex",
      flexFlow: "row wrap",
      minWidth: 0,
      "&::before, &::after": {
        display: "flex"
      },
      "&-no-wrap": {
        flexWrap: "nowrap"
      },
      // The origin of the X-axis
      "&-start": {
        justifyContent: "flex-start"
      },
      // The center of the X-axis
      "&-center": {
        justifyContent: "center"
      },
      // The opposite of the X-axis
      "&-end": {
        justifyContent: "flex-end"
      },
      "&-space-between": {
        justifyContent: "space-between"
      },
      "&-space-around": {
        justifyContent: "space-around"
      },
      "&-space-evenly": {
        justifyContent: "space-evenly"
      },
      // Align at the top
      "&-top": {
        alignItems: "flex-start"
      },
      // Align at the center
      "&-middle": {
        alignItems: "center"
      },
      "&-bottom": {
        alignItems: "flex-end"
      }
    }
  };
}, Fk = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // Grid system
    [t]: {
      position: "relative",
      maxWidth: "100%",
      // Prevent columns from collapsing when empty
      minHeight: 1
    }
  };
}, Lk = (e, t) => {
  const {
    prefixCls: n,
    componentCls: r,
    gridColumns: o
  } = e, i = {};
  for (let a = o; a >= 0; a--)
    a === 0 ? (i[`${r}${t}-${a}`] = {
      display: "none"
    }, i[`${r}-push-${a}`] = {
      insetInlineStart: "auto"
    }, i[`${r}-pull-${a}`] = {
      insetInlineEnd: "auto"
    }, i[`${r}${t}-push-${a}`] = {
      insetInlineStart: "auto"
    }, i[`${r}${t}-pull-${a}`] = {
      insetInlineEnd: "auto"
    }, i[`${r}${t}-offset-${a}`] = {
      marginInlineStart: 0
    }, i[`${r}${t}-order-${a}`] = {
      order: 0
    }) : (i[`${r}${t}-${a}`] = [
      // https://github.com/ant-design/ant-design/issues/44456
      // Form set `display: flex` on Col which will override `display: block`.
      // Let's get it from css variable to support override.
      {
        "--ant-display": "block",
        // Fallback to display if variable not support
        display: "block"
      },
      {
        display: "var(--ant-display)",
        flex: `0 0 ${a / o * 100}%`,
        maxWidth: `${a / o * 100}%`
      }
    ], i[`${r}${t}-push-${a}`] = {
      insetInlineStart: `${a / o * 100}%`
    }, i[`${r}${t}-pull-${a}`] = {
      insetInlineEnd: `${a / o * 100}%`
    }, i[`${r}${t}-offset-${a}`] = {
      marginInlineStart: `${a / o * 100}%`
    }, i[`${r}${t}-order-${a}`] = {
      order: a
    });
  return i[`${r}${t}-flex`] = {
    flex: `var(--${n}${t}-flex)`
  }, i;
}, If = (e, t) => Lk(e, t), Mk = (e, t, n) => ({
  [`@media (min-width: ${ze(t)})`]: Object.assign({}, If(e, n))
}), Dk = () => ({}), jk = () => ({});
qo("Grid", Nk, Dk);
const R2 = (e) => ({
  xs: e.screenXSMin,
  sm: e.screenSMMin,
  md: e.screenMDMin,
  lg: e.screenLGMin,
  xl: e.screenXLMin,
  xxl: e.screenXXLMin
});
qo("Grid", (e) => {
  const t = rr(e, {
    gridColumns: 24
    // Row is divided into 24 parts in Grid
  }), n = R2(t);
  return delete n.xs, [Fk(t), If(t, ""), If(t, "-xs"), Object.keys(n).map((r) => Mk(t, n[r], `-${r}`)).reduce((r, o) => Object.assign(Object.assign({}, r), o), {})];
}, jk);
function s0(e) {
  return {
    position: e,
    inset: 0
  };
}
const Bk = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return [{
    [`${t}-root`]: {
      [`${t}${n}-zoom-enter, ${t}${n}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: e.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${t}${n}-zoom-leave ${t}-content`]: {
        pointerEvents: "none"
      },
      [`${t}-mask`]: Object.assign(Object.assign({}, s0("fixed")), {
        zIndex: e.zIndexPopupBase,
        height: "100%",
        backgroundColor: e.colorBgMask,
        pointerEvents: "none",
        [`${t}-hidden`]: {
          display: "none"
        }
      }),
      [`${t}-wrap`]: Object.assign(Object.assign({}, s0("fixed")), {
        zIndex: e.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch"
      })
    }
  }, {
    [`${t}-root`]: hA(e)
  }];
}, Vk = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    // ======================== Root =========================
    {
      [`${t}-root`]: {
        [`${t}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${t}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [t]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${e.screenSMMax}px)`]: {
          [t]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${ze(e.marginXS)} auto`
          },
          [`${t}-centered`]: {
            [t]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [t]: Object.assign(Object.assign({}, Sb(e)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${ze(e.calc(e.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: e.paddingLG,
        [`${t}-title`]: {
          margin: 0,
          color: e.titleColor,
          fontWeight: e.fontWeightStrong,
          fontSize: e.titleFontSize,
          lineHeight: e.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${t}-content`]: {
          position: "relative",
          backgroundColor: e.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: e.borderRadiusLG,
          boxShadow: e.boxShadow,
          pointerEvents: "auto",
          padding: e.contentPadding
        },
        [`${t}-close`]: Object.assign({
          position: "absolute",
          top: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: e.calc(e.modalHeaderHeight).sub(e.modalCloseBtnSize).div(2).equal(),
          zIndex: e.calc(e.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: e.modalCloseIconColor,
          fontWeight: e.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: e.borderRadiusSM,
          width: e.modalCloseBtnSize,
          height: e.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${e.motionDurationMid}, background-color ${e.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: e.fontSizeLG,
            fontStyle: "normal",
            lineHeight: ze(e.modalCloseBtnSize),
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:disabled": {
            pointerEvents: "none"
          },
          "&:hover": {
            color: e.modalCloseIconHoverColor,
            backgroundColor: e.colorBgTextHover,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: e.colorBgTextActive
          }
        }, Ph(e)),
        [`${t}-header`]: {
          color: e.colorText,
          background: e.headerBg,
          borderRadius: `${ze(e.borderRadiusLG)} ${ze(e.borderRadiusLG)} 0 0`,
          marginBottom: e.headerMarginBottom,
          padding: e.headerPadding,
          borderBottom: e.headerBorderBottom
        },
        [`${t}-body`]: {
          fontSize: e.fontSize,
          lineHeight: e.lineHeight,
          wordWrap: "break-word",
          padding: e.bodyPadding,
          [`${t}-body-skeleton`]: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: `${ze(e.margin)} auto`
          }
        },
        [`${t}-footer`]: {
          textAlign: "end",
          background: e.footerBg,
          marginTop: e.footerMarginTop,
          padding: e.footerPadding,
          borderTop: e.footerBorderTop,
          borderRadius: e.footerBorderRadius,
          [`> ${e.antCls}-btn + ${e.antCls}-btn`]: {
            marginInlineStart: e.marginXS
          }
        },
        [`${t}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${t}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${t}-content,
          ${t}-body,
          ${t}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${t}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
}, Uk = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-root`]: {
      [`${t}-wrap-rtl`]: {
        direction: "rtl",
        [`${t}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
}, Hk = (e) => {
  const {
    componentCls: t
  } = e, n = R2(e);
  delete n.xs;
  const r = Object.keys(n).map((o) => ({
    [`@media (min-width: ${ze(n[o])})`]: {
      width: `var(--${t.replace(".", "")}-${o}-width)`
    }
  }));
  return {
    [`${t}-root`]: {
      [t]: [{
        width: `var(--${t.replace(".", "")}-xs-width)`
      }].concat(Pe(r))
    }
  };
}, A2 = (e) => {
  const t = e.padding, n = e.fontSizeHeading5, r = e.lineHeightHeading5;
  return rr(e, {
    modalHeaderHeight: e.calc(e.calc(r).mul(n).equal()).add(e.calc(t).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: e.colorSplit,
    modalFooterBorderStyle: e.lineType,
    modalFooterBorderWidth: e.lineWidth,
    modalCloseIconColor: e.colorIcon,
    modalCloseIconHoverColor: e.colorIconHover,
    modalCloseBtnSize: e.controlHeight,
    modalConfirmIconSize: e.fontHeight,
    modalTitleHeight: e.calc(e.titleFontSize).mul(e.titleLineHeight).equal()
  });
}, I2 = (e) => ({
  footerBg: "transparent",
  headerBg: e.colorBgElevated,
  titleLineHeight: e.lineHeightHeading5,
  titleFontSize: e.fontSizeHeading5,
  contentBg: e.colorBgElevated,
  titleColor: e.colorTextHeading,
  // internal
  contentPadding: e.wireframe ? 0 : `${ze(e.paddingMD)} ${ze(e.paddingContentHorizontalLG)}`,
  headerPadding: e.wireframe ? `${ze(e.padding)} ${ze(e.paddingLG)}` : 0,
  headerBorderBottom: e.wireframe ? `${ze(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  headerMarginBottom: e.wireframe ? 0 : e.marginXS,
  bodyPadding: e.wireframe ? e.paddingLG : 0,
  footerPadding: e.wireframe ? `${ze(e.paddingXS)} ${ze(e.padding)}` : 0,
  footerBorderTop: e.wireframe ? `${ze(e.lineWidth)} ${e.lineType} ${e.colorSplit}` : "none",
  footerBorderRadius: e.wireframe ? `0 0 ${ze(e.borderRadiusLG)} ${ze(e.borderRadiusLG)}` : 0,
  footerMarginTop: e.wireframe ? 0 : e.marginSM,
  confirmBodyPadding: e.wireframe ? `${ze(e.padding * 2)} ${ze(e.padding * 2)} ${ze(e.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: e.wireframe ? e.margin : e.marginSM,
  confirmBtnsMarginTop: e.wireframe ? e.marginLG : e.marginSM
}), k2 = qo("Modal", (e) => {
  const t = A2(e);
  return [Vk(t), Uk(t), Bk(t), s2(t, "zoom"), Hk(t)];
}, I2, {
  unitless: {
    titleLineHeight: !0
  }
});
var zk = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let kf;
const qk = (e) => {
  kf = {
    x: e.pageX,
    y: e.pageY
  }, setTimeout(() => {
    kf = null;
  }, 100);
};
fk() && document.documentElement.addEventListener("click", qk, !0);
const $2 = (e) => {
  var t;
  const {
    getPopupContainer: n,
    getPrefixCls: r,
    direction: o,
    modal: i
  } = y.useContext(kt), a = (ge) => {
    const {
      onCancel: ie
    } = e;
    ie == null || ie(ge);
  }, s = (ge) => {
    const {
      onOk: ie
    } = e;
    ie == null || ie(ge);
  };
  if (z.env.NODE_ENV !== "production") {
    const ge = nr("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((ie) => {
      let [he, ue] = ie;
      ge.deprecated(!(he in e), he, ue);
    });
  }
  const {
    prefixCls: l,
    className: c,
    rootClassName: u,
    open: d,
    wrapClassName: f,
    centered: h,
    getContainer: p,
    focusTriggerAfterClose: g = !0,
    style: v,
    // Deprecated
    visible: b,
    width: m = 520,
    footer: w,
    classNames: E,
    styles: C,
    children: x,
    loading: _
  } = e, T = zk(e, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles", "children", "loading"]), O = r("modal", l), I = r(), L = zb(O), [B, j, M] = k2(O, L), q = me(f, {
    [`${O}-centered`]: !!h,
    [`${O}-wrap-rtl`]: o === "rtl"
  }), N = w !== null && !_ ? /* @__PURE__ */ y.createElement(P2, Object.assign({}, e, {
    onOk: s,
    onCancel: a
  })) : null, [$, F, H] = S2(Fl(e), Fl(i), {
    closable: !0,
    closeIcon: /* @__PURE__ */ y.createElement(Bo, {
      className: `${O}-close-icon`
    }),
    closeIconRender: (ge) => O2(O, ge)
  }), k = T2(`.${O}-content`), [W, G] = Ih("Modal", T.zIndex), [ne, Y] = y.useMemo(() => m && typeof m == "object" ? [void 0, m] : [m, void 0], [m]), fe = y.useMemo(() => {
    const ge = {};
    return Y && Object.keys(Y).forEach((ie) => {
      const he = Y[ie];
      he !== void 0 && (ge[`--${O}-${ie}-width`] = typeof he == "number" ? `${he}px` : he);
    }), ge;
  }, [Y]);
  return B(/* @__PURE__ */ y.createElement(Lh, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ y.createElement(Ba.Provider, {
    value: G
  }, /* @__PURE__ */ y.createElement(m2, Object.assign({
    width: ne
  }, T, {
    zIndex: W,
    getContainer: p === void 0 ? n : p,
    prefixCls: O,
    rootClassName: me(j, u, M, L),
    footer: N,
    visible: d ?? b,
    mousePosition: (t = T.mousePosition) !== null && t !== void 0 ? t : kf,
    onClose: a,
    closable: $ && {
      disabled: H,
      closeIcon: F
    },
    closeIcon: F,
    focusTriggerAfterClose: g,
    transitionName: Uo(I, "zoom", e.transitionName),
    maskTransitionName: Uo(I, "fade", e.maskTransitionName),
    className: me(j, c, i == null ? void 0 : i.className),
    style: Object.assign(Object.assign(Object.assign({}, i == null ? void 0 : i.style), v), fe),
    classNames: Object.assign(Object.assign(Object.assign({}, i == null ? void 0 : i.classNames), E), {
      wrapper: me(q, E == null ? void 0 : E.wrapper)
    }),
    styles: Object.assign(Object.assign({}, i == null ? void 0 : i.styles), C),
    panelRef: k
  }), _ ? /* @__PURE__ */ y.createElement(Kr, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 4
    },
    className: `${O}-body-skeleton`
  }) : x))));
}, Wk = (e) => {
  const {
    componentCls: t,
    titleFontSize: n,
    titleLineHeight: r,
    modalConfirmIconSize: o,
    fontSize: i,
    lineHeight: a,
    modalTitleHeight: s,
    fontHeight: l,
    confirmBodyPadding: c
  } = e, u = `${t}-confirm`;
  return {
    [u]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${e.antCls}-modal-header`]: {
        display: "none"
      },
      [`${u}-body-wrapper`]: Object.assign({}, wP()),
      [`&${t} ${t}-body`]: {
        padding: c
      },
      // ====================== Body ======================
      [`${u}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${e.iconCls}`]: {
          flex: "none",
          fontSize: o,
          marginInlineEnd: e.confirmIconMarginInlineEnd,
          marginTop: e.calc(e.calc(l).sub(o).equal()).div(2).equal()
        },
        [`&-has-title > ${e.iconCls}`]: {
          marginTop: e.calc(e.calc(s).sub(o).equal()).div(2).equal()
        }
      },
      [`${u}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: e.marginXS,
        // https://github.com/ant-design/ant-design/issues/51912
        maxWidth: `calc(100% - ${ze(e.marginSM)})`
      },
      // https://github.com/ant-design/ant-design/issues/48159
      [`${e.iconCls} + ${u}-paragraph`]: {
        maxWidth: `calc(100% - ${ze(e.calc(e.modalConfirmIconSize).add(e.marginSM).equal())})`
      },
      [`${u}-title`]: {
        color: e.colorTextHeading,
        fontWeight: e.fontWeightStrong,
        fontSize: n,
        lineHeight: r
      },
      [`${u}-content`]: {
        color: e.colorText,
        fontSize: i,
        lineHeight: a
      },
      // ===================== Footer =====================
      [`${u}-btns`]: {
        textAlign: "end",
        marginTop: e.confirmBtnsMarginTop,
        [`${e.antCls}-btn + ${e.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: e.marginXS
        }
      }
    },
    [`${u}-error ${u}-body > ${e.iconCls}`]: {
      color: e.colorError
    },
    [`${u}-warning ${u}-body > ${e.iconCls},
        ${u}-confirm ${u}-body > ${e.iconCls}`]: {
      color: e.colorWarning
    },
    [`${u}-info ${u}-body > ${e.iconCls}`]: {
      color: e.colorInfo
    },
    [`${u}-success ${u}-body > ${e.iconCls}`]: {
      color: e.colorSuccess
    }
  };
}, Gk = Pb(["Modal", "confirm"], (e) => {
  const t = A2(e);
  return [Wk(t)];
}, I2, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});
var Kk = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function N2(e) {
  const {
    prefixCls: t,
    icon: n,
    okText: r,
    cancelText: o,
    confirmPrefixCls: i,
    type: a,
    okCancel: s,
    footer: l,
    // Legacy for static function usage
    locale: c
  } = e, u = Kk(e, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (z.env.NODE_ENV !== "production") {
    const _ = nr("Modal");
    z.env.NODE_ENV !== "production" && _(!(typeof n == "string" && n.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${n}\` at https://ant.design/components/icon`);
  }
  let d = n;
  if (!n && n !== null)
    switch (a) {
      case "info":
        d = /* @__PURE__ */ y.createElement(Py, null);
        break;
      case "success":
        d = /* @__PURE__ */ y.createElement(Sy, null);
        break;
      case "error":
        d = /* @__PURE__ */ y.createElement(Ty, null);
        break;
      default:
        d = /* @__PURE__ */ y.createElement(Oy, null);
    }
  const f = s ?? a === "confirm", h = e.autoFocusButton === null ? !1 : e.autoFocusButton || "ok", [p] = Oh("Modal"), g = c || p, v = r || (f ? g == null ? void 0 : g.okText : g == null ? void 0 : g.justOkText), b = o || (g == null ? void 0 : g.cancelText), m = Object.assign({
    autoFocusButton: h,
    cancelTextLocale: b,
    okTextLocale: v,
    mergedOkCancel: f
  }, u), w = y.useMemo(() => m, Pe(Object.values(m))), E = /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(Lg, null), /* @__PURE__ */ y.createElement(Mg, null)), C = e.title !== void 0 && e.title !== null, x = `${i}-body`;
  return /* @__PURE__ */ y.createElement("div", {
    className: `${i}-body-wrapper`
  }, /* @__PURE__ */ y.createElement("div", {
    className: me(x, {
      [`${x}-has-title`]: C
    })
  }, d, /* @__PURE__ */ y.createElement("div", {
    className: `${i}-paragraph`
  }, C && /* @__PURE__ */ y.createElement("span", {
    className: `${i}-title`
  }, e.title), /* @__PURE__ */ y.createElement("div", {
    className: `${i}-content`
  }, e.content))), l === void 0 || typeof l == "function" ? /* @__PURE__ */ y.createElement(f2, {
    value: w
  }, /* @__PURE__ */ y.createElement("div", {
    className: `${i}-btns`
  }, typeof l == "function" ? l(E, {
    OkBtn: Mg,
    CancelBtn: Lg
  }) : E)) : l, /* @__PURE__ */ y.createElement(Gk, {
    prefixCls: t
  }));
}
const F2 = (e) => {
  const {
    close: t,
    zIndex: n,
    maskStyle: r,
    direction: o,
    prefixCls: i,
    wrapClassName: a,
    rootPrefixCls: s,
    bodyStyle: l,
    closable: c = !1,
    onConfirm: u,
    styles: d
  } = e;
  if (z.env.NODE_ENV !== "production") {
    const E = nr("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((C) => {
      let [x, _] = C;
      E.deprecated(!(x in e), x, _);
    });
  }
  const f = `${i}-confirm`, h = e.width || 416, p = e.style || {}, g = e.mask === void 0 ? !0 : e.mask, v = e.maskClosable === void 0 ? !1 : e.maskClosable, b = me(f, `${f}-${e.type}`, {
    [`${f}-rtl`]: o === "rtl"
  }, e.className), [, m] = Gr(), w = y.useMemo(() => n !== void 0 ? n : m.zIndexPopupBase + qb, [n, m]);
  return /* @__PURE__ */ y.createElement($2, Object.assign({}, e, {
    className: b,
    wrapClassName: me({
      [`${f}-centered`]: !!e.centered
    }, a),
    onCancel: () => {
      t == null || t({
        triggerCancel: !0
      }), u == null || u(!1);
    },
    title: "",
    footer: null,
    transitionName: Uo(s || "", "zoom", e.transitionName),
    maskTransitionName: Uo(s || "", "fade", e.maskTransitionName),
    mask: g,
    maskClosable: v,
    style: p,
    styles: Object.assign({
      body: l,
      mask: r
    }, d),
    width: h,
    zIndex: w,
    closable: c
  }), /* @__PURE__ */ y.createElement(N2, Object.assign({}, e, {
    confirmPrefixCls: f
  })));
}, Mh = (e) => {
  const {
    rootPrefixCls: t,
    iconPrefixCls: n,
    direction: r,
    theme: o
  } = e;
  return /* @__PURE__ */ y.createElement(br, {
    prefixCls: t,
    iconPrefixCls: n,
    direction: r,
    theme: o
  }, /* @__PURE__ */ y.createElement(F2, Object.assign({}, e)));
};
z.env.NODE_ENV !== "production" && (F2.displayName = "ConfirmDialog", Mh.displayName = "ConfirmDialogWrapper");
const Io = [];
let L2 = "";
function M2() {
  return L2;
}
const Yk = (e) => {
  var t, n;
  const {
    prefixCls: r,
    getContainer: o,
    direction: i
  } = e, a = db(), s = Bt(kt), l = M2() || s.getPrefixCls(), c = r || `${l}-modal`;
  let u = o;
  return u === !1 && (u = void 0, z.env.NODE_ENV !== "production" && z.env.NODE_ENV !== "production" && Wr(!1, "Modal", "Static method not support `getContainer` to be `false` since it do not have context env.")), /* @__PURE__ */ ee.createElement(Mh, Object.assign({}, e, {
    rootPrefixCls: l,
    prefixCls: c,
    iconPrefixCls: s.iconPrefixCls,
    theme: s.theme,
    direction: i ?? s.direction,
    locale: (n = (t = s.locale) === null || t === void 0 ? void 0 : t.Modal) !== null && n !== void 0 ? n : a,
    getContainer: u
  }));
};
function Wa(e) {
  const t = sR();
  z.env.NODE_ENV !== "production" && !t.holderRender && nR("Modal");
  const n = document.createDocumentFragment();
  let r = Object.assign(Object.assign({}, e), {
    close: l,
    open: !0
  }), o, i;
  function a() {
    for (var u, d = arguments.length, f = new Array(d), h = 0; h < d; h++)
      f[h] = arguments[h];
    if (f.some((v) => v == null ? void 0 : v.triggerCancel)) {
      var g;
      (u = e.onCancel) === null || u === void 0 || (g = u).call.apply(g, [e, () => {
      }].concat(Pe(f.slice(1))));
    }
    for (let v = 0; v < Io.length; v++)
      if (Io[v] === l) {
        Io.splice(v, 1);
        break;
      }
    i();
  }
  function s(u) {
    clearTimeout(o), o = setTimeout(() => {
      const d = t.getPrefixCls(void 0, M2()), f = t.getIconPrefixCls(), h = t.getTheme(), p = /* @__PURE__ */ ee.createElement(Yk, Object.assign({}, u));
      i = Gb()(/* @__PURE__ */ ee.createElement(br, {
        prefixCls: d,
        iconPrefixCls: f,
        theme: h
      }, t.holderRender ? t.holderRender(p) : p), n);
    });
  }
  function l() {
    for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
      d[f] = arguments[f];
    r = Object.assign(Object.assign({}, r), {
      open: !1,
      afterClose: () => {
        typeof e.afterClose == "function" && e.afterClose(), a.apply(this, d);
      }
    }), r.visible && delete r.visible, s(r);
  }
  function c(u) {
    typeof u == "function" ? r = u(r) : r = Object.assign(Object.assign({}, r), u), s(r);
  }
  return s(r), Io.push(l), {
    destroy: l,
    update: c
  };
}
function D2(e) {
  return Object.assign(Object.assign({}, e), {
    type: "warning"
  });
}
function j2(e) {
  return Object.assign(Object.assign({}, e), {
    type: "info"
  });
}
function B2(e) {
  return Object.assign(Object.assign({}, e), {
    type: "success"
  });
}
function V2(e) {
  return Object.assign(Object.assign({}, e), {
    type: "error"
  });
}
function U2(e) {
  return Object.assign(Object.assign({}, e), {
    type: "confirm"
  });
}
function Zk(e) {
  let {
    rootPrefixCls: t
  } = e;
  z.env.NODE_ENV !== "production" && Wr(!1, "Modal", "Modal.config is deprecated. Please use ConfigProvider.config instead."), L2 = t;
}
var Qk = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Xk = (e, t) => {
  var n, {
    afterClose: r,
    config: o
  } = e, i = Qk(e, ["afterClose", "config"]);
  const [a, s] = y.useState(!0), [l, c] = y.useState(o), {
    direction: u,
    getPrefixCls: d
  } = y.useContext(kt), f = d("modal"), h = d(), p = () => {
    var m;
    r(), (m = l.afterClose) === null || m === void 0 || m.call(l);
  }, g = function() {
    var m;
    s(!1);
    for (var w = arguments.length, E = new Array(w), C = 0; C < w; C++)
      E[C] = arguments[C];
    if (E.some((T) => T == null ? void 0 : T.triggerCancel)) {
      var _;
      (m = l.onCancel) === null || m === void 0 || (_ = m).call.apply(_, [l, () => {
      }].concat(Pe(E.slice(1))));
    }
  };
  y.useImperativeHandle(t, () => ({
    destroy: g,
    update: (m) => {
      c((w) => Object.assign(Object.assign({}, w), m));
    }
  }));
  const v = (n = l.okCancel) !== null && n !== void 0 ? n : l.type === "confirm", [b] = Oh("Modal", Vo.Modal);
  return /* @__PURE__ */ y.createElement(Mh, Object.assign({
    prefixCls: f,
    rootPrefixCls: h
  }, l, {
    close: g,
    open: a,
    afterClose: p,
    okText: l.okText || (v ? b == null ? void 0 : b.okText : b == null ? void 0 : b.justOkText),
    direction: l.direction || u,
    cancelText: l.cancelText || (b == null ? void 0 : b.cancelText)
  }, i));
}, Jk = /* @__PURE__ */ y.forwardRef(Xk);
let l0 = 0;
const e$ = /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef((e, t) => {
  const [n, r] = bR();
  return y.useImperativeHandle(t, () => ({
    patchElement: r
  }), []), /* @__PURE__ */ y.createElement(y.Fragment, null, n);
}));
function t$() {
  const e = y.useRef(null), [t, n] = y.useState([]);
  y.useEffect(() => {
    t.length && (Pe(t).forEach((a) => {
      a();
    }), n([]));
  }, [t]);
  const r = y.useCallback((i) => function(s) {
    var l;
    l0 += 1;
    const c = /* @__PURE__ */ y.createRef();
    let u;
    const d = new Promise((v) => {
      u = v;
    });
    let f = !1, h;
    const p = /* @__PURE__ */ y.createElement(Jk, {
      key: `modal-${l0}`,
      config: i(s),
      ref: c,
      afterClose: () => {
        h == null || h();
      },
      isSilent: () => f,
      onConfirm: (v) => {
        u(v);
      }
    });
    return h = (l = e.current) === null || l === void 0 ? void 0 : l.patchElement(p), h && Io.push(h), {
      destroy: () => {
        function v() {
          var b;
          (b = c.current) === null || b === void 0 || b.destroy();
        }
        c.current ? v() : n((b) => [].concat(Pe(b), [v]));
      },
      update: (v) => {
        function b() {
          var m;
          (m = c.current) === null || m === void 0 || m.update(v);
        }
        c.current ? b() : n((m) => [].concat(Pe(m), [b]));
      },
      then: (v) => (f = !0, d.then(v))
    };
  }, []);
  return [y.useMemo(() => ({
    info: r(j2),
    success: r(B2),
    error: r(V2),
    warning: r(D2),
    confirm: r(U2)
  }), []), /* @__PURE__ */ y.createElement(e$, {
    key: "modal-holder",
    ref: e
  })];
}
function n$(e) {
  return (t) => /* @__PURE__ */ y.createElement(br, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ y.createElement(e, Object.assign({}, t)));
}
const r$ = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
function o$(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, o = e.arrowPos, i = r || {}, a = i.className, s = i.content, l = o.x, c = l === void 0 ? 0 : l, u = o.y, d = u === void 0 ? 0 : u, f = y.useRef();
  if (!n || !n.points)
    return null;
  var h = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var p = n.points[0], g = n.points[1], v = p[0], b = p[1], m = g[0], w = g[1];
    v === m || !["t", "b"].includes(v) ? h.top = d : v === "t" ? h.top = 0 : h.bottom = 0, b === w || !["l", "r"].includes(b) ? h.left = c : b === "l" ? h.left = 0 : h.right = 0;
  }
  return /* @__PURE__ */ y.createElement("div", {
    ref: f,
    className: me("".concat(t, "-arrow"), a),
    style: h
  }, s);
}
function i$(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, o = e.mask, i = e.motion;
  return o ? /* @__PURE__ */ y.createElement(Hr, it({}, i, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ y.createElement("div", {
      style: {
        zIndex: r
      },
      className: me("".concat(t, "-mask"), s)
    });
  }) : null;
}
var H2 = /* @__PURE__ */ y.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
z.env.NODE_ENV !== "production" && (H2.displayName = "PopupContent");
var z2 = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, o = e.prefixCls, i = e.style, a = e.target, s = e.onVisibleChanged, l = e.open, c = e.keepDom, u = e.fresh, d = e.onClick, f = e.mask, h = e.arrow, p = e.arrowPos, g = e.align, v = e.motion, b = e.maskMotion, m = e.forceRender, w = e.getPopupContainer, E = e.autoDestroy, C = e.portal, x = e.zIndex, _ = e.onMouseEnter, T = e.onMouseLeave, O = e.onPointerEnter, I = e.onPointerDownCapture, L = e.ready, B = e.offsetX, j = e.offsetY, M = e.offsetR, q = e.offsetB, N = e.onAlign, $ = e.onPrepare, F = e.stretch, H = e.targetWidth, k = e.targetHeight, W = typeof n == "function" ? n() : n, G = l || c, ne = (w == null ? void 0 : w.length) > 0, Y = y.useState(!w || !ne), fe = de(Y, 2), ge = fe[0], ie = fe[1];
  if (vn(function() {
    !ge && ne && a && ie(!0);
  }, [ge, ne, a]), !ge)
    return null;
  var he = "auto", ue = {
    left: "-1000vw",
    top: "-1000vh",
    right: he,
    bottom: he
  };
  if (L || !l) {
    var ce, Se = g.points, te = g.dynamicInset || ((ce = g._experimental) === null || ce === void 0 ? void 0 : ce.dynamicInset), ke = te && Se[0][1] === "r", se = te && Se[0][0] === "b";
    ke ? (ue.right = M, ue.left = he) : (ue.left = B, ue.right = he), se ? (ue.bottom = q, ue.top = he) : (ue.top = j, ue.bottom = he);
  }
  var D = {};
  return F && (F.includes("height") && k ? D.height = k : F.includes("minHeight") && k && (D.minHeight = k), F.includes("width") && H ? D.width = H : F.includes("minWidth") && H && (D.minWidth = H)), l || (D.pointerEvents = "none"), /* @__PURE__ */ y.createElement(C, {
    open: m || G,
    getContainer: w && function() {
      return w(a);
    },
    autoDestroy: E
  }, /* @__PURE__ */ y.createElement(i$, {
    prefixCls: o,
    open: l,
    zIndex: x,
    mask: f,
    motion: b
  }), /* @__PURE__ */ y.createElement(cc, {
    onResize: N,
    disabled: !l
  }, function(X) {
    return /* @__PURE__ */ y.createElement(Hr, it({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: m,
      leavedClassName: "".concat(o, "-hidden")
    }, v, {
      onAppearPrepare: $,
      onEnterPrepare: $,
      visible: l,
      onVisibleChanged: function(_e) {
        var Ce;
        v == null || (Ce = v.onVisibleChanged) === null || Ce === void 0 || Ce.call(v, _e), s(_e);
      }
    }), function(Q, _e) {
      var Ce = Q.className, Ne = Q.style, ae = me(o, Ce, r);
      return /* @__PURE__ */ y.createElement("div", {
        ref: ac(X, t, _e),
        className: ae,
        style: V(V(V(V({
          "--arrow-x": "".concat(p.x || 0, "px"),
          "--arrow-y": "".concat(p.y || 0, "px")
        }, ue), D), Ne), {}, {
          boxSizing: "border-box",
          zIndex: x
        }, i),
        onMouseEnter: _,
        onMouseLeave: T,
        onPointerEnter: O,
        onClick: d,
        onPointerDownCapture: I
      }, h && /* @__PURE__ */ y.createElement(o$, {
        prefixCls: o,
        arrow: h,
        arrowPos: p,
        align: g
      }), /* @__PURE__ */ y.createElement(H2, {
        cache: !l && !u
      }, W));
    });
  }));
});
z.env.NODE_ENV !== "production" && (z2.displayName = "Popup");
var q2 = /* @__PURE__ */ y.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, o = ja(n), i = y.useCallback(function(s) {
    Ch(t, r ? r(s) : s);
  }, [r]), a = zi(i, sc(n));
  return o ? /* @__PURE__ */ y.cloneElement(n, {
    ref: a
  }) : n;
});
z.env.NODE_ENV !== "production" && (q2.displayName = "TriggerWrapper");
var c0 = /* @__PURE__ */ y.createContext(null);
function u0(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function a$(e, t, n, r) {
  return y.useMemo(function() {
    var o = u0(n ?? t), i = u0(r ?? t), a = new Set(o), s = new Set(i);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
function s$() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function l$(e, t, n, r) {
  for (var o = n.points, i = Object.keys(e), a = 0; a < i.length; a += 1) {
    var s, l = i[a];
    if (s$((s = e[l]) === null || s === void 0 ? void 0 : s.points, o, r))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function d0(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function Ga(e) {
  return e.ownerDocument.defaultView;
}
function $f(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var o = Ga(n).getComputedStyle(n), i = o.overflowX, a = o.overflowY, s = o.overflow;
    [i, a, s].some(function(l) {
      return r.includes(l);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function Ia(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function la(e) {
  return Ia(parseFloat(e), 0);
}
function f0(e, t) {
  var n = V({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var o = Ga(r).getComputedStyle(r), i = o.overflow, a = o.overflowClipMargin, s = o.borderTopWidth, l = o.borderBottomWidth, c = o.borderLeftWidth, u = o.borderRightWidth, d = r.getBoundingClientRect(), f = r.offsetHeight, h = r.clientHeight, p = r.offsetWidth, g = r.clientWidth, v = la(s), b = la(l), m = la(c), w = la(u), E = Ia(Math.round(d.width / p * 1e3) / 1e3), C = Ia(Math.round(d.height / f * 1e3) / 1e3), x = (p - g - m - w) * E, _ = (f - h - v - b) * C, T = v * C, O = b * C, I = m * E, L = w * E, B = 0, j = 0;
      if (i === "clip") {
        var M = la(a);
        B = M * E, j = M * C;
      }
      var q = d.x + I - B, N = d.y + T - j, $ = q + d.width + 2 * B - I - L - x, F = N + d.height + 2 * j - T - O - _;
      n.left = Math.max(n.left, q), n.top = Math.max(n.top, N), n.right = Math.min(n.right, $), n.bottom = Math.min(n.bottom, F);
    }
  }), n;
}
function h0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function p0(e, t) {
  var n = t || [], r = de(n, 2), o = r[0], i = r[1];
  return [h0(e.width, o), h0(e.height, i)];
}
function v0() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function ai(e, t) {
  var n = t[0], r = t[1], o, i;
  return n === "t" ? i = e.y : n === "b" ? i = e.y + e.height : i = e.y + e.height / 2, r === "l" ? o = e.x : r === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: i
  };
}
function Xr(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, o) {
    return o === t ? n[r] || "c" : r;
  }).join("");
}
function c$(e, t, n, r, o, i, a) {
  var s = y.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[r] || {}
  }), l = de(s, 2), c = l[0], u = l[1], d = y.useRef(0), f = y.useMemo(function() {
    return t ? $f(t) : [];
  }, [t]), h = y.useRef({}), p = function() {
    h.current = {};
  };
  e || p();
  var g = Cn(function() {
    if (t && n && e) {
      let Wn = function(Xo, Zr) {
        var Qr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : mt, Qi = Y.x + Xo, rs = Y.y + Zr, Hc = Qi + ke, zc = rs + te, qc = Math.max(Qi, Qr.left), Te = Math.max(rs, Qr.top), Me = Math.min(Hc, Qr.right), At = Math.min(zc, Qr.bottom);
        return Math.max(0, (Me - qc) * (At - Te));
      }, ns = function() {
        He = Y.y + rt, Ze = He + te, je = Y.x + ot, Be = je + ke;
      };
      var m, w, E, C, x = t, _ = x.ownerDocument, T = Ga(x), O = T.getComputedStyle(x), I = O.width, L = O.height, B = O.position, j = x.style.left, M = x.style.top, q = x.style.right, N = x.style.bottom, $ = x.style.overflow, F = V(V({}, o[r]), i), H = _.createElement("div");
      (m = x.parentElement) === null || m === void 0 || m.appendChild(H), H.style.left = "".concat(x.offsetLeft, "px"), H.style.top = "".concat(x.offsetTop, "px"), H.style.position = B, H.style.height = "".concat(x.offsetHeight, "px"), H.style.width = "".concat(x.offsetWidth, "px"), x.style.left = "0", x.style.top = "0", x.style.right = "auto", x.style.bottom = "auto", x.style.overflow = "hidden";
      var k;
      if (Array.isArray(n))
        k = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var W, G, ne = n.getBoundingClientRect();
        ne.x = (W = ne.x) !== null && W !== void 0 ? W : ne.left, ne.y = (G = ne.y) !== null && G !== void 0 ? G : ne.top, k = {
          x: ne.x,
          y: ne.y,
          width: ne.width,
          height: ne.height
        };
      }
      var Y = x.getBoundingClientRect();
      Y.x = (w = Y.x) !== null && w !== void 0 ? w : Y.left, Y.y = (E = Y.y) !== null && E !== void 0 ? E : Y.top;
      var fe = _.documentElement, ge = fe.clientWidth, ie = fe.clientHeight, he = fe.scrollWidth, ue = fe.scrollHeight, ce = fe.scrollTop, Se = fe.scrollLeft, te = Y.height, ke = Y.width, se = k.height, D = k.width, X = {
        left: 0,
        top: 0,
        right: ge,
        bottom: ie
      }, Q = {
        left: -Se,
        top: -ce,
        right: he - Se,
        bottom: ue - ce
      }, _e = F.htmlRegion, Ce = "visible", Ne = "visibleFirst";
      _e !== "scroll" && _e !== Ne && (_e = Ce);
      var ae = _e === Ne, xe = f0(Q, f), Re = f0(X, f), mt = _e === Ce ? Re : xe, et = ae ? Re : mt;
      x.style.left = "auto", x.style.top = "auto", x.style.right = "0", x.style.bottom = "0";
      var tt = x.getBoundingClientRect();
      x.style.left = j, x.style.top = M, x.style.right = q, x.style.bottom = N, x.style.overflow = $, (C = x.parentElement) === null || C === void 0 || C.removeChild(H);
      var _t = Ia(Math.round(ke / parseFloat(I) * 1e3) / 1e3), $t = Ia(Math.round(te / parseFloat(L) * 1e3) / 1e3);
      if (_t === 0 || $t === 0 || Sa(n) && !Kb(n))
        return;
      var en = F.offset, Ee = F.targetOffset, Fe = p0(Y, en), S = de(Fe, 2), A = S[0], K = S[1], J = p0(k, Ee), le = de(J, 2), be = le[0], Oe = le[1];
      k.x -= be, k.y -= Oe;
      var We = F.points || [], Ke = de(We, 2), nt = Ke[0], at = Ke[1], st = v0(at), ct = v0(nt), Vt = ai(k, st), xt = ai(Y, ct), _n = V({}, F), ot = Vt.x - xt.x + A, rt = Vt.y - xt.y + K, Ut = Wn(ot, rt), ir = Wn(ot, rt, Re), St = ai(k, ["t", "l"]), tn = ai(Y, ["t", "l"]), Yr = ai(k, ["b", "r"]), yt = ai(Y, ["b", "r"]), bt = F.overflow || {}, fn = bt.adjustX, R = bt.adjustY, re = bt.shiftX, pe = bt.shiftY, Ie = function(Zr) {
        return typeof Zr == "boolean" ? Zr : Zr >= 0;
      }, He, Ze, je, Be;
      ns();
      var Ot = Ie(R), Xe = ct[0] === st[0];
      if (Ot && ct[0] === "t" && (Ze > et.bottom || h.current.bt)) {
        var Qe = rt;
        Xe ? Qe -= te - se : Qe = St.y - yt.y - K;
        var hn = Wn(ot, Qe), wr = Wn(ot, Qe, Re);
        // Of course use larger one
        hn > Ut || hn === Ut && (!ae || // Choose recommend one
        wr >= ir) ? (h.current.bt = !0, rt = Qe, K = -K, _n.points = [Xr(ct, 0), Xr(st, 0)]) : h.current.bt = !1;
      }
      if (Ot && ct[0] === "b" && (He < et.top || h.current.tb)) {
        var xn = rt;
        Xe ? xn += te - se : xn = Yr.y - tn.y - K;
        var Qt = Wn(ot, xn), wo = Wn(ot, xn, Re);
        // Of course use larger one
        Qt > Ut || Qt === Ut && (!ae || // Choose recommend one
        wo >= ir) ? (h.current.tb = !0, rt = xn, K = -K, _n.points = [Xr(ct, 0), Xr(st, 0)]) : h.current.tb = !1;
      }
      var Go = Ie(fn), Ko = ct[1] === st[1];
      if (Go && ct[1] === "l" && (Be > et.right || h.current.rl)) {
        var Eo = ot;
        Ko ? Eo -= ke - D : Eo = St.x - yt.x - A;
        var Za = Wn(Eo, rt), Yo = Wn(Eo, rt, Re);
        // Of course use larger one
        Za > Ut || Za === Ut && (!ae || // Choose recommend one
        Yo >= ir) ? (h.current.rl = !0, ot = Eo, A = -A, _n.points = [Xr(ct, 1), Xr(st, 1)]) : h.current.rl = !1;
      }
      if (Go && ct[1] === "r" && (je < et.left || h.current.lr)) {
        var Nr = ot;
        Ko ? Nr += ke - D : Nr = Yr.x - tn.x - A;
        var Qa = Wn(Nr, rt), Xa = Wn(Nr, rt, Re);
        // Of course use larger one
        Qa > Ut || Qa === Ut && (!ae || // Choose recommend one
        Xa >= ir) ? (h.current.lr = !0, ot = Nr, A = -A, _n.points = [Xr(ct, 1), Xr(st, 1)]) : h.current.lr = !1;
      }
      ns();
      var Er = re === !0 ? 0 : re;
      typeof Er == "number" && (je < Re.left && (ot -= je - Re.left - A, k.x + D < Re.left + Er && (ot += k.x - Re.left + D - Er)), Be > Re.right && (ot -= Be - Re.right - A, k.x > Re.right - Er && (ot += k.x - Re.right + Er)));
      var ar = pe === !0 ? 0 : pe;
      typeof ar == "number" && (He < Re.top && (rt -= He - Re.top - K, k.y + se < Re.top + ar && (rt += k.y - Re.top + se - ar)), Ze > Re.bottom && (rt -= Ze - Re.bottom - K, k.y > Re.bottom - ar && (rt += k.y - Re.bottom + ar)));
      var Zo = Y.x + ot, Qo = Zo + ke, _r = Y.y + rt, $c = _r + te, Ja = k.x, Nc = Ja + D, Yi = k.y, Fc = Yi + se, Lc = Math.max(Zo, Ja), Mc = Math.min(Qo, Nc), es = (Lc + Mc) / 2, Dc = es - Zo, jc = Math.max(_r, Yi), ts = Math.min($c, Fc), Bc = (jc + ts) / 2, Vc = Bc - _r;
      a == null || a(t, _n);
      var Zi = tt.right - Y.x - (ot + Y.width), xr = tt.bottom - Y.y - (rt + Y.height);
      _t === 1 && (ot = Math.round(ot), Zi = Math.round(Zi)), $t === 1 && (rt = Math.round(rt), xr = Math.round(xr));
      var Uc = {
        ready: !0,
        offsetX: ot / _t,
        offsetY: rt / $t,
        offsetR: Zi / _t,
        offsetB: xr / $t,
        arrowX: Dc / _t,
        arrowY: Vc / $t,
        scaleX: _t,
        scaleY: $t,
        align: _n
      };
      u(Uc);
    }
  }), v = function() {
    d.current += 1;
    var w = d.current;
    Promise.resolve().then(function() {
      d.current === w && g();
    });
  }, b = function() {
    u(function(w) {
      return V(V({}, w), {}, {
        ready: !1
      });
    });
  };
  return vn(b, [r]), vn(function() {
    e || b();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, v];
}
function u$(e, t, n, r, o) {
  vn(function() {
    if (e && t && n) {
      let d = function() {
        r(), o();
      };
      var i = t, a = n, s = $f(i), l = $f(a), c = Ga(a), u = new Set([c].concat(Pe(s), Pe(l)));
      return u.forEach(function(f) {
        f.addEventListener("scroll", d, {
          passive: !0
        });
      }), c.addEventListener("resize", d, {
        passive: !0
      }), r(), function() {
        u.forEach(function(f) {
          f.removeEventListener("scroll", d), c.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, n]);
}
function d$(e, t, n, r, o, i, a, s) {
  var l = y.useRef(e);
  l.current = e;
  var c = y.useRef(!1);
  y.useEffect(function() {
    if (t && r && (!o || i)) {
      var d = function() {
        c.current = !1;
      }, f = function(E) {
        var C;
        l.current && !a(((C = E.composedPath) === null || C === void 0 || (C = C.call(E)) === null || C === void 0 ? void 0 : C[0]) || E.target) && !c.current && s(!1);
      }, h = Ga(r);
      h.addEventListener("pointerdown", d, !0), h.addEventListener("mousedown", f, !0), h.addEventListener("contextmenu", f, !0);
      var p = Sl(n);
      if (p && (p.addEventListener("mousedown", f, !0), p.addEventListener("contextmenu", f, !0)), z.env.NODE_ENV !== "production") {
        var g, v, b = n == null || (g = n.getRootNode) === null || g === void 0 ? void 0 : g.call(n), m = (v = r.getRootNode) === null || v === void 0 ? void 0 : v.call(r);
        go(b === m, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        h.removeEventListener("pointerdown", d, !0), h.removeEventListener("mousedown", f, !0), h.removeEventListener("contextmenu", f, !0), p && (p.removeEventListener("mousedown", f, !0), p.removeEventListener("contextmenu", f, !0));
      };
    }
  }, [t, n, r, o, i]);
  function u() {
    c.current = !0;
  }
  return u;
}
var f$ = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function h$() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ha, t = /* @__PURE__ */ y.forwardRef(function(n, r) {
    var o = n.prefixCls, i = o === void 0 ? "rc-trigger-popup" : o, a = n.children, s = n.action, l = s === void 0 ? "hover" : s, c = n.showAction, u = n.hideAction, d = n.popupVisible, f = n.defaultPopupVisible, h = n.onPopupVisibleChange, p = n.afterPopupVisibleChange, g = n.mouseEnterDelay, v = n.mouseLeaveDelay, b = v === void 0 ? 0.1 : v, m = n.focusDelay, w = n.blurDelay, E = n.mask, C = n.maskClosable, x = C === void 0 ? !0 : C, _ = n.getPopupContainer, T = n.forceRender, O = n.autoDestroy, I = n.destroyPopupOnHide, L = n.popup, B = n.popupClassName, j = n.popupStyle, M = n.popupPlacement, q = n.builtinPlacements, N = q === void 0 ? {} : q, $ = n.popupAlign, F = n.zIndex, H = n.stretch, k = n.getPopupClassNameFromAlign, W = n.fresh, G = n.alignPoint, ne = n.onPopupClick, Y = n.onPopupAlign, fe = n.arrow, ge = n.popupMotion, ie = n.maskMotion, he = n.popupTransitionName, ue = n.popupAnimation, ce = n.maskTransitionName, Se = n.maskAnimation, te = n.className, ke = n.getTriggerDOMNode, se = Hn(n, f$), D = O || I || !1, X = y.useState(!1), Q = de(X, 2), _e = Q[0], Ce = Q[1];
    vn(function() {
      Ce(r$());
    }, []);
    var Ne = y.useRef({}), ae = y.useContext(c0), xe = y.useMemo(function() {
      return {
        registerSubPopup: function(Me, At) {
          Ne.current[Me] = At, ae == null || ae.registerSubPopup(Me, At);
        }
      };
    }, [ae]), Re = v2(), mt = y.useState(null), et = de(mt, 2), tt = et[0], _t = et[1], $t = y.useRef(null), en = Cn(function(Te) {
      $t.current = Te, Sa(Te) && tt !== Te && _t(Te), ae == null || ae.registerSubPopup(Re, Te);
    }), Ee = y.useState(null), Fe = de(Ee, 2), S = Fe[0], A = Fe[1], K = y.useRef(null), J = Cn(function(Te) {
      Sa(Te) && S !== Te && (A(Te), K.current = Te);
    }), le = y.Children.only(a), be = (le == null ? void 0 : le.props) || {}, Oe = {}, We = Cn(function(Te) {
      var Me, At, Xt = S;
      return (Xt == null ? void 0 : Xt.contains(Te)) || ((Me = Sl(Xt)) === null || Me === void 0 ? void 0 : Me.host) === Te || Te === Xt || (tt == null ? void 0 : tt.contains(Te)) || ((At = Sl(tt)) === null || At === void 0 ? void 0 : At.host) === Te || Te === tt || Object.values(Ne.current).some(function(Ft) {
        return (Ft == null ? void 0 : Ft.contains(Te)) || Te === Ft;
      });
    }), Ke = d0(i, ge, ue, he), nt = d0(i, ie, Se, ce), at = y.useState(f || !1), st = de(at, 2), ct = st[0], Vt = st[1], xt = d ?? ct, _n = Cn(function(Te) {
      d === void 0 && Vt(Te);
    });
    vn(function() {
      Vt(d || !1);
    }, [d]);
    var ot = y.useRef(xt);
    ot.current = xt;
    var rt = y.useRef([]);
    rt.current = [];
    var Ut = Cn(function(Te) {
      var Me;
      _n(Te), ((Me = rt.current[rt.current.length - 1]) !== null && Me !== void 0 ? Me : xt) !== Te && (rt.current.push(Te), h == null || h(Te));
    }), ir = y.useRef(), St = function() {
      clearTimeout(ir.current);
    }, tn = function(Me) {
      var At = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      St(), At === 0 ? Ut(Me) : ir.current = setTimeout(function() {
        Ut(Me);
      }, At * 1e3);
    };
    y.useEffect(function() {
      return St;
    }, []);
    var Yr = y.useState(!1), yt = de(Yr, 2), bt = yt[0], fn = yt[1];
    vn(function(Te) {
      (!Te || xt) && fn(!0);
    }, [xt]);
    var R = y.useState(null), re = de(R, 2), pe = re[0], Ie = re[1], He = y.useState(null), Ze = de(He, 2), je = Ze[0], Be = Ze[1], Ot = function(Me) {
      Be([Me.clientX, Me.clientY]);
    }, Xe = c$(xt, tt, G && je !== null ? je : S, M, N, $, Y), Qe = de(Xe, 11), hn = Qe[0], wr = Qe[1], xn = Qe[2], Qt = Qe[3], wo = Qe[4], Go = Qe[5], Ko = Qe[6], Eo = Qe[7], Za = Qe[8], Yo = Qe[9], Nr = Qe[10], Qa = a$(_e, l, c, u), Xa = de(Qa, 2), Er = Xa[0], ar = Xa[1], Zo = Er.has("click"), Qo = ar.has("click") || ar.has("contextMenu"), _r = Cn(function() {
      bt || Nr();
    }), $c = function() {
      ot.current && G && Qo && tn(!1);
    };
    u$(xt, S, tt, _r, $c), vn(function() {
      _r();
    }, [je, M]), vn(function() {
      xt && !(N != null && N[M]) && _r();
    }, [JSON.stringify($)]);
    var Ja = y.useMemo(function() {
      var Te = l$(N, i, Yo, G);
      return me(Te, k == null ? void 0 : k(Yo));
    }, [Yo, k, N, i, G]);
    y.useImperativeHandle(r, function() {
      return {
        nativeElement: K.current,
        popupElement: $t.current,
        forceAlign: _r
      };
    });
    var Nc = y.useState(0), Yi = de(Nc, 2), Fc = Yi[0], Lc = Yi[1], Mc = y.useState(0), es = de(Mc, 2), Dc = es[0], jc = es[1], ts = function() {
      if (H && S) {
        var Me = S.getBoundingClientRect();
        Lc(Me.width), jc(Me.height);
      }
    }, Bc = function() {
      ts(), _r();
    }, Vc = function(Me) {
      fn(!1), Nr(), p == null || p(Me);
    }, Zi = function() {
      return new Promise(function(Me) {
        ts(), Ie(function() {
          return Me;
        });
      });
    };
    vn(function() {
      pe && (Nr(), pe(), Ie(null));
    }, [pe]);
    function xr(Te, Me, At, Xt) {
      Oe[Te] = function(Ft) {
        var os;
        Xt == null || Xt(Ft), tn(Me, At);
        for (var Wc = arguments.length, Gh = new Array(Wc > 1 ? Wc - 1 : 0), is = 1; is < Wc; is++)
          Gh[is - 1] = arguments[is];
        (os = be[Te]) === null || os === void 0 || os.call.apply(os, [be, Ft].concat(Gh));
      };
    }
    (Zo || Qo) && (Oe.onClick = function(Te) {
      var Me;
      ot.current && Qo ? tn(!1) : !ot.current && Zo && (Ot(Te), tn(!0));
      for (var At = arguments.length, Xt = new Array(At > 1 ? At - 1 : 0), Ft = 1; Ft < At; Ft++)
        Xt[Ft - 1] = arguments[Ft];
      (Me = be.onClick) === null || Me === void 0 || Me.call.apply(Me, [be, Te].concat(Xt));
    });
    var Uc = d$(xt, Qo, S, tt, E, x, We, tn), Wn = Er.has("hover"), ns = ar.has("hover"), Xo, Zr;
    Wn && (xr("onMouseEnter", !0, g, function(Te) {
      Ot(Te);
    }), xr("onPointerEnter", !0, g, function(Te) {
      Ot(Te);
    }), Xo = function(Me) {
      (xt || bt) && tt !== null && tt !== void 0 && tt.contains(Me.target) && tn(!0, g);
    }, G && (Oe.onMouseMove = function(Te) {
      var Me;
      (Me = be.onMouseMove) === null || Me === void 0 || Me.call(be, Te);
    })), ns && (xr("onMouseLeave", !1, b), xr("onPointerLeave", !1, b), Zr = function() {
      tn(!1, b);
    }), Er.has("focus") && xr("onFocus", !0, m), ar.has("focus") && xr("onBlur", !1, w), Er.has("contextMenu") && (Oe.onContextMenu = function(Te) {
      var Me;
      ot.current && ar.has("contextMenu") ? tn(!1) : (Ot(Te), tn(!0)), Te.preventDefault();
      for (var At = arguments.length, Xt = new Array(At > 1 ? At - 1 : 0), Ft = 1; Ft < At; Ft++)
        Xt[Ft - 1] = arguments[Ft];
      (Me = be.onContextMenu) === null || Me === void 0 || Me.call.apply(Me, [be, Te].concat(Xt));
    }), te && (Oe.className = me(be.className, te));
    var Qr = V(V({}, be), Oe), Qi = {}, rs = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    rs.forEach(function(Te) {
      se[Te] && (Qi[Te] = function() {
        for (var Me, At = arguments.length, Xt = new Array(At), Ft = 0; Ft < At; Ft++)
          Xt[Ft] = arguments[Ft];
        (Me = Qr[Te]) === null || Me === void 0 || Me.call.apply(Me, [Qr].concat(Xt)), se[Te].apply(se, Xt);
      });
    });
    var Hc = /* @__PURE__ */ y.cloneElement(le, V(V({}, Qr), Qi)), zc = {
      x: Go,
      y: Ko
    }, qc = fe ? V({}, fe !== !0 ? fe : {}) : null;
    return /* @__PURE__ */ y.createElement(y.Fragment, null, /* @__PURE__ */ y.createElement(cc, {
      disabled: !xt,
      ref: J,
      onResize: Bc
    }, /* @__PURE__ */ y.createElement(q2, {
      getTriggerDOMNode: ke
    }, Hc)), /* @__PURE__ */ y.createElement(c0.Provider, {
      value: xe
    }, /* @__PURE__ */ y.createElement(z2, {
      portal: e,
      ref: en,
      prefixCls: i,
      popup: L,
      className: me(B, Ja),
      style: j,
      target: S,
      onMouseEnter: Xo,
      onMouseLeave: Zr,
      onPointerEnter: Xo,
      zIndex: F,
      open: xt,
      keepDom: bt,
      fresh: W,
      onClick: ne,
      onPointerDownCapture: Uc,
      mask: E,
      motion: Ke,
      maskMotion: nt,
      onVisibleChanged: Vc,
      onPrepare: Zi,
      forceRender: T,
      autoDestroy: D,
      getPopupContainer: _,
      align: Yo,
      arrow: qc,
      arrowPos: zc,
      ready: hn,
      offsetX: wr,
      offsetY: xn,
      offsetR: Qt,
      offsetB: wo,
      onAlign: _r,
      stretch: H,
      targetWidth: Fc / Eo,
      targetHeight: Dc / Za
    })));
  });
  return z.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const p$ = h$(Ha);
function W2(e) {
  var t = e.children, n = e.prefixCls, r = e.id, o = e.overlayInnerStyle, i = e.bodyClassName, a = e.className, s = e.style;
  return /* @__PURE__ */ y.createElement("div", {
    className: me("".concat(n, "-content"), a),
    style: s
  }, /* @__PURE__ */ y.createElement("div", {
    className: me("".concat(n, "-inner"), i),
    id: r,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
}
var si = {
  shiftX: 64,
  adjustY: 1
}, li = {
  adjustX: 1,
  shiftY: !0
}, Yn = [0, 0], v$ = {
  left: {
    points: ["cr", "cl"],
    overflow: li,
    offset: [-4, 0],
    targetOffset: Yn
  },
  right: {
    points: ["cl", "cr"],
    overflow: li,
    offset: [4, 0],
    targetOffset: Yn
  },
  top: {
    points: ["bc", "tc"],
    overflow: si,
    offset: [0, -4],
    targetOffset: Yn
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: si,
    offset: [0, 4],
    targetOffset: Yn
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: si,
    offset: [0, -4],
    targetOffset: Yn
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: li,
    offset: [-4, 0],
    targetOffset: Yn
  },
  topRight: {
    points: ["br", "tr"],
    overflow: si,
    offset: [0, -4],
    targetOffset: Yn
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: li,
    offset: [4, 0],
    targetOffset: Yn
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: si,
    offset: [0, 4],
    targetOffset: Yn
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: li,
    offset: [4, 0],
    targetOffset: Yn
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: si,
    offset: [0, 4],
    targetOffset: Yn
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: li,
    offset: [-4, 0],
    targetOffset: Yn
  }
}, g$ = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"], m$ = function(t, n) {
  var r = t.overlayClassName, o = t.trigger, i = o === void 0 ? ["hover"] : o, a = t.mouseEnterDelay, s = a === void 0 ? 0 : a, l = t.mouseLeaveDelay, c = l === void 0 ? 0.1 : l, u = t.overlayStyle, d = t.prefixCls, f = d === void 0 ? "rc-tooltip" : d, h = t.children, p = t.onVisibleChange, g = t.afterVisibleChange, v = t.transitionName, b = t.animation, m = t.motion, w = t.placement, E = w === void 0 ? "right" : w, C = t.align, x = C === void 0 ? {} : C, _ = t.destroyTooltipOnHide, T = _ === void 0 ? !1 : _, O = t.defaultVisible, I = t.getTooltipContainer, L = t.overlayInnerStyle;
  t.arrowContent;
  var B = t.overlay, j = t.id, M = t.showArrow, q = M === void 0 ? !0 : M, N = t.classNames, $ = t.styles, F = Hn(t, g$), H = lt(null);
  iw(n, function() {
    return H.current;
  });
  var k = V({}, F);
  "visible" in t && (k.popupVisible = t.visible);
  var W = function() {
    return /* @__PURE__ */ y.createElement(W2, {
      key: "content",
      prefixCls: f,
      id: j,
      bodyClassName: N == null ? void 0 : N.body,
      overlayInnerStyle: V(V({}, L), $ == null ? void 0 : $.body)
    }, B);
  };
  return /* @__PURE__ */ y.createElement(p$, it({
    popupClassName: me(r, N == null ? void 0 : N.root),
    prefixCls: f,
    popup: W,
    action: i,
    builtinPlacements: v$,
    popupPlacement: E,
    ref: H,
    popupAlign: x,
    getPopupContainer: I,
    onPopupVisibleChange: p,
    afterPopupVisibleChange: g,
    popupTransitionName: v,
    popupAnimation: b,
    popupMotion: m,
    defaultPopupVisible: O,
    autoDestroy: T,
    mouseLeaveDelay: c,
    popupStyle: V(V({}, u), $ == null ? void 0 : $.root),
    mouseEnterDelay: s,
    arrow: q
  }, k), h);
};
const y$ = /* @__PURE__ */ Na(m$);
function b$(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, o = t / 2, i = 0, a = o, s = r * 1 / Math.sqrt(2), l = o - r * (1 - 1 / Math.sqrt(2)), c = o - n * (1 / Math.sqrt(2)), u = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), d = 2 * o - c, f = u, h = 2 * o - s, p = l, g = 2 * o - i, v = a, b = o * Math.sqrt(2) + r * (Math.sqrt(2) - 2), m = r * (Math.sqrt(2) - 1), w = `polygon(${m}px 100%, 50% ${m}px, ${2 * o - m}px 100%, ${m}px 100%)`, E = `path('M ${i} ${a} A ${r} ${r} 0 0 0 ${s} ${l} L ${c} ${u} A ${n} ${n} 0 0 1 ${d} ${f} L ${h} ${p} A ${r} ${r} 0 0 0 ${g} ${v} Z')`;
  return {
    arrowShadowWidth: b,
    arrowPath: E,
    arrowPolygon: w
  };
}
const C$ = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: o,
    arrowPath: i,
    arrowShadowWidth: a,
    borderRadiusXS: s,
    calc: l
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: l(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [o, i]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: a,
      height: a,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${ze(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, G2 = 8;
function K2(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? G2 : r
  };
}
function Fs(e, t) {
  return e ? t : {};
}
function w$(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: o,
    arrowOffsetVertical: i,
    arrowOffsetHorizontal: a
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, C$(e, t, o)), {
        "&:before": {
          background: t
        }
      })]
    }, Fs(!!l.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${ze(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), Fs(!!l.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${ze(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), Fs(!!l.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: i
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: i
      }
    })), Fs(!!l.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: i
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: i
      }
    }))
  };
}
function E$(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const o = r && typeof r == "object" ? r : {}, i = {};
  switch (e) {
    case "top":
    case "bottom":
      i.shiftX = t.arrowOffsetHorizontal * 2 + n, i.shiftY = !0, i.adjustY = !0;
      break;
    case "left":
    case "right":
      i.shiftY = t.arrowOffsetVertical * 2 + n, i.shiftX = !0, i.adjustX = !0;
      break;
  }
  const a = Object.assign(Object.assign({}, i), o);
  return a.shiftX || (a.adjustX = !0), a.shiftY || (a.adjustY = !0), a;
}
const g0 = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, _$ = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, x$ = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function S$(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: o,
    borderRadius: i,
    visibleFirst: a
  } = e, s = t / 2, l = {};
  return Object.keys(g0).forEach((c) => {
    const u = r && _$[c] || g0[c], d = Object.assign(Object.assign({}, u), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[c] = d, x$.has(c) && (d.autoArrow = !1), c) {
      case "top":
      case "topLeft":
      case "topRight":
        d.offset[1] = -s - o;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        d.offset[1] = s + o;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        d.offset[0] = -s - o;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        d.offset[0] = s + o;
        break;
    }
    const f = K2({
      contentRadius: i,
      limitVerticalRadius: !0
    });
    if (r)
      switch (c) {
        case "topLeft":
        case "bottomLeft":
          d.offset[0] = -f.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          d.offset[0] = f.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          d.offset[1] = -f.arrowOffsetHorizontal * 2 + s;
          break;
        case "leftBottom":
        case "rightBottom":
          d.offset[1] = f.arrowOffsetHorizontal * 2 - s;
          break;
      }
    d.overflow = E$(c, f, t, n), a && (d.htmlRegion = "visibleFirst");
  }), l;
}
const T$ = (e) => {
  const {
    calc: t,
    componentCls: n,
    // ant-tooltip
    tooltipMaxWidth: r,
    tooltipColor: o,
    tooltipBg: i,
    tooltipBorderRadius: a,
    zIndexPopup: s,
    controlHeight: l,
    boxShadowSecondary: c,
    paddingSM: u,
    paddingXS: d,
    arrowOffsetHorizontal: f,
    sizePopupArrow: h
  } = e, p = t(a).add(h).add(f).equal(), g = t(a).mul(2).add(h).equal();
  return [
    {
      [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, Sb(e)), {
        position: "absolute",
        zIndex: s,
        display: "block",
        width: "max-content",
        maxWidth: r,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": i,
        // Wrapper for the tooltip content
        [`${n}-inner`]: {
          minWidth: g,
          minHeight: l,
          padding: `${ze(e.calc(u).div(2).equal())} ${ze(d)}`,
          color: o,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: i,
          borderRadius: a,
          boxShadow: c,
          boxSizing: "border-box"
        },
        // Align placement should have another min width
        [["&-placement-topLeft", "&-placement-topRight", "&-placement-bottomLeft", "&-placement-bottomRight"].join(",")]: {
          minWidth: p
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${n}-inner`]: {
            borderRadius: e.min(a, G2)
          }
        },
        [`${n}-content`]: {
          position: "relative"
        }
      }), TP(e, (v, b) => {
        let {
          darkColor: m
        } = b;
        return {
          [`&${n}-${v}`]: {
            [`${n}-inner`]: {
              backgroundColor: m
            },
            [`${n}-arrow`]: {
              "--antd-arrow-background-color": m
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    w$(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${n}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, O$ = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, K2({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), b$(rr(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), Y2 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return qo("Tooltip", (r) => {
    const {
      borderRadius: o,
      colorTextLightSolid: i,
      colorBgSpotlight: a
    } = r, s = rr(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: i,
      tooltipBorderRadius: o,
      tooltipBg: a
    });
    return [T$(s), s2(r, "zoom-big-fast")];
  }, O$, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, P$ = Mi.map((e) => `${e}-inverse`);
function R$(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(Pe(P$), Pe(Mi)).includes(e) : Mi.includes(e);
}
function Z2(e, t) {
  const n = R$(t), r = me({
    [`${e}-${t}`]: t && n
  }), o = {}, i = {};
  return t && !n && (o.background = t, i["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: o,
    arrowStyle: i
  };
}
const A$ = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: o,
    color: i,
    overlayInnerStyle: a
  } = e, {
    getPrefixCls: s
  } = y.useContext(kt), l = s("tooltip", t), [c, u, d] = Y2(l), f = Z2(l, i), h = f.arrowStyle, p = Object.assign(Object.assign({}, a), f.overlayStyle), g = me(u, d, l, `${l}-pure`, `${l}-placement-${r}`, n, f.className);
  return c(/* @__PURE__ */ y.createElement("div", {
    className: g,
    style: h
  }, /* @__PURE__ */ y.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ y.createElement(W2, Object.assign({}, e, {
    className: u,
    prefixCls: l,
    overlayInnerStyle: p
  }), o)));
};
var I$ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const k$ = /* @__PURE__ */ y.forwardRef((e, t) => {
  var n, r, o, i, a, s;
  const {
    prefixCls: l,
    openClassName: c,
    getTooltipContainer: u,
    color: d,
    overlayInnerStyle: f,
    children: h,
    afterOpenChange: p,
    afterVisibleChange: g,
    destroyTooltipOnHide: v,
    arrow: b = !0,
    title: m,
    overlay: w,
    builtinPlacements: E,
    arrowPointAtCenter: C = !1,
    autoAdjustOverflow: x = !0
  } = e, _ = !!b, [, T] = Gr(), {
    getPopupContainer: O,
    getPrefixCls: I,
    direction: L,
    tooltip: B
  } = y.useContext(kt), j = nr("Tooltip"), M = y.useRef(null), q = () => {
    var Ee;
    (Ee = M.current) === null || Ee === void 0 || Ee.forceAlign();
  };
  y.useImperativeHandle(t, () => {
    var Ee;
    return {
      forceAlign: q,
      forcePopupAlign: () => {
        j.deprecated(!1, "forcePopupAlign", "forceAlign"), q();
      },
      nativeElement: (Ee = M.current) === null || Ee === void 0 ? void 0 : Ee.nativeElement
    };
  }), z.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"], ["overlayStyle", "styles={{ root: {} }}"], ["overlayInnerStyle", "styles={{ body: {} }}"], ["overlayClassName", "classNames={{ root: {} }}"]].forEach((Ee) => {
    let [Fe, S] = Ee;
    j.deprecated(!(Fe in e), Fe, S);
  }), z.env.NODE_ENV !== "production" && j(!v || typeof v == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), z.env.NODE_ENV !== "production" && j(!b || typeof b == "boolean" || !("arrowPointAtCenter" in b), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [N, $] = Cb(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), F = !m && !w && m !== 0, H = (Ee) => {
    var Fe, S;
    $(F ? !1 : Ee), F || ((Fe = e.onOpenChange) === null || Fe === void 0 || Fe.call(e, Ee), (S = e.onVisibleChange) === null || S === void 0 || S.call(e, Ee));
  }, k = y.useMemo(() => {
    var Ee, Fe;
    let S = C;
    return typeof b == "object" && (S = (Fe = (Ee = b.pointAtCenter) !== null && Ee !== void 0 ? Ee : b.arrowPointAtCenter) !== null && Fe !== void 0 ? Fe : C), E || S$({
      arrowPointAtCenter: S,
      autoAdjustOverflow: x,
      arrowWidth: _ ? T.sizePopupArrow : 0,
      borderRadius: T.borderRadius,
      offset: T.marginXXS,
      visibleFirst: !0
    });
  }, [C, b, E, T]), W = y.useMemo(() => m === 0 ? m : w || m || "", [w, m]), G = /* @__PURE__ */ y.createElement(Lh, {
    space: !0
  }, typeof W == "function" ? W() : W), {
    getPopupContainer: ne,
    placement: Y = "top",
    mouseEnterDelay: fe = 0.1,
    mouseLeaveDelay: ge = 0.1,
    overlayStyle: ie,
    rootClassName: he,
    overlayClassName: ue,
    styles: ce,
    classNames: Se
  } = e, te = I$(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]), ke = I("tooltip", l), se = I(), D = e["data-popover-inject"];
  let X = N;
  !("open" in e) && !("visible" in e) && F && (X = !1);
  const Q = /* @__PURE__ */ y.isValidElement(h) && !Hb(h) ? h : /* @__PURE__ */ y.createElement("span", null, h), _e = Q.props, Ce = !_e.className || typeof _e.className == "string" ? me(_e.className, c || `${ke}-open`) : _e.className, [Ne, ae, xe] = Y2(ke, !D), Re = Z2(ke, d), mt = Re.arrowStyle, et = me(ue, {
    [`${ke}-rtl`]: L === "rtl"
  }, Re.className, he, ae, xe, B == null ? void 0 : B.className, (o = B == null ? void 0 : B.classNames) === null || o === void 0 ? void 0 : o.root, Se == null ? void 0 : Se.root), tt = me((i = B == null ? void 0 : B.classNames) === null || i === void 0 ? void 0 : i.body, Se == null ? void 0 : Se.body), [_t, $t] = Ih("Tooltip", te.zIndex), en = /* @__PURE__ */ y.createElement(y$, Object.assign({}, te, {
    zIndex: _t,
    showArrow: _,
    placement: Y,
    mouseEnterDelay: fe,
    mouseLeaveDelay: ge,
    prefixCls: ke,
    classNames: {
      root: et,
      body: tt
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mt), (a = B == null ? void 0 : B.styles) === null || a === void 0 ? void 0 : a.root), B == null ? void 0 : B.style), ie), ce == null ? void 0 : ce.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, (s = B == null ? void 0 : B.styles) === null || s === void 0 ? void 0 : s.body), f), ce == null ? void 0 : ce.body), Re.overlayStyle)
    },
    getTooltipContainer: ne || u || O,
    ref: M,
    builtinPlacements: k,
    overlay: G,
    visible: X,
    onVisibleChange: H,
    afterVisibleChange: p ?? g,
    arrowContent: /* @__PURE__ */ y.createElement("span", {
      className: `${ke}-arrow-content`
    }),
    motion: {
      motionName: Uo(se, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!v
  }), X ? Ah(Q, {
    className: Ce
  }) : Q);
  return Ne(/* @__PURE__ */ y.createElement(Ba.Provider, {
    value: $t
  }, en));
}), fo = k$;
z.env.NODE_ENV !== "production" && (fo.displayName = "Tooltip");
fo._InternalPanelDoNotUseOrYouWillBeFired = A$;
var m0 = /* @__PURE__ */ y.createContext(null), Q2 = /* @__PURE__ */ y.createContext({}), $$ = ["prefixCls", "className", "containerRef"], X2 = function(t) {
  var n = t.prefixCls, r = t.className, o = t.containerRef, i = Hn(t, $$), a = y.useContext(Q2), s = a.panel, l = zi(s, o);
  return /* @__PURE__ */ y.createElement("div", it({
    className: me("".concat(n, "-content"), r),
    role: "dialog",
    ref: l
  }, Di(t, {
    aria: !0
  }), {
    "aria-modal": "true"
  }, i));
};
z.env.NODE_ENV !== "production" && (X2.displayName = "DrawerPanel");
function y0(e) {
  return typeof e == "string" && String(Number(e)) === e ? (Et(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function N$(e) {
  Et(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), Et(En() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var b0 = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function F$(e, t) {
  var n, r, o, i = e.prefixCls, a = e.open, s = e.placement, l = e.inline, c = e.push, u = e.forceRender, d = e.autoFocus, f = e.keyboard, h = e.classNames, p = e.rootClassName, g = e.rootStyle, v = e.zIndex, b = e.className, m = e.id, w = e.style, E = e.motion, C = e.width, x = e.height, _ = e.children, T = e.mask, O = e.maskClosable, I = e.maskMotion, L = e.maskClassName, B = e.maskStyle, j = e.afterOpenChange, M = e.onClose, q = e.onMouseEnter, N = e.onMouseOver, $ = e.onMouseLeave, F = e.onClick, H = e.onKeyDown, k = e.onKeyUp, W = e.styles, G = e.drawerRender, ne = y.useRef(), Y = y.useRef(), fe = y.useRef();
  y.useImperativeHandle(t, function() {
    return ne.current;
  });
  var ge = function(xe) {
    var Re = xe.keyCode, mt = xe.shiftKey;
    switch (Re) {
      case $e.TAB: {
        if (Re === $e.TAB) {
          if (!mt && document.activeElement === fe.current) {
            var et;
            (et = Y.current) === null || et === void 0 || et.focus({
              preventScroll: !0
            });
          } else if (mt && document.activeElement === Y.current) {
            var tt;
            (tt = fe.current) === null || tt === void 0 || tt.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case $e.ESC: {
        M && f && (xe.stopPropagation(), M(xe));
        break;
      }
    }
  };
  y.useEffect(function() {
    if (a && d) {
      var ae;
      (ae = ne.current) === null || ae === void 0 || ae.focus({
        preventScroll: !0
      });
    }
  }, [a]);
  var ie = y.useState(!1), he = de(ie, 2), ue = he[0], ce = he[1], Se = y.useContext(m0), te;
  typeof c == "boolean" ? te = c ? {} : {
    distance: 0
  } : te = c || {};
  var ke = (n = (r = (o = te) === null || o === void 0 ? void 0 : o.distance) !== null && r !== void 0 ? r : Se == null ? void 0 : Se.pushDistance) !== null && n !== void 0 ? n : 180, se = y.useMemo(function() {
    return {
      pushDistance: ke,
      push: function() {
        ce(!0);
      },
      pull: function() {
        ce(!1);
      }
    };
  }, [ke]);
  y.useEffect(function() {
    if (a) {
      var ae;
      Se == null || (ae = Se.push) === null || ae === void 0 || ae.call(Se);
    } else {
      var xe;
      Se == null || (xe = Se.pull) === null || xe === void 0 || xe.call(Se);
    }
  }, [a]), y.useEffect(function() {
    return function() {
      var ae;
      Se == null || (ae = Se.pull) === null || ae === void 0 || ae.call(Se);
    };
  }, []);
  var D = T && /* @__PURE__ */ y.createElement(Hr, it({
    key: "mask"
  }, I, {
    visible: a
  }), function(ae, xe) {
    var Re = ae.className, mt = ae.style;
    return /* @__PURE__ */ y.createElement("div", {
      className: me("".concat(i, "-mask"), Re, h == null ? void 0 : h.mask, L),
      style: V(V(V({}, mt), B), W == null ? void 0 : W.mask),
      onClick: O && a ? M : void 0,
      ref: xe
    });
  }), X = typeof E == "function" ? E(s) : E, Q = {};
  if (ue && ke)
    switch (s) {
      case "top":
        Q.transform = "translateY(".concat(ke, "px)");
        break;
      case "bottom":
        Q.transform = "translateY(".concat(-ke, "px)");
        break;
      case "left":
        Q.transform = "translateX(".concat(ke, "px)");
        break;
      default:
        Q.transform = "translateX(".concat(-ke, "px)");
        break;
    }
  s === "left" || s === "right" ? Q.width = y0(C) : Q.height = y0(x);
  var _e = {
    onMouseEnter: q,
    onMouseOver: N,
    onMouseLeave: $,
    onClick: F,
    onKeyDown: H,
    onKeyUp: k
  }, Ce = /* @__PURE__ */ y.createElement(Hr, it({
    key: "panel"
  }, X, {
    visible: a,
    forceRender: u,
    onVisibleChanged: function(xe) {
      j == null || j(xe);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(i, "-content-wrapper-hidden")
  }), function(ae, xe) {
    var Re = ae.className, mt = ae.style, et = /* @__PURE__ */ y.createElement(X2, it({
      id: m,
      containerRef: xe,
      prefixCls: i,
      className: me(b, h == null ? void 0 : h.content),
      style: V(V({}, w), W == null ? void 0 : W.content)
    }, Di(e, {
      aria: !0
    }), _e), _);
    return /* @__PURE__ */ y.createElement("div", it({
      className: me("".concat(i, "-content-wrapper"), h == null ? void 0 : h.wrapper, Re),
      style: V(V(V({}, Q), mt), W == null ? void 0 : W.wrapper)
    }, Di(e, {
      data: !0
    })), G ? G(et) : et);
  }), Ne = V({}, g);
  return v && (Ne.zIndex = v), /* @__PURE__ */ y.createElement(m0.Provider, {
    value: se
  }, /* @__PURE__ */ y.createElement("div", {
    className: me(i, "".concat(i, "-").concat(s), p, U(U({}, "".concat(i, "-open"), a), "".concat(i, "-inline"), l)),
    style: Ne,
    tabIndex: -1,
    ref: ne,
    onKeyDown: ge
  }, D, /* @__PURE__ */ y.createElement("div", {
    tabIndex: 0,
    ref: Y,
    style: b0,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), Ce, /* @__PURE__ */ y.createElement("div", {
    tabIndex: 0,
    ref: fe,
    style: b0,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var J2 = /* @__PURE__ */ y.forwardRef(F$);
z.env.NODE_ENV !== "production" && (J2.displayName = "DrawerPopup");
var eC = function(t) {
  var n = t.open, r = n === void 0 ? !1 : n, o = t.prefixCls, i = o === void 0 ? "rc-drawer" : o, a = t.placement, s = a === void 0 ? "right" : a, l = t.autoFocus, c = l === void 0 ? !0 : l, u = t.keyboard, d = u === void 0 ? !0 : u, f = t.width, h = f === void 0 ? 378 : f, p = t.mask, g = p === void 0 ? !0 : p, v = t.maskClosable, b = v === void 0 ? !0 : v, m = t.getContainer, w = t.forceRender, E = t.afterOpenChange, C = t.destroyOnClose, x = t.onMouseEnter, _ = t.onMouseOver, T = t.onMouseLeave, O = t.onClick, I = t.onKeyDown, L = t.onKeyUp, B = t.panelRef, j = y.useState(!1), M = de(j, 2), q = M[0], N = M[1];
  z.env.NODE_ENV !== "production" && N$(t);
  var $ = y.useState(!1), F = de($, 2), H = F[0], k = F[1];
  vn(function() {
    k(!0);
  }, []);
  var W = H ? r : !1, G = y.useRef(), ne = y.useRef();
  vn(function() {
    W && (ne.current = document.activeElement);
  }, [W]);
  var Y = function(ue) {
    var ce;
    if (N(ue), E == null || E(ue), !ue && ne.current && !((ce = G.current) !== null && ce !== void 0 && ce.contains(ne.current))) {
      var Se;
      (Se = ne.current) === null || Se === void 0 || Se.focus({
        preventScroll: !0
      });
    }
  }, fe = y.useMemo(function() {
    return {
      panel: B
    };
  }, [B]);
  if (!w && !q && !W && C)
    return null;
  var ge = {
    onMouseEnter: x,
    onMouseOver: _,
    onMouseLeave: T,
    onClick: O,
    onKeyDown: I,
    onKeyUp: L
  }, ie = V(V({}, t), {}, {
    open: W,
    prefixCls: i,
    placement: s,
    autoFocus: c,
    keyboard: d,
    width: h,
    mask: g,
    maskClosable: b,
    inline: m === !1,
    afterOpenChange: Y,
    ref: G
  }, ge);
  return /* @__PURE__ */ y.createElement(Q2.Provider, {
    value: fe
  }, /* @__PURE__ */ y.createElement(Ha, {
    open: W || w || q,
    autoDestroy: !1,
    getContainer: m,
    autoLock: g && (W || q)
  }, /* @__PURE__ */ y.createElement(J2, ie)));
};
z.env.NODE_ENV !== "production" && (eC.displayName = "Drawer");
const tC = (e) => {
  var t, n;
  const {
    prefixCls: r,
    title: o,
    footer: i,
    extra: a,
    loading: s,
    onClose: l,
    headerStyle: c,
    bodyStyle: u,
    footerStyle: d,
    children: f,
    classNames: h,
    styles: p
  } = e, {
    drawer: g
  } = y.useContext(kt), v = y.useCallback((C) => /* @__PURE__ */ y.createElement("button", {
    type: "button",
    onClick: l,
    "aria-label": "Close",
    className: `${r}-close`
  }, C), [l]), [b, m] = S2(Fl(e), Fl(g), {
    closable: !0,
    closeIconRender: v
  }), w = y.useMemo(() => {
    var C, x;
    return !o && !b ? null : /* @__PURE__ */ y.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (C = g == null ? void 0 : g.styles) === null || C === void 0 ? void 0 : C.header), c), p == null ? void 0 : p.header),
      className: me(`${r}-header`, {
        [`${r}-header-close-only`]: b && !o && !a
      }, (x = g == null ? void 0 : g.classNames) === null || x === void 0 ? void 0 : x.header, h == null ? void 0 : h.header)
    }, /* @__PURE__ */ y.createElement("div", {
      className: `${r}-header-title`
    }, m, o && /* @__PURE__ */ y.createElement("div", {
      className: `${r}-title`
    }, o)), a && /* @__PURE__ */ y.createElement("div", {
      className: `${r}-extra`
    }, a));
  }, [b, m, a, c, r, o]), E = y.useMemo(() => {
    var C, x;
    if (!i)
      return null;
    const _ = `${r}-footer`;
    return /* @__PURE__ */ y.createElement("div", {
      className: me(_, (C = g == null ? void 0 : g.classNames) === null || C === void 0 ? void 0 : C.footer, h == null ? void 0 : h.footer),
      style: Object.assign(Object.assign(Object.assign({}, (x = g == null ? void 0 : g.styles) === null || x === void 0 ? void 0 : x.footer), d), p == null ? void 0 : p.footer)
    }, i);
  }, [i, d, r]);
  return /* @__PURE__ */ y.createElement(y.Fragment, null, w, /* @__PURE__ */ y.createElement("div", {
    className: me(`${r}-body`, h == null ? void 0 : h.body, (t = g == null ? void 0 : g.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (n = g == null ? void 0 : g.styles) === null || n === void 0 ? void 0 : n.body), u), p == null ? void 0 : p.body)
  }, s ? /* @__PURE__ */ y.createElement(Kr, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 5
    },
    className: `${r}-body-skeleton`
  }) : f), E);
}, L$ = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, nC = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), rC = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, nC({
  opacity: e
}, {
  opacity: 1
})), M$ = (e, t) => [rC(0.7, t), nC({
  transform: L$(e)
}, {
  transform: "none"
})], D$ = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: rC(0, n),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((r, o) => Object.assign(Object.assign({}, r), {
        [`&-${o}`]: M$(o, n)
      }), {})
    }
  };
}, j$ = (e) => {
  const {
    borderRadiusSM: t,
    componentCls: n,
    zIndexPopup: r,
    colorBgMask: o,
    colorBgElevated: i,
    motionDurationSlow: a,
    motionDurationMid: s,
    paddingXS: l,
    padding: c,
    paddingLG: u,
    fontSizeLG: d,
    lineHeightLG: f,
    lineWidth: h,
    lineType: p,
    colorSplit: g,
    marginXS: v,
    colorIcon: b,
    colorIconHover: m,
    colorBgTextHover: w,
    colorBgTextActive: E,
    colorText: C,
    fontWeightStrong: x,
    footerPaddingBlock: _,
    footerPaddingInline: T,
    calc: O
  } = e, I = `${n}-content-wrapper`;
  return {
    [n]: {
      position: "fixed",
      inset: 0,
      zIndex: r,
      pointerEvents: "none",
      color: C,
      "&-pure": {
        position: "relative",
        background: i,
        display: "flex",
        flexDirection: "column",
        [`&${n}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${n}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${n}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${n}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${n}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: r,
        background: o,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [I]: {
        position: "absolute",
        zIndex: r,
        maxWidth: "100vw",
        transition: `all ${a}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${I}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${I}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${I}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${I}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${n}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: i,
        pointerEvents: "auto"
      },
      // Header
      [`${n}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${ze(c)} ${ze(u)}`,
        fontSize: d,
        lineHeight: f,
        borderBottom: `${ze(h)} ${p} ${g}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${n}-extra`]: {
        flex: "none"
      },
      [`${n}-close`]: Object.assign({
        display: "inline-flex",
        width: O(d).add(l).equal(),
        height: O(d).add(l).equal(),
        borderRadius: t,
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: v,
        color: b,
        fontWeight: x,
        fontSize: d,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${s}`,
        textRendering: "auto",
        "&:hover": {
          color: m,
          backgroundColor: w,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: E
        }
      }, Ph(e)),
      [`${n}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: e.fontWeightStrong,
        fontSize: d,
        lineHeight: f
      },
      // Body
      [`${n}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: u,
        overflow: "auto",
        [`${n}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${n}-footer`]: {
        flexShrink: 0,
        padding: `${ze(_)} ${ze(T)}`,
        borderTop: `${ze(h)} ${p} ${g}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, B$ = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), oC = qo("Drawer", (e) => {
  const t = rr(e, {});
  return [j$(t), D$(t)];
}, B$);
var iC = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const V$ = {
  distance: 180
}, Dh = (e) => {
  var t;
  const {
    rootClassName: n,
    width: r,
    height: o,
    size: i = "default",
    mask: a = !0,
    push: s = V$,
    open: l,
    afterOpenChange: c,
    onClose: u,
    prefixCls: d,
    getContainer: f,
    style: h,
    className: p,
    // Deprecated
    visible: g,
    afterVisibleChange: v,
    maskStyle: b,
    drawerStyle: m,
    contentWrapperStyle: w
  } = e, E = iC(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle"]), {
    getPopupContainer: C,
    getPrefixCls: x,
    direction: _,
    drawer: T
  } = y.useContext(kt), O = x("drawer", d), [I, L, B] = oC(O), j = (
    // 有可能为 false，所以不能直接判断
    f === void 0 && C ? () => C(document.body) : f
  ), M = me({
    "no-mask": !a,
    [`${O}-rtl`]: _ === "rtl"
  }, n, L, B);
  if (z.env.NODE_ENV !== "production") {
    const ge = nr("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"]].forEach((ie) => {
      let [he, ue] = ie;
      ge.deprecated(!(he in e), he, ue);
    }), j !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && z.env.NODE_ENV !== "production" && ge(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const q = y.useMemo(() => r ?? (i === "large" ? 736 : 378), [r, i]), N = y.useMemo(() => o ?? (i === "large" ? 736 : 378), [o, i]), $ = {
    motionName: Uo(O, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, F = (ge) => ({
    motionName: Uo(O, `panel-motion-${ge}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), H = T2(), [k, W] = Ih("Drawer", E.zIndex), {
    classNames: G = {},
    styles: ne = {}
  } = E, {
    classNames: Y = {},
    styles: fe = {}
  } = T || {};
  return I(/* @__PURE__ */ y.createElement(Lh, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ y.createElement(Ba.Provider, {
    value: W
  }, /* @__PURE__ */ y.createElement(eC, Object.assign({
    prefixCls: O,
    onClose: u,
    maskMotion: $,
    motion: F
  }, E, {
    classNames: {
      mask: me(G.mask, Y.mask),
      content: me(G.content, Y.content),
      wrapper: me(G.wrapper, Y.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, ne.mask), b), fe.mask),
      content: Object.assign(Object.assign(Object.assign({}, ne.content), m), fe.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, ne.wrapper), w), fe.wrapper)
    },
    open: l ?? g,
    mask: a,
    push: s,
    width: q,
    height: N,
    style: Object.assign(Object.assign({}, T == null ? void 0 : T.style), h),
    className: me(T == null ? void 0 : T.className, p),
    rootClassName: M,
    getContainer: j,
    afterOpenChange: c ?? v,
    panelRef: H,
    zIndex: k
  }), /* @__PURE__ */ y.createElement(tC, Object.assign({
    prefixCls: O
  }, E, {
    onClose: u
  }))))));
}, U$ = (e) => {
  const {
    prefixCls: t,
    style: n,
    className: r,
    placement: o = "right"
  } = e, i = iC(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: a
  } = y.useContext(kt), s = a("drawer", t), [l, c, u] = oC(s), d = me(s, `${s}-pure`, `${s}-${o}`, c, u, r);
  return l(/* @__PURE__ */ y.createElement("div", {
    className: d,
    style: n
  }, /* @__PURE__ */ y.createElement(tC, Object.assign({
    prefixCls: s
  }, i))));
};
Dh._InternalPanelDoNotUseOrYouWillBeFired = U$;
z.env.NODE_ENV !== "production" && (Dh.displayName = "Drawer");
var H$ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const z$ = (e) => {
  const {
    prefixCls: t,
    className: n,
    closeIcon: r,
    closable: o,
    type: i,
    title: a,
    children: s,
    footer: l
  } = e, c = H$(e, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]), {
    getPrefixCls: u
  } = y.useContext(kt), d = u(), f = t || u("modal"), h = zb(d), [p, g, v] = k2(f, h), b = `${f}-confirm`;
  let m = {};
  return i ? m = {
    closable: o ?? !1,
    title: "",
    footer: "",
    children: /* @__PURE__ */ y.createElement(N2, Object.assign({}, e, {
      prefixCls: f,
      confirmPrefixCls: b,
      rootPrefixCls: d,
      content: s
    }))
  } : m = {
    closable: o ?? !0,
    title: a,
    footer: l !== null && /* @__PURE__ */ y.createElement(P2, Object.assign({}, e)),
    children: s
  }, p(/* @__PURE__ */ y.createElement(Nh, Object.assign({
    prefixCls: f,
    className: me(g, `${f}-pure-panel`, i && b, i && `${b}-${i}`, n, v, h)
  }, c, {
    closeIcon: O2(f, r),
    closable: o
  }, m)));
}, q$ = n$(z$);
function aC(e) {
  return Wa(D2(e));
}
const or = $2;
or.useModal = t$;
or.info = function(t) {
  return Wa(j2(t));
};
or.success = function(t) {
  return Wa(B2(t));
};
or.error = function(t) {
  return Wa(V2(t));
};
or.warning = aC;
or.warn = aC;
or.confirm = function(t) {
  return Wa(U2(t));
};
or.destroyAll = function() {
  for (; Io.length; ) {
    const t = Io.pop();
    t && t();
  }
};
or.config = Zk;
or._InternalPanelDoNotUseOrYouWillBeFired = q$;
z.env.NODE_ENV !== "production" && (or.displayName = "Modal");
const C0 = ({
  quotas: e,
  workspaceId: t,
  dark: n,
  availableOrFull: r
}) => {
  const {
    t: o
  } = Fa(), i = jn(), [a, s] = wt(!0), [l, c] = wt(!1), u = e.length === 1 ? o("settings_menu.quota_warning.singular_text", {
    app: e[0].appName
  }) : o("settings_menu.quota_warning.plural_text"), d = /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    o("settings_menu.quota_warning.manage_text", {
      app: e.map((h) => h.appName).join(", ")
    }),
    /* @__PURE__ */ P.jsx(dr, { style: {
      padding: 0
    }, type: "link", onClick: () => {
      c(!0);
    }, children: o("settings_menu.quota_warning.learn_why_button") })
  ] }), f = () => {
    Ms("quota-mgt", {
      workspaceId: t ?? "",
      userLanguage: sr.language
    }, i.getAccountsURL() + `/app/quota?workspace=${t}`);
  };
  return a && e.length > 0 && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx(G$, { $dark: n, children: /* @__PURE__ */ P.jsxs("div", { className: "quota-container", children: [
      /* @__PURE__ */ P.jsxs("div", { className: "header-container", children: [
        /* @__PURE__ */ P.jsx("div", { style: {
          display: "flex",
          flexDirection: "row",
          marginLeft: "8px"
        }, children: e.map((h) => /* @__PURE__ */ P.jsx("img", { src: h.appIcon, style: {
          height: "32px",
          width: "32px",
          marginLeft: "-8px"
        }, alt: h.appName + "logo" }, h.appName)) }),
        /* @__PURE__ */ P.jsx(Bo, { className: "close-icon", onClick: () => s(!1) })
      ] }),
      /* @__PURE__ */ P.jsxs("div", { className: "body-container", children: [
        /* @__PURE__ */ P.jsx("div", { className: "title", children: o("settings_menu.quota_warning.empower_title", {
          app: e.length === 1 ? e[0].appName : o("settings_menu.quota_warning.more_apps_title")
        }) }),
        /* @__PURE__ */ P.jsx("div", { className: "content", children: r === "available" ? u : d })
      ] }),
      /* @__PURE__ */ P.jsxs(dr, { className: "button-container", onClick: f, children: [
        /* @__PURE__ */ P.jsx("div", { children: o("settings_menu.quota_warning.manage_quota_button") }),
        /* @__PURE__ */ P.jsx(ep, {})
      ] })
    ] }) }),
    /* @__PURE__ */ P.jsxs(K$, { title: !1, footer: null, closable: !1, open: l, width: 630, style: {
      padding: 0
    }, styles: {
      body: {
        padding: 0
      }
    }, maskClosable: !0, children: [
      /* @__PURE__ */ P.jsxs("div", { className: "header", children: [
        /* @__PURE__ */ P.jsx("div", { className: "title", children: o("settings_menu.quota_warning.about_title") }),
        /* @__PURE__ */ P.jsx(dr, { type: "text", className: "close", onClick: () => c(!1), children: /* @__PURE__ */ P.jsx(Bo, {}) })
      ] }),
      /* @__PURE__ */ P.jsxs("div", { className: "body", children: [
        /* @__PURE__ */ P.jsx(Bw, {}),
        /* @__PURE__ */ P.jsxs("div", { children: [
          /* @__PURE__ */ P.jsx("p", { children: o("settings_menu.quota_warning.has_area_quota_text", {
            app: e.map((h) => h.appName).join(", ")
          }) }),
          /* @__PURE__ */ P.jsx("p", { children: o("settings_menu.quota_warning.to_free_up_quota_text") })
        ] })
      ] }),
      /* @__PURE__ */ P.jsxs("div", { className: "footer", children: [
        /* @__PURE__ */ P.jsx(dr, { size: "large", type: "text", onClick: () => c(!1), children: o("common.button.dismiss") }),
        /* @__PURE__ */ P.jsxs(dr, { type: "primary", size: "large", onClick: f, children: [
          o("settings_menu.quota_warning.manage_quota_button"),
          /* @__PURE__ */ P.jsx(ep, { fill: "#fff" })
        ] })
      ] })
    ] })
  ] });
}, W$ = ee.memo(({
  workspaceId: e,
  organizationId: t,
  dark: n = !1
}) => {
  const [r, o] = wt([]), i = jn(), a = i == null ? void 0 : i.getAPIURL(), s = Mt(() => ({
    headers: i == null ? void 0 : i.getDefaultHeaders()
  }), [i]);
  return ut(() => {
    e && aw(a, s).loadAppsAndContracts(e).then(({
      fieldQuotaByApp: l,
      organizationQuotaByApp: c
    }) => {
      o(Object.values(l).map((u) => {
        let d = u.total;
        t && c[u.id] && (d = c[u.id].usageByEntity[t] ?? 0);
        let f = !1, h = !1;
        return u.assigned === 0 ? f = !0 : u.assigned >= d * 0.9 && (h = !0), {
          appName: u.name,
          appIcon: u.icon,
          warnAvailable: f,
          warnFull: h
        };
      }));
    });
  }, [e, t, a, s]), /* @__PURE__ */ P.jsx(br, { prefixCls: "cw-elements", children: /* @__PURE__ */ P.jsxs(q0, { ns: "settings-menu", children: [
    /* @__PURE__ */ P.jsx(C0, { quotas: r.filter((l) => l.warnAvailable), dark: n, workspaceId: e, availableOrFull: "available" }),
    /* @__PURE__ */ P.jsx(C0, { quotas: r.filter((l) => l.warnFull), dark: n, workspaceId: e, availableOrFull: "full" })
  ] }) });
}), G$ = Ue.div`
  .quota-container {
    font-family: 'Noto Sans', sans-serif;
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    align-items: flex-start;
    max-width: 243px;
    gap: 10px;
    margin-bottom: 12px;

    border-radius: 8px;

    ${({
  $dark: e
}) => e === !1 ? Rt`
          background-color: #fff;
          border: 1px solid #c2c7d0;
        ` : Rt`
          background-color: #232630;
          border: 1px solid #363948;
        `}

    .header-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 4px;

      width: 100%;

      .close-icon {
        cursor: pointer;
        color: #696f88;
        height: 18px;
        width: 18px;
      }
    }

    .body-container {
      .title {
        ${({
  $dark: e
}) => e === !1 ? Rt`
              color: #14151c;
            ` : Rt`
              color: #fff;
            `}

        font-family: Noto Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.105px;

        margin-bottom: 4px;
      }

      .content {
        ${({
  $dark: e
}) => e === !1 ? Rt`
              color: #363948;
            ` : Rt`
              color: #c2c7d0;
            `}

        font-family: Noto Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.105px;
      }
    }

    .button-container {
      display: flex;
      flex-direction: row;
      color: #14151c;

      cursor: pointer;

      width: 100%;
      height: 40px;

      justify-content: center;
      align-items: center;

      border-radius: 4px;
      border: 1px solid #c2c7d0;
      background: #fff;
      text-decoration: none;
      font-size: 14px;

      svg {
        margin-left: 4px;
      }

      ${({
  $dark: e
}) => {
  if (e)
    return Rt`
            color: #fff;
            background-color: transparent;
            text-decoration: none;
          `;
}}

      &:hover {
        color: unset;
        background-color: unset;
        border-color: unset;
      }
    }
  }
`, K$ = Ue(or)`
  height: 429px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    margin: -24px;
    margin-bottom: 24px;

    border-bottom: 1px solid #dfe2e7;
  }

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    gap: 8px;

    button {
      border-radius: 4px;

      &.cw-elements-btn-primary {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        background-color: #14803c;
      }
    }
  }
`, Y$ = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" })), Z$ = (e) => /* @__PURE__ */ y.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ y.createElement("path", { d: "M8.29492 16.59L12.8749 12L8.29492 7.41L9.70492 6L15.7049 12L9.70492 18L8.29492 16.59Z" }));
var xi = /* @__PURE__ */ ((e) => (e.EXTERNAL = "EXTERNAL", e.INTERNAL = "INTERNAL", e))(xi || {});
const sC = Ue.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(e) => e.$dark ? ve[80] : ln[10]};
  color: ${(e) => e.$dark ? ve[40] : ln[60]};
  transition: background-color 400ms ease-in-out;
  flex-shrink: 0;

  svg {
    width: 16px;
    transition: width 200ms ease-in-out;
  }
`, lC = Ue.div`
  position: absolute;
  box-sizing: border-box;
  right: 8px;
  opacity: 0;
  transition: opacity 200ms ease-in-out;
`, Q$ = Ue.p`
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  text-align: start;
  font-family: 'Noto Sans', sans-serif;
`, w0 = Rt`
  color: ${(e) => e.$dark ? ve[10] : ve[100]};
  background-color: ${(e) => e.$dark ? ve[80] : ln[10]};

  ${sC} {
    background-color: ${(e) => e.$dark ? ve[100] : ln[20]};
  }

  ${lC} {
    opacity: 1;
  }
`, E0 = Ue.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  transition: background-color 400ms ease-in-out;
  color: ${(e) => e.$dark ? ve[10] : ve[100]};
  border: none;
  background: none;
  text-decoration: none;
  width: 100%;

  &:hover {
    ${w0}
  }

  ${({
  $isHover: e
}) => e && w0};
`, _0 = Ue.button`
  border: 0;
  display: none;
  border-radius: 4px;
  width: 32px;
  height: auto;
  align-items: center;
  justify-content: center;
  background-color: ${(e) => e.$dark ? ve[80] : ln[10]};
  cursor: pointer;
  color: ${(e) => e.$dark ? "#A3A9B9" : "#0071CD"};

  &:hover {
    display: flex;
  }

  ${({
  $isHover: e
}) => e && Rt`
      display: flex;
    `};
`, X$ = ({
  icon: e,
  label: t,
  tooltipText: n,
  loading: r,
  extraButtonTooltipText: o,
  dark: i = !1,
  secondButton: a,
  hoverType: s = xi.EXTERNAL,
  ...l
}) => {
  const [c, u] = wt(!1), d = () => /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx(sC, { $dark: i, children: e }),
    /* @__PURE__ */ P.jsx(Q$, { children: t }),
    s === xi.EXTERNAL && /* @__PURE__ */ P.jsx(lC, { children: /* @__PURE__ */ P.jsx(X0, { dark: i }) })
  ] }), f = (p) => /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx(fo, { title: n, placement: "left", color: i ? ve[70] : ve[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ P.jsx(E0, { as: "a", href: p, $dark: i, $isHover: c, children: d() }) }),
    a && /* @__PURE__ */ P.jsx(fo, { title: o, placement: "left", color: i ? ve[70] : ve[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ P.jsx(_0, { onClick: a, $isHover: c, $dark: i, "aria-label": o, children: /* @__PURE__ */ P.jsx(tp, { "data-testid": "extraButton" }) }) })
  ] }), h = (p) => /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx(fo, { title: n, placement: "left", color: i ? ve[70] : ve[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ P.jsx(E0, { as: "button", type: "button", onClick: p, $dark: i, $isHover: c, children: d() }) }),
    a && /* @__PURE__ */ P.jsx(fo, { title: o, placement: "left", color: i ? ve[70] : ve[90], overlayInnerStyle: {
      borderRadius: 4
    }, children: /* @__PURE__ */ P.jsx(_0, { onClick: a, $isHover: c, $dark: i, "aria-label": o, children: /* @__PURE__ */ P.jsx(tp, {}) }) })
  ] });
  return /* @__PURE__ */ P.jsx("div", { onMouseEnter: () => u(!0), onMouseLeave: () => u(!1), style: {
    display: "flex",
    gap: "5px"
  }, children: r ? /* @__PURE__ */ P.jsx("div", { "data-testid": "skeleton", children: /* @__PURE__ */ P.jsx(Kr, { avatar: {
    size: "small",
    shape: "circle"
  }, paragraph: !1, active: !0 }) }) : l.onClick ? h(l.onClick) : f(l.link) });
}, J$ = Ue.div`
  color: ${(e) => e.theme.colors[e.$dark, "cws_neutral_100"]};
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid
    ${(e) => e.theme.colors[e.$dark ? "cws_neutral_80" : "cws_neutral_20"]};

  & + & {
    margin-top: 12px;
  }
`, Xu = Ue.base`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 4px;
  margin-bottom: 12px;
  border-radius: 4px;
  transition: background-color 400ms ease-in-out;
  cursor: default;
  border: none;
  background: none;
  text-decoration: none;
  color: ${(e) => e.theme.colors[e.$dark ? "cws_neutral_00" : "cws_neutral_100"]};
  font-family: 'Noto Sans', sans-serif;

  .title {
    font-weight: 500;
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: ${(e) => e.theme.colors[e.$dark ? "cws_neutral_00" : "cws_neutral_100"]};
  }

  svg {
    color: ${(e) => e.theme.colors[e.$dark ? "cws_neutral_40" : "cws_neutral_60"]};
    transition: transform 400ms ease-in-out;
    margin-left: 4px;
    font-size: 12px;
  }

  ${({
  $withAction: e,
  theme: t,
  $dark: n
}) => e && `
    cursor: pointer;
    
    &:hover {
      background-color: ${t.colors[n ? "cws_neutral_80" : "cws_blue_10"]};
    
      .title + svg {
        transform: translateX(4px);
      }
    }
  `}

  & + & {
    margin-top: 12px;
  }

  &:hover {
    .new-tab-icon {
      display: none;
    }

    .arrow-icon {
      display: inline-block;
    }
  }

  .new-tab-icon {
    display: inline-block;
  }

  .arrow-icon {
    display: none;
    height: 16px;
    width: 16px;
  }
`, eN = Ue.div`
  display: flex;
  align-items: center;
  margin-right: 4px;

  svg {
    width: 20px;
  }
`, tN = Ue.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .cw-elements-skeleton {
    display: flex !important;
    align-items: center;

    &-title {
      margin: 0 !important;
    }
  }
`, nN = ({
  title: e,
  tooltipText: t,
  icon: n,
  loading: r,
  items: o,
  dark: i = !1,
  ...a
}) => {
  const s = !!a.onClickTitle, l = !!a.titleLink, c = () => /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    n && /* @__PURE__ */ P.jsx(eN, { children: n }),
    /* @__PURE__ */ P.jsx("h2", { className: "title", children: e }),
    !n && (s || l) && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
      /* @__PURE__ */ P.jsx(X0, { className: "new-tab-icon" }),
      /* @__PURE__ */ P.jsx(Y$, { className: "arrow-icon" })
    ] })
  ] }), u = () => /* @__PURE__ */ P.jsx(Xu, { $dark: i, $withAction: s, as: "button", type: "button", onClick: a.onClickTitle, children: c() }), d = () => /* @__PURE__ */ P.jsx(Xu, { $dark: i, $withAction: l, as: "a", href: a.titleLink, children: c() }), f = () => /* @__PURE__ */ P.jsx(Xu, { $dark: i, as: "div", children: c() });
  return /* @__PURE__ */ P.jsxs(J$, { $dark: i, children: [
    /* @__PURE__ */ P.jsx(fo, { placement: "left", title: t, color: i ? "#4D5165" : "#232630", overlayInnerStyle: {
      borderRadius: 4
    }, children: s ? u() : l ? d() : f() }),
    /* @__PURE__ */ P.jsx(tN, { children: o.map(({
      key: h,
      ...p
    }) => /* @__PURE__ */ P.jsx(X$, { ...p, loading: r, dark: i }, h)) })
  ] });
};
function cC(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: rN } = Object.prototype, { getPrototypeOf: jh } = Object, xc = /* @__PURE__ */ ((e) => (t) => {
  const n = rN.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Cr = (e) => (e = e.toLowerCase(), (t) => xc(t) === e), Sc = (e) => (t) => typeof t === e, { isArray: Gi } = Array, ka = Sc("undefined");
function oN(e) {
  return e !== null && !ka(e) && e.constructor !== null && !ka(e.constructor) && Vn(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const uC = Cr("ArrayBuffer");
function iN(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && uC(e.buffer), t;
}
const aN = Sc("string"), Vn = Sc("function"), dC = Sc("number"), Tc = (e) => e !== null && typeof e == "object", sN = (e) => e === !0 || e === !1, cl = (e) => {
  if (xc(e) !== "object")
    return !1;
  const t = jh(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, lN = Cr("Date"), cN = Cr("File"), uN = Cr("Blob"), dN = Cr("FileList"), fN = (e) => Tc(e) && Vn(e.pipe), hN = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Vn(e.append) && ((t = xc(e)) === "formdata" || // detect form-data instance
  t === "object" && Vn(e.toString) && e.toString() === "[object FormData]"));
}, pN = Cr("URLSearchParams"), [vN, gN, mN, yN] = ["ReadableStream", "Request", "Response", "Headers"].map(Cr), bN = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ka(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Gi(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let s;
    for (r = 0; r < a; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function fC(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const ko = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : Bn, hC = (e) => !ka(e) && e !== ko;
function Nf() {
  const { caseless: e } = hC(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && fC(t, o) || o;
    cl(t[i]) && cl(r) ? t[i] = Nf(t[i], r) : cl(r) ? t[i] = Nf({}, r) : Gi(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Ka(arguments[r], n);
  return t;
}
const CN = (e, t, n, { allOwnKeys: r } = {}) => (Ka(t, (o, i) => {
  n && Vn(o) ? e[i] = cC(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), wN = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), EN = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, _N = (e, t, n, r) => {
  let o, i, a;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && jh(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, xN = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, SN = (e) => {
  if (!e)
    return null;
  if (Gi(e))
    return e;
  let t = e.length;
  if (!dC(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, TN = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && jh(Uint8Array)), ON = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, PN = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, RN = Cr("HTMLFormElement"), AN = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), x0 = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), IN = Cr("RegExp"), pC = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Ka(n, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (r[i] = a || o);
  }), Object.defineProperties(e, r);
}, kN = (e) => {
  pC(e, (t, n) => {
    if (Vn(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Vn(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, $N = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return Gi(e) ? r(e) : r(String(e).split(t)), n;
}, NN = () => {
}, FN = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Ju = "abcdefghijklmnopqrstuvwxyz", S0 = "0123456789", vC = {
  DIGIT: S0,
  ALPHA: Ju,
  ALPHA_DIGIT: Ju + Ju.toUpperCase() + S0
}, LN = (e = 16, t = vC.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function MN(e) {
  return !!(e && Vn(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const DN = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (Tc(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = Gi(r) ? [] : {};
        return Ka(r, (a, s) => {
          const l = n(a, o + 1);
          !ka(l) && (i[s] = l);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, jN = Cr("AsyncFunction"), BN = (e) => e && (Tc(e) || Vn(e)) && Vn(e.then) && Vn(e.catch), gC = ((e, t) => e ? setImmediate : t ? ((n, r) => (ko.addEventListener("message", ({ source: o, data: i }) => {
  o === ko && i === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), ko.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Vn(ko.postMessage)
), VN = typeof queueMicrotask < "u" ? queueMicrotask.bind(ko) : typeof z < "u" && z.nextTick || gC, Z = {
  isArray: Gi,
  isArrayBuffer: uC,
  isBuffer: oN,
  isFormData: hN,
  isArrayBufferView: iN,
  isString: aN,
  isNumber: dC,
  isBoolean: sN,
  isObject: Tc,
  isPlainObject: cl,
  isReadableStream: vN,
  isRequest: gN,
  isResponse: mN,
  isHeaders: yN,
  isUndefined: ka,
  isDate: lN,
  isFile: cN,
  isBlob: uN,
  isRegExp: IN,
  isFunction: Vn,
  isStream: fN,
  isURLSearchParams: pN,
  isTypedArray: TN,
  isFileList: dN,
  forEach: Ka,
  merge: Nf,
  extend: CN,
  trim: bN,
  stripBOM: wN,
  inherits: EN,
  toFlatObject: _N,
  kindOf: xc,
  kindOfTest: Cr,
  endsWith: xN,
  toArray: SN,
  forEachEntry: ON,
  matchAll: PN,
  isHTMLForm: RN,
  hasOwnProperty: x0,
  hasOwnProp: x0,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pC,
  freezeMethods: kN,
  toObjectSet: $N,
  toCamelCase: AN,
  noop: NN,
  toFiniteNumber: FN,
  findKey: fC,
  global: ko,
  isContextDefined: hC,
  ALPHABET: vC,
  generateString: LN,
  isSpecCompliantForm: MN,
  toJSONObject: DN,
  isAsyncFn: jN,
  isThenable: BN,
  setImmediate: gC,
  asap: VN
};
var Rr = [], Qn = [], UN = typeof Uint8Array < "u" ? Uint8Array : Array, Bh = !1;
function mC() {
  Bh = !0;
  for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, n = e.length; t < n; ++t)
    Rr[t] = e[t], Qn[e.charCodeAt(t)] = t;
  Qn[45] = 62, Qn[95] = 63;
}
function HN(e) {
  Bh || mC();
  var t, n, r, o, i, a, s = e.length;
  if (s % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  i = e[s - 2] === "=" ? 2 : e[s - 1] === "=" ? 1 : 0, a = new UN(s * 3 / 4 - i), r = i > 0 ? s - 4 : s;
  var l = 0;
  for (t = 0, n = 0; t < r; t += 4, n += 3)
    o = Qn[e.charCodeAt(t)] << 18 | Qn[e.charCodeAt(t + 1)] << 12 | Qn[e.charCodeAt(t + 2)] << 6 | Qn[e.charCodeAt(t + 3)], a[l++] = o >> 16 & 255, a[l++] = o >> 8 & 255, a[l++] = o & 255;
  return i === 2 ? (o = Qn[e.charCodeAt(t)] << 2 | Qn[e.charCodeAt(t + 1)] >> 4, a[l++] = o & 255) : i === 1 && (o = Qn[e.charCodeAt(t)] << 10 | Qn[e.charCodeAt(t + 1)] << 4 | Qn[e.charCodeAt(t + 2)] >> 2, a[l++] = o >> 8 & 255, a[l++] = o & 255), a;
}
function zN(e) {
  return Rr[e >> 18 & 63] + Rr[e >> 12 & 63] + Rr[e >> 6 & 63] + Rr[e & 63];
}
function qN(e, t, n) {
  for (var r, o = [], i = t; i < n; i += 3)
    r = (e[i] << 16) + (e[i + 1] << 8) + e[i + 2], o.push(zN(r));
  return o.join("");
}
function T0(e) {
  Bh || mC();
  for (var t, n = e.length, r = n % 3, o = "", i = [], a = 16383, s = 0, l = n - r; s < l; s += a)
    i.push(qN(e, s, s + a > l ? l : s + a));
  return r === 1 ? (t = e[n - 1], o += Rr[t >> 2], o += Rr[t << 4 & 63], o += "==") : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], o += Rr[t >> 10], o += Rr[t >> 4 & 63], o += Rr[t << 2 & 63], o += "="), i.push(o), i.join("");
}
function Oc(e, t, n, r, o) {
  var i, a, s = o * 8 - r - 1, l = (1 << s) - 1, c = l >> 1, u = -7, d = n ? o - 1 : 0, f = n ? -1 : 1, h = e[t + d];
  for (d += f, i = h & (1 << -u) - 1, h >>= -u, u += s; u > 0; i = i * 256 + e[t + d], d += f, u -= 8)
    ;
  for (a = i & (1 << -u) - 1, i >>= -u, u += r; u > 0; a = a * 256 + e[t + d], d += f, u -= 8)
    ;
  if (i === 0)
    i = 1 - c;
  else {
    if (i === l)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, r), i = i - c;
  }
  return (h ? -1 : 1) * a * Math.pow(2, i - r);
}
function yC(e, t, n, r, o, i) {
  var a, s, l, c = i * 8 - o - 1, u = (1 << c) - 1, d = u >> 1, f = o === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : i - 1, p = r ? 1 : -1, g = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = u) : (a = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), a + d >= 1 ? t += f / l : t += f * Math.pow(2, 1 - d), t * l >= 2 && (a++, l /= 2), a + d >= u ? (s = 0, a = u) : a + d >= 1 ? (s = (t * l - 1) * Math.pow(2, o), a = a + d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, o), a = 0)); o >= 8; e[n + h] = s & 255, h += p, s /= 256, o -= 8)
    ;
  for (a = a << o | s, c += o; c > 0; e[n + h] = a & 255, h += p, a /= 256, c -= 8)
    ;
  e[n + h - p] |= g * 128;
}
var WN = {}.toString, bC = Array.isArray || function(e) {
  return WN.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
var GN = 50;
oe.TYPED_ARRAY_SUPPORT = Bn.TYPED_ARRAY_SUPPORT !== void 0 ? Bn.TYPED_ARRAY_SUPPORT : !0;
Ll();
function Ll() {
  return oe.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function Br(e, t) {
  if (Ll() < t)
    throw new RangeError("Invalid typed array length");
  return oe.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t), e.__proto__ = oe.prototype) : (e === null && (e = new oe(t)), e.length = t), e;
}
function oe(e, t, n) {
  if (!oe.TYPED_ARRAY_SUPPORT && !(this instanceof oe))
    return new oe(e, t, n);
  if (typeof e == "number") {
    if (typeof t == "string")
      throw new Error("If encoding is specified then the first argument must be a string");
    return Vh(this, e);
  }
  return CC(this, e, t, n);
}
oe.poolSize = 8192;
oe._augment = function(e) {
  return e.__proto__ = oe.prototype, e;
};
function CC(e, t, n, r) {
  if (typeof t == "number")
    throw new TypeError('"value" argument must not be a number');
  return typeof ArrayBuffer < "u" && t instanceof ArrayBuffer ? ZN(e, t, n, r) : typeof t == "string" ? YN(e, t, n) : QN(e, t);
}
oe.from = function(e, t, n) {
  return CC(null, e, t, n);
};
oe.TYPED_ARRAY_SUPPORT && (oe.prototype.__proto__ = Uint8Array.prototype, oe.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && oe[Symbol.species]);
function wC(e) {
  if (typeof e != "number")
    throw new TypeError('"size" argument must be a number');
  if (e < 0)
    throw new RangeError('"size" argument must not be negative');
}
function KN(e, t, n, r) {
  return wC(t), t <= 0 ? Br(e, t) : n !== void 0 ? typeof r == "string" ? Br(e, t).fill(n, r) : Br(e, t).fill(n) : Br(e, t);
}
oe.alloc = function(e, t, n) {
  return KN(null, e, t, n);
};
function Vh(e, t) {
  if (wC(t), e = Br(e, t < 0 ? 0 : Uh(t) | 0), !oe.TYPED_ARRAY_SUPPORT)
    for (var n = 0; n < t; ++n)
      e[n] = 0;
  return e;
}
oe.allocUnsafe = function(e) {
  return Vh(null, e);
};
oe.allocUnsafeSlow = function(e) {
  return Vh(null, e);
};
function YN(e, t, n) {
  if ((typeof n != "string" || n === "") && (n = "utf8"), !oe.isEncoding(n))
    throw new TypeError('"encoding" must be a valid string encoding');
  var r = EC(t, n) | 0;
  e = Br(e, r);
  var o = e.write(t, n);
  return o !== r && (e = e.slice(0, o)), e;
}
function Ff(e, t) {
  var n = t.length < 0 ? 0 : Uh(t.length) | 0;
  e = Br(e, n);
  for (var r = 0; r < n; r += 1)
    e[r] = t[r] & 255;
  return e;
}
function ZN(e, t, n, r) {
  if (t.byteLength, n < 0 || t.byteLength < n)
    throw new RangeError("'offset' is out of bounds");
  if (t.byteLength < n + (r || 0))
    throw new RangeError("'length' is out of bounds");
  return n === void 0 && r === void 0 ? t = new Uint8Array(t) : r === void 0 ? t = new Uint8Array(t, n) : t = new Uint8Array(t, n, r), oe.TYPED_ARRAY_SUPPORT ? (e = t, e.__proto__ = oe.prototype) : e = Ff(e, t), e;
}
function QN(e, t) {
  if ($r(t)) {
    var n = Uh(t.length) | 0;
    return e = Br(e, n), e.length === 0 || t.copy(e, 0, 0, n), e;
  }
  if (t) {
    if (typeof ArrayBuffer < "u" && t.buffer instanceof ArrayBuffer || "length" in t)
      return typeof t.length != "number" || gF(t.length) ? Br(e, 0) : Ff(e, t);
    if (t.type === "Buffer" && bC(t.data))
      return Ff(e, t.data);
  }
  throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function Uh(e) {
  if (e >= Ll())
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Ll().toString(16) + " bytes");
  return e | 0;
}
oe.isBuffer = mF;
function $r(e) {
  return !!(e != null && e._isBuffer);
}
oe.compare = function(t, n) {
  if (!$r(t) || !$r(n))
    throw new TypeError("Arguments must be Buffers");
  if (t === n)
    return 0;
  for (var r = t.length, o = n.length, i = 0, a = Math.min(r, o); i < a; ++i)
    if (t[i] !== n[i]) {
      r = t[i], o = n[i];
      break;
    }
  return r < o ? -1 : o < r ? 1 : 0;
};
oe.isEncoding = function(t) {
  switch (String(t).toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "latin1":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
      return !0;
    default:
      return !1;
  }
};
oe.concat = function(t, n) {
  if (!bC(t))
    throw new TypeError('"list" argument must be an Array of Buffers');
  if (t.length === 0)
    return oe.alloc(0);
  var r;
  if (n === void 0)
    for (n = 0, r = 0; r < t.length; ++r)
      n += t[r].length;
  var o = oe.allocUnsafe(n), i = 0;
  for (r = 0; r < t.length; ++r) {
    var a = t[r];
    if (!$r(a))
      throw new TypeError('"list" argument must be an Array of Buffers');
    a.copy(o, i), i += a.length;
  }
  return o;
};
function EC(e, t) {
  if ($r(e))
    return e.length;
  if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer))
    return e.byteLength;
  typeof e != "string" && (e = "" + e);
  var n = e.length;
  if (n === 0)
    return 0;
  for (var r = !1; ; )
    switch (t) {
      case "ascii":
      case "latin1":
      case "binary":
        return n;
      case "utf8":
      case "utf-8":
      case void 0:
        return Ml(e).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return n * 2;
      case "hex":
        return n >>> 1;
      case "base64":
        return RC(e).length;
      default:
        if (r)
          return Ml(e).length;
        t = ("" + t).toLowerCase(), r = !0;
    }
}
oe.byteLength = EC;
function XN(e, t, n) {
  var r = !1;
  if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, t >>>= 0, n <= t))
    return "";
  for (e || (e = "utf8"); ; )
    switch (e) {
      case "hex":
        return lF(this, t, n);
      case "utf8":
      case "utf-8":
        return SC(this, t, n);
      case "ascii":
        return aF(this, t, n);
      case "latin1":
      case "binary":
        return sF(this, t, n);
      case "base64":
        return oF(this, t, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return cF(this, t, n);
      default:
        if (r)
          throw new TypeError("Unknown encoding: " + e);
        e = (e + "").toLowerCase(), r = !0;
    }
}
oe.prototype._isBuffer = !0;
function $o(e, t, n) {
  var r = e[t];
  e[t] = e[n], e[n] = r;
}
oe.prototype.swap16 = function() {
  var t = this.length;
  if (t % 2 !== 0)
    throw new RangeError("Buffer size must be a multiple of 16-bits");
  for (var n = 0; n < t; n += 2)
    $o(this, n, n + 1);
  return this;
};
oe.prototype.swap32 = function() {
  var t = this.length;
  if (t % 4 !== 0)
    throw new RangeError("Buffer size must be a multiple of 32-bits");
  for (var n = 0; n < t; n += 4)
    $o(this, n, n + 3), $o(this, n + 1, n + 2);
  return this;
};
oe.prototype.swap64 = function() {
  var t = this.length;
  if (t % 8 !== 0)
    throw new RangeError("Buffer size must be a multiple of 64-bits");
  for (var n = 0; n < t; n += 8)
    $o(this, n, n + 7), $o(this, n + 1, n + 6), $o(this, n + 2, n + 5), $o(this, n + 3, n + 4);
  return this;
};
oe.prototype.toString = function() {
  var t = this.length | 0;
  return t === 0 ? "" : arguments.length === 0 ? SC(this, 0, t) : XN.apply(this, arguments);
};
oe.prototype.equals = function(t) {
  if (!$r(t))
    throw new TypeError("Argument must be a Buffer");
  return this === t ? !0 : oe.compare(this, t) === 0;
};
oe.prototype.inspect = function() {
  var t = "", n = GN;
  return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">";
};
oe.prototype.compare = function(t, n, r, o, i) {
  if (!$r(t))
    throw new TypeError("Argument must be a Buffer");
  if (n === void 0 && (n = 0), r === void 0 && (r = t ? t.length : 0), o === void 0 && (o = 0), i === void 0 && (i = this.length), n < 0 || r > t.length || o < 0 || i > this.length)
    throw new RangeError("out of range index");
  if (o >= i && n >= r)
    return 0;
  if (o >= i)
    return -1;
  if (n >= r)
    return 1;
  if (n >>>= 0, r >>>= 0, o >>>= 0, i >>>= 0, this === t)
    return 0;
  for (var a = i - o, s = r - n, l = Math.min(a, s), c = this.slice(o, i), u = t.slice(n, r), d = 0; d < l; ++d)
    if (c[d] !== u[d]) {
      a = c[d], s = u[d];
      break;
    }
  return a < s ? -1 : s < a ? 1 : 0;
};
function _C(e, t, n, r, o) {
  if (e.length === 0)
    return -1;
  if (typeof n == "string" ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = o ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
    if (o)
      return -1;
    n = e.length - 1;
  } else if (n < 0)
    if (o)
      n = 0;
    else
      return -1;
  if (typeof t == "string" && (t = oe.from(t, r)), $r(t))
    return t.length === 0 ? -1 : O0(e, t, n, r, o);
  if (typeof t == "number")
    return t = t & 255, oe.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? o ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : O0(e, [t], n, r, o);
  throw new TypeError("val must be string, number or Buffer");
}
function O0(e, t, n, r, o) {
  var i = 1, a = e.length, s = t.length;
  if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
    if (e.length < 2 || t.length < 2)
      return -1;
    i = 2, a /= 2, s /= 2, n /= 2;
  }
  function l(h, p) {
    return i === 1 ? h[p] : h.readUInt16BE(p * i);
  }
  var c;
  if (o) {
    var u = -1;
    for (c = n; c < a; c++)
      if (l(e, c) === l(t, u === -1 ? 0 : c - u)) {
        if (u === -1 && (u = c), c - u + 1 === s)
          return u * i;
      } else
        u !== -1 && (c -= c - u), u = -1;
  } else
    for (n + s > a && (n = a - s), c = n; c >= 0; c--) {
      for (var d = !0, f = 0; f < s; f++)
        if (l(e, c + f) !== l(t, f)) {
          d = !1;
          break;
        }
      if (d)
        return c;
    }
  return -1;
}
oe.prototype.includes = function(t, n, r) {
  return this.indexOf(t, n, r) !== -1;
};
oe.prototype.indexOf = function(t, n, r) {
  return _C(this, t, n, r, !0);
};
oe.prototype.lastIndexOf = function(t, n, r) {
  return _C(this, t, n, r, !1);
};
function JN(e, t, n, r) {
  n = Number(n) || 0;
  var o = e.length - n;
  r ? (r = Number(r), r > o && (r = o)) : r = o;
  var i = t.length;
  if (i % 2 !== 0)
    throw new TypeError("Invalid hex string");
  r > i / 2 && (r = i / 2);
  for (var a = 0; a < r; ++a) {
    var s = parseInt(t.substr(a * 2, 2), 16);
    if (isNaN(s))
      return a;
    e[n + a] = s;
  }
  return a;
}
function eF(e, t, n, r) {
  return Ac(Ml(t, e.length - n), e, n, r);
}
function xC(e, t, n, r) {
  return Ac(pF(t), e, n, r);
}
function tF(e, t, n, r) {
  return xC(e, t, n, r);
}
function nF(e, t, n, r) {
  return Ac(RC(t), e, n, r);
}
function rF(e, t, n, r) {
  return Ac(vF(t, e.length - n), e, n, r);
}
oe.prototype.write = function(t, n, r, o) {
  if (n === void 0)
    o = "utf8", r = this.length, n = 0;
  else if (r === void 0 && typeof n == "string")
    o = n, r = this.length, n = 0;
  else if (isFinite(n))
    n = n | 0, isFinite(r) ? (r = r | 0, o === void 0 && (o = "utf8")) : (o = r, r = void 0);
  else
    throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
  var i = this.length - n;
  if ((r === void 0 || r > i) && (r = i), t.length > 0 && (r < 0 || n < 0) || n > this.length)
    throw new RangeError("Attempt to write outside buffer bounds");
  o || (o = "utf8");
  for (var a = !1; ; )
    switch (o) {
      case "hex":
        return JN(this, t, n, r);
      case "utf8":
      case "utf-8":
        return eF(this, t, n, r);
      case "ascii":
        return xC(this, t, n, r);
      case "latin1":
      case "binary":
        return tF(this, t, n, r);
      case "base64":
        return nF(this, t, n, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return rF(this, t, n, r);
      default:
        if (a)
          throw new TypeError("Unknown encoding: " + o);
        o = ("" + o).toLowerCase(), a = !0;
    }
};
oe.prototype.toJSON = function() {
  return {
    type: "Buffer",
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function oF(e, t, n) {
  return t === 0 && n === e.length ? T0(e) : T0(e.slice(t, n));
}
function SC(e, t, n) {
  n = Math.min(e.length, n);
  for (var r = [], o = t; o < n; ) {
    var i = e[o], a = null, s = i > 239 ? 4 : i > 223 ? 3 : i > 191 ? 2 : 1;
    if (o + s <= n) {
      var l, c, u, d;
      switch (s) {
        case 1:
          i < 128 && (a = i);
          break;
        case 2:
          l = e[o + 1], (l & 192) === 128 && (d = (i & 31) << 6 | l & 63, d > 127 && (a = d));
          break;
        case 3:
          l = e[o + 1], c = e[o + 2], (l & 192) === 128 && (c & 192) === 128 && (d = (i & 15) << 12 | (l & 63) << 6 | c & 63, d > 2047 && (d < 55296 || d > 57343) && (a = d));
          break;
        case 4:
          l = e[o + 1], c = e[o + 2], u = e[o + 3], (l & 192) === 128 && (c & 192) === 128 && (u & 192) === 128 && (d = (i & 15) << 18 | (l & 63) << 12 | (c & 63) << 6 | u & 63, d > 65535 && d < 1114112 && (a = d));
      }
    }
    a === null ? (a = 65533, s = 1) : a > 65535 && (a -= 65536, r.push(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), r.push(a), o += s;
  }
  return iF(r);
}
var P0 = 4096;
function iF(e) {
  var t = e.length;
  if (t <= P0)
    return String.fromCharCode.apply(String, e);
  for (var n = "", r = 0; r < t; )
    n += String.fromCharCode.apply(String, e.slice(r, r += P0));
  return n;
}
function aF(e, t, n) {
  var r = "";
  n = Math.min(e.length, n);
  for (var o = t; o < n; ++o)
    r += String.fromCharCode(e[o] & 127);
  return r;
}
function sF(e, t, n) {
  var r = "";
  n = Math.min(e.length, n);
  for (var o = t; o < n; ++o)
    r += String.fromCharCode(e[o]);
  return r;
}
function lF(e, t, n) {
  var r = e.length;
  (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
  for (var o = "", i = t; i < n; ++i)
    o += hF(e[i]);
  return o;
}
function cF(e, t, n) {
  for (var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)
    o += String.fromCharCode(r[i] + r[i + 1] * 256);
  return o;
}
oe.prototype.slice = function(t, n) {
  var r = this.length;
  t = ~~t, n = n === void 0 ? r : ~~n, t < 0 ? (t += r, t < 0 && (t = 0)) : t > r && (t = r), n < 0 ? (n += r, n < 0 && (n = 0)) : n > r && (n = r), n < t && (n = t);
  var o;
  if (oe.TYPED_ARRAY_SUPPORT)
    o = this.subarray(t, n), o.__proto__ = oe.prototype;
  else {
    var i = n - t;
    o = new oe(i, void 0);
    for (var a = 0; a < i; ++a)
      o[a] = this[a + t];
  }
  return o;
};
function dn(e, t, n) {
  if (e % 1 !== 0 || e < 0)
    throw new RangeError("offset is not uint");
  if (e + t > n)
    throw new RangeError("Trying to access beyond buffer length");
}
oe.prototype.readUIntLE = function(t, n, r) {
  t = t | 0, n = n | 0, r || dn(t, n, this.length);
  for (var o = this[t], i = 1, a = 0; ++a < n && (i *= 256); )
    o += this[t + a] * i;
  return o;
};
oe.prototype.readUIntBE = function(t, n, r) {
  t = t | 0, n = n | 0, r || dn(t, n, this.length);
  for (var o = this[t + --n], i = 1; n > 0 && (i *= 256); )
    o += this[t + --n] * i;
  return o;
};
oe.prototype.readUInt8 = function(t, n) {
  return n || dn(t, 1, this.length), this[t];
};
oe.prototype.readUInt16LE = function(t, n) {
  return n || dn(t, 2, this.length), this[t] | this[t + 1] << 8;
};
oe.prototype.readUInt16BE = function(t, n) {
  return n || dn(t, 2, this.length), this[t] << 8 | this[t + 1];
};
oe.prototype.readUInt32LE = function(t, n) {
  return n || dn(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + this[t + 3] * 16777216;
};
oe.prototype.readUInt32BE = function(t, n) {
  return n || dn(t, 4, this.length), this[t] * 16777216 + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
};
oe.prototype.readIntLE = function(t, n, r) {
  t = t | 0, n = n | 0, r || dn(t, n, this.length);
  for (var o = this[t], i = 1, a = 0; ++a < n && (i *= 256); )
    o += this[t + a] * i;
  return i *= 128, o >= i && (o -= Math.pow(2, 8 * n)), o;
};
oe.prototype.readIntBE = function(t, n, r) {
  t = t | 0, n = n | 0, r || dn(t, n, this.length);
  for (var o = n, i = 1, a = this[t + --o]; o > 0 && (i *= 256); )
    a += this[t + --o] * i;
  return i *= 128, a >= i && (a -= Math.pow(2, 8 * n)), a;
};
oe.prototype.readInt8 = function(t, n) {
  return n || dn(t, 1, this.length), this[t] & 128 ? (255 - this[t] + 1) * -1 : this[t];
};
oe.prototype.readInt16LE = function(t, n) {
  n || dn(t, 2, this.length);
  var r = this[t] | this[t + 1] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
oe.prototype.readInt16BE = function(t, n) {
  n || dn(t, 2, this.length);
  var r = this[t + 1] | this[t] << 8;
  return r & 32768 ? r | 4294901760 : r;
};
oe.prototype.readInt32LE = function(t, n) {
  return n || dn(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
};
oe.prototype.readInt32BE = function(t, n) {
  return n || dn(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
};
oe.prototype.readFloatLE = function(t, n) {
  return n || dn(t, 4, this.length), Oc(this, t, !0, 23, 4);
};
oe.prototype.readFloatBE = function(t, n) {
  return n || dn(t, 4, this.length), Oc(this, t, !1, 23, 4);
};
oe.prototype.readDoubleLE = function(t, n) {
  return n || dn(t, 8, this.length), Oc(this, t, !0, 52, 8);
};
oe.prototype.readDoubleBE = function(t, n) {
  return n || dn(t, 8, this.length), Oc(this, t, !1, 52, 8);
};
function In(e, t, n, r, o, i) {
  if (!$r(e))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (t > o || t < i)
    throw new RangeError('"value" argument is out of bounds');
  if (n + r > e.length)
    throw new RangeError("Index out of range");
}
oe.prototype.writeUIntLE = function(t, n, r, o) {
  if (t = +t, n = n | 0, r = r | 0, !o) {
    var i = Math.pow(2, 8 * r) - 1;
    In(this, t, n, r, i, 0);
  }
  var a = 1, s = 0;
  for (this[n] = t & 255; ++s < r && (a *= 256); )
    this[n + s] = t / a & 255;
  return n + r;
};
oe.prototype.writeUIntBE = function(t, n, r, o) {
  if (t = +t, n = n | 0, r = r | 0, !o) {
    var i = Math.pow(2, 8 * r) - 1;
    In(this, t, n, r, i, 0);
  }
  var a = r - 1, s = 1;
  for (this[n + a] = t & 255; --a >= 0 && (s *= 256); )
    this[n + a] = t / s & 255;
  return n + r;
};
oe.prototype.writeUInt8 = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 1, 255, 0), oe.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[n] = t & 255, n + 1;
};
function Pc(e, t, n, r) {
  t < 0 && (t = 65535 + t + 1);
  for (var o = 0, i = Math.min(e.length - n, 2); o < i; ++o)
    e[n + o] = (t & 255 << 8 * (r ? o : 1 - o)) >>> (r ? o : 1 - o) * 8;
}
oe.prototype.writeUInt16LE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 2, 65535, 0), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t & 255, this[n + 1] = t >>> 8) : Pc(this, t, n, !0), n + 2;
};
oe.prototype.writeUInt16BE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 2, 65535, 0), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 8, this[n + 1] = t & 255) : Pc(this, t, n, !1), n + 2;
};
function Rc(e, t, n, r) {
  t < 0 && (t = 4294967295 + t + 1);
  for (var o = 0, i = Math.min(e.length - n, 4); o < i; ++o)
    e[n + o] = t >>> (r ? o : 3 - o) * 8 & 255;
}
oe.prototype.writeUInt32LE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 4, 4294967295, 0), oe.TYPED_ARRAY_SUPPORT ? (this[n + 3] = t >>> 24, this[n + 2] = t >>> 16, this[n + 1] = t >>> 8, this[n] = t & 255) : Rc(this, t, n, !0), n + 4;
};
oe.prototype.writeUInt32BE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 4, 4294967295, 0), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 24, this[n + 1] = t >>> 16, this[n + 2] = t >>> 8, this[n + 3] = t & 255) : Rc(this, t, n, !1), n + 4;
};
oe.prototype.writeIntLE = function(t, n, r, o) {
  if (t = +t, n = n | 0, !o) {
    var i = Math.pow(2, 8 * r - 1);
    In(this, t, n, r, i - 1, -i);
  }
  var a = 0, s = 1, l = 0;
  for (this[n] = t & 255; ++a < r && (s *= 256); )
    t < 0 && l === 0 && this[n + a - 1] !== 0 && (l = 1), this[n + a] = (t / s >> 0) - l & 255;
  return n + r;
};
oe.prototype.writeIntBE = function(t, n, r, o) {
  if (t = +t, n = n | 0, !o) {
    var i = Math.pow(2, 8 * r - 1);
    In(this, t, n, r, i - 1, -i);
  }
  var a = r - 1, s = 1, l = 0;
  for (this[n + a] = t & 255; --a >= 0 && (s *= 256); )
    t < 0 && l === 0 && this[n + a + 1] !== 0 && (l = 1), this[n + a] = (t / s >> 0) - l & 255;
  return n + r;
};
oe.prototype.writeInt8 = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 1, 127, -128), oe.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[n] = t & 255, n + 1;
};
oe.prototype.writeInt16LE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 2, 32767, -32768), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t & 255, this[n + 1] = t >>> 8) : Pc(this, t, n, !0), n + 2;
};
oe.prototype.writeInt16BE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 2, 32767, -32768), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 8, this[n + 1] = t & 255) : Pc(this, t, n, !1), n + 2;
};
oe.prototype.writeInt32LE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 4, 2147483647, -2147483648), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t & 255, this[n + 1] = t >>> 8, this[n + 2] = t >>> 16, this[n + 3] = t >>> 24) : Rc(this, t, n, !0), n + 4;
};
oe.prototype.writeInt32BE = function(t, n, r) {
  return t = +t, n = n | 0, r || In(this, t, n, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), oe.TYPED_ARRAY_SUPPORT ? (this[n] = t >>> 24, this[n + 1] = t >>> 16, this[n + 2] = t >>> 8, this[n + 3] = t & 255) : Rc(this, t, n, !1), n + 4;
};
function TC(e, t, n, r, o, i) {
  if (n + r > e.length)
    throw new RangeError("Index out of range");
  if (n < 0)
    throw new RangeError("Index out of range");
}
function OC(e, t, n, r, o) {
  return o || TC(e, t, n, 4), yC(e, t, n, r, 23, 4), n + 4;
}
oe.prototype.writeFloatLE = function(t, n, r) {
  return OC(this, t, n, !0, r);
};
oe.prototype.writeFloatBE = function(t, n, r) {
  return OC(this, t, n, !1, r);
};
function PC(e, t, n, r, o) {
  return o || TC(e, t, n, 8), yC(e, t, n, r, 52, 8), n + 8;
}
oe.prototype.writeDoubleLE = function(t, n, r) {
  return PC(this, t, n, !0, r);
};
oe.prototype.writeDoubleBE = function(t, n, r) {
  return PC(this, t, n, !1, r);
};
oe.prototype.copy = function(t, n, r, o) {
  if (r || (r = 0), !o && o !== 0 && (o = this.length), n >= t.length && (n = t.length), n || (n = 0), o > 0 && o < r && (o = r), o === r || t.length === 0 || this.length === 0)
    return 0;
  if (n < 0)
    throw new RangeError("targetStart out of bounds");
  if (r < 0 || r >= this.length)
    throw new RangeError("sourceStart out of bounds");
  if (o < 0)
    throw new RangeError("sourceEnd out of bounds");
  o > this.length && (o = this.length), t.length - n < o - r && (o = t.length - n + r);
  var i = o - r, a;
  if (this === t && r < n && n < o)
    for (a = i - 1; a >= 0; --a)
      t[a + n] = this[a + r];
  else if (i < 1e3 || !oe.TYPED_ARRAY_SUPPORT)
    for (a = 0; a < i; ++a)
      t[a + n] = this[a + r];
  else
    Uint8Array.prototype.set.call(t, this.subarray(r, r + i), n);
  return i;
};
oe.prototype.fill = function(t, n, r, o) {
  if (typeof t == "string") {
    if (typeof n == "string" ? (o = n, n = 0, r = this.length) : typeof r == "string" && (o = r, r = this.length), t.length === 1) {
      var i = t.charCodeAt(0);
      i < 256 && (t = i);
    }
    if (o !== void 0 && typeof o != "string")
      throw new TypeError("encoding must be a string");
    if (typeof o == "string" && !oe.isEncoding(o))
      throw new TypeError("Unknown encoding: " + o);
  } else
    typeof t == "number" && (t = t & 255);
  if (n < 0 || this.length < n || this.length < r)
    throw new RangeError("Out of range index");
  if (r <= n)
    return this;
  n = n >>> 0, r = r === void 0 ? this.length : r >>> 0, t || (t = 0);
  var a;
  if (typeof t == "number")
    for (a = n; a < r; ++a)
      this[a] = t;
  else {
    var s = $r(t) ? t : Ml(new oe(t, o).toString()), l = s.length;
    for (a = 0; a < r - n; ++a)
      this[a + n] = s[a % l];
  }
  return this;
};
var uF = /[^+\/0-9A-Za-z-_]/g;
function dF(e) {
  if (e = fF(e).replace(uF, ""), e.length < 2)
    return "";
  for (; e.length % 4 !== 0; )
    e = e + "=";
  return e;
}
function fF(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function hF(e) {
  return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function Ml(e, t) {
  t = t || 1 / 0;
  for (var n, r = e.length, o = null, i = [], a = 0; a < r; ++a) {
    if (n = e.charCodeAt(a), n > 55295 && n < 57344) {
      if (!o) {
        if (n > 56319) {
          (t -= 3) > -1 && i.push(239, 191, 189);
          continue;
        } else if (a + 1 === r) {
          (t -= 3) > -1 && i.push(239, 191, 189);
          continue;
        }
        o = n;
        continue;
      }
      if (n < 56320) {
        (t -= 3) > -1 && i.push(239, 191, 189), o = n;
        continue;
      }
      n = (o - 55296 << 10 | n - 56320) + 65536;
    } else
      o && (t -= 3) > -1 && i.push(239, 191, 189);
    if (o = null, n < 128) {
      if ((t -= 1) < 0)
        break;
      i.push(n);
    } else if (n < 2048) {
      if ((t -= 2) < 0)
        break;
      i.push(n >> 6 | 192, n & 63 | 128);
    } else if (n < 65536) {
      if ((t -= 3) < 0)
        break;
      i.push(n >> 12 | 224, n >> 6 & 63 | 128, n & 63 | 128);
    } else if (n < 1114112) {
      if ((t -= 4) < 0)
        break;
      i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, n & 63 | 128);
    } else
      throw new Error("Invalid code point");
  }
  return i;
}
function pF(e) {
  for (var t = [], n = 0; n < e.length; ++n)
    t.push(e.charCodeAt(n) & 255);
  return t;
}
function vF(e, t) {
  for (var n, r, o, i = [], a = 0; a < e.length && !((t -= 2) < 0); ++a)
    n = e.charCodeAt(a), r = n >> 8, o = n % 256, i.push(o), i.push(r);
  return i;
}
function RC(e) {
  return HN(dF(e));
}
function Ac(e, t, n, r) {
  for (var o = 0; o < r && !(o + n >= t.length || o >= e.length); ++o)
    t[o + n] = e[o];
  return o;
}
function gF(e) {
  return e !== e;
}
function mF(e) {
  return e != null && (!!e._isBuffer || AC(e) || yF(e));
}
function AC(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function yF(e) {
  return typeof e.readFloatLE == "function" && typeof e.slice == "function" && AC(e.slice(0, 0));
}
function qe(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
Z.inherits(qe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Z.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const IC = qe.prototype, kC = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  kC[e] = { value: e };
});
Object.defineProperties(qe, kC);
Object.defineProperty(IC, "isAxiosError", { value: !0 });
qe.from = (e, t, n, r, o, i) => {
  const a = Object.create(IC);
  return Z.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), qe.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const bF = null;
function Lf(e) {
  return Z.isPlainObject(e) || Z.isArray(e);
}
function $C(e) {
  return Z.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function R0(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = $C(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function CF(e) {
  return Z.isArray(e) && !e.some(Lf);
}
const wF = Z.toFlatObject(Z, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ic(e, t, n) {
  if (!Z.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = Z.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, v) {
    return !Z.isUndefined(v[g]);
  });
  const r = n.metaTokens, o = n.visitor || u, i = n.dots, a = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && Z.isSpecCompliantForm(t);
  if (!Z.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(p) {
    if (p === null)
      return "";
    if (Z.isDate(p))
      return p.toISOString();
    if (!l && Z.isBlob(p))
      throw new qe("Blob is not supported. Use a Buffer instead.");
    return Z.isArrayBuffer(p) || Z.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : oe.from(p) : p;
  }
  function u(p, g, v) {
    let b = p;
    if (p && !v && typeof p == "object") {
      if (Z.endsWith(g, "{}"))
        g = r ? g : g.slice(0, -2), p = JSON.stringify(p);
      else if (Z.isArray(p) && CF(p) || (Z.isFileList(p) || Z.endsWith(g, "[]")) && (b = Z.toArray(p)))
        return g = $C(g), b.forEach(function(w, E) {
          !(Z.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? R0([g], E, i) : a === null ? g : g + "[]",
            c(w)
          );
        }), !1;
    }
    return Lf(p) ? !0 : (t.append(R0(v, g, i), c(p)), !1);
  }
  const d = [], f = Object.assign(wF, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Lf
  });
  function h(p, g) {
    if (!Z.isUndefined(p)) {
      if (d.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      d.push(p), Z.forEach(p, function(b, m) {
        (!(Z.isUndefined(b) || b === null) && o.call(
          t,
          b,
          Z.isString(m) ? m.trim() : m,
          g,
          f
        )) === !0 && h(b, g ? g.concat(m) : [m]);
      }), d.pop();
    }
  }
  if (!Z.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function A0(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Hh(e, t) {
  this._pairs = [], e && Ic(e, this, t);
}
const NC = Hh.prototype;
NC.append = function(t, n) {
  this._pairs.push([t, n]);
};
NC.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, A0);
  } : A0;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function EF(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function FC(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || EF, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = Z.isURLSearchParams(t) ? t.toString() : new Hh(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class I0 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    Z.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const LC = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, _F = typeof URLSearchParams < "u" ? URLSearchParams : Hh, xF = typeof FormData < "u" ? FormData : null, SF = typeof Blob < "u" ? Blob : null, TF = {
  isBrowser: !0,
  classes: {
    URLSearchParams: _F,
    FormData: xF,
    Blob: SF
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, zh = typeof window < "u" && typeof document < "u", Mf = typeof navigator == "object" && navigator || void 0, OF = zh && (!Mf || ["ReactNative", "NativeScript", "NS"].indexOf(Mf.product) < 0), PF = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", RF = zh && window.location.href || "http://localhost", AF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: zh,
  hasStandardBrowserEnv: OF,
  hasStandardBrowserWebWorkerEnv: PF,
  navigator: Mf,
  origin: RF
}, Symbol.toStringTag, { value: "Module" })), Rn = {
  ...AF,
  ...TF
};
function IF(e, t) {
  return Ic(e, new Rn.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return Rn.isNode && Z.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function kF(e) {
  return Z.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function $F(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function MC(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    if (a === "__proto__")
      return !0;
    const s = Number.isFinite(+a), l = i >= n.length;
    return a = !a && Z.isArray(o) ? o.length : a, l ? (Z.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !s) : ((!o[a] || !Z.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && Z.isArray(o[a]) && (o[a] = $F(o[a])), !s);
  }
  if (Z.isFormData(e) && Z.isFunction(e.entries)) {
    const n = {};
    return Z.forEachEntry(e, (r, o) => {
      t(kF(r), o, n, 0);
    }), n;
  }
  return null;
}
function NF(e, t, n) {
  if (Z.isString(e))
    try {
      return (t || JSON.parse)(e), Z.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Ya = {
  transitional: LC,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = Z.isObject(t);
    if (i && Z.isHTMLForm(t) && (t = new FormData(t)), Z.isFormData(t))
      return o ? JSON.stringify(MC(t)) : t;
    if (Z.isArrayBuffer(t) || Z.isBuffer(t) || Z.isStream(t) || Z.isFile(t) || Z.isBlob(t) || Z.isReadableStream(t))
      return t;
    if (Z.isArrayBufferView(t))
      return t.buffer;
    if (Z.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return IF(t, this.formSerializer).toString();
      if ((s = Z.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Ic(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), NF(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Ya.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (Z.isResponse(t) || Z.isReadableStream(t))
      return t;
    if (t && Z.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? qe.from(s, qe.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Rn.classes.FormData,
    Blob: Rn.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Z.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ya.headers[e] = {};
});
const FF = Z.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), LF = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && FF[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, k0 = Symbol("internals");
function ca(e) {
  return e && String(e).trim().toLowerCase();
}
function ul(e) {
  return e === !1 || e == null ? e : Z.isArray(e) ? e.map(ul) : String(e);
}
function MF(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const DF = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ed(e, t, n, r, o) {
  if (Z.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!Z.isString(t)) {
    if (Z.isString(r))
      return t.indexOf(r) !== -1;
    if (Z.isRegExp(r))
      return r.test(t);
  }
}
function jF(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function BF(e, t) {
  const n = Z.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class An {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(s, l, c) {
      const u = ca(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = Z.findKey(o, u);
      (!d || o[d] === void 0 || c === !0 || c === void 0 && o[d] !== !1) && (o[d || l] = ul(s));
    }
    const a = (s, l) => Z.forEach(s, (c, u) => i(c, u, l));
    if (Z.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (Z.isString(t) && (t = t.trim()) && !DF(t))
      a(LF(t), n);
    else if (Z.isHeaders(t))
      for (const [s, l] of t.entries())
        i(l, s, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = ca(t), t) {
      const r = Z.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return MF(o);
        if (Z.isFunction(n))
          return n.call(this, o, r);
        if (Z.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = ca(t), t) {
      const r = Z.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || ed(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = ca(a), a) {
        const s = Z.findKey(r, a);
        s && (!n || ed(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return Z.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || ed(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return Z.forEach(this, (o, i) => {
      const a = Z.findKey(r, i);
      if (a) {
        n[a] = ul(o), delete n[i];
        return;
      }
      const s = t ? jF(i) : String(i).trim();
      s !== i && delete n[i], n[s] = ul(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return Z.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && Z.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[k0] = this[k0] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const s = ca(a);
      r[s] || (BF(o, a), r[s] = !0);
    }
    return Z.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
An.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Z.reduceDescriptors(An.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
Z.freezeMethods(An);
function td(e, t) {
  const n = this || Ya, r = t || n, o = An.from(r.headers);
  let i = r.data;
  return Z.forEach(e, function(s) {
    i = s.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function DC(e) {
  return !!(e && e.__CANCEL__);
}
function Ki(e, t, n) {
  qe.call(this, e ?? "canceled", qe.ERR_CANCELED, t, n), this.name = "CanceledError";
}
Z.inherits(Ki, qe, {
  __CANCEL__: !0
});
function jC(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new qe(
    "Request failed with status code " + n.status,
    [qe.ERR_BAD_REQUEST, qe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function VF(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function UF(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[i];
    a || (a = c), n[o] = l, r[o] = c;
    let d = i, f = 0;
    for (; d !== o; )
      f += n[d++], d = d % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), c - a < t)
      return;
    const h = u && c - u;
    return h ? Math.round(f * 1e3 / h) : void 0;
  };
}
function HF(e, t) {
  let n = 0, r = 1e3 / t, o, i;
  const a = (c, u = Date.now()) => {
    n = u, o = null, i && (clearTimeout(i), i = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? a(c, u) : (o = c, i || (i = setTimeout(() => {
      i = null, a(o);
    }, r - d)));
  }, () => o && a(o)];
}
const Dl = (e, t, n = 3) => {
  let r = 0;
  const o = UF(50, 250);
  return HF((i) => {
    const a = i.loaded, s = i.lengthComputable ? i.total : void 0, l = a - r, c = o(l), u = a <= s;
    r = a;
    const d = {
      loaded: a,
      total: s,
      progress: s ? a / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - a) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, $0 = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, N0 = (e) => (...t) => Z.asap(() => e(...t)), zF = Rn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = Rn.navigator && /(msie|trident)/i.test(Rn.navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let a = i;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const s = Z.isString(a) ? o(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), qF = Rn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      Z.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), Z.isString(r) && a.push("path=" + r), Z.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function WF(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function GF(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function BC(e, t) {
  return e && !WF(t) ? GF(e, t) : t;
}
const F0 = (e) => e instanceof An ? { ...e } : e;
function Ho(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return Z.isPlainObject(c) && Z.isPlainObject(u) ? Z.merge.call({ caseless: d }, c, u) : Z.isPlainObject(u) ? Z.merge({}, u) : Z.isArray(u) ? u.slice() : u;
  }
  function o(c, u, d) {
    if (Z.isUndefined(u)) {
      if (!Z.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function i(c, u) {
    if (!Z.isUndefined(u))
      return r(void 0, u);
  }
  function a(c, u) {
    if (Z.isUndefined(u)) {
      if (!Z.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (c, u) => o(F0(c), F0(u), !0)
  };
  return Z.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || o, f = d(e[u], t[u], u);
    Z.isUndefined(f) && d !== s || (n[u] = f);
  }), n;
}
const VC = (e) => {
  const t = Ho({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: s } = t;
  t.headers = a = An.from(a), t.url = FC(BC(t.baseURL, t.url), e.params, e.paramsSerializer), s && a.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (Z.isFormData(n)) {
    if (Rn.hasStandardBrowserEnv || Rn.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      a.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Rn.hasStandardBrowserEnv && (r && Z.isFunction(r) && (r = r(t)), r || r !== !1 && zF(t.url))) {
    const c = o && i && qF.read(i);
    c && a.set(o, c);
  }
  return t;
}, KF = typeof XMLHttpRequest < "u", YF = KF && function(e) {
  return new Promise(function(n, r) {
    const o = VC(e);
    let i = o.data;
    const a = An.from(o.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: c } = o, u, d, f, h, p;
    function g() {
      h && h(), p && p(), o.cancelToken && o.cancelToken.unsubscribe(u), o.signal && o.signal.removeEventListener("abort", u);
    }
    let v = new XMLHttpRequest();
    v.open(o.method.toUpperCase(), o.url, !0), v.timeout = o.timeout;
    function b() {
      if (!v)
        return;
      const w = An.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), C = {
        data: !s || s === "text" || s === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: w,
        config: e,
        request: v
      };
      jC(function(_) {
        n(_), g();
      }, function(_) {
        r(_), g();
      }, C), v = null;
    }
    "onloadend" in v ? v.onloadend = b : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, v.onabort = function() {
      v && (r(new qe("Request aborted", qe.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function() {
      r(new qe("Network Error", qe.ERR_NETWORK, e, v)), v = null;
    }, v.ontimeout = function() {
      let E = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const C = o.transitional || LC;
      o.timeoutErrorMessage && (E = o.timeoutErrorMessage), r(new qe(
        E,
        C.clarifyTimeoutError ? qe.ETIMEDOUT : qe.ECONNABORTED,
        e,
        v
      )), v = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in v && Z.forEach(a.toJSON(), function(E, C) {
      v.setRequestHeader(C, E);
    }), Z.isUndefined(o.withCredentials) || (v.withCredentials = !!o.withCredentials), s && s !== "json" && (v.responseType = o.responseType), c && ([f, p] = Dl(c, !0), v.addEventListener("progress", f)), l && v.upload && ([d, h] = Dl(l), v.upload.addEventListener("progress", d), v.upload.addEventListener("loadend", h)), (o.cancelToken || o.signal) && (u = (w) => {
      v && (r(!w || w.type ? new Ki(null, e, v) : w), v.abort(), v = null);
    }, o.cancelToken && o.cancelToken.subscribe(u), o.signal && (o.signal.aborted ? u() : o.signal.addEventListener("abort", u)));
    const m = VF(o.url);
    if (m && Rn.protocols.indexOf(m) === -1) {
      r(new qe("Unsupported protocol " + m + ":", qe.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(i || null);
  });
}, ZF = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), o;
    const i = function(c) {
      if (!o) {
        o = !0, s();
        const u = c instanceof Error ? c : this.reason;
        r.abort(u instanceof qe ? u : new Ki(u instanceof Error ? u.message : u));
      }
    };
    let a = t && setTimeout(() => {
      a = null, i(new qe(`timeout ${t} of ms exceeded`, qe.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: l } = r;
    return l.unsubscribe = () => Z.asap(s), l;
  }
}, QF = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, XF = async function* (e, t) {
  for await (const n of JF(e))
    yield* QF(n, t);
}, JF = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, L0 = (e, t, n, r) => {
  const o = XF(e, t);
  let i = 0, a, s = (l) => {
    a || (a = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await o.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let f = i += d;
          n(f);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, kc = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", UC = kc && typeof ReadableStream == "function", eL = kc && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), HC = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, tL = UC && HC(() => {
  let e = !1;
  const t = new Request(Rn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), M0 = 64 * 1024, Df = UC && HC(() => Z.isReadableStream(new Response("").body)), jl = {
  stream: Df && ((e) => e.body)
};
kc && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !jl[t] && (jl[t] = Z.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new qe(`Response type '${t}' is not supported`, qe.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const nL = async (e) => {
  if (e == null)
    return 0;
  if (Z.isBlob(e))
    return e.size;
  if (Z.isSpecCompliantForm(e))
    return (await new Request(Rn.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (Z.isArrayBufferView(e) || Z.isArrayBuffer(e))
    return e.byteLength;
  if (Z.isURLSearchParams(e) && (e = e + ""), Z.isString(e))
    return (await eL(e)).byteLength;
}, rL = async (e, t) => {
  const n = Z.toFiniteNumber(e.getContentLength());
  return n ?? nL(t);
}, oL = kc && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: f
  } = VC(e);
  c = c ? (c + "").toLowerCase() : "text";
  let h = ZF([o, i && i.toAbortSignal()], a), p;
  const g = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let v;
  try {
    if (l && tL && n !== "get" && n !== "head" && (v = await rL(u, r)) !== 0) {
      let C = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), x;
      if (Z.isFormData(r) && (x = C.headers.get("content-type")) && u.setContentType(x), C.body) {
        const [_, T] = $0(
          v,
          Dl(N0(l))
        );
        r = L0(C.body, M0, _, T);
      }
    }
    Z.isString(d) || (d = d ? "include" : "omit");
    const b = "credentials" in Request.prototype;
    p = new Request(t, {
      ...f,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: b ? d : void 0
    });
    let m = await fetch(p);
    const w = Df && (c === "stream" || c === "response");
    if (Df && (s || w && g)) {
      const C = {};
      ["status", "statusText", "headers"].forEach((O) => {
        C[O] = m[O];
      });
      const x = Z.toFiniteNumber(m.headers.get("content-length")), [_, T] = s && $0(
        x,
        Dl(N0(s), !0)
      ) || [];
      m = new Response(
        L0(m.body, M0, _, () => {
          T && T(), g && g();
        }),
        C
      );
    }
    c = c || "text";
    let E = await jl[Z.findKey(jl, c) || "text"](m, e);
    return !w && g && g(), await new Promise((C, x) => {
      jC(C, x, {
        data: E,
        headers: An.from(m.headers),
        status: m.status,
        statusText: m.statusText,
        config: e,
        request: p
      });
    });
  } catch (b) {
    throw g && g(), b && b.name === "TypeError" && /fetch/i.test(b.message) ? Object.assign(
      new qe("Network Error", qe.ERR_NETWORK, e, p),
      {
        cause: b.cause || b
      }
    ) : qe.from(b, b && b.code, e, p);
  }
}), jf = {
  http: bF,
  xhr: YF,
  fetch: oL
};
Z.forEach(jf, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const D0 = (e) => `- ${e}`, iL = (e) => Z.isFunction(e) || e === null || e === !1, zC = {
  getAdapter: (e) => {
    e = Z.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let a;
      if (r = n, !iL(n) && (r = jf[(a = String(n)).toLowerCase()], r === void 0))
        throw new qe(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(D0).join(`
`) : " " + D0(i[0]) : "as no adapter specified";
      throw new qe(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: jf
};
function nd(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ki(null, e);
}
function j0(e) {
  return nd(e), e.headers = An.from(e.headers), e.data = td.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), zC.getAdapter(e.adapter || Ya.adapter)(e).then(function(r) {
    return nd(e), r.data = td.call(
      e,
      e.transformResponse,
      r
    ), r.headers = An.from(r.headers), r;
  }, function(r) {
    return DC(r) || (nd(e), r && r.response && (r.response.data = td.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = An.from(r.response.headers))), Promise.reject(r);
  });
}
const qC = "1.7.7", qh = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  qh[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const B0 = {};
qh.transitional = function(t, n, r) {
  function o(i, a) {
    return "[Axios v" + qC + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, s) => {
    if (t === !1)
      throw new qe(
        o(a, " has been removed" + (n ? " in " + n : "")),
        qe.ERR_DEPRECATED
      );
    return n && !B0[a] && (B0[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function aL(e, t, n) {
  if (typeof e != "object")
    throw new qe("options must be an object", qe.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const s = e[i], l = s === void 0 || a(s, i, e);
      if (l !== !0)
        throw new qe("option " + i + " must be " + l, qe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new qe("Unknown option " + i, qe.ERR_BAD_OPTION);
  }
}
const Bf = {
  assertOptions: aL,
  validators: qh
}, Jr = Bf.validators;
class Mo {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new I0(),
      response: new I0()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Ho(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && Bf.assertOptions(r, {
      silentJSONParsing: Jr.transitional(Jr.boolean),
      forcedJSONParsing: Jr.transitional(Jr.boolean),
      clarifyTimeoutError: Jr.transitional(Jr.boolean)
    }, !1), o != null && (Z.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : Bf.assertOptions(o, {
      encode: Jr.function,
      serialize: Jr.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = i && Z.merge(
      i.common,
      i[n.method]
    );
    i && Z.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = An.concat(a, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(n) === !1 || (l = l && g.synchronous, s.unshift(g.fulfilled, g.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(g) {
      c.push(g.fulfilled, g.rejected);
    });
    let u, d = 0, f;
    if (!l) {
      const p = [j0.bind(this), void 0];
      for (p.unshift.apply(p, s), p.push.apply(p, c), f = p.length, u = Promise.resolve(n); d < f; )
        u = u.then(p[d++], p[d++]);
      return u;
    }
    f = s.length;
    let h = n;
    for (d = 0; d < f; ) {
      const p = s[d++], g = s[d++];
      try {
        h = p(h);
      } catch (v) {
        g.call(this, v);
        break;
      }
    }
    try {
      u = j0.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (d = 0, f = c.length; d < f; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Ho(this.defaults, t);
    const n = BC(t.baseURL, t.url);
    return FC(n, t.params, t.paramsSerializer);
  }
}
Z.forEach(["delete", "get", "head", "options"], function(t) {
  Mo.prototype[t] = function(n, r) {
    return this.request(Ho(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
Z.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, s) {
      return this.request(Ho(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  Mo.prototype[t] = n(), Mo.prototype[t + "Form"] = n(!0);
});
class Wh {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, s) {
      r.reason || (r.reason = new Ki(i, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Wh(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function sL(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function lL(e) {
  return Z.isObject(e) && e.isAxiosError === !0;
}
const Vf = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Vf).forEach(([e, t]) => {
  Vf[t] = e;
});
function WC(e) {
  const t = new Mo(e), n = cC(Mo.prototype.request, t);
  return Z.extend(n, Mo.prototype, t, { allOwnKeys: !0 }), Z.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return WC(Ho(e, o));
  }, n;
}
const Zt = WC(Ya);
Zt.Axios = Mo;
Zt.CanceledError = Ki;
Zt.CancelToken = Wh;
Zt.isCancel = DC;
Zt.VERSION = qC;
Zt.toFormData = Ic;
Zt.AxiosError = qe;
Zt.Cancel = Zt.CanceledError;
Zt.all = function(t) {
  return Promise.all(t);
};
Zt.spread = sL;
Zt.isAxiosError = lL;
Zt.mergeConfig = Ho;
Zt.AxiosHeaders = An;
Zt.formToJSON = (e) => MC(Z.isHTMLForm(e) ? new FormData(e) : e);
Zt.getAdapter = zC.getAdapter;
Zt.HttpStatusCode = Vf;
Zt.default = Zt;
const cL = {
  FIELD_WRITE: !1,
  MANAGE_QUOTA: !1
};
function uL({
  workspaceId: e,
  propertyId: t
}) {
  const {
    cwElementsSettingsMenuCws13844UseValidateEndpoint: n
  } = dh(), r = jn(), o = async (a, s) => {
    var c;
    return ((c = (await Zt.post(`${r.getAPIURL()}/v2/internal/settings/menu/validate`, {
      workspace_id: a,
      property_id: s,
      options: ["MANAGE_QUOTA", "FIELD_WRITE"]
    }, {
      headers: r.getDefaultHeaders()
    })).data) == null ? void 0 : c.items.reduce((u, d) => (u[d.name] = d.value, u), {})) ?? null;
  }, {
    data: i
  } = h7({
    queryKey: ["menuValidate", e, t],
    enabled: !!(e && n),
    queryFn: async () => o(e, t)
  });
  return i ?? cL;
}
var dL = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const rd = "ACCOUNTS_MGMT", fL = Ue.div`
  .group {
    transition:
      opacity 300ms ease-in-out,
      transform 300ms ease-in-out;
    opacity: 0;
    transform: translateY(20px);
  }

  .group + .group {
    margin-top: 12px;
  }

  ${({
  $show: e
}) => e && `
      .group {
        opacity: 1;
        transform: translateY(0);
        transition-delay: var(--delay);
      }
  `}
`, hL = P1(""), pL = ({
  component: e,
  workspaceId: t,
  workspaceName: n,
  orgId: r,
  orgName: o,
  orgCountry: i,
  orgSource: a,
  propertyId: s,
  propertyName: l,
  productSettings: c,
  extraDelay: u = 0,
  dark: d = !1,
  accountId: f
}) => {
  const h = dL.VITE_USE_LOCAL_MFES === "true" ? "local" : void 0, p = ci("machinery-file-uploader"), g = ci("fields/create", h), v = ci("members-mgt/starter", h), b = ci("inputs-mgt/drawer", h), m = ci("inputs-mgt/create", h), w = jn(), E = w.getHostAppId(), {
    t: C
  } = Fa(), [x, _] = wt({
    id: s,
    name: l
  }), [T, O] = wt(!1), [I, L] = wt(!1), [B, j] = wt(!1), M = hL(() => ({
    component: e,
    workspaceId: t,
    workspaceName: n,
    organizationId: r,
    organizationName: o,
    farmId: x.id,
    farmName: x.name
  })), {
    settingsMenuEnableConnectMenu: q,
    settingsMenuEnableConnectMenuFileUpload: N,
    settingsMenuEnableConnectMenuIntegrationsItem: $,
    settingMenEnableConnectMenuDataMapping: F,
    farmSettingsCws11151EnableInputs: H,
    farmSettingsEntitiesHallCws11468EnableMfe: k,
    cwElementsFieldsCws11316EnableFieldsMfe: W,
    cwElementsMembersMgtCws13415UseMembersMgt: G,
    cwElementsInputsMgtCws12528EnableNavigationTests: ne
  } = dh(), Y = uL({
    workspaceId: t,
    propertyId: x.id
  }), {
    membersAndContantURL: fe,
    quotaMgtURL: ge
  } = p7({
    workspaceId: t,
    orgId: r
  });
  ut(() => {
    setTimeout(() => {
      j(!0);
    });
  }, []);
  const ie = Xi((Ee, Fe = !1, S = !1) => {
    let A = w.getFarmSettingsURL();
    return Fe ? A += `/app/landing-organization/${r}` : A += k ? "/app/my-cropwise" : "/app/my-organizations", Fe && S && (x.id ? A += `/property/${x.id}` : Ee = "/create-farm"), A + Ee + (E !== rd ? `?callback_app=${E}` : "");
  }, [r, x.id, E, w, k]), he = Xi(() => {
    dispatchEvent(new CustomEvent(gl.CLOSE_MENU));
  }, []), ue = Xi(({
    platformBlock: Ee,
    productBlock: Fe,
    platformFeature: S
  }) => {
    M("access settings links", {
      "platform block": Ee,
      "platform feature": S,
      "product block": Fe
    });
  }, [M]), ce = Xi((Ee, {
    platformBlock: Fe,
    productBlock: S,
    platformFeature: A
  }) => {
    var K;
    he(), ue({
      platformBlock: Fe,
      productBlock: S,
      platformFeature: A
    }), (K = window.open(Ee, "_blank")) == null || K.focus();
  }, [he, ue]);
  ut(() => {
    function Ee(Fe) {
      window.dispatchEvent(new CustomEvent(Yh, {
        detail: {
          userLanguage: Fe
        }
      }));
    }
    return sr.on("languageChanged", Ee), () => sr.off("languageChanged", Ee);
  }, []), ut(() => {
    window.dispatchEvent(new CustomEvent(Yh, {
      detail: {
        workspaceId: t ?? "",
        orgId: r ?? "",
        location: i ?? "",
        source: a ?? ""
      }
    }));
  }, [t, r, i, a]);
  const Se = Mt(() => H ? {
    key: "MANAGE_INPUTS",
    icon: /* @__PURE__ */ P.jsx(Hw, {}),
    label: C("settings_menu.inputs.title"),
    tooltipText: C("settings_menu.inputs.tooltip"),
    onClick: () => {
      he(), ue({
        platformBlock: "Farm Settings",
        platformFeature: "Inputs"
      }), ne ? (window.dispatchEvent(new CustomEvent(Om.OPEN_DRAWER)), M("access settings links - navigation tests", {
        "platform block": "Farm Settings",
        "platform feature": "Inputs"
      })) : Ms("inputs-mgt", {
        workspaceId: t ?? "",
        orgId: r ?? "",
        userLanguage: sr.language,
        location: i ?? "",
        source: a ?? ""
      }, ie("/inputs/crop-protection", !0, !1));
    },
    secondButton: ne ? () => {
      he(), ke(!0), M("access settings links - navigation tests", {
        "platform block": "Farm Settings",
        "platform feature": "Quickly add Inputs"
      });
    } : void 0,
    extraButtonTooltipText: C("settings_menu.inputs.extra_button_tooltip")
  } : {
    key: "MANAGE_PRODUCTS",
    icon: /* @__PURE__ */ P.jsx(Ww, { dark: d }),
    label: C("settings_menu.products.title"),
    tooltipText: C("settings_menu.products.tooltip"),
    onClick: () => ce(ie("/resources/1", !0, !1), {
      platformBlock: "Farm Settings",
      platformFeature: "Products"
    })
  }, [ie, d, H, ne, he, M, ce, ue, r, C, t, i, a]), [te, ke] = wt(!1), [se, D] = wt(!1), [X, Q] = wt(!1), _e = Mt(() => ({
    key: "FARM_SETTINGS",
    items: [{
      key: "MANAGE_FIELDS",
      icon: /* @__PURE__ */ P.jsx(Uw, { dark: d }),
      label: C("settings_menu.fields.title"),
      tooltipText: C("settings_menu.fields.tooltip"),
      onClick: () => ce(ie("/all-fields", !0, !0), {
        platformBlock: "Farm Settings",
        platformFeature: "Fields"
      }),
      secondButton: W && (Y != null && Y.FIELD_WRITE) ? () => {
        he(), D(!0), ue({
          platformBlock: "Farm Settings",
          platformFeature: "Quickly add Fields"
        });
      } : void 0,
      extraButtonTooltipText: C("settings_menu.fields.extra_button_tooltip")
    }, {
      key: "MANAGE_SEASONS",
      icon: /* @__PURE__ */ P.jsx(Vw, { dark: d }),
      label: C("settings_menu.seasons.title"),
      tooltipText: C("settings_menu.seasons.tooltip"),
      onClick: () => ce(ie("/table-view", !0, !0), {
        platformBlock: "Farm Settings",
        platformFeature: "Seasons"
      })
    }, Se],
    title: C("settings_menu.farm_settings.title"),
    tooltipText: C("settings_menu.farm_settings.tooltip"),
    onClickTitle: () => ce(ie(""), {
      platformBlock: "Farm Settings",
      platformFeature: "Farm Settings"
    })
  }), [d, C, Se, W, Y == null ? void 0 : Y.FIELD_WRITE, ce, ie, he, ue]), Ce = Xi((Ee) => w.getConnectURL() + Ee + (E !== rd ? `?callback_app=${E}` : ""), [E, w]), Ne = Mt(() => ({
    label: C("settings_menu.connect.integrations_title"),
    icon: /* @__PURE__ */ P.jsx(Yw, {}),
    key: "INTEGRATIONS",
    tooltipText: C("settings_menu.connect.integrations_tooltip"),
    onClick: () => {
      ce(Ce("integrations"), {
        platformBlock: "Connect",
        platformFeature: "Integrations"
      });
    }
  }), [Ce, ce, C]), [ae, xe] = wt(!1), Re = Mt(() => ({
    label: C("settings_menu.connect.file_upload_title"),
    icon: /* @__PURE__ */ P.jsx(Kw, {}),
    key: "FILE_UPLOAD",
    tooltipText: C("settings_menu.connect.file_upload_tooltip"),
    onClick: () => {
      p.Mfe ? (xe(!0), he(), ue({
        platformBlock: "Connect",
        platformFeature: "File Upload"
      })) : ce(Ce("file-upload"), {
        platformBlock: "Connect",
        platformFeature: "File Upload"
      });
    },
    hoverType: xi.INTERNAL
  }), [C, p.Mfe, ue, he, ce, Ce]), mt = Mt(() => ({
    label: C("settings_menu.connect.data_matching_title"),
    icon: /* @__PURE__ */ P.jsx(Gw, {}),
    key: "DATA_MATCHING",
    tooltipText: C("settings_menu.connect.data_matching_tooltip"),
    onClick: () => {
      ce(Ce("resource-mapper"), {
        platformBlock: "Connect",
        platformFeature: "Data Mapping"
      });
    },
    hoverType: xi.INTERNAL
  }), [Ce, ce, C]), et = Mt(() => {
    const Ee = [];
    return $ && Ee.push(Ne), N && Ee.push(Re), F && Ee.push(mt), {
      key: "CONNECT",
      title: C("settings_menu.connect.title"),
      tooltipText: C("settings_menu.connect.tooltip"),
      onClickTitle: () => {
        ce(Ce(""), {
          platformBlock: "Connect",
          platformFeature: "Connect"
        });
      },
      items: Ee
    };
  }, [$, N, F, C, Ne, Re, mt, ce, Ce]), tt = Mt(() => `${w.getAccountsURL()}/app/invite-members?workspace=${t}`, [w, t]), _t = Mt(() => {
    const Ee = [{
      key: "MEMBERS_AND_CONTACTS",
      icon: /* @__PURE__ */ P.jsx(qw, {}),
      label: C("settings_menu.members_and_contacts.title"),
      tooltipText: C("settings_menu.members_and_contacts.tooltip"),
      onClick: () => {
        ce(fe, {
          platformBlock: "Accounts",
          platformFeature: "Members and Contacts"
        });
      },
      secondButton: () => {
        if (he(), G) {
          Q(!0);
          return;
        }
        ue({
          platformBlock: "Accounts",
          platformFeature: "Quickly invite members"
        }), Ms("invite-members", {
          workspaceId: t ?? "",
          orgId: r ?? "",
          userLanguage: sr.language
        }, tt);
      },
      extraButtonTooltipText: C("settings_menu.members_and_contacts.extraButtonTooltip")
    }];
    return Y != null && Y.MANAGE_QUOTA && Ee.push({
      key: "MANAGE_QUOTAS",
      icon: /* @__PURE__ */ P.jsx(zw, {}),
      label: C("settings_menu.manage_quotas.title"),
      tooltipText: C("settings_menu.manage_quotas.tooltip"),
      onClick: () => {
        Ms("quota-mgt", {
          workspaceId: t ?? "",
          userLanguage: sr.language
        }, ge), he(), ue({
          platformBlock: "Accounts",
          platformFeature: "Manage Quotas"
        });
      },
      hoverType: xi.INTERNAL
    }), {
      key: "ACCOUNTS",
      items: Ee,
      title: C("settings_menu.accounts.title"),
      tooltipText: C("settings_menu.accounts.tooltip"),
      onClickTitle: () => ce(`${w.getAccountsURL()}/app/workspaces`, {
        platformBlock: "Accounts",
        platformFeature: "Accounts"
      })
    };
  }, [C, ce, fe, r, t, tt, ue, he, ge, w, Y == null ? void 0 : Y.MANAGE_QUOTA, G]);
  ut(() => {
    if (r && !s) {
      const Ee = () => {
        L(!1), O(!0), dl.getPropertiesByOrg(r).then((Fe) => {
          var A, K;
          const S = ((K = (A = Fe.data) == null ? void 0 : A.content) == null ? void 0 : K[0]) ?? void 0;
          _({
            id: S == null ? void 0 : S.id,
            name: S == null ? void 0 : S.name
          }), O(!1);
        }).catch(() => {
          L(!0);
        });
      };
      _o.getInstance().addCallbackAfterSetToken(Ee);
    }
  }, [r, s]), ut(() => {
    s && _({
      id: s,
      name: l
    });
  }, [s, l]);
  const $t = Mt(() => {
    const Ee = [];
    return I || Ee.push(_e), E !== rd && Ee.push(_t), c && Ee.push({
      ...c,
      onClickTitle: () => {
        var Fe;
        M("access settings links", {
          "product block": `${c.title} - ${c.title}`
        }), (Fe = c.onClickTitle) == null || Fe.call(c);
      },
      items: c.items.map((Fe) => ({
        ...Fe,
        onClick: () => {
          var S;
          M("access settings links", {
            "product block": `${c.title} - ${Fe.label}`
          }), (S = Fe.onClick) == null || S.call(Fe);
        }
      }))
    }), q && Ee.push(et), Ee;
  }, [M, I, E, c, q, _e, _t, et]);
  if (!r)
    return null;
  const en = !!(r && (x.id ?? s) && (Y != null && Y.FIELD_WRITE));
  return /* @__PURE__ */ P.jsxs(fL, { $show: B, children: [
    b.Mfe && /* @__PURE__ */ P.jsx(b.Mfe, { userLanguage: sr.language, workspaceId: t, orgId: r, isCanon: !1, location: i ?? "", source: a ?? "" }),
    m.Mfe && /* @__PURE__ */ P.jsx(m.Mfe, { userLanguage: sr.language, open: te, onClose: () => ke(!1), __experimental_navigation_tests: {
      useCustomEvents: !0
    } }),
    p.Mfe && /* @__PURE__ */ P.jsx(p.Mfe, { userLanguage: sr.language, getConfigInstance: jn, userId: f ?? "", orgId: r, isOpen: ae, onClose: () => xe(!1) }),
    en && g.Mfe && /* @__PURE__ */ P.jsx(g.Mfe, { isOpen: se, onClose: () => D(!1), userLanguage: sr.language, orgId: r, propertyId: x.id ?? s }),
    G && v.Mfe && /* @__PURE__ */ P.jsx(v.Mfe, { isOpen: X, onClose: () => Q(!1), userLanguage: sr.language, workspaceId: t ?? "", getConfigInstance: jn }),
    /* @__PURE__ */ P.jsx(W$, { workspaceId: t, dark: d }),
    $t.map(({
      key: Ee,
      ...Fe
    }, S) => /* @__PURE__ */ P.jsx("div", { className: "group", style: {
      "--delay": S * 300 + u + "ms"
    }, children: /* @__PURE__ */ P.jsx(nN, { ...Fe, loading: T, dark: d }, Ee) }, Ee))
  ] });
}, vL = new z8(), gL = (e) => /* @__PURE__ */ P.jsx(J8, { client: vL, children: /* @__PURE__ */ P.jsx(pL, { ...e }) }), mL = Ue.header`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
`, yL = Ue.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`, bL = Ue.h1`
  font-size: ${Jn.FontSize.Title5};
  margin: 0;
  line-height: 1.3;
`, CL = Ue.p`
  font-size: ${Jn.FontSize.Body2};
  margin: 8px 0 0;
  font-weight: ${Jn.FontWeight.Regular};
  line-height: 1.4;
  color: ${ve[60]};
`, wL = Ue.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 7px;
  justify-content: center;
  border-radius: 8px;
  align-items: center;
  background-color: ${(e) => e.color};
  svg {
    fill: ${ln[60]};
  }
`, cD = ({
  icon: e,
  detailsTitle: t,
  detailsSubTitle: n
}) => /* @__PURE__ */ P.jsxs(mL, { children: [
  /* @__PURE__ */ P.jsx(wL, { color: ln[10], children: e }),
  /* @__PURE__ */ P.jsxs(yL, { children: [
    /* @__PURE__ */ P.jsx(bL, { children: t }),
    /* @__PURE__ */ P.jsx(CL, { children: n })
  ] })
] }), V0 = "18px", U0 = "32px", EL = Ue.span`
  clip: rect(1px, 1px, 1px, 1px);
  clippath: inset(50%);
  height: 1px;
  width: 1px;
  margin: -2px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`, _L = Ue.h2`
  font-size: ${Jn.FontSize.Title6};
  line-height: 1.333;
  font-weight: 600;
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 0;
`, xL = Ue.button`
  border-radius: 100%;
  color: ${ve[60]};
  background-color: ${ve[0]};
  border: solid 1px ${ve[30]};
  width: ${U0};
  height: ${U0};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: ${V0};
    height: ${V0};
  }
`, SL = Ue.span`
  flex-grow: 1;
`, uD = ({
  text: e,
  children: t,
  onBack: n,
  buttonGoBackTitle: r,
  buttonGoBackScreenReader: o,
  ...i
}) => /* @__PURE__ */ P.jsxs(_L, { ...i, children: [
  n && /* @__PURE__ */ P.jsxs(xL, { onClick: n, children: [
    /* @__PURE__ */ P.jsx(Dw, { title: r }),
    /* @__PURE__ */ P.jsx(EL, { children: o })
  ] }),
  /* @__PURE__ */ P.jsx(SL, { children: e }),
  t
] }), GC = "10px", TL = Ue.div`
  position: relative;

  &.is-full {
    width: 100%;
    max-width: 100%;
  }
`, OL = Rt`
  width: 256px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid ${ve[30]};
  color: ${ve[60]};
  background-color: ${ve[10]};
`, PL = {
  search: OL
}, RL = Ue.input`
  border-radius: ${Jn.BorderRadius.Small};
  border: solid 1px ${ve[30]};
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;

  &:hover {
    border-color: ${ln[50]};
  }

  &:focus,
  &:active {
    border-color: ${ln[50]};
    box-shadow: 0px 0px 0px 3px rgba(0, 146, 228, 0.25);
    outline: none;
  }

  &:disabled {
    background-color: ${ve[20]};
    border-color: ${ve[30]};
    color: ${ve[50]};
  }

  .has-left-element & {
    padding-left: 32px;
  }

  .has-right-element & {
    padding-right: 32px;
  }

  ${({
  $styleType: e
}) => e ? PL[e] : ""}
`, KC = Ue.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${ve[60]};
  display: flex;
  align-items: center;

  svg {
    width: 18px;
    height: 18px;
  }
`, AL = Ue(KC)`
  left: ${GC};
`, IL = Ue(KC)`
  right: ${GC};
`, dD = ({
  leftAddon: e,
  full: t,
  rightAddon: n,
  onChange: r,
  styleType: o,
  ...i
}) => {
  const a = me({
    "is-full": t !== void 0,
    "has-left-element": e,
    "has-right-element": n
  });
  return /* @__PURE__ */ P.jsxs(TL, { className: a, children: [
    e && /* @__PURE__ */ P.jsx(AL, { children: e }),
    /* @__PURE__ */ P.jsx(RL, { onChange: r, type: "text", $styleType: o, ...i }),
    n && /* @__PURE__ */ P.jsx(IL, { children: n })
  ] });
};
var kL = /* @__PURE__ */ ((e) => (e.SEARCH = "search", e))(kL || {});
const $L = Ue.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + .slider {
    background-color: #0071cd;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #0071cd;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`, NL = Ue.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #a3a9b9;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`, fD = ({
  checked: e,
  onChange: t
}) => {
  const [n, r] = wt(!1);
  return ut(() => {
    r(e);
  }, [e]), /* @__PURE__ */ P.jsxs($L, { "aria-label": "", children: [
    /* @__PURE__ */ P.jsx("input", { type: "checkbox", "aria-checked": n, checked: n, "aria-label": "Switch input", onChange: () => r((o) => (t && t(!o), !o)) }),
    /* @__PURE__ */ P.jsx(NL, { className: "slider" })
  ] });
}, FL = (e) => /* @__PURE__ */ y.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ y.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6271 8C13.6271 8.255 13.6046 8.495 13.5746 8.735L15.1571 9.9725C15.2996 10.085 15.3371 10.2875 15.2471 10.4525L13.7471 13.0475C13.6796 13.1675 13.5521 13.235 13.4246 13.235C13.3796 13.235 13.3346 13.2275 13.2896 13.2125L11.4221 12.4625C11.0321 12.755 10.6121 13.01 10.1546 13.1975L9.86958 15.185C9.84708 15.365 9.68958 15.5 9.50208 15.5H6.50208C6.31458 15.5 6.15708 15.365 6.13458 15.185L5.84958 13.1975C5.39208 13.01 4.97208 12.7625 4.58208 12.4625L2.71458 13.2125C2.67708 13.2275 2.63208 13.235 2.58708 13.235C2.45208 13.235 2.32458 13.1675 2.25708 13.0475L0.757077 10.4525C0.667077 10.2875 0.704577 10.085 0.847077 9.9725L2.42958 8.735C2.39958 8.495 2.37708 8.2475 2.37708 8C2.37708 7.7525 2.39958 7.505 2.42958 7.265L0.847077 6.0275C0.704577 5.915 0.659577 5.7125 0.757077 5.5475L2.25708 2.9525C2.32458 2.8325 2.45208 2.765 2.57958 2.765C2.62458 2.765 2.66958 2.7725 2.71458 2.7875L4.58208 3.5375C4.97208 3.245 5.39208 2.99 5.84958 2.8025L6.13458 0.815C6.15708 0.635 6.31458 0.5 6.50208 0.5H9.50208C9.68958 0.5 9.84708 0.635 9.86958 0.815L10.1546 2.8025C10.6121 2.99 11.0321 3.2375 11.4221 3.5375L13.2896 2.7875C13.3271 2.7725 13.3721 2.765 13.4171 2.765C13.5521 2.765 13.6796 2.8325 13.7471 2.9525L15.2471 5.5475C15.3371 5.7125 15.2996 5.915 15.1571 6.0275L13.5746 7.265C13.6046 7.505 13.6271 7.745 13.6271 8ZM12.127 8C12.127 7.8425 12.1195 7.685 12.0895 7.4525L11.9845 6.605L12.652 6.08L13.4545 5.4425L12.9295 4.535L11.977 4.9175L11.182 5.24L10.4995 4.715C10.1995 4.49 9.89949 4.3175 9.57699 4.1825L8.78199 3.86L8.66199 3.0125L8.51949 2H7.47699L7.32699 3.0125L7.20699 3.86L6.41199 4.1825C6.10449 4.31 5.79699 4.49 5.47449 4.73L4.79949 5.24L4.01949 4.925L3.06699 4.5425L2.54199 5.45L3.35199 6.08L4.01949 6.605L3.91449 7.4525C3.89199 7.6775 3.87699 7.85 3.87699 8C3.87699 8.15 3.89199 8.3225 3.91449 8.555L4.01949 9.4025L3.35199 9.9275L2.54199 10.5575L3.06699 11.465L4.01949 11.0825L4.81449 10.76L5.49699 11.285C5.79699 11.51 6.09699 11.6825 6.41949 11.8175L7.21449 12.14L7.33449 12.9875L7.47699 14H8.52699L8.67699 12.9875L8.79699 12.14L9.59199 11.8175C9.89949 11.69 10.207 11.51 10.5295 11.27L11.2045 10.76L11.9845 11.075L12.937 11.4575L13.462 10.55L12.652 9.92L11.9845 9.395L12.0895 8.5475C12.112 8.3225 12.127 8.1575 12.127 8ZM8.0022 5C6.3447 5 5.0022 6.3425 5.0022 8C5.0022 9.6575 6.3447 11 8.0022 11C9.6597 11 11.0022 9.6575 11.0022 8C11.0022 6.3425 9.6597 5 8.0022 5ZM6.5022 8C6.5022 8.825 7.1772 9.5 8.0022 9.5C8.8272 9.5 9.5022 8.825 9.5022 8C9.5022 7.175 8.8272 6.5 8.0022 6.5C7.1772 6.5 6.5022 7.175 6.5022 8Z", fill: "#696F88" })), LL = {
  colors: {
    base_dark_blue: "#00a0be",
    base_light_blue: "#00b5d8",
    base_dark_green: "#749204",
    base_light_green: "#aab400",
    base_light_green_2: "#cbcf6e",
    base_orange: "#eb8205",
    base_yellow: "#ffca41",
    base_yellow_2: "#ffd17e",
    base_red: "#d91e3f",
    base_dark_grey: "#c1c5c8",
    base_light_grey: "#f2f4f6",
    base_white: "#ffffff",
    base_black: "#2f3031",
    base_purple_heart: "#882d8e",
    base_iris: "#4b57d1",
    base_dark_orchid: "#ac38c0",
    base_field_drab: "#7b5d21",
    base_flame: "#df4c29",
    base_steel_blue: "#3c7ea1",
    base_dark_tan: "#977c42",
    base_deep_carrot_orange: "#dc7237",
    base_bleu_de_france: "#4396ef",
    base_old_rose: "#cb7b80",
    base_cadet_blue: "#53a491",
    base_cornflower_blue: "#6f93e3",
    base_persian_pink: "#e977b3",
    base_brass: "#bba536",
    base_olivine: "#9eaa75",
    base_tiger_eye: "#e89d3c",
    base_mantis: "#73c461",
    base_apple_green: "#a3bc10",
    base_sky_blue: "#81bddb",
    base_bright_ube: "#c2a5f5",
    base_medium_turquoise: "#69d5d1",
    base_june_bud: "#b9d950",
    base_light_green_3: "#7dea99",
    base_straw: "#e3d66d",
    base_medium_spring_bud: "#d7dd9d",
    base_gainsboro: "#d9e3e4",
    cws_blue_10: "#EAF6FF",
    cws_blue_20: "#C6E6FF",
    cws_blue_30: "#82CFFF",
    cws_blue_40: "#31B4F2",
    cws_blue_50: "#0092E4",
    cws_blue_60: "#0071CD",
    cws_blue_70: "#005693",
    cws_blue_80: "#003B69",
    cws_blue_90: "#002747",
    cws_blue_100: "#00172D",
    cws_green_10: "#DFFBE8",
    cws_green_20: "#C3EAD1",
    cws_green_30: "#90D6AA",
    cws_green_40: "#5EBB7F",
    cws_green_50: "#19A04B",
    cws_green_60: "#14803C",
    cws_green_70: "#0C612C",
    cws_green_80: "#06431C",
    cws_green_90: "#032D10",
    cws_green_100: "#011B07",
    cws_red_10: "#FFF1F1",
    cws_red_20: "#FFD9D9",
    cws_red_30: "#FFB3B3",
    cws_red_40: "#F98989",
    cws_red_50: "#EB4B4B",
    cws_red_60: "#CF3537",
    cws_red_70: "#9C2628",
    cws_red_80: "#70191A",
    cws_red_90: "#4C0E0F",
    cws_red_100: "#300606",
    cws_orange_10: "#FFF1ED",
    cws_orange_20: "#FFDACE",
    cws_orange_30: "#FFB59D",
    cws_orange_40: "#FF785A",
    cws_orange_50: "#EE5B3A",
    cws_orange_60: "#C1462B",
    cws_orange_70: "#92331E",
    cws_orange_80: "#682213",
    cws_orange_90: "#48150A",
    cws_orange_100: "#2D0A04",
    cws_yellow_10: "#FFF3DD",
    cws_yellow_20: "#FFE4AE",
    cws_yellow_30: "#F0C355",
    cws_yellow_40: "#E99921",
    cws_yellow_50: "#C17E19",
    cws_yellow_60: "#9A6412",
    cws_yellow_70: "#744A0B",
    cws_yellow_80: "#523305",
    cws_yellow_90: "#372102",
    cws_yellow_100: "#221201",
    cws_teal_10: "#E0F9F7",
    cws_teal_20: "#A9EFE8",
    cws_teal_30: "#5FD2C8",
    cws_teal_40: "#46BBB0",
    cws_teal_50: "#2B9C92",
    cws_teal_60: "#217C74",
    cws_teal_70: "#165C56",
    cws_teal_80: "#0D413C",
    cws_teal_90: "#062B27",
    cws_teal_100: "#021917",
    cws_purple_10: "#F6F2FE",
    cws_purple_20: "#E7DDFC",
    cws_purple_30: "#D2BDF9",
    cws_purple_40: "#BA99F6",
    cws_purple_50: "#9664F0",
    cws_purple_60: "#8354D6",
    cws_purple_70: "#643AAA",
    cws_purple_80: "#462779",
    cws_purple_90: "#2E1954",
    cws_purple_100: "#1C0D35",
    cws_pink_10: "#FFF1F3",
    cws_pink_20: "#FFD8DF",
    cws_pink_30: "#FFB2C1",
    cws_pink_40: "#FF7D96",
    cws_pink_50: "#E85D78",
    cws_pink_60: "#BB485D",
    cws_pink_70: "#8D3545",
    cws_pink_80: "#65232F",
    cws_pink_90: "#45161E",
    cws_pink_100: "#2B0A10",
    cws_neutral_00: "#FFFFFF",
    cws_neutral_10: "#F3F4F6",
    cws_neutral_20: "#DFE2E7",
    cws_neutral_30: "#C2C7D0",
    cws_neutral_40: "#A3A9B9",
    cws_neutral_50: "#868CA2",
    cws_neutral_60: "#696F88",
    cws_neutral_70: "#4D5165",
    cws_neutral_80: "#363948",
    cws_neutral_90: "#232630",
    cws_neutral_100: "#14151C"
  }
}, YC = $a({}), ML = Rt`
  * {
    font-family: 'Noto Sans', sans-serif;
  }

  * > * {
    font-family: 'Noto Sans', sans-serif;
  }
`, DL = Ue.div`
  ${ML}
`, ZC = ({
  providerConfig: e,
  children: t
}) => /* @__PURE__ */ P.jsx(DL, { id: "cw-elements-settings-menu", children: /* @__PURE__ */ P.jsx(nE, { theme: LL, children: /* @__PURE__ */ P.jsx(br, { prefixCls: "cw-elements", children: /* @__PURE__ */ P.jsx(YC.Provider, { value: e, children: t }) }) }) }), Ls = {
  Big: 16,
  Medium: 12,
  Default: 8,
  Small: 4,
  XSmall: 2
}, jL = {
  10: "#EAF6FF",
  20: "#C6E6FF",
  30: "#82CFFF",
  40: "#31B4F2",
  50: "#0092E4",
  60: "#0071CD",
  70: "#005693",
  80: "#003B69",
  90: "#002747",
  100: "#00172D"
}, Dn = {
  0: "#FFFFFF",
  10: "#F3F4F6",
  20: "#DFE2E7",
  30: "#C2C7D0",
  40: "#A3A9B9",
  50: "#868CA2",
  60: "#696F88",
  70: "#4D5165",
  80: "#363948",
  90: "#232630",
  100: "#14151C"
}, Fn = {
  Title1: 56,
  Title2: 46,
  Title3: 36,
  Title4: 30,
  Title5: 24,
  Title6: 20,
  Body1: 16,
  Body2: 14,
  Subtitle1: 16,
  Subtitle2: 14,
  Button1: 14,
  Button2: 14,
  Caption: 12
}, ua = {
  Tooltip: 1070,
  Dropdown: 1050,
  Notification: 1010,
  Modal: 1e3,
  Drawer: 1005
}, BL = {
  BorderRadius: {
    Big: `${Ls.Big}px`,
    Medium: `${Ls.Medium}px`,
    Default: `${Ls.Default}px`,
    Small: `${Ls.Small}px`
  },
  FontSize: {
    Title1: `${Fn.Title1}px`,
    Title2: `${Fn.Title2}px`,
    Title3: `${Fn.Title3}px`,
    Title4: `${Fn.Title4}px`,
    Title5: `${Fn.Title5}px`,
    Title6: `${Fn.Title6}px`,
    Body1: `${Fn.Body1}px`,
    Body2: `${Fn.Body2}px`,
    Subtitle1: `${Fn.Subtitle1}px`,
    Subtitle2: `${Fn.Subtitle2}px`,
    Button1: `${Fn.Button1}px`,
    Button2: `${Fn.Button2}px`,
    Caption: `${Fn.Caption}px`
  },
  FontWeight: {
    Regular: 400,
    Bold: 600
  },
  ZIndex: {
    Below: -1,
    Above: 2,
    Default: 1,
    Tooltip: ua.Tooltip,
    Dropdown: ua.Dropdown,
    Notification: ua.Notification,
    Modal: ua.Modal,
    Drawer: ua.Drawer
  }
}, VL = Ue.button`
  @property --bgGradientStart {
    syntax: '<color>';
    initial-value: #00004b;
    inherits: false;
  }

  @property --bgGradientEnd {
    syntax: '<color>';
    initial-value: #369f61;
    inherits: false;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  transform: rotate(0deg);
  transition:
    background-color ease-in-out 300ms,
    --bgGradientStart ease-in-out 300ms,
    --bgGradientEnd ease-in-out 300ms,
    transform 300ms ease-in-out;

  svg {
    font-size: 16px;
    transform: rotate(0deg);
    transition: transform 300ms ease-in-out;
  }

  &:focus {
    outline-color: #c0e3f9;
  }

  ${({
  $active: e
}) => `
    ${e && `background-color: ${Dn[20]};`};

    &:active {
      background-color: ${Dn[20]};
    }

    &:hover:not(&:active) {
      ${!e && `background-color: ${Dn[10]};`};
    }
  `}

  ${({
  $primaryBg: e,
  $active: t
}) => e && `
    background: linear-gradient(
      90deg,
      var(--bgGradientStart) 0%,
      var(--bgGradientEnd) 100%
    );
    color: ${Dn[0]};

    svg {
      transform: rotate(90deg);

      path {
        fill: currentColor;
      }
    }

    &:hover:not(&:active) {
      ${!t && `
          --bgGradientStart: #000044;
          --bgGradientEnd: #318f57;
        `}
    }

    ${t && `
        --bgGradientStart: #00003c;
        --bgGradientEnd: #2b7f4e;
      `};
    &:active {
      --bgGradientStart: #00003c;
      --bgGradientEnd: #2b7f4e;    
    }
    
  `}
`, QC = ({
  primaryBg: e = !1,
  active: t = !1,
  onClick: n
}) => /* @__PURE__ */ P.jsx(VL, { $primaryBg: e, $active: t, onClick: n, "aria-label": "settings button", children: /* @__PURE__ */ P.jsx(FL, {}) }), hD = function(e) {
  return /* @__PURE__ */ P.jsx(ZC, { providerConfig: {}, children: /* @__PURE__ */ P.jsx(QC, { ...e }) });
}, UL = (e) => {
  var r, o;
  const [t, n] = wt(e ? document.querySelector(e) : null);
  return z0(() => {
    n(e ? document.querySelector(e) : null);
  }, [e]), t ? ((o = (r = t.getBoundingClientRect) == null ? void 0 : r.call(t)) == null ? void 0 : o.height) ?? 0 : 0;
}, HL = Ue.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  font-family: 'Noto Sans', sans-serif;

  .title {
    margin: 0;
    color: ${Dn[100]};
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    font-family: 'Noto Sans', sans-serif;
  }
`, zL = Ue.button`
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color ease-in-out 300ms,
    color ease-in-out 300ms;
  color: ${Dn[60]};
  font-size: 12px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${Dn[10]};
    color: ${Dn[100]};
  }

  &:focus {
    outline-color: #c0e3f9;
  }

  &:active {
    background-color: ${Dn[20]};
  }
`, qL = ({
  onClose: e,
  open: t,
  headerSelector: n,
  extraSection: r,
  productSettings: o
}) => {
  const {
    workspaceId: i,
    workspaceName: a,
    organizationId: s,
    organizationName: l,
    organizationCountry: c,
    organizationSource: u,
    propertyId: d,
    propertyName: f
  } = Bt(YC), {
    t: h
  } = Fa(), p = UL(n), [g, v] = wt();
  return ut(() => {
    const b = () => {
      dl.getCurrentUser().then((m) => {
        m && v(m.id);
      });
    };
    _o.getInstance().addCallbackAfterSetToken(b);
  }, []), /* @__PURE__ */ P.jsxs(Dh, { placement: "right", closable: !1, onClose: e, open: t, mask: !1, width: 308, style: {
    marginTop: p,
    height: `calc(100% - ${p}px)`,
    boxShadow: "-2px 8px 8px 0px #00000026",
    borderLeft: "1px solid #D4D4D4"
  }, styles: {
    body: {
      padding: "24px 14px",
      overflow: "auto",
      height: `calc(100% - ${p}px)`
    },
    wrapper: {
      boxShadow: "none",
      border: "none"
    }
  }, children: [
    /* @__PURE__ */ P.jsxs(HL, { children: [
      /* @__PURE__ */ P.jsx("h1", { className: "title", children: h("settings_menu.common.edit_and_manage_title") }),
      /* @__PURE__ */ P.jsx(zL, { type: "button", onClick: e, "aria-label": "close settings button", children: /* @__PURE__ */ P.jsx(Bo, { className: "close-icon" }) })
    ] }),
    r && /* @__PURE__ */ P.jsx("div", { style: {
      marginBottom: 12
    }, children: r }, "extraSection"),
    /* @__PURE__ */ P.jsx(gL, { component: "Settings Menu", workspaceId: i, workspaceName: a, orgId: s, orgName: l, orgCountry: c, orgSource: u, propertyId: d, propertyName: f, productSettings: o, extraDelay: r ? 300 : 0, accountId: g })
  ] });
}, WL = {}, GL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WL
}, Symbol.toStringTag, { value: "Module" })), KL = {}, YL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: KL
}, Symbol.toStringTag, { value: "Module" })), XC = {
  common: {
    associate_crop_condition_text: "Um eine Kultur einem Feld zuzuordnen, müssen Sie erst einen Betrieb und ein Feld anlegen",
    continue_setting_up_button: "Continue setting up",
    crop_to_field_association_text: "Crop to Field Association",
    field_registration_with_geometry_text: "Felder anlegen über Feldgrenzenzeichnungen",
    organization_registration_text: "Organization registration",
    property_registration_text: "Betrieb anlegen",
    register_field_condition_text: "Um ein Feld zu registrieren, müssen Sie zuerst einen Betrieb anlegen"
  },
  console: {
    connected_to_apps_ws: "Verbunden mit App WS",
    error_connect_to_websocket: "Fehler bei der Verbindung zum Websocket Server. Erneuter Versuch..."
  },
  error: {
    please_try_again_text: "Please try again.",
    please_try_later_text: "Please try again later.",
    problem_text: "We've had a problem",
    sorry_still_text: "Sorry, it still wasn't possible to load some of your settings.",
    sorry_text: "Sorry, it wasn't possible to load some of your settings.",
    still_problem_text: "We're still having problems",
    try_later_text: "Später versuchen"
  },
  get_started: {
    all_products_text: "können Sie all Ihre Produkte nutzen.",
    available_products_text: "PRODUKTE AUF DIE SIE BEREITS ZUGRIFF HABEN",
    minimum_settings_text: "Siehe die Mindesteinstellungen in",
    so_you_text: "Base, damit Sie",
    title: "Produkte aufrufen",
    to_cropwise_text: "Zu Cropwise!",
    welcome_text: "Wilkommen"
  }
}, JC = {
  button: {
    dismiss: "Dismiss",
    go_to_app: "Zum Produkt",
    try_again: "Try again"
  }
}, e3 = "Ungültige Anmeldedaten", t3 = "Bereits registrierte E-Mail Adresse oder Handynummer", n3 = "Diese E-mail-Adresse ist bereits registriert", r3 = "Nutzer haben kein Recht diese Handlung durchzuführen", o3 = {
  common: {
    edit_and_manage_title: "Edit and Manage"
  },
  crop_cycles: {
    title: "Crop Cycles",
    tooltip: "Create or edit crop cycles and agronomic data."
  },
  edit_members_and_their_roles: "Edit members and their roles.",
  equipments: {
    title: "Equipments",
    tooltip: "Create or edit vehicles and implements."
  },
  farm_settings: {
    title: "Farm Settings"
  },
  fields: {
    title: "Fields",
    tooltip: "Create and edit fields, and see changes over time."
  },
  inputs: {
    title: "Inputs",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel."
  },
  invite_members: {
    title: "Invite Members",
    tooltip: "Invite coworkers to access the farm"
  },
  is_running_low: "is running low",
  members: {
    title: "Members",
    tooltip: "See who has access to the farm and edit what each member can see"
  },
  notifications: {
    all_of_your_apps: "All of your Cropwise apps",
    and: "and",
    apps: "apps",
    are_now_available: "are now available!",
    continue: "Continue",
    cropwise_apps: "Cropwise apps",
    farm_setup: "Betriebseinstellungen",
    go_to: "Go to",
    if_you_prefer: "If you prefer, continue setting up your farm!",
    is_now_available: "is now available!",
    keep_following_the_steps: "Keep following the steps to enable all your",
    now_if_you_prefer: "now. If you prefer, continue setting up your farm!",
    see_all: "See all",
    you_are_close_to: "You're close to completing the settings!",
    you_can_go: "You can go to",
    you_can_go_to_these_apps: "You can go to these apps now."
  },
  products: {
    title: "Products",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel."
  },
  quota: "Kontingent",
  quota_warning: {
    about_title: "Über Kontingente",
    empower_title: "Digitalisieren Sie Ihre Felder mit {{ app }}",
    has_area_quota_text: "Ihre Organisation hat ein Flächenkontingent für die Nutzung von {{ app }}. Derzeit ist dieses Kontingent zu 90 % oder mehr ausgeschöpft.",
    learn_why_button: "Mehr erfahren.",
    manage_quota_button: "Kontingent verwalten",
    manage_text: "Verwalten Sie die Quote, wenn Sie {{ app }} mit mehr Feldern verwenden möchten.",
    more_apps_title: "weitere Cropwise apps",
    plural_text: "Ihr Unternehmen verfügt über offene Kontingente.",
    singular_text: "Ihre Organisation verfügt über ein {{ app }}-Kontingent.",
    to_free_up_quota_text: "Um Kontingente freizugeben, heben Sie die Zuweisung anderer Felder auf oder fordern Sie mehr Kontingente an."
  },
  seasons: {
    title: "Seasons",
    tooltip: "Create or edit crop cycles and agronomic data."
  }
}, ZL = {
  assistant: XC,
  common: JC,
  EACC001: e3,
  EACC002: t3,
  EACC003: n3,
  EORG013: r3,
  settings_menu: o3
}, QL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: e3,
  EACC002: t3,
  EACC003: n3,
  EORG013: r3,
  assistant: XC,
  common: JC,
  default: ZL,
  settings_menu: o3
}, Symbol.toStringTag, { value: "Module" })), XL = {}, JL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: XL
}, Symbol.toStringTag, { value: "Module" })), i3 = {
  common: {
    associate_crop_condition_text: "To associate a Crop to a Field, you must first have a Property and a Field",
    continue_setting_up_button: "Continue setting up",
    crop_to_field_association_text: "Crop to Field Association",
    field_registration_with_geometry_text: "Field registration with geometry",
    organization_registration_text: "Organization registration",
    property_registration_text: "Property registration",
    register_field_condition_text: "To register a Field, you must first have a Property"
  },
  console: {
    connected_to_apps_ws: "Connected to App WS",
    error_connect_to_websocket: "Error to connect to Websocket Server. Retrying..."
  },
  error: {
    please_try_again_text: "Please try again.",
    please_try_later_text: "Please try again later.",
    problem_text: "We've had a problem",
    sorry_still_text: "Sorry, it still wasn't possible to load some of your settings.",
    sorry_text: "Sorry, it wasn't possible to load some of your settings.",
    still_problem_text: "We're still having problems",
    try_later_text: "Try later"
  },
  get_started: {
    all_products_text: "can use all your apps.",
    available_products_text: "PRODUCTS YOU CAN ALREADY ACCESS",
    minimum_settings_text: "See the minimum settings in",
    so_you_text: "so you",
    title: "Get Started",
    to_cropwise_text: " to Cropwise!",
    welcome_text: "Welcome"
  }
}, a3 = {
  button: {
    dismiss: "Dismiss",
    go_to_app: "Go to app",
    try_again: "Try again"
  }
}, s3 = "Bad credentials", l3 = "E-mail address or mobile number already  registered", c3 = "This email is already registered", u3 = "User doesn't have permission to perform the requested action", d3 = {
  accounts: {
    title: "Accounts",
    tooltip: "Manage all info related to your Cropwise account "
  },
  common: {
    edit_and_manage_title: "Edit and Manage"
  },
  connect: {
    data_matching_title: "Data matching",
    data_matching_tooltip: "Manage apps, services and data connected to Cropwise",
    file_upload_title: "File Upload",
    file_upload_tooltip: "Add machine operations",
    integrations_title: "Integrations",
    integrations_tooltip: "Access the apps and services integrated with Cropwise",
    title: "Connect",
    tooltip: "Manage apps, services and data connected to Cropwise"
  },
  crop_cycles: {
    title: "Seasons",
    tooltip: `End the current season, start a new one 
and select fields for each crop`
  },
  divisions: {
    title: "Divisions",
    tooltip: "Group organizations into different sectors, stores or staff members"
  },
  edit_members_and_their_roles: "See who has access to the farm and edit what each member can see",
  equipments: {
    title: "Equipment",
    tooltip: "Add and edit equipment such as planters"
  },
  farm_settings: {
    title: "Farm Settings",
    tooltip: "Create and manage your digital farm to use Cropwise products "
  },
  fields: {
    extra_button_tooltip: "Quickly add fields",
    title: "Fields",
    tooltip: "Create new, edit shapes and see editing history"
  },
  inputs: {
    extra_button_tooltip: "Quickly add inputs",
    title: "Inputs",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel"
  },
  invite_members: {
    title: "Invite Members",
    tooltip: "Invite coworkers to access the farm"
  },
  is_running_low: "is running low",
  manage_quotas: {
    title: "Manage quota",
    tooltip: "Check and edit the hectares available for using Cropwise apps"
  },
  members_and_contacts: {
    extraButtonTooltip: "Quickly invite members",
    title: "Members & Contacts",
    tooltip: "Edit the contact list and members of the organization"
  },
  members: {
    title: "Members",
    tooltip: "See who has access to the farm and edit what each member can see"
  },
  notifications: {
    all_of_your_apps: "All of your Cropwise apps",
    and: "and",
    apps: "apps",
    are_now_available: "are now available!",
    continue: "Continue",
    cropwise_apps: "Cropwise apps",
    farm_setup: "Farm Setup",
    go_to: "Go to",
    if_you_prefer: "If you prefer, continue setting up your farm!",
    is_now_available: "is now available!",
    keep_following_the_steps: "Keep following the steps to enable all your",
    now_if_you_prefer: "now. If you prefer, continue setting up your farm!",
    see_all: "See all",
    you_are_close_to: "You're close to completing the settings!",
    you_can_go: "You can go to",
    you_can_go_to_these_apps: "You can go to these apps now."
  },
  onboarding: {
    assign_crops: "Assign crops",
    continue: "Continue setup",
    create_fields: "Create fields",
    step: "Step {{current}} of {{total}}: "
  },
  products: {
    title: "Products",
    tooltip: "Add and edit products such as varieties, insecticides and fuel"
  },
  quota: "quota",
  quota_warning: {
    about_title: "About quotas",
    empower_title: "Empower your fields with {{ app }}",
    has_area_quota_text: "Your organization has an area quota to use {{ app }}. Currently this quota is 90% or more used.",
    learn_why_button: "Learn why.",
    manage_quota_button: "Manage quota",
    manage_text: "Manage quota if you'd like to use {{ app }} with more fields.",
    more_apps_title: "more Cropwise apps",
    plural_text: "Your organization has available quotas.",
    singular_text: "Your organization has available {{ app }} quota.",
    to_free_up_quota_text: "To free up quota, unassign other fields, or request more quota."
  },
  seasons: {
    title: "Seasons",
    tooltip: "Create or edit crop cycles and agronomic data"
  }
}, eM = {
  assistant: i3,
  common: a3,
  EACC001: s3,
  EACC002: l3,
  EACC003: c3,
  EORG013: u3,
  settings_menu: d3
}, tM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: s3,
  EACC002: l3,
  EACC003: c3,
  EORG013: u3,
  assistant: i3,
  common: a3,
  default: eM,
  settings_menu: d3
}, Symbol.toStringTag, { value: "Module" })), f3 = {
  common: {
    associate_crop_condition_text: "Para asociar un cultivo a una parcela, primero hay que tener una explotación y una parcela",
    continue_setting_up_button: "Continuar configurando",
    crop_to_field_association_text: "Asociación entre cultivos y parcelas",
    field_registration_with_geometry_text: "Registro de explotación con geometría",
    organization_registration_text: "Registro de la organización",
    property_registration_text: "Registro de propiedad",
    register_field_condition_text: "Para registrar una parcela, primero hay que crear una propiedad"
  },
  console: {
    connected_to_apps_ws: "Conectado a la App WS",
    error_connect_to_websocket: "Error al conectar con el servidor Websocket. Reintentando..."
  },
  error: {
    please_try_again_text: "Por favor, pruebe otra vez",
    please_try_later_text: "Por favor, inténtelo de nuevo más tarde",
    problem_text: "Hemos tenido un problema",
    sorry_still_text: "Lo siento, todavía no ha sido posible cargar algunos de sus ajustes",
    sorry_text: "Lo siento, no ha sido posible cargar algunos de sus ajustes",
    still_problem_text: "Todavía tenemos problemas",
    try_later_text: "Inténtelo más tarde"
  },
  get_started: {
    all_products_text: "Puede utilizar todas sus aplicaciones",
    available_products_text: "PRODUCTOS A LOS QUE YA PUEDE ACCEDER",
    minimum_settings_text: "Consulte los ajustes mínimos en",
    so_you_text: "Así que",
    title: "Comenzar",
    to_cropwise_text: "¡A Cropwise!",
    welcome_text: "Bienvenido"
  }
}, h3 = {
  button: {
    dismiss: "Descartar",
    go_to_app: "Ir a la aplicación",
    try_again: "Inténtelo de nuevo"
  }
}, p3 = "Credenciales no válidas", v3 = "Dirección de correo electrónico o número de móvil ya registrado", g3 = "Este correo electrónico ya está registrado ", m3 = "El usuario no tiene permiso para realizar la acción solicitada", y3 = {
  accounts: {
    title: "Cuentas",
    tooltip: "Gestione toda la información relacionada con su cuenta de Cropwise"
  },
  common: {
    edit_and_manage_title: "Editar y administrar"
  },
  connect: {
    data_matching_title: "Coincidencia de datos",
    data_matching_tooltip: "Administre apps, servicios y datos conectados a Cropwise",
    file_upload_title: "Carga de archivos",
    file_upload_tooltip: "Adición de operaciones de máquina",
    integrations_title: "Integraciones",
    integrations_tooltip: "Acceda a las apps y servicios integrados con Cropwise",
    title: "Conectar",
    tooltip: "Administre apps, servicios y datos conectados a Cropwise"
  },
  crop_cycles: {
    title: "Ciclos de cultivos",
    tooltip: "Cree o edite ciclos de cultivos y datos agronómicos"
  },
  divisions: {
    title: "Divisiones",
    tooltip: "Agrupe las organizaciones en diferentes sectores, almacebes o miembros del personal"
  },
  edit_members_and_their_roles: "Editar miembros y sus roles",
  equipments: {
    title: "Equipments",
    tooltip: "Create or edit vehicles and implements."
  },
  farm_settings: {
    title: "Configuración de la explotación",
    tooltip: "Cree y gestione su explotación digital para utilizar los productos de Cropwise"
  },
  fields: {
    extra_button_tooltip: "Añada parcelas rápidamente",
    title: "Parcelas",
    tooltip: "Cree y edite campos y vea los cambios a lo largo del tiempo"
  },
  inputs: {
    title: "Inputs",
    tooltip: "Cree o edite productos como pesticidas, variedades, reguladores y combustible"
  },
  invite_members: {
    title: "Invite a los miembros",
    tooltip: "Invite a sus compañeros de trabajo a acceder a la explotación"
  },
  is_running_low: "Se está agotando",
  manage_quotas: {
    title: "Gestionar la cuota",
    tooltip: "Verifique y edite las hectáreas disponibles para usar las aplicaciones de Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Invitar rápidamente a miembros",
    title: "Miembros y contactos",
    tooltip: "Editar la lista de contactos y los miembros de la organización"
  },
  members: {
    title: "Miembros",
    tooltip: "Vea quién tiene acceso a la explotación y edite lo que cada miembro puede ver"
  },
  notifications: {
    all_of_your_apps: "Todas sus aplicaciones Cropwise",
    and: "y",
    apps: "Aplicaciones",
    are_now_available: "¡Ya están disponibles!",
    continue: "Continuar",
    cropwise_apps: "Aplicaciones Cropwise",
    farm_setup: "Configurar Explotación",
    go_to: "Ir a",
    if_you_prefer: "Si lo prefiere, continue configurando su explotación",
    is_now_available: "¡Ya está disponible!",
    keep_following_the_steps: "Siga los pasos para habilitar todos sus",
    now_if_you_prefer: "Ahora, si lo prefiere, continue configurando su explotación",
    see_all: "Ver todo",
    you_are_close_to: "¡Está cerca de completar la configuración!",
    you_can_go: "Puede ir",
    you_can_go_to_these_apps: "Puede ir ya a esas aplicaciones"
  },
  onboarding: {
    assign_crops: "Asignar cultivos",
    continue: "Continuar la configuración",
    create_fields: "Crear campos",
    step: "Paso {{current}} de {{total}}:"
  },
  products: {
    title: "Productos",
    tooltip: "Cree o edite productos como pesticidas, variedades, reguladores y combustible"
  },
  quota: "Cuota",
  quota_warning: {
    about_title: "Sobre las cuotas",
    empower_title: "Potencie sus explotaciones con {{ app }}",
    has_area_quota_text: "Su organización tiene una cuota de área para utilizar {{ app }}. Actualmente esta cuota está utilizada en un 90% o más",
    learn_why_button: "Aprenda por qué",
    manage_quota_button: "Gestionar la cuota",
    manage_text: "Gestione la cuota si desea utilizar {{ app }} con más explotaciones",
    more_apps_title: "Más aplicaciones de Cropwise",
    plural_text: "Su organización dispone de cuotas",
    singular_text: "Su organización dispone de la cuota {{ app }}",
    to_free_up_quota_text: "Para liberar cuota, desasigne otras explotaciones o solicite más cuota"
  },
  seasons: {
    title: "Ciclos de cultivos",
    tooltip: "Cree o edite ciclos de cultivos y datos agronómicos"
  }
}, nM = {
  assistant: f3,
  common: h3,
  EACC001: p3,
  EACC002: v3,
  EACC003: g3,
  EORG013: m3,
  settings_menu: y3
}, rM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: p3,
  EACC002: v3,
  EACC003: g3,
  EORG013: m3,
  assistant: f3,
  common: h3,
  default: nM,
  settings_menu: y3
}, Symbol.toStringTag, { value: "Module" })), b3 = {
  common: {
    associate_crop_condition_text: "Para asociar un cultivo a una parcela, primero hay que crear una explotación y una parcela",
    continue_setting_up_button: "Continuar configurando",
    crop_to_field_association_text: "Asociación de un cultivo a una parcela",
    field_registration_with_geometry_text: "Registro de explotación con geometría",
    organization_registration_text: "Registro de la organización",
    property_registration_text: "Registro de la explotación",
    register_field_condition_text: "Para registrar una parcela, primero hay que crear una explotación"
  },
  console: {
    connected_to_apps_ws: "Conectado a App WS ",
    error_connect_to_websocket: "Error conectando con el servidor. Intentando de nuevo..."
  },
  error: {
    please_try_again_text: "Por favor, pruebe otra vez",
    please_try_later_text: "Por favor, inténtelo de nuevo más tarde",
    problem_text: "Hemos tenido un problema",
    sorry_still_text: "Lo sentimos, todavía no fue posible cargar algunas de tus configuraciones",
    sorry_text: "Lo sentimos, no fue posible cargar algunas de sus configuraciones",
    still_problem_text: "Todavía tenemos problemas",
    try_later_text: "Intente más tarde"
  },
  get_started: {
    all_products_text: "Puede utilizar todos sus productos de Cropwise",
    available_products_text: "PRODUCTOS A LOS QUE YA PUEDE ACCEDER ",
    minimum_settings_text: "Consulte los ajustes mínimos en",
    so_you_text: "Usted tambien ",
    title: "Empezar",
    to_cropwise_text: "¡A Cropwise!",
    welcome_text: "Bienvenido"
  }
}, C3 = {
  button: {
    dismiss: "Descartar",
    go_to_app: "Ir al producto ",
    try_again: "Inténtelo de nuevo"
  }
}, w3 = "Credenciales inválidas", E3 = "La dirección de correo electrónico o el número móvil ya están registrados", _3 = "Este correo electrónico ya está registrado ", x3 = "El usuario no tiene permiso de realizar la acción solicitada ", S3 = {
  accounts: {
    title: "Cuentas ",
    tooltip: "Gestione toda la información relacionada con su cuenta de Cropwise"
  },
  common: {
    edit_and_manage_title: "Editar y administrar"
  },
  connect: {
    data_matching_title: "Coincidencia de datos",
    data_matching_tooltip: "Administre apps, servicios y datos conectados a Cropwise",
    file_upload_title: "Carga de archivos",
    file_upload_tooltip: "Adición de operaciones de máquina",
    integrations_title: "Integraciones",
    integrations_tooltip: "Acceda a las apps y servicios integrados con Cropwise",
    title: "Conectar",
    tooltip: "Administre apps, servicios y datos conectados a Cropwise"
  },
  crop_cycles: {
    title: "Ciclos de cultivos",
    tooltip: "Cree o edite ciclos de cultivos y datos agronómicos"
  },
  divisions: {
    title: "Divisiones",
    tooltip: "Agrupe organizaciones en diferentes sectores, almacenes o miembros del personal"
  },
  edit_members_and_their_roles: "Editar miembros y sus roles",
  equipments: {
    title: "Equipos",
    tooltip: "Crear o editar vehículos e implementos"
  },
  farm_settings: {
    title: "Configuración de la explotación",
    tooltip: "Cree y gestione su explotación digital para utilizar los productos de Cropwise"
  },
  fields: {
    extra_button_tooltip: "Añadir parcelas rápidamente",
    title: "Parcelas",
    tooltip: "Cree y edite parcelas y vea los cambios a lo largo del tiempo"
  },
  inputs: {
    extra_button_tooltip: "Añadir insumos rápidamente",
    title: "Insumos",
    tooltip: "Cree o edite productos como fitosanitarios, variedades, reguladores de crecimiento y combustible"
  },
  invite_members: {
    title: "Invite a los miembros",
    tooltip: "Invite a sus compañeros de trabajo a acceder a la explotación"
  },
  is_running_low: "Se está agotando",
  manage_quotas: {
    title: "Gestione su quota",
    tooltip: "Compruebe y edite las hectáreas disponibles para utilizar las aplicaciones Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Invitar rápidamente a los miembros",
    title: "Miembros y contactos",
    tooltip: "Editar la lista de contactos y miembros de la organización"
  },
  members: {
    title: "Miembros",
    tooltip: "Vea quién tiene acceso a la explotación y edite lo que cada miembro puede ver"
  },
  notifications: {
    all_of_your_apps: "Todas sus aplicaciones Cropwise",
    and: "y",
    apps: "Aplicaciones",
    are_now_available: "¡Ya están disponibles!",
    continue: "Continuar",
    cropwise_apps: "Aplicaciones Cropwise",
    farm_setup: "Confirgurar Explotación",
    go_to: "Ir a ",
    if_you_prefer: "Si lo prefiere, ¡siga configurando su explotación!",
    is_now_available: "¡Ya está disponible!",
    keep_following_the_steps: "Siga los pasos para habilitar todos sus",
    now_if_you_prefer: "Ahora, ¡si lo prefiere, siga configurando su explotación!",
    see_all: "Ver todo",
    you_are_close_to: "¡Está cerca de completar la configuración!",
    you_can_go: "Puede ir a",
    you_can_go_to_these_apps: "Puede ir a estas aplicaciones ahora"
  },
  onboarding: {
    assign_crops: "Asignar cultivos",
    continue: "Continuar con la configuración",
    create_fields: "Crear parcelas",
    step: "Paso {{current}} de {{total}}:"
  },
  products: {
    title: "Productos",
    tooltip: "Cree o edite productos como fitosanitarios, variedades, reguladores de crecimiento y combustible"
  },
  quota: "Cuota",
  quota_warning: {
    about_title: "Acerca de las cuotas",
    empower_title: "Su organización está disponible",
    has_area_quota_text: "Su organización tiene una cuota de área para usar {{ app }} . Actualmente esta cuota se utiliza en un 90% o más",
    learn_why_button: "Saber por qué",
    manage_quota_button: "Gestione su quota",
    manage_text: "Administre la cuota si desea utilizar {{ app }} con más explotaciones",
    more_apps_title: "Más aplicaciones de Cropwise",
    plural_text: "Su organización dispone de cuotas",
    singular_text: "Su organización dispone de la cuota {{ app }} ",
    to_free_up_quota_text: "Para liberar cuota, desasignar otras explotaciones o solicitar más cuota"
  },
  seasons: {
    title: "Campañas",
    tooltip: "Cree o edite ciclos de cultivos y datos agronómicos"
  }
}, oM = {
  assistant: b3,
  common: C3,
  EACC001: w3,
  EACC002: E3,
  EACC003: _3,
  EORG013: x3,
  settings_menu: S3
}, iM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: w3,
  EACC002: E3,
  EACC003: _3,
  EORG013: x3,
  assistant: b3,
  common: C3,
  default: oM,
  settings_menu: S3
}, Symbol.toStringTag, { value: "Module" })), T3 = {
  common: {
    associate_crop_condition_text: "Pour associer une culture à une parcelle, veuillez d'abord créer une exploitation et une parcelle.",
    continue_setting_up_button: "Continuer la configuration",
    crop_to_field_association_text: "Association de la culture à la parcelle",
    field_registration_with_geometry_text: "Enregistrer une parcelle avec l'outil de géométrie",
    organization_registration_text: "Enregistrement de l'organisation",
    property_registration_text: "Enregistrement de l'exploitation",
    register_field_condition_text: "Pour enregistrer une parcelle, vous devez avoir une exploitation."
  },
  console: {
    connected_to_apps_ws: "Connecté à App WS",
    error_connect_to_websocket: "Erreur de connexion au serveur Websocket. Réessayer..."
  },
  error: {
    please_try_again_text: "Please try again.",
    please_try_later_text: "Please try again later.",
    problem_text: "Nous avons rencontré un problème",
    sorry_still_text: "Désolé, il n'a toujours pas été possible de charger certains de vos paramètres.",
    sorry_text: "Désolé, il n'a pas été possible de charger certains de vos paramètres.",
    still_problem_text: "We're still having problems",
    try_later_text: "Essayer plus tard"
  },
  get_started: {
    all_products_text: "peut utiliser toutes vos applications.",
    available_products_text: "Produits auxquels vous avez déjà accès",
    minimum_settings_text: "Voir les paramètres minimaux dans",
    so_you_text: "pour que vous",
    title: "Commencez",
    to_cropwise_text: "à Cropwise !",
    welcome_text: "Bienvenue"
  }
}, O3 = {
  button: {
    dismiss: "Fermer",
    go_to_app: "Aller à",
    try_again: "Réessayer"
  }
}, P3 = "Mauvais accès", R3 = "Adresse email ou numéro de téléphone portable déjà enregistré", A3 = "Cet e-mail est déjà enregistré", I3 = "L'utilisateur n'a pas la permission d'effectuer l'action demandée.", k3 = {
  accounts: {
    title: "Comptes",
    tooltip: "Gérez toutes les informations relatives à votre compte Cropwise"
  },
  common: {
    edit_and_manage_title: "Modifier et Gérer"
  },
  connect: {
    data_matching_title: "Correspondance des données",
    data_matching_tooltip: "Gérez les applications, les services et les données connectés à Cropwise",
    file_upload_title: "Téléchargement de fichiers",
    file_upload_tooltip: "Ajouter des opérations de machine",
    integrations_title: "Intégrations",
    integrations_tooltip: "Accédez aux applications et services intégrés à Cropwise",
    title: "Connecter",
    tooltip: "Gérez les applications, les services et les données connectés à Cropwise"
  },
  crop_cycles: {
    title: "Campagnes",
    tooltip: "Créez ou modifiez des cycles de culture et des données agronomiques."
  },
  divisions: {
    title: "Sections",
    tooltip: "Regroupez les organisations en différentes secteurs, magasins ou membres du personnel"
  },
  edit_members_and_their_roles: "Voir qui a accès à l'exploitation et modifier ce que chaque utilisateur peut voir",
  equipments: {
    title: "Matériel",
    tooltip: "Créez ou modifiez des équipements et des outils."
  },
  farm_settings: {
    title: "Configuration de l'exploitation",
    tooltip: "Créez et gérez votre exploitation pour utiliser les produits Cropwise"
  },
  fields: {
    extra_button_tooltip: "Ajouter rapidement des parcelles",
    title: "Parcelles",
    tooltip: "Créez et modifiez des parcelles et observez les changements au fil du temps."
  },
  inputs: {
    extra_button_tooltip: "Ajouter rapidement des informations",
    title: "Intrants",
    tooltip: "Créez ou modifiez des produits tels que des pesticides, des variétés, des régulateurs et des carburants."
  },
  invite_members: {
    title: "Inviter des utilisateurs",
    tooltip: "Inviter des collègues à accéder à l'exploitation"
  },
  is_running_low: "s'affaiblit",
  manage_quotas: {
    title: "Gérer les quotas",
    tooltip: "Vérifiez et modifiez les hectares disponibles pour l’utilisation des applications Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Inviter rapidement des utilisateurs",
    title: "Utilisateurs et contacts",
    tooltip: "Modifier la liste de contacts et les membres de l’organisation"
  },
  members: {
    title: "Utilisateurs",
    tooltip: "Voir qui a accès à l'exploitation et modifier ce que chaque membre peut voir"
  },
  notifications: {
    all_of_your_apps: "Toutes vos applications Cropwise",
    and: "et",
    apps: "applications",
    are_now_available: "sont maintenant disponibles !",
    continue: "Continuer",
    cropwise_apps: "Applications Cropwise",
    farm_setup: "Configuration de l'exploitation",
    go_to: "Aller à",
    if_you_prefer: "Si vous préférez, continuez à créer votre exploitation !",
    is_now_available: "est maintenant disponible!",
    keep_following_the_steps: "Continuez à suivre les étapes pour activer tous vos",
    now_if_you_prefer: "now. If you prefer, continue setting up your farm!",
    see_all: "See all",
    you_are_close_to: "Vous êtes sur le point de terminer le paramétrage.",
    you_can_go: "You can go to",
    you_can_go_to_these_apps: "Vous pouvez accéder à ces applications maintenant."
  },
  onboarding: {
    assign_crops: "Attribuer des cultures",
    continue: "Poursuivre la configuration",
    create_fields: "Créer des parcelles",
    step: "Étape {{current}} sur {{total}}"
  },
  products: {
    title: "Produits",
    tooltip: "Créez ou modifiez des produits tels que des pesticides, des variétés, des régulateurs et des carburants."
  },
  quota: "quota",
  quota_warning: {
    about_title: "A propos des quotas",
    empower_title: "Renforcez vos champs avec {{ app }}",
    has_area_quota_text: "Votre organisation dispose d'un quota de zone à utiliser {{ app }} . Actuellement, ce quota est utilisé à 90 % ou plus.",
    learn_why_button: "Apprenez pourquoi",
    manage_quota_button: "Gérer les quotas",
    manage_text: "Gérez vos quota si vous souhaitez utiliser {{ app }} avec plus de parcelles.",
    more_apps_title: "plus d'applications Cropwise",
    plural_text: "Votre organisation a des quotas disponibles.",
    singular_text: "Votre organisation dispose d'un quota de {{ app }}.",
    to_free_up_quota_text: "Pour libérer un quota, désattribuez d'autres parcelles ou demandez plus de quota."
  },
  seasons: {
    title: "Campagnes",
    tooltip: "Créez ou modifiez des cycles de culture et des données agronomiques."
  }
}, aM = {
  assistant: T3,
  common: O3,
  EACC001: P3,
  EACC002: R3,
  EACC003: A3,
  EORG013: I3,
  settings_menu: k3
}, sM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: P3,
  EACC002: R3,
  EACC003: A3,
  EORG013: I3,
  assistant: T3,
  common: O3,
  default: aM,
  settings_menu: k3
}, Symbol.toStringTag, { value: "Module" })), $3 = {
  common: {
    associate_crop_condition_text: "Ahhoz hogy növényt társíthasson a táblájához először rendelkeznie kell telephellyel  és táblával.",
    continue_setting_up_button: "Continue setting up",
    crop_to_field_association_text: "Növény társítása táblához",
    field_registration_with_geometry_text: "Tábla regisztrációja geometriával ",
    organization_registration_text: "Organization registration",
    property_registration_text: "Telephely regisztrációja",
    register_field_condition_text: "A táblák regisztrálásához először telehellyel kell rendelkeznie."
  },
  console: {
    connected_to_apps_ws: "Csatlakoztatva az App WS-hez ",
    error_connect_to_websocket: "Error to connect to Websocket Server. Retrying..."
  },
  error: {
    please_try_again_text: "Please try again.",
    please_try_later_text: "Please try again later.",
    problem_text: "We've had a problem",
    sorry_still_text: "Sorry, it still wasn't possible to load some of your settings.",
    sorry_text: "Sorry, it wasn't possible to load some of your settings.",
    still_problem_text: "We're still having problems"
  },
  get_started: {
    all_products_text: "Használhatja az összes termékét ",
    available_products_text: "PRODUCTS YOU CAN ALREADY ACCESS",
    minimum_settings_text: "Lásd minimális beállításokat",
    so_you_text: "so you",
    title: "Get Started",
    to_cropwise_text: "A Cropwise-hoz ",
    welcome_text: "Welcome"
  }
}, N3 = {
  button: {
    dismiss: "Dismiss",
    go_to_app: "Go to app",
    try_again: "Try again"
  }
}, F3 = "Rossz azonosító adatok ", L3 = "E-mail address or mobile number already  registered", M3 = "This email is already registered", D3 = "A felhasználónak nincs jogosultsága a kért művelet végrehajtásához.", j3 = {
  common: {
    edit_and_manage_title: "Edit and Manage"
  },
  crop_cycles: {
    title: "Crop Cycles",
    tooltip: "Create or edit crop cycles and agronomic data."
  },
  edit_members_and_their_roles: "Edit members and their roles.",
  equipments: {
    title: "Equipments",
    tooltip: "Create or edit vehicles and implements."
  },
  farm_settings: {
    title: "Farm Settings"
  },
  fields: {
    title: "Fields",
    tooltip: "Create and edit fields, and see changes over time."
  },
  inputs: {
    title: "Inputs",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel."
  },
  invite_members: {
    title: "Invite Members",
    tooltip: "Invite coworkers to access the farm"
  },
  members: {
    title: "Members",
    tooltip: "See who has access to the farm and edit what each member can see"
  },
  notifications: {
    all_of_your_apps: "All of your Cropwise apps",
    and: "and",
    apps: "apps",
    are_now_available: "are now available!",
    continue: "Continue",
    cropwise_apps: "Cropwise apps",
    go_to: "Go to",
    if_you_prefer: "If you prefer, continue setting up your farm!",
    is_now_available: "is now available!",
    keep_following_the_steps: "Keep following the steps to enable all your",
    now_if_you_prefer: "now. If you prefer, continue setting up your farm!",
    see_all: "See all",
    you_are_close_to: "You're close to completing the settings!",
    you_can_go: "You can go to",
    you_can_go_to_these_apps: "You can go to these apps now."
  },
  products: {
    title: "Products",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel."
  },
  seasons: {
    title: "Seasons",
    tooltip: "Create or edit crop cycles and agronomic data."
  }
}, lM = {
  assistant: $3,
  common: N3,
  EACC001: F3,
  EACC002: L3,
  EACC003: M3,
  EORG013: D3,
  settings_menu: j3
}, cM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: F3,
  EACC002: L3,
  EACC003: M3,
  EORG013: D3,
  assistant: $3,
  common: N3,
  default: lM,
  settings_menu: j3
}, Symbol.toStringTag, { value: "Module" })), uM = {}, dM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uM
}, Symbol.toStringTag, { value: "Module" })), fM = {}, hM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fM
}, Symbol.toStringTag, { value: "Module" })), pM = {}, vM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pM
}, Symbol.toStringTag, { value: "Module" })), B3 = {
  common: {
    associate_crop_condition_text: "To associate a Crop to a Field, you must first have a Property and a Field",
    continue_setting_up_button: "Continue setting up",
    crop_to_field_association_text: "Crop to Field Association",
    field_registration_with_geometry_text: "Field registration with geometry",
    organization_registration_text: "Organization registration",
    property_registration_text: "Property registration",
    register_field_condition_text: "To register a Field, you must first have a Property"
  },
  console: {
    connected_to_apps_ws: "Połączony z App WS",
    error_connect_to_websocket: "Błąd połączenia z serwerem Websocket. Ponowna próba..."
  },
  error: {
    please_try_again_text: "Please try again.",
    please_try_later_text: "Please try again later.",
    problem_text: "We've had a problem",
    sorry_still_text: "Sorry, it still wasn't possible to load some of your settings.",
    sorry_text: "Sorry, it wasn't possible to load some of your settings.",
    still_problem_text: "We're still having problems"
  },
  get_started: {
    all_products_text: "może używać wszystkich twoich produktów.",
    available_products_text: "PRODUKTY, DO KTÓRYCH JUŻ MASZ DOSTĘP",
    minimum_settings_text: "Zobacz ustawienia minimalne w",
    so_you_text: "Base, więc",
    title: "Zaczynaj",
    to_cropwise_text: " w Cropwise!",
    welcome_text: "Witamy"
  }
}, V3 = {
  button: {
    dismiss: "Dismiss",
    go_to_app: "Przejdź do produktu",
    try_again: "Try again"
  }
}, U3 = "Złe dane uwierzytelniające", H3 = "Adres e-mail lub numer telefonu komórkowego już zarejestrowany", z3 = "Ten e-mail jest już zarejestrowany", q3 = "Użytkownik nie ma uprawnień do wykonania żądanej akcji", W3 = {
  common: {
    edit_and_manage_title: "Edit and Manage"
  },
  crop_cycles: {
    title: "Crop Cycles",
    tooltip: "Create or edit crop cycles and agronomic data."
  },
  edit_members_and_their_roles: "Edit members and their roles.",
  equipments: {
    title: "Equipments",
    tooltip: "Create or edit vehicles and implements."
  },
  farm_settings: {
    title: "Farm Settings"
  },
  fields: {
    title: "Fields",
    tooltip: "Create and edit fields, and see changes over time."
  },
  inputs: {
    title: "Inputs",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel."
  },
  invite_members: {
    title: "Invite Members",
    tooltip: "Invite coworkers to access the farm"
  },
  members: {
    title: "Members",
    tooltip: "See who has access to the farm and edit what each member can see"
  },
  notifications: {
    all_of_your_apps: "All of your Cropwise apps",
    and: "and",
    apps: "apps",
    are_now_available: "are now available!",
    continue: "Continue",
    cropwise_apps: "Cropwise apps",
    go_to: "Go to",
    if_you_prefer: "If you prefer, continue setting up your farm!",
    is_now_available: "is now available!",
    keep_following_the_steps: "Keep following the steps to enable all your",
    now_if_you_prefer: "now. If you prefer, continue setting up your farm!",
    see_all: "See all",
    you_are_close_to: "You're close to completing the settings!",
    you_can_go: "You can go to",
    you_can_go_to_these_apps: "You can go to these apps now."
  },
  products: {
    title: "Products",
    tooltip: "Create or edit products like pesticides, varieties, regulators and fuel."
  },
  seasons: {
    title: "Seasons",
    tooltip: "Create or edit crop cycles and agronomic data."
  }
}, gM = {
  assistant: B3,
  common: V3,
  EACC001: U3,
  EACC002: H3,
  EACC003: z3,
  EORG013: q3,
  settings_menu: W3
}, mM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: U3,
  EACC002: H3,
  EACC003: z3,
  EORG013: q3,
  assistant: B3,
  common: V3,
  default: gM,
  settings_menu: W3
}, Symbol.toStringTag, { value: "Module" })), G3 = {
  common: {
    associate_crop_condition_text: "Para associar uma safra a um talhão, você primeiro deve criar uma Propriedade e os talhões dela",
    continue_setting_up_button: "Continue as configurações",
    crop_to_field_association_text: "Associação de safra a talhão",
    field_registration_with_geometry_text: "Registro de talhão com geometria",
    organization_registration_text: "Registro de Organização",
    property_registration_text: "Registro de Propriedade",
    register_field_condition_text: "Para registrar um talhão, você primeiro precisa criar uma Propriedade"
  },
  console: {
    connected_to_apps_ws: "Conectado ao App WS",
    error_connect_to_websocket: "Erro para se conectar ao Websocket Server. Tentando novamente..."
  },
  error: {
    please_try_again_text: "Por favor, tente novamente.",
    please_try_later_text: "Por favor, tente novamente mais tarde.",
    problem_text: "Tivemos um problema",
    sorry_still_text: "Desculpa, ainda não conseguimos carregar algumas configurações.",
    sorry_text: "Desculpe, não foi possível carregar algumas configurações.",
    still_problem_text: "Ainda estamos tendo problemas",
    try_later_text: "Tente mais tarde"
  },
  get_started: {
    all_products_text: "para utilizar seus produtos.",
    available_products_text: "SEUS PRODUTOS:",
    minimum_settings_text: "Configure seu",
    so_you_text: "para que voê",
    title: "Acessar produtos",
    to_cropwise_text: " ao Cropwise!",
    welcome_text: "Bem-vindo"
  }
}, K3 = {
  button: {
    dismiss: "Fechar",
    go_to_app: "Acessar",
    try_again: "Tente novamente."
  }
}, Y3 = "Credenciais incorretas", Z3 = "Endereço de e-mail ou número de celular já cadastrado", Q3 = "Este email já foi registrado.", X3 = "O usuário não tem permissão para executar a ação", J3 = {
  accounts: {
    title: "Contas",
    tooltip: "Gerencie todas as informações relacionadas à sua conta Cropwise"
  },
  common: {
    edit_and_manage_title: "Editar e Gerenciar"
  },
  connect: {
    data_matching_title: "Combinar Dados",
    data_matching_tooltip: "Gerencie aplicativos, serviços e dados conectados ao Cropwise",
    file_upload_title: "Carregamento de arquivos",
    file_upload_tooltip: "Adicione operações de máquinas",
    integrations_title: "Integrações",
    integrations_tooltip: "Acesse os aplicativos e serviços integrados ao Cropwise",
    title: "Connect",
    tooltip: "Gerencie aplicativos, serviços e dados conectados ao Cropwise"
  },
  crop_cycles: {
    title: "Safras",
    tooltip: `Encerrar a safra atual, iniciar safra nova
e selecionar talhões para cada cultura`
  },
  divisions: {
    title: "Divisões",
    tooltip: "Agrupe organizações em diferentes setores, lojas ou membros da equipe"
  },
  edit_members_and_their_roles: "Veja quem tem acesso à propriedade e edite o que cada membro pode ver",
  equipments: {
    title: "Equipamentos",
    tooltip: "Adicionar e editar equipamentos como plantadeiras"
  },
  farm_settings: {
    title: "Configurações",
    tooltip: "Crie e gerencie sua fazenda digital para usar produtos Cropwise "
  },
  fields: {
    extra_button_tooltip: "Adicione talhões rapidamente",
    title: "Talhões",
    tooltip: "Criar novos, mudar formato, ver o histórico de edições"
  },
  inputs: {
    title: "Insumos",
    tooltip: "Crie ou edite produtos como pesticidas, variedades, reguladores e combustível "
  },
  invite_members: {
    title: "Convidar Membros",
    tooltip: "Convide pessoas para acessar a propriedade"
  },
  is_running_low: "está acabando",
  manage_quotas: {
    title: "Gerenciar quotas",
    tooltip: "Verifique e edite os hectares disponíveis para usar os apps Cropwise"
  },
  members_and_contacts: {
    extraButtonTooltip: "Convidar membros rapidamente",
    title: "Membros & Contatos",
    tooltip: "Convide membros e customize suas permissões"
  },
  members: {
    title: "Membros",
    tooltip: "Veja quem tem acesso à propriedade e edite o que cada membro pode ver"
  },
  notifications: {
    all_of_your_apps: "Todos os seus aplicativos Cropwise",
    and: "e",
    apps: "aplicativos",
    are_now_available: "já estão disponíveis!",
    continue: "Continuar",
    cropwise_apps: "aplicativos Cropwise",
    farm_setup: "Configuração da propriedade",
    go_to: "Vá para",
    if_you_prefer: "Se preferir, continue configurando sua fazenda!",
    is_now_available: "já está disponível!",
    keep_following_the_steps: "Continue seguindo os passos para habilitar todos os seus",
    now_if_you_prefer: "agora. Se preferir, continue configurando sua fazenda!",
    see_all: "Veja todos",
    you_are_close_to: "Você está perto de completar as configurações!",
    you_can_go: "Você pode accessar o",
    you_can_go_to_these_apps: "Você pode acessar esses aplicativos agora."
  },
  onboarding: {
    assign_crops: "Atribuir culturas",
    continue: "Continuar configuração",
    create_fields: "Criar talhões",
    step: "Passo {{current}} de {{total}}:"
  },
  products: {
    title: "Produtos",
    tooltip: "Adicionar e editar produtos, como variedades, inseticidas e combustível"
  },
  quota: "cota",
  quota_warning: {
    about_title: "Sobre cotas",
    empower_title: "Potencialize seus talhões com {{ app }}",
    has_area_quota_text: "Sua organização tem uma cota de área para usar {{ app }}. Atualmente essa cota está 90% ou mais usada.",
    learn_why_button: "Saiba por quê.",
    manage_quota_button: "Gerenciar cota",
    manage_text: "Gerencia a(s) cota(s) se quiser usar {{ app }} com mais talhões.",
    more_apps_title: "mais apps Cropwise",
    plural_text: "Sua organização tem cota disponível.",
    singular_text: "A sua organização tem cota disponível no {{ app }}.",
    to_free_up_quota_text: "Para liberar cota, dessasocie talhões ou adquira mais cota."
  },
  seasons: {
    title: "Safras",
    tooltip: "Crie ou edite safras e informações agronômicas "
  }
}, yM = {
  assistant: G3,
  common: K3,
  EACC001: Y3,
  EACC002: Z3,
  EACC003: Q3,
  EORG013: X3,
  settings_menu: J3
}, bM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EACC001: Y3,
  EACC002: Z3,
  EACC003: Q3,
  EORG013: X3,
  assistant: G3,
  common: K3,
  default: yM,
  settings_menu: J3
}, Symbol.toStringTag, { value: "Module" })), CM = {}, wM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CM
}, Symbol.toStringTag, { value: "Module" })), EM = {}, _M = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: EM
}, Symbol.toStringTag, { value: "Module" })), xM = {}, SM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xM
}, Symbol.toStringTag, { value: "Module" }));
var ew = { exports: {} };
(function(e) {
  (function() {
    function t(S, A, K) {
      return S.call.apply(S.bind, arguments);
    }
    function n(S, A, K) {
      if (!S)
        throw Error();
      if (2 < arguments.length) {
        var J = Array.prototype.slice.call(arguments, 2);
        return function() {
          var le = Array.prototype.slice.call(arguments);
          return Array.prototype.unshift.apply(le, J), S.apply(A, le);
        };
      }
      return function() {
        return S.apply(A, arguments);
      };
    }
    function r(S, A, K) {
      return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? t : n, r.apply(null, arguments);
    }
    var o = Date.now || function() {
      return +/* @__PURE__ */ new Date();
    };
    function i(S, A) {
      this.a = S, this.o = A || S, this.c = this.o.document;
    }
    var a = !!window.FontFace;
    function s(S, A, K, J) {
      if (A = S.c.createElement(A), K)
        for (var le in K)
          K.hasOwnProperty(le) && (le == "style" ? A.style.cssText = K[le] : A.setAttribute(le, K[le]));
      return J && A.appendChild(S.c.createTextNode(J)), A;
    }
    function l(S, A, K) {
      S = S.c.getElementsByTagName(A)[0], S || (S = document.documentElement), S.insertBefore(K, S.lastChild);
    }
    function c(S) {
      S.parentNode && S.parentNode.removeChild(S);
    }
    function u(S, A, K) {
      A = A || [], K = K || [];
      for (var J = S.className.split(/\s+/), le = 0; le < A.length; le += 1) {
        for (var be = !1, Oe = 0; Oe < J.length; Oe += 1)
          if (A[le] === J[Oe]) {
            be = !0;
            break;
          }
        be || J.push(A[le]);
      }
      for (A = [], le = 0; le < J.length; le += 1) {
        for (be = !1, Oe = 0; Oe < K.length; Oe += 1)
          if (J[le] === K[Oe]) {
            be = !0;
            break;
          }
        be || A.push(J[le]);
      }
      S.className = A.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function d(S, A) {
      for (var K = S.className.split(/\s+/), J = 0, le = K.length; J < le; J++)
        if (K[J] == A)
          return !0;
      return !1;
    }
    function f(S) {
      return S.o.location.hostname || S.a.location.hostname;
    }
    function h(S, A, K) {
      function J() {
        We && le && be && (We(Oe), We = null);
      }
      A = s(S, "link", { rel: "stylesheet", href: A, media: "all" });
      var le = !1, be = !0, Oe = null, We = K || null;
      a ? (A.onload = function() {
        le = !0, J();
      }, A.onerror = function() {
        le = !0, Oe = Error("Stylesheet failed to load"), J();
      }) : setTimeout(function() {
        le = !0, J();
      }, 0), l(S, "head", A);
    }
    function p(S, A, K, J) {
      var le = S.c.getElementsByTagName("head")[0];
      if (le) {
        var be = s(S, "script", { src: A }), Oe = !1;
        return be.onload = be.onreadystatechange = function() {
          Oe || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (Oe = !0, K && K(null), be.onload = be.onreadystatechange = null, be.parentNode.tagName == "HEAD" && le.removeChild(be));
        }, le.appendChild(be), setTimeout(function() {
          Oe || (Oe = !0, K && K(Error("Script load timeout")));
        }, J || 5e3), be;
      }
      return null;
    }
    function g() {
      this.a = 0, this.c = null;
    }
    function v(S) {
      return S.a++, function() {
        S.a--, m(S);
      };
    }
    function b(S, A) {
      S.c = A, m(S);
    }
    function m(S) {
      S.a == 0 && S.c && (S.c(), S.c = null);
    }
    function w(S) {
      this.a = S || "-";
    }
    w.prototype.c = function(S) {
      for (var A = [], K = 0; K < arguments.length; K++)
        A.push(arguments[K].replace(/[\W_]+/g, "").toLowerCase());
      return A.join(this.a);
    };
    function E(S, A) {
      this.c = S, this.f = 4, this.a = "n";
      var K = (A || "n4").match(/^([nio])([1-9])$/i);
      K && (this.a = K[1], this.f = parseInt(K[2], 10));
    }
    function C(S) {
      return T(S) + " " + (S.f + "00") + " 300px " + x(S.c);
    }
    function x(S) {
      var A = [];
      S = S.split(/,\s*/);
      for (var K = 0; K < S.length; K++) {
        var J = S[K].replace(/['"]/g, "");
        J.indexOf(" ") != -1 || /^\d/.test(J) ? A.push("'" + J + "'") : A.push(J);
      }
      return A.join(",");
    }
    function _(S) {
      return S.a + S.f;
    }
    function T(S) {
      var A = "normal";
      return S.a === "o" ? A = "oblique" : S.a === "i" && (A = "italic"), A;
    }
    function O(S) {
      var A = 4, K = "n", J = null;
      return S && ((J = S.match(/(normal|oblique|italic)/i)) && J[1] && (K = J[1].substr(0, 1).toLowerCase()), (J = S.match(/([1-9]00|normal|bold)/i)) && J[1] && (/bold/i.test(J[1]) ? A = 7 : /[1-9]00/.test(J[1]) && (A = parseInt(J[1].substr(0, 1), 10)))), K + A;
    }
    function I(S, A) {
      this.c = S, this.f = S.o.document.documentElement, this.h = A, this.a = new w("-"), this.j = A.events !== !1, this.g = A.classes !== !1;
    }
    function L(S) {
      S.g && u(S.f, [S.a.c("wf", "loading")]), j(S, "loading");
    }
    function B(S) {
      if (S.g) {
        var A = d(S.f, S.a.c("wf", "active")), K = [], J = [S.a.c("wf", "loading")];
        A || K.push(S.a.c("wf", "inactive")), u(S.f, K, J);
      }
      j(S, "inactive");
    }
    function j(S, A, K) {
      S.j && S.h[A] && (K ? S.h[A](K.c, _(K)) : S.h[A]());
    }
    function M() {
      this.c = {};
    }
    function q(S, A, K) {
      var J = [], le;
      for (le in A)
        if (A.hasOwnProperty(le)) {
          var be = S.c[le];
          be && J.push(be(A[le], K));
        }
      return J;
    }
    function N(S, A) {
      this.c = S, this.f = A, this.a = s(this.c, "span", { "aria-hidden": "true" }, this.f);
    }
    function $(S) {
      l(S.c, "body", S.a);
    }
    function F(S) {
      return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + x(S.c) + ";" + ("font-style:" + T(S) + ";font-weight:" + (S.f + "00") + ";");
    }
    function H(S, A, K, J, le, be) {
      this.g = S, this.j = A, this.a = J, this.c = K, this.f = le || 3e3, this.h = be || void 0;
    }
    H.prototype.start = function() {
      var S = this.c.o.document, A = this, K = o(), J = new Promise(function(Oe, We) {
        function Ke() {
          o() - K >= A.f ? We() : S.fonts.load(C(A.a), A.h).then(function(nt) {
            1 <= nt.length ? Oe() : setTimeout(Ke, 25);
          }, function() {
            We();
          });
        }
        Ke();
      }), le = null, be = new Promise(function(Oe, We) {
        le = setTimeout(We, A.f);
      });
      Promise.race([be, J]).then(function() {
        le && (clearTimeout(le), le = null), A.g(A.a);
      }, function() {
        A.j(A.a);
      });
    };
    function k(S, A, K, J, le, be, Oe) {
      this.v = S, this.B = A, this.c = K, this.a = J, this.s = Oe || "BESbswy", this.f = {}, this.w = le || 3e3, this.u = be || null, this.m = this.j = this.h = this.g = null, this.g = new N(this.c, this.s), this.h = new N(this.c, this.s), this.j = new N(this.c, this.s), this.m = new N(this.c, this.s), S = new E(this.a.c + ",serif", _(this.a)), S = F(S), this.g.a.style.cssText = S, S = new E(this.a.c + ",sans-serif", _(this.a)), S = F(S), this.h.a.style.cssText = S, S = new E("serif", _(this.a)), S = F(S), this.j.a.style.cssText = S, S = new E("sans-serif", _(this.a)), S = F(S), this.m.a.style.cssText = S, $(this.g), $(this.h), $(this.j), $(this.m);
    }
    var W = { D: "serif", C: "sans-serif" }, G = null;
    function ne() {
      if (G === null) {
        var S = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        G = !!S && (536 > parseInt(S[1], 10) || parseInt(S[1], 10) === 536 && 11 >= parseInt(S[2], 10));
      }
      return G;
    }
    k.prototype.start = function() {
      this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = o(), fe(this);
    };
    function Y(S, A, K) {
      for (var J in W)
        if (W.hasOwnProperty(J) && A === S.f[W[J]] && K === S.f[W[J]])
          return !0;
      return !1;
    }
    function fe(S) {
      var A = S.g.a.offsetWidth, K = S.h.a.offsetWidth, J;
      (J = A === S.f.serif && K === S.f["sans-serif"]) || (J = ne() && Y(S, A, K)), J ? o() - S.A >= S.w ? ne() && Y(S, A, K) && (S.u === null || S.u.hasOwnProperty(S.a.c)) ? ie(S, S.v) : ie(S, S.B) : ge(S) : ie(S, S.v);
    }
    function ge(S) {
      setTimeout(r(function() {
        fe(this);
      }, S), 50);
    }
    function ie(S, A) {
      setTimeout(r(function() {
        c(this.g.a), c(this.h.a), c(this.j.a), c(this.m.a), A(this.a);
      }, S), 0);
    }
    function he(S, A, K) {
      this.c = S, this.a = A, this.f = 0, this.m = this.j = !1, this.s = K;
    }
    var ue = null;
    he.prototype.g = function(S) {
      var A = this.a;
      A.g && u(A.f, [A.a.c("wf", S.c, _(S).toString(), "active")], [A.a.c("wf", S.c, _(S).toString(), "loading"), A.a.c("wf", S.c, _(S).toString(), "inactive")]), j(A, "fontactive", S), this.m = !0, ce(this);
    }, he.prototype.h = function(S) {
      var A = this.a;
      if (A.g) {
        var K = d(A.f, A.a.c("wf", S.c, _(S).toString(), "active")), J = [], le = [A.a.c("wf", S.c, _(S).toString(), "loading")];
        K || J.push(A.a.c("wf", S.c, _(S).toString(), "inactive")), u(A.f, J, le);
      }
      j(A, "fontinactive", S), ce(this);
    };
    function ce(S) {
      --S.f == 0 && S.j && (S.m ? (S = S.a, S.g && u(S.f, [S.a.c("wf", "active")], [S.a.c("wf", "loading"), S.a.c("wf", "inactive")]), j(S, "active")) : B(S.a));
    }
    function Se(S) {
      this.j = S, this.a = new M(), this.h = 0, this.f = this.g = !0;
    }
    Se.prototype.load = function(S) {
      this.c = new i(this.j, S.context || this.j), this.g = S.events !== !1, this.f = S.classes !== !1, ke(this, new I(this.c, S), S);
    };
    function te(S, A, K, J, le) {
      var be = --S.h == 0;
      (S.f || S.g) && setTimeout(function() {
        var Oe = le || null, We = J || null || {};
        if (K.length === 0 && be)
          B(A.a);
        else {
          A.f += K.length, be && (A.j = be);
          var Ke, nt = [];
          for (Ke = 0; Ke < K.length; Ke++) {
            var at = K[Ke], st = We[at.c], ct = A.a, Vt = at;
            if (ct.g && u(ct.f, [ct.a.c("wf", Vt.c, _(Vt).toString(), "loading")]), j(ct, "fontloading", Vt), ct = null, ue === null)
              if (window.FontFace) {
                var Vt = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xt = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                ue = Vt ? 42 < parseInt(Vt[1], 10) : !xt;
              } else
                ue = !1;
            ue ? ct = new H(r(A.g, A), r(A.h, A), A.c, at, A.s, st) : ct = new k(r(A.g, A), r(A.h, A), A.c, at, A.s, Oe, st), nt.push(ct);
          }
          for (Ke = 0; Ke < nt.length; Ke++)
            nt[Ke].start();
        }
      }, 0);
    }
    function ke(S, A, K) {
      var le = [], J = K.timeout;
      L(A);
      var le = q(S.a, K, S.c), be = new he(S.c, A, J);
      for (S.h = le.length, A = 0, K = le.length; A < K; A++)
        le[A].load(function(Oe, We, Ke) {
          te(S, be, Oe, We, Ke);
        });
    }
    function se(S, A) {
      this.c = S, this.a = A;
    }
    se.prototype.load = function(S) {
      function A() {
        if (be["__mti_fntLst" + J]) {
          var Oe = be["__mti_fntLst" + J](), We = [], Ke;
          if (Oe)
            for (var nt = 0; nt < Oe.length; nt++) {
              var at = Oe[nt].fontfamily;
              Oe[nt].fontStyle != null && Oe[nt].fontWeight != null ? (Ke = Oe[nt].fontStyle + Oe[nt].fontWeight, We.push(new E(at, Ke))) : We.push(new E(at));
            }
          S(We);
        } else
          setTimeout(function() {
            A();
          }, 50);
      }
      var K = this, J = K.a.projectId, le = K.a.version;
      if (J) {
        var be = K.c.o;
        p(this.c, (K.a.api || "https://fast.fonts.net/jsapi") + "/" + J + ".js" + (le ? "?v=" + le : ""), function(Oe) {
          Oe ? S([]) : (be["__MonotypeConfiguration__" + J] = function() {
            return K.a;
          }, A());
        }).id = "__MonotypeAPIScript__" + J;
      } else
        S([]);
    };
    function D(S, A) {
      this.c = S, this.a = A;
    }
    D.prototype.load = function(S) {
      var A, K, J = this.a.urls || [], le = this.a.families || [], be = this.a.testStrings || {}, Oe = new g();
      for (A = 0, K = J.length; A < K; A++)
        h(this.c, J[A], v(Oe));
      var We = [];
      for (A = 0, K = le.length; A < K; A++)
        if (J = le[A].split(":"), J[1])
          for (var Ke = J[1].split(","), nt = 0; nt < Ke.length; nt += 1)
            We.push(new E(J[0], Ke[nt]));
        else
          We.push(new E(J[0]));
      b(Oe, function() {
        S(We, be);
      });
    };
    function X(S, A) {
      S ? this.c = S : this.c = Q, this.a = [], this.f = [], this.g = A || "";
    }
    var Q = "https://fonts.googleapis.com/css";
    function _e(S, A) {
      for (var K = A.length, J = 0; J < K; J++) {
        var le = A[J].split(":");
        le.length == 3 && S.f.push(le.pop());
        var be = "";
        le.length == 2 && le[1] != "" && (be = ":"), S.a.push(le.join(be));
      }
    }
    function Ce(S) {
      if (S.a.length == 0)
        throw Error("No fonts to load!");
      if (S.c.indexOf("kit=") != -1)
        return S.c;
      for (var A = S.a.length, K = [], J = 0; J < A; J++)
        K.push(S.a[J].replace(/ /g, "+"));
      return A = S.c + "?family=" + K.join("%7C"), 0 < S.f.length && (A += "&subset=" + S.f.join(",")), 0 < S.g.length && (A += "&text=" + encodeURIComponent(S.g)), A;
    }
    function Ne(S) {
      this.f = S, this.a = [], this.c = {};
    }
    var ae = { latin: "BESbswy", "latin-ext": "çöüğş", cyrillic: "йяЖ", greek: "αβΣ", khmer: "កខគ", Hanuman: "កខគ" }, xe = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, Re = { i: "i", italic: "i", n: "n", normal: "n" }, mt = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function et(S) {
      for (var A = S.f.length, K = 0; K < A; K++) {
        var J = S.f[K].split(":"), le = J[0].replace(/\+/g, " "), be = ["n4"];
        if (2 <= J.length) {
          var Oe, We = J[1];
          if (Oe = [], We)
            for (var We = We.split(","), Ke = We.length, nt = 0; nt < Ke; nt++) {
              var at;
              if (at = We[nt], at.match(/^[\w-]+$/)) {
                var st = mt.exec(at.toLowerCase());
                if (st == null)
                  at = "";
                else {
                  if (at = st[2], at = at == null || at == "" ? "n" : Re[at], st = st[1], st == null || st == "")
                    st = "4";
                  else
                    var ct = xe[st], st = ct || (isNaN(st) ? "4" : st.substr(0, 1));
                  at = [at, st].join("");
                }
              } else
                at = "";
              at && Oe.push(at);
            }
          0 < Oe.length && (be = Oe), J.length == 3 && (J = J[2], Oe = [], J = J ? J.split(",") : Oe, 0 < J.length && (J = ae[J[0]]) && (S.c[le] = J));
        }
        for (S.c[le] || (J = ae[le]) && (S.c[le] = J), J = 0; J < be.length; J += 1)
          S.a.push(new E(le, be[J]));
      }
    }
    function tt(S, A) {
      this.c = S, this.a = A;
    }
    var _t = { Arimo: !0, Cousine: !0, Tinos: !0 };
    tt.prototype.load = function(S) {
      var A = new g(), K = this.c, J = new X(this.a.api, this.a.text), le = this.a.families;
      _e(J, le);
      var be = new Ne(le);
      et(be), h(K, Ce(J), v(A)), b(A, function() {
        S(be.a, be.c, _t);
      });
    };
    function $t(S, A) {
      this.c = S, this.a = A;
    }
    $t.prototype.load = function(S) {
      var A = this.a.id, K = this.c.o;
      A ? p(this.c, (this.a.api || "https://use.typekit.net") + "/" + A + ".js", function(J) {
        if (J)
          S([]);
        else if (K.Typekit && K.Typekit.config && K.Typekit.config.fn) {
          J = K.Typekit.config.fn;
          for (var le = [], be = 0; be < J.length; be += 2)
            for (var Oe = J[be], We = J[be + 1], Ke = 0; Ke < We.length; Ke++)
              le.push(new E(Oe, We[Ke]));
          try {
            K.Typekit.load({ events: !1, classes: !1, async: !0 });
          } catch {
          }
          S(le);
        }
      }, 2e3) : S([]);
    };
    function en(S, A) {
      this.c = S, this.f = A, this.a = [];
    }
    en.prototype.load = function(S) {
      var A = this.f.id, K = this.c.o, J = this;
      A ? (K.__webfontfontdeckmodule__ || (K.__webfontfontdeckmodule__ = {}), K.__webfontfontdeckmodule__[A] = function(le, be) {
        for (var Oe = 0, We = be.fonts.length; Oe < We; ++Oe) {
          var Ke = be.fonts[Oe];
          J.a.push(new E(Ke.name, O("font-weight:" + Ke.weight + ";font-style:" + Ke.style)));
        }
        S(J.a);
      }, p(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + f(this.c) + "/" + A + ".js", function(le) {
        le && S([]);
      })) : S([]);
    };
    var Ee = new Se(window);
    Ee.a.c.custom = function(S, A) {
      return new D(A, S);
    }, Ee.a.c.fontdeck = function(S, A) {
      return new en(A, S);
    }, Ee.a.c.monotype = function(S, A) {
      return new se(A, S);
    }, Ee.a.c.typekit = function(S, A) {
      return new $t(A, S);
    }, Ee.a.c.google = function(S, A) {
      return new tt(A, S);
    };
    var Fe = { load: r(Ee.load, Ee) };
    e.exports ? e.exports = Fe : (window.WebFont = Fe, window.WebFontConfig && Ee.load(window.WebFontConfig));
  })();
})(ew);
var TM = ew.exports;
const OM = /* @__PURE__ */ Uf(TM);
var PM = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
async function RM() {
  OM.load({
    google: {
      families: ["Noto Sans:400,600"]
    }
  });
  let e;
  PM && (e = /* @__PURE__ */ Object.assign({
    "../translations/bg.json": GL,
    "../translations/da.json": YL,
    "../translations/de.json": QL,
    "../translations/el.json": JL,
    "../translations/en.json": tM,
    "../translations/es-419.json": rM,
    "../translations/es.json": iM,
    "../translations/fr.json": sM,
    "../translations/hu.json": cM,
    "../translations/it.json": dM,
    "../translations/ja.json": hM,
    "../translations/nl.json": vM,
    "../translations/pl.json": mM,
    "../translations/pt-BR.json": bM,
    "../translations/ro.json": wM,
    "../translations/sv.json": _M,
    "../translations/uk.json": SM
  }), sw("settings-menu", e));
}
const AM = (e) => /* @__PURE__ */ y.createElement("svg", { viewBox: "0 0 264 73", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ y.createElement("g", { opacity: 0.2 }, /* @__PURE__ */ y.createElement("path", { d: "M-2.43859 58.2049C5.76206 73.3021 7.62893 91.8297 7.49451 95.9639C3.02549 97.5546 0.479714 97.1694 0.479714 97.1694C0.479714 97.1694 0.88257 84.7667 -2.84185 70.6074C-6.58344 56.3828 -15.9732 40.0464 -23.1932 30.173C-24.9381 27.9903 -25.8136 26.8827 -25.1554 27.5796C-24.5246 28.3829 -23.8684 29.2497 -23.1932 30.173C-18.2062 36.4113 -6.1178 51.4315 -2.43859 58.2049Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M116.379 55.5446C128.42 64.4445 136.449 78.0417 137.787 81.2556C134.665 83.9338 132.434 84.4692 132.434 84.4692C132.434 84.4692 128.42 74.8277 120.392 65.1862C112.328 55.5002 98.8733 46.0382 89.4698 40.8238C87.2684 39.7196 86.1595 39.156 86.9456 39.4756C87.7464 39.8856 88.5904 40.3361 89.4698 40.8238C95.7613 43.9796 110.976 51.5517 116.379 55.5446Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M189.77 58.5563C177.728 67.4562 169.7 81.0535 168.362 84.2673C171.483 86.9455 173.714 87.4809 173.714 87.4809C173.714 87.4809 177.728 77.8394 185.756 68.1979C193.821 58.5119 207.275 49.0499 216.679 43.8355C218.88 42.7313 219.989 42.1678 219.203 42.4873C218.402 42.8974 217.558 43.3478 216.679 43.8355C210.387 46.9913 195.172 54.5634 189.77 58.5563Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M246.381 43.1348C232.923 56.7813 223.949 77.6304 222.454 82.5583C225.943 86.6649 228.437 87.4859 228.437 87.4859C228.437 87.4859 232.923 72.7022 241.895 57.9185C250.908 43.0667 265.946 28.5583 276.456 20.5628C278.916 18.8698 280.155 18.0057 279.277 18.4956C278.382 19.1244 277.438 19.8151 276.456 20.5628C269.424 25.4018 252.419 37.0123 246.381 43.1348Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M225.353 44.8985C212.897 59.4652 205.425 80.8983 204.283 85.9199C208.054 89.7686 210.6 90.4107 210.6 90.4107C210.6 90.4107 214.026 75.346 221.927 59.9632C229.864 44.5094 243.834 28.9709 253.751 20.2501C256.085 18.3867 257.259 17.4369 256.418 17.9879C255.57 18.6786 254.678 19.4345 253.751 20.2501C247.08 25.5756 230.941 38.3631 225.353 44.8985Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M286.859 50.0952C296.332 64.4285 299.791 82.7259 300.013 86.8563C295.698 88.8267 293.129 88.6626 293.129 88.6626C293.129 88.6626 292.46 76.2714 287.528 62.4863C282.573 48.6376 271.808 33.1724 263.763 23.9588C261.836 21.9349 260.869 20.9069 261.584 21.5444C262.282 22.2903 263.011 23.0972 263.763 23.9588C269.27 29.7435 282.609 43.6646 286.859 50.0952Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M301.219 55.6364C309.545 68.2349 312.585 84.3178 312.781 87.9483C308.988 89.6802 306.73 89.536 306.73 89.536C306.73 89.536 306.142 78.6445 301.807 66.5278C297.451 54.3552 287.99 40.7617 280.918 32.6633C279.225 30.8843 278.374 29.9808 279.003 30.5411C279.617 31.1967 280.257 31.9059 280.918 32.6633C285.759 37.7478 297.483 49.9841 301.219 55.6364Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M158.275 52.6325C149.949 65.231 146.909 81.3139 146.713 84.9444C150.506 86.6763 152.764 86.5321 152.764 86.5321C152.764 86.5321 153.352 75.6406 157.688 63.5239C162.043 51.3513 171.505 37.7578 178.576 29.6594C180.269 27.8804 181.12 26.9769 180.491 27.5372C179.878 28.1928 179.237 28.902 178.576 29.6594C173.736 34.7439 162.011 46.9802 158.275 52.6325Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M147.873 55.6364C156.2 68.2349 159.24 84.3178 159.436 87.9483C155.643 89.6802 153.384 89.536 153.384 89.536C153.384 89.536 152.796 78.6445 148.461 66.5278C144.106 54.3552 134.644 40.7617 127.573 32.6633C125.879 30.8843 125.028 29.9808 125.658 30.5411C126.271 31.1967 126.911 31.9059 127.573 32.6633C132.413 37.7478 144.138 49.9841 147.873 55.6364Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M-22.055 58.6403C-30.3813 71.2388 -33.4213 87.3217 -33.6172 90.9522C-29.8244 92.6841 -27.5658 92.5399 -27.5658 92.5399C-27.5658 92.5399 -26.9779 81.6484 -22.6425 69.5317C-18.2872 57.3591 -8.82553 43.7656 -1.75421 35.6672C-0.0606838 33.8882 0.790021 32.9847 0.160815 33.545C-0.452534 34.2006 -1.09292 34.9098 -1.75421 35.6672C-6.59444 40.7517 -18.3194 52.988 -22.055 58.6403Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M59.0935 52.6325C50.7672 65.231 47.7271 81.3139 47.5312 84.9444C51.3241 86.6763 53.5826 86.5321 53.5826 86.5321C53.5826 86.5321 54.1705 75.6406 58.5059 63.5239C62.8613 51.3513 72.3229 37.7578 79.3942 29.6594C81.0878 27.8804 81.9385 26.9769 81.3093 27.5372C80.6959 28.1928 80.0555 28.902 79.3942 29.6594C74.554 34.7439 62.8291 46.9802 59.0935 52.6325Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M106.446 36.7548C96.9727 54.9256 93.514 78.122 93.2912 83.3582C97.6063 85.8562 100.176 85.6482 100.176 85.6482C100.176 85.6482 100.845 69.9394 105.777 52.4634C110.732 34.907 121.497 15.3011 129.542 3.6207C131.468 1.05484 132.436 -0.248295 131.72 0.55986C131.022 1.50539 130.294 2.52839 129.542 3.6207C124.035 10.9542 110.695 28.6025 106.446 36.7548Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M199.697 39.7665C209.17 57.9374 212.629 81.1337 212.851 86.3699C208.536 88.8679 205.967 88.6599 205.967 88.6599C205.967 88.6599 205.298 72.9511 200.366 55.4752C195.41 37.9187 184.646 18.3128 176.601 6.63242C174.674 4.06655 173.706 2.76342 174.422 3.57158C175.12 4.51711 175.849 5.54011 176.601 6.63242C182.108 13.9659 195.447 31.6142 199.697 39.7665Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M178.547 44.8613C189.285 62.3145 194.381 85.207 194.974 90.4143C190.847 93.2121 188.269 93.1868 188.269 93.1868C188.269 93.1868 186.488 77.565 180.328 60.483C174.14 43.3222 162.012 24.5293 153.159 13.449C151.055 11.0263 149.997 9.79507 150.769 10.5504C151.532 11.4441 152.331 12.4128 153.159 13.449C159.172 20.3734 173.73 37.031 178.547 44.8613Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M9.93221 57.2805C18.7194 72.0441 21.3123 90.4841 21.3403 94.6204C16.9372 96.3854 14.3783 96.1004 14.3783 96.1004C14.3783 96.1004 14.2938 83.6915 10.0163 69.6893C5.71901 55.6226 -4.30503 39.6675 -11.9071 30.0852C-13.7364 27.9728 -14.6547 26.9004 -13.9697 27.5709C-13.3078 28.3488 -12.618 29.1891 -11.9071 30.0852C-6.67901 36.1229 5.98987 50.6568 9.93221 57.2805Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M35.1353 51.9133C43.9225 66.6769 46.5154 85.1169 46.5435 89.2532C42.1404 91.0182 39.5814 90.7332 39.5814 90.7332C39.5814 90.7332 39.4969 78.3243 35.2194 64.3221C30.9221 50.2554 20.8981 34.3003 13.296 24.7181C11.4668 22.6056 10.5484 21.5332 11.2334 22.2037C11.8953 22.9816 12.5851 23.822 13.296 24.7181C18.5241 30.7557 31.193 45.2897 35.1353 51.9133Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M271.013 54.9094C262.226 69.673 259.633 88.113 259.605 92.2493C264.008 94.0143 266.567 93.7293 266.567 93.7293C266.567 93.7293 266.651 81.3204 270.929 67.3182C275.226 53.2515 285.25 37.2964 292.852 27.7141C294.682 25.6017 295.6 24.5293 294.915 25.1998C294.253 25.9777 293.563 26.818 292.852 27.7141C287.624 33.7518 274.955 48.2858 271.013 54.9094Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M132.575 56.8637C140.298 69.8404 142.577 86.0487 142.602 89.6843C138.732 91.2357 136.483 90.9853 136.483 90.9853C136.483 90.9853 136.408 80.0782 132.648 67.7707C128.871 55.4065 120.06 41.3824 113.378 32.9599C111.771 31.1031 110.963 30.1605 111.566 30.7498C112.147 31.4336 112.754 32.1722 113.378 32.9599C117.974 38.2668 129.109 51.0417 132.575 56.8637Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M77.2076 42.8548C85.9948 61.5712 88.5877 84.9483 88.6157 90.192C84.2126 92.4296 81.6537 92.0683 81.6537 92.0683C81.6537 92.0683 81.5692 76.337 77.2917 58.5859C72.9944 40.7531 62.9704 20.5261 55.3683 8.37834C53.539 5.70027 52.6207 4.3408 53.3057 5.1908C53.9676 6.17695 54.6573 7.24232 55.3683 8.37834C60.5964 16.0325 73.2653 34.4578 77.2076 42.8548Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M208.148 48.8731C200.711 68.1656 199.783 91.6678 200.127 96.9003C204.677 98.8199 207.204 98.278 207.204 98.278C207.204 98.278 206.173 82.5804 209.18 64.5706C212.202 46.4778 220.766 25.5908 227.487 12.9343C229.122 10.1333 229.941 8.71206 229.318 9.60851C228.728 10.6391 228.116 11.7507 227.487 12.9343C222.815 20.94 211.485 40.2176 208.148 48.8731Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M15.3011 54.5553C11.5369 71.3186 14.8028 89.6514 16.0615 93.5916C20.7951 93.9009 23.1388 92.8349 23.1388 92.8349C23.1388 92.8349 19.3629 81.014 19.0774 66.3759C18.7905 51.6702 23.3601 33.39 27.608 21.9197C28.6902 19.3434 29.2298 18.0388 28.7871 18.8889C28.3997 19.834 28.0053 20.8471 27.608 21.9197C24.515 29.2831 16.9899 47.0345 15.3011 54.5553Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M290.84 57.5514C294.604 74.3147 291.338 92.6475 290.079 96.5877C285.346 96.897 283.002 95.831 283.002 95.831C283.002 95.831 286.778 84.0101 287.063 69.372C287.35 54.6663 282.781 36.3861 278.533 24.9158C277.45 22.3395 276.911 21.0349 277.354 21.885C277.741 22.8301 278.135 23.8432 278.533 24.9158C281.626 32.2792 289.151 50.0306 290.84 57.5514Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M75.7249 54.2858C71.9608 71.0491 75.2266 89.3819 76.4853 93.3221C81.2189 93.6314 83.5626 92.5653 83.5626 92.5653C83.5626 92.5653 79.7867 80.7445 79.5012 66.1063C79.2143 51.4007 83.7839 33.1204 88.0318 21.6502C89.114 19.0739 89.6537 17.7692 89.2109 18.6194C88.8235 19.5645 88.4291 20.5776 88.0318 21.6502C84.9388 29.0136 77.4137 46.7649 75.7249 54.2858Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M45.6664 54.2858C41.9022 71.0491 45.168 89.3819 46.4267 93.3221C51.1603 93.6314 53.504 92.5653 53.504 92.5653C53.504 92.5653 49.7281 80.7445 49.4426 66.1063C49.1558 51.4007 53.7253 33.1204 57.9732 21.6502C59.0554 19.0739 59.5951 17.7692 59.1523 18.6194C58.7649 19.5645 58.3705 20.5776 57.9732 21.6502C54.8802 29.0136 47.3552 46.7649 45.6664 54.2858Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M245.761 57.5514C249.526 74.3147 246.26 92.6475 245.001 96.5877C240.267 96.897 237.924 95.831 237.924 95.831C237.924 95.831 241.7 84.0101 241.985 69.372C242.272 54.6663 237.702 36.3861 233.454 24.9158C232.372 22.3395 231.833 21.0349 232.275 21.885C232.663 22.8301 233.057 23.8432 233.454 24.9158C236.548 32.2792 244.073 50.0306 245.761 57.5514Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M102.459 46.2054C98.6951 67.4569 101.961 90.6981 103.22 95.6933C107.953 96.0854 110.297 94.7339 110.297 94.7339C110.297 94.7339 106.521 79.7482 106.236 61.1908C105.949 42.5479 110.518 19.3733 114.766 4.83209C115.848 1.56597 116.388 -0.087985 115.945 0.989806C115.558 2.18789 115.163 3.47224 114.766 4.83209C111.673 14.1669 104.148 36.671 102.459 46.2054Z", fill: "#00004B" }), /* @__PURE__ */ y.createElement("path", { d: "M203.681 49.2211C207.445 70.4725 204.18 93.7138 202.921 98.7089C198.187 99.101 195.844 97.7495 195.844 97.7495C195.844 97.7495 199.62 82.7638 199.905 64.2064C200.192 45.5635 195.622 22.389 191.374 7.84772C190.292 4.5816 189.753 2.92764 190.195 4.00543C190.583 5.20352 190.977 6.48787 191.374 7.84772C194.467 17.1826 201.993 39.6866 203.681 49.2211Z", fill: "#00004B" }))), IM = Ue.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-radius: 8px;
  background: linear-gradient(90deg, #00004b 0%, #369f61 100%);
  position: relative;
  cursor: pointer;
  overflow: hidden;
  color: ${Dn[10]};
  height: 76px;
  box-sizing: border-box;
  z-index: 1;

  svg.background {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    z-index: -1;
  }
`, kM = Ue.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 4px;
`, $M = Ue.span`
  color: ${Dn[0]};
  font-weight: 600;
  line-height: 24px;
`, H0 = Ue.span`
  color: ${Dn[20]};
  font-size: ${BL.FontSize.Caption};
  line-height: 20px;
`, NM = {
  1: "settings_menu.onboarding.create_property",
  2: "settings_menu.onboarding.create_fields",
  3: "settings_menu.onboarding.assign_crops"
};
function FM({
  onClick: e,
  requiredSteps: t,
  completedSteps: n
}) {
  const {
    t: r
  } = Fa(), o = Mt(() => {
    const i = n.includes(hd.PROPERTY_CREATED), a = n.includes(hd.FIELD_CREATED);
    return i ? a ? 3 : 2 : 1;
  }, [n]);
  return /* @__PURE__ */ P.jsxs(IM, { onClick: e, role: "button", "aria-label": "open onboarding modal", children: [
    /* @__PURE__ */ P.jsxs(kM, { children: [
      /* @__PURE__ */ P.jsx($M, { children: r("settings_menu.onboarding.continue") }),
      /* @__PURE__ */ P.jsxs("span", { children: [
        /* @__PURE__ */ P.jsx(H0, { children: r("settings_menu.onboarding.step", {
          current: o,
          total: t.length
        }) }),
        /* @__PURE__ */ P.jsx(H0, { children: r(NM[o]) })
      ] })
    ] }),
    /* @__PURE__ */ P.jsx(Z$, { width: 24, height: 24, fill: Dn[0] }),
    /* @__PURE__ */ P.jsx(AM, { className: "background" })
  ] });
}
const It = class It {
};
It.config = jn(), It.$getWorkspaceName = {}, It.getWorkspaceName = async (t) => (It.$getWorkspaceName[t] === void 0 && (It.$getWorkspaceName[t] = Gc.get(`${It.config.getAPIURL()}/v2/workspaces/${t}`, {
  headers: It.config.getDefaultHeaders()
}).then((n) => {
  var r;
  return (r = n.data) == null ? void 0 : r.name;
})), It.$getWorkspaceName[t]), It.$getPropertyName = {}, It.getPropertyName = async (t) => (It.$getPropertyName[t] === void 0 && (It.$getPropertyName[t] = Gc.get(`${It.config.getAPIURL()}/v2/properties/${t}`, {
  headers: It.config.getDefaultHeaders()
}).then((n) => {
  var r;
  return (r = n.data) == null ? void 0 : r.name;
})), It.$getPropertyName[t]), It.$getOrgData = {}, It.getOrgData = async (t) => (It.$getOrgData[t] === void 0 && (It.$getOrgData[t] = Gc.get(`${It.config.getAPIURL()}/v2/orgs/${t}`, {
  headers: It.config.getDefaultHeaders()
}).then((n) => n == null ? void 0 : n.data)), It.$getOrgData[t]);
let ba = It;
function LM({
  orgId: e,
  propertyId: t,
  workspaceId: n
}) {
  const [r, o] = wt(), [i, a] = wt(), [s, l] = wt(), [c, u] = wt();
  return ut(() => {
    const d = () => {
      dl.getCurrentUser().then((f) => {
        f && o({
          id: f.id,
          name: f.name
        });
      });
    };
    _o.getInstance().addCallbackAfterSetToken(d);
  }, []), ut(() => {
    if (n) {
      const d = async () => {
        const f = await ba.getWorkspaceName(n).catch(() => "");
        a({
          id: n,
          name: f
        });
      };
      _o.getInstance().addCallbackAfterSetToken(d);
    }
  }, [n]), ut(() => {
    if (e) {
      const d = async () => {
        const f = await ba.getOrgData(e).catch();
        l({
          id: e,
          name: f == null ? void 0 : f.name,
          country: f == null ? void 0 : f.country,
          source: f == null ? void 0 : f.source
        });
      };
      _o.getInstance().addCallbackAfterSetToken(d);
    }
  }, [e]), ut(() => {
    if (t) {
      const d = async () => {
        const f = await ba.getPropertyName(t).catch(() => "");
        u({
          id: t,
          name: f
        });
      };
      _o.getInstance().addCallbackAfterSetToken(d);
    }
  }, [t]), ut(() => {
    if (e && !t) {
      const d = () => {
        dl.getPropertiesByOrg(e).then((f) => {
          var p, g;
          const h = (g = (p = f.data) == null ? void 0 : p.content) == null ? void 0 : g[0];
          u(h ? {
            id: h.id,
            name: h.name
          } : void 0);
        });
      };
      _o.getInstance().addCallbackAfterSetToken(d);
    }
  }, [e, t]), {
    userId: r == null ? void 0 : r.id,
    userName: r == null ? void 0 : r.name,
    workspaceId: i == null ? void 0 : i.id,
    workspaceName: i == null ? void 0 : i.name,
    organizationId: s == null ? void 0 : s.id,
    organizationName: s == null ? void 0 : s.name,
    organizationCountry: s == null ? void 0 : s.country,
    organizationSource: s == null ? void 0 : s.source,
    propertyId: c == null ? void 0 : c.id,
    propertyName: c == null ? void 0 : c.name
  };
}
RM();
const MM = P1("Settings Menu"), DM = ({
  headerSelector: e,
  workspaceId: t,
  orgId: n,
  propertyId: r,
  productSettings: o
}) => {
  const i = ci("onboarding-modal"), {
    cwElementsOnboardingModalCws10974EnableModal: a
  } = dh(), s = jn();
  R8(s), tS();
  const {
    t: l
  } = Fa(), c = LM({
    workspaceId: t,
    orgId: n,
    propertyId: r
  }), u = MM(() => ({
    workspaceId: c.workspaceId,
    workspaceName: c.workspaceName,
    organizationId: c.organizationId,
    organizationName: c.organizationName,
    farmId: c.propertyId,
    farmName: c.propertyName
  })), [d, f] = wt(!1), [h, p] = wt(!1), [g, v] = wt(null);
  ut(() => {
    const x = setTimeout(() => {
      d && f(!1);
    }, 1e4);
    return () => clearTimeout(x);
  }, [d]), ut(() => {
    if (a) {
      const x = (_) => {
        v(_.detail), p(!1), f(!_.detail.completed);
      };
      return window.addEventListener(zs.MODAL_INFORMATION, x), () => window.removeEventListener(zs.MODAL_INFORMATION, x);
    }
  }, [a]), ut(() => {
    function x() {
      p(!1);
    }
    return window.addEventListener(Zh, x), window.addEventListener(gl.CLOSE_MENU, x), () => {
      window.removeEventListener(Zh, x), window.removeEventListener(gl.CLOSE_MENU, x);
    };
  }, []);
  const b = () => {
    u("Onboarding - Opened Onboarding modal"), window.dispatchEvent(new CustomEvent(zs.OPEN_MODAL));
  }, m = () => {
    f(!1), n ? (u(h ? "close settings" : "access settings", {
      "entity level": r ? "Farm" : "Organization",
      action: "Clicking on settings button"
    }), p(!h)) : g && b();
  }, w = a && t && c.organizationId && c.userId, E = !!(g && !g.completed), C = !!(n ?? E);
  return /* @__PURE__ */ P.jsxs(ZC, { providerConfig: c, children: [
    w && i.Mfe && /* @__PURE__ */ P.jsx(i.Mfe, { workspaceId: t, userId: c.userId, userName: c.userName, orgId: c.organizationId, propertyId: c.propertyId, propertyName: c.propertyName, getConfigInstance: jn }),
    /* @__PURE__ */ P.jsxs("div", { className: "cw-settings-menu-wrapper", children: [
      C && /* @__PURE__ */ P.jsx(fo, { open: d, title: l("settings_menu.onboarding.continue"), placement: "bottomLeft", color: jL[60], overlayInnerStyle: {
        borderRadius: 4
      }, children: /* @__PURE__ */ P.jsx("div", { children: /* @__PURE__ */ P.jsx(QC, { primaryBg: E, active: E || h, onClick: m }) }) }),
      /* @__PURE__ */ P.jsx(qL, { onClose: () => {
        p(!1), u("close settings", {
          action: "Clicking on close"
        });
      }, open: h, headerSelector: e, extraSection: E ? /* @__PURE__ */ P.jsx(FM, { onClick: b, requiredSteps: (g == null ? void 0 : g.requiredSteps) ?? [], completedSteps: (g == null ? void 0 : g.completedSteps) ?? [] }) : null, productSettings: o })
    ] })
  ] });
}, pD = (e) => {
  const t = jn();
  return /* @__PURE__ */ P.jsx(q0, { ns: "settings-menu", children: /* @__PURE__ */ P.jsx(O8, { clientSideID: t.getLaunchDarklyClientID(), children: /* @__PURE__ */ P.jsx(DM, { ...e }) }) });
};
export {
  Dw as ArrowLeftIcon,
  jw as ArrowUpIcon,
  oD as Button,
  ep as ButtonIcon,
  _E as ButtonSize,
  SE as ButtonSpace,
  xE as ButtonType,
  HM as CloseIcon,
  iD as CollapsibleCard,
  Vw as CropCycles,
  Gw as DataMatchingIcon,
  gL as DefaultSettingsGroups,
  GM as DetailsIcon,
  WM as Equipments,
  KM as ErrorIcon,
  Uw as Field,
  Kw as FileUploadIcon,
  cD as FormDetail,
  uD as FormTitle,
  YM as HideIcon,
  ZM as InfoIcon,
  dD as Input,
  kL as InputStyleTypesEnum,
  Hw as InputsIcon,
  Yw as IntegrationsIcon,
  QM as KeyIcon,
  Zw as LoadingIcon,
  zw as ManageQuotasIcon,
  X0 as OpenInNewTab,
  qw as PersonAddIcon,
  tp as PlusIcon,
  Ww as Products,
  qM as QuotaFullIcon,
  zM as QuotaIcon,
  Bw as QuotaSet,
  W$ as QuotaWarningGroup,
  QC as SettingsButton,
  hD as SettingsButtonWithProviders,
  fL as SettingsDrawerGroups,
  XM as SettingsIcon,
  pD as SettingsMenu,
  JM as ShowIcon,
  eD as SorterIcon,
  tD as SwapIcon,
  fD as Switch,
  rD as Theme,
  nD as TrashIcon,
  aD as UnitOfMeasurement
};
